export let videoList = {
  // Gen 1
  Haachama :
  [
  {
    "videoId": "ZDoyb3CWQnE",
    "thumbnail": "https://i.ytimg.com/vi/ZDoyb3CWQnE/mqdefault.jpg",
    "title": "🔴【初放送】新人Vtuberの赤井はあとです！はじめまして！",
    "publishedAt": "2018-06-02T13:13:12Z"
  },
  {
    "videoId": "16oql7Yjia8",
    "thumbnail": "https://i.ytimg.com/vi/16oql7Yjia8/mqdefault.jpg",
    "title": "🔴【QWOP】とんでもないバカゲー実況",
    "publishedAt": "2018-06-06T11:51:33Z"
  },
  {
    "videoId": "BZr9gFuoxyU",
    "thumbnail": "https://i.ytimg.com/vi/BZr9gFuoxyU/mqdefault.jpg",
    "title": "🔴【壺男】とんでもないバカゲー実況＃２-getting over it-",
    "publishedAt": "2018-06-07T13:32:37Z"
  },
  {
    "videoId": "LDVu8fu0NSQ",
    "thumbnail": "https://i.ytimg.com/vi/LDVu8fu0NSQ/mqdefault.jpg",
    "title": "【QWOP】とんでもないバカゲー実況＃１～超凝縮編～",
    "publishedAt": "2018-06-10T09:00:09Z"
  },
  {
    "videoId": "0Ze__14qwFg",
    "thumbnail": "https://i.ytimg.com/vi/0Ze__14qwFg/mqdefault.jpg",
    "title": "🔴【死にゲー】狂気の世界でいざ妹探しへ！＃1【LIMBO】",
    "publishedAt": "2018-06-13T12:37:05Z"
  },
  {
    "videoId": "7PV4PVOFfgQ",
    "thumbnail": "https://i.ytimg.com/vi/7PV4PVOFfgQ/mqdefault.jpg",
    "title": "🔴【はあとch】ざつだんするわよ！♡",
    "publishedAt": "2018-06-16T12:07:01Z"
  },
  {
    "videoId": "aSOs6wKVdEM",
    "thumbnail": "https://i.ytimg.com/vi/aSOs6wKVdEM/mqdefault.jpg",
    "title": "【放送事故】壺男実況をするはずが号泣...？",
    "publishedAt": "2018-06-16T13:33:14Z"
  },
  {
    "videoId": "NgR8XUVxe6w",
    "thumbnail": "https://i.ytimg.com/vi/NgR8XUVxe6w/mqdefault.jpg",
    "title": "【放送事故】Getting over it で大号泣しちゃったVtuber",
    "publishedAt": "2018-06-16T16:02:47Z"
  },
  {
    "videoId": "RkCSMfIbvFQ",
    "thumbnail": "https://i.ytimg.com/vi/RkCSMfIbvFQ/mqdefault.jpg",
    "title": "【6/18】すーぱー朝らじっ！🌞#1",
    "publishedAt": "2018-06-17T22:08:15Z"
  },
  {
    "videoId": "4zAodlubQeg",
    "thumbnail": "https://i.ytimg.com/vi/4zAodlubQeg/mqdefault.jpg",
    "title": "10分で分かる赤井はあとの朝ラジオ！",
    "publishedAt": "2018-06-18T21:30:39Z"
  },
  {
    "videoId": "x1O7M-rk51k",
    "thumbnail": "https://i.ytimg.com/vi/x1O7M-rk51k/mqdefault.jpg",
    "title": "【6/19】すーぱー朝らじっ！🌞#2",
    "publishedAt": "2018-06-18T22:05:09Z"
  },
  {
    "videoId": "s0NCXO-wLKY",
    "thumbnail": "https://i.ytimg.com/vi/s0NCXO-wLKY/mqdefault.jpg",
    "title": "【死にゲー】狂気の森でいざ妹探し！LIMBO#２",
    "publishedAt": "2018-06-19T10:36:53Z"
  },
  {
    "videoId": "QD-vAAsVH0M",
    "thumbnail": "https://i.ytimg.com/vi/QD-vAAsVH0M/mqdefault.jpg",
    "title": "【6/20】すーぱー朝らじっ！🌞#3",
    "publishedAt": "2018-06-19T22:06:56Z"
  },
  {
    "videoId": "4n7Y9rbkrkc",
    "thumbnail": "https://i.ytimg.com/vi/4n7Y9rbkrkc/mqdefault.jpg",
    "title": "【6/22】すーぱー朝らじっ！🌞#4",
    "publishedAt": "2018-06-21T22:09:04Z"
  },
  {
    "videoId": "TwTh-mW8cYE",
    "thumbnail": "https://i.ytimg.com/vi/TwTh-mW8cYE/mqdefault.jpg",
    "title": "【実力】果たして赤井はあとの学力はどのぐらい？",
    "publishedAt": "2018-06-22T10:36:54Z"
  },
  {
    "videoId": "gwzpsYPm-FY",
    "thumbnail": "https://i.ytimg.com/vi/gwzpsYPm-FY/mqdefault.jpg",
    "title": "【6/25】すーぱー朝らじっ！🌞#5",
    "publishedAt": "2018-06-24T22:02:48Z"
  },
  {
    "videoId": "1uRN_LgDNsU",
    "thumbnail": "https://i.ytimg.com/vi/1uRN_LgDNsU/mqdefault.jpg",
    "title": "【死にゲー】狂気の森でいざ妹探し！LIMBO#3",
    "publishedAt": "2018-06-25T13:02:45Z"
  },
  {
    "videoId": "NyJy0lcCiR4",
    "thumbnail": "https://i.ytimg.com/vi/NyJy0lcCiR4/mqdefault.jpg",
    "title": "【Vtuber】ヒロイン風に自己紹介！【赤井はあと】",
    "publishedAt": "2018-06-26T13:05:09Z"
  },
  {
    "videoId": "9RP0lTtbsfY",
    "thumbnail": "https://i.ytimg.com/vi/9RP0lTtbsfY/mqdefault.jpg",
    "title": "【雑談】はあとん劇場♡1話",
    "publishedAt": "2018-06-26T13:52:50Z"
  },
  {
    "videoId": "UJ2LzVlWL-I",
    "thumbnail": "https://i.ytimg.com/vi/UJ2LzVlWL-I/mqdefault.jpg",
    "title": "【怒ってる？】ツンデレじゃなくて、ツンツンよ！",
    "publishedAt": "2018-07-03T12:40:32Z"
  },
  {
    "videoId": "_dN9WiWxo54",
    "thumbnail": "https://i.ytimg.com/vi/_dN9WiWxo54/mqdefault.jpg",
    "title": "【しょぼんのアクション】鬼畜ゲーム1stステージ！実況プレイ！",
    "publishedAt": "2018-07-10T12:32:15Z"
  },
  {
    "videoId": "aekF1SisPQA",
    "thumbnail": "https://i.ytimg.com/vi/aekF1SisPQA/mqdefault.jpg",
    "title": "【Minecraft】はあと&フブキでダイヤブロック作り！【はあとSIDE】",
    "publishedAt": "2018-07-17T11:54:49Z"
  },
  {
    "videoId": "Mq0Tt9Y5TUE",
    "thumbnail": "https://i.ytimg.com/vi/Mq0Tt9Y5TUE/mqdefault.jpg",
    "title": "【Minecraft】初見プレイでどこまでやれるか！【ゲーム実況】#1",
    "publishedAt": "2018-07-18T11:37:04Z"
  },
  {
    "videoId": "_H3EXVohZaM",
    "thumbnail": "https://i.ytimg.com/vi/_H3EXVohZaM/mqdefault.jpg",
    "title": "【LIMBO】いよいよ最終回...？！クリアするまで終われない！！！#4",
    "publishedAt": "2018-07-23T10:39:40Z"
  },
  {
    "videoId": "jSXNBwYlWHM",
    "thumbnail": "https://i.ytimg.com/vi/jSXNBwYlWHM/mqdefault.jpg",
    "title": "♡はあとん劇場 第二話♡ 【赤井はあと/Vtuber】",
    "publishedAt": "2018-07-25T12:38:17Z"
  },
  {
    "videoId": "XL5YgUUh_P8",
    "thumbnail": "https://i.ytimg.com/vi/XL5YgUUh_P8/mqdefault.jpg",
    "title": "【はあとん劇場】爽やかに夏のおはなし会♡第3話",
    "publishedAt": "2018-07-26T11:35:49Z"
  },
  {
    "videoId": "-bEaqJZ7TuY",
    "thumbnail": "https://i.ytimg.com/vi/-bEaqJZ7TuY/mqdefault.jpg",
    "title": "【悲報】赤井はあと、歯ブラシで食事するってよ。",
    "publishedAt": "2018-07-28T12:30:38Z"
  },
  {
    "videoId": "AopVpPAxnG8",
    "thumbnail": "https://i.ytimg.com/vi/AopVpPAxnG8/mqdefault.jpg",
    "title": "【朝らじっ！】夏にたべたい！そうめん特集♡＃５[Morning Radio]",
    "publishedAt": "2018-07-29T22:07:01Z"
  },
  {
    "videoId": "gSifLZyGyk4",
    "thumbnail": "https://i.ytimg.com/vi/gSifLZyGyk4/mqdefault.jpg",
    "title": "【Super Bunny Man】〇〇〇になって実況プレイ♡#1",
    "publishedAt": "2018-07-31T12:12:31Z"
  },
  {
    "videoId": "OWle4O2Kd4o",
    "thumbnail": "https://i.ytimg.com/vi/OWle4O2Kd4o/mqdefault.jpg",
    "title": "【朝らじっ！】赤井はあとによるバーチャルyoutuberニュース！＃６[Morning Radio]",
    "publishedAt": "2018-07-31T22:08:27Z"
  },
  {
    "videoId": "93XvYVM4WU4",
    "thumbnail": "https://i.ytimg.com/vi/93XvYVM4WU4/mqdefault.jpg",
    "title": "赤井はあとの朝ラジオ#7[Morning Radio]",
    "publishedAt": "2018-08-02T22:07:56Z"
  },
  {
    "videoId": "g_pQYlTG8eI",
    "thumbnail": "https://i.ytimg.com/vi/g_pQYlTG8eI/mqdefault.jpg",
    "title": "赤井はあとの朝ラジオ #8",
    "publishedAt": "2018-08-05T22:06:32Z"
  },
  {
    "videoId": "aag1wLPc8_k",
    "thumbnail": "https://i.ytimg.com/vi/aag1wLPc8_k/mqdefault.jpg",
    "title": "赤井はあとの朝ラジオ#9 [Vtuber News DAY]",
    "publishedAt": "2018-08-07T22:09:49Z"
  },
  {
    "videoId": "vtEQUicyh-A",
    "thumbnail": "https://i.ytimg.com/vi/vtEQUicyh-A/mqdefault.jpg",
    "title": "【しょぼんのアクション】絶対にイライラしないでクリア！3rdステージ！【実況プレイ】",
    "publishedAt": "2018-08-08T13:46:50Z"
  },
  {
    "videoId": "Nby-XcGupzg",
    "thumbnail": "https://i.ytimg.com/vi/Nby-XcGupzg/mqdefault.jpg",
    "title": "赤井はあとの朝ラジオ #10",
    "publishedAt": "2018-08-09T21:58:45Z"
  },
  {
    "videoId": "yil1WuTfKQU",
    "thumbnail": "https://i.ytimg.com/vi/yil1WuTfKQU/mqdefault.jpg",
    "title": "【生誕祭】赤井はあとのお誕生日会🎉",
    "publishedAt": "2018-08-10T13:42:53Z"
  },
  {
    "videoId": "OI7r3REiS8w",
    "thumbnail": "https://i.ytimg.com/vi/OI7r3REiS8w/mqdefault.jpg",
    "title": "赤井はあとの朝ラジオ#11[Morning Radio]",
    "publishedAt": "2018-08-12T22:06:29Z"
  },
  {
    "videoId": "lerx8Sdc3Y4",
    "thumbnail": "https://i.ytimg.com/vi/lerx8Sdc3Y4/mqdefault.jpg",
    "title": "鬼畜すぎるウサギゲームの実況＃２【Super Bunny Man】",
    "publishedAt": "2018-08-13T13:05:51Z"
  },
  {
    "videoId": "nVRTPsNwZD0",
    "thumbnail": "https://i.ytimg.com/vi/nVRTPsNwZD0/mqdefault.jpg",
    "title": "朝からまったりおはなしでもしない？♡",
    "publishedAt": "2018-08-13T22:37:57Z"
  },
  {
    "videoId": "wcuVRU_g5pM",
    "thumbnail": "https://i.ytimg.com/vi/wcuVRU_g5pM/mqdefault.jpg",
    "title": "【はあとん劇場】留学先の学校であったヤバイ話+後半はお歌",
    "publishedAt": "2018-08-14T10:10:02Z"
  },
  {
    "videoId": "TqxLiW2_oY8",
    "thumbnail": "https://i.ytimg.com/vi/TqxLiW2_oY8/mqdefault.jpg",
    "title": "赤井はあとの朝ラジオ #12 [Morning Radio]",
    "publishedAt": "2018-08-14T22:32:14Z"
  },
  {
    "videoId": "i-_aVb1lYbY",
    "thumbnail": "https://i.ytimg.com/vi/i-_aVb1lYbY/mqdefault.jpg",
    "title": "【Virtual Youtuber】ABOUT ME Haato Akai",
    "publishedAt": "2018-08-15T14:30:41Z"
  },
  {
    "videoId": "aDelJV1nVXE",
    "thumbnail": "https://i.ytimg.com/vi/aDelJV1nVXE/mqdefault.jpg",
    "title": "朝からまったりおはなしでもしない？♡#2",
    "publishedAt": "2018-08-15T22:35:45Z"
  },
  {
    "videoId": "yIpqu9Wm2KM",
    "thumbnail": "https://i.ytimg.com/vi/yIpqu9Wm2KM/mqdefault.jpg",
    "title": "【ゲリライブ】歌をうたうわよ！！！💓[Music live]",
    "publishedAt": "2018-08-19T11:36:55Z"
  },
  {
    "videoId": "6AQRLzLlkoc",
    "thumbnail": "https://i.ytimg.com/vi/6AQRLzLlkoc/mqdefault.jpg",
    "title": "【はあとん劇場】留学のおはなしとましゅまろもぐもぐ。",
    "publishedAt": "2018-08-22T11:39:23Z"
  },
  {
    "videoId": "H76pEA8kDyM",
    "thumbnail": "https://i.ytimg.com/vi/H76pEA8kDyM/mqdefault.jpg",
    "title": "はなそったらはなそったらはなそったらはなそ。うん。",
    "publishedAt": "2018-08-25T11:36:17Z"
  },
  {
    "videoId": "d3kAcFe6oYw",
    "thumbnail": "https://i.ytimg.com/vi/d3kAcFe6oYw/mqdefault.jpg",
    "title": "【放送事故】赤井はあとが固まりまくる歌枠、最終的には...",
    "publishedAt": "2018-09-03T11:40:29Z"
  },
  {
    "videoId": "vjvDvx2OZZM",
    "thumbnail": "https://i.ytimg.com/vi/vjvDvx2OZZM/mqdefault.jpg",
    "title": "【衝撃】フィリピン留学が危険すぎた話",
    "publishedAt": "2018-09-07T15:50:24Z"
  },
  {
    "videoId": "YfcGioF93yA",
    "thumbnail": "https://i.ytimg.com/vi/YfcGioF93yA/mqdefault.jpg",
    "title": "【はあとCh】留学のおはなしとましゅまろもぐもぐ。#2",
    "publishedAt": "2018-09-09T07:00:45Z"
  },
  {
    "videoId": "uQXvd0TjMCM",
    "thumbnail": "https://i.ytimg.com/vi/uQXvd0TjMCM/mqdefault.jpg",
    "title": "【報告】イケボな彼氏ができました。",
    "publishedAt": "2018-09-16T11:08:06Z"
  },
  {
    "videoId": "MUQrju6ZQpc",
    "thumbnail": "https://i.ytimg.com/vi/MUQrju6ZQpc/mqdefault.jpg",
    "title": "【物申す】本当になんなのよおおおおおおお！？【激おこ】",
    "publishedAt": "2018-09-29T10:33:18Z"
  },
  {
    "videoId": "_4m5XlHPKvQ",
    "thumbnail": "https://i.ytimg.com/vi/_4m5XlHPKvQ/mqdefault.jpg",
    "title": "お叱り覚悟でみんなの気になる話ぶっちゃけトーク！",
    "publishedAt": "2018-10-02T11:36:11Z"
  },
  {
    "videoId": "EJ52A3-AGNc",
    "thumbnail": "https://i.ytimg.com/vi/EJ52A3-AGNc/mqdefault.jpg",
    "title": "【炎上不可避】彼氏呼んで歌枠するけど嫉妬しないでね？💓",
    "publishedAt": "2018-10-07T08:44:10Z"
  },
  {
    "videoId": "tFNpid1bDzY",
    "thumbnail": "https://i.ytimg.com/vi/tFNpid1bDzY/mqdefault.jpg",
    "title": "新学期がカオスすぎてって話なのよ",
    "publishedAt": "2018-10-08T11:43:12Z"
  },
  {
    "videoId": "NccYGfaqZtw",
    "thumbnail": "https://i.ytimg.com/vi/NccYGfaqZtw/mqdefault.jpg",
    "title": "全世界を萌えさせたい。",
    "publishedAt": "2018-10-15T11:35:26Z"
  },
  {
    "videoId": "T1pv01sXHMw",
    "thumbnail": "https://i.ytimg.com/vi/T1pv01sXHMw/mqdefault.jpg",
    "title": "【放送事故/ヤバイ発言編】10分でわかる赤井はあと",
    "publishedAt": "2018-10-21T12:16:20Z"
  },
  {
    "videoId": "Ysw2ojrSxQc",
    "thumbnail": "https://i.ytimg.com/vi/Ysw2ojrSxQc/mqdefault.jpg",
    "title": "【壺男】泣いても怒っても絶対クリアしてみせる！[Getting over it]",
    "publishedAt": "2018-11-11T10:42:50Z"
  },
  {
    "videoId": "JyDQWQyTvBU",
    "thumbnail": "https://i.ytimg.com/vi/JyDQWQyTvBU/mqdefault.jpg",
    "title": "11月があまりにも濃密すぎて覚醒しました。",
    "publishedAt": "2018-11-28T10:36:23Z"
  },
  {
    "videoId": "F4iIyAUyNqc",
    "thumbnail": "https://i.ytimg.com/vi/F4iIyAUyNqc/mqdefault.jpg",
    "title": "【記念放送】祝！活動半年！皆から第一印象と今を聞いたら酷すぎた！",
    "publishedAt": "2018-12-07T11:39:46Z"
  },
  {
    "videoId": "UhvKnuE0avA",
    "thumbnail": "https://i.ytimg.com/vi/UhvKnuE0avA/mqdefault.jpg",
    "title": "【Minecraft】ホロライブ鯖に突撃する！",
    "publishedAt": "2018-12-14T11:31:03Z"
  },
  {
    "videoId": "mKORVdoWU2E",
    "thumbnail": "https://i.ytimg.com/vi/mKORVdoWU2E/mqdefault.jpg",
    "title": "Sweets parade/赤井はあと 【歌ってみた】",
    "publishedAt": "2018-12-21T11:15:04Z"
  },
  {
    "videoId": "LJA_-ptAokg",
    "thumbnail": "https://i.ytimg.com/vi/LJA_-ptAokg/mqdefault.jpg",
    "title": "今年最後の生放送で今を振り返る！",
    "publishedAt": "2018-12-28T12:01:37Z"
  },
  {
    "videoId": "Ag-RB-z9LWU",
    "thumbnail": "https://i.ytimg.com/vi/Ag-RB-z9LWU/mqdefault.jpg",
    "title": "【神回】赤井はあとの3Dお披露目LIVE！【VTuber】",
    "publishedAt": "2019-01-25T12:41:59Z"
  },
  {
    "videoId": "o4sYNR4NnRs",
    "thumbnail": "https://i.ytimg.com/vi/o4sYNR4NnRs/mqdefault.jpg",
    "title": "3D放送を見ながら裏話！【アーカイブ実況】",
    "publishedAt": "2019-01-26T11:38:26Z"
  },
  {
    "videoId": "IHssdev9rK4",
    "thumbnail": "https://i.ytimg.com/vi/IHssdev9rK4/mqdefault.jpg",
    "title": "【壺男】涙あり叫びありでクリア目指す！【リベンジ】",
    "publishedAt": "2019-02-16T11:36:09Z"
  },
  {
    "videoId": "3kyhBahxrn4",
    "thumbnail": "https://i.ytimg.com/vi/3kyhBahxrn4/mqdefault.jpg",
    "title": "【Minecraft】大のハリポタ好きが魔法界に突撃っ！！！",
    "publishedAt": "2019-02-23T09:55:55Z"
  },
  {
    "videoId": "S-I62nTCbL0",
    "thumbnail": "https://i.ytimg.com/vi/S-I62nTCbL0/mqdefault.jpg",
    "title": "【ゆるたび】浴衣でオーストラリアの街を観光っ♪",
    "publishedAt": "2019-02-25T11:36:40Z"
  },
  {
    "videoId": "YJZe5-JnztY",
    "thumbnail": "https://i.ytimg.com/vi/YJZe5-JnztY/mqdefault.jpg",
    "title": "【壺男】そろそろ決着つけるんだからね！！！！！(Getting over it)",
    "publishedAt": "2019-03-13T11:37:12Z"
  },
  {
    "videoId": "sSk9ad1onxQ",
    "thumbnail": "https://i.ytimg.com/vi/sSk9ad1onxQ/mqdefault.jpg",
    "title": "【壺男】これで最後にしよう。さようなら。【最終回】",
    "publishedAt": "2019-03-26T12:34:15Z"
  },
  {
    "videoId": "dnsJiV8oktM",
    "thumbnail": "https://i.ytimg.com/vi/dnsJiV8oktM/mqdefault.jpg",
    "title": "【5万人記念✨】チーズフォンデュでお祝いする～！(音フェチ) EATING SOUNDS",
    "publishedAt": "2019-03-30T11:40:19Z"
  },
  {
    "videoId": "kVOfVStQGVc",
    "thumbnail": "https://i.ytimg.com/vi/kVOfVStQGVc/mqdefault.jpg",
    "title": "【激怒】先輩にガチギレしました。なんなのよ。",
    "publishedAt": "2019-04-07T12:33:02Z"
  },
  {
    "videoId": "vD_nLaXNROA",
    "thumbnail": "https://i.ytimg.com/vi/vD_nLaXNROA/mqdefault.jpg",
    "title": "【#赤井はあと新3D】新しい体を手に入れたわっ！",
    "publishedAt": "2019-04-17T12:38:22Z"
  },
  {
    "videoId": "zNoHDT8jzzs",
    "thumbnail": "https://i.ytimg.com/vi/zNoHDT8jzzs/mqdefault.jpg",
    "title": "【暴露】ばれたらヤバイ！？性癖を教えちゃう！【Vtuber】",
    "publishedAt": "2019-04-27T13:47:31Z"
  },
  {
    "videoId": "Z8TnOhIxN90",
    "thumbnail": "https://i.ytimg.com/vi/Z8TnOhIxN90/mqdefault.jpg",
    "title": "ECHO/赤井はあと【Cover】",
    "publishedAt": "2019-06-02T13:12:47Z"
  },
  {
    "videoId": "oe5ft9-9suA",
    "thumbnail": "https://i.ytimg.com/vi/oe5ft9-9suA/mqdefault.jpg",
    "title": "【1周年!】先輩にたくさんの感謝を届けたい。【記念放送】",
    "publishedAt": "2019-06-02T13:57:16Z"
  },
  {
    "videoId": "YNe5yQ3khAg",
    "thumbnail": "https://i.ytimg.com/vi/YNe5yQ3khAg/mqdefault.jpg",
    "title": "【Getting Over It】クリアするまで終われない壺男！【赤井はあと/ホロライブ】",
    "publishedAt": "2019-06-03T14:21:13Z"
  },
  {
    "videoId": "vfFxKqTEuX4",
    "thumbnail": "https://i.ytimg.com/vi/vfFxKqTEuX4/mqdefault.jpg",
    "title": "【検証】Vtuberリスナーは英語できるのか！？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-06-21T15:02:50Z"
  },
  {
    "videoId": "xBRsUdZJ8Xc",
    "thumbnail": "https://i.ytimg.com/vi/xBRsUdZJ8Xc/mqdefault.jpg",
    "title": "【3D放送】赤井はあと、ついに水着解禁！？【#ホロライブサマー / 赤井はあと】",
    "publishedAt": "2019-07-09T13:37:32Z"
  },
  {
    "videoId": "J7VU--wDbVc",
    "thumbnail": "https://i.ytimg.com/vi/J7VU--wDbVc/mqdefault.jpg",
    "title": "思い出いっぱいの『日本』との別れ。",
    "publishedAt": "2019-07-16T12:36:54Z"
  },
  {
    "videoId": "IceW8m0jzeU",
    "thumbnail": "https://i.ytimg.com/vi/IceW8m0jzeU/mqdefault.jpg",
    "title": "【アニメ】英語ペラペラな子供にいじめられた【留学体験談】",
    "publishedAt": "2019-08-15T13:00:09Z"
  },
  {
    "videoId": "eom_y2Lhy9o",
    "thumbnail": "https://i.ytimg.com/vi/eom_y2Lhy9o/mqdefault.jpg",
    "title": "【アニメ】こんな千と千尋の神隠しは嫌だｗｗｗ",
    "publishedAt": "2019-08-16T13:30:12Z"
  },
  {
    "videoId": "FS-VMlO4EBc",
    "thumbnail": "https://i.ytimg.com/vi/FS-VMlO4EBc/mqdefault.jpg",
    "title": "【寝起きで】新種のおにぎり焼き散らかす！【赤井クッキング】",
    "publishedAt": "2019-09-01T03:03:52Z"
  },
  {
    "videoId": "d71E3pHzibw",
    "thumbnail": "https://i.ytimg.com/vi/d71E3pHzibw/mqdefault.jpg",
    "title": "夏祭り  / 赤井はあと×夏色まつり【歌ってみた】",
    "publishedAt": "2019-09-06T12:00:11Z"
  },
  {
    "videoId": "Xh_UsPysuJs",
    "thumbnail": "https://i.ytimg.com/vi/Xh_UsPysuJs/mqdefault.jpg",
    "title": "【寝起きで】流行の『タピ納豆うどん』作る！【赤井クッキング】",
    "publishedAt": "2019-09-15T02:49:40Z"
  },
  {
    "videoId": "ENSxJQ1o2ZA",
    "thumbnail": "https://i.ytimg.com/vi/ENSxJQ1o2ZA/mqdefault.jpg",
    "title": "【10万人記念】私、アイドル宣言/赤井はあと【歌ってみた】",
    "publishedAt": "2019-09-27T12:00:15Z"
  },
  {
    "videoId": "xFbN5IJqnic",
    "thumbnail": "https://i.ytimg.com/vi/xFbN5IJqnic/mqdefault.jpg",
    "title": "【3D放送】10万人突破ありがとん！",
    "publishedAt": "2019-09-27T12:53:38Z"
  },
  {
    "videoId": "oIL0mdwjHxw",
    "thumbnail": "https://i.ytimg.com/vi/oIL0mdwjHxw/mqdefault.jpg",
    "title": "【さらば】日本生活、最終日。",
    "publishedAt": "2019-10-03T23:40:20Z"
  },
  {
    "videoId": "yfyLG9HoNi0",
    "thumbnail": "https://i.ytimg.com/vi/yfyLG9HoNi0/mqdefault.jpg",
    "title": "全世界のはあとんを萌えさせる。",
    "publishedAt": "2019-10-11T10:33:07Z"
  },
  {
    "videoId": "8fzDEfuHAGc",
    "thumbnail": "https://i.ytimg.com/vi/8fzDEfuHAGc/mqdefault.jpg",
    "title": "【マイクラ】新ホロ鯖で大冒険をするわよーっ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-12T12:10:09Z"
  },
  {
    "videoId": "niJO8hGLeWo",
    "thumbnail": "https://i.ytimg.com/vi/niJO8hGLeWo/mqdefault.jpg",
    "title": "【寝起きで】台風の時でも作れる！健康カップ麺【赤井クッキング】",
    "publishedAt": "2019-10-13T03:31:55Z"
  },
  {
    "videoId": "mUnVPj8SiyE",
    "thumbnail": "https://i.ytimg.com/vi/mUnVPj8SiyE/mqdefault.jpg",
    "title": "【マイクラ】ろぼ子先輩宅にお邪魔したら事故った・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-14T08:03:28Z"
  },
  {
    "videoId": "1jsVu8GbFlk",
    "thumbnail": "https://i.ytimg.com/vi/1jsVu8GbFlk/mqdefault.jpg",
    "title": "【マイクラ】新ホロ鯖でおしゃれハウスつくるわよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-15T11:36:09Z"
  },
  {
    "videoId": "W1IH9Gc8X2U",
    "thumbnail": "https://i.ytimg.com/vi/W1IH9Gc8X2U/mqdefault.jpg",
    "title": "【マイクラ】ホロ鯖におしゃれな新居作るわよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-18T05:40:01Z"
  },
  {
    "videoId": "QhPgq4L_vY0",
    "thumbnail": "https://i.ytimg.com/vi/QhPgq4L_vY0/mqdefault.jpg",
    "title": "【マイクラ】ホロ鯖にきキュートなおうちが作りたいの！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-19T10:33:13Z"
  },
  {
    "videoId": "nF04teMkozQ",
    "thumbnail": "https://i.ytimg.com/vi/nF04teMkozQ/mqdefault.jpg",
    "title": "【寝起きで】もやしで生活を乗り切るわよ！【赤井クッキング】",
    "publishedAt": "2019-10-20T02:38:33Z"
  },
  {
    "videoId": "ct7ZS0GMo0g",
    "thumbnail": "https://i.ytimg.com/vi/ct7ZS0GMo0g/mqdefault.jpg",
    "title": "【マイクラ】迷子になったりなんかしないんだからね！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-20T07:19:23Z"
  },
  {
    "videoId": "aSQ2ZCUGwT8",
    "thumbnail": "https://i.ytimg.com/vi/aSQ2ZCUGwT8/mqdefault.jpg",
    "title": "【マイクラ】すーぱーうるとらべりべりきゅーとな新居作るわよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-21T09:47:16Z"
  },
  {
    "videoId": "XwFpP3P4TnI",
    "thumbnail": "https://i.ytimg.com/vi/XwFpP3P4TnI/mqdefault.jpg",
    "title": "【マイクラ】天才による建築を見なさ――――い！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-22T08:49:37Z"
  },
  {
    "videoId": "O5ZsP8pEhL4",
    "thumbnail": "https://i.ytimg.com/vi/O5ZsP8pEhL4/mqdefault.jpg",
    "title": "【鬼畜ゲー】『QWOP』ついに完走！？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-22T10:19:31Z"
  },
  {
    "videoId": "FvyED3WYe4Y",
    "thumbnail": "https://i.ytimg.com/vi/FvyED3WYe4Y/mqdefault.jpg",
    "title": "【マイクラ】ホロ鯖に新居作りながらざつーだんっ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-24T07:39:35Z"
  },
  {
    "videoId": "_5V6och69qM",
    "thumbnail": "https://i.ytimg.com/vi/_5V6och69qM/mqdefault.jpg",
    "title": "【マイクラ】いまだに新居で来てないってマ？？？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-25T08:07:02Z"
  },
  {
    "videoId": "QbfCxMeiQR0",
    "thumbnail": "https://i.ytimg.com/vi/QbfCxMeiQR0/mqdefault.jpg",
    "title": "【激怒】クソマロ送んないでよ！ばかばかばかー！",
    "publishedAt": "2019-10-26T10:37:56Z"
  },
  {
    "videoId": "flTN1Ggi7NM",
    "thumbnail": "https://i.ytimg.com/vi/flTN1Ggi7NM/mqdefault.jpg",
    "title": "【マイクラ】ホロ鯖ハロウィン！とりっくおあとりーと！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-26T11:35:17Z"
  },
  {
    "videoId": "6yQTf7dJvIM",
    "thumbnail": "https://i.ytimg.com/vi/6yQTf7dJvIM/mqdefault.jpg",
    "title": "【マイクラ】めりーくりすまーーーーすっ！いたずらするわよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-27T08:37:56Z"
  },
  {
    "videoId": "H8ZP_4oEBnw",
    "thumbnail": "https://i.ytimg.com/vi/H8ZP_4oEBnw/mqdefault.jpg",
    "title": "【マイクラ】ホロ鯖でいたずら建築するわよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2019-10-28T10:59:36Z"
  },
  {
    "videoId": "1dhp2_oXhXI",
    "thumbnail": "https://i.ytimg.com/vi/1dhp2_oXhXI/mqdefault.jpg",
    "title": "壺男落ちたら即放送終了するわ！！！！！！！！！！！！！！！！！！！！！！！！！！！",
    "publishedAt": "2019-10-30T07:39:11Z"
  },
  {
    "videoId": "XgjWfXlSxdY",
    "thumbnail": "https://i.ytimg.com/vi/XgjWfXlSxdY/mqdefault.jpg",
    "title": "私気づいたの、一番平和なゲームはこれなんだって・・・【壺男】",
    "publishedAt": "2019-10-31T10:16:14Z"
  },
  {
    "videoId": "OGDNsZxzJP4",
    "thumbnail": "https://i.ytimg.com/vi/OGDNsZxzJP4/mqdefault.jpg",
    "title": "【マイクラ】巨大ツリーハウス作りするってマ？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-11-02T06:49:00Z"
  },
  {
    "videoId": "Na9boLmHA80",
    "thumbnail": "https://i.ytimg.com/vi/Na9boLmHA80/mqdefault.jpg",
    "title": "【マイクラ】プロ建築家参上(自称)！まったりいくわよ～【ホロライブ/赤井はあと】",
    "publishedAt": "2019-11-08T18:31:16Z"
  },
  {
    "videoId": "CmOl-bQewJw",
    "thumbnail": "https://i.ytimg.com/vi/CmOl-bQewJw/mqdefault.jpg",
    "title": "【罰ゲームあり】日本語禁止のリングフィットアドベンチャー！【RFA/Ring fit adventure】",
    "publishedAt": "2019-11-13T17:08:21Z"
  },
  {
    "videoId": "zXzsdzFR4BA",
    "thumbnail": "https://i.ytimg.com/vi/zXzsdzFR4BA/mqdefault.jpg",
    "title": "【雑】2分以内にわからせる赤井クッキング！【まとめ動画】",
    "publishedAt": "2019-11-16T01:00:13Z"
  },
  {
    "videoId": "pxxCcyOhTCQ",
    "thumbnail": "https://i.ytimg.com/vi/pxxCcyOhTCQ/mqdefault.jpg",
    "title": "Let's plow the field in MINECRAFT!",
    "publishedAt": "2019-11-17T04:13:13Z"
  },
  {
    "videoId": "4sRe-6tLK-E",
    "thumbnail": "https://i.ytimg.com/vi/4sRe-6tLK-E/mqdefault.jpg",
    "title": "【マイクラ】インテリ女子だわよ！【赤井はあと/ホロライブ】",
    "publishedAt": "2019-11-19T07:26:18Z"
  },
  {
    "videoId": "O314VOAq0og",
    "thumbnail": "https://i.ytimg.com/vi/O314VOAq0og/mqdefault.jpg",
    "title": "【前半】空中ハウスをつくっちゃうわよ～！【マイクラ】",
    "publishedAt": "2019-11-22T06:47:23Z"
  },
  {
    "videoId": "qpeEQjZkoLQ",
    "thumbnail": "https://i.ytimg.com/vi/qpeEQjZkoLQ/mqdefault.jpg",
    "title": "【後半】空中ハウスをつくてる最中に衝撃が…！【マイクラ】",
    "publishedAt": "2019-11-22T09:52:02Z"
  },
  {
    "videoId": "PMOxQz8_4O8",
    "thumbnail": "https://i.ytimg.com/vi/PMOxQz8_4O8/mqdefault.jpg",
    "title": "Let's create a FANTASY WORLD!",
    "publishedAt": "2019-11-23T02:56:19Z"
  },
  {
    "videoId": "SRcbHmyBqWE",
    "thumbnail": "https://i.ytimg.com/vi/SRcbHmyBqWE/mqdefault.jpg",
    "title": "【2日目】空中に家をつくるわよ～！【マイクラ】",
    "publishedAt": "2019-11-23T05:16:14Z"
  },
  {
    "videoId": "VOcf8gHOOgo",
    "thumbnail": "https://i.ytimg.com/vi/VOcf8gHOOgo/mqdefault.jpg",
    "title": "I'M GONNA BE  BRAVE EXPLORER!",
    "publishedAt": "2019-11-24T07:43:49Z"
  },
  {
    "videoId": "btutKmLdc50",
    "thumbnail": "https://i.ytimg.com/vi/btutKmLdc50/mqdefault.jpg",
    "title": "FUNNY＆CUTE MOMENT IN MINECRAFT! -Virtual YouTuber",
    "publishedAt": "2019-11-24T13:50:39Z"
  },
  {
    "videoId": "JdKADjGJ8k0",
    "thumbnail": "https://i.ytimg.com/vi/JdKADjGJ8k0/mqdefault.jpg",
    "title": "【マイクラ】ジブリの世界に住みたい人生だった...【ホロライブ/赤井はあと】",
    "publishedAt": "2019-11-25T10:45:52Z"
  },
  {
    "videoId": "_3HOd6vkENo",
    "thumbnail": "https://i.ytimg.com/vi/_3HOd6vkENo/mqdefault.jpg",
    "title": "ADORABLE ANIME GIRL IS HERE! - ABOUT ME -",
    "publishedAt": "2019-11-25T14:00:11Z"
  },
  {
    "videoId": "Q7EL2jlDNWM",
    "thumbnail": "https://i.ytimg.com/vi/Q7EL2jlDNWM/mqdefault.jpg",
    "title": "【マイクラ】ジブリ世界で現実逃避しよ...？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-11-27T09:04:05Z"
  },
  {
    "videoId": "_qDR6kra2hI",
    "thumbnail": "https://i.ytimg.com/vi/_qDR6kra2hI/mqdefault.jpg",
    "title": "【マイクラ】癒しのおやすみマイクラ。睡眠導入するわよ☆彡【安眠】",
    "publishedAt": "2019-11-28T18:41:26Z"
  },
  {
    "videoId": "NLifaB035hk",
    "thumbnail": "https://i.ytimg.com/vi/NLifaB035hk/mqdefault.jpg",
    "title": "RELAXING MINECRAFT LIVE STREAM🌙",
    "publishedAt": "2019-11-28T21:06:32Z"
  },
  {
    "videoId": "Fth5LCkN0kw",
    "thumbnail": "https://i.ytimg.com/vi/Fth5LCkN0kw/mqdefault.jpg",
    "title": "HOT SPRING IN THE SKY!!! -Minecraft-",
    "publishedAt": "2019-12-03T09:32:18Z"
  },
  {
    "videoId": "JjdWMOTnXyU",
    "thumbnail": "https://i.ytimg.com/vi/JjdWMOTnXyU/mqdefault.jpg",
    "title": "【激怒】なにクソマロ送ってんのよ？あん？【ホロライブ/赤井はあと】",
    "publishedAt": "2019-12-03T16:28:22Z"
  },
  {
    "videoId": "ziylb_FpvgY",
    "thumbnail": "https://i.ytimg.com/vi/ziylb_FpvgY/mqdefault.jpg",
    "title": "MINECRAFT FOR SLEEP - RELAXING-",
    "publishedAt": "2019-12-04T15:54:38Z"
  },
  {
    "videoId": "Nwqt9KgDBRo",
    "thumbnail": "https://i.ytimg.com/vi/Nwqt9KgDBRo/mqdefault.jpg",
    "title": "MINECRAFT FOR SLEEP -RELAXING-",
    "publishedAt": "2019-12-05T18:48:25Z"
  },
  {
    "videoId": "hhFMtRiLqc0",
    "thumbnail": "https://i.ytimg.com/vi/hhFMtRiLqc0/mqdefault.jpg",
    "title": "【朗報】赤井はあと、一億年ぶりの日本帰国！",
    "publishedAt": "2019-12-07T16:33:41Z"
  },
  {
    "videoId": "iO49k8GEVhI",
    "thumbnail": "https://i.ytimg.com/vi/iO49k8GEVhI/mqdefault.jpg",
    "title": "Country Road/ John Denver",
    "publishedAt": "2019-12-07T17:11:59Z"
  },
  {
    "videoId": "NGjd1cxY_mc",
    "thumbnail": "https://i.ytimg.com/vi/NGjd1cxY_mc/mqdefault.jpg",
    "title": "【マイクラ】眠れるおやすみマイクラ。睡眠導入がやってきた☆彡【安眠】",
    "publishedAt": "2019-12-08T22:02:08Z"
  },
  {
    "videoId": "TrBU4aMdbfU",
    "thumbnail": "https://i.ytimg.com/vi/TrBU4aMdbfU/mqdefault.jpg",
    "title": "【マイクラ】癒しのおやすみマイクラ。波の音を添えて♡【安眠】",
    "publishedAt": "2019-12-09T21:07:18Z"
  },
  {
    "videoId": "P-VtMuEVSrQ",
    "thumbnail": "https://i.ytimg.com/vi/P-VtMuEVSrQ/mqdefault.jpg",
    "title": "【絶叫FNAF VR】二人のビビりがVRホラゲに挑戦する！【#はーえー3D】",
    "publishedAt": "2019-12-10T11:29:34Z"
  },
  {
    "videoId": "cBhoYmgBKmM",
    "thumbnail": "https://i.ytimg.com/vi/cBhoYmgBKmM/mqdefault.jpg",
    "title": "【マイクラ】眠れるおやすみマイクラ。睡眠導入参る☆彡【安眠】",
    "publishedAt": "2019-12-11T21:20:32Z"
  },
  {
    "videoId": "luYI1VWekOY",
    "thumbnail": "https://i.ytimg.com/vi/luYI1VWekOY/mqdefault.jpg",
    "title": "【マイクラ】眠れない先輩おいで。睡眠導入やるYO☆彡【安眠】",
    "publishedAt": "2019-12-12T20:55:17Z"
  },
  {
    "videoId": "wxbEBvUfl4I",
    "thumbnail": "https://i.ytimg.com/vi/wxbEBvUfl4I/mqdefault.jpg",
    "title": "【マイクラ】癒しのおやすみマイクラ。まったり～【安眠】",
    "publishedAt": "2019-12-14T19:25:30Z"
  },
  {
    "videoId": "z0KYYo82Gi0",
    "thumbnail": "https://i.ytimg.com/vi/z0KYYo82Gi0/mqdefault.jpg",
    "title": "【寝起きで】自分の顔のキャラ弁つくる！【#赤井クッキング】",
    "publishedAt": "2019-12-15T02:28:31Z"
  },
  {
    "videoId": "rYKJbIaF8LY",
    "thumbnail": "https://i.ytimg.com/vi/rYKJbIaF8LY/mqdefault.jpg",
    "title": "RELAXING MINECARAFT for sleep【マイクラ/安眠】",
    "publishedAt": "2019-12-15T20:01:55Z"
  },
  {
    "videoId": "NH8ZwyUC0Kg",
    "thumbnail": "https://i.ytimg.com/vi/NH8ZwyUC0Kg/mqdefault.jpg",
    "title": "【マイクラ】ほっこり癒しの安眠会。(RELAXING MINECRAFT)",
    "publishedAt": "2019-12-17T21:47:09Z"
  },
  {
    "videoId": "tutupNJC3Ho",
    "thumbnail": "https://i.ytimg.com/vi/tutupNJC3Ho/mqdefault.jpg",
    "title": "I'M A BRAVE EXPLORER! -Minecraft-",
    "publishedAt": "2019-12-19T07:07:11Z"
  },
  {
    "videoId": "kX2SEl6Zd3U",
    "thumbnail": "https://i.ytimg.com/vi/kX2SEl6Zd3U/mqdefault.jpg",
    "title": "【マイクラ】癒しのおやすみマイクラ。睡眠導入参る☆彡【安眠】",
    "publishedAt": "2019-12-20T21:28:34Z"
  },
  {
    "videoId": "kCaJcebrQuc",
    "thumbnail": "https://i.ytimg.com/vi/kCaJcebrQuc/mqdefault.jpg",
    "title": "【テトリス99】100キルするまで終わらないZE！【地獄耐久】",
    "publishedAt": "2019-12-21T05:20:17Z"
  },
  {
    "videoId": "pFsPESAUoVU",
    "thumbnail": "https://i.ytimg.com/vi/pFsPESAUoVU/mqdefault.jpg",
    "title": "【マイクラ】休日の癒しのじかん～。眠れない先輩おいで？【安眠】",
    "publishedAt": "2019-12-21T20:10:59Z"
  },
  {
    "videoId": "go_pyAblmFs",
    "thumbnail": "https://i.ytimg.com/vi/go_pyAblmFs/mqdefault.jpg",
    "title": "【マイクラ】眠れない先輩おーいで。睡眠導入なのじゃ☆彡【安眠】",
    "publishedAt": "2019-12-22T20:19:24Z"
  },
  {
    "videoId": "0FYbXfYPEP8",
    "thumbnail": "https://i.ytimg.com/vi/0FYbXfYPEP8/mqdefault.jpg",
    "title": "【マイクラ】圧倒的クリぼっちな夜。ふんっ！【クリスマスイブ】",
    "publishedAt": "2019-12-23T20:18:46Z"
  },
  {
    "videoId": "kBZ49y-_oPc",
    "thumbnail": "https://i.ytimg.com/vi/kBZ49y-_oPc/mqdefault.jpg",
    "title": "【マイクラ】聖夜にするマイクラ。睡眠導入じゃい☆彡【メリークリスマス】",
    "publishedAt": "2019-12-24T19:37:46Z"
  },
  {
    "videoId": "W-4ywfJgguk",
    "thumbnail": "https://i.ytimg.com/vi/W-4ywfJgguk/mqdefault.jpg",
    "title": "Relaxing Minecraft For Sleep",
    "publishedAt": "2019-12-25T19:02:48Z"
  },
  {
    "videoId": "_TJhqZJFQ9A",
    "thumbnail": "https://i.ytimg.com/vi/_TJhqZJFQ9A/mqdefault.jpg",
    "title": "【おやすみマイクラ】眠れない先輩向け。ディスコつくる☆彡【安眠】",
    "publishedAt": "2019-12-27T20:21:58Z"
  },
  {
    "videoId": "ilQlzLdu988",
    "thumbnail": "https://i.ytimg.com/vi/ilQlzLdu988/mqdefault.jpg",
    "title": "【マイクラ】眠れない先輩おいで。巨大建築✨【安眠】",
    "publishedAt": "2019-12-29T20:33:10Z"
  },
  {
    "videoId": "yRISYOQqLv8",
    "thumbnail": "https://i.ytimg.com/vi/yRISYOQqLv8/mqdefault.jpg",
    "title": "【新衣装お披露目】センパイを萌え打首にしてやるわよっ！！【#ホロライブ正月衣装】",
    "publishedAt": "2020-01-01T06:33:52Z"
  },
  {
    "videoId": "Pb-UzlWL2Z8",
    "thumbnail": "https://i.ytimg.com/vi/Pb-UzlWL2Z8/mqdefault.jpg",
    "title": "【激怒】新年にもクソマロ送るな！ばかああ！",
    "publishedAt": "2020-01-01T16:31:30Z"
  },
  {
    "videoId": "ELqdOu3h-Co",
    "thumbnail": "https://i.ytimg.com/vi/ELqdOu3h-Co/mqdefault.jpg",
    "title": "【悲報】赤井はあと休止するってよ。【はあちゃまロス不可避】",
    "publishedAt": "2020-01-04T16:42:43Z"
  },
  {
    "videoId": "QLCcomFf8Yc",
    "thumbnail": "https://i.ytimg.com/vi/QLCcomFf8Yc/mqdefault.jpg",
    "title": "【英語ver.】千本桜／黒うさP・初音ミク【歌ってみた】(covered by 赤井はあと)",
    "publishedAt": "2020-01-20T15:00:12Z"
  },
  {
    "videoId": "E7QPBFhZ40A",
    "thumbnail": "https://i.ytimg.com/vi/E7QPBFhZ40A/mqdefault.jpg",
    "title": "【感動】伝説の赤井はあと復活配信！【再会】",
    "publishedAt": "2020-01-20T15:38:25Z"
  },
  {
    "videoId": "ct7UEQlu5nY",
    "thumbnail": "https://i.ytimg.com/vi/ct7UEQlu5nY/mqdefault.jpg",
    "title": "【晒す】先輩のツイートきもちわるい！【#赤井はあと復活祭】",
    "publishedAt": "2020-01-20T16:35:37Z"
  },
  {
    "videoId": "3STtkRt028A",
    "thumbnail": "https://i.ytimg.com/vi/3STtkRt028A/mqdefault.jpg",
    "title": "【マイクラ】愛しのホロ鯖に帰るわよ！【赤井はあと/ホロライブ】",
    "publishedAt": "2020-01-21T07:39:27Z"
  },
  {
    "videoId": "-V1dAZvERVw",
    "thumbnail": "https://i.ytimg.com/vi/-V1dAZvERVw/mqdefault.jpg",
    "title": "【逆凸】ホロライブで彼女つくる！【赤井はあと/ホロライブ】",
    "publishedAt": "2020-01-21T16:05:36Z"
  },
  {
    "videoId": "H0B4uouKlZo",
    "thumbnail": "https://i.ytimg.com/vi/H0B4uouKlZo/mqdefault.jpg",
    "title": "【安眠】マイクラの世界で演奏会する。睡眠導入☆彡【ホロライブ/赤井はあと】",
    "publishedAt": "2020-01-22T18:08:53Z"
  },
  {
    "videoId": "cNZ6PfS64c8",
    "thumbnail": "https://i.ytimg.com/vi/cNZ6PfS64c8/mqdefault.jpg",
    "title": "【マイクラ】ドキドキして寝れないから夜更かし。【#とまらないホロライブ】",
    "publishedAt": "2020-01-24T22:29:15Z"
  },
  {
    "videoId": "lgFFuv4fYOw",
    "thumbnail": "https://i.ytimg.com/vi/lgFFuv4fYOw/mqdefault.jpg",
    "title": "【晩酌マイクラ】W氏の監視部屋を強化するわよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-01-25T19:24:15Z"
  },
  {
    "videoId": "5YJrKsTAspw",
    "thumbnail": "https://i.ytimg.com/vi/5YJrKsTAspw/mqdefault.jpg",
    "title": "【マイクラ】超極秘！W氏にバレないように教会つくる！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-01-29T11:04:16Z"
  },
  {
    "videoId": "cYtUcF2VmsM",
    "thumbnail": "https://i.ytimg.com/vi/cYtUcF2VmsM/mqdefault.jpg",
    "title": "【マイクラ】ホロ鯖をてぇてぇ化するために動き出す・・・！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-01-30T10:01:24Z"
  },
  {
    "videoId": "mbG49uD6N-Q",
    "thumbnail": "https://i.ytimg.com/vi/mbG49uD6N-Q/mqdefault.jpg",
    "title": "【マイクラ】今ならホロ鯖でやりたい放題！卍【ホロライブ/赤井はあと】",
    "publishedAt": "2020-01-31T09:40:55Z"
  },
  {
    "videoId": "J7EO_nblfcE",
    "thumbnail": "https://i.ytimg.com/vi/J7EO_nblfcE/mqdefault.jpg",
    "title": "【耐久】眠くなるまで教会つくるわよ～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-01T00:55:36Z"
  },
  {
    "videoId": "EpmJoqPchDQ",
    "thumbnail": "https://i.ytimg.com/vi/EpmJoqPchDQ/mqdefault.jpg",
    "title": "【初☆コラボ】ついに、この日が来たわよ...！！！【ホロライブ/赤井はあと×角巻わため】",
    "publishedAt": "2020-02-01T11:36:23Z"
  },
  {
    "videoId": "gsQQ3BEZ-S4",
    "thumbnail": "https://i.ytimg.com/vi/gsQQ3BEZ-S4/mqdefault.jpg",
    "title": "【マイクラ】PCデータ全ロスしたのでまったり雑談と建築【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-01T23:41:18Z"
  },
  {
    "videoId": "p2la__chwdA",
    "thumbnail": "https://i.ytimg.com/vi/p2la__chwdA/mqdefault.jpg",
    "title": "RELAXING MINECRAFT is here!!✨",
    "publishedAt": "2020-02-02T01:49:45Z"
  },
  {
    "videoId": "I7_t4e-QTGw",
    "thumbnail": "https://i.ytimg.com/vi/I7_t4e-QTGw/mqdefault.jpg",
    "title": "【第一回英語テスト】#ホロライブ珍回答王 は誰だ！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-12T11:48:25Z"
  },
  {
    "videoId": "siIr9iASfFk",
    "thumbnail": "https://i.ytimg.com/vi/siIr9iASfFk/mqdefault.jpg",
    "title": "【英語検定】珍回答王なんて言わせない！つよつよ英語！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-13T11:56:59Z"
  },
  {
    "videoId": "zH72eSD-Kig",
    "thumbnail": "https://i.ytimg.com/vi/zH72eSD-Kig/mqdefault.jpg",
    "title": "【マイクラ】バレンタインなので教会つくるわ！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-14T10:21:32Z"
  },
  {
    "videoId": "n37auBITn38",
    "thumbnail": "https://i.ytimg.com/vi/n37auBITn38/mqdefault.jpg",
    "title": "【祝杯】収益化復活したのでたくさん祝う！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-15T16:48:43Z"
  },
  {
    "videoId": "5vEQhBKg0aM",
    "thumbnail": "https://i.ytimg.com/vi/5vEQhBKg0aM/mqdefault.jpg",
    "title": "【マイクラ】極秘任務！W氏監視部屋リフォーム計画！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-18T10:25:32Z"
  },
  {
    "videoId": "We5Imseqk1I",
    "thumbnail": "https://i.ytimg.com/vi/We5Imseqk1I/mqdefault.jpg",
    "title": "【テトリス99】一位余裕なんだからっ！！！リハビリだし！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-21T10:12:23Z"
  },
  {
    "videoId": "GBGO6Eys9gc",
    "thumbnail": "https://i.ytimg.com/vi/GBGO6Eys9gc/mqdefault.jpg",
    "title": "THIS GAME MAKE ME CRY!!! -Getting over it-",
    "publishedAt": "2020-02-22T17:04:45Z"
  },
  {
    "videoId": "b3lr10YQ0D8",
    "thumbnail": "https://i.ytimg.com/vi/b3lr10YQ0D8/mqdefault.jpg",
    "title": "【Minecraft】眠れない先輩おいで～睡眠導入ぶひ☆彡【ホロライブ/赤井はあと】",
    "publishedAt": "2020-02-24T18:09:07Z"
  },
  {
    "videoId": "iKZYJWxuLC8",
    "thumbnail": "https://i.ytimg.com/vi/iKZYJWxuLC8/mqdefault.jpg",
    "title": "【歌ってみた】World is Mine/ワールドイズマイン【赤井はあと】",
    "publishedAt": "2020-02-27T11:00:10Z"
  },
  {
    "videoId": "Od5idez3Xxg",
    "thumbnail": "https://i.ytimg.com/vi/Od5idez3Xxg/mqdefault.jpg",
    "title": "【夜勤事件】びびびびってなんかないし！？つよつよ度胸試し！【ホラゲ/赤井はあと】",
    "publishedAt": "2020-02-28T17:54:48Z"
  },
  {
    "videoId": "Jk2QYzTA9bU",
    "thumbnail": "https://i.ytimg.com/vi/Jk2QYzTA9bU/mqdefault.jpg",
    "title": "【#ホロ英語伝言ゲーム】まさかの空耳地獄！？英会話伝言ゲーム！【ホロライブ】",
    "publishedAt": "2020-03-02T14:09:39Z"
  },
  {
    "videoId": "PvUtJNnQh_U",
    "thumbnail": "https://i.ytimg.com/vi/PvUtJNnQh_U/mqdefault.jpg",
    "title": "ぼっちでマルチゲームを極めすぎた結果・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-05T12:40:36Z"
  },
  {
    "videoId": "7cpStYK4ltk",
    "thumbnail": "https://i.ytimg.com/vi/7cpStYK4ltk/mqdefault.jpg",
    "title": "罵倒が欲しかったんでしょ？キモヲタくん？w【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-06T12:34:54Z"
  },
  {
    "videoId": "1QtR24Zzkfc",
    "thumbnail": "https://i.ytimg.com/vi/1QtR24Zzkfc/mqdefault.jpg",
    "title": "【真昼間に】精神崩壊！？そんなもの私の辞書にないわ！【あ゛あ゛あ゛】",
    "publishedAt": "2020-03-09T05:32:30Z"
  },
  {
    "videoId": "Z9ZetWLGNVU",
    "thumbnail": "https://i.ytimg.com/vi/Z9ZetWLGNVU/mqdefault.jpg",
    "title": "Vtuber界一ぼっち実況がうまいです。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-11T08:44:44Z"
  },
  {
    "videoId": "gcVq6RrTAuk",
    "thumbnail": "https://i.ytimg.com/vi/gcVq6RrTAuk/mqdefault.jpg",
    "title": "【耐久】〝足で〟壺男をプレイした結果！ｗ【#はあちゃま足臭】",
    "publishedAt": "2020-03-13T09:58:14Z"
  },
  {
    "videoId": "wIgbpQBkHEE",
    "thumbnail": "https://i.ytimg.com/vi/wIgbpQBkHEE/mqdefault.jpg",
    "title": "【凸待ち】ホロライブメンバーから凸が来る予感しかしない！【30万人記念(幻覚)】",
    "publishedAt": "2020-03-13T13:34:21Z"
  },
  {
    "videoId": "uue_C0v9Dpk",
    "thumbnail": "https://i.ytimg.com/vi/uue_C0v9Dpk/mqdefault.jpg",
    "title": "【足で】ホロライブメンバーを描く！かんぺきっ！【#はあちゃま足臭】",
    "publishedAt": "2020-03-15T13:37:14Z"
  },
  {
    "videoId": "qe7yU8KQXr8",
    "thumbnail": "https://i.ytimg.com/vi/qe7yU8KQXr8/mqdefault.jpg",
    "title": "【新作の】鬼畜ゲーム！？よよよよよ余裕だし！？？？ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-17T08:32:48Z"
  },
  {
    "videoId": "h4a7JuLUxGs",
    "thumbnail": "https://i.ytimg.com/vi/h4a7JuLUxGs/mqdefault.jpg",
    "title": "清楚なオタクたちのリプお披露目会【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-25T16:31:56Z"
  },
  {
    "videoId": "E5yj0nP-SAU",
    "thumbnail": "https://i.ytimg.com/vi/E5yj0nP-SAU/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】闇の深すぎるリスナー島巡り【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-26T11:31:52Z"
  },
  {
    "videoId": "iMp4n0fOIfQ",
    "thumbnail": "https://i.ytimg.com/vi/iMp4n0fOIfQ/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】ホロメンくるまで終われない！島凸待ち！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-28T09:54:27Z"
  },
  {
    "videoId": "jaTDD-MGFUw",
    "thumbnail": "https://i.ytimg.com/vi/jaTDD-MGFUw/mqdefault.jpg",
    "title": "【検証】徹夜明けではあちゃまはテトリス1位取れるのか！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-29T05:52:38Z"
  },
  {
    "videoId": "W2XdKI_7zUA",
    "thumbnail": "https://i.ytimg.com/vi/W2XdKI_7zUA/mqdefault.jpg",
    "title": "仲間割れしまくる戦闘ゲームが楽しすぎる！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-30T08:43:05Z"
  },
  {
    "videoId": "6fBLqR1k_8Y",
    "thumbnail": "https://i.ytimg.com/vi/6fBLqR1k_8Y/mqdefault.jpg",
    "title": "「牛乳」を守る闇の組織との戦いが壮絶すぎる【ホロライブ/赤井はあと】",
    "publishedAt": "2020-03-31T08:45:44Z"
  },
  {
    "videoId": "nQczF51q4cg",
    "thumbnail": "https://i.ytimg.com/vi/nQczF51q4cg/mqdefault.jpg",
    "title": "【スマブラ】最近始めたばっかだけど負ける気しないわ！！！ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-06T05:33:53Z"
  },
  {
    "videoId": "laEEs6PTfKg",
    "thumbnail": "https://i.ytimg.com/vi/laEEs6PTfKg/mqdefault.jpg",
    "title": "はあちゃま、キャラのアプデしたってよ。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-06T10:36:49Z"
  },
  {
    "videoId": "E16XjDsSTQg",
    "thumbnail": "https://i.ytimg.com/vi/E16XjDsSTQg/mqdefault.jpg",
    "title": "【死んだら即終了】バニメン40時間プレイしたガチ勢による戦い【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-11T02:08:56Z"
  },
  {
    "videoId": "YL0dqMxfOeo",
    "thumbnail": "https://i.ytimg.com/vi/YL0dqMxfOeo/mqdefault.jpg",
    "title": "【耐久】バニメン全コースクリアするまで終われない！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-12T05:31:40Z"
  },
  {
    "videoId": "W8iXIoYLe2A",
    "thumbnail": "https://i.ytimg.com/vi/W8iXIoYLe2A/mqdefault.jpg",
    "title": "【視聴者参加型】余裕しか感じられないスマブラ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-13T06:07:45Z"
  },
  {
    "videoId": "hMgLNzrMfM4",
    "thumbnail": "https://i.ytimg.com/vi/hMgLNzrMfM4/mqdefault.jpg",
    "title": "【テトリス99】圧倒的な力の差ってもんをみせてやるよ！ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-14T07:47:19Z"
  },
  {
    "videoId": "1q-DzQFggrA",
    "thumbnail": "https://i.ytimg.com/vi/1q-DzQFggrA/mqdefault.jpg",
    "title": "【#ヲタク写メコン】ダサすぎ！？ヲタクの服装チェック！【ホロライブ/赤井はあと/にじさんじ/星川サラ】",
    "publishedAt": "2020-04-14T13:54:42Z"
  },
  {
    "videoId": "IUuxFBCKZU0",
    "thumbnail": "https://i.ytimg.com/vi/IUuxFBCKZU0/mqdefault.jpg",
    "title": "【寝起きで】鬼畜コース！？よよよ余裕過ぎるんだがｗｗｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-18T03:44:18Z"
  },
  {
    "videoId": "AM99ebLuqUY",
    "thumbnail": "https://i.ytimg.com/vi/AM99ebLuqUY/mqdefault.jpg",
    "title": "【ぶおおおおお】1時間以内で壺男クリア！余裕にRTA！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-19T10:03:14Z"
  },
  {
    "videoId": "RHJrbsH6k6Y",
    "thumbnail": "https://i.ytimg.com/vi/RHJrbsH6k6Y/mqdefault.jpg",
    "title": "【足で】世界1位目指す！かかってこいや！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-20T08:34:32Z"
  },
  {
    "videoId": "EUyGuGEFSaE",
    "thumbnail": "https://i.ytimg.com/vi/EUyGuGEFSaE/mqdefault.jpg",
    "title": "【激ムズ！】鬼畜だけど “クセになる” 音ゲー！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-21T08:37:11Z"
  },
  {
    "videoId": "PFaGWAK5qJM",
    "thumbnail": "https://i.ytimg.com/vi/PFaGWAK5qJM/mqdefault.jpg",
    "title": "【寝起きで】鬼畜ゲー！？ミ〇キーの様子がおかしい・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-26T05:31:51Z"
  },
  {
    "videoId": "ontj3y9IEuM",
    "thumbnail": "https://i.ytimg.com/vi/ontj3y9IEuM/mqdefault.jpg",
    "title": "【壺男】雑談のついでに余裕でクリアしちゃうよん！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-28T09:22:10Z"
  },
  {
    "videoId": "XpztZIP73-I",
    "thumbnail": "https://i.ytimg.com/vi/XpztZIP73-I/mqdefault.jpg",
    "title": "【鬼畜】心がぶっ壊れる！？メンタル＼(^o^)／ｵﾜﾀｗｗｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-04-30T15:06:36Z"
  },
  {
    "videoId": "1l26zuLlHFU",
    "thumbnail": "https://i.ytimg.com/vi/1l26zuLlHFU/mqdefault.jpg",
    "title": "【鬼畜】精神崩壊ゲーム！？メンタル＼(^o^)／ｵﾜﾀｗｗｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-01T10:49:00Z"
  },
  {
    "videoId": "rOQosfSrdKQ",
    "thumbnail": "https://i.ytimg.com/vi/rOQosfSrdKQ/mqdefault.jpg",
    "title": "【絶叫】閲覧注意レベル(らしい)ホラゲをやった結果・・・。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-02T15:19:09Z"
  },
  {
    "videoId": "W-HaY-36i0w",
    "thumbnail": "https://i.ytimg.com/vi/W-HaY-36i0w/mqdefault.jpg",
    "title": "【罵倒】変なマシュマロおくんないでよ！！！ばか！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-08T16:02:03Z"
  },
  {
    "videoId": "nAjy8WgLUcU",
    "thumbnail": "https://i.ytimg.com/vi/nAjy8WgLUcU/mqdefault.jpg",
    "title": "【寝起きで】死にゲー！？心がへし折られる鬼畜度【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-09T03:10:30Z"
  },
  {
    "videoId": "atCoTSGZPRQ",
    "thumbnail": "https://i.ytimg.com/vi/atCoTSGZPRQ/mqdefault.jpg",
    "title": "【英語テスト】 角巻わため VS  姫森ルーナ 英語力どのくらい？【#ぬきうちはあと】",
    "publishedAt": "2020-05-13T12:25:48Z"
  },
  {
    "videoId": "WROP5xuTLzY",
    "thumbnail": "https://i.ytimg.com/vi/WROP5xuTLzY/mqdefault.jpg",
    "title": "【嫁にしたいVtuberは？】ホロライブリスナーにアンケで聞いてみた！【#ホロライブファン】",
    "publishedAt": "2020-05-15T16:21:16Z"
  },
  {
    "videoId": "baRgVvRS-xY",
    "thumbnail": "https://i.ytimg.com/vi/baRgVvRS-xY/mqdefault.jpg",
    "title": "【脱足臭!!劇的ビフォーアフター】人生を変えたい、そう決意した。【#はあちゃま足臭/ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-17T11:15:13Z"
  },
  {
    "videoId": "4XqoCiXDtwQ",
    "thumbnail": "https://i.ytimg.com/vi/4XqoCiXDtwQ/mqdefault.jpg",
    "title": "【春のアンチ感謝祭!!】神様仏様アンチ様！圧倒的感謝！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-18T13:19:51Z"
  },
  {
    "videoId": "Jm9gvJGXzpo",
    "thumbnail": "https://i.ytimg.com/vi/Jm9gvJGXzpo/mqdefault.jpg",
    "title": "【ホロメン凸待ち】録音した音声だけで通話してみる！【#はあちゃま記念/ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-20T13:08:16Z"
  },
  {
    "videoId": "Nkf5bYi9cP8",
    "thumbnail": "https://i.ytimg.com/vi/Nkf5bYi9cP8/mqdefault.jpg",
    "title": "【#ホロ飯テロ】アイドルの食生活を調査してみた結果！？【ホロライブ/赤井はあと/友人A】",
    "publishedAt": "2020-05-22T12:13:06Z"
  },
  {
    "videoId": "UZ7EavezZ4A",
    "thumbnail": "https://i.ytimg.com/vi/UZ7EavezZ4A/mqdefault.jpg",
    "title": "【2分クッキング！】ヲタクに料理させた結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-29T10:27:28Z"
  },
  {
    "videoId": "wH8BPAvkwkM",
    "thumbnail": "https://i.ytimg.com/vi/wH8BPAvkwkM/mqdefault.jpg",
    "title": "【負けたら腹筋!?】ネイティブ　ＶＳ　留学生　ガチボコ英語対決・・・！？【#はあココ】",
    "publishedAt": "2020-05-29T13:11:50Z"
  },
  {
    "videoId": "SusFyQXRZMs",
    "thumbnail": "https://i.ytimg.com/vi/SusFyQXRZMs/mqdefault.jpg",
    "title": "超危険!?海外のエナドリ全種飲み比べ！【※良い子はマネしないでね！】",
    "publishedAt": "2020-05-30T09:26:40Z"
  },
  {
    "videoId": "A5VyoVr5y34",
    "thumbnail": "https://i.ytimg.com/vi/A5VyoVr5y34/mqdefault.jpg",
    "title": "ゲロ吐いて叩かれたアイドルが物申す【ホロライブ/赤井はあと】",
    "publishedAt": "2020-05-31T07:00:13Z"
  },
  {
    "videoId": "kCtwswO1hfM",
    "thumbnail": "https://i.ytimg.com/vi/kCtwswO1hfM/mqdefault.jpg",
    "title": "プロフェッショナルアイドルの流儀【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-01T15:00:30Z"
  },
  {
    "videoId": "etVnek5pOjw",
    "thumbnail": "https://i.ytimg.com/vi/etVnek5pOjw/mqdefault.jpg",
    "title": "【2周年記念】開始10分で衝撃の展開！？はあちゃままさかの・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-02T16:06:49Z"
  },
  {
    "videoId": "fCiq-V9krp4",
    "thumbnail": "https://i.ytimg.com/vi/fCiq-V9krp4/mqdefault.jpg",
    "title": "【実体験】気を付けて！もしかして騙されてるかも・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-03T10:13:44Z"
  },
  {
    "videoId": "FchiWue45KI",
    "thumbnail": "https://i.ytimg.com/vi/FchiWue45KI/mqdefault.jpg",
    "title": "絶対に笑ってはいけないホロライブ！？最強コンビの戦い！【#ちゃまたん】",
    "publishedAt": "2020-06-04T10:12:14Z"
  },
  {
    "videoId": "pkGvRvyEItM",
    "thumbnail": "https://i.ytimg.com/vi/pkGvRvyEItM/mqdefault.jpg",
    "title": "『RED HEART』1stオリジナルソング-宣伝MV-",
    "publishedAt": "2020-06-06T08:32:29Z"
  },
  {
    "videoId": "cAdvOjR1DWE",
    "thumbnail": "https://i.ytimg.com/vi/cAdvOjR1DWE/mqdefault.jpg",
    "title": "【パパ対談】私達の実のパパがヤバイって訳。【#はあココ】",
    "publishedAt": "2020-06-06T12:56:18Z"
  },
  {
    "videoId": "98Ks422-gqo",
    "thumbnail": "https://i.ytimg.com/vi/98Ks422-gqo/mqdefault.jpg",
    "title": "最近、真面目に悩んでる事。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-10T13:18:52Z"
  },
  {
    "videoId": "UtR1Q0OQGNA",
    "thumbnail": "https://i.ytimg.com/vi/UtR1Q0OQGNA/mqdefault.jpg",
    "title": "はあちゃま、旅立ち。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-11T14:01:15Z"
  },
  {
    "videoId": "mA-Hi29pqTg",
    "thumbnail": "https://i.ytimg.com/vi/mA-Hi29pqTg/mqdefault.jpg",
    "title": "【帰還】悩みがあるんだ。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-12T11:39:06Z"
  },
  {
    "videoId": "Gn3DySrXfBk",
    "thumbnail": "https://i.ytimg.com/vi/Gn3DySrXfBk/mqdefault.jpg",
    "title": "【ぼっちで果てまでいってQ！】オーストラリア徘徊【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-13T12:40:41Z"
  },
  {
    "videoId": "va68lEvWYD0",
    "thumbnail": "https://i.ytimg.com/vi/va68lEvWYD0/mqdefault.jpg",
    "title": "35臆記念で焼肉を焼く放送【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-13T16:56:33Z"
  },
  {
    "videoId": "lL-piL4N74U",
    "thumbnail": "https://i.ytimg.com/vi/lL-piL4N74U/mqdefault.jpg",
    "title": "【壺男】一時間以内にクリアのはずがまさかの・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-14T10:07:55Z"
  },
  {
    "videoId": "BwV1o4fkKcA",
    "thumbnail": "https://i.ytimg.com/vi/BwV1o4fkKcA/mqdefault.jpg",
    "title": "ヲタク共に言いたい事がある！",
    "publishedAt": "2020-06-14T13:16:58Z"
  },
  {
    "videoId": "kkP_Un8Hv4k",
    "thumbnail": "https://i.ytimg.com/vi/kkP_Un8Hv4k/mqdefault.jpg",
    "title": "▢リボしか勝たん！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-15T13:35:44Z"
  },
  {
    "videoId": "xKa3pOHJvVk",
    "thumbnail": "https://i.ytimg.com/vi/xKa3pOHJvVk/mqdefault.jpg",
    "title": "見なきゃ発作が起きる中毒歌枠【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-16T11:06:37Z"
  },
  {
    "videoId": "KmGe-28JV00",
    "thumbnail": "https://i.ytimg.com/vi/KmGe-28JV00/mqdefault.jpg",
    "title": "【#ぽてとりお】3人で恋愛相談する～！！！【ホロライブ/赤井はあと/角巻わため/姫森ルーナ】",
    "publishedAt": "2020-06-17T11:10:51Z"
  },
  {
    "videoId": "om0EHrGdFYg",
    "thumbnail": "https://i.ytimg.com/vi/om0EHrGdFYg/mqdefault.jpg",
    "title": "絶望的!?動画で汚部屋ツアーした結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-19T12:58:44Z"
  },
  {
    "videoId": "QX-CcKFGph8",
    "thumbnail": "https://i.ytimg.com/vi/QX-CcKFGph8/mqdefault.jpg",
    "title": "【悲報】ついに日本出禁になりました。",
    "publishedAt": "2020-06-19T13:47:16Z"
  },
  {
    "videoId": "V30bbTLmiEk",
    "thumbnail": "https://i.ytimg.com/vi/V30bbTLmiEk/mqdefault.jpg",
    "title": "【緊急】日本出禁だけど帰国してみた！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-20T09:30:20Z"
  },
  {
    "videoId": "rNoKEEfwLcE",
    "thumbnail": "https://i.ytimg.com/vi/rNoKEEfwLcE/mqdefault.jpg",
    "title": "密入国した結果とんでもないことに・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-20T09:40:27Z"
  },
  {
    "videoId": "D1t0NsYy4mI",
    "thumbnail": "https://i.ytimg.com/vi/D1t0NsYy4mI/mqdefault.jpg",
    "title": "2分で「餃子」作った結果・・・！？【はあちゃまクッキング】",
    "publishedAt": "2020-06-20T14:14:38Z"
  },
  {
    "videoId": "JR6kZQMFBa0",
    "thumbnail": "https://i.ytimg.com/vi/JR6kZQMFBa0/mqdefault.jpg",
    "title": "ヲタクのための唄",
    "publishedAt": "2020-06-21T13:57:49Z"
  },
  {
    "videoId": "K7-qlgak5ec",
    "thumbnail": "https://i.ytimg.com/vi/K7-qlgak5ec/mqdefault.jpg",
    "title": "【黒歴史】みんなの過去が恥ずかしすぎるｗｗｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-22T11:37:35Z"
  },
  {
    "videoId": "R9dLe4vOfz8",
    "thumbnail": "https://i.ytimg.com/vi/R9dLe4vOfz8/mqdefault.jpg",
    "title": "2分で「カレー」作ったらエグすぎた・・・！？【はあちゃまクッキング】",
    "publishedAt": "2020-06-22T14:33:54Z"
  },
  {
    "videoId": "L-cEcZ1juYA",
    "thumbnail": "https://i.ytimg.com/vi/L-cEcZ1juYA/mqdefault.jpg",
    "title": "【#ホロ謎メン】アイドル4人の蹴落とし合いバトル・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-23T13:36:46Z"
  },
  {
    "videoId": "t2OMO4LPfSQ",
    "thumbnail": "https://i.ytimg.com/vi/t2OMO4LPfSQ/mqdefault.jpg",
    "title": "ぴえんの唄【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-23T14:38:44Z"
  },
  {
    "videoId": "XAcKUKf1sRo",
    "thumbnail": "https://i.ytimg.com/vi/XAcKUKf1sRo/mqdefault.jpg",
    "title": "【初心に戻る】一時間キレイに歌い続ける放送【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-24T08:02:55Z"
  },
  {
    "videoId": "LLhPzcqDfAQ",
    "thumbnail": "https://i.ytimg.com/vi/LLhPzcqDfAQ/mqdefault.jpg",
    "title": "【#ちゃまたん】平和に動物を積むはずがまさかの・・・！？【ホロライブ/赤井はあと/天音かなた】",
    "publishedAt": "2020-06-24T10:05:04Z"
  },
  {
    "videoId": "0F2x-sDpSfw",
    "thumbnail": "https://i.ytimg.com/vi/0F2x-sDpSfw/mqdefault.jpg",
    "title": "【#コスプレ選手権】ヲタクとガチ勢がすごすぎるｗｗｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-25T12:00:46Z"
  },
  {
    "videoId": "kPBZOjh-tP4",
    "thumbnail": "https://i.ytimg.com/vi/kPBZOjh-tP4/mqdefault.jpg",
    "title": "2分で「パスタ」を作った結果・・・！？【はあちゃまクッキング】",
    "publishedAt": "2020-06-26T14:00:13Z"
  },
  {
    "videoId": "ALNSQbb-yss",
    "thumbnail": "https://i.ytimg.com/vi/ALNSQbb-yss/mqdefault.jpg",
    "title": "ひたすら寿司を作るだけ放送【はあちゃまクッキング】",
    "publishedAt": "2020-06-27T09:58:41Z"
  },
  {
    "videoId": "-RmGyoORDlo",
    "thumbnail": "https://i.ytimg.com/vi/-RmGyoORDlo/mqdefault.jpg",
    "title": "ぼっちでぶらり旅【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-28T09:41:45Z"
  },
  {
    "videoId": "OM4hlTljR7E",
    "thumbnail": "https://i.ytimg.com/vi/OM4hlTljR7E/mqdefault.jpg",
    "title": "アイドルなのに足くせーじゃん！ｗｗｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-29T09:56:39Z"
  },
  {
    "videoId": "J3X3IgEeO-M",
    "thumbnail": "https://i.ytimg.com/vi/J3X3IgEeO-M/mqdefault.jpg",
    "title": "新・たこ焼きつくり！withルーナ先生【ホロライブ/赤井はあと/姫森ルーナ】",
    "publishedAt": "2020-06-29T14:05:24Z"
  },
  {
    "videoId": "pp-1f8M6gQs",
    "thumbnail": "https://i.ytimg.com/vi/pp-1f8M6gQs/mqdefault.jpg",
    "title": "笑ったら激辛ペヤング【ホロライブ/赤井はあと】",
    "publishedAt": "2020-06-30T11:10:36Z"
  },
  {
    "videoId": "Cfo9ZDTrKMs",
    "thumbnail": "https://i.ytimg.com/vi/Cfo9ZDTrKMs/mqdefault.jpg",
    "title": "高音域はあちゃまテスト",
    "publishedAt": "2020-06-30T12:09:28Z"
  },
  {
    "videoId": "cGxKncDHY_U",
    "thumbnail": "https://i.ytimg.com/vi/cGxKncDHY_U/mqdefault.jpg",
    "title": "野菜パンケーキ作ってみた！【はあちゃまクッキング】",
    "publishedAt": "2020-06-30T15:50:17Z"
  },
  {
    "videoId": "yyXeRlvMV5I",
    "thumbnail": "https://i.ytimg.com/vi/yyXeRlvMV5I/mqdefault.jpg",
    "title": "再来!?日本と韓国の激辛食べ比べ！【※良い子はマネしないでね！】",
    "publishedAt": "2020-07-01T11:07:26Z"
  },
  {
    "videoId": "XTlDdGA5cO8",
    "thumbnail": "https://i.ytimg.com/vi/XTlDdGA5cO8/mqdefault.jpg",
    "title": "新・ラーメン作ってみた！【はあちゃまクッキング】",
    "publishedAt": "2020-07-02T15:11:36Z"
  },
  {
    "videoId": "Jr9aW5XlTLc",
    "thumbnail": "https://i.ytimg.com/vi/Jr9aW5XlTLc/mqdefault.jpg",
    "title": "【はあちゃま自己紹介動画】",
    "publishedAt": "2020-07-02T19:58:45Z"
  },
  {
    "videoId": "-i_a0iafU3Q",
    "thumbnail": "https://i.ytimg.com/vi/-i_a0iafU3Q/mqdefault.jpg",
    "title": "レッドブルの使用方法5選【はあちゃまライフ】",
    "publishedAt": "2020-07-04T03:20:01Z"
  },
  {
    "videoId": "rAEjfEd8uSk",
    "thumbnail": "https://i.ytimg.com/vi/rAEjfEd8uSk/mqdefault.jpg",
    "title": "噂の!?メントスコーラ焼き！【はあちゃまクッキング】",
    "publishedAt": "2020-07-04T13:57:29Z"
  },
  {
    "videoId": "ov_RuNeHSTM",
    "thumbnail": "https://i.ytimg.com/vi/ov_RuNeHSTM/mqdefault.jpg",
    "title": "【はあちゃま丸わかりCM】",
    "publishedAt": "2020-07-04T22:41:59Z"
  },
  {
    "videoId": "wzRwXW7QtVg",
    "thumbnail": "https://i.ytimg.com/vi/wzRwXW7QtVg/mqdefault.jpg",
    "title": "セルカ棒の使用方法5選【はあちゃまライフ】",
    "publishedAt": "2020-07-05T13:01:31Z"
  },
  {
    "videoId": "9zJMVHULJ0c",
    "thumbnail": "https://i.ytimg.com/vi/9zJMVHULJ0c/mqdefault.jpg",
    "title": "カレーパスタ作ってみた！【はあちゃまクッキング】",
    "publishedAt": "2020-07-05T14:09:38Z"
  },
  {
    "videoId": "NRKsqut_FUw",
    "thumbnail": "https://i.ytimg.com/vi/NRKsqut_FUw/mqdefault.jpg",
    "title": "いちご飴作ってみた！【はあちゃまクッキング】",
    "publishedAt": "2020-07-06T14:05:07Z"
  },
  {
    "videoId": "v5UvcxZE200",
    "thumbnail": "https://i.ytimg.com/vi/v5UvcxZE200/mqdefault.jpg",
    "title": "鍋しながら凸待ちしようぜ【#はあちゃま祝祭】",
    "publishedAt": "2020-07-06T15:10:12Z"
  },
  {
    "videoId": "mmDdOJDhzHs",
    "thumbnail": "https://i.ytimg.com/vi/mmDdOJDhzHs/mqdefault.jpg",
    "title": "はあちゃま三世のテーマ",
    "publishedAt": "2020-07-06T21:29:48Z"
  },
  {
    "videoId": "gNQ2Tr8zeUs",
    "thumbnail": "https://i.ytimg.com/vi/gNQ2Tr8zeUs/mqdefault.jpg",
    "title": "うわああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああん【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-07T11:42:03Z"
  },
  {
    "videoId": "afJEpNE-Al8",
    "thumbnail": "https://i.ytimg.com/vi/afJEpNE-Al8/mqdefault.jpg",
    "title": "はあちゃまは変〇",
    "publishedAt": "2020-07-07T21:04:55Z"
  },
  {
    "videoId": "PPgGdJ5dAKI",
    "thumbnail": "https://i.ytimg.com/vi/PPgGdJ5dAKI/mqdefault.jpg",
    "title": "ツイ廃なのでツイートと会話するなどした",
    "publishedAt": "2020-07-08T08:11:01Z"
  },
  {
    "videoId": "cSYup1dVXX0",
    "thumbnail": "https://i.ytimg.com/vi/cSYup1dVXX0/mqdefault.jpg",
    "title": "天才的!?ヲタクに特技を募集した結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-08T13:24:22Z"
  },
  {
    "videoId": "zSYo8ZIIU88",
    "thumbnail": "https://i.ytimg.com/vi/zSYo8ZIIU88/mqdefault.jpg",
    "title": "はあちゃまチャンネル♪【テーマソング】",
    "publishedAt": "2020-07-08T13:29:15Z"
  },
  {
    "videoId": "0y6vH-AZKMk",
    "thumbnail": "https://i.ytimg.com/vi/0y6vH-AZKMk/mqdefault.jpg",
    "title": "たこ焼きキュウリこんにゃくのり巻き作った【はあちゃまクッキング】",
    "publishedAt": "2020-07-08T15:39:41Z"
  },
  {
    "videoId": "a0EOKKRph54",
    "thumbnail": "https://i.ytimg.com/vi/a0EOKKRph54/mqdefault.jpg",
    "title": "今日もはあ虐で飯を食う",
    "publishedAt": "2020-07-09T10:50:45Z"
  },
  {
    "videoId": "HQvX9ClXsWE",
    "thumbnail": "https://i.ytimg.com/vi/HQvX9ClXsWE/mqdefault.jpg",
    "title": "ポテトサラダ作った【はあちゃまクッキング】",
    "publishedAt": "2020-07-09T14:02:11Z"
  },
  {
    "videoId": "_WaiCiwUqQI",
    "thumbnail": "https://i.ytimg.com/vi/_WaiCiwUqQI/mqdefault.jpg",
    "title": "はあちゃまで音MAD作ってみた",
    "publishedAt": "2020-07-09T20:59:31Z"
  },
  {
    "videoId": "WvaS0AWONB0",
    "thumbnail": "https://i.ytimg.com/vi/WvaS0AWONB0/mqdefault.jpg",
    "title": "超巨大!?スライム作る放送【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-11T11:00:12Z"
  },
  {
    "videoId": "UdNsz8y3Bwg",
    "thumbnail": "https://i.ytimg.com/vi/UdNsz8y3Bwg/mqdefault.jpg",
    "title": "正気な狂気のコンテンツ",
    "publishedAt": "2020-07-12T21:29:55Z"
  },
  {
    "videoId": "xBqWAQodhFg",
    "thumbnail": "https://i.ytimg.com/vi/xBqWAQodhFg/mqdefault.jpg",
    "title": "インスタ映え朝食作った結果・・・！？【はあちゃまクッキング】",
    "publishedAt": "2020-07-13T09:14:19Z"
  },
  {
    "videoId": "tpp4OU9v3yY",
    "thumbnail": "https://i.ytimg.com/vi/tpp4OU9v3yY/mqdefault.jpg",
    "title": "無心",
    "publishedAt": "2020-07-14T12:09:04Z"
  },
  {
    "videoId": "GRdmDKlb_bw",
    "thumbnail": "https://i.ytimg.com/vi/GRdmDKlb_bw/mqdefault.jpg",
    "title": "新・カレーライス作り！withかなた先生【ホロライブ/赤井はあと/天音かなた】",
    "publishedAt": "2020-07-15T14:08:06Z"
  },
  {
    "videoId": "l422JoYoDMY",
    "thumbnail": "https://i.ytimg.com/vi/l422JoYoDMY/mqdefault.jpg",
    "title": "ヲタクと料理対決【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-16T13:26:17Z"
  },
  {
    "videoId": "h2CfS9akvVo",
    "thumbnail": "https://i.ytimg.com/vi/h2CfS9akvVo/mqdefault.jpg",
    "title": "新・ピザ作ってみた！【はあちゃまクッキング】",
    "publishedAt": "2020-07-16T14:09:17Z"
  },
  {
    "videoId": "rbZktdR3GRQ",
    "thumbnail": "https://i.ytimg.com/vi/rbZktdR3GRQ/mqdefault.jpg",
    "title": "壺男30分クリア【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-17T10:35:14Z"
  },
  {
    "videoId": "rCH44vE90So",
    "thumbnail": "https://i.ytimg.com/vi/rCH44vE90So/mqdefault.jpg",
    "title": "【#はあちゃまおきろ】朝の会",
    "publishedAt": "2020-07-18T01:03:24Z"
  },
  {
    "videoId": "FAQQUMcRj_Q",
    "thumbnail": "https://i.ytimg.com/vi/FAQQUMcRj_Q/mqdefault.jpg",
    "title": "パンケーキ作った【はあちゃまクッキング】",
    "publishedAt": "2020-07-18T14:00:08Z"
  },
  {
    "videoId": "k28zK41-jJA",
    "thumbnail": "https://i.ytimg.com/vi/k28zK41-jJA/mqdefault.jpg",
    "title": "ENGLISH",
    "publishedAt": "2020-07-19T10:16:31Z"
  },
  {
    "videoId": "0C3YTdmowIA",
    "thumbnail": "https://i.ytimg.com/vi/0C3YTdmowIA/mqdefault.jpg",
    "title": "漢字間違えたら即終了　withかなたん【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-21T09:49:43Z"
  },
  {
    "videoId": "_TQ7tqqn0gU",
    "thumbnail": "https://i.ytimg.com/vi/_TQ7tqqn0gU/mqdefault.jpg",
    "title": "【謝罪動画】",
    "publishedAt": "2020-07-22T10:50:48Z"
  },
  {
    "videoId": "hYN6D026C38",
    "thumbnail": "https://i.ytimg.com/vi/hYN6D026C38/mqdefault.jpg",
    "title": "本格カレー作るだけ放送【はあちゃまクッキング】",
    "publishedAt": "2020-07-22T14:27:58Z"
  },
  {
    "videoId": "Uzu9QaBvk6Y",
    "thumbnail": "https://i.ytimg.com/vi/Uzu9QaBvk6Y/mqdefault.jpg",
    "title": "はあちゃま結婚",
    "publishedAt": "2020-07-24T11:29:49Z"
  },
  {
    "videoId": "iimnU6HsrUg",
    "thumbnail": "https://i.ytimg.com/vi/iimnU6HsrUg/mqdefault.jpg",
    "title": "【アニメ】こんなゲーム実況は嫌だ【スーパーバニーメン】",
    "publishedAt": "2020-07-25T13:53:08Z"
  },
  {
    "videoId": "nv0mT23DMdo",
    "thumbnail": "https://i.ytimg.com/vi/nv0mT23DMdo/mqdefault.jpg",
    "title": "【人生が豊かになる動画】",
    "publishedAt": "2020-07-28T08:44:57Z"
  },
  {
    "videoId": "Q93_mXhJNP0",
    "thumbnail": "https://i.ytimg.com/vi/Q93_mXhJNP0/mqdefault.jpg",
    "title": "漢字間違えたら即終了　withるーなたん【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-28T10:42:03Z"
  },
  {
    "videoId": "43Ggkcrv3cw",
    "thumbnail": "https://i.ytimg.com/vi/43Ggkcrv3cw/mqdefault.jpg",
    "title": "はあちゃま朝の会💓11日目【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-28T22:11:25Z"
  },
  {
    "videoId": "eKriB3myCBw",
    "thumbnail": "https://i.ytimg.com/vi/eKriB3myCBw/mqdefault.jpg",
    "title": "新　は　あ　ち　ゃ　ま",
    "publishedAt": "2020-07-29T14:38:57Z"
  },
  {
    "videoId": "YEfJuXJlP_4",
    "thumbnail": "https://i.ytimg.com/vi/YEfJuXJlP_4/mqdefault.jpg",
    "title": "これで君も頭はあちゃまっちゃま～",
    "publishedAt": "2020-07-30T09:35:24Z"
  },
  {
    "videoId": "-0J0IInuypo",
    "thumbnail": "https://i.ytimg.com/vi/-0J0IInuypo/mqdefault.jpg",
    "title": "【#新はあちゃま】明らかに何かがおかしい・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-07-30T14:58:13Z"
  },
  {
    "videoId": "PzHBe7lsv8w",
    "thumbnail": "https://i.ytimg.com/vi/PzHBe7lsv8w/mqdefault.jpg",
    "title": "HAACHAMA Rap　/Prod. by Mixla",
    "publishedAt": "2020-07-31T14:19:15Z"
  },
  {
    "videoId": "bYKeO_RKh6I",
    "thumbnail": "https://i.ytimg.com/vi/bYKeO_RKh6I/mqdefault.jpg",
    "title": "癖強すぎ!?ヲタクにラクガキ募集した結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-01T11:21:07Z"
  },
  {
    "videoId": "8BTHTHuUIXw",
    "thumbnail": "https://i.ytimg.com/vi/8BTHTHuUIXw/mqdefault.jpg",
    "title": "虚無",
    "publishedAt": "2020-08-02T12:09:34Z"
  },
  {
    "videoId": "ViX62UtybwA",
    "thumbnail": "https://i.ytimg.com/vi/ViX62UtybwA/mqdefault.jpg",
    "title": "おつかれの舞い",
    "publishedAt": "2020-08-03T09:54:53Z"
  },
  {
    "videoId": "99_C2LuMuWA",
    "thumbnail": "https://i.ytimg.com/vi/99_C2LuMuWA/mqdefault.jpg",
    "title": "なんだこの意味わからん怪文書は・・・ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-03T12:23:41Z"
  },
  {
    "videoId": "n9AkIEDVHoU",
    "thumbnail": "https://i.ytimg.com/vi/n9AkIEDVHoU/mqdefault.jpg",
    "title": "This is haato bassic cooking rap",
    "publishedAt": "2020-08-03T15:12:42Z"
  },
  {
    "videoId": "7AzHS4mBZ3A",
    "thumbnail": "https://i.ytimg.com/vi/7AzHS4mBZ3A/mqdefault.jpg",
    "title": "感謝の儀式",
    "publishedAt": "2020-08-04T09:08:57Z"
  },
  {
    "videoId": "RmwCdkMiKRc",
    "thumbnail": "https://i.ytimg.com/vi/RmwCdkMiKRc/mqdefault.jpg",
    "title": "漢字間違えたら即終了　withココ会長【ホロライブ/赤井はあと/桐生ココ】",
    "publishedAt": "2020-08-04T10:54:52Z"
  },
  {
    "videoId": "95tktqHXwFQ",
    "thumbnail": "https://i.ytimg.com/vi/95tktqHXwFQ/mqdefault.jpg",
    "title": "[Good Morning!]朝からはあちゃまっちゃはあちゃまっちゃはあちゃまはあちゃまっちゃま～！💓16回目【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-04T22:04:23Z"
  },
  {
    "videoId": "-g9-Gv019aI",
    "thumbnail": "https://i.ytimg.com/vi/-g9-Gv019aI/mqdefault.jpg",
    "title": "FF外から失礼する方法",
    "publishedAt": "2020-08-05T03:01:56Z"
  },
  {
    "videoId": "-283f3EK_yY",
    "thumbnail": "https://i.ytimg.com/vi/-283f3EK_yY/mqdefault.jpg",
    "title": "FEETー足",
    "publishedAt": "2020-08-05T11:21:03Z"
  },
  {
    "videoId": "B5KoNaDvfmc",
    "thumbnail": "https://i.ytimg.com/vi/B5KoNaDvfmc/mqdefault.jpg",
    "title": "トマトうどん作った！【はあちゃまクッキング】",
    "publishedAt": "2020-08-05T14:58:45Z"
  },
  {
    "videoId": "HHVQos6HXZU",
    "thumbnail": "https://i.ytimg.com/vi/HHVQos6HXZU/mqdefault.jpg",
    "title": "シェアハピ～♪",
    "publishedAt": "2020-08-06T03:09:39Z"
  },
  {
    "videoId": "DqO9tKL-sIM",
    "thumbnail": "https://i.ytimg.com/vi/DqO9tKL-sIM/mqdefault.jpg",
    "title": "ホロライブ6期生はあちゃまっちゃま～！#新人Vtuべr",
    "publishedAt": "2020-08-06T07:50:59Z"
  },
  {
    "videoId": "USwZeF7ZKEQ",
    "thumbnail": "https://i.ytimg.com/vi/USwZeF7ZKEQ/mqdefault.jpg",
    "title": "毎秒脳死するアソビ大全51【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-06T14:28:42Z"
  },
  {
    "videoId": "VgqSwPQkxTc",
    "thumbnail": "https://i.ytimg.com/vi/VgqSwPQkxTc/mqdefault.jpg",
    "title": "HAACHAMA-therf*cker /Prod. by Soulker",
    "publishedAt": "2020-08-06T15:18:30Z"
  },
  {
    "videoId": "cM7w1YC_0Q4",
    "thumbnail": "https://i.ytimg.com/vi/cM7w1YC_0Q4/mqdefault.jpg",
    "title": "悩みがはあちゃまになる放送【スナックはあちゃま】",
    "publishedAt": "2020-08-07T18:16:20Z"
  },
  {
    "videoId": "XXG5qbw9bf4",
    "thumbnail": "https://i.ytimg.com/vi/XXG5qbw9bf4/mqdefault.jpg",
    "title": "やる気が出ないあなたへ",
    "publishedAt": "2020-08-08T03:02:48Z"
  },
  {
    "videoId": "RViPh0gDpOA",
    "thumbnail": "https://i.ytimg.com/vi/RViPh0gDpOA/mqdefault.jpg",
    "title": "こんな猫は嫌だ",
    "publishedAt": "2020-08-08T05:55:28Z"
  },
  {
    "videoId": "9RhVyx1eW28",
    "thumbnail": "https://i.ytimg.com/vi/9RhVyx1eW28/mqdefault.jpg",
    "title": "【速報】はあちゃま、生まれたってよ。",
    "publishedAt": "2020-08-09T15:00:11Z"
  },
  {
    "videoId": "EzwReYXYjiU",
    "thumbnail": "https://i.ytimg.com/vi/EzwReYXYjiU/mqdefault.jpg",
    "title": "【凸待ち】誕生日に誰からも凸が来ないわけもなく・・・【#はあちゃま生誕祭】",
    "publishedAt": "2020-08-10T11:16:18Z"
  },
  {
    "videoId": "BGR3Wy-t0Vk",
    "thumbnail": "https://i.ytimg.com/vi/BGR3Wy-t0Vk/mqdefault.jpg",
    "title": "【#はあちゃま生誕祭】はあちゃま、生涯を振り返る【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-10T15:27:41Z"
  },
  {
    "videoId": "4kptkVr1b_A",
    "thumbnail": "https://i.ytimg.com/vi/4kptkVr1b_A/mqdefault.jpg",
    "title": "ご飯を食べる際にどうぞ",
    "publishedAt": "2020-08-11T02:34:47Z"
  },
  {
    "videoId": "8Q7qI9j4Suc",
    "thumbnail": "https://i.ytimg.com/vi/8Q7qI9j4Suc/mqdefault.jpg",
    "title": "[Good Morning!]朝からはあちゃまっちゃま～！💓21回目【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-11T22:06:01Z"
  },
  {
    "videoId": "rGYRk_Qug4o",
    "thumbnail": "https://i.ytimg.com/vi/rGYRk_Qug4o/mqdefault.jpg",
    "title": "おりゃおりゃ",
    "publishedAt": "2020-08-12T02:54:22Z"
  },
  {
    "videoId": "I1gi2LELGKs",
    "thumbnail": "https://i.ytimg.com/vi/I1gi2LELGKs/mqdefault.jpg",
    "title": "【足で】ホロライブ5期生描く～！【#ほろふぁいぶ】※秘密だよ",
    "publishedAt": "2020-08-12T11:17:13Z"
  },
  {
    "videoId": "s-spnuUNmLk",
    "thumbnail": "https://i.ytimg.com/vi/s-spnuUNmLk/mqdefault.jpg",
    "title": "餃子焼きCooking!!【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-13T11:14:42Z"
  },
  {
    "videoId": "nlJyiPatRnE",
    "thumbnail": "https://i.ytimg.com/vi/nlJyiPatRnE/mqdefault.jpg",
    "title": "【Fall Guys】初見でNo.１になるまでやる！はあちゃまっちゃま～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-13T21:40:53Z"
  },
  {
    "videoId": "jSbK8HKu4Ps",
    "thumbnail": "https://i.ytimg.com/vi/jSbK8HKu4Ps/mqdefault.jpg",
    "title": "【アソビ大全】ガチンコバトル！はあ虐？それともすい虐？【ホロライブ/#赤星】",
    "publishedAt": "2020-08-14T11:17:02Z"
  },
  {
    "videoId": "yEnOMw0Py_A",
    "thumbnail": "https://i.ytimg.com/vi/yEnOMw0Py_A/mqdefault.jpg",
    "title": "[Room tour!!]ヲタク部屋観光がガチすぎる【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-15T09:34:26Z"
  },
  {
    "videoId": "AeAB2m19ecU",
    "thumbnail": "https://i.ytimg.com/vi/AeAB2m19ecU/mqdefault.jpg",
    "title": "50万突破まで無心",
    "publishedAt": "2020-08-16T08:54:10Z"
  },
  {
    "videoId": "g8ZIpBzQK8E",
    "thumbnail": "https://i.ytimg.com/vi/g8ZIpBzQK8E/mqdefault.jpg",
    "title": "声枯れっちゃまっちゃま〜💖",
    "publishedAt": "2020-08-16T09:41:13Z"
  },
  {
    "videoId": "lnUuacmi3Uk",
    "thumbnail": "https://i.ytimg.com/vi/lnUuacmi3Uk/mqdefault.jpg",
    "title": "正気な狂気",
    "publishedAt": "2020-08-17T05:00:16Z"
  },
  {
    "videoId": "8UADsDEddtI",
    "thumbnail": "https://i.ytimg.com/vi/8UADsDEddtI/mqdefault.jpg",
    "title": "【ぼっちで】ホロライブ声真似選手権【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-17T11:14:08Z"
  },
  {
    "videoId": "_gn338pA4JA",
    "thumbnail": "https://i.ytimg.com/vi/_gn338pA4JA/mqdefault.jpg",
    "title": "応援歌",
    "publishedAt": "2020-08-18T02:49:09Z"
  },
  {
    "videoId": "y9cuSHR83pA",
    "thumbnail": "https://i.ytimg.com/vi/y9cuSHR83pA/mqdefault.jpg",
    "title": "【アソビ大全】はあわた復活！てぇてぇ？バチバチ！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-18T13:36:22Z"
  },
  {
    "videoId": "wRbAa8lYBzI",
    "thumbnail": "https://i.ytimg.com/vi/wRbAa8lYBzI/mqdefault.jpg",
    "title": "今回の騒動について、皆様にお知らせがあります。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-19T10:42:05Z"
  },
  {
    "videoId": "W-iOh9LThkw",
    "thumbnail": "https://i.ytimg.com/vi/W-iOh9LThkw/mqdefault.jpg",
    "title": "脳死で替え歌した【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-20T09:15:13Z"
  },
  {
    "videoId": "qWN717ckJ5k",
    "thumbnail": "https://i.ytimg.com/vi/qWN717ckJ5k/mqdefault.jpg",
    "title": "【Fall guys】このゲームには必勝法がある【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-20T11:12:28Z"
  },
  {
    "videoId": "oYcneFCtm8w",
    "thumbnail": "https://i.ytimg.com/vi/oYcneFCtm8w/mqdefault.jpg",
    "title": "目覚めのはあちゃま【#はあちゃまおきろ/ホロライブ】",
    "publishedAt": "2020-08-20T22:23:29Z"
  },
  {
    "videoId": "79VxDmx7l7A",
    "thumbnail": "https://i.ytimg.com/vi/79VxDmx7l7A/mqdefault.jpg",
    "title": "【TETRIS99】我、はあちゃまゾ！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-21T11:33:44Z"
  },
  {
    "videoId": "p__aeehvF0Y",
    "thumbnail": "https://i.ytimg.com/vi/p__aeehvF0Y/mqdefault.jpg",
    "title": "「迫りくる狂気、はあちゃま」【ビッグマックを食べた/CMパロディ】",
    "publishedAt": "2020-08-21T14:48:26Z"
  },
  {
    "videoId": "vt-xJTGuiHU",
    "thumbnail": "https://i.ytimg.com/vi/vt-xJTGuiHU/mqdefault.jpg",
    "title": "朝食にはあちゃまを食べる【#はあちゃまおきろ/ホロライブ】",
    "publishedAt": "2020-08-22T02:27:04Z"
  },
  {
    "videoId": "xsDtOJo_U34",
    "thumbnail": "https://i.ytimg.com/vi/xsDtOJo_U34/mqdefault.jpg",
    "title": "[Performance contest!!]天才的!?ヲタクに演奏を募集した結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-22T14:30:20Z"
  },
  {
    "videoId": "E9fo6yCGQ-Y",
    "thumbnail": "https://i.ytimg.com/vi/E9fo6yCGQ-Y/mqdefault.jpg",
    "title": "はあちゃまのファンがキャラ濃すぎる件",
    "publishedAt": "2020-08-22T15:11:58Z"
  },
  {
    "videoId": "RBXFQv_jNeo",
    "thumbnail": "https://i.ytimg.com/vi/RBXFQv_jNeo/mqdefault.jpg",
    "title": "日曜日もようちゃまりおる。#3【#はあちゃまおきろ/ホロライブ】",
    "publishedAt": "2020-08-23T02:05:47Z"
  },
  {
    "videoId": "3WbFHd0H27g",
    "thumbnail": "https://i.ytimg.com/vi/3WbFHd0H27g/mqdefault.jpg",
    "title": "【Fall guys】NO WIN NO FIN【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-23T10:34:56Z"
  },
  {
    "videoId": "yETwjQXsU8g",
    "thumbnail": "https://i.ytimg.com/vi/yETwjQXsU8g/mqdefault.jpg",
    "title": "【Fall guys】NO WIN NO FIN ②【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-23T12:09:29Z"
  },
  {
    "videoId": "_nnuep80J_k",
    "thumbnail": "https://i.ytimg.com/vi/_nnuep80J_k/mqdefault.jpg",
    "title": "ここでニュースの時間です。",
    "publishedAt": "2020-08-23T13:49:31Z"
  },
  {
    "videoId": "E5fXSL_irkk",
    "thumbnail": "https://i.ytimg.com/vi/E5fXSL_irkk/mqdefault.jpg",
    "title": "月曜には刺激的すぎるはあちゃま#4【#はあちゃまおきろ/ホロライブ】",
    "publishedAt": "2020-08-23T22:05:17Z"
  },
  {
    "videoId": "bS7vVuQUeAE",
    "thumbnail": "https://i.ytimg.com/vi/bS7vVuQUeAE/mqdefault.jpg",
    "title": "はあちゃま実は受験生なんよ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-24T12:02:34Z"
  },
  {
    "videoId": "8mpht5rN4BA",
    "thumbnail": "https://i.ytimg.com/vi/8mpht5rN4BA/mqdefault.jpg",
    "title": "[Horror Contest!!]狂気的!?ホラーなもの募集した結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-29T13:36:24Z"
  },
  {
    "videoId": "bF8TesmjfTo",
    "thumbnail": "https://i.ytimg.com/vi/bF8TesmjfTo/mqdefault.jpg",
    "title": "SAN値エグる動画",
    "publishedAt": "2020-08-29T13:58:15Z"
  },
  {
    "videoId": "z-r_uQwTpoI",
    "thumbnail": "https://i.ytimg.com/vi/z-r_uQwTpoI/mqdefault.jpg",
    "title": "【Fall Guys】NO.1になるまで！全キル目指す！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-29T22:01:27Z"
  },
  {
    "videoId": "wPAyH0yHtaM",
    "thumbnail": "https://i.ytimg.com/vi/wPAyH0yHtaM/mqdefault.jpg",
    "title": "自分の8月を最速で振り返ってみた！",
    "publishedAt": "2020-08-30T14:40:09Z"
  },
  {
    "videoId": "b_gR7XLd6l8",
    "thumbnail": "https://i.ytimg.com/vi/b_gR7XLd6l8/mqdefault.jpg",
    "title": "【Fall Guys】NO WIN NO LIFE😭😭😭 【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-31T12:01:50Z"
  },
  {
    "videoId": "3DGjYRma72U",
    "thumbnail": "https://i.ytimg.com/vi/3DGjYRma72U/mqdefault.jpg",
    "title": "餅焼きながら8月語る【ホロライブ/赤井はあと】",
    "publishedAt": "2020-08-31T16:04:47Z"
  },
  {
    "videoId": "KwQQNuSGvlk",
    "thumbnail": "https://i.ytimg.com/vi/KwQQNuSGvlk/mqdefault.jpg",
    "title": "上級者向けの百合アニメ",
    "publishedAt": "2020-09-02T05:35:47Z"
  },
  {
    "videoId": "gpv3wiRldQ8",
    "thumbnail": "https://i.ytimg.com/vi/gpv3wiRldQ8/mqdefault.jpg",
    "title": "健全UwU~",
    "publishedAt": "2020-09-02T10:41:42Z"
  },
  {
    "videoId": "tRwn1WGHtLs",
    "thumbnail": "https://i.ytimg.com/vi/tRwn1WGHtLs/mqdefault.jpg",
    "title": "Haachama of meme life rap (prod. Nxnja)",
    "publishedAt": "2020-09-02T22:06:59Z"
  },
  {
    "videoId": "SntXk1-TVbA",
    "thumbnail": "https://i.ytimg.com/vi/SntXk1-TVbA/mqdefault.jpg",
    "title": "日本語喋ったら即終了！？ENGLISH ONLY FALL GUYS!!!",
    "publishedAt": "2020-09-03T10:27:27Z"
  },
  {
    "videoId": "mJ2wnpFm7dI",
    "thumbnail": "https://i.ytimg.com/vi/mJ2wnpFm7dI/mqdefault.jpg",
    "title": "日本語喋ったら即終了！？ENGLISH ONLY FALL GUYS!!!#2",
    "publishedAt": "2020-09-03T11:49:28Z"
  },
  {
    "videoId": "aS1dsbOtFaY",
    "thumbnail": "https://i.ytimg.com/vi/aS1dsbOtFaY/mqdefault.jpg",
    "title": "はあちゃまの英語力が上達してるだと・・・！？【ホロライブ/赤井はあと切り抜き】",
    "publishedAt": "2020-09-04T07:38:43Z"
  },
  {
    "videoId": "-XtxWtbl_dQ",
    "thumbnail": "https://i.ytimg.com/vi/-XtxWtbl_dQ/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖侵略計画始動！#1【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-05T06:48:30Z"
  },
  {
    "videoId": "Ms91YPW2FDY",
    "thumbnail": "https://i.ytimg.com/vi/Ms91YPW2FDY/mqdefault.jpg",
    "title": "【Fall Guys】今なら一位いける気がする・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-05T11:12:16Z"
  },
  {
    "videoId": "vAAWZn_SHpU",
    "thumbnail": "https://i.ytimg.com/vi/vAAWZn_SHpU/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖も頭はあちゃまっちゃま～！#2【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-06T10:09:20Z"
  },
  {
    "videoId": "-_xju_AWwH0",
    "thumbnail": "https://i.ytimg.com/vi/-_xju_AWwH0/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖息してくれえええ！ヒッヒッフー！#3【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-07T10:20:58Z"
  },
  {
    "videoId": "PkVhqYv-Alo",
    "thumbnail": "https://i.ytimg.com/vi/PkVhqYv-Alo/mqdefault.jpg",
    "title": "黒ごま海苔巻きハンバーグつくるちゃまっ☆彡【はあちゃまクッキング】",
    "publishedAt": "2020-09-08T11:11:17Z"
  },
  {
    "videoId": "VanlXR55hGw",
    "thumbnail": "https://i.ytimg.com/vi/VanlXR55hGw/mqdefault.jpg",
    "title": "【幽霊列車】こんなん、頭おかしくなっちゃうよ！！(迫真)【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-10T14:27:37Z"
  },
  {
    "videoId": "T64yYnvI0Uc",
    "thumbnail": "https://i.ytimg.com/vi/T64yYnvI0Uc/mqdefault.jpg",
    "title": "【Minecraft】ホ　ロ　鯖　復　興　計　画　#4【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-11T09:16:20Z"
  },
  {
    "videoId": "9rvCAwSjWeA",
    "thumbnail": "https://i.ytimg.com/vi/9rvCAwSjWeA/mqdefault.jpg",
    "title": "【Minecraft】ホ　ロ　鯖　を　ク　ッ　キ　ン　グ　♪#5【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-12T09:08:58Z"
  },
  {
    "videoId": "9aQ0Lvjn17I",
    "thumbnail": "https://i.ytimg.com/vi/9aQ0Lvjn17I/mqdefault.jpg",
    "title": "【Fall Guys】クールに優勝キメる ( 妄 想 )【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-13T09:04:56Z"
  },
  {
    "videoId": "8649YFAuNPg",
    "thumbnail": "https://i.ytimg.com/vi/8649YFAuNPg/mqdefault.jpg",
    "title": "秒でネイティブになる英語勉強法！【はあちゃまイングリッシュ】",
    "publishedAt": "2020-09-14T14:00:12Z"
  },
  {
    "videoId": "_eizwEQGl6Y",
    "thumbnail": "https://i.ytimg.com/vi/_eizwEQGl6Y/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖ガンギマリ化・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-15T08:57:09Z"
  },
  {
    "videoId": "oS1CnIRBGqY",
    "thumbnail": "https://i.ytimg.com/vi/oS1CnIRBGqY/mqdefault.jpg",
    "title": "【Super Bunny Man】ぼっちで全クリ！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-16T10:27:52Z"
  },
  {
    "videoId": "-ozXKzbj8oU",
    "thumbnail": "https://i.ytimg.com/vi/-ozXKzbj8oU/mqdefault.jpg",
    "title": "【Fall Guys】メスガキ二人でわちゃわちゃ戦う！【#さらちゃま/ホロライブ/にじさんじ】",
    "publishedAt": "2020-09-16T12:18:08Z"
  },
  {
    "videoId": "_7YNkf3bXdY",
    "thumbnail": "https://i.ytimg.com/vi/_7YNkf3bXdY/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖YAGOO増殖中・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-18T13:05:41Z"
  },
  {
    "videoId": "TCyVS6p1-yc",
    "thumbnail": "https://i.ytimg.com/vi/TCyVS6p1-yc/mqdefault.jpg",
    "title": "【Minecraft】YAGOOの呪いで悲しみの全ロス【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-19T05:00:58Z"
  },
  {
    "videoId": "EpxA0bsV2DQ",
    "thumbnail": "https://i.ytimg.com/vi/EpxA0bsV2DQ/mqdefault.jpg",
    "title": "【Minecraft】天空あくあタワードッキリ計画！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-19T10:12:47Z"
  },
  {
    "videoId": "28DcqevqkXI",
    "thumbnail": "https://i.ytimg.com/vi/28DcqevqkXI/mqdefault.jpg",
    "title": "【世界のアソビ大全51】ノエフレ VS はあわた 愛の決戦・・・！？【ホロライブ/#ノエフレはあわた】",
    "publishedAt": "2020-09-19T13:14:12Z"
  },
  {
    "videoId": "W0c4Y9BDeCA",
    "thumbnail": "https://i.ytimg.com/vi/W0c4Y9BDeCA/mqdefault.jpg",
    "title": "【歌枠】深夜の癒しうた！Subarasinging♪【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-19T19:48:48Z"
  },
  {
    "videoId": "DDK7D1bxGPo",
    "thumbnail": "https://i.ytimg.com/vi/DDK7D1bxGPo/mqdefault.jpg",
    "title": "【Minecraft】はあわたでピクセルアート建築～！【ホロライブ/#はあわた】",
    "publishedAt": "2020-09-20T07:18:04Z"
  },
  {
    "videoId": "_Sko986ZrrE",
    "thumbnail": "https://i.ytimg.com/vi/_Sko986ZrrE/mqdefault.jpg",
    "title": "はあちゃま、ホロライブEN征服するってよ【#hololiveEnglish/赤井はあと】",
    "publishedAt": "2020-09-21T11:37:24Z"
  },
  {
    "videoId": "oyeunIMPYKo",
    "thumbnail": "https://i.ytimg.com/vi/oyeunIMPYKo/mqdefault.jpg",
    "title": "「はあちゃまっちゃま～」で We will rock you歌ってみた！",
    "publishedAt": "2020-09-22T13:55:52Z"
  },
  {
    "videoId": "9ErJ5B6InTA",
    "thumbnail": "https://i.ytimg.com/vi/9ErJ5B6InTA/mqdefault.jpg",
    "title": "【マリオ3Dコレクション】初見！あそぶよあははっ！☆彡【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-23T12:44:34Z"
  },
  {
    "videoId": "A_DQiVAJrrc",
    "thumbnail": "https://i.ytimg.com/vi/A_DQiVAJrrc/mqdefault.jpg",
    "title": "特製味噌汁作った！【はあちゃまクッキング】",
    "publishedAt": "2020-09-23T14:08:32Z"
  },
  {
    "videoId": "5pGGv0OJ3j8",
    "thumbnail": "https://i.ytimg.com/vi/5pGGv0OJ3j8/mqdefault.jpg",
    "title": "ツイートとMEMEを食べた",
    "publishedAt": "2020-09-24T05:10:12Z"
  },
  {
    "videoId": "ZSXYl0hOhuU",
    "thumbnail": "https://i.ytimg.com/vi/ZSXYl0hOhuU/mqdefault.jpg",
    "title": "【Fall Guys】1時間以内に優勝しないと罰ゲーム【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-24T16:20:35Z"
  },
  {
    "videoId": "sNPpa3k8Z3g",
    "thumbnail": "https://i.ytimg.com/vi/sNPpa3k8Z3g/mqdefault.jpg",
    "title": "【#うたちゃま】デート服写メを募集した結果・・・！？【ホロライブ/赤井はあと/にじさんじ/鈴鹿詩子】",
    "publishedAt": "2020-09-25T11:13:34Z"
  },
  {
    "videoId": "dp0OBtp_Dwo",
    "thumbnail": "https://i.ytimg.com/vi/dp0OBtp_Dwo/mqdefault.jpg",
    "title": "【切り抜き】やらかしはあちゃま集【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-25T15:04:12Z"
  },
  {
    "videoId": "2qT9m_XQ3O0",
    "thumbnail": "https://i.ytimg.com/vi/2qT9m_XQ3O0/mqdefault.jpg",
    "title": "【Minecraft】おやすみマイクラ！ホロ鯖で極秘計画！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-25T18:23:14Z"
  },
  {
    "videoId": "pX0BF8u_kyg",
    "thumbnail": "https://i.ytimg.com/vi/pX0BF8u_kyg/mqdefault.jpg",
    "title": "【Minecraft】超極秘！？ポルカドッキリ作戦！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-09-26T07:23:06Z"
  },
  {
    "videoId": "_WfZ-KghBTg",
    "thumbnail": "https://i.ytimg.com/vi/_WfZ-KghBTg/mqdefault.jpg",
    "title": "【アソビ大全】はあちゃま×ねねち、ガチンコ勝負・・・！？【ホロライブ/赤井はあと/桃鈴ねね】",
    "publishedAt": "2020-09-26T12:05:11Z"
  },
  {
    "videoId": "JxGf20fOn2U",
    "thumbnail": "https://i.ytimg.com/vi/JxGf20fOn2U/mqdefault.jpg",
    "title": "HAACHAMA FUNNY MEME MOMENT",
    "publishedAt": "2020-09-26T13:52:23Z"
  },
  {
    "videoId": "WmnOASQHdj0",
    "thumbnail": "https://i.ytimg.com/vi/WmnOASQHdj0/mqdefault.jpg",
    "title": "た　だ　い　ま【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-19T10:15:36Z"
  },
  {
    "videoId": "TlAi_TVzO9E",
    "thumbnail": "https://i.ytimg.com/vi/TlAi_TVzO9E/mqdefault.jpg",
    "title": "カレー飯つくった！【はあちゃまクッキング】",
    "publishedAt": "2020-10-20T06:05:22Z"
  },
  {
    "videoId": "Hd1xGDogL_o",
    "thumbnail": "https://i.ytimg.com/vi/Hd1xGDogL_o/mqdefault.jpg",
    "title": "【#はあココ】マイクラ！ホロ鯖観光・・・！？【ホロライブ/赤井はあと/桐生ココ】",
    "publishedAt": "2020-10-20T11:20:28Z"
  },
  {
    "videoId": "y1xur9YJLro",
    "thumbnail": "https://i.ytimg.com/vi/y1xur9YJLro/mqdefault.jpg",
    "title": "新・ピザつくり！with #はあココ【ホロライブ/赤井はあと/桐生ココ】",
    "publishedAt": "2020-10-20T13:52:29Z"
  },
  {
    "videoId": "Si0RHBmYs3o",
    "thumbnail": "https://i.ytimg.com/vi/Si0RHBmYs3o/mqdefault.jpg",
    "title": "【歌枠】SINGCHAMA#1｜はじめてのすいよるうた！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-21T11:54:14Z"
  },
  {
    "videoId": "njmjN0tBFdw",
    "thumbnail": "https://i.ytimg.com/vi/njmjN0tBFdw/mqdefault.jpg",
    "title": "【Among Us】OVERKILL HAACHAMACHAMA~~~!!!【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-22T11:46:10Z"
  },
  {
    "videoId": "XDKFy0Z2EH4",
    "thumbnail": "https://i.ytimg.com/vi/XDKFy0Z2EH4/mqdefault.jpg",
    "title": "[ASK HAACHAMA] HAACHAMURDER ENGLISH!! #HAACHAMA #HololiveEnglish",
    "publishedAt": "2020-10-23T11:39:06Z"
  },
  {
    "videoId": "y_dg8XrI0Ms",
    "thumbnail": "https://i.ytimg.com/vi/y_dg8XrI0Ms/mqdefault.jpg",
    "title": "【Minecraft】重大発表！&はあちゃま建築始動！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-23T18:29:13Z"
  },
  {
    "videoId": "hzbsN5sqJg0",
    "thumbnail": "https://i.ytimg.com/vi/hzbsN5sqJg0/mqdefault.jpg",
    "title": "【Minecraft】HORROR!!!ジェットコースタ！？【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-24T09:05:11Z"
  },
  {
    "videoId": "ylD9r6o7I-4",
    "thumbnail": "https://i.ytimg.com/vi/ylD9r6o7I-4/mqdefault.jpg",
    "title": "COOKING CONTEST",
    "publishedAt": "2020-10-24T15:12:33Z"
  },
  {
    "videoId": "m2lcRM7PgoE",
    "thumbnail": "https://i.ytimg.com/vi/m2lcRM7PgoE/mqdefault.jpg",
    "title": "[Cooking Contest] ヲタクの料理がガチすぎる #HAACHAMASUNDAY",
    "publishedAt": "2020-10-25T10:37:04Z"
  },
  {
    "videoId": "abtnHUQ0iKM",
    "thumbnail": "https://i.ytimg.com/vi/abtnHUQ0iKM/mqdefault.jpg",
    "title": "[Getting Over It]PROFECIONAL POGCHAMA!! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-10-26T09:10:11Z"
  },
  {
    "videoId": "Gv2WN7YozW0",
    "thumbnail": "https://i.ytimg.com/vi/Gv2WN7YozW0/mqdefault.jpg",
    "title": "[NEW COSTUME] ついに新衣装お披露目・・・！？【#はあちゃま新衣装】",
    "publishedAt": "2020-10-26T13:14:14Z"
  },
  {
    "videoId": "eE4liS8Tt7M",
    "thumbnail": "https://i.ytimg.com/vi/eE4liS8Tt7M/mqdefault.jpg",
    "title": "【Minecraft】おやすみマイクラ！資源集めするよ～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-26T18:08:09Z"
  },
  {
    "videoId": "hQunAHddfdk",
    "thumbnail": "https://i.ytimg.com/vi/hQunAHddfdk/mqdefault.jpg",
    "title": "【#AMECHAMA COLLAB】51 Clubhouse Games with Amelia!!  #HololiveEN",
    "publishedAt": "2020-10-27T08:12:42Z"
  },
  {
    "videoId": "j7iuaiddOAg",
    "thumbnail": "https://i.ytimg.com/vi/j7iuaiddOAg/mqdefault.jpg",
    "title": "【Minecraft】絶叫ジェットコースター つくるぞ・・・！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-27T11:37:13Z"
  },
  {
    "videoId": "BcEYwXT0HY8",
    "thumbnail": "https://i.ytimg.com/vi/BcEYwXT0HY8/mqdefault.jpg",
    "title": "LET'S MAKE SUSHI~~~!!! #HAACHAMACOOKING #HololiveEN",
    "publishedAt": "2020-10-28T08:42:44Z"
  },
  {
    "videoId": "cLtFTQgPMFY",
    "thumbnail": "https://i.ytimg.com/vi/cLtFTQgPMFY/mqdefault.jpg",
    "title": "【歌枠】SINGCHAMA#2｜はあちゃまうたうよ～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-28T11:56:16Z"
  },
  {
    "videoId": "riVv_iQdNeY",
    "thumbnail": "https://i.ytimg.com/vi/riVv_iQdNeY/mqdefault.jpg",
    "title": "【Among Us】はあちゃま嘘ついたことないよん【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-29T11:29:02Z"
  },
  {
    "videoId": "ZGBbDAAGX0M",
    "thumbnail": "https://i.ytimg.com/vi/ZGBbDAAGX0M/mqdefault.jpg",
    "title": "【Minecraft】DEATH はあちゃまっちゃまコースター・完！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-30T12:02:38Z"
  },
  {
    "videoId": "hsVuAVvVgdc",
    "thumbnail": "https://i.ytimg.com/vi/hsVuAVvVgdc/mqdefault.jpg",
    "title": "REQUEST HALLOWEEN!!  #HAACHAMA #HololiveEN",
    "publishedAt": "2020-10-31T01:40:57Z"
  },
  {
    "videoId": "UD8VaYwaJf8",
    "thumbnail": "https://i.ytimg.com/vi/UD8VaYwaJf8/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖HALOWEEN!!ばんざーい！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-10-31T10:05:11Z"
  },
  {
    "videoId": "PIu7HlAtZVE",
    "thumbnail": "https://i.ytimg.com/vi/PIu7HlAtZVE/mqdefault.jpg",
    "title": "VIDEO CONTEST",
    "publishedAt": "2020-11-01T04:41:47Z"
  },
  {
    "videoId": "guURa3HfZXU",
    "thumbnail": "https://i.ytimg.com/vi/guURa3HfZXU/mqdefault.jpg",
    "title": "[VIDEO CONTEST] ヲタクにCMを募集した結果・・・！？ #HAACHAMASUNDAY",
    "publishedAt": "2020-11-01T10:47:55Z"
  },
  {
    "videoId": "gA-R4CdRaaU",
    "thumbnail": "https://i.ytimg.com/vi/gA-R4CdRaaU/mqdefault.jpg",
    "title": "EMERGENCY! はあちゃまプロヂュース作戦！#2【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-02T11:20:55Z"
  },
  {
    "videoId": "Ke3z73Z-c1w",
    "thumbnail": "https://i.ytimg.com/vi/Ke3z73Z-c1w/mqdefault.jpg",
    "title": "【Minecraft】HAACHAMA建設！初仕事やるっ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-03T11:35:34Z"
  },
  {
    "videoId": "aHKU4KfxrLk",
    "thumbnail": "https://i.ytimg.com/vi/aHKU4KfxrLk/mqdefault.jpg",
    "title": "[Among Us] WHAT A SMELLLLLLLY!! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-04T08:24:59Z"
  },
  {
    "videoId": "CiCpD_5Hq_g",
    "thumbnail": "https://i.ytimg.com/vi/CiCpD_5Hq_g/mqdefault.jpg",
    "title": "【歌枠】SINGCHAMA#3｜アニソンもりもりはあちゃま～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-04T11:39:29Z"
  },
  {
    "videoId": "m6MUG8H6fr8",
    "thumbnail": "https://i.ytimg.com/vi/m6MUG8H6fr8/mqdefault.jpg",
    "title": "【#ポンホロAmongUs】OVERKILL!!はあちゃまっちゃま～～～！☆彡【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-04T14:11:07Z"
  },
  {
    "videoId": "NMNO1cijEak",
    "thumbnail": "https://i.ytimg.com/vi/NMNO1cijEak/mqdefault.jpg",
    "title": "[PLUG & PLAY] WHAT A HELL IS THIS GAME!?  #HAACHAMA  #HololiveEN",
    "publishedAt": "2020-11-05T07:12:50Z"
  },
  {
    "videoId": "Sc7QONpIXFw",
    "thumbnail": "https://i.ytimg.com/vi/Sc7QONpIXFw/mqdefault.jpg",
    "title": "【激おこ】クソマロおくらないでよ！！！へんたい！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-05T12:07:24Z"
  },
  {
    "videoId": "62du-UvTwno",
    "thumbnail": "https://i.ytimg.com/vi/62du-UvTwno/mqdefault.jpg",
    "title": "【Among Us】進化した！HAACHAMURDER~~~!!!【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-06T11:14:56Z"
  },
  {
    "videoId": "oThVa8tTNo0",
    "thumbnail": "https://i.ytimg.com/vi/oThVa8tTNo0/mqdefault.jpg",
    "title": "MINECRAFT CONTEST",
    "publishedAt": "2020-11-07T13:00:29Z"
  },
  {
    "videoId": "23mopFFtXc0",
    "thumbnail": "https://i.ytimg.com/vi/23mopFFtXc0/mqdefault.jpg",
    "title": "[MINECRAFT CONTEST]リスナーに建築させたらガチすぎた #HAACHAMASUNDAY",
    "publishedAt": "2020-11-08T10:48:14Z"
  },
  {
    "videoId": "za2jweDiKNo",
    "thumbnail": "https://i.ytimg.com/vi/za2jweDiKNo/mqdefault.jpg",
    "title": "【Phasmophobia】GHOST HUNT!! はじめての幽霊調査！#はあココ【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-09T11:13:20Z"
  },
  {
    "videoId": "eOi2JvZhAhM",
    "thumbnail": "https://i.ytimg.com/vi/eOi2JvZhAhM/mqdefault.jpg",
    "title": "[ASK HAACHAMA] ANSWER IN TALKING SLEEP...zzz #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-10T08:43:13Z"
  },
  {
    "videoId": "RIP64FVWOZg",
    "thumbnail": "https://i.ytimg.com/vi/RIP64FVWOZg/mqdefault.jpg",
    "title": "【Minecraft】超　極　秘　計　画　！（ニチャァ）【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-10T13:14:55Z"
  },
  {
    "videoId": "5dnBblEByGc",
    "thumbnail": "https://i.ytimg.com/vi/5dnBblEByGc/mqdefault.jpg",
    "title": "【歌枠】SINGCHAMA#4｜うたうはあちゃま～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-11T11:53:30Z"
  },
  {
    "videoId": "fzHbBACDfUo",
    "thumbnail": "https://i.ytimg.com/vi/fzHbBACDfUo/mqdefault.jpg",
    "title": "NEW CHIKEN COOKING!! with Kiara #KIACHAMA #HololiveEN",
    "publishedAt": "2020-11-12T08:29:40Z"
  },
  {
    "videoId": "wWi-0c07ANM",
    "thumbnail": "https://i.ytimg.com/vi/wWi-0c07ANM/mqdefault.jpg",
    "title": "【Minecraft】超　大　型　建　築 　！（ぐへへぇ）【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-12T13:12:22Z"
  },
  {
    "videoId": "cC7y0ENWZoQ",
    "thumbnail": "https://i.ytimg.com/vi/cC7y0ENWZoQ/mqdefault.jpg",
    "title": "麺つくった！【#HAACHAMACOOKING】",
    "publishedAt": "2020-11-12T15:01:03Z"
  },
  {
    "videoId": "y4vIw_NqFcc",
    "thumbnail": "https://i.ytimg.com/vi/y4vIw_NqFcc/mqdefault.jpg",
    "title": "AKAI HAATO VS HAACHAMA Q&A #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-13T09:32:25Z"
  },
  {
    "videoId": "frjEi3lGk0k",
    "thumbnail": "https://i.ytimg.com/vi/frjEi3lGk0k/mqdefault.jpg",
    "title": "【Minecraft】戦争だ！キング・オブ・ハーチャマ設計！（どやぁ）【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-13T19:53:52Z"
  },
  {
    "videoId": "-0SPbERR9fY",
    "thumbnail": "https://i.ytimg.com/vi/-0SPbERR9fY/mqdefault.jpg",
    "title": "[Minecraft] LET'S GOOOO TO EN SERVER!! #AMECHAMA #HololiveEN",
    "publishedAt": "2020-11-14T08:08:04Z"
  },
  {
    "videoId": "i071ggjXXP4",
    "thumbnail": "https://i.ytimg.com/vi/i071ggjXXP4/mqdefault.jpg",
    "title": "[Minecraft] NEW HAACHAMA LIFE!! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-16T09:32:18Z"
  },
  {
    "videoId": "29A7NrbtTp4",
    "thumbnail": "https://i.ytimg.com/vi/29A7NrbtTp4/mqdefault.jpg",
    "title": "【Minecraft】キング・オブ・ハーチャマ最終回！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-16T17:40:10Z"
  },
  {
    "videoId": "ZeggOHi5OtI",
    "thumbnail": "https://i.ytimg.com/vi/ZeggOHi5OtI/mqdefault.jpg",
    "title": "BEST BURGAR EVER~~~~~~~~!!! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-17T08:55:02Z"
  },
  {
    "videoId": "XZ_bLOXoEOs",
    "thumbnail": "https://i.ytimg.com/vi/XZ_bLOXoEOs/mqdefault.jpg",
    "title": "【Minecraft】史　上　最　大　建　築　！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-17T12:09:45Z"
  },
  {
    "videoId": "7DlXVvIt78g",
    "thumbnail": "https://i.ytimg.com/vi/7DlXVvIt78g/mqdefault.jpg",
    "title": "[Minecraft] DEAD NEW HOUSE!! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-18T09:47:40Z"
  },
  {
    "videoId": "JFnnC4taR14",
    "thumbnail": "https://i.ytimg.com/vi/JFnnC4taR14/mqdefault.jpg",
    "title": "【70万人ありがとん💓】SINGCHAMA#5｜そして目指せ800,000万人！",
    "publishedAt": "2020-11-18T16:41:59Z"
  },
  {
    "videoId": "GLjDai10Lc8",
    "thumbnail": "https://i.ytimg.com/vi/GLjDai10Lc8/mqdefault.jpg",
    "title": "HAACHAMA WANNA GO HOME.",
    "publishedAt": "2020-11-19T13:40:21Z"
  },
  {
    "videoId": "NvOHijJqups",
    "thumbnail": "https://i.ytimg.com/vi/NvOHijJqups/mqdefault.jpg",
    "title": "Ievan Polkka　ロイちゃま",
    "publishedAt": "2020-11-20T06:00:11Z"
  },
  {
    "videoId": "eBxssjg__ro",
    "thumbnail": "https://i.ytimg.com/vi/eBxssjg__ro/mqdefault.jpg",
    "title": "ホロライブ秋の大運動会！赤Bチーム視点【#ホロライブ運動会 / Minecraft】",
    "publishedAt": "2020-11-21T09:54:13Z"
  },
  {
    "videoId": "MoOUFt3yHRI",
    "thumbnail": "https://i.ytimg.com/vi/MoOUFt3yHRI/mqdefault.jpg",
    "title": "【Minecraft】深夜のまったりはあちゃまっちゃま～。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-22T20:59:05Z"
  },
  {
    "videoId": "bpJPBT1IO3o",
    "thumbnail": "https://i.ytimg.com/vi/bpJPBT1IO3o/mqdefault.jpg",
    "title": "【OVEREDCOOK2】We cook for thanksgiving~~!!! #HololiveEN",
    "publishedAt": "2020-11-25T09:15:32Z"
  },
  {
    "videoId": "OI5oZnKhKcY",
    "thumbnail": "https://i.ytimg.com/vi/OI5oZnKhKcY/mqdefault.jpg",
    "title": "【Minecraft】食料大量！？はあちゃまファクトリ～！！！☆彡【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-25T13:09:49Z"
  },
  {
    "videoId": "tJOyOUuhfkE",
    "thumbnail": "https://i.ytimg.com/vi/tJOyOUuhfkE/mqdefault.jpg",
    "title": "[Minecraft] BYE BYE ENserver!! #HAACHAMA #HololiveEN0",
    "publishedAt": "2020-11-26T08:57:22Z"
  },
  {
    "videoId": "8gBy4C3OgIE",
    "thumbnail": "https://i.ytimg.com/vi/8gBy4C3OgIE/mqdefault.jpg",
    "title": "[Cooking simulator] Who can I eat today? All members? Sure! #HAACHAMA #HololiveEN0",
    "publishedAt": "2020-11-27T09:11:28Z"
  },
  {
    "videoId": "y9bzuJGOLaI",
    "thumbnail": "https://i.ytimg.com/vi/y9bzuJGOLaI/mqdefault.jpg",
    "title": "【歌枠】80万人突破までうたう！🌟Sing till I reach 800k!!【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-27T13:33:55Z"
  },
  {
    "videoId": "mGoBhiWo4jk",
    "thumbnail": "https://i.ytimg.com/vi/mGoBhiWo4jk/mqdefault.jpg",
    "title": "[CHAT] Can HAACHAMA get up? #HAACHAMA #HololiveEN0",
    "publishedAt": "2020-11-28T01:59:44Z"
  },
  {
    "videoId": "Sdqlp8CGXJ4",
    "thumbnail": "https://i.ytimg.com/vi/Sdqlp8CGXJ4/mqdefault.jpg",
    "title": "衝撃的!?ヲタクの私服がガチすぎる・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-29T10:02:48Z"
  },
  {
    "videoId": "pqQdeSyTYFo",
    "thumbnail": "https://i.ytimg.com/vi/pqQdeSyTYFo/mqdefault.jpg",
    "title": "[Getting over it] RTA~~~!! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-11-30T08:35:16Z"
  },
  {
    "videoId": "hGF_riBTgOI",
    "thumbnail": "https://i.ytimg.com/vi/hGF_riBTgOI/mqdefault.jpg",
    "title": "【Minecraft\\】ホロ鯖であそぶ～～～～～っ！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-11-30T12:35:36Z"
  },
  {
    "videoId": "6ysYAJTdTEg",
    "thumbnail": "https://i.ytimg.com/vi/6ysYAJTdTEg/mqdefault.jpg",
    "title": "AMAZING TACO TACOS~~~!!!#HAACHAMA #HololiveEN",
    "publishedAt": "2020-12-01T09:11:40Z"
  },
  {
    "videoId": "Wu0RoC5U-04",
    "thumbnail": "https://i.ytimg.com/vi/Wu0RoC5U-04/mqdefault.jpg",
    "title": "【Papers, Please】はあちゃま、入国審査員になる！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-01T13:15:16Z"
  },
  {
    "videoId": "okl9TMlXyEc",
    "thumbnail": "https://i.ytimg.com/vi/okl9TMlXyEc/mqdefault.jpg",
    "title": "【歌枠】ボカロ縛りでうたうよ～！｜Singing♪#5 【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-02T12:14:37Z"
  },
  {
    "videoId": "Fcs4T14YXHw",
    "thumbnail": "https://i.ytimg.com/vi/Fcs4T14YXHw/mqdefault.jpg",
    "title": "はあちゃま、高校卒業。【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-04T12:27:08Z"
  },
  {
    "videoId": "mB2hfFe3geg",
    "thumbnail": "https://i.ytimg.com/vi/mB2hfFe3geg/mqdefault.jpg",
    "title": "John Denver - Take Me Home, Country Roads (Cover by Akaihaato)",
    "publishedAt": "2020-12-05T09:00:12Z"
  },
  {
    "videoId": "IGmnlol_7Xk",
    "thumbnail": "https://i.ytimg.com/vi/IGmnlol_7Xk/mqdefault.jpg",
    "title": "HAACHAMA HORROR SONG",
    "publishedAt": "2020-12-10T09:54:33Z"
  },
  {
    "videoId": "IT186xDTwUU",
    "thumbnail": "https://i.ytimg.com/vi/IT186xDTwUU/mqdefault.jpg",
    "title": "HAACHAMA COOKING SONG♪",
    "publishedAt": "2020-12-12T15:11:08Z"
  },
  {
    "videoId": "pJuPoYMEnbo",
    "thumbnail": "https://i.ytimg.com/vi/pJuPoYMEnbo/mqdefault.jpg",
    "title": "【朗報】はあちゃま、日本上陸！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-15T12:04:52Z"
  },
  {
    "videoId": "ET4ZdTiHAhA",
    "thumbnail": "https://i.ytimg.com/vi/ET4ZdTiHAhA/mqdefault.jpg",
    "title": "I'm studying abroad in Japan! #HAACHAMA #HololiveEN",
    "publishedAt": "2020-12-16T07:10:40Z"
  },
  {
    "videoId": "CzZcwIfXeno",
    "thumbnail": "https://i.ytimg.com/vi/CzZcwIfXeno/mqdefault.jpg",
    "title": "【Minecraft】地獄or地獄のジェットコースター！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-16T11:09:48Z"
  },
  {
    "videoId": "A4BnqtzTat0",
    "thumbnail": "https://i.ytimg.com/vi/A4BnqtzTat0/mqdefault.jpg",
    "title": "[Minecraft] BIG EXPLOSION PLAN!!!!! #HololiveEN0",
    "publishedAt": "2020-12-17T08:13:36Z"
  },
  {
    "videoId": "uGYS8FSakjo",
    "thumbnail": "https://i.ytimg.com/vi/uGYS8FSakjo/mqdefault.jpg",
    "title": "でぶちゃまとは言わせない！！！！！！！！！！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-17T11:18:26Z"
  },
  {
    "videoId": "gFtNHOvftWQ",
    "thumbnail": "https://i.ytimg.com/vi/gFtNHOvftWQ/mqdefault.jpg",
    "title": "HAACHAMACHAMA ENGLISH TEST~~~!!",
    "publishedAt": "2020-12-18T03:59:33Z"
  },
  {
    "videoId": "oA5tVludYbo",
    "thumbnail": "https://i.ytimg.com/vi/oA5tVludYbo/mqdefault.jpg",
    "title": "【RingFit Adverture】でぶちゃまとは言わせない！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-18T11:08:21Z"
  },
  {
    "videoId": "JclEHyfveVE",
    "thumbnail": "https://i.ytimg.com/vi/JclEHyfveVE/mqdefault.jpg",
    "title": "はじめての！ゲテモノCOOKING♪【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-19T11:04:19Z"
  },
  {
    "videoId": "Zy7wah9Egfo",
    "thumbnail": "https://i.ytimg.com/vi/Zy7wah9Egfo/mqdefault.jpg",
    "title": "【Minecraft】ちゃまサンタ！美味しい料理宅配する♪【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-23T17:09:00Z"
  },
  {
    "videoId": "_frVYLzIFwg",
    "thumbnail": "https://i.ytimg.com/vi/_frVYLzIFwg/mqdefault.jpg",
    "title": "【#ホロライブクリスマス】SINGING♪メリークリスマスっちゃまちゃま～！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-25T05:06:27Z"
  },
  {
    "videoId": "r3dtqpLYdQo",
    "thumbnail": "https://i.ytimg.com/vi/r3dtqpLYdQo/mqdefault.jpg",
    "title": "[Minecraft]Merry Christmas DATE!!! with Amelia💕 #HololiveEN #AMECHAMA",
    "publishedAt": "2020-12-26T04:08:39Z"
  },
  {
    "videoId": "6sfWeeXOuLg",
    "thumbnail": "https://i.ytimg.com/vi/6sfWeeXOuLg/mqdefault.jpg",
    "title": "超過酷!?足つぼやりながらリングフィットやる！【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-27T11:33:04Z"
  },
  {
    "videoId": "jhJ_tw0lB9o",
    "thumbnail": "https://i.ytimg.com/vi/jhJ_tw0lB9o/mqdefault.jpg",
    "title": "SPICY NOODLE CHAT!!! with Ina'nis #TAKOCHAMA #HololiveEN",
    "publishedAt": "2020-12-28T07:05:13Z"
  },
  {
    "videoId": "_pTFgDkeXL0",
    "thumbnail": "https://i.ytimg.com/vi/_pTFgDkeXL0/mqdefault.jpg",
    "title": "あばよ2020年！カンガルー鍋 THE END♪【ホロライブ/赤井はあと】",
    "publishedAt": "2020-12-31T04:39:18Z"
  },
  {
    "videoId": "aEsb4wSZybo",
    "thumbnail": "https://i.ytimg.com/vi/aEsb4wSZybo/mqdefault.jpg",
    "title": "新年に見るべきアニメ【#ちゃまグラ】",
    "publishedAt": "2020-12-31T19:08:17Z"
  },
  {
    "videoId": "DsV-EJmbvr8",
    "thumbnail": "https://i.ytimg.com/vi/DsV-EJmbvr8/mqdefault.jpg",
    "title": "【#はあちゃま3D】はあちゃま、動きます。",
    "publishedAt": "2021-01-03T11:59:23Z"
  },
  {
    "videoId": "A9HY4DsRTCg",
    "thumbnail": "https://i.ytimg.com/vi/A9HY4DsRTCg/mqdefault.jpg",
    "title": "RED HEART / 赤井はあと (Official)",
    "publishedAt": "2021-01-10T17:37:28Z"
  },
  {
    "videoId": "syvzvC2PrJ4",
    "thumbnail": "https://i.ytimg.com/vi/syvzvC2PrJ4/mqdefault.jpg",
    "title": "いただきはあちゃま",
    "publishedAt": "2021-01-11T08:44:56Z"
  },
  {
    "videoId": "iKVkn2lNW4Y",
    "thumbnail": "https://i.ytimg.com/vi/iKVkn2lNW4Y/mqdefault.jpg",
    "title": "めざせ！90万人までSINGING♪【ホロライブ/赤井はあと】",
    "publishedAt": "2021-01-12T12:17:43Z"
  },
  {
    "videoId": "6_cj1dUc8rI",
    "thumbnail": "https://i.ytimg.com/vi/6_cj1dUc8rI/mqdefault.jpg",
    "title": "ツンデレ後輩　VS　変態豚",
    "publishedAt": "2021-01-12T18:53:54Z"
  },
  {
    "videoId": "39IIGwgW5eo",
    "thumbnail": "https://i.ytimg.com/vi/39IIGwgW5eo/mqdefault.jpg",
    "title": "魚さばく！COOKING♪【ホロライブ/赤井はあと】",
    "publishedAt": "2021-01-13T05:29:44Z"
  },
  {
    "videoId": "y4keU10-9bY",
    "thumbnail": "https://i.ytimg.com/vi/y4keU10-9bY/mqdefault.jpg",
    "title": "深夜のぼっちUNO【ホロライブ/赤井はあと】",
    "publishedAt": "2021-01-17T17:26:59Z"
  },
  {
    "videoId": "dUottv_czvE",
    "thumbnail": "https://i.ytimg.com/vi/dUottv_czvE/mqdefault.jpg",
    "title": "ちょっとだけ夜更かし【ホロライブ/赤井はあと】",
    "publishedAt": "2021-01-18T16:54:08Z"
  },
  {
    "videoId": "lueGJGxj1ws",
    "thumbnail": "https://i.ytimg.com/vi/lueGJGxj1ws/mqdefault.jpg",
    "title": "はあちゃまクッキングREVEW!!【ホロライブ/赤井はあと】",
    "publishedAt": "2021-01-19T11:50:18Z"
  },
  {
    "videoId": "okg2gkhGi7U",
    "thumbnail": "https://i.ytimg.com/vi/okg2gkhGi7U/mqdefault.jpg",
    "title": "はあちゃま、豚になる。",
    "publishedAt": "2021-01-19T12:50:20Z"
  },
  {
    "videoId": "LptHYRoOZsc",
    "thumbnail": "https://i.ytimg.com/vi/LptHYRoOZsc/mqdefault.jpg",
    "title": "虚無いはあと【ホロライブ/#はあちゃまなう】",
    "publishedAt": "2021-01-21T13:03:11Z"
  },
  {
    "videoId": "zDYyOKP2nMs",
    "thumbnail": "https://i.ytimg.com/vi/zDYyOKP2nMs/mqdefault.jpg",
    "title": "新・はあちゃま占い！",
    "publishedAt": "2021-01-22T14:48:24Z"
  },
  {
    "videoId": "4LMb5PLgyqo",
    "thumbnail": "https://i.ytimg.com/vi/4LMb5PLgyqo/mqdefault.jpg",
    "title": "COOKING CONTEST #2",
    "publishedAt": "2021-01-24T08:15:32Z"
  },
  {
    "videoId": "W-gO1LpZ2ro",
    "thumbnail": "https://i.ytimg.com/vi/W-gO1LpZ2ro/mqdefault.jpg",
    "title": "COOKING CONTEST♪　#はあちゃまレストラン",
    "publishedAt": "2021-01-24T14:12:10Z"
  },
  {
    "videoId": "JnU00OYE3A4",
    "thumbnail": "https://i.ytimg.com/vi/JnU00OYE3A4/mqdefault.jpg",
    "title": "ウサギCOOKING♪【ホロライブ/#はあちゃまなう】",
    "publishedAt": "2021-01-25T14:18:07Z"
  },
  {
    "videoId": "C9v0IR1jpCA",
    "thumbnail": "https://i.ytimg.com/vi/C9v0IR1jpCA/mqdefault.jpg",
    "title": "HAACHAMA ENGLISH DEATH #HololiveEN 0th",
    "publishedAt": "2021-01-26T13:04:24Z"
  },
  {
    "videoId": "N0vBDacTJ9k",
    "thumbnail": "https://i.ytimg.com/vi/N0vBDacTJ9k/mqdefault.jpg",
    "title": "ぽっぴっぽー  /　HAACHAMA 【Cover】",
    "publishedAt": "2021-01-26T17:00:40Z"
  },
  {
    "videoId": "l0F_KGomG8w",
    "thumbnail": "https://i.ytimg.com/vi/l0F_KGomG8w/mqdefault.jpg",
    "title": "激辛ペヤング新作、箱で届いた。【獄激辛カレー】",
    "publishedAt": "2021-01-29T15:41:07Z"
  },
  {
    "videoId": "cpsj5nxR5CY",
    "thumbnail": "https://i.ytimg.com/vi/cpsj5nxR5CY/mqdefault.jpg",
    "title": "ざつだん【ホロライブ/#はあちゃまなう】",
    "publishedAt": "2021-01-30T13:26:36Z"
  },
  {
    "videoId": "hTgFR1MSkWs",
    "thumbnail": "https://i.ytimg.com/vi/hTgFR1MSkWs/mqdefault.jpg",
    "title": "【Minecraft】【ホロライブ/赤井はあと】",
    "publishedAt": "2021-02-02T20:08:47Z"
  },
  {
    "videoId": "qbEdlmzQftE",
    "thumbnail": "https://i.ytimg.com/vi/qbEdlmzQftE/mqdefault.jpg",
    "title": "#FREEHAATO",
    "publishedAt": "2021-02-04T14:09:04Z"
  },
  {
    "videoId": "z9vWQzb_Znw",
    "thumbnail": "https://i.ytimg.com/vi/z9vWQzb_Znw/mqdefault.jpg",
    "title": "【Minecraft】深夜にこっそり【 Hololive / Akaihaato 】",
    "publishedAt": "2021-02-04T17:43:18Z"
  },
  {
    "videoId": "9h8WVdrve1k",
    "thumbnail": "https://i.ytimg.com/vi/9h8WVdrve1k/mqdefault.jpg",
    "title": "HAACHAMA ENGLISH SCHOOL♪【 #HololiveEN0 】",
    "publishedAt": "2021-02-05T14:03:09Z"
  },
  {
    "videoId": "pg8Gf-GKUtI",
    "thumbnail": "https://i.ytimg.com/vi/pg8Gf-GKUtI/mqdefault.jpg",
    "title": "COEXIST FOREVER",
    "publishedAt": "2021-02-05T14:10:24Z"
  },
  {
    "videoId": "AcPbGfrr-ds",
    "thumbnail": "https://i.ytimg.com/vi/AcPbGfrr-ds/mqdefault.jpg",
    "title": "【Minecraft】のーんびりこっそり【Hololive/Akaihaato】",
    "publishedAt": "2021-02-05T17:54:39Z"
  },
  {
    "videoId": "m9DCPvYuU8k",
    "thumbnail": "https://i.ytimg.com/vi/m9DCPvYuU8k/mqdefault.jpg",
    "title": "【Minecraft】まったーりこっそり【 Minecraft / Akaihaato 】",
    "publishedAt": "2021-02-06T17:12:34Z"
  },
  {
    "videoId": "Mzz35N-GeMM",
    "thumbnail": "https://i.ytimg.com/vi/Mzz35N-GeMM/mqdefault.jpg",
    "title": "R.I.P Akaihaato",
    "publishedAt": "2021-02-07T16:07:34Z"
  },
  {
    "videoId": "8JjjscSWLi0",
    "thumbnail": "https://i.ytimg.com/vi/8JjjscSWLi0/mqdefault.jpg",
    "title": "#FREEHAACHAMA",
    "publishedAt": "2021-02-07T16:09:23Z"
  },
  {
    "videoId": "6H2MBid-CTc",
    "thumbnail": "https://i.ytimg.com/vi/6H2MBid-CTc/mqdefault.jpg",
    "title": "着信アリ（はあちゃま）",
    "publishedAt": "2021-02-07T16:13:23Z"
  },
  {
    "videoId": "8eudigz3jiQ",
    "thumbnail": "https://i.ytimg.com/vi/8eudigz3jiQ/mqdefault.jpg",
    "title": "Doki!Doki!Haato club!!",
    "publishedAt": "2021-02-08T14:30:17Z"
  },
  {
    "videoId": "m7Ud7Hn1-bI",
    "thumbnail": "https://i.ytimg.com/vi/m7Ud7Hn1-bI/mqdefault.jpg",
    "title": "HELP ME",
    "publishedAt": "2021-02-08T14:36:54Z"
  },
  {
    "videoId": "oIvvuBQvrzk",
    "thumbnail": "https://i.ytimg.com/vi/oIvvuBQvrzk/mqdefault.jpg",
    "title": "＃REVIVEHAATO",
    "publishedAt": "2021-02-09T13:47:14Z"
  },
  {
    "videoId": "Z86cMpo4SQE",
    "thumbnail": "https://i.ytimg.com/vi/Z86cMpo4SQE/mqdefault.jpg",
    "title": "I'M BACK",
    "publishedAt": "2021-02-09T14:06:02Z"
  },
  {
    "videoId": "6-lJ8SMUJWw",
    "thumbnail": "https://i.ytimg.com/vi/6-lJ8SMUJWw/mqdefault.jpg",
    "title": "【Minecraft】ひさしぶりにこっそり【Hololive/Akaihaato】",
    "publishedAt": "2021-02-09T17:50:13Z"
  },
  {
    "videoId": "5clHgQZJ3vY",
    "thumbnail": "https://i.ytimg.com/vi/5clHgQZJ3vY/mqdefault.jpg",
    "title": "#BYEBYEHAACHAMA",
    "publishedAt": "2021-02-10T14:01:46Z"
  },
  {
    "videoId": "ph5lZtzE9EA",
    "thumbnail": "https://i.ytimg.com/vi/ph5lZtzE9EA/mqdefault.jpg",
    "title": "かくれんぼ",
    "publishedAt": "2021-02-10T14:03:03Z"
  },
  {
    "videoId": "i1s0T66z7q4",
    "thumbnail": "https://i.ytimg.com/vi/i1s0T66z7q4/mqdefault.jpg",
    "title": "Always.",
    "publishedAt": "2021-02-10T14:06:08Z"
  },
  {
    "videoId": "pC3-IpyW23A",
    "thumbnail": "https://i.ytimg.com/vi/pC3-IpyW23A/mqdefault.jpg",
    "title": "R.I.P HAACHAMA",
    "publishedAt": "2021-02-10T14:10:34Z"
  },
  {
    "videoId": "pnMnPD2NesI",
    "thumbnail": "https://i.ytimg.com/vi/pnMnPD2NesI/mqdefault.jpg",
    "title": "Congrats on 1M",
    "publishedAt": "2021-02-11T17:23:51Z"
  },
  {
    "videoId": "U5oL--X-WYk",
    "thumbnail": "https://i.ytimg.com/vi/U5oL--X-WYk/mqdefault.jpg",
    "title": "THANK YOU",
    "publishedAt": "2021-02-11T17:24:23Z"
  },
  {
    "videoId": "7J8hZuBz54g",
    "thumbnail": "https://i.ytimg.com/vi/7J8hZuBz54g/mqdefault.jpg",
    "title": "【Minecraft】深夜のふりーだむ【Hololive/Akaihaato】",
    "publishedAt": "2021-02-12T17:04:16Z"
  },
  {
    "videoId": "jxIaegrWkGg",
    "thumbnail": "https://i.ytimg.com/vi/jxIaegrWkGg/mqdefault.jpg",
    "title": "バレンタイン♡COOKING♪【#HAACHAMACOOKING​】",
    "publishedAt": "2021-02-14T14:17:51Z"
  },
  {
    "videoId": "2c6-9ic8mrg",
    "thumbnail": "https://i.ytimg.com/vi/2c6-9ic8mrg/mqdefault.jpg",
    "title": "【】",
    "publishedAt": "2021-02-14T16:51:07Z"
  },
  {
    "videoId": "wEWPOl5ctAM",
    "thumbnail": "https://i.ytimg.com/vi/wEWPOl5ctAM/mqdefault.jpg",
    "title": "NEW GAME",
    "publishedAt": "2021-02-15T15:40:11Z"
  },
  {
    "videoId": "hVbVxMV6V4w",
    "thumbnail": "https://i.ytimg.com/vi/hVbVxMV6V4w/mqdefault.jpg",
    "title": "HERE IS HAACHAMA",
    "publishedAt": "2021-02-15T15:41:03Z"
  },
  {
    "videoId": "0z57K0VA9ZE",
    "thumbnail": "https://i.ytimg.com/vi/0z57K0VA9ZE/mqdefault.jpg",
    "title": "YUMMY!! YUMMY!!",
    "publishedAt": "2021-02-15T15:50:00Z"
  },
  {
    "videoId": "512K9d1bPsY",
    "thumbnail": "https://i.ytimg.com/vi/512K9d1bPsY/mqdefault.jpg",
    "title": "8",
    "publishedAt": "2021-02-16T15:52:06Z"
  },
  {
    "videoId": "UBYL-AY5WKU",
    "thumbnail": "https://i.ytimg.com/vi/UBYL-AY5WKU/mqdefault.jpg",
    "title": "NIGHTMARE",
    "publishedAt": "2021-02-18T13:02:51Z"
  },
  {
    "videoId": "s-X1TsR9scI",
    "thumbnail": "https://i.ytimg.com/vi/s-X1TsR9scI/mqdefault.jpg",
    "title": "HAACHAMACHAMA~",
    "publishedAt": "2021-02-18T15:05:38Z"
  },
  {
    "videoId": "AP-65Eu0m5w",
    "thumbnail": "https://i.ytimg.com/vi/AP-65Eu0m5w/mqdefault.jpg",
    "title": "LOLICHAMA",
    "publishedAt": "2021-02-20T14:29:14Z"
  },
  {
    "videoId": "uryelR5u9PQ",
    "thumbnail": "https://i.ytimg.com/vi/uryelR5u9PQ/mqdefault.jpg",
    "title": "【】",
    "publishedAt": "2021-02-23T16:04:34Z"
  },
  {
    "videoId": "14Gwl_0v9-w",
    "thumbnail": "https://i.ytimg.com/vi/14Gwl_0v9-w/mqdefault.jpg",
    "title": "BAD END",
    "publishedAt": "2021-02-28T15:28:26Z"
  },
  {
    "videoId": "m9lytQ0t_Qc",
    "thumbnail": "https://i.ytimg.com/vi/m9lytQ0t_Qc/mqdefault.jpg",
    "title": "COEXIST",
    "publishedAt": "2021-02-28T15:34:18Z"
  },
  {
    "videoId": "7IqNz__e59w",
    "thumbnail": "https://i.ytimg.com/vi/7IqNz__e59w/mqdefault.jpg",
    "title": "#BADEND",
    "publishedAt": "2021-02-28T16:14:48Z"
  },
  {
    "videoId": "H6R5FNT8Fvs",
    "thumbnail": "https://i.ytimg.com/vi/H6R5FNT8Fvs/mqdefault.jpg",
    "title": "#NEVERENDINGSTORY",
    "publishedAt": "2021-03-03T13:05:09Z"
  },
  {
    "videoId": "LTcpdUrF4iM",
    "thumbnail": "https://i.ytimg.com/vi/LTcpdUrF4iM/mqdefault.jpg",
    "title": "#COEXIST",
    "publishedAt": "2021-03-30T14:23:44Z"
  },
  {
    "videoId": "nqzdcwBsLyM",
    "thumbnail": "https://i.ytimg.com/vi/nqzdcwBsLyM/mqdefault.jpg",
    "title": "SINGCHAMA",
    "publishedAt": "2021-03-31T15:01:33Z"
  },
  {
    "videoId": "288zS7ycyo4",
    "thumbnail": "https://i.ytimg.com/vi/288zS7ycyo4/mqdefault.jpg",
    "title": "【BIRTHDAY STREAM】誕生日凸待ち",
    "publishedAt": "2021-04-01T11:59:48Z"
  },
  {
    "videoId": "nM-Ln7aIIIE",
    "thumbnail": "https://i.ytimg.com/vi/nM-Ln7aIIIE/mqdefault.jpg",
    "title": "ご飯を食べる際にどうぞ",
    "publishedAt": "2021-04-02T03:53:12Z"
  },
  {
    "videoId": "OHZhlusvdx0",
    "thumbnail": "https://i.ytimg.com/vi/OHZhlusvdx0/mqdefault.jpg",
    "title": "空気読み。/ YABE",
    "publishedAt": "2021-04-02T11:45:39Z"
  },
  {
    "videoId": "Hdduxl58xVE",
    "thumbnail": "https://i.ytimg.com/vi/Hdduxl58xVE/mqdefault.jpg",
    "title": "ゃりおゃりお",
    "publishedAt": "2021-04-04T11:02:56Z"
  },
  {
    "videoId": "vDYQwMrWEes",
    "thumbnail": "https://i.ytimg.com/vi/vDYQwMrWEes/mqdefault.jpg",
    "title": "[Room tour!!]ヲタク部屋観光がガチすぎる【ホロライブ/はあちゃま】",
    "publishedAt": "2021-04-04T14:07:33Z"
  },
  {
    "videoId": "YYYJSX-vBKY",
    "thumbnail": "https://i.ytimg.com/vi/YYYJSX-vBKY/mqdefault.jpg",
    "title": "はあちゃま♡COOKING♪ 【#HAACHAMACOOKING​​】",
    "publishedAt": "2021-04-05T15:01:42Z"
  },
  {
    "videoId": "bDp5LVNENr0",
    "thumbnail": "https://i.ytimg.com/vi/bDp5LVNENr0/mqdefault.jpg",
    "title": "50万突破まで無心 / until 500k",
    "publishedAt": "2021-04-06T16:05:44Z"
  },
  {
    "videoId": "MdLvuLaoWvs",
    "thumbnail": "https://i.ytimg.com/vi/MdLvuLaoWvs/mqdefault.jpg",
    "title": "REVIVAL",
    "publishedAt": "2021-04-26T14:41:06Z"
  },
  {
    "videoId": "AXBMxI0fhdc",
    "thumbnail": "https://i.ytimg.com/vi/AXBMxI0fhdc/mqdefault.jpg",
    "title": "SINGCHAMA｜【歌枠】",
    "publishedAt": "2021-04-27T14:34:44Z"
  },
  {
    "videoId": "4QIvGHQMu0E",
    "thumbnail": "https://i.ytimg.com/vi/4QIvGHQMu0E/mqdefault.jpg",
    "title": "のーんびり対戦【TETRIS99】",
    "publishedAt": "2021-04-29T11:21:05Z"
  },
  {
    "videoId": "BdDPkTBcubA",
    "thumbnail": "https://i.ytimg.com/vi/BdDPkTBcubA/mqdefault.jpg",
    "title": "虹色ラーメン♡COOKING♪【#HAACHAMACOOKING​​​】",
    "publishedAt": "2021-05-01T16:24:51Z"
  },
  {
    "videoId": "zlcncg_44Cw",
    "thumbnail": "https://i.ytimg.com/vi/zlcncg_44Cw/mqdefault.jpg",
    "title": "[Cosplay contest!!]コスプレを募集した結果・・・！？",
    "publishedAt": "2021-05-02T15:15:34Z"
  },
  {
    "videoId": "BujmzBSzQtk",
    "thumbnail": "https://i.ytimg.com/vi/BujmzBSzQtk/mqdefault.jpg",
    "title": "【Minecraft】深夜の残業。",
    "publishedAt": "2021-05-03T16:24:13Z"
  },
  {
    "videoId": "Uvp5KuVMOgw",
    "thumbnail": "https://i.ytimg.com/vi/Uvp5KuVMOgw/mqdefault.jpg",
    "title": "虫歯の痛い歌枠｜Singing💢",
    "publishedAt": "2021-05-04T14:07:31Z"
  },
  {
    "videoId": "CCeuVUZ7JJc",
    "thumbnail": "https://i.ytimg.com/vi/CCeuVUZ7JJc/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖であそぶ～～～～～っ！【ホロライブ/はあちゃま】",
    "publishedAt": "2021-05-07T11:52:42Z"
  },
  {
    "videoId": "yeXlL3w-NRI",
    "thumbnail": "https://i.ytimg.com/vi/yeXlL3w-NRI/mqdefault.jpg",
    "title": "SUSHI CONTEST!!",
    "publishedAt": "2021-05-08T14:49:53Z"
  },
  {
    "videoId": "yitzIgzLLWY",
    "thumbnail": "https://i.ytimg.com/vi/yitzIgzLLWY/mqdefault.jpg",
    "title": "H � � ... C H A M A ? ?",
    "publishedAt": "2021-05-08T15:12:09Z"
  },
  {
    "videoId": "bDN9KiWdXbs",
    "thumbnail": "https://i.ytimg.com/vi/bDN9KiWdXbs/mqdefault.jpg",
    "title": "HAACHAMA IS DEAD",
    "publishedAt": "2021-05-08T16:58:26Z"
  },
  {
    "videoId": "W0Fo39SpN-g",
    "thumbnail": "https://i.ytimg.com/vi/W0Fo39SpN-g/mqdefault.jpg",
    "title": "[COOKING CONTEST!!]オリジナル寿司を募集した結果・・・！？",
    "publishedAt": "2021-05-09T12:10:05Z"
  },
  {
    "videoId": "711J_W0-qfY",
    "thumbnail": "https://i.ytimg.com/vi/711J_W0-qfY/mqdefault.jpg",
    "title": "Good-bye.",
    "publishedAt": "2021-05-10T13:45:29Z"
  },
  {
    "videoId": "o2a_zc6-71Y",
    "thumbnail": "https://i.ytimg.com/vi/o2a_zc6-71Y/mqdefault.jpg",
    "title": "LOLICHAMA",
    "publishedAt": "2021-05-11T11:42:05Z"
  },
  {
    "videoId": "CNN0QKp08Wg",
    "thumbnail": "https://i.ytimg.com/vi/CNN0QKp08Wg/mqdefault.jpg",
    "title": "COOKING ♪ #shorts",
    "publishedAt": "2021-05-12T06:32:41Z"
  },
  {
    "videoId": "LButyx65snY",
    "thumbnail": "https://i.ytimg.com/vi/LButyx65snY/mqdefault.jpg",
    "title": "すこしだけ【TETRIS99】",
    "publishedAt": "2021-05-13T12:06:41Z"
  },
  {
    "videoId": "HQ0JX8SD-5E",
    "thumbnail": "https://i.ytimg.com/vi/HQ0JX8SD-5E/mqdefault.jpg",
    "title": "GO BACK",
    "publishedAt": "2021-05-16T12:32:51Z"
  },
  {
    "videoId": "S_M4CJgJDvk",
    "thumbnail": "https://i.ytimg.com/vi/S_M4CJgJDvk/mqdefault.jpg",
    "title": "HAACHAMA CHAMA",
    "publishedAt": "2021-05-18T16:44:20Z"
  },
  {
    "videoId": "ICim2O8u2ms",
    "thumbnail": "https://i.ytimg.com/vi/ICim2O8u2ms/mqdefault.jpg",
    "title": "【#from1st】一期生歌枠リレ～！Singing♪【ホロライブ/はあちゃま】",
    "publishedAt": "2021-05-27T14:11:59Z"
  },
  {
    "videoId": "9mj2QJE-UOI",
    "thumbnail": "https://i.ytimg.com/vi/9mj2QJE-UOI/mqdefault.jpg",
    "title": "Infinity / 赤井はあと (Official)",
    "publishedAt": "2021-06-02T16:33:46Z"
  },
  {
    "videoId": "aNAHJGK2PJY",
    "thumbnail": "https://i.ytimg.com/vi/aNAHJGK2PJY/mqdefault.jpg",
    "title": "【凸待ち】#はあちゃま3周年 3rd anniversary!!",
    "publishedAt": "2021-06-03T15:15:30Z"
  },
  {
    "videoId": "RGsmcgWw7Z8",
    "thumbnail": "https://i.ytimg.com/vi/RGsmcgWw7Z8/mqdefault.jpg",
    "title": "はあちゃまのお知らせ【ホロライブ/はあちゃま】",
    "publishedAt": "2021-06-12T14:05:20Z"
  },
  {
    "videoId": "4p2BaQ9WRzo",
    "thumbnail": "https://i.ytimg.com/vi/4p2BaQ9WRzo/mqdefault.jpg",
    "title": "ただいま【ホロライブ/はあちゃま】",
    "publishedAt": "2021-07-24T17:55:49Z"
  },
  {
    "videoId": "YndAV5Z5sXQ",
    "thumbnail": "https://i.ytimg.com/vi/YndAV5Z5sXQ/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW!!",
    "publishedAt": "2021-07-25T04:59:05Z"
  },
  {
    "videoId": "ZgkBimQ0Jlc",
    "thumbnail": "https://i.ytimg.com/vi/ZgkBimQ0Jlc/mqdefault.jpg",
    "title": "タコパしながら凸待ちしようぜ【#HAACHAMACOOKING】",
    "publishedAt": "2021-07-26T13:47:27Z"
  },
  {
    "videoId": "eVCvK2XTvho",
    "thumbnail": "https://i.ytimg.com/vi/eVCvK2XTvho/mqdefault.jpg",
    "title": "【#1】地獄の歌枠【HELLSING】",
    "publishedAt": "2021-07-27T15:40:38Z"
  },
  {
    "videoId": "GGcs4ussEnI",
    "thumbnail": "https://i.ytimg.com/vi/GGcs4ussEnI/mqdefault.jpg",
    "title": "【Minecraft】帰ってきたホロ鯖！【Hololive/Akaihaato】",
    "publishedAt": "2021-07-30T17:50:09Z"
  },
  {
    "videoId": "Qu41r_b1Qrw",
    "thumbnail": "https://i.ytimg.com/vi/Qu41r_b1Qrw/mqdefault.jpg",
    "title": "天才的!?ヲタクの特技が凄すぎる・・・！？【#HAACHAMASUNDAY】",
    "publishedAt": "2021-08-01T03:50:35Z"
  },
  {
    "videoId": "YSRrPr2wt1s",
    "thumbnail": "https://i.ytimg.com/vi/YSRrPr2wt1s/mqdefault.jpg",
    "title": "天才的!?ヲタクの特技が凄すぎる・・・！？【#HAACHAMASUNDAY】",
    "publishedAt": "2021-08-01T04:16:39Z"
  },
  {
    "videoId": "6e6C3qQp68E",
    "thumbnail": "https://i.ytimg.com/vi/6e6C3qQp68E/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with KIARA!!",
    "publishedAt": "2021-08-01T14:09:08Z"
  },
  {
    "videoId": "pB7ESyzEmnk",
    "thumbnail": "https://i.ytimg.com/vi/pB7ESyzEmnk/mqdefault.jpg",
    "title": "かき氷つくるだけ【#HAACHAMACOOKING】",
    "publishedAt": "2021-08-02T15:42:34Z"
  },
  {
    "videoId": "Vwhvi3oA2k8",
    "thumbnail": "https://i.ytimg.com/vi/Vwhvi3oA2k8/mqdefault.jpg",
    "title": "【ヘリウムで!?】地獄の歌枠【HELLSING】",
    "publishedAt": "2021-08-03T16:16:52Z"
  },
  {
    "videoId": "izQBkUsnbY8",
    "thumbnail": "https://i.ytimg.com/vi/izQBkUsnbY8/mqdefault.jpg",
    "title": "【Gartic Phone】はあちゃま画伯、現る・・・！ 【#ホロお絵描き伝言】",
    "publishedAt": "2021-08-06T13:30:17Z"
  },
  {
    "videoId": "oZedeiZYJy0",
    "thumbnail": "https://i.ytimg.com/vi/oZedeiZYJy0/mqdefault.jpg",
    "title": "【Minecraft】おやすみマイクラ【Hololive/Akaihaato】",
    "publishedAt": "2021-08-06T16:10:30Z"
  },
  {
    "videoId": "Vyk_-R4iMEE",
    "thumbnail": "https://i.ytimg.com/vi/Vyk_-R4iMEE/mqdefault.jpg",
    "title": "個性的!?グッズのアイデア募集してみた結果！【#HAACHAMASUNDAY】",
    "publishedAt": "2021-08-08T04:35:54Z"
  },
  {
    "videoId": "DikZFHp5glU",
    "thumbnail": "https://i.ytimg.com/vi/DikZFHp5glU/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with AKAIHAATO!!",
    "publishedAt": "2021-08-08T12:02:09Z"
  },
  {
    "videoId": "z28xfePCnmM",
    "thumbnail": "https://i.ytimg.com/vi/z28xfePCnmM/mqdefault.jpg",
    "title": "HAPPY BIRTHDAY !!",
    "publishedAt": "2021-08-09T16:08:31Z"
  },
  {
    "videoId": "RAzc3ITPKnE",
    "thumbnail": "https://i.ytimg.com/vi/RAzc3ITPKnE/mqdefault.jpg",
    "title": "誕生日だからケーキ作る【#HAACHAMACOOKING】",
    "publishedAt": "2021-08-10T14:37:38Z"
  },
  {
    "videoId": "EootVKrfAyE",
    "thumbnail": "https://i.ytimg.com/vi/EootVKrfAyE/mqdefault.jpg",
    "title": "【Minecraft】バベルの塔、てっぺん目指す!!【ホロライブ/はあちゃま】",
    "publishedAt": "2021-08-11T19:40:00Z"
  },
  {
    "videoId": "gnfua42sLbk",
    "thumbnail": "https://i.ytimg.com/vi/gnfua42sLbk/mqdefault.jpg",
    "title": "【 Minecraft 】超巨大建築！一生完成しません；；【ホロライブ/はあちゃま】",
    "publishedAt": "2021-08-12T16:39:10Z"
  },
  {
    "videoId": "b8HierrGwyQ",
    "thumbnail": "https://i.ytimg.com/vi/b8HierrGwyQ/mqdefault.jpg",
    "title": "【Minecraft】SLEEPCRAFT CHAMA~~~💤【English only】",
    "publishedAt": "2021-08-13T05:27:06Z"
  },
  {
    "videoId": "7mSV_gjNEQo",
    "thumbnail": "https://i.ytimg.com/vi/7mSV_gjNEQo/mqdefault.jpg",
    "title": "【Minecraft】おデートだにぇちゃま～～～！【#はあみこまふぃあ】",
    "publishedAt": "2021-08-14T15:13:19Z"
  },
  {
    "videoId": "ohIWBDxIJW4",
    "thumbnail": "https://i.ytimg.com/vi/ohIWBDxIJW4/mqdefault.jpg",
    "title": "【Minecraft】深夜にこっそり【Akaihaato】",
    "publishedAt": "2021-08-14T20:36:38Z"
  },
  {
    "videoId": "cRpsol6VcTc",
    "thumbnail": "https://i.ytimg.com/vi/cRpsol6VcTc/mqdefault.jpg",
    "title": "【Minecraft】バベルの塔つくった！",
    "publishedAt": "2021-08-14T23:40:02Z"
  },
  {
    "videoId": "BOpCX9zf2iI",
    "thumbnail": "https://i.ytimg.com/vi/BOpCX9zf2iI/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with IRyS!!",
    "publishedAt": "2021-08-15T14:11:05Z"
  },
  {
    "videoId": "BnRtNC2TC0M",
    "thumbnail": "https://i.ytimg.com/vi/BnRtNC2TC0M/mqdefault.jpg",
    "title": "流しゲテモノ麺つくった！【はあちゃまクッキング】",
    "publishedAt": "2021-08-16T16:54:25Z"
  },
  {
    "videoId": "LOAHOG0cg_w",
    "thumbnail": "https://i.ytimg.com/vi/LOAHOG0cg_w/mqdefault.jpg",
    "title": "BOIN CHAMA!! #Shorts",
    "publishedAt": "2021-08-16T20:02:42Z"
  },
  {
    "videoId": "-Jl9PAdb9HM",
    "thumbnail": "https://i.ytimg.com/vi/-Jl9PAdb9HM/mqdefault.jpg",
    "title": "NEW FRIEND",
    "publishedAt": "2021-08-17T15:08:16Z"
  },
  {
    "videoId": "q5wfoXWuVfw",
    "thumbnail": "https://i.ytimg.com/vi/q5wfoXWuVfw/mqdefault.jpg",
    "title": "ERROR CHAMA!? #shorts",
    "publishedAt": "2021-08-17T22:21:42Z"
  },
  {
    "videoId": "vGi6U_mS4g8",
    "thumbnail": "https://i.ytimg.com/vi/vGi6U_mS4g8/mqdefault.jpg",
    "title": "ぶるちゃま",
    "publishedAt": "2021-08-18T10:59:52Z"
  },
  {
    "videoId": "2OQDO7GMep4",
    "thumbnail": "https://i.ytimg.com/vi/2OQDO7GMep4/mqdefault.jpg",
    "title": "【 Minecraft 】ENと繋がる🌎はあちゃまっちゃま～【#ホロ鯖ENポータルリレー / #HOLOserverPORTAL】",
    "publishedAt": "2021-08-21T13:02:57Z"
  },
  {
    "videoId": "9XMs-OcTnQw",
    "thumbnail": "https://i.ytimg.com/vi/9XMs-OcTnQw/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with Ollie!!",
    "publishedAt": "2021-08-22T04:09:07Z"
  },
  {
    "videoId": "IjbOzggZYE4",
    "thumbnail": "https://i.ytimg.com/vi/IjbOzggZYE4/mqdefault.jpg",
    "title": "【#はあちゃまサンデー】動画コンテスト！",
    "publishedAt": "2021-08-22T15:04:17Z"
  },
  {
    "videoId": "P6DcLalmvkI",
    "thumbnail": "https://i.ytimg.com/vi/P6DcLalmvkI/mqdefault.jpg",
    "title": "【 DEBUT STREAM 】🙏🏻PRAY TO THE GODCHAMA🙏🏻 #hololiveEnglish",
    "publishedAt": "2021-08-23T17:36:19Z"
  },
  {
    "videoId": "UpVise2FH2E",
    "thumbnail": "https://i.ytimg.com/vi/UpVise2FH2E/mqdefault.jpg",
    "title": "【実験】輪ゴムでスイカ割り！COOKING♪",
    "publishedAt": "2021-08-24T15:23:56Z"
  },
  {
    "videoId": "fjgzG8u2WyE",
    "thumbnail": "https://i.ytimg.com/vi/fjgzG8u2WyE/mqdefault.jpg",
    "title": "輪ゴムスイカ割り！【はあちゃまクッキング】",
    "publishedAt": "2021-08-25T10:08:46Z"
  },
  {
    "videoId": "KNPGMJUPZ_A",
    "thumbnail": "https://i.ytimg.com/vi/KNPGMJUPZ_A/mqdefault.jpg",
    "title": "罵倒配信【ホロライブ/はあちゃま】",
    "publishedAt": "2021-08-25T14:12:28Z"
  },
  {
    "videoId": "IzVCRnubv-w",
    "thumbnail": "https://i.ytimg.com/vi/IzVCRnubv-w/mqdefault.jpg",
    "title": "謝罪動画",
    "publishedAt": "2021-08-25T16:51:12Z"
  },
  {
    "videoId": "PJT7YwsNFQs",
    "thumbnail": "https://i.ytimg.com/vi/PJT7YwsNFQs/mqdefault.jpg",
    "title": "RUDE NUDE DUDE!!",
    "publishedAt": "2021-08-25T17:37:41Z"
  },
  {
    "videoId": "dOFiuU7SX0c",
    "thumbnail": "https://i.ytimg.com/vi/dOFiuU7SX0c/mqdefault.jpg",
    "title": "PANTSU CHAMA!? #jackochallenge",
    "publishedAt": "2021-08-27T10:13:51Z"
  },
  {
    "videoId": "OOpuWC3t0eQ",
    "thumbnail": "https://i.ytimg.com/vi/OOpuWC3t0eQ/mqdefault.jpg",
    "title": "Pick me up... CHAMA",
    "publishedAt": "2021-08-28T10:03:47Z"
  },
  {
    "videoId": "p5oAhNG9eek",
    "thumbnail": "https://i.ytimg.com/vi/p5oAhNG9eek/mqdefault.jpg",
    "title": "BAD WORD RAP by HAACHAMA",
    "publishedAt": "2021-08-29T11:37:40Z"
  },
  {
    "videoId": "mRCfFS0SsCk",
    "thumbnail": "https://i.ytimg.com/vi/mRCfFS0SsCk/mqdefault.jpg",
    "title": "ウ”ィ”エ” チ”ャ”マ”",
    "publishedAt": "2021-09-07T11:35:22Z"
  },
  {
    "videoId": "7J6bL0kCtqc",
    "thumbnail": "https://i.ytimg.com/vi/7J6bL0kCtqc/mqdefault.jpg",
    "title": "はあちゃまの本音【ホロライブ/はあちゃま】",
    "publishedAt": "2021-09-07T16:01:36Z"
  },
  {
    "videoId": "GNrSnDr8Aeo",
    "thumbnail": "https://i.ytimg.com/vi/GNrSnDr8Aeo/mqdefault.jpg",
    "title": "【 Minecraft 】新　事　業　始　動　！withふーたん【 #はあフレ 】",
    "publishedAt": "2021-09-08T16:45:22Z"
  },
  {
    "videoId": "uldXH46tBnM",
    "thumbnail": "https://i.ytimg.com/vi/uldXH46tBnM/mqdefault.jpg",
    "title": "ぶるぶるマシンで！COOKING♪【#HAACHAMACOOKING】",
    "publishedAt": "2021-09-09T15:25:09Z"
  },
  {
    "videoId": "PXEAD7lcA9I",
    "thumbnail": "https://i.ytimg.com/vi/PXEAD7lcA9I/mqdefault.jpg",
    "title": "【耐久】はあちゃまは何時間はあちゃまっちゃまできるのか？",
    "publishedAt": "2021-09-10T12:48:50Z"
  },
  {
    "videoId": "IB0gLerrmFw",
    "thumbnail": "https://i.ytimg.com/vi/IB0gLerrmFw/mqdefault.jpg",
    "title": "OMG, Finally I got slangs!! [HAACHAMA English]",
    "publishedAt": "2021-09-11T15:41:03Z"
  },
  {
    "videoId": "uB7MzL1HtXs",
    "thumbnail": "https://i.ytimg.com/vi/uB7MzL1HtXs/mqdefault.jpg",
    "title": "【アソビ大全】ガチンコ対決！はあ虐？それともすい虐？【ホロライブ/#赤星】",
    "publishedAt": "2021-09-15T14:27:11Z"
  },
  {
    "videoId": "a1T7W71N4gA",
    "thumbnail": "https://i.ytimg.com/vi/a1T7W71N4gA/mqdefault.jpg",
    "title": "【 Minecraft 】LET'S！ホロ鯖であそぼ～～～♪【ホロライブ/はあちゃま】",
    "publishedAt": "2021-09-17T16:30:05Z"
  },
  {
    "videoId": "15AimCh9jCE",
    "thumbnail": "https://i.ytimg.com/vi/15AimCh9jCE/mqdefault.jpg",
    "title": "【はあちゃま×HoloID2】日本語教える！HAACHAMA's Japanese Lesson!!",
    "publishedAt": "2021-09-20T10:48:03Z"
  },
  {
    "videoId": "UlVRyWU86DY",
    "thumbnail": "https://i.ytimg.com/vi/UlVRyWU86DY/mqdefault.jpg",
    "title": "【VALORANT】はじめてのFPS配信！【 初心者 】",
    "publishedAt": "2021-09-20T17:54:03Z"
  },
  {
    "videoId": "PkrRlxEWzCE",
    "thumbnail": "https://i.ytimg.com/vi/PkrRlxEWzCE/mqdefault.jpg",
    "title": "【おすそわけるメイドインワリオ】#ちゃまとねね でガチンコ勝負！【はあちゃま&桃鈴ねね】",
    "publishedAt": "2021-09-21T13:12:38Z"
  },
  {
    "videoId": "CkOoFnxTqlQ",
    "thumbnail": "https://i.ytimg.com/vi/CkOoFnxTqlQ/mqdefault.jpg",
    "title": "【 Minecraft 】うぇるかむホロEN～♪【ホロライブ/赤井はあと】",
    "publishedAt": "2021-09-22T07:40:23Z"
  },
  {
    "videoId": "fijMpYDYyX4",
    "thumbnail": "https://i.ytimg.com/vi/fijMpYDYyX4/mqdefault.jpg",
    "title": "BrBrBAKAMEe!!",
    "publishedAt": "2021-10-06T02:49:23Z"
  },
  {
    "videoId": "344tXc84-u0",
    "thumbnail": "https://i.ytimg.com/vi/344tXc84-u0/mqdefault.jpg",
    "title": "【歌枠】深夜にしっとり歌いますわ♪【ホロライブ/はあちゃま】",
    "publishedAt": "2021-10-15T16:59:43Z"
  },
  {
    "videoId": "lKbSIIJELig",
    "thumbnail": "https://i.ytimg.com/vi/lKbSIIJELig/mqdefault.jpg",
    "title": "顎クイはあちゃま #shorts",
    "publishedAt": "2021-10-21T15:53:30Z"
  },
  {
    "videoId": "K6gfdqw_76w",
    "thumbnail": "https://i.ytimg.com/vi/K6gfdqw_76w/mqdefault.jpg",
    "title": "は？？？",
    "publishedAt": "2021-10-21T16:26:42Z"
  },
  {
    "videoId": "XhfuYtpfF9c",
    "thumbnail": "https://i.ytimg.com/vi/XhfuYtpfF9c/mqdefault.jpg",
    "title": "シェアハピ～♪",
    "publishedAt": "2021-10-23T11:15:05Z"
  },
  {
    "videoId": "TkVh9ZZPe1s",
    "thumbnail": "https://i.ytimg.com/vi/TkVh9ZZPe1s/mqdefault.jpg",
    "title": "【Slither.io】シコタマ寝れる配信【ホロライブ/はあちゃま】",
    "publishedAt": "2021-10-23T16:02:20Z"
  },
  {
    "videoId": "rx2mufVoRi4",
    "thumbnail": "https://i.ytimg.com/vi/rx2mufVoRi4/mqdefault.jpg",
    "title": "【歌枠】HALLOWEEN PARTY NIGHT♪【ホロライブ/はあちゃま】",
    "publishedAt": "2021-10-31T18:33:35Z"
  },
  {
    "videoId": "TpPg8ZgZmzM",
    "thumbnail": "https://i.ytimg.com/vi/TpPg8ZgZmzM/mqdefault.jpg",
    "title": "ハロウィンなのでもんじゃ焼く！#HAACHAMACOOKING",
    "publishedAt": "2021-11-01T16:22:34Z"
  },
  {
    "videoId": "Dk9sbDguyP0",
    "thumbnail": "https://i.ytimg.com/vi/Dk9sbDguyP0/mqdefault.jpg",
    "title": "HAACHAMASUNDAY THEME",
    "publishedAt": "2021-11-01T18:39:22Z"
  },
  {
    "videoId": "B0a-hm7j-ho",
    "thumbnail": "https://i.ytimg.com/vi/B0a-hm7j-ho/mqdefault.jpg",
    "title": "ガチすぎ!?コスプレ募集した結果・・・！【#はあちゃまハロコス祭】",
    "publishedAt": "2021-11-02T16:41:34Z"
  },
  {
    "videoId": "qIMl5bWK0_Q",
    "thumbnail": "https://i.ytimg.com/vi/qIMl5bWK0_Q/mqdefault.jpg",
    "title": "HAACHAMA DRUG",
    "publishedAt": "2021-11-04T19:40:57Z"
  },
  {
    "videoId": "aPIfocr6Rzc",
    "thumbnail": "https://i.ytimg.com/vi/aPIfocr6Rzc/mqdefault.jpg",
    "title": "【初】はあちゃま、テキーラ飲む！【晩酌】",
    "publishedAt": "2021-11-04T19:56:48Z"
  },
  {
    "videoId": "9oOjchK3ZZU",
    "thumbnail": "https://i.ytimg.com/vi/9oOjchK3ZZU/mqdefault.jpg",
    "title": "BACK TO EN SERVER!! 【Minecraft】",
    "publishedAt": "2021-11-11T17:12:26Z"
  },
  {
    "videoId": "t8xekQ-MGFc",
    "thumbnail": "https://i.ytimg.com/vi/t8xekQ-MGFc/mqdefault.jpg",
    "title": "【#タイクレ】えちちな抱き枕GET！？クレーンゲームやる！【ホロライブ/はあちゃま】",
    "publishedAt": "2021-11-12T13:00:12Z"
  },
  {
    "videoId": "rg_74n-6ke8",
    "thumbnail": "https://i.ytimg.com/vi/rg_74n-6ke8/mqdefault.jpg",
    "title": ":D",
    "publishedAt": "2021-11-16T14:11:35Z"
  },
  {
    "videoId": "Q9RwEYIgGMY",
    "thumbnail": "https://i.ytimg.com/vi/Q9RwEYIgGMY/mqdefault.jpg",
    "title": "はあちゃま、爆誕。",
    "publishedAt": "2021-11-17T15:34:59Z"
  },
  {
    "videoId": "88APiRAcQcc",
    "thumbnail": "https://i.ytimg.com/vi/88APiRAcQcc/mqdefault.jpg",
    "title": "【#はあちゃま生誕祭2021】🤪👆💫お誕生日3DLIVE💫👆🤪【はあちゃま/ホロライブ】",
    "publishedAt": "2021-11-18T12:14:02Z"
  },
  {
    "videoId": "_uMQCVHdwUI",
    "thumbnail": "https://i.ytimg.com/vi/_uMQCVHdwUI/mqdefault.jpg",
    "title": "Infinity 【3DLIVE】",
    "publishedAt": "2021-11-18T17:40:20Z"
  },
  {
    "videoId": "FJn4f5f7DQM",
    "thumbnail": "https://i.ytimg.com/vi/FJn4f5f7DQM/mqdefault.jpg",
    "title": "3DHAACHAMA COOKING♪",
    "publishedAt": "2021-11-19T16:38:58Z"
  },
  {
    "videoId": "UOFSCbraOnY",
    "thumbnail": "https://i.ytimg.com/vi/UOFSCbraOnY/mqdefault.jpg",
    "title": "FPS YARU UMU...........!!!",
    "publishedAt": "2021-11-19T17:11:07Z"
  },
  {
    "videoId": "--c3tOUcrZA",
    "thumbnail": "https://i.ytimg.com/vi/--c3tOUcrZA/mqdefault.jpg",
    "title": "DEGENELATE",
    "publishedAt": "2021-11-22T21:30:58Z"
  },
  {
    "videoId": "zF48lIJsLrY",
    "thumbnail": "https://i.ytimg.com/vi/zF48lIJsLrY/mqdefault.jpg",
    "title": "【#タイクレ】はあちゃま秘密結社、裏ボス現る・・・！【※寝坊ごめんなさい！！！】",
    "publishedAt": "2021-11-26T14:22:10Z"
  },
  {
    "videoId": "aCRB01W3VeY",
    "thumbnail": "https://i.ytimg.com/vi/aCRB01W3VeY/mqdefault.jpg",
    "title": "HAACHAMA DARKNESS RAP",
    "publishedAt": "2021-11-26T16:53:01Z"
  },
  {
    "videoId": "72tcLl8SDhI",
    "thumbnail": "https://i.ytimg.com/vi/72tcLl8SDhI/mqdefault.jpg",
    "title": "はあちゃま、HoloXに敗北。【LOSECHAMA】",
    "publishedAt": "2021-11-27T17:41:26Z"
  },
  {
    "videoId": "2r9N4pLd7Ug",
    "thumbnail": "https://i.ytimg.com/vi/2r9N4pLd7Ug/mqdefault.jpg",
    "title": "やめてくだSTOP!! #shorts",
    "publishedAt": "2021-11-27T18:22:16Z"
  },
  {
    "videoId": "6hpNgAa9pq0",
    "thumbnail": "https://i.ytimg.com/vi/6hpNgAa9pq0/mqdefault.jpg",
    "title": "R.I.P HAACHAMA",
    "publishedAt": "2021-11-28T16:04:44Z"
  },
  {
    "videoId": "OfMvQ9TmJTc",
    "thumbnail": "https://i.ytimg.com/vi/OfMvQ9TmJTc/mqdefault.jpg",
    "title": "神っぽいはあちゃまRAP",
    "publishedAt": "2021-12-02T15:31:58Z"
  },
  {
    "videoId": "iQroU4ZRgE8",
    "thumbnail": "https://i.ytimg.com/vi/iQroU4ZRgE8/mqdefault.jpg",
    "title": "お手軽電子ドラッグRAP",
    "publishedAt": "2021-12-03T22:30:56Z"
  },
  {
    "videoId": "2BEBK9oS5hk",
    "thumbnail": "https://i.ytimg.com/vi/2BEBK9oS5hk/mqdefault.jpg",
    "title": "あなたと心中RAP",
    "publishedAt": "2021-12-05T16:26:09Z"
  },
  {
    "videoId": "ULbSydKA0Bs",
    "thumbnail": "https://i.ytimg.com/vi/ULbSydKA0Bs/mqdefault.jpg",
    "title": "【ゲリラ】ド深夜【CHILL】",
    "publishedAt": "2021-12-05T20:22:18Z"
  },
  {
    "videoId": "IkqhK72hE4I",
    "thumbnail": "https://i.ytimg.com/vi/IkqhK72hE4I/mqdefault.jpg",
    "title": "単位やばい大学生RAP",
    "publishedAt": "2021-12-05T23:13:57Z"
  },
  {
    "videoId": "dEbxC5S2Rwo",
    "thumbnail": "https://i.ytimg.com/vi/dEbxC5S2Rwo/mqdefault.jpg",
    "title": "足くさRAP",
    "publishedAt": "2021-12-07T02:35:37Z"
  },
  {
    "videoId": "NMCdl4XwasI",
    "thumbnail": "https://i.ytimg.com/vi/NMCdl4XwasI/mqdefault.jpg",
    "title": "【Gartic Phone】SoloX！？秘密結社のメンバーぼっちで十分！【ホロライブ/はあちゃま】",
    "publishedAt": "2021-12-07T17:10:38Z"
  },
  {
    "videoId": "PEDxLV5b2l4",
    "thumbnail": "https://i.ytimg.com/vi/PEDxLV5b2l4/mqdefault.jpg",
    "title": "永眠ができる歌【Singing♪】",
    "publishedAt": "2021-12-08T18:28:28Z"
  },
  {
    "videoId": "3l0f7PUYJuk",
    "thumbnail": "https://i.ytimg.com/vi/3l0f7PUYJuk/mqdefault.jpg",
    "title": "【Jump King】超　鬼　畜　ゲ　ー【ホロライブ/はあちゃま】",
    "publishedAt": "2021-12-09T12:36:58Z"
  },
  {
    "videoId": "uk9IUTeUesc",
    "thumbnail": "https://i.ytimg.com/vi/uk9IUTeUesc/mqdefault.jpg",
    "title": "DIS RAP",
    "publishedAt": "2021-12-12T16:58:38Z"
  },
  {
    "videoId": "9qZvzL7Qfcw",
    "thumbnail": "https://i.ytimg.com/vi/9qZvzL7Qfcw/mqdefault.jpg",
    "title": "THE END",
    "publishedAt": "2021-12-13T18:40:53Z"
  },
  {
    "videoId": "JRnca_X3T0U",
    "thumbnail": "https://i.ytimg.com/vi/JRnca_X3T0U/mqdefault.jpg",
    "title": "【ゲリラ】真冬のほっこり【CHILL】",
    "publishedAt": "2021-12-15T17:32:17Z"
  },
  {
    "videoId": "2EI3SVrK79Q",
    "thumbnail": "https://i.ytimg.com/vi/2EI3SVrK79Q/mqdefault.jpg",
    "title": "陰陽RAP",
    "publishedAt": "2021-12-15T22:21:43Z"
  },
  {
    "videoId": "AG2wP3vZSmk",
    "thumbnail": "https://i.ytimg.com/vi/AG2wP3vZSmk/mqdefault.jpg",
    "title": "【Minecraft】はあちゃま、旅立ち。【Hololive/HAACHAMA】",
    "publishedAt": "2021-12-16T17:27:04Z"
  },
  {
    "videoId": "oE9Zw9FVziQ",
    "thumbnail": "https://i.ytimg.com/vi/oE9Zw9FVziQ/mqdefault.jpg",
    "title": "配信で写ったメガネのブスRAP",
    "publishedAt": "2021-12-19T13:38:16Z"
  },
  {
    "videoId": "nykFMowm058",
    "thumbnail": "https://i.ytimg.com/vi/nykFMowm058/mqdefault.jpg",
    "title": "Vtuber顔バレ？なにそれ？美味しいの？",
    "publishedAt": "2021-12-19T14:50:09Z"
  },
  {
    "videoId": "L-XuRP6zvOA",
    "thumbnail": "https://i.ytimg.com/vi/L-XuRP6zvOA/mqdefault.jpg",
    "title": "【ROBOT】事故るか完成するまで【DIY】",
    "publishedAt": "2021-12-19T17:37:39Z"
  },
  {
    "videoId": "XmaWvu9OM3o",
    "thumbnail": "https://i.ytimg.com/vi/XmaWvu9OM3o/mqdefault.jpg",
    "title": "#はあちゃま闇の夜会",
    "publishedAt": "2021-12-20T17:40:14Z"
  },
  {
    "videoId": "SjzHCoKimGM",
    "thumbnail": "https://i.ytimg.com/vi/SjzHCoKimGM/mqdefault.jpg",
    "title": "単位なんてくそくらえRAP",
    "publishedAt": "2021-12-21T00:06:59Z"
  },
  {
    "videoId": "n_LL-jikx9w",
    "thumbnail": "https://i.ytimg.com/vi/n_LL-jikx9w/mqdefault.jpg",
    "title": "∞",
    "publishedAt": "2021-12-21T15:02:56Z"
  },
  {
    "videoId": "sy62AHZwOE8",
    "thumbnail": "https://i.ytimg.com/vi/sy62AHZwOE8/mqdefault.jpg",
    "title": "【速報】はあちゃま実写、かわいくね？？？？？ #REALCHAMA",
    "publishedAt": "2021-12-21T17:19:21Z"
  },
  {
    "videoId": "lsx4p_lsotI",
    "thumbnail": "https://i.ytimg.com/vi/lsx4p_lsotI/mqdefault.jpg",
    "title": "#HAACHAMATRIX",
    "publishedAt": "2021-12-21T18:05:29Z"
  },
  {
    "videoId": "5h_KXJwu47A",
    "thumbnail": "https://i.ytimg.com/vi/5h_KXJwu47A/mqdefault.jpg",
    "title": "あぶぶぁABABABABABABAAAAAAAAAAAA",
    "publishedAt": "2021-12-22T17:18:50Z"
  },
  {
    "videoId": "R1yVtuB4yhw",
    "thumbnail": "https://i.ytimg.com/vi/R1yVtuB4yhw/mqdefault.jpg",
    "title": "【Minecraft】チャマ文明をつくる！【ホロライブ/はあちゃま】",
    "publishedAt": "2021-12-23T17:12:24Z"
  },
  {
    "videoId": "FRXyQsOQC50",
    "thumbnail": "https://i.ytimg.com/vi/FRXyQsOQC50/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】はあちゃまだぜ！X'MAS HAACHAMA♪【ホロライブ/はあちゃま】",
    "publishedAt": "2021-12-25T13:26:10Z"
  },
  {
    "videoId": "ezW2_sJf4DA",
    "thumbnail": "https://i.ytimg.com/vi/ezW2_sJf4DA/mqdefault.jpg",
    "title": "くりぼっち忘年会。#BADASS",
    "publishedAt": "2021-12-25T17:07:57Z"
  },
  {
    "videoId": "50CwFFTNX70",
    "thumbnail": "https://i.ytimg.com/vi/50CwFFTNX70/mqdefault.jpg",
    "title": "ばあちゃまとの別れ",
    "publishedAt": "2021-12-25T17:13:50Z"
  },
  {
    "videoId": "djiavgCb5nU",
    "thumbnail": "https://i.ytimg.com/vi/djiavgCb5nU/mqdefault.jpg",
    "title": "【 Minecraft 】HELP MEEEEEEEE!!!!!【はあちゃま英会話】",
    "publishedAt": "2021-12-27T02:19:10Z"
  },
  {
    "videoId": "Y92HO2cH6DM",
    "thumbnail": "https://i.ytimg.com/vi/Y92HO2cH6DM/mqdefault.jpg",
    "title": "12/28",
    "publishedAt": "2021-12-27T13:21:08Z"
  },
  {
    "videoId": "Z3tKCt3PbOg",
    "thumbnail": "https://i.ytimg.com/vi/Z3tKCt3PbOg/mqdefault.jpg",
    "title": "～FIN～",
    "publishedAt": "2021-12-27T15:27:27Z"
  },
  {
    "videoId": "YazuwO5DxYs",
    "thumbnail": "https://i.ytimg.com/vi/YazuwO5DxYs/mqdefault.jpg",
    "title": "【 初配信 】DEBUT STREAM",
    "publishedAt": "2021-12-28T15:02:51Z"
  },
  {
    "videoId": "dNRlWDPYbgc",
    "thumbnail": "https://i.ytimg.com/vi/dNRlWDPYbgc/mqdefault.jpg",
    "title": "THE LAST OF 2021",
    "publishedAt": "2021-12-31T05:02:21Z"
  },
  {
    "videoId": "IhYl1JVBz1M",
    "thumbnail": "https://i.ytimg.com/vi/IhYl1JVBz1M/mqdefault.jpg",
    "title": "【 最後 】THE END 2021",
    "publishedAt": "2021-12-31T08:36:42Z"
  },
  {
    "videoId": "lWSX3BNrsHs",
    "thumbnail": "https://i.ytimg.com/vi/lWSX3BNrsHs/mqdefault.jpg",
    "title": "虫食って仲直りする！【#夏色はあと】",
    "publishedAt": "2022-01-05T11:08:56Z"
  },
  {
    "videoId": "mSPdwI6WD6Y",
    "thumbnail": "https://i.ytimg.com/vi/mSPdwI6WD6Y/mqdefault.jpg",
    "title": "DUDE RAP",
    "publishedAt": "2022-01-13T11:10:08Z"
  },
  {
    "videoId": "mKBxdQeImk8",
    "thumbnail": "https://i.ytimg.com/vi/mKBxdQeImk8/mqdefault.jpg",
    "title": "【悲報】はあちゃま、収益化剥奪。【NO MONEY】",
    "publishedAt": "2022-01-17T12:54:00Z"
  },
  {
    "videoId": "XXIibq8fQz0",
    "thumbnail": "https://i.ytimg.com/vi/XXIibq8fQz0/mqdefault.jpg",
    "title": "[MINECRAFT] LET'S GOOOOOO~~~!!! MUM&BAE&CHAMA!!!",
    "publishedAt": "2022-01-18T13:30:04Z"
  },
  {
    "videoId": "vP-PTfLWDE8",
    "thumbnail": "https://i.ytimg.com/vi/vP-PTfLWDE8/mqdefault.jpg",
    "title": "【深夜放送】ホラゲ・・・あばばばばばば【#karASHi】",
    "publishedAt": "2022-01-18T15:59:49Z"
  },
  {
    "videoId": "AUWSDf-yyj0",
    "thumbnail": "https://i.ytimg.com/vi/AUWSDf-yyj0/mqdefault.jpg",
    "title": "#PHOTOCHAMA 【#1】",
    "publishedAt": "2022-01-23T17:00:40Z"
  },
  {
    "videoId": "eqWKypA3PMY",
    "thumbnail": "https://i.ytimg.com/vi/eqWKypA3PMY/mqdefault.jpg",
    "title": "【復活】I'M BACK.",
    "publishedAt": "2022-02-05T12:17:08Z"
  },
  {
    "videoId": "Ru0v6YfXNuw",
    "thumbnail": "https://i.ytimg.com/vi/Ru0v6YfXNuw/mqdefault.jpg",
    "title": "【歌枠】アベ・チャママ 【SINGCHAMA】",
    "publishedAt": "2022-02-05T14:54:28Z"
  },
  {
    "videoId": "kp1jh_uGC1k",
    "thumbnail": "https://i.ytimg.com/vi/kp1jh_uGC1k/mqdefault.jpg",
    "title": "【 Minecraft 】深夜にまったり。",
    "publishedAt": "2022-02-06T15:14:35Z"
  },
  {
    "videoId": "fz4UbNUpdBs",
    "thumbnail": "https://i.ytimg.com/vi/fz4UbNUpdBs/mqdefault.jpg",
    "title": "アニソンを歌いつくすの会【SINGCHAMA】",
    "publishedAt": "2022-02-08T15:08:58Z"
  },
  {
    "videoId": "tgXYhBy1T-0",
    "thumbnail": "https://i.ytimg.com/vi/tgXYhBy1T-0/mqdefault.jpg",
    "title": "【最強】Vtuber界で一番うまいです【 Super Bunny Man 】",
    "publishedAt": "2022-02-10T13:57:49Z"
  },
  {
    "videoId": "uODjpkhfH4o",
    "thumbnail": "https://i.ytimg.com/vi/uODjpkhfH4o/mqdefault.jpg",
    "title": "[PHOTO CONTEST!!] 写真募集したらガチすぎた・・・！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-11T12:35:20Z"
  },
  {
    "videoId": "NPcl-gNrnBk",
    "thumbnail": "https://i.ytimg.com/vi/NPcl-gNrnBk/mqdefault.jpg",
    "title": "シュート",
    "publishedAt": "2022-02-11T12:58:05Z"
  },
  {
    "videoId": "w7DYH2zQhSM",
    "thumbnail": "https://i.ytimg.com/vi/w7DYH2zQhSM/mqdefault.jpg",
    "title": "【Minecraft】LET'S DO TNT PARTY~~~!!! #HololiveEN0",
    "publishedAt": "2022-02-12T04:22:34Z"
  },
  {
    "videoId": "MXm0PWPfOpI",
    "thumbnail": "https://i.ytimg.com/vi/MXm0PWPfOpI/mqdefault.jpg",
    "title": "【MARIO KART 8DX 】前代未聞！？逆さマリオカート【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-12T12:16:32Z"
  },
  {
    "videoId": "IxH7UePMzcI",
    "thumbnail": "https://i.ytimg.com/vi/IxH7UePMzcI/mqdefault.jpg",
    "title": "【#HAACHAMAMUSIC】音楽コンテスト開催した結果・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-13T14:10:19Z"
  },
  {
    "videoId": "p0T-f3fV0ao",
    "thumbnail": "https://i.ytimg.com/vi/p0T-f3fV0ao/mqdefault.jpg",
    "title": "【絶望】バレンタイン♡COOKING♪【#HAACHAMACOOKING】",
    "publishedAt": "2022-02-14T15:43:03Z"
  },
  {
    "videoId": "5hgD5tdSjGs",
    "thumbnail": "https://i.ytimg.com/vi/5hgD5tdSjGs/mqdefault.jpg",
    "title": "【歌枠】アイドルソング縛り♪きゃわわ～～～！#SINGCHAMA【ホロライブ/はあちゃま】",
    "publishedAt": "2022-02-15T12:45:21Z"
  },
  {
    "videoId": "ka_eUoKCLG8",
    "thumbnail": "https://i.ytimg.com/vi/ka_eUoKCLG8/mqdefault.jpg",
    "title": "【TETRIS99】めざせ！打倒星街！おりゃ～～～！！！～第一章～【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-16T12:21:57Z"
  },
  {
    "videoId": "TeTyLjmA8HY",
    "thumbnail": "https://i.ytimg.com/vi/TeTyLjmA8HY/mqdefault.jpg",
    "title": "【Human: Fall Flat】CAN YOU SPEAK ENGLISH...!?!? #HoloEN0",
    "publishedAt": "2022-02-16T14:57:37Z"
  },
  {
    "videoId": "4549lWFrjvE",
    "thumbnail": "https://i.ytimg.com/vi/4549lWFrjvE/mqdefault.jpg",
    "title": "【TETRIS99】めざせ！打倒星街！あされんするぞおおお！ ～第二章～【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-17T00:08:24Z"
  },
  {
    "videoId": "7KCoZfHm7Tg",
    "thumbnail": "https://i.ytimg.com/vi/7KCoZfHm7Tg/mqdefault.jpg",
    "title": "【Raft】はあちゃま、無人島生活はじめる！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-02-17T12:12:08Z"
  },
  {
    "videoId": "r05-ybfaPmY",
    "thumbnail": "https://i.ytimg.com/vi/r05-ybfaPmY/mqdefault.jpg",
    "title": "【TETRIS99】めざせ！打倒星街！ほんきだぞ～～～！？！？～第三章～【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-18T00:28:34Z"
  },
  {
    "videoId": "H5o643bA1sM",
    "thumbnail": "https://i.ytimg.com/vi/H5o643bA1sM/mqdefault.jpg",
    "title": "【歌枠】ジブリ縛り！トトロいるもももん！！！#SINGCHAMA【ホロライブ/はあちゃま】",
    "publishedAt": "2022-02-19T12:08:36Z"
  },
  {
    "videoId": "bCsplkncNDo",
    "thumbnail": "https://i.ytimg.com/vi/bCsplkncNDo/mqdefault.jpg",
    "title": "【TETRIS99】めざせ！打倒星街！朝から晩までカチコミだあああ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-19T14:31:46Z"
  },
  {
    "videoId": "Cp-GfbfTR38",
    "thumbnail": "https://i.ytimg.com/vi/Cp-GfbfTR38/mqdefault.jpg",
    "title": "[ROOM TOUR!!]汚部屋観光！？きたねぇ強者を拝む～～～！☆ミ【ホロライブ/はあちゃま】",
    "publishedAt": "2022-02-20T12:17:18Z"
  },
  {
    "videoId": "63OWpAf2fdA",
    "thumbnail": "https://i.ytimg.com/vi/63OWpAf2fdA/mqdefault.jpg",
    "title": "【TETRIS99】めざせ！打倒星街！まけてもよみがえる！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-02-20T14:22:54Z"
  },
  {
    "videoId": "wcF48KkfiX8",
    "thumbnail": "https://i.ytimg.com/vi/wcF48KkfiX8/mqdefault.jpg",
    "title": "赤井がうたいたがってるんだ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-02-23T12:24:20Z"
  },
  {
    "videoId": "Pqphy9wEXp8",
    "thumbnail": "https://i.ytimg.com/vi/Pqphy9wEXp8/mqdefault.jpg",
    "title": "【ASMR】かりんとうと酒うめぇ～～～♪【KU100/高音質】",
    "publishedAt": "2022-02-24T16:46:19Z"
  },
  {
    "videoId": "arXOITIG01A",
    "thumbnail": "https://i.ytimg.com/vi/arXOITIG01A/mqdefault.jpg",
    "title": "【Minecraft】魔法の言葉♪See you again...【ホロライブ/はあちゃま】",
    "publishedAt": "2022-02-25T15:09:15Z"
  },
  {
    "videoId": "ad4_ys1Q8-Q",
    "thumbnail": "https://i.ytimg.com/vi/ad4_ys1Q8-Q/mqdefault.jpg",
    "title": "[MANGA CONTEST!!] 爆笑!?はあちゃま4コマ漫画選手権！【#はあちゃま4コマ】",
    "publishedAt": "2022-02-28T14:51:41Z"
  },
  {
    "videoId": "F8WQGz4Hwd8",
    "thumbnail": "https://i.ytimg.com/vi/F8WQGz4Hwd8/mqdefault.jpg",
    "title": "【朝活】めざせ！打倒星街！やっぱりあきらめないもんねっ！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-01T00:14:42Z"
  },
  {
    "videoId": "V_EowgjBN6I",
    "thumbnail": "https://i.ytimg.com/vi/V_EowgjBN6I/mqdefault.jpg",
    "title": "【Minecraft】I'M A SPY, U KNOW??? #HololiveEN0【Hololive/Akaihaato】",
    "publishedAt": "2022-03-01T06:57:42Z"
  },
  {
    "videoId": "4KXAT88i7Pw",
    "thumbnail": "https://i.ytimg.com/vi/4KXAT88i7Pw/mqdefault.jpg",
    "title": "【朝活】めざせ！打倒星街！ふるぼっこにしてやんよ！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-02T00:18:34Z"
  },
  {
    "videoId": "qRbmKX-oVFc",
    "thumbnail": "https://i.ytimg.com/vi/qRbmKX-oVFc/mqdefault.jpg",
    "title": "【Minecraft】はあちゃま、全建設とおともだちになる～っ♪【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-02T12:17:53Z"
  },
  {
    "videoId": "MMJmRtsEFjg",
    "thumbnail": "https://i.ytimg.com/vi/MMJmRtsEFjg/mqdefault.jpg",
    "title": "【歌枠】あっは～ん！色気全開でいくわよ・・・♥【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-03T12:17:30Z"
  },
  {
    "videoId": "Vwv2LR_Mw7o",
    "thumbnail": "https://i.ytimg.com/vi/Vwv2LR_Mw7o/mqdefault.jpg",
    "title": "【朝活】めざせ！打倒星街！限界をこえていけ！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-04T00:10:53Z"
  },
  {
    "videoId": "PCEn19V2jxs",
    "thumbnail": "https://i.ytimg.com/vi/PCEn19V2jxs/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖をはあちゃまっちゃま～～～！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-04T12:22:02Z"
  },
  {
    "videoId": "I7ThkP8Wx0I",
    "thumbnail": "https://i.ytimg.com/vi/I7ThkP8Wx0I/mqdefault.jpg",
    "title": "【朝活】めざせ！打倒星街！がんばるんばるん～～～！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-05T00:10:37Z"
  },
  {
    "videoId": "cjiCu82NMCg",
    "thumbnail": "https://i.ytimg.com/vi/cjiCu82NMCg/mqdefault.jpg",
    "title": "【歌ったり喋る】たまにはまったり～～～。",
    "publishedAt": "2022-03-05T12:14:37Z"
  },
  {
    "videoId": "JaU_Bor7imQ",
    "thumbnail": "https://i.ytimg.com/vi/JaU_Bor7imQ/mqdefault.jpg",
    "title": "【朝練】めざせ！打倒星街！一位をとるぞおおお～～～！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-06T01:16:53Z"
  },
  {
    "videoId": "IvugstfXrNY",
    "thumbnail": "https://i.ytimg.com/vi/IvugstfXrNY/mqdefault.jpg",
    "title": "【Minecraft】I AM HERE. #HololiveEN0",
    "publishedAt": "2022-03-06T06:47:09Z"
  },
  {
    "videoId": "_-h86MUQOLk",
    "thumbnail": "https://i.ytimg.com/vi/_-h86MUQOLk/mqdefault.jpg",
    "title": "SING STREAM with my best friend♪",
    "publishedAt": "2022-03-07T12:18:49Z"
  },
  {
    "videoId": "EYYizyYe5GY",
    "thumbnail": "https://i.ytimg.com/vi/EYYizyYe5GY/mqdefault.jpg",
    "title": "【精神崩壊】いやだ・・・！壊れたくないいいい！！！(発狂)【Egg is broken heart is too】",
    "publishedAt": "2022-03-08T12:44:46Z"
  },
  {
    "videoId": "i5WkL02vTfc",
    "thumbnail": "https://i.ytimg.com/vi/i5WkL02vTfc/mqdefault.jpg",
    "title": "【おわた】DEAAAAD :D【ストレス発散】",
    "publishedAt": "2022-03-12T14:19:55Z"
  },
  {
    "videoId": "SMqOQqRi2Uo",
    "thumbnail": "https://i.ytimg.com/vi/SMqOQqRi2Uo/mqdefault.jpg",
    "title": "【Minecraft】必殺！ちょろち！？ハニートラップ大作戦！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-03-15T03:36:39Z"
  },
  {
    "videoId": "x2nb8c4_hWo",
    "thumbnail": "https://i.ytimg.com/vi/x2nb8c4_hWo/mqdefault.jpg",
    "title": "【Minecraft】ついに！ちょろち捕獲！釣れたぞおおお～！ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2022-03-17T14:47:29Z"
  },
  {
    "videoId": "7ZfNZRCPoHs",
    "thumbnail": "https://i.ytimg.com/vi/7ZfNZRCPoHs/mqdefault.jpg",
    "title": "【Minecraft】初コラボ！？さあ！愛の巣をつくろうか・・・！(圧)【ホロライブ/はあちゃま/博衣こより #こよちゃま 】",
    "publishedAt": "2022-03-21T13:54:50Z"
  },
  {
    "videoId": "U1Cv-EpeqmM",
    "thumbnail": "https://i.ytimg.com/vi/U1Cv-EpeqmM/mqdefault.jpg",
    "title": "【雑談】ねえ、YAGOO。履修登録やっといてくれない？？？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-03-23T13:24:51Z"
  },
  {
    "videoId": "lhm0ojx3atU",
    "thumbnail": "https://i.ytimg.com/vi/lhm0ojx3atU/mqdefault.jpg",
    "title": "【閉店事件/The Closing Shift】ぶぁあああ！！！ほじがわたすけてええええ！！！【はあちゃま/星川サラ/ホロライブ/にじさんじ】",
    "publishedAt": "2022-03-24T16:21:27Z"
  },
  {
    "videoId": "p39vuyBWzDk",
    "thumbnail": "https://i.ytimg.com/vi/p39vuyBWzDk/mqdefault.jpg",
    "title": "【#はあちゃまぼっち】ぼっち選手権！真のぼっちは誰だ・・・！？【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-26T13:15:23Z"
  },
  {
    "videoId": "DlV9Xba9N9s",
    "thumbnail": "https://i.ytimg.com/vi/DlV9Xba9N9s/mqdefault.jpg",
    "title": "【REDDIT SHITPOST REVIEW】IT'S TIME TO DO IT...!!【#HololiveEN0】",
    "publishedAt": "2022-03-27T04:01:14Z"
  },
  {
    "videoId": "xIPhMGzmVE8",
    "thumbnail": "https://i.ytimg.com/vi/xIPhMGzmVE8/mqdefault.jpg",
    "title": "【歌枠】わたくしの歌声を聴きなさい！おほほ～♪さむっ...【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-28T15:10:14Z"
  },
  {
    "videoId": "-6pC6xNU5uk",
    "thumbnail": "https://i.ytimg.com/vi/-6pC6xNU5uk/mqdefault.jpg",
    "title": "【マリオカート8DX】新コースでたって！？いくっきゃねーよな！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-30T06:27:27Z"
  },
  {
    "videoId": "nSDqM_7XaPc",
    "thumbnail": "https://i.ytimg.com/vi/nSDqM_7XaPc/mqdefault.jpg",
    "title": "皆さんに、重大発表があります。【ホロライブ/赤井はあと】",
    "publishedAt": "2022-03-31T15:23:10Z"
  },
  {
    "videoId": "rNWJNgiFtWo",
    "thumbnail": "https://i.ytimg.com/vi/rNWJNgiFtWo/mqdefault.jpg",
    "title": "【Minecraft】大空警察に逮捕されたい・・・！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-03-31T15:35:13Z"
  },
  {
    "videoId": "5p5ClywY1aU",
    "thumbnail": "https://i.ytimg.com/vi/5p5ClywY1aU/mqdefault.jpg",
    "title": "[NEW COSTUME] 新衣装をお披露目しますわ・・・♪【#はあちゃま新衣装 /ホロライブ】",
    "publishedAt": "2022-04-01T13:57:52Z"
  },
  {
    "videoId": "hpkwepHrJPk",
    "thumbnail": "https://i.ytimg.com/vi/hpkwepHrJPk/mqdefault.jpg",
    "title": "【Minecraft】癒しのおやすみマイクラっ！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-04-02T15:14:25Z"
  },
  {
    "videoId": "m8b-HZpu71I",
    "thumbnail": "https://i.ytimg.com/vi/m8b-HZpu71I/mqdefault.jpg",
    "title": "【カメラ配信】レーザー彫刻機でYAGOO焼く！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-04-03T12:34:47Z"
  },
  {
    "videoId": "rraBhhq2VKA",
    "thumbnail": "https://i.ytimg.com/vi/rraBhhq2VKA/mqdefault.jpg",
    "title": "【歌枠】センパイ！おうたでたくさん癒されてね💓【ホロライブ/赤井はあと】",
    "publishedAt": "2022-04-04T15:25:51Z"
  },
  {
    "videoId": "SB6Ogb7FkTM",
    "thumbnail": "https://i.ytimg.com/vi/SB6Ogb7FkTM/mqdefault.jpg",
    "title": "【Minecraft】兎〇・・・逃れられると思うなよ？？？フハハ！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-04-05T14:32:12Z"
  },
  {
    "videoId": "snLYkP92Qos",
    "thumbnail": "https://i.ytimg.com/vi/snLYkP92Qos/mqdefault.jpg",
    "title": "【REDDIT SHITPOST REVIEW】OH YEAH...! BOOM!!!【#HololiveEN0】",
    "publishedAt": "2022-04-09T03:55:57Z"
  },
  {
    "videoId": "xWDCz6A-iRI",
    "thumbnail": "https://i.ytimg.com/vi/xWDCz6A-iRI/mqdefault.jpg",
    "title": "【雑談】ねえ、のどかちゃん。新学期いってきてくれない？？？【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-10T14:13:39Z"
  },
  {
    "videoId": "tXZzaZqs0FQ",
    "thumbnail": "https://i.ytimg.com/vi/tXZzaZqs0FQ/mqdefault.jpg",
    "title": "【歌枠】新学期・・・とっても刺激的でしたわ♪【ホロライブ/赤井はあと】",
    "publishedAt": "2022-04-11T15:14:51Z"
  },
  {
    "videoId": "LZuNXZ-1Y7c",
    "thumbnail": "https://i.ytimg.com/vi/LZuNXZ-1Y7c/mqdefault.jpg",
    "title": "【ホロメン関係性】モテ期！？ついにハーレムを作る時がきた・・・！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-12T15:30:51Z"
  },
  {
    "videoId": "FwreaM76rZg",
    "thumbnail": "https://i.ytimg.com/vi/FwreaM76rZg/mqdefault.jpg",
    "title": "【ホロメン関係性】モテ期！？ついにハーレムを作る時がきた・・・！～後編～【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-13T14:36:49Z"
  },
  {
    "videoId": "Vam389104rc",
    "thumbnail": "https://i.ytimg.com/vi/Vam389104rc/mqdefault.jpg",
    "title": "【RAFT】WE ARE TOGETHER!! FOREVER...【#HoloCHAOS】",
    "publishedAt": "2022-04-14T15:19:17Z"
  },
  {
    "videoId": "OoSwxUMNeKM",
    "thumbnail": "https://i.ytimg.com/vi/OoSwxUMNeKM/mqdefault.jpg",
    "title": "【Minecraft】超極秘!? “ 闇の計画 ” を実行する・・・！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-17T12:55:51Z"
  },
  {
    "videoId": "t25fk8tUPYE",
    "thumbnail": "https://i.ytimg.com/vi/t25fk8tUPYE/mqdefault.jpg",
    "title": "【オフコラボ】リア友凸!? 学校でともだちできた！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-18T13:07:50Z"
  },
  {
    "videoId": "_Hhr3K-Aa2A",
    "thumbnail": "https://i.ytimg.com/vi/_Hhr3K-Aa2A/mqdefault.jpg",
    "title": "【カメラ配信】YAGOO社長に誕プレ作る♪おたおめ〜！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-19T13:00:53Z"
  },
  {
    "videoId": "IOq9Kg_Yo24",
    "thumbnail": "https://i.ytimg.com/vi/IOq9Kg_Yo24/mqdefault.jpg",
    "title": "【晩酌】ぶっちゃけトーク!? 飲みながら色々語る！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-04-23T15:11:44Z"
  },
  {
    "videoId": "F6_dvgLYF2c",
    "thumbnail": "https://i.ytimg.com/vi/F6_dvgLYF2c/mqdefault.jpg",
    "title": "【脱！ダークマター!?】綺麗な飯がつくりたいんだ。【#HAACHAMASUNDAY】",
    "publishedAt": "2022-04-24T11:58:53Z"
  },
  {
    "videoId": "y8dbOECb_2A",
    "thumbnail": "https://i.ytimg.com/vi/y8dbOECb_2A/mqdefault.jpg",
    "title": "【歌枠】大人の色気むんむんで歌いますわよ～♪【ホロライブ/はあちゃま】",
    "publishedAt": "2022-04-25T15:10:40Z"
  },
  {
    "videoId": "MYJfWxMboE0",
    "thumbnail": "https://i.ytimg.com/vi/MYJfWxMboE0/mqdefault.jpg",
    "title": "爆笑!!ホロリス英語大喜利大会！！！🤩【はあちゃま×ルイ姉】",
    "publishedAt": "2022-04-30T13:18:59Z"
  },
  {
    "videoId": "3ZOemmRuSIM",
    "thumbnail": "https://i.ytimg.com/vi/3ZOemmRuSIM/mqdefault.jpg",
    "title": "【GW限定!!】グレちゃま凸待ち！ゴラァ！！！🤜💥🤛【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-03T12:18:32Z"
  },
  {
    "videoId": "tU0FR1uYG0I",
    "thumbnail": "https://i.ytimg.com/vi/tU0FR1uYG0I/mqdefault.jpg",
    "title": "【Nintendo Switch Sports】目指せ！！！オリンピック選手・・・！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-05T16:15:33Z"
  },
  {
    "videoId": "rHZ0hg5XdHs",
    "thumbnail": "https://i.ytimg.com/vi/rHZ0hg5XdHs/mqdefault.jpg",
    "title": "【＃ホロAmongUs】パンピー担当☆ミ【ホロライブ/赤井はあと】",
    "publishedAt": "2022-05-07T14:26:17Z"
  },
  {
    "videoId": "KGp0eAmDDbM",
    "thumbnail": "https://i.ytimg.com/vi/KGp0eAmDDbM/mqdefault.jpg",
    "title": "【歌枠】深夜のすやすや歌💤KARAOKE FOR SLEEP♪【ホロライブ/赤井はあと】",
    "publishedAt": "2022-05-07T17:00:26Z"
  },
  {
    "videoId": "IG4vi6ch1G4",
    "thumbnail": "https://i.ytimg.com/vi/IG4vi6ch1G4/mqdefault.jpg",
    "title": "【VALORANT】First time collab!! #KOBOCHAMA 🌟【#holoID03 / #holoEN0】",
    "publishedAt": "2022-05-08T11:27:03Z"
  },
  {
    "videoId": "tteSdhTxcZY",
    "thumbnail": "https://i.ytimg.com/vi/tteSdhTxcZY/mqdefault.jpg",
    "title": "【太鼓の達人】見よ！これがはあちゃまの実力だっ！！！🔥【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-09T15:30:23Z"
  },
  {
    "videoId": "W90xna2LuRM",
    "thumbnail": "https://i.ytimg.com/vi/W90xna2LuRM/mqdefault.jpg",
    "title": "【#YAGOO新衣装コンテスト】これはやばい・・・【はあちゃま×えーちゃん】",
    "publishedAt": "2022-05-10T13:04:21Z"
  },
  {
    "videoId": "-EoILnAFKl8",
    "thumbnail": "https://i.ytimg.com/vi/-EoILnAFKl8/mqdefault.jpg",
    "title": "【歌枠】絶対に寝かしつける配信。～永眠率99%～【ホロライブ/赤井はあと】",
    "publishedAt": "2022-05-13T16:12:33Z"
  },
  {
    "videoId": "O1TnFlf2CBc",
    "thumbnail": "https://i.ytimg.com/vi/O1TnFlf2CBc/mqdefault.jpg",
    "title": "【VALORANT】ゲリラ！ひさびさにあそぶ！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-15T15:42:49Z"
  },
  {
    "videoId": "sRy13wru-SQ",
    "thumbnail": "https://i.ytimg.com/vi/sRy13wru-SQ/mqdefault.jpg",
    "title": "【Minecraft】か○なたんにドッキリ作戦・・・！？【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-17T12:46:46Z"
  },
  {
    "videoId": "4wqdasP-alk",
    "thumbnail": "https://i.ytimg.com/vi/4wqdasP-alk/mqdefault.jpg",
    "title": "【はあちゃま相談室】みんなの悩みはあちゃまっちゃま～！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-05-21T10:08:35Z"
  },
  {
    "videoId": "fJZBKvkIpNA",
    "thumbnail": "https://i.ytimg.com/vi/fJZBKvkIpNA/mqdefault.jpg",
    "title": "OH HAACHAMA...",
    "publishedAt": "2022-05-21T12:53:16Z"
  },
  {
    "videoId": "79Qw7Kgn7gU",
    "thumbnail": "https://i.ytimg.com/vi/79Qw7Kgn7gU/mqdefault.jpg",
    "title": "【DIY選手権】ガチ勢すぎてやばすぎ・・・！？ #HAACHAMASUNDAY",
    "publishedAt": "2022-05-22T11:33:44Z"
  },
  {
    "videoId": "eRN-kcZEGAY",
    "thumbnail": "https://i.ytimg.com/vi/eRN-kcZEGAY/mqdefault.jpg",
    "title": "【歌枠】ゴラァ！！！懐メロで満足できねえ奴いるぅ？いねえよなぁ！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-23T15:00:39Z"
  },
  {
    "videoId": "g1EcMIwBlvk",
    "thumbnail": "https://i.ytimg.com/vi/g1EcMIwBlvk/mqdefault.jpg",
    "title": "【ドッキリ作戦会議】料理だけで済むと思ったか・・・？w【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-24T10:43:47Z"
  },
  {
    "videoId": "Ech7a8QRVZY",
    "thumbnail": "https://i.ytimg.com/vi/Ech7a8QRVZY/mqdefault.jpg",
    "title": "【たこ焼きリベンジ】失敗は許されねえのら・・・！【#ちゃまなのら /ホロライブ】",
    "publishedAt": "2022-05-24T13:03:32Z"
  },
  {
    "videoId": "GfGGNhlRQ60",
    "thumbnail": "https://i.ytimg.com/vi/GfGGNhlRQ60/mqdefault.jpg",
    "title": "【悲報】はあちゃま、修羅場すぎてやばい・・・！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-25T10:35:34Z"
  },
  {
    "videoId": "lrgy93wsNso",
    "thumbnail": "https://i.ytimg.com/vi/lrgy93wsNso/mqdefault.jpg",
    "title": "【Minecraft】やばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいやばいタスケテ・・・【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-25T14:53:13Z"
  },
  {
    "videoId": "xQJTZTdPvQk",
    "thumbnail": "https://i.ytimg.com/vi/xQJTZTdPvQk/mqdefault.jpg",
    "title": "ホロメンにガチ恋ドッキリ仕掛けてみた・・・！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-26T13:32:10Z"
  },
  {
    "videoId": "c8Nweu_TTnM",
    "thumbnail": "https://i.ytimg.com/vi/c8Nweu_TTnM/mqdefault.jpg",
    "title": "【はあちゃま相談室】恋の悩みはイチコロよっ♪まっかせなさ～い！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-28T11:26:47Z"
  },
  {
    "videoId": "76cf7-DzIUw",
    "thumbnail": "https://i.ytimg.com/vi/76cf7-DzIUw/mqdefault.jpg",
    "title": "【クソザコ絵心選手権】画伯が勢ぞろい・・・？ with かなたん　#HAACHAMASUNDAY",
    "publishedAt": "2022-05-29T10:14:08Z"
  },
  {
    "videoId": "VN7NHYdDAOQ",
    "thumbnail": "https://i.ytimg.com/vi/VN7NHYdDAOQ/mqdefault.jpg",
    "title": "罵倒ドッキリしたらやばい奴しかいなかった・・・【ホロライブ/はあちゃま】",
    "publishedAt": "2022-05-30T14:08:27Z"
  },
  {
    "videoId": "h6b3ggEymo8",
    "thumbnail": "https://i.ytimg.com/vi/h6b3ggEymo8/mqdefault.jpg",
    "title": "【はあちゃま被害者の会】逆凸【ホロライブ/はあちゃま】",
    "publishedAt": "2022-06-01T14:47:04Z"
  },
  {
    "videoId": "7B8TRjqvuUc",
    "thumbnail": "https://i.ytimg.com/vi/7B8TRjqvuUc/mqdefault.jpg",
    "title": "【お知らせ】ほんとうにごめんなさい。【ホロライブ/赤井はあと】",
    "publishedAt": "2022-06-02T12:03:03Z"
  },
  {
    "videoId": "6u1VP5hzyRs",
    "thumbnail": "https://i.ytimg.com/vi/6u1VP5hzyRs/mqdefault.jpg",
    "title": "【4周年記念凸待ち】【ホロライブ/はあちゃま】",
    "publishedAt": "2022-06-02T13:13:13Z"
  },
  {
    "videoId": "RE7rvq3GGH8",
    "thumbnail": "https://i.ytimg.com/vi/RE7rvq3GGH8/mqdefault.jpg",
    "title": "【周年リベンジ】6/7決定！～編集終わるまで耐久配信～【ホロライブ/はあちゃま】",
    "publishedAt": "2022-06-05T08:41:07Z"
  },
  {
    "videoId": "ma6b9V1aAqM",
    "thumbnail": "https://i.ytimg.com/vi/ma6b9V1aAqM/mqdefault.jpg",
    "title": "【クソダサコーデ選手権】この服装・・・やばい、、、with ミオちゃん 【 #HAACHAMASUNDAY 】",
    "publishedAt": "2022-06-05T10:01:14Z"
  },
  {
    "videoId": "qaOYNXxv1Hk",
    "thumbnail": "https://i.ytimg.com/vi/qaOYNXxv1Hk/mqdefault.jpg",
    "title": "【周年リベンジ】6/7決定！～編集終わるまで耐久配信～【ホロライブ/はあちゃま】",
    "publishedAt": "2022-06-05T14:17:15Z"
  },
  {
    "videoId": "92OkhRiUDZk",
    "thumbnail": "https://i.ytimg.com/vi/92OkhRiUDZk/mqdefault.jpg",
    "title": "【#はあねね / 太鼓の達人】打倒ねねち！！！！！！！！！！！！！！！！！！！！！【ホロライブ】",
    "publishedAt": "2022-06-06T13:14:27Z"
  },
  {
    "videoId": "20KL1ITIg5A",
    "thumbnail": "https://i.ytimg.com/vi/20KL1ITIg5A/mqdefault.jpg",
    "title": "【#はあちゃま4周年】最強アイドルになるべく、四天王に挑む・・・！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-06-07T12:00:16Z"
  },
  {
    "videoId": "BRjrG9QR2yU",
    "thumbnail": "https://i.ytimg.com/vi/BRjrG9QR2yU/mqdefault.jpg",
    "title": "【同時視聴枠】ついに・・・！#はあちゃま4周年 がやってきた！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-06-07T13:49:35Z"
  },
  {
    "videoId": "27KBVjVlCwg",
    "thumbnail": "https://i.ytimg.com/vi/27KBVjVlCwg/mqdefault.jpg",
    "title": "【レーザー彫刻機】“はあみっこよ” を焼いて掘る！！【#はあちゃまDIY】",
    "publishedAt": "2022-06-08T12:57:34Z"
  },
  {
    "videoId": "8DsBzGoRrmQ",
    "thumbnail": "https://i.ytimg.com/vi/8DsBzGoRrmQ/mqdefault.jpg",
    "title": "【歌枠】ワクチン接種からの帰還！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-06-12T10:16:42Z"
  },
  {
    "videoId": "UzntVxxD7RI",
    "thumbnail": "https://i.ytimg.com/vi/UzntVxxD7RI/mqdefault.jpg",
    "title": "【晩酌】はじめての #おかちゃま ！いったいどうなる！？【ホロライブ/はあちゃま/猫又おかゆ】",
    "publishedAt": "2022-06-13T14:11:39Z"
  },
  {
    "videoId": "FJGcLWvq2VA",
    "thumbnail": "https://i.ytimg.com/vi/FJGcLWvq2VA/mqdefault.jpg",
    "title": "【料理コンテスト】料理上手な2人が審査！！！with ちょこ先生【 #HAACHAMASUNDAY 】",
    "publishedAt": "2022-06-19T10:11:03Z"
  },
  {
    "videoId": "LSxhMj86jIM",
    "thumbnail": "https://i.ytimg.com/vi/LSxhMj86jIM/mqdefault.jpg",
    "title": "【DDLC】はあちゃま、ドキドキ文芸部はいる！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-06-20T14:27:47Z"
  },
  {
    "videoId": "QgKvy6fU_Ng",
    "thumbnail": "https://i.ytimg.com/vi/QgKvy6fU_Ng/mqdefault.jpg",
    "title": "【#1】新企画！ハリー・ポッター建築、略して「ちゃまポタ」始動！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-07-04T14:41:47Z"
  },
  {
    "videoId": "8vyyfd9pL-8",
    "thumbnail": "https://i.ytimg.com/vi/8vyyfd9pL-8/mqdefault.jpg",
    "title": "やだやだやだ！助けて！変なおじさんからDMが・・・【おじさんと遊ぼう】",
    "publishedAt": "2022-07-05T11:30:50Z"
  },
  {
    "videoId": "ICxqsVPuXg0",
    "thumbnail": "https://i.ytimg.com/vi/ICxqsVPuXg0/mqdefault.jpg",
    "title": "【深夜の】がちあまあま【はあと様】",
    "publishedAt": "2022-07-08T17:22:00Z"
  },
  {
    "videoId": "0qbpFeRdqjg",
    "thumbnail": "https://i.ytimg.com/vi/0qbpFeRdqjg/mqdefault.jpg",
    "title": "【アンカー・赤井はあと】1期生Live2Dver3.0お披露目リレー【ホロライブ/hololive】",
    "publishedAt": "2022-07-09T12:26:49Z"
  },
  {
    "videoId": "dHLdgYCW5Yg",
    "thumbnail": "https://i.ytimg.com/vi/dHLdgYCW5Yg/mqdefault.jpg",
    "title": "【運試し】いざ！はあちゃまヨット大会開催！🎉【ホロライブ/はあちゃま】",
    "publishedAt": "2022-07-11T13:27:25Z"
  },
  {
    "videoId": "A3PYzHuWxhc",
    "thumbnail": "https://i.ytimg.com/vi/A3PYzHuWxhc/mqdefault.jpg",
    "title": "【#2】チャマポタ！ホグワーツのドデカ橋作る！【Minecraft】【ホロライブ/赤井はあと】",
    "publishedAt": "2022-07-12T12:26:12Z"
  },
  {
    "videoId": "j7cX8nvgsN0",
    "thumbnail": "https://i.ytimg.com/vi/j7cX8nvgsN0/mqdefault.jpg",
    "title": "寝起きデスマッチャレンジ！【VALORANT】",
    "publishedAt": "2022-07-12T22:30:05Z"
  },
  {
    "videoId": "GHmDJa3VNNM",
    "thumbnail": "https://i.ytimg.com/vi/GHmDJa3VNNM/mqdefault.jpg",
    "title": "【TETRIS99】わからせる、おらおら【ホロライブ/はあちゃま】",
    "publishedAt": "2022-07-14T12:42:30Z"
  },
  {
    "videoId": "vBuvFRmxzcg",
    "thumbnail": "https://i.ytimg.com/vi/vBuvFRmxzcg/mqdefault.jpg",
    "title": "【 Ring Fit Adventure 】脱でぶちゃま！運動不足！モテボディ～！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-07-18T11:21:04Z"
  },
  {
    "videoId": "J7cujm3868M",
    "thumbnail": "https://i.ytimg.com/vi/J7cujm3868M/mqdefault.jpg",
    "title": "【 晩酌 】卒業ギリギリだが飲んで忘れよう。【まだ舞える】",
    "publishedAt": "2022-07-25T15:17:50Z"
  },
  {
    "videoId": "K4kGWbLkhBs",
    "thumbnail": "https://i.ytimg.com/vi/K4kGWbLkhBs/mqdefault.jpg",
    "title": "【 激辛 】おいおい、完食できない訳ないだろ～？🔥【 チャレンジ 】",
    "publishedAt": "2022-07-27T12:08:39Z"
  },
  {
    "videoId": "MqQSWd5dv_4",
    "thumbnail": "https://i.ytimg.com/vi/MqQSWd5dv_4/mqdefault.jpg",
    "title": "誕生日なので生きたエビを食す！🦐【 #HAACHAMACOOKING 】",
    "publishedAt": "2022-08-10T13:13:20Z"
  },
  {
    "videoId": "AzLJgvMhwF4",
    "thumbnail": "https://i.ytimg.com/vi/AzLJgvMhwF4/mqdefault.jpg",
    "title": "【アニメ】史上最恐のギャルゲつくった！ｗｗｗ【#ちゃまパラ】",
    "publishedAt": "2022-08-11T06:00:12Z"
  },
  {
    "videoId": "NKWTg2WKvLY",
    "thumbnail": "https://i.ytimg.com/vi/NKWTg2WKvLY/mqdefault.jpg",
    "title": "ダークマター料理、卒業します。【はあちゃまクッキング・改】",
    "publishedAt": "2022-08-12T10:00:47Z"
  },
  {
    "videoId": "l1T_rBw3few",
    "thumbnail": "https://i.ytimg.com/vi/l1T_rBw3few/mqdefault.jpg",
    "title": "【 健全 】ぐるぐるソーセージを焼いて食うだけ【ホロライブ/はあちゃま】",
    "publishedAt": "2022-08-13T08:35:22Z"
  },
  {
    "videoId": "hEx1NJeyJsU",
    "thumbnail": "https://i.ytimg.com/vi/hEx1NJeyJsU/mqdefault.jpg",
    "title": "【 ぼっち旅 】単位落として傷心旅行【ホロライブ/はあちゃま】",
    "publishedAt": "2022-08-14T07:01:39Z"
  },
  {
    "videoId": "PNe3lhd41FY",
    "thumbnail": "https://i.ytimg.com/vi/PNe3lhd41FY/mqdefault.jpg",
    "title": "【 ぼっち旅 】カップルだらけで精神崩壊！？【 in 江ノ島】",
    "publishedAt": "2022-08-16T14:33:16Z"
  },
  {
    "videoId": "wOomRxacoQ0",
    "thumbnail": "https://i.ytimg.com/vi/wOomRxacoQ0/mqdefault.jpg",
    "title": "粉ぶっかけて、最高級カレー作った！#2【はあちゃまクッキング・改】",
    "publishedAt": "2022-08-19T05:42:30Z"
  },
  {
    "videoId": "2tn4ZKsZ8mM",
    "thumbnail": "https://i.ytimg.com/vi/2tn4ZKsZ8mM/mqdefault.jpg",
    "title": "【睡眠導入】はあとちゃんの歌枠♪",
    "publishedAt": "2022-08-19T14:44:14Z"
  },
  {
    "videoId": "ok3_-0hOSNs",
    "thumbnail": "https://i.ytimg.com/vi/ok3_-0hOSNs/mqdefault.jpg",
    "title": "【 ダイエット 】ぶるぶるして脂肪撲滅する！ with ラプラス【1日目】",
    "publishedAt": "2022-08-24T09:48:47Z"
  },
  {
    "videoId": "u2hHMYql6Bs",
    "thumbnail": "https://i.ytimg.com/vi/u2hHMYql6Bs/mqdefault.jpg",
    "title": "【 ダイエット 】昼食に！色んなゲテモノ食べ比べ！【2日目】",
    "publishedAt": "2022-08-25T09:41:07Z"
  },
  {
    "videoId": "dkeKvo4OBwY",
    "thumbnail": "https://i.ytimg.com/vi/dkeKvo4OBwY/mqdefault.jpg",
    "title": "【#ちゃまたんなのら】負けたら腹筋マリカ？余裕だなぁ！！！【はあちゃま/ホロライブ】",
    "publishedAt": "2022-08-25T11:08:11Z"
  },
  {
    "videoId": "R_z7gpC9wO8",
    "thumbnail": "https://i.ytimg.com/vi/R_z7gpC9wO8/mqdefault.jpg",
    "title": "インドのみんな、これがカレーだ。~最終回~【はあちゃまクッキング・改】",
    "publishedAt": "2022-08-26T10:00:14Z"
  },
  {
    "videoId": "nR6JdmHYWoc",
    "thumbnail": "https://i.ytimg.com/vi/nR6JdmHYWoc/mqdefault.jpg",
    "title": "【Minecraft】夏祭りステージリレー！はあちゃま建設やんぞごらぁ～！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-08-27T07:03:08Z"
  },
  {
    "videoId": "gztxNY0__Is",
    "thumbnail": "https://i.ytimg.com/vi/gztxNY0__Is/mqdefault.jpg",
    "title": "【 ASMR 】海ぶどうを食べる深夜24時【sea grapes】",
    "publishedAt": "2022-08-28T15:59:11Z"
  },
  {
    "videoId": "pd6r1mzl_ho",
    "thumbnail": "https://i.ytimg.com/vi/pd6r1mzl_ho/mqdefault.jpg",
    "title": "【#ホロ鯖夏祭り】滑り込みセーフで参加！！！！！！🔥【はあちゃま/ホロライブ】",
    "publishedAt": "2022-08-29T16:11:01Z"
  },
  {
    "videoId": "eFeMey3zcz0",
    "thumbnail": "https://i.ytimg.com/vi/eFeMey3zcz0/mqdefault.jpg",
    "title": "【 メシマズ卒業式 】ご卒業おめでとうございます。【はあちゃまクッキング同時視聴/ホロライブ】",
    "publishedAt": "2022-08-30T15:29:35Z"
  },
  {
    "videoId": "P5F2aMhyO9A",
    "thumbnail": "https://i.ytimg.com/vi/P5F2aMhyO9A/mqdefault.jpg",
    "title": "【アニメ】ホラー展開になるギャルゲが怖すぎｗ【#ちゃまパラ】",
    "publishedAt": "2022-09-01T11:01:35Z"
  },
  {
    "videoId": "lBjRltNv0jc",
    "thumbnail": "https://i.ytimg.com/vi/lBjRltNv0jc/mqdefault.jpg",
    "title": "【 ぼっち旅 】夏休みに夢の国へ・・・【ホロライブ/はあちゃま】",
    "publishedAt": "2022-09-01T15:32:11Z"
  },
  {
    "videoId": "efyWLmMxRW0",
    "thumbnail": "https://i.ytimg.com/vi/efyWLmMxRW0/mqdefault.jpg",
    "title": "【第一話】フォークとスプーン作った！【はあちゃまDIY】",
    "publishedAt": "2022-09-02T10:00:12Z"
  },
  {
    "videoId": "BFxH0FBUMTs",
    "thumbnail": "https://i.ytimg.com/vi/BFxH0FBUMTs/mqdefault.jpg",
    "title": "【#3】ホグワーツ編！つくっちゃうよ～ん♪【Minecraft】【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-03T11:02:10Z"
  },
  {
    "videoId": "5Kkgw1yCihk",
    "thumbnail": "https://i.ytimg.com/vi/5Kkgw1yCihk/mqdefault.jpg",
    "title": "【 朝活 】今日こそは早起きするんだっ！いざ！！！【ホロライブ/はあちゃま】",
    "publishedAt": "2022-09-03T23:06:54Z"
  },
  {
    "videoId": "Lz8EZnolhd8",
    "thumbnail": "https://i.ytimg.com/vi/Lz8EZnolhd8/mqdefault.jpg",
    "title": "【#4】ホグワーツ編！まもなく門完成だ～～～！✨【Minecraft】【ホロライブ/はあちゃま】",
    "publishedAt": "2022-09-04T09:49:16Z"
  },
  {
    "videoId": "aefNLRojRA4",
    "thumbnail": "https://i.ytimg.com/vi/aefNLRojRA4/mqdefault.jpg",
    "title": "【 ASMR 】地球グミを食べる🌎 もぐもぐ【咀嚼音 EATING SOUND】【PLANET GUMMY】",
    "publishedAt": "2022-09-05T13:05:28Z"
  },
  {
    "videoId": "Dg3WK2XYGNw",
    "thumbnail": "https://i.ytimg.com/vi/Dg3WK2XYGNw/mqdefault.jpg",
    "title": "【#5】ホグワーツ編！人口の「崖」作っちゃお！【Minecraft】【ホロライブ/はあちゃま】",
    "publishedAt": "2022-09-06T12:11:01Z"
  },
  {
    "videoId": "SV_hquamt7g",
    "thumbnail": "https://i.ytimg.com/vi/SV_hquamt7g/mqdefault.jpg",
    "title": "【#6】ホグワーツ編！果てしなく続く崖・・・【Minecraft】【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-07T09:47:04Z"
  },
  {
    "videoId": "HwiA1Y95fG8",
    "thumbnail": "https://i.ytimg.com/vi/HwiA1Y95fG8/mqdefault.jpg",
    "title": "【 朝活 】ぜったいに遅刻できない！！！後期からがんばる【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-07T22:36:57Z"
  },
  {
    "videoId": "LUwoGPvdQ3Y",
    "thumbnail": "https://i.ytimg.com/vi/LUwoGPvdQ3Y/mqdefault.jpg",
    "title": "【 朝活 】おしゃべりしたいことたくさん！おきるだ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-08T22:36:49Z"
  },
  {
    "videoId": "W-LGfgH7sKA",
    "thumbnail": "https://i.ytimg.com/vi/W-LGfgH7sKA/mqdefault.jpg",
    "title": "友人P登場！？冷やし中華、はじめました ~第1話~【はあちゃまクッキング・改】",
    "publishedAt": "2022-09-09T06:00:12Z"
  },
  {
    "videoId": "MWSX27glrec",
    "thumbnail": "https://i.ytimg.com/vi/MWSX27glrec/mqdefault.jpg",
    "title": "【HoloCure】新キャラ登場！？はあちゃまはゼロからはじめる～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-10T10:42:46Z"
  },
  {
    "videoId": "BQ1pR9AOJWQ",
    "thumbnail": "https://i.ytimg.com/vi/BQ1pR9AOJWQ/mqdefault.jpg",
    "title": "【HoloCure】新キャラ 欲しい！！今日こそはクリアするよ〜〜〜ん！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-11T10:44:20Z"
  },
  {
    "videoId": "br6DmVlGF08",
    "thumbnail": "https://i.ytimg.com/vi/br6DmVlGF08/mqdefault.jpg",
    "title": "【 RUST 】Season３参戦！右も左もわからないはあちゃま生き残れる！？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-12T13:26:29Z"
  },
  {
    "videoId": "KpgnAUkt0VI",
    "thumbnail": "https://i.ytimg.com/vi/KpgnAUkt0VI/mqdefault.jpg",
    "title": "【 歌枠 】みんなで140万人見届けた〜い！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-13T10:31:46Z"
  },
  {
    "videoId": "ncAJU4k4V04",
    "thumbnail": "https://i.ytimg.com/vi/ncAJU4k4V04/mqdefault.jpg",
    "title": "【アニメ】プールで人工呼吸するはずが・・・【#ちゃまパラ】",
    "publishedAt": "2022-09-13T23:23:07Z"
  },
  {
    "videoId": "IeRcN7nQmF4",
    "thumbnail": "https://i.ytimg.com/vi/IeRcN7nQmF4/mqdefault.jpg",
    "title": "【#7】ホグワーツ編！立派な城になってきた！？✨【 Minecraft 】【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-14T09:01:26Z"
  },
  {
    "videoId": "YvkeA0IKgNQ",
    "thumbnail": "https://i.ytimg.com/vi/YvkeA0IKgNQ/mqdefault.jpg",
    "title": "【 RUST 】こよりのペットになった！銃かもん！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-15T07:49:51Z"
  },
  {
    "videoId": "hVz62am6AaI",
    "thumbnail": "https://i.ytimg.com/vi/hVz62am6AaI/mqdefault.jpg",
    "title": "【 VALORANT 】戦って目覚めよ！！！！！！🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-15T22:22:42Z"
  },
  {
    "videoId": "YMnpmGnXluE",
    "thumbnail": "https://i.ytimg.com/vi/YMnpmGnXluE/mqdefault.jpg",
    "title": "【 スプラトゥーン３ 】初心者だけど全力で楽しむぞおおお！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-17T10:29:07Z"
  },
  {
    "videoId": "_DfKn4HAfw4",
    "thumbnail": "https://i.ytimg.com/vi/_DfKn4HAfw4/mqdefault.jpg",
    "title": "【 RUST 】みこちの闘技場でバイト生活！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-18T10:18:08Z"
  },
  {
    "videoId": "ARVpfe_aEvE",
    "thumbnail": "https://i.ytimg.com/vi/ARVpfe_aEvE/mqdefault.jpg",
    "title": "【hololive ERROR】ついにやるぞー！まあ、よゆ～よゆ～！！！【ホロライブ /赤井はあと】",
    "publishedAt": "2022-09-20T11:59:16Z"
  },
  {
    "videoId": "lZ6PnoI5xy4",
    "thumbnail": "https://i.ytimg.com/vi/lZ6PnoI5xy4/mqdefault.jpg",
    "title": "【 RUST 】GET SOME Holomen MEATTT!!! #Hololive0 #englishstream",
    "publishedAt": "2022-09-21T09:23:01Z"
  },
  {
    "videoId": "BdPT8IiPQ0k",
    "thumbnail": "https://i.ytimg.com/vi/BdPT8IiPQ0k/mqdefault.jpg",
    "title": "【#ぽるちゃま】最強コンビ爆誕！？タイマンコラボだ！！【ホロライブ/尾丸ポルカ/赤井はあと】",
    "publishedAt": "2022-09-21T11:19:32Z"
  },
  {
    "videoId": "bcy-c4Eyapg",
    "thumbnail": "https://i.ytimg.com/vi/bcy-c4Eyapg/mqdefault.jpg",
    "title": "【#8】ホグワーツ編！城をつくらねば始まらん！【Minecraft】【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-22T07:46:00Z"
  },
  {
    "videoId": "GmVvVND_czs",
    "thumbnail": "https://i.ytimg.com/vi/GmVvVND_czs/mqdefault.jpg",
    "title": "【 RUST 】旅に出る、探さないでください―――。【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-22T23:00:21Z"
  },
  {
    "videoId": "QtE-ZoVq8Vs",
    "thumbnail": "https://i.ytimg.com/vi/QtE-ZoVq8Vs/mqdefault.jpg",
    "title": "食える飯が作りたい。~第2話~【はあちゃまクッキング・改】",
    "publishedAt": "2022-09-23T06:00:13Z"
  },
  {
    "videoId": "IxQ7Nyztatc",
    "thumbnail": "https://i.ytimg.com/vi/IxQ7Nyztatc/mqdefault.jpg",
    "title": "【Holocure】みこだにぇに勝って、HARDモードいきたい！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-25T07:30:40Z"
  },
  {
    "videoId": "Np1dvGEiEGI",
    "thumbnail": "https://i.ytimg.com/vi/Np1dvGEiEGI/mqdefault.jpg",
    "title": "【Holocure】HARDモード！ぜったいクリアしたい！！！🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-27T11:25:24Z"
  },
  {
    "videoId": "4H3YpRFt6RY",
    "thumbnail": "https://i.ytimg.com/vi/4H3YpRFt6RY/mqdefault.jpg",
    "title": "【RUST】WHERE AM I GOING??? #Hololive0 #englishstream",
    "publishedAt": "2022-09-28T06:41:44Z"
  },
  {
    "videoId": "tkKsn4RTdpU",
    "thumbnail": "https://i.ytimg.com/vi/tkKsn4RTdpU/mqdefault.jpg",
    "title": "【#ちゃまたんなのら】ウチらの絆なら、脱出よゆ〜！「Quest Rooms」やる！【ホロライブ/天音かなた/姫森ルーナ/赤井はあと】",
    "publishedAt": "2022-09-28T11:43:32Z"
  },
  {
    "videoId": "gxLZCOtQ7Ts",
    "thumbnail": "https://i.ytimg.com/vi/gxLZCOtQ7Ts/mqdefault.jpg",
    "title": "【朝ちゃま】全人類！起きるのだ！はあちゃまにひれ伏せ！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-28T22:35:00Z"
  },
  {
    "videoId": "i3FInuOHvIc",
    "thumbnail": "https://i.ytimg.com/vi/i3FInuOHvIc/mqdefault.jpg",
    "title": "【#9】ホグワーツ編！でっかい城をつくるどおおお！🏰【Minecraft】【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-29T08:14:33Z"
  },
  {
    "videoId": "0rH0UHHS1Ic",
    "thumbnail": "https://i.ytimg.com/vi/0rH0UHHS1Ic/mqdefault.jpg",
    "title": "【#10】ホグワーツ編！まったり大広間を作り！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-30T09:41:43Z"
  },
  {
    "videoId": "tmF6DN5XBIM",
    "thumbnail": "https://i.ytimg.com/vi/tmF6DN5XBIM/mqdefault.jpg",
    "title": "【 しょぼんのるきみん！ 】ふっ、こんなチンチクリンに負けるわけ、、、ぎゃあ’’あ’’あ’’ぁ’’ぁ’’ぁ’’ぁ’’ぁ’’ぁ’’た’’す’’け’’て’’【ホロライブ/赤井はあと】",
    "publishedAt": "2022-09-30T23:12:03Z"
  },
  {
    "videoId": "dsnrYDDy3yc",
    "thumbnail": "https://i.ytimg.com/vi/dsnrYDDy3yc/mqdefault.jpg",
    "title": "【地獄銭湯】よーし！平泳ぎの練習するぞ〜〜〜！ぷかぷか【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-03T13:05:03Z"
  },
  {
    "videoId": "YHsKnajBKHk",
    "thumbnail": "https://i.ytimg.com/vi/YHsKnajBKHk/mqdefault.jpg",
    "title": "【歌枠】アニソン！虫歯の激痛やばめ！がんばる！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-04T10:09:03Z"
  },
  {
    "videoId": "jq6nOPScwus",
    "thumbnail": "https://i.ytimg.com/vi/jq6nOPScwus/mqdefault.jpg",
    "title": "【FALL GUYS】OI, MATE! Let's play with me~~~!!! #HololiveEN0 #Haachamaenglish",
    "publishedAt": "2022-10-05T06:22:55Z"
  },
  {
    "videoId": "JG5Ucp1HpDk",
    "thumbnail": "https://i.ytimg.com/vi/JG5Ucp1HpDk/mqdefault.jpg",
    "title": "【地獄銭湯】逃げちゃだめ、逃げちゃだめだこわいいい・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-05T09:07:01Z"
  },
  {
    "videoId": "G07p30vzxTE",
    "thumbnail": "https://i.ytimg.com/vi/G07p30vzxTE/mqdefault.jpg",
    "title": "【RUST】あばよSeason3！暴れまくるぜ！！！！！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-06T14:57:23Z"
  },
  {
    "videoId": "AdperKGOWFc",
    "thumbnail": "https://i.ytimg.com/vi/AdperKGOWFc/mqdefault.jpg",
    "title": "【Minecraft】緊急事態！虫歯で顔ぱんぱん！だが建築はする！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-11T07:15:09Z"
  },
  {
    "videoId": "FD4F6m2g8z0",
    "thumbnail": "https://i.ytimg.com/vi/FD4F6m2g8z0/mqdefault.jpg",
    "title": "【EN/FREE TALK】ENGLISH MUZUKASHI OMG!! ；；",
    "publishedAt": "2022-10-12T05:09:47Z"
  },
  {
    "videoId": "P4Bce9W-gtU",
    "thumbnail": "https://i.ytimg.com/vi/P4Bce9W-gtU/mqdefault.jpg",
    "title": "【Minecraft】ホグワーツ再現！？建築やっていくぞおおお！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-12T09:21:49Z"
  },
  {
    "videoId": "P2qXZsxOgP0",
    "thumbnail": "https://i.ytimg.com/vi/P2qXZsxOgP0/mqdefault.jpg",
    "title": "【Slither.io】WORLD TOP1 IDOL! LET'S GO!!!",
    "publishedAt": "2022-10-13T06:02:34Z"
  },
  {
    "videoId": "Jhip26JOFcY",
    "thumbnail": "https://i.ytimg.com/vi/Jhip26JOFcY/mqdefault.jpg",
    "title": "【Minecraft】全力！前進！だだだだ！けんちくだああああ〜〜〜♪【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-13T10:32:44Z"
  },
  {
    "videoId": "qAKOqwQs_vw",
    "thumbnail": "https://i.ytimg.com/vi/qAKOqwQs_vw/mqdefault.jpg",
    "title": "【RUST】シーズン4！いざ！参戦するぞ〜〜〜！#ホロ鯖rust 【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-17T13:13:28Z"
  },
  {
    "videoId": "wfJCVWoSWQM",
    "thumbnail": "https://i.ytimg.com/vi/wfJCVWoSWQM/mqdefault.jpg",
    "title": "【火夜歌枠】第一回！ちゃまちゃま★れぼりゅ〜しょん！ボカロ多め！#1【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-18T11:07:24Z"
  },
  {
    "videoId": "ONnTH70z8Gk",
    "thumbnail": "https://i.ytimg.com/vi/ONnTH70z8Gk/mqdefault.jpg",
    "title": "【Minecraft】ちゃまポタ！ホグワーツ城の大広間作る〜！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-19T12:48:48Z"
  },
  {
    "videoId": "s8EYwm7pHGk",
    "thumbnail": "https://i.ytimg.com/vi/s8EYwm7pHGk/mqdefault.jpg",
    "title": "【Minecraft】ちゃまポタ！大広間完成させるまでやる！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-20T07:14:28Z"
  },
  {
    "videoId": "VTpBrO77a8E",
    "thumbnail": "https://i.ytimg.com/vi/VTpBrO77a8E/mqdefault.jpg",
    "title": "みこちにうまい飯、食わせたい ~最終回~【はあちゃまクッキング・改】",
    "publishedAt": "2022-10-21T03:00:12Z"
  },
  {
    "videoId": "GSrUqO_3QLA",
    "thumbnail": "https://i.ytimg.com/vi/GSrUqO_3QLA/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪#2【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-23T01:33:57Z"
  },
  {
    "videoId": "gg_VmHB-A2c",
    "thumbnail": "https://i.ytimg.com/vi/gg_VmHB-A2c/mqdefault.jpg",
    "title": "【Minecraft】大広間かんせいはできるのか～～～！？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-23T07:04:40Z"
  },
  {
    "videoId": "V7FfH-4zsdE",
    "thumbnail": "https://i.ytimg.com/vi/V7FfH-4zsdE/mqdefault.jpg",
    "title": "【反省会】こより宣戦布告！？〜冷やし中華を経て〜【はあちゃまクッキング同時視聴/ホロライブ】",
    "publishedAt": "2022-10-25T13:04:45Z"
  },
  {
    "videoId": "n0DQs4YRWZc",
    "thumbnail": "https://i.ytimg.com/vi/n0DQs4YRWZc/mqdefault.jpg",
    "title": "【Minecraft】大広間ラストスパート！完成見届けてね！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-26T07:08:56Z"
  },
  {
    "videoId": "BJoL9Ad3vho",
    "thumbnail": "https://i.ytimg.com/vi/BJoL9Ad3vho/mqdefault.jpg",
    "title": "【COLLAB】Clubhouse 51 with Baelz~~~! #hololivecouncil #HoloEN0",
    "publishedAt": "2022-10-26T11:13:12Z"
  },
  {
    "videoId": "8aLbVCHDmQs",
    "thumbnail": "https://i.ytimg.com/vi/8aLbVCHDmQs/mqdefault.jpg",
    "title": "【#はあとなニュース 】病み上がりからのほっこりニュースお届け♪#3【ホロライブ/赤井はあと】",
    "publishedAt": "2022-10-30T01:34:40Z"
  },
  {
    "videoId": "Kt96gprvq7M",
    "thumbnail": "https://i.ytimg.com/vi/Kt96gprvq7M/mqdefault.jpg",
    "title": "HELP..........MEEEEEEEE!!!!! Escaping from horror game #holoen0",
    "publishedAt": "2022-11-02T05:19:58Z"
  },
  {
    "videoId": "zSsnOR1wKrQ",
    "thumbnail": "https://i.ytimg.com/vi/zSsnOR1wKrQ/mqdefault.jpg",
    "title": "【Minecraft】今日こそは！大広間を完成させるんだ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-02T10:03:38Z"
  },
  {
    "videoId": "8l8rE0ss1W0",
    "thumbnail": "https://i.ytimg.com/vi/8l8rE0ss1W0/mqdefault.jpg",
    "title": "【Minecraft】今日はまったり癒しな感じ〜！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-03T07:25:53Z"
  },
  {
    "videoId": "FDOG7X8I2M4",
    "thumbnail": "https://i.ytimg.com/vi/FDOG7X8I2M4/mqdefault.jpg",
    "title": "【#はあとなニュース 】運動会前のほっこりニュースお届け♪ #4 【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-06T01:36:38Z"
  },
  {
    "videoId": "ysMWS0jqiE0",
    "thumbnail": "https://i.ytimg.com/vi/ysMWS0jqiE0/mqdefault.jpg",
    "title": "【 月末雑談 】祝48kgの10月！おめでとうの会！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-07T12:33:02Z"
  },
  {
    "videoId": "7BxeUzWJkwA",
    "thumbnail": "https://i.ytimg.com/vi/7BxeUzWJkwA/mqdefault.jpg",
    "title": "【火夜歌枠】すーぱーぴちぴち！最強アイドルの歌きいて〜〜〜！#2【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-08T11:13:50Z"
  },
  {
    "videoId": "r23XnW3wb1I",
    "thumbnail": "https://i.ytimg.com/vi/r23XnW3wb1I/mqdefault.jpg",
    "title": "【Minecraft】メンタルパッションで作る大型建築！だい！ #20【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-09T09:10:56Z"
  },
  {
    "videoId": "AN93FtItVEY",
    "thumbnail": "https://i.ytimg.com/vi/AN93FtItVEY/mqdefault.jpg",
    "title": "【#はあとなニュース】日朝からほっこりニュースをお届け♪#5【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-13T01:38:04Z"
  },
  {
    "videoId": "aBASPF9VOA4",
    "thumbnail": "https://i.ytimg.com/vi/aBASPF9VOA4/mqdefault.jpg",
    "title": "【反省会】問題作！？いやいや名作ですが？？？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-14T12:56:21Z"
  },
  {
    "videoId": "1TYx38CSGsc",
    "thumbnail": "https://i.ytimg.com/vi/1TYx38CSGsc/mqdefault.jpg",
    "title": "【火夜歌枠】はあちゃまの歌にヒヨってる奴いる〜〜〜？#3 【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-15T11:16:33Z"
  },
  {
    "videoId": "i6oVDVNnMVo",
    "thumbnail": "https://i.ytimg.com/vi/i6oVDVNnMVo/mqdefault.jpg",
    "title": "【Minecraft】酔い止め対策ばっちり！いけいけ！どんどん！！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-16T06:40:48Z"
  },
  {
    "videoId": "Dv5bNXQzivM",
    "thumbnail": "https://i.ytimg.com/vi/Dv5bNXQzivM/mqdefault.jpg",
    "title": "【The Backrooms: 1998】Be quiet..... #Baechama #hololiveenglish",
    "publishedAt": "2022-11-16T11:12:04Z"
  },
  {
    "videoId": "4yj6Cj7Hg8E",
    "thumbnail": "https://i.ytimg.com/vi/4yj6Cj7Hg8E/mqdefault.jpg",
    "title": "【晩酌】大人の階段のぼる〜ちゃまはまだシンデレラさ〜【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-21T12:49:02Z"
  },
  {
    "videoId": "Hh09jB3eOkw",
    "thumbnail": "https://i.ytimg.com/vi/Hh09jB3eOkw/mqdefault.jpg",
    "title": "【火夜歌枠】ちょっとセンチメンタルな秋🍁#4【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-22T11:37:03Z"
  },
  {
    "videoId": "A5Fq3tW2Yhw",
    "thumbnail": "https://i.ytimg.com/vi/A5Fq3tW2Yhw/mqdefault.jpg",
    "title": "[ 51 club house ] Witch one is strong!? LET'S FIGHT!!! #KOBOCHAMA【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-23T12:56:33Z"
  },
  {
    "videoId": "KuAU_7cHV6M",
    "thumbnail": "https://i.ytimg.com/vi/KuAU_7cHV6M/mqdefault.jpg",
    "title": "【 #ホロライブ運動会2022 】めざせ優勝！ソロはあちゃま！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-24T12:31:38Z"
  },
  {
    "videoId": "kfvXxUX_NXk",
    "thumbnail": "https://i.ytimg.com/vi/kfvXxUX_NXk/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪#6【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-27T01:42:44Z"
  },
  {
    "videoId": "jWDw_zOBnBY",
    "thumbnail": "https://i.ytimg.com/vi/jWDw_zOBnBY/mqdefault.jpg",
    "title": "【 月末雑談 】おい、11月。もうそろ終わるってマ？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-28T13:35:50Z"
  },
  {
    "videoId": "_bTfp8Xi-XM",
    "thumbnail": "https://i.ytimg.com/vi/_bTfp8Xi-XM/mqdefault.jpg",
    "title": "【火夜歌枠】ばぶちゃまのお遊戯会だぞ！🍼 #5【ホロライブ/赤井はあと】",
    "publishedAt": "2022-11-29T11:19:35Z"
  },
  {
    "videoId": "DuiDlgztRZ0",
    "thumbnail": "https://i.ytimg.com/vi/DuiDlgztRZ0/mqdefault.jpg",
    "title": "【 Bus Simulator 21 】STRONGEST BUS DRIVER!! 🚌💨 【HAACHAMA EN WED】#HaachamaEnglish #holoen0",
    "publishedAt": "2022-11-30T07:40:11Z"
  },
  {
    "videoId": "o4FS8dPXlL8",
    "thumbnail": "https://i.ytimg.com/vi/o4FS8dPXlL8/mqdefault.jpg",
    "title": "【 Minecraft 】ホグワーツ編！2022年、最後までがんばるぞ～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-01T07:39:37Z"
  },
  {
    "videoId": "6wByOOSmPP0",
    "thumbnail": "https://i.ytimg.com/vi/6wByOOSmPP0/mqdefault.jpg",
    "title": "【#はあとなニュース】日朝からほっこりニュースをお届け♪#7【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-04T01:53:01Z"
  },
  {
    "videoId": "RWOZ3hQU6GI",
    "thumbnail": "https://i.ytimg.com/vi/RWOZ3hQU6GI/mqdefault.jpg",
    "title": "【 Minecraft 】ホグワーツ編！私、絶対完成させるのでっ！#23【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-04T06:21:24Z"
  },
  {
    "videoId": "xlTuHprHK1c",
    "thumbnail": "https://i.ytimg.com/vi/xlTuHprHK1c/mqdefault.jpg",
    "title": "【2020➡︎2022】2年間で歌の成長、できたかな・・・？【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-05T13:08:24Z"
  },
  {
    "videoId": "RRnNWQENN5M",
    "thumbnail": "https://i.ytimg.com/vi/RRnNWQENN5M/mqdefault.jpg",
    "title": "【 火夜歌枠 】色気たっぷりな和風曲はいかが？👘#6【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-06T11:14:33Z"
  },
  {
    "videoId": "bo3OjavDbn0",
    "thumbnail": "https://i.ytimg.com/vi/bo3OjavDbn0/mqdefault.jpg",
    "title": "【HoloDive】I'M BLACK HOOOOLE!!!!!! 【#HaachamaEnglish #HoloEN0】",
    "publishedAt": "2022-12-07T05:27:19Z"
  },
  {
    "videoId": "ga1rUeCifIY",
    "thumbnail": "https://i.ytimg.com/vi/ga1rUeCifIY/mqdefault.jpg",
    "title": "【#ちゃまたんなのら】ほろ酔い🍷飲んで騒いで大暴れ！【マリオパーティスーパースターズ】",
    "publishedAt": "2022-12-07T13:37:26Z"
  },
  {
    "videoId": "B_mRZ_Hewj0",
    "thumbnail": "https://i.ytimg.com/vi/B_mRZ_Hewj0/mqdefault.jpg",
    "title": "過去一絶望的な餃子ができた・・・ ~第1話~【はあちゃまクッキング・改】",
    "publishedAt": "2022-12-09T06:00:06Z"
  },
  {
    "videoId": "0gSYWxDYmFY",
    "thumbnail": "https://i.ytimg.com/vi/0gSYWxDYmFY/mqdefault.jpg",
    "title": "【#ちゃまポタ】-Hogwarts in Minecraft- 安眠！絶対に寝るおやすみマイクラ〜💤  #24【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-10T10:04:59Z"
  },
  {
    "videoId": "Pd0xXBok-Gc",
    "thumbnail": "https://i.ytimg.com/vi/Pd0xXBok-Gc/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪#8【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-11T01:46:16Z"
  },
  {
    "videoId": "rkQ0VXOCf58",
    "thumbnail": "https://i.ytimg.com/vi/rkQ0VXOCf58/mqdefault.jpg",
    "title": "【#ちゃまポタ】-Hogwarts in Minecraft- はあちゃま社長じゃ～！ #25【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-11T06:37:58Z"
  },
  {
    "videoId": "hZ1DtlDcwVc",
    "thumbnail": "https://i.ytimg.com/vi/hZ1DtlDcwVc/mqdefault.jpg",
    "title": "【 晩酌 】卒業ギリギリ・・・とでも思ったか！？ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-12T12:10:59Z"
  },
  {
    "videoId": "QYXPtehv_1g",
    "thumbnail": "https://i.ytimg.com/vi/QYXPtehv_1g/mqdefault.jpg",
    "title": "【 火夜歌枠 】しっとりバラードな気分...🌙#7【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-13T11:16:34Z"
  },
  {
    "videoId": "dU1ch5cV8PM",
    "thumbnail": "https://i.ytimg.com/vi/dU1ch5cV8PM/mqdefault.jpg",
    "title": "【 Jump King 】I CAN FLY...",
    "publishedAt": "2022-12-14T08:00:50Z"
  },
  {
    "videoId": "jV4Cl0YxPbk",
    "thumbnail": "https://i.ytimg.com/vi/jV4Cl0YxPbk/mqdefault.jpg",
    "title": "【 MADiSON 】Super scary BATSU GAME..... #kobochama",
    "publishedAt": "2022-12-14T11:33:05Z"
  },
  {
    "videoId": "MBUn_MS3Dtw",
    "thumbnail": "https://i.ytimg.com/vi/MBUn_MS3Dtw/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】チーム対抗勝負！？全力でたのしむぞおおお！わくわく～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-14T15:03:08Z"
  },
  {
    "videoId": "rUfegfEaAxE",
    "thumbnail": "https://i.ytimg.com/vi/rUfegfEaAxE/mqdefault.jpg",
    "title": "【Minecraft】おしゃれな壁作りする！-Hogwarts in Minecraft-  #26【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-15T08:16:43Z"
  },
  {
    "videoId": "KpCH4mbj_pk",
    "thumbnail": "https://i.ytimg.com/vi/KpCH4mbj_pk/mqdefault.jpg",
    "title": "餃子を皮から手作りした結果！？ ~第2話~【はあちゃまクッキング・改】",
    "publishedAt": "2022-12-16T06:13:53Z"
  },
  {
    "videoId": "i_IgTPXlxAY",
    "thumbnail": "https://i.ytimg.com/vi/i_IgTPXlxAY/mqdefault.jpg",
    "title": "【アソビ大全】ちゃまたんは漫才コンビだよなぁ！？告知あり！【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-16T09:17:10Z"
  },
  {
    "videoId": "SqgZMZ5ii3M",
    "thumbnail": "https://i.ytimg.com/vi/SqgZMZ5ii3M/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪#9【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-18T01:48:36Z"
  },
  {
    "videoId": "Skp5C4p2ZHE",
    "thumbnail": "https://i.ytimg.com/vi/Skp5C4p2ZHE/mqdefault.jpg",
    "title": "【 火夜歌枠 】いつも、いつでも元気炸裂！💣#8【ホロライブ/赤井はあと】",
    "publishedAt": "2022-12-20T12:17:02Z"
  },
  {
    "videoId": "7lLhIuITOkY",
    "thumbnail": "https://i.ytimg.com/vi/7lLhIuITOkY/mqdefault.jpg",
    "title": "Xmas MEAT PARTY🎄🎅🍖【HAACHAMA EN WED】#HaachamaEnglish #holoen0",
    "publishedAt": "2022-12-21T07:53:10Z"
  },
  {
    "videoId": "lLGj_Xd6zL4",
    "thumbnail": "https://i.ytimg.com/vi/lLGj_Xd6zL4/mqdefault.jpg",
    "title": "【放送事故】大掃除したらマイク壊れて復帰できませんでした・・・",
    "publishedAt": "2023-01-17T09:22:42Z"
  },
  {
    "videoId": "rNtnaeKgnlg",
    "thumbnail": "https://i.ytimg.com/vi/rNtnaeKgnlg/mqdefault.jpg",
    "title": "マイクが壊れたならKU100を使えばいいじゃない～！",
    "publishedAt": "2023-01-17T09:56:10Z"
  },
  {
    "videoId": "tnohR0EB3dI",
    "thumbnail": "https://i.ytimg.com/vi/tnohR0EB3dI/mqdefault.jpg",
    "title": "TEST(・∀・)",
    "publishedAt": "2023-01-21T09:02:14Z"
  },
  {
    "videoId": "QGFHJGo7l8o",
    "thumbnail": "https://i.ytimg.com/vi/QGFHJGo7l8o/mqdefault.jpg",
    "title": "【Minecraft】いないない～～～ばぁ～～～！！！！！🤩🤩🤩【ホロライブ/赤井はあと】",
    "publishedAt": "2023-01-28T09:05:46Z"
  },
  {
    "videoId": "lB_3NVdRkeQ",
    "thumbnail": "https://i.ytimg.com/vi/lB_3NVdRkeQ/mqdefault.jpg",
    "title": "【GEOGUESSR】ぼっち旅だ～～～～～～～～～～～！！！！！！！！！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-03T14:47:16Z"
  },
  {
    "videoId": "kVikCiO9toA",
    "thumbnail": "https://i.ytimg.com/vi/kVikCiO9toA/mqdefault.jpg",
    "title": "【 ホグワーツレガシー 】べっ、べべべつに！入学したくなんてなななななないんだからね！？！？！？！？！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-09T18:26:02Z"
  },
  {
    "videoId": "-NdPph9F0g4",
    "thumbnail": "https://i.ytimg.com/vi/-NdPph9F0g4/mqdefault.jpg",
    "title": "【 Hogwarts Legacy 】あやしいもんじゃ、、、ないですううううううううう！？！？！？！？！？🤣🤣🤣【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-11T09:22:40Z"
  },
  {
    "videoId": "y_dPD4YRxFU",
    "thumbnail": "https://i.ytimg.com/vi/y_dPD4YRxFU/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪#10【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-12T02:14:25Z"
  },
  {
    "videoId": "lJ3tlFawDdU",
    "thumbnail": "https://i.ytimg.com/vi/lJ3tlFawDdU/mqdefault.jpg",
    "title": "【バレンタインCOOKIN♪】カカオ豆でチョコつくる！",
    "publishedAt": "2023-02-14T12:49:02Z"
  },
  {
    "videoId": "P33rEwDeXgY",
    "thumbnail": "https://i.ytimg.com/vi/P33rEwDeXgY/mqdefault.jpg",
    "title": "新企画！【#はあちゃま神絵師になる】with ももしき先生 【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-15T12:08:56Z"
  },
  {
    "videoId": "T1KDSK5FgpM",
    "thumbnail": "https://i.ytimg.com/vi/T1KDSK5FgpM/mqdefault.jpg",
    "title": "【 Minecraft 】いろはちゃんとおデート【ホロライブ/赤井はあと/風真いろは】",
    "publishedAt": "2023-02-16T14:22:38Z"
  },
  {
    "videoId": "hBcUYY8qs5s",
    "thumbnail": "https://i.ytimg.com/vi/hBcUYY8qs5s/mqdefault.jpg",
    "title": "【#KUREIJIARCADE】NOOB APEX👏",
    "publishedAt": "2023-02-18T12:13:13Z"
  },
  {
    "videoId": "UUhJBSuDYKk",
    "thumbnail": "https://i.ytimg.com/vi/UUhJBSuDYKk/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪#11【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-19T01:59:55Z"
  },
  {
    "videoId": "W1sn2dVGsCE",
    "thumbnail": "https://i.ytimg.com/vi/W1sn2dVGsCE/mqdefault.jpg",
    "title": "【 Hogwarts in Minecraft 】深夜のまったりマイクラ♪【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-20T18:10:59Z"
  },
  {
    "videoId": "gyL4nq53AHc",
    "thumbnail": "https://i.ytimg.com/vi/gyL4nq53AHc/mqdefault.jpg",
    "title": "【 火夜歌枠 】2023年！初のおうた！#9【ホロライブ/赤井はあと】",
    "publishedAt": "2023-02-21T13:19:21Z"
  },
  {
    "videoId": "5KoYmlSuulA",
    "thumbnail": "https://i.ytimg.com/vi/5KoYmlSuulA/mqdefault.jpg",
    "title": "みなさんへのご報告【ホロライブ/赤井はあと】",
    "publishedAt": "2023-09-20T07:00:05Z"
  },
  {
    "videoId": "mcJe1OoJMNM",
    "thumbnail": "https://i.ytimg.com/vi/mcJe1OoJMNM/mqdefault.jpg",
    "title": "Important Notice [Hololive/Akai Haato].",
    "publishedAt": "2023-09-20T07:00:19Z"
  },
  {
    "videoId": "jWd6cpvnfd0",
    "thumbnail": "https://i.ytimg.com/vi/jWd6cpvnfd0/mqdefault.jpg",
    "title": "【Original anime MV】BUTA/Akaihaato (official)",
    "publishedAt": "2023-11-01T13:00:09Z"
  },
  {
    "videoId": "q6KktlRYeuI",
    "thumbnail": "https://i.ytimg.com/vi/q6KktlRYeuI/mqdefault.jpg",
    "title": "【#はあちゃま復活】みんなただいま～～～！！！はあちゃまっちゃま～！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-01T13:18:54Z"
  },
  {
    "videoId": "-Dmo9lykEIk",
    "thumbnail": "https://i.ytimg.com/vi/-Dmo9lykEIk/mqdefault.jpg",
    "title": "【】HOLO・・・LIVE？？？？？？？？【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-05T14:30:54Z"
  },
  {
    "videoId": "_U--hP9-WyY",
    "thumbnail": "https://i.ytimg.com/vi/_U--hP9-WyY/mqdefault.jpg",
    "title": "【凸待ち】ホロ・・・ライブ？のみなさんと通話してみる！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-06T13:40:10Z"
  },
  {
    "videoId": "8lK72FOLOto",
    "thumbnail": "https://i.ytimg.com/vi/8lK72FOLOto/mqdefault.jpg",
    "title": "知らない料理を推理して作ってみた！#shorts #cooking",
    "publishedAt": "2023-11-10T12:18:19Z"
  },
  {
    "videoId": "SqbCfYFUokw",
    "thumbnail": "https://i.ytimg.com/vi/SqbCfYFUokw/mqdefault.jpg",
    "title": "【スイカゲーム】初見！ダブルスイカ o r 脱衣か！？【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-11T11:30:39Z"
  },
  {
    "videoId": "Opo5QJehk4I",
    "thumbnail": "https://i.ytimg.com/vi/Opo5QJehk4I/mqdefault.jpg",
    "title": "【歌枠】三億年ぶりのKARAOKE～～～♪うたう！！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-14T12:10:46Z"
  },
  {
    "videoId": "ti5POC3mi5c",
    "thumbnail": "https://i.ytimg.com/vi/ti5POC3mi5c/mqdefault.jpg",
    "title": "【Q REMASTERED】超難問！？ひらめついた・・・！（脳みそ爆誕）【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-16T12:07:52Z"
  },
  {
    "videoId": "uii3udF_nII",
    "thumbnail": "https://i.ytimg.com/vi/uii3udF_nII/mqdefault.jpg",
    "title": "みんなに「架空求人募集」を作ってもらった結果・・・ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-19T10:05:22Z"
  },
  {
    "videoId": "hai9wo_W2lE",
    "thumbnail": "https://i.ytimg.com/vi/hai9wo_W2lE/mqdefault.jpg",
    "title": "【#青ちゃまたんなのら】新人ちゃん、ちょっとツラ貸せよ・・・【ホロライブ/赤井はあと/天音かなた/姫森ルーナ/火威青】",
    "publishedAt": "2023-11-21T13:30:04Z"
  },
  {
    "videoId": "IO2ImIoHz5E",
    "thumbnail": "https://i.ytimg.com/vi/IO2ImIoHz5E/mqdefault.jpg",
    "title": "【#ほしちゃま】星川、実家にやってくる。【ホロライブ/赤井はあと/にじさんじ/星川サラ】",
    "publishedAt": "2023-11-24T14:04:01Z"
  },
  {
    "videoId": "TQbVEk2cS9Y",
    "thumbnail": "https://i.ytimg.com/vi/TQbVEk2cS9Y/mqdefault.jpg",
    "title": "【Minecraft】ただいまホロ鯖!! 観光するよ～～～♪【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-26T11:01:31Z"
  },
  {
    "videoId": "pJUuno2SjHs",
    "thumbnail": "https://i.ytimg.com/vi/pJUuno2SjHs/mqdefault.jpg",
    "title": "【第２回】#はあちゃま神絵師になる withももしき先生【ホロライブ/赤井はあと】",
    "publishedAt": "2023-11-28T10:08:39Z"
  },
  {
    "videoId": "hG8TeHqnAlM",
    "thumbnail": "https://i.ytimg.com/vi/hG8TeHqnAlM/mqdefault.jpg",
    "title": "これなーんだ？ #shorts #cooking",
    "publishedAt": "2023-11-29T15:24:28Z"
  },
  {
    "videoId": "-yKRb5sFzVY",
    "thumbnail": "https://i.ytimg.com/vi/-yKRb5sFzVY/mqdefault.jpg",
    "title": "【ホロパレード】ホロライブのゲーム！！！？はあちゃまGETしたい～！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-04T18:28:44Z"
  },
  {
    "videoId": "O_fw2GUDxrw",
    "thumbnail": "https://i.ytimg.com/vi/O_fw2GUDxrw/mqdefault.jpg",
    "title": "SPICY NOODLE CHAT!!! with Kronii #KROCHAMA #hololiveenglish",
    "publishedAt": "2023-12-07T04:38:59Z"
  },
  {
    "videoId": "uk5J051y-Lo",
    "thumbnail": "https://i.ytimg.com/vi/uk5J051y-Lo/mqdefault.jpg",
    "title": "踏まれたい？お風呂の水欲しい？本気なの？ほんとヤバすぎ・・・#shorts",
    "publishedAt": "2023-12-07T04:42:30Z"
  },
  {
    "videoId": "UIPyckVZCeQ",
    "thumbnail": "https://i.ytimg.com/vi/UIPyckVZCeQ/mqdefault.jpg",
    "title": "ホロメンとあったいろんな話！恋バナ・・・？【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-11T16:24:21Z"
  },
  {
    "videoId": "raXp6EPDuP4",
    "thumbnail": "https://i.ytimg.com/vi/raXp6EPDuP4/mqdefault.jpg",
    "title": "【】添　い　寝　凸　待　ち【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-12T15:24:24Z"
  },
  {
    "videoId": "45p_8WgfEjM",
    "thumbnail": "https://i.ytimg.com/vi/45p_8WgfEjM/mqdefault.jpg",
    "title": "$1 Christmas Gift for  @MoriCalliope  #shorts #christmas",
    "publishedAt": "2023-12-14T10:02:00Z"
  },
  {
    "videoId": "nk-dlsOzihY",
    "thumbnail": "https://i.ytimg.com/vi/nk-dlsOzihY/mqdefault.jpg",
    "title": "【#ホロ料理部】はあちゃまクッキング料理教室🍳【ホロライブ/赤井はあと/一条莉々華】",
    "publishedAt": "2023-12-14T12:41:30Z"
  },
  {
    "videoId": "S8906cHW08g",
    "thumbnail": "https://i.ytimg.com/vi/S8906cHW08g/mqdefault.jpg",
    "title": "【#ホロ一期コラボ】一致するまで終われまテン！！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-16T13:12:32Z"
  },
  {
    "videoId": "XcRlmlxH96M",
    "thumbnail": "https://i.ytimg.com/vi/XcRlmlxH96M/mqdefault.jpg",
    "title": "【8番出口】駅から出られなくて困ってるなう！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-17T04:07:45Z"
  },
  {
    "videoId": "YO7dWoL37rc",
    "thumbnail": "https://i.ytimg.com/vi/YO7dWoL37rc/mqdefault.jpg",
    "title": "まつりちゃんにクリスマスプレゼントあげてみた！ #夏色まつり",
    "publishedAt": "2023-12-17T04:51:46Z"
  },
  {
    "videoId": "PuYLyIK4Qlk",
    "thumbnail": "https://i.ytimg.com/vi/PuYLyIK4Qlk/mqdefault.jpg",
    "title": "【#でんちゃま】虫食いVtuberの引退、そして今後・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-18T13:04:25Z"
  },
  {
    "videoId": "qqHVsLuvD8Y",
    "thumbnail": "https://i.ytimg.com/vi/qqHVsLuvD8Y/mqdefault.jpg",
    "title": "【 ASMR 】絶対に永眠できる💓Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-19T16:42:17Z"
  },
  {
    "videoId": "seDRh_L8t10",
    "thumbnail": "https://i.ytimg.com/vi/seDRh_L8t10/mqdefault.jpg",
    "title": "クリスマスCOOKING♪ホロメンに🎁【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-23T12:04:49Z"
  },
  {
    "videoId": "UD1mlyGs6Hk",
    "thumbnail": "https://i.ytimg.com/vi/UD1mlyGs6Hk/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー 】めり～ちゃまります☆彡🎄🎅🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-25T07:02:04Z"
  },
  {
    "videoId": "dXFVG0Noa-U",
    "thumbnail": "https://i.ytimg.com/vi/dXFVG0Noa-U/mqdefault.jpg",
    "title": "【オフコラボ】聖なる夜に！クリスマスパーティ♪【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-26T06:04:03Z"
  },
  {
    "videoId": "WL8Ay5QPzRU",
    "thumbnail": "https://i.ytimg.com/vi/WL8Ay5QPzRU/mqdefault.jpg",
    "title": "【 マリカ8DX 】#ほしちゃま でマリカ杯特訓するぞ！！！！！！！！！【ホロライブ/赤井はあと 】",
    "publishedAt": "2023-12-26T15:06:18Z"
  },
  {
    "videoId": "npDfyLVU6g8",
    "thumbnail": "https://i.ytimg.com/vi/npDfyLVU6g8/mqdefault.jpg",
    "title": "【オフコラボ】なんか赤たんきた【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-27T15:58:43Z"
  },
  {
    "videoId": "sFhM78O8hyE",
    "thumbnail": "https://i.ytimg.com/vi/sFhM78O8hyE/mqdefault.jpg",
    "title": "【#ホロ新人生ゲーム】新人ちゃん、ちょっとツラ貸せよ・・・【ホロライブ/赤井はあと/天音かなた/姫森ルーナ/音乃瀬奏】",
    "publishedAt": "2023-12-28T17:00:49Z"
  },
  {
    "videoId": "xO1MykmUjYI",
    "thumbnail": "https://i.ytimg.com/vi/xO1MykmUjYI/mqdefault.jpg",
    "title": "【Party Animals】#金髪3姉妹 ！？動物になって勝負だ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-29T11:17:18Z"
  },
  {
    "videoId": "nQkMuTkXr6A",
    "thumbnail": "https://i.ytimg.com/vi/nQkMuTkXr6A/mqdefault.jpg",
    "title": "【あばよ2023年】　大　掃　除　配　信　【ホロライブ/赤井はあと】",
    "publishedAt": "2023-12-31T09:09:53Z"
  },
  {
    "videoId": "IvxE-0vxrkA",
    "thumbnail": "https://i.ytimg.com/vi/IvxE-0vxrkA/mqdefault.jpg",
    "title": "2024年初配信✨ホロメン相関図2023&今年の目標っちゃまっちゃま～～～！🎍【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-03T17:32:49Z"
  },
  {
    "videoId": "xlXFmaRuK04",
    "thumbnail": "https://i.ytimg.com/vi/xlXFmaRuK04/mqdefault.jpg",
    "title": "【Hololive EN&ID】Relationship Chart 2023→2024!!✨",
    "publishedAt": "2024-01-04T05:53:21Z"
  },
  {
    "videoId": "fG1CbFVWn44",
    "thumbnail": "https://i.ytimg.com/vi/fG1CbFVWn44/mqdefault.jpg",
    "title": "【おせちCOOKING♪】※※莉々華は閲覧禁止※※【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-04T10:27:15Z"
  },
  {
    "videoId": "h7GzLzQ5seg",
    "thumbnail": "https://i.ytimg.com/vi/h7GzLzQ5seg/mqdefault.jpg",
    "title": "【#ホロお正月CUP2024】グループA予選！つよ杯いくぞおおお！ちゃま♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-07T08:49:55Z"
  },
  {
    "videoId": "y5hhaR8923o",
    "thumbnail": "https://i.ytimg.com/vi/y5hhaR8923o/mqdefault.jpg",
    "title": "【 マリオカート8DX 】やっべ、練習しよ。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-08T03:41:57Z"
  },
  {
    "videoId": "HLcUjHZ5o00",
    "thumbnail": "https://i.ytimg.com/vi/HLcUjHZ5o00/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2024 】つよ杯しか勝たん！ざぁこ💓グループF本選！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-08T09:43:29Z"
  },
  {
    "videoId": "L30phWHBk-0",
    "thumbnail": "https://i.ytimg.com/vi/L30phWHBk-0/mqdefault.jpg",
    "title": "莉々華にお年玉あげてみた！ #regloss",
    "publishedAt": "2024-01-12T09:10:42Z"
  },
  {
    "videoId": "g1ZIu91A12E",
    "thumbnail": "https://i.ytimg.com/vi/g1ZIu91A12E/mqdefault.jpg",
    "title": "【#ホロ狂人ワードウルフ】最強の狂人を決める！！！！！！！！！【ホロライブ】",
    "publishedAt": "2024-01-13T13:25:17Z"
  },
  {
    "videoId": "DWcrfRDZ3BM",
    "thumbnail": "https://i.ytimg.com/vi/DWcrfRDZ3BM/mqdefault.jpg",
    "title": "【黒歴史】6年間の過去ポスト振り返る！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-14T17:16:17Z"
  },
  {
    "videoId": "nGyuEI6lEcA",
    "thumbnail": "https://i.ytimg.com/vi/nGyuEI6lEcA/mqdefault.jpg",
    "title": "【BUG REVIEW】Let's look at some BUGS! with @WatsonAmelia",
    "publishedAt": "2024-01-16T04:32:58Z"
  },
  {
    "videoId": "Zis-caWn6WI",
    "thumbnail": "https://i.ytimg.com/vi/Zis-caWn6WI/mqdefault.jpg",
    "title": "【歌枠】ちょこっと歌います。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-17T09:34:51Z"
  },
  {
    "videoId": "XBm1MxgA0ZI",
    "thumbnail": "https://i.ytimg.com/vi/XBm1MxgA0ZI/mqdefault.jpg",
    "title": "【朝活】朝ごはん食べる🐙おでけけ～！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-17T23:51:31Z"
  },
  {
    "videoId": "a0qrgKLy-9I",
    "thumbnail": "https://i.ytimg.com/vi/a0qrgKLy-9I/mqdefault.jpg",
    "title": "【#はあみこ】お　泊　り　新　年　会【ホロライブ/赤井はあと/さくらみこ】",
    "publishedAt": "2024-01-18T13:35:28Z"
  },
  {
    "videoId": "FOZ1J8BBU8E",
    "thumbnail": "https://i.ytimg.com/vi/FOZ1J8BBU8E/mqdefault.jpg",
    "title": "【ただいま】開店！",
    "publishedAt": "2024-01-26T10:39:43Z"
  },
  {
    "videoId": "nfLIpEl91Ok",
    "thumbnail": "https://i.ytimg.com/vi/nfLIpEl91Ok/mqdefault.jpg",
    "title": "【朝活】おはるーじゅ！無性にやりたかったゲームやる・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-27T00:26:03Z"
  },
  {
    "videoId": "rWYS1FP4aPI",
    "thumbnail": "https://i.ytimg.com/vi/rWYS1FP4aPI/mqdefault.jpg",
    "title": "【最終回】#はあちゃま神絵師になる withももしき先生【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-27T05:52:55Z"
  },
  {
    "videoId": "AdPKiBHUp7c",
    "thumbnail": "https://i.ytimg.com/vi/AdPKiBHUp7c/mqdefault.jpg",
    "title": "【パルワールド】はじめてのホロ鯖！参戦～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-27T22:24:38Z"
  },
  {
    "videoId": "yHf6cij1AMA",
    "thumbnail": "https://i.ytimg.com/vi/yHf6cij1AMA/mqdefault.jpg",
    "title": "【アソビ大全】はじめちゃん、ちょっとツラ貸せよ・・・！😎【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-28T12:25:30Z"
  },
  {
    "videoId": "RqTPLtRWiuw",
    "thumbnail": "https://i.ytimg.com/vi/RqTPLtRWiuw/mqdefault.jpg",
    "title": "【TABS】#ちゃまぼた 戦争がはじまる・・・！🐏を巡るの巻き【ホロライブ/赤井はあと】",
    "publishedAt": "2024-01-30T11:07:27Z"
  },
  {
    "videoId": "BJQnGW-h3L8",
    "thumbnail": "https://i.ytimg.com/vi/BJQnGW-h3L8/mqdefault.jpg",
    "title": "【 節分 】恵方巻きもぐちゃま！👹【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-03T01:04:41Z"
  },
  {
    "videoId": "_rdYLSe0t9E",
    "thumbnail": "https://i.ytimg.com/vi/_rdYLSe0t9E/mqdefault.jpg",
    "title": "バレンタインCOOKING♪教室 with りっちしょこら💘【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-04T12:37:38Z"
  },
  {
    "videoId": "FUH29UnCAqs",
    "thumbnail": "https://i.ytimg.com/vi/FUH29UnCAqs/mqdefault.jpg",
    "title": "【Unpacking】安眠できるお片付け....💤【ホロライブ/赤井はあと/#おやすみはあと】",
    "publishedAt": "2024-02-05T17:11:26Z"
  },
  {
    "videoId": "tDyzrxmjJOA",
    "thumbnail": "https://i.ytimg.com/vi/tDyzrxmjJOA/mqdefault.jpg",
    "title": "【Melatonin】Chill可愛いリズムゲーで #おやすみはあと ...💤【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-07T15:27:47Z"
  },
  {
    "videoId": "DbssbfxuSoI",
    "thumbnail": "https://i.ytimg.com/vi/DbssbfxuSoI/mqdefault.jpg",
    "title": "[NEW CO.....] いきなり新○○お披露目・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-08T16:55:55Z"
  },
  {
    "videoId": "D9mKs6WuBKk",
    "thumbnail": "https://i.ytimg.com/vi/D9mKs6WuBKk/mqdefault.jpg",
    "title": "COLLEGE GIRLS WAR 2024 :D  HAACHAMA VS @NanashiMumei",
    "publishedAt": "2024-02-09T04:46:40Z"
  },
  {
    "videoId": "se2lKI8yqMo",
    "thumbnail": "https://i.ytimg.com/vi/se2lKI8yqMo/mqdefault.jpg",
    "title": "NEW RAINBOW BURGER COOKING!! for  @ShioriNovella",
    "publishedAt": "2024-02-10T04:43:01Z"
  },
  {
    "videoId": "1E6Lynof6Yk",
    "thumbnail": "https://i.ytimg.com/vi/1E6Lynof6Yk/mqdefault.jpg",
    "title": "【 #ホロオジ選手権 】おじさん構文で最強の “ホロオジ” を決める！！【オジサンメッセージ】",
    "publishedAt": "2024-02-10T13:57:14Z"
  },
  {
    "videoId": "G8brfCjua20",
    "thumbnail": "https://i.ytimg.com/vi/G8brfCjua20/mqdefault.jpg",
    "title": "【 #ブルージュ 】やっと2人きりになれたね・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-11T12:32:40Z"
  },
  {
    "videoId": "JajpFYtK-lY",
    "thumbnail": "https://i.ytimg.com/vi/JajpFYtK-lY/mqdefault.jpg",
    "title": "【 料理/カメラ枠 】バレンタインCOOKING♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-12T04:10:52Z"
  },
  {
    "videoId": "Q7ScZwhsglo",
    "thumbnail": "https://i.ytimg.com/vi/Q7ScZwhsglo/mqdefault.jpg",
    "title": "【歌枠】ハートをぶち抜くSINGING♪[ Relaxing Sleep Music ]",
    "publishedAt": "2024-02-12T16:15:46Z"
  },
  {
    "videoId": "IXptmBFjwfI",
    "thumbnail": "https://i.ytimg.com/vi/IXptmBFjwfI/mqdefault.jpg",
    "title": "【 #はあわた 】いちゃいちゃカラオケデート！覗き見？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-16T12:46:17Z"
  },
  {
    "videoId": "PqVYAZYpI3c",
    "thumbnail": "https://i.ytimg.com/vi/PqVYAZYpI3c/mqdefault.jpg",
    "title": "【アソビ大全】おいらでん、ちょっとツラ貸せよ・・・！？😲【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-20T11:09:06Z"
  },
  {
    "videoId": "LShvvLeAL6A",
    "thumbnail": "https://i.ytimg.com/vi/LShvvLeAL6A/mqdefault.jpg",
    "title": "【 ASMR 】寝る前に『午前5時にピアノを弾く』をプレイ🎧⊹♡  (囁きゲーム実況)",
    "publishedAt": "2024-02-20T18:48:56Z"
  },
  {
    "videoId": "gRDGkCMzEds",
    "thumbnail": "https://i.ytimg.com/vi/gRDGkCMzEds/mqdefault.jpg",
    "title": "【Genital Jousting】SEISO!",
    "publishedAt": "2024-02-22T10:04:17Z"
  },
  {
    "videoId": "dsglw6SwgWw",
    "thumbnail": "https://i.ytimg.com/vi/dsglw6SwgWw/mqdefault.jpg",
    "title": "【Lethal Company】はじめてのお仕事！！！！！！！！！！るんるん♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-22T15:21:42Z"
  },
  {
    "videoId": "e9RjspacQ5I",
    "thumbnail": "https://i.ytimg.com/vi/e9RjspacQ5I/mqdefault.jpg",
    "title": "【Drawing】イオフィ、清楚な漫画をつくらないか・・・？#Chaofi【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-23T10:26:07Z"
  },
  {
    "videoId": "y6CUrKl4d8k",
    "thumbnail": "https://i.ytimg.com/vi/y6CUrKl4d8k/mqdefault.jpg",
    "title": "【 ASMR 】寝る前に『あつまれどうぶつの森』をプレイ⸜🌷⸝ (囁きゲーム実況)",
    "publishedAt": "2024-02-23T18:13:17Z"
  },
  {
    "videoId": "1Fowv9d2AZk",
    "thumbnail": "https://i.ytimg.com/vi/1Fowv9d2AZk/mqdefault.jpg",
    "title": "【創作ハンバーガー堂】ちゃまバーガー開店！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-24T09:58:22Z"
  },
  {
    "videoId": "8ZLJH5fKL7o",
    "thumbnail": "https://i.ytimg.com/vi/8ZLJH5fKL7o/mqdefault.jpg",
    "title": "【創作ハンバーガー堂】ん～～///ジューシーフロミーズの味！🍔✨【ホロライブ/赤井はあと】",
    "publishedAt": "2024-02-25T10:09:29Z"
  },
  {
    "videoId": "xPdUpBMEHAU",
    "thumbnail": "https://i.ytimg.com/vi/xPdUpBMEHAU/mqdefault.jpg",
    "title": "【ASMR】寝落ちするまで海を泳ぎます......🐠 🏝️ 🐬*˖° (ABZU/囁きゲーム実況)",
    "publishedAt": "2024-02-26T18:31:01Z"
  },
  {
    "videoId": "p9mIVAyyozs",
    "thumbnail": "https://i.ytimg.com/vi/p9mIVAyyozs/mqdefault.jpg",
    "title": "【オフコラボ】ようこそ、おしゃ女子会へ！～番長参戦～【ホロライブ/赤井はあと/hololive DEV_IS ReGLOSS/一条莉々華】",
    "publishedAt": "2024-02-27T04:13:05Z"
  },
  {
    "videoId": "3kJTyYmu54o",
    "thumbnail": "https://i.ytimg.com/vi/3kJTyYmu54o/mqdefault.jpg",
    "title": "【オフコラボ】💩焼き対談(タコパ)でなかよしになる！！🤩【#ういちゃま】",
    "publishedAt": "2024-02-29T12:11:03Z"
  },
  {
    "videoId": "Hv4hxXY80ZY",
    "thumbnail": "https://i.ytimg.com/vi/Hv4hxXY80ZY/mqdefault.jpg",
    "title": "【ASMR】寝落ちするまでお片付けします...........˖* 🐷🧹✧(Unpacking/囁きゲーム実況)",
    "publishedAt": "2024-02-29T19:50:31Z"
  },
  {
    "videoId": "ZGrGDCd8VyM",
    "thumbnail": "https://i.ytimg.com/vi/ZGrGDCd8VyM/mqdefault.jpg",
    "title": "【ASMR】深夜にラーメン食べちゃう......⸜🍜⸝(咀嚼音/ Mukbang/ Eating Sounds)",
    "publishedAt": "2024-03-01T17:08:19Z"
  },
  {
    "videoId": "gAd_qg6MZ-E",
    "thumbnail": "https://i.ytimg.com/vi/gAd_qg6MZ-E/mqdefault.jpg",
    "title": "【創作ハンバーガー堂】脱赤字！足臭ドリップで差をつけろ！☕🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2024-03-02T10:21:54Z"
  },
  {
    "videoId": "jZcy_ZuwSKE",
    "thumbnail": "https://i.ytimg.com/vi/jZcy_ZuwSKE/mqdefault.jpg",
    "title": "【雑談】あなた、トントロっていうのね！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-03-03T11:40:15Z"
  },
  {
    "videoId": "fnlWRsnFSwc",
    "thumbnail": "https://i.ytimg.com/vi/fnlWRsnFSwc/mqdefault.jpg",
    "title": "【#ラプちゃま】ガキの晩酌雑談【ホロライブ/赤井はあと】",
    "publishedAt": "2024-03-04T12:07:23Z"
  },
  {
    "videoId": "LRDP5QFpz3Q",
    "thumbnail": "https://i.ytimg.com/vi/LRDP5QFpz3Q/mqdefault.jpg",
    "title": "【ENGLISH】JUST TEACH ME F*CKBOY!!　#HololiveEN0",
    "publishedAt": "2024-03-05T04:07:00Z"
  },
  {
    "videoId": "nDJtcmSbyUA",
    "thumbnail": "https://i.ytimg.com/vi/nDJtcmSbyUA/mqdefault.jpg",
    "title": "Girl with pink hair - Akaihaato",
    "publishedAt": "2024-03-06T08:00:12Z"
  },
  {
    "videoId": "wJWrHCGMoF0",
    "thumbnail": "https://i.ytimg.com/vi/wJWrHCGMoF0/mqdefault.jpg",
    "title": "HELP ME.....................................................I GOT BURIED ALIVE😱",
    "publishedAt": "2024-03-07T04:34:34Z"
  },
  {
    "videoId": "Mht8DG4LDwM",
    "thumbnail": "https://i.ytimg.com/vi/Mht8DG4LDwM/mqdefault.jpg",
    "title": "【友人A✖はあちゃま】真　面　目　対　談　！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-03-07T11:08:38Z"
  },
  {
    "videoId": "611B1a_rz3k",
    "thumbnail": "https://i.ytimg.com/vi/611B1a_rz3k/mqdefault.jpg",
    "title": "はあちゃまの脳みそは入れ替え式",
    "publishedAt": "2024-03-08T03:00:06Z"
  },
  {
    "videoId": "GozEv0IruEE",
    "thumbnail": "https://i.ytimg.com/vi/GozEv0IruEE/mqdefault.jpg",
    "title": "ブタサンダー - Yukopi / Covered by 赤井はあと【Cover】",
    "publishedAt": "2024-03-09T15:00:10Z"
  },
  {
    "videoId": "31Rpe_c4dAE",
    "thumbnail": "https://i.ytimg.com/vi/31Rpe_c4dAE/mqdefault.jpg",
    "title": "【カメラ枠】おじさんになる時が来たようだ・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2024-03-12T10:31:13Z"
  },
  {
    "videoId": "E4mBCAwT1ko",
    "thumbnail": "https://i.ytimg.com/vi/E4mBCAwT1ko/mqdefault.jpg",
    "title": "【#よこせやホワイトデー】ねえねえ！なにくれるの？？？くれるよね・・・・・？🔪【#HAACHAMASUNDAY】",
    "publishedAt": "2024-03-14T10:18:03Z"
  },
  {
    "videoId": "FxNbCAr5qGU",
    "thumbnail": "https://i.ytimg.com/vi/FxNbCAr5qGU/mqdefault.jpg",
    "title": "【感想会＆お知らせ】hololive 5th fes. Capture the Moment【ホロライブ/赤井はあと】",
    "publishedAt": "2024-03-16T16:49:25Z"
  },
  {
    "videoId": "AXasW1OSb10",
    "thumbnail": "https://i.ytimg.com/vi/AXasW1OSb10/mqdefault.jpg",
    "title": "Booo! / TOKOTOKO（西沢さんP）covered by 赤井はあと【Cover】",
    "publishedAt": "2024-04-01T11:00:07Z"
  },
  {
    "videoId": "lclUrxJH-74",
    "thumbnail": "https://i.ytimg.com/vi/lclUrxJH-74/mqdefault.jpg",
    "title": "逆凸するぶー。【#BOOCHAMA】",
    "publishedAt": "2024-04-01T11:33:07Z"
  },
  {
    "videoId": "WDCJIAbAGiM",
    "thumbnail": "https://i.ytimg.com/vi/WDCJIAbAGiM/mqdefault.jpg",
    "title": "I WANT TO BE HUMAN  / THE BEAST TAKE",
    "publishedAt": "2024-04-02T16:41:40Z"
  },
  {
    "videoId": "rh1RRWhd-r8",
    "thumbnail": "https://i.ytimg.com/vi/rh1RRWhd-r8/mqdefault.jpg",
    "title": "【セガNET麻雀 MJ】はじめての麻雀！ぶ～！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-03T01:05:51Z"
  },
  {
    "videoId": "6rOhzvfN_h4",
    "thumbnail": "https://i.ytimg.com/vi/6rOhzvfN_h4/mqdefault.jpg",
    "title": "【セガNET麻雀 MJ】#かみちゃまろーぜ 1期生で麻雀練習【ホロライブ/赤井はあと/#ホロ麻雀チーム大会】",
    "publishedAt": "2024-04-05T15:36:15Z"
  },
  {
    "videoId": "n1p3Kr2gOAE",
    "thumbnail": "https://i.ytimg.com/vi/n1p3Kr2gOAE/mqdefault.jpg",
    "title": "【#ホロ麻雀チーム大会】#かみちゃまろーぜ 本番！はあちゃま視点！【セガNET麻雀 MJ/ホロライブ】",
    "publishedAt": "2024-04-06T11:22:03Z"
  },
  {
    "videoId": "OEC3EgU03k0",
    "thumbnail": "https://i.ytimg.com/vi/OEC3EgU03k0/mqdefault.jpg",
    "title": "【#ホロ麻雀チーム大会】#かみちゃまろーぜ ホワイトゴット応援&エキシビジョン！【セガNET麻雀 MJ/ホロライブ】",
    "publishedAt": "2024-04-06T13:37:47Z"
  },
  {
    "videoId": "ZJUGE8-4H2o",
    "thumbnail": "https://i.ytimg.com/vi/ZJUGE8-4H2o/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪ #12【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-07T01:38:37Z"
  },
  {
    "videoId": "ITciza_aljg",
    "thumbnail": "https://i.ytimg.com/vi/ITciza_aljg/mqdefault.jpg",
    "title": "⚠️⚠️⚠️ロリちゃま（8さい）【フルボッコようちえん】",
    "publishedAt": "2024-04-08T11:37:45Z"
  },
  {
    "videoId": "xVBjxmP6bU8",
    "thumbnail": "https://i.ytimg.com/vi/xVBjxmP6bU8/mqdefault.jpg",
    "title": "【Goonect】KUSOGAKIDS @KosekiBijou",
    "publishedAt": "2024-04-09T04:16:11Z"
  },
  {
    "videoId": "sOOMhG_jpBg",
    "thumbnail": "https://i.ytimg.com/vi/sOOMhG_jpBg/mqdefault.jpg",
    "title": "【歌枠】卒業ソングメドレー♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-09T11:11:10Z"
  },
  {
    "videoId": "fS1gPzMDP9A",
    "thumbnail": "https://i.ytimg.com/vi/fS1gPzMDP9A/mqdefault.jpg",
    "title": "【Minecraft】GOD, Please Elytra. @KaelaKovalskia",
    "publishedAt": "2024-04-11T07:12:21Z"
  },
  {
    "videoId": "GhFBSy4n-rQ",
    "thumbnail": "https://i.ytimg.com/vi/GhFBSy4n-rQ/mqdefault.jpg",
    "title": "【 Hogwarts in Minecraft 】1億年ぶり！深夜のまったりマイクラ♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-12T17:44:09Z"
  },
  {
    "videoId": "N1ZJWb7CDUU",
    "thumbnail": "https://i.ytimg.com/vi/N1ZJWb7CDUU/mqdefault.jpg",
    "title": "【同時視聴】ハリー・ポッターと秘密の部屋｜Harry Potter and the Chamber of Secrets!!",
    "publishedAt": "2024-04-13T12:09:54Z"
  },
  {
    "videoId": "AwU7Xa_b6Nk",
    "thumbnail": "https://i.ytimg.com/vi/AwU7Xa_b6Nk/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪ #13【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-14T00:48:10Z"
  },
  {
    "videoId": "ds7tCF5UWus",
    "thumbnail": "https://i.ytimg.com/vi/ds7tCF5UWus/mqdefault.jpg",
    "title": "【 ASMR 】ASMR KFC CHICKEN MUKBANG｜EATING SOUNDS　#hololiveen0",
    "publishedAt": "2024-04-15T04:06:48Z"
  },
  {
    "videoId": "xruueaAMeaY",
    "thumbnail": "https://i.ytimg.com/vi/xruueaAMeaY/mqdefault.jpg",
    "title": "yukopi - 🐖 ブタサンダー🐖 l Haachama Ver. #yukopi #vtuber #shorts",
    "publishedAt": "2024-04-15T12:41:25Z"
  },
  {
    "videoId": "_QY1o-08f4c",
    "thumbnail": "https://i.ytimg.com/vi/_QY1o-08f4c/mqdefault.jpg",
    "title": "【衝撃】意外と知らないはあちゃまキャラ設定",
    "publishedAt": "2024-04-15T13:16:16Z"
  },
  {
    "videoId": "uvVfu8zFMjM",
    "thumbnail": "https://i.ytimg.com/vi/uvVfu8zFMjM/mqdefault.jpg",
    "title": "【カメラ枠】ホグワーツ3Dパズル！模型つくり♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-19T19:18:29Z"
  },
  {
    "videoId": "UcySVDs28G8",
    "thumbnail": "https://i.ytimg.com/vi/UcySVDs28G8/mqdefault.jpg",
    "title": "【同時視聴】ハリー・ポッターとアズカバンの囚人｜Harry Potter and the Prisoner of Azkaban!!",
    "publishedAt": "2024-04-20T10:18:56Z"
  },
  {
    "videoId": "QGe3dmojTAs",
    "thumbnail": "https://i.ytimg.com/vi/QGe3dmojTAs/mqdefault.jpg",
    "title": "【#はあとなニュース】今日の天気は蜘蛛ります♪ #14【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-21T01:00:28Z"
  },
  {
    "videoId": "5Hw4eB4Ek4I",
    "thumbnail": "https://i.ytimg.com/vi/5Hw4eB4Ek4I/mqdefault.jpg",
    "title": "【ゲリラ/朝活】眠れなかった、スイカゲーム！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-04-28T00:02:17Z"
  },
  {
    "videoId": "BFhrRC7BVDo",
    "thumbnail": "https://i.ytimg.com/vi/BFhrRC7BVDo/mqdefault.jpg",
    "title": "【スイカゲーム】星川とオフコラボでバトル！【#ほしちゃま ｜ホロライブ/にじさんじ】",
    "publishedAt": "2024-04-28T11:16:12Z"
  },
  {
    "videoId": "B12gghximys",
    "thumbnail": "https://i.ytimg.com/vi/B12gghximys/mqdefault.jpg",
    "title": "【縦型歌枠】癒しのピアノ曲メドレー♪#shorts【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-02T16:13:43Z"
  },
  {
    "videoId": "f0lsJ5_a7Jc",
    "thumbnail": "https://i.ytimg.com/vi/f0lsJ5_a7Jc/mqdefault.jpg",
    "title": "【Content warning】心霊スポットでバズ動画とってくる！【ホロライブ/#ふわもこぽるちゃま】",
    "publishedAt": "2024-05-03T11:18:20Z"
  },
  {
    "videoId": "7XHDJBe7SoM",
    "thumbnail": "https://i.ytimg.com/vi/7XHDJBe7SoM/mqdefault.jpg",
    "title": "【 セガNET麻雀 MJ 】視聴者参加型でたのしくあそぼ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-04T16:17:38Z"
  },
  {
    "videoId": "pXK4-_6Y0fo",
    "thumbnail": "https://i.ytimg.com/vi/pXK4-_6Y0fo/mqdefault.jpg",
    "title": "【#はあとなニュース】例のあの、ほっこり♪#15【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-05T01:12:10Z"
  },
  {
    "videoId": "CxgfDwaXy88",
    "thumbnail": "https://i.ytimg.com/vi/CxgfDwaXy88/mqdefault.jpg",
    "title": "【Lethal Company】LET'S Eat ALL Monsters!!! @KosekiBijou @KaelaKovalskia",
    "publishedAt": "2024-05-06T04:55:23Z"
  },
  {
    "videoId": "MsNFdL7QQAg",
    "thumbnail": "https://i.ytimg.com/vi/MsNFdL7QQAg/mqdefault.jpg",
    "title": "【縦型雑談】ざつだ～～～～～～～ん！#shorts 【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-07T17:04:49Z"
  },
  {
    "videoId": "mthwZ2bPRG8",
    "thumbnail": "https://i.ytimg.com/vi/mthwZ2bPRG8/mqdefault.jpg",
    "title": "もしもし・・・はあちゃまだよ？おきて【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-08T01:13:30Z"
  },
  {
    "videoId": "xaDT3N7kFHA",
    "thumbnail": "https://i.ytimg.com/vi/xaDT3N7kFHA/mqdefault.jpg",
    "title": "【 ASMR 】癒しましまし永眠💭Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-08T16:38:56Z"
  },
  {
    "videoId": "hg75ss2ZK28",
    "thumbnail": "https://i.ytimg.com/vi/hg75ss2ZK28/mqdefault.jpg",
    "title": "【Content warning】このメンツ、やばい奴多いな・・・？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-09T12:09:35Z"
  },
  {
    "videoId": "qtjF463u1fM",
    "thumbnail": "https://i.ytimg.com/vi/qtjF463u1fM/mqdefault.jpg",
    "title": "【 岩おじ 】マイペースに岩を転がす💭【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-10T17:29:09Z"
  },
  {
    "videoId": "fIk2-MXcFDo",
    "thumbnail": "https://i.ytimg.com/vi/fIk2-MXcFDo/mqdefault.jpg",
    "title": "【Gartic Phone】画伯集合！わちゃわちゃあそぶぞ～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-11T16:49:41Z"
  },
  {
    "videoId": "y7VCTm1g_JQ",
    "thumbnail": "https://i.ytimg.com/vi/y7VCTm1g_JQ/mqdefault.jpg",
    "title": "【縦型雑談】おはよ....ねおき雑談。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-12T01:15:46Z"
  },
  {
    "videoId": "Mv2kaOG6rvc",
    "thumbnail": "https://i.ytimg.com/vi/Mv2kaOG6rvc/mqdefault.jpg",
    "title": "[ NEW OUTFIT ]#タランちゃま新衣装 ホシイ・・・ #HAACHAMASUNDAY",
    "publishedAt": "2024-05-12T16:10:17Z"
  },
  {
    "videoId": "xXk3fjKlDz8",
    "thumbnail": "https://i.ytimg.com/vi/xXk3fjKlDz8/mqdefault.jpg",
    "title": "【 ASMR 】フルーツ飴を食べる🍓 もぐもぐ【咀嚼音 EATING SOUND】【CANDIED FRUITS】",
    "publishedAt": "2024-05-13T15:09:02Z"
  },
  {
    "videoId": "eDHdA53dPzY",
    "thumbnail": "https://i.ytimg.com/vi/eDHdA53dPzY/mqdefault.jpg",
    "title": "【縦型歌枠】激カワすぎるおうた♡【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-14T17:19:36Z"
  },
  {
    "videoId": "1NCvxg9eUWU",
    "thumbnail": "https://i.ytimg.com/vi/1NCvxg9eUWU/mqdefault.jpg",
    "title": "【 ASMR 】ママみ100%な永眠🍼Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-15T16:24:08Z"
  },
  {
    "videoId": "x41zTzrQPws",
    "thumbnail": "https://i.ytimg.com/vi/x41zTzrQPws/mqdefault.jpg",
    "title": "[ ENGLISH ] I'LL EAT MY LUNCH!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! #shorts",
    "publishedAt": "2024-05-16T06:17:13Z"
  },
  {
    "videoId": "YK1KOB4446o",
    "thumbnail": "https://i.ytimg.com/vi/YK1KOB4446o/mqdefault.jpg",
    "title": "【 #ホロ鯖ハードコアマイクラ 】初参戦！ハードコア生き残る！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-16T19:26:44Z"
  },
  {
    "videoId": "5WPHW0r-Iic",
    "thumbnail": "https://i.ytimg.com/vi/5WPHW0r-Iic/mqdefault.jpg",
    "title": "【#はあとなニュース】朝からほっこりをお届け♪ #16【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-19T01:08:51Z"
  },
  {
    "videoId": "o-WpF2aj0Rc",
    "thumbnail": "https://i.ytimg.com/vi/o-WpF2aj0Rc/mqdefault.jpg",
    "title": "やほー。【150万人突破】",
    "publishedAt": "2024-05-19T17:36:51Z"
  },
  {
    "videoId": "Mc8AqWw1tH4",
    "thumbnail": "https://i.ytimg.com/vi/Mc8AqWw1tH4/mqdefault.jpg",
    "title": "【 TETRIS 99 】おらおらおら！対戦かもん～！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-20T20:36:57Z"
  },
  {
    "videoId": "GT0oWn2vUaA",
    "thumbnail": "https://i.ytimg.com/vi/GT0oWn2vUaA/mqdefault.jpg",
    "title": "【 150万人記念 】ぐるぐるソーセージを焼いて祝う🎉【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-21T15:35:46Z"
  },
  {
    "videoId": "xSo0b2FlmBs",
    "thumbnail": "https://i.ytimg.com/vi/xSo0b2FlmBs/mqdefault.jpg",
    "title": "【 無 】カタカタカタカタ・・・・・ASMR keyboard sounds ( NO TALKING)",
    "publishedAt": "2024-05-22T16:23:48Z"
  },
  {
    "videoId": "kydqAnbpA50",
    "thumbnail": "https://i.ytimg.com/vi/kydqAnbpA50/mqdefault.jpg",
    "title": "あのー。。。【リハビリ雑&歌】",
    "publishedAt": "2024-05-27T20:13:31Z"
  },
  {
    "videoId": "mNwU2RrOeDs",
    "thumbnail": "https://i.ytimg.com/vi/mNwU2RrOeDs/mqdefault.jpg",
    "title": "【 ASMR 】いっしょに添い寝💤Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-29T16:20:10Z"
  },
  {
    "videoId": "qhyTIrxGbnI",
    "thumbnail": "https://i.ytimg.com/vi/qhyTIrxGbnI/mqdefault.jpg",
    "title": "カップルなわけ・・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2024-05-30T00:04:56Z"
  },
  {
    "videoId": "2C2DQHQvMDo",
    "thumbnail": "https://i.ytimg.com/vi/2C2DQHQvMDo/mqdefault.jpg",
    "title": "【#はあとなニュース】活動6周年スペシャル🌟【#はあちゃま6周年】",
    "publishedAt": "2024-06-02T01:29:37Z"
  },
  {
    "videoId": "k5CSdQuVzyg",
    "thumbnail": "https://i.ytimg.com/vi/k5CSdQuVzyg/mqdefault.jpg",
    "title": "【#はあちゃま6周年】1期生リレー告知！？ついにアレがでる！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-02T11:05:05Z"
  },
  {
    "videoId": "UpmFuANpg1M",
    "thumbnail": "https://i.ytimg.com/vi/UpmFuANpg1M/mqdefault.jpg",
    "title": "【#はあちゃま6周年】凸待ち♡COOKING♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-02T15:21:19Z"
  },
  {
    "videoId": "KeURQpuMckA",
    "thumbnail": "https://i.ytimg.com/vi/KeURQpuMckA/mqdefault.jpg",
    "title": "【あんた】朝雑【バカぁ？】",
    "publishedAt": "2024-06-09T01:04:11Z"
  },
  {
    "videoId": "J6xuyZZVpNw",
    "thumbnail": "https://i.ytimg.com/vi/J6xuyZZVpNw/mqdefault.jpg",
    "title": "タランチュトーク / Tarantula Talk【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-09T13:57:29Z"
  },
  {
    "videoId": "rO2aJuv5I64",
    "thumbnail": "https://i.ytimg.com/vi/rO2aJuv5I64/mqdefault.jpg",
    "title": "いつもありがとん♡【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-10T12:14:10Z"
  },
  {
    "videoId": "sQHmnYdxJ5I",
    "thumbnail": "https://i.ytimg.com/vi/sQHmnYdxJ5I/mqdefault.jpg",
    "title": "【スイカゲーム】はあちゃまに勝てるとでも・・・？ｗ【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-10T15:17:31Z"
  },
  {
    "videoId": "2xFB9MsnDH8",
    "thumbnail": "https://i.ytimg.com/vi/2xFB9MsnDH8/mqdefault.jpg",
    "title": "【DON'T SCREAM】EASYYYYYYYYYY",
    "publishedAt": "2024-06-11T04:07:34Z"
  },
  {
    "videoId": "4HO_NGwOpH0",
    "thumbnail": "https://i.ytimg.com/vi/4HO_NGwOpH0/mqdefault.jpg",
    "title": "【おやすみ】子守唄【ねろ】",
    "publishedAt": "2024-06-11T17:12:29Z"
  },
  {
    "videoId": "j8td38j0wo8",
    "thumbnail": "https://i.ytimg.com/vi/j8td38j0wo8/mqdefault.jpg",
    "title": "【 ASMR 】全肯定あまあま安眠💖Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-12T16:35:28Z"
  },
  {
    "videoId": "yTph4XiKLkI",
    "thumbnail": "https://i.ytimg.com/vi/yTph4XiKLkI/mqdefault.jpg",
    "title": "【 ASMR 】両耳シャウエッセンASMR♡@IchijouRirika 【咀嚼音 / EATING SOUNDS】",
    "publishedAt": "2024-06-15T09:59:17Z"
  },
  {
    "videoId": "fiiS-OEr90w",
    "thumbnail": "https://i.ytimg.com/vi/fiiS-OEr90w/mqdefault.jpg",
    "title": "【朝活】おはるーじゅ！まったり囁き雑談。【ホロライブ/赤井はあと】#shorts #vtuber",
    "publishedAt": "2024-06-16T02:14:22Z"
  },
  {
    "videoId": "0SgcjD0mDt8",
    "thumbnail": "https://i.ytimg.com/vi/0SgcjD0mDt8/mqdefault.jpg",
    "title": "【Potion Craft】眠れるお薬つくり💤【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-17T17:09:55Z"
  },
  {
    "videoId": "EArIM-Tguis",
    "thumbnail": "https://i.ytimg.com/vi/EArIM-Tguis/mqdefault.jpg",
    "title": "【FNAF】LET'S Five Nights at Freddy’s!!",
    "publishedAt": "2024-06-18T04:15:18Z"
  },
  {
    "videoId": "dYk7ywqazrA",
    "thumbnail": "https://i.ytimg.com/vi/dYk7ywqazrA/mqdefault.jpg",
    "title": "【スイカゲーム】アーニャ VS はあちゃま どっちが強いか勝負だ！！🔥【ホロライブ/#ちゃまあにゃ】",
    "publishedAt": "2024-06-18T10:48:05Z"
  },
  {
    "videoId": "FKkTi3SZVgU",
    "thumbnail": "https://i.ytimg.com/vi/FKkTi3SZVgU/mqdefault.jpg",
    "title": "【KARAOKE】かっこいい曲だらけっちゃま～～～🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-21T18:15:52Z"
  },
  {
    "videoId": "Q5hogpVta-0",
    "thumbnail": "https://i.ytimg.com/vi/Q5hogpVta-0/mqdefault.jpg",
    "title": "【飯テロ】もんじゃ焼きパーリナイ☆ミ【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-22T16:11:06Z"
  },
  {
    "videoId": "5KF6LYCTg0A",
    "thumbnail": "https://i.ytimg.com/vi/5KF6LYCTg0A/mqdefault.jpg",
    "title": "【ねおき】ごぉーーっぷすぅーー･･････････ZZZZ・・・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-23T01:12:55Z"
  },
  {
    "videoId": "09IsVFEP-4I",
    "thumbnail": "https://i.ytimg.com/vi/09IsVFEP-4I/mqdefault.jpg",
    "title": "【 Chained Together 】鎖に繋がれた仲間・・・はもういない。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-27T10:47:33Z"
  },
  {
    "videoId": "7havikuCgI0",
    "thumbnail": "https://i.ytimg.com/vi/7havikuCgI0/mqdefault.jpg",
    "title": "【Steamサマーセール】夏だ！セールだ！ゲーム三昧！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-28T11:18:30Z"
  },
  {
    "videoId": "1fW6WKXd8UQ",
    "thumbnail": "https://i.ytimg.com/vi/1fW6WKXd8UQ/mqdefault.jpg",
    "title": "【 夜食 】っっっく！！！抑えられないっ！！食べたい・・・・あ‘‘あ‘‘あ‘‘あ‘‘あ‘‘あ‘‘あ‘‘【ホロライブ/赤井はあと】",
    "publishedAt": "2024-06-29T15:42:55Z"
  },
  {
    "videoId": "RXHHDMawL5Y",
    "thumbnail": "https://i.ytimg.com/vi/RXHHDMawL5Y/mqdefault.jpg",
    "title": "【僕、アルバイトォォ！！】お客様？？？？？？？？？？？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-01T15:24:29Z"
  },
  {
    "videoId": "4PodFRbem8U",
    "thumbnail": "https://i.ytimg.com/vi/4PodFRbem8U/mqdefault.jpg",
    "title": "【COOKING】WELCOME TO JAPAN @NerissaRavencroft 🎉✨🍖【SUKIYAKI】",
    "publishedAt": "2024-07-02T10:17:35Z"
  },
  {
    "videoId": "3iLmRWaO4Q8",
    "thumbnail": "https://i.ytimg.com/vi/3iLmRWaO4Q8/mqdefault.jpg",
    "title": "【 激辛 】告知あり！過去一辛いかも・・・・・・😭【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-03T10:28:58Z"
  },
  {
    "videoId": "aVIrXp54yTg",
    "thumbnail": "https://i.ytimg.com/vi/aVIrXp54yTg/mqdefault.jpg",
    "title": "【人生初】極寒の中オーロラ旅へ向かう・・・！？【 in フィンランド】",
    "publishedAt": "2024-07-04T09:18:39Z"
  },
  {
    "videoId": "clKf5H6W4RQ",
    "thumbnail": "https://i.ytimg.com/vi/clKf5H6W4RQ/mqdefault.jpg",
    "title": "【NEW OUTFIT】えちかわな新衣装お披露目・・・！？🔥【#はあちゃま新衣装】",
    "publishedAt": "2024-07-09T13:04:57Z"
  },
  {
    "videoId": "_ZkIMw5dvMc",
    "thumbnail": "https://i.ytimg.com/vi/_ZkIMw5dvMc/mqdefault.jpg",
    "title": "【CHILL】マッチョ飼い始めました。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-10T10:52:42Z"
  },
  {
    "videoId": "qYJUanQNn_0",
    "thumbnail": "https://i.ytimg.com/vi/qYJUanQNn_0/mqdefault.jpg",
    "title": "【Q&A】WELCOME TO CHAMA BAR!! #HoloEN0 th🍹",
    "publishedAt": "2024-07-12T08:11:51Z"
  },
  {
    "videoId": "45g4Odr0ixw",
    "thumbnail": "https://i.ytimg.com/vi/45g4Odr0ixw/mqdefault.jpg",
    "title": "【Chained Together】落ちるなよ？精神統一だ・・・！！！！！！！！！【#ホロ料理部】",
    "publishedAt": "2024-07-12T15:23:38Z"
  },
  {
    "videoId": "pUXinRdxOfE",
    "thumbnail": "https://i.ytimg.com/vi/pUXinRdxOfE/mqdefault.jpg",
    "title": "【ぐあああ】- 失踪 - タケシ、お前の言う通りだった。この廃村はヤバすぎる。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-17T10:36:05Z"
  },
  {
    "videoId": "0qMBRzXMuOI",
    "thumbnail": "https://i.ytimg.com/vi/0qMBRzXMuOI/mqdefault.jpg",
    "title": "【全力で】しかのこのこのここしたんたん #shorts",
    "publishedAt": "2024-07-18T08:57:45Z"
  },
  {
    "videoId": "-ACrcuJbkkw",
    "thumbnail": "https://i.ytimg.com/vi/-ACrcuJbkkw/mqdefault.jpg",
    "title": "はじめまして、太ももです。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-18T09:06:36Z"
  },
  {
    "videoId": "vzdckr8uEMU",
    "thumbnail": "https://i.ytimg.com/vi/vzdckr8uEMU/mqdefault.jpg",
    "title": "【COOKING】MAKE SOME GOOD SH*T!! #HoloEN0 th🍔",
    "publishedAt": "2024-07-19T06:04:18Z"
  },
  {
    "videoId": "P178V-UD0jg",
    "thumbnail": "https://i.ytimg.com/vi/P178V-UD0jg/mqdefault.jpg",
    "title": "【 雑談 】ご注文はお決まりですかぁ～～～？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-21T16:35:10Z"
  },
  {
    "videoId": "byYvogv1pDs",
    "thumbnail": "https://i.ytimg.com/vi/byYvogv1pDs/mqdefault.jpg",
    "title": "【 予習 】なにやらホロライブARK始まるってよ・・・・・。会議【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-22T16:09:46Z"
  },
  {
    "videoId": "Y1SnGHzrUYg",
    "thumbnail": "https://i.ytimg.com/vi/Y1SnGHzrUYg/mqdefault.jpg",
    "title": "【＃ホロARK】大参戦！とにかくやってみるっきゃない！！！！！1日目【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-23T19:31:03Z"
  },
  {
    "videoId": "qgy16OQ-dL0",
    "thumbnail": "https://i.ytimg.com/vi/qgy16OQ-dL0/mqdefault.jpg",
    "title": "【＃ホロARK】ミッションいくぞ！最強になるんだあああ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-24T11:28:19Z"
  },
  {
    "videoId": "UDc9GC_VPek",
    "thumbnail": "https://i.ytimg.com/vi/UDc9GC_VPek/mqdefault.jpg",
    "title": "【＃ホロARK】はあちゃまは強くなるんだあああああ！！！2日目【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-24T18:08:23Z"
  },
  {
    "videoId": "wRYPR22w3PQ",
    "thumbnail": "https://i.ytimg.com/vi/wRYPR22w3PQ/mqdefault.jpg",
    "title": "【＃ホロARK】心臓を捧げっちゃま～～～！！！！！！！！！6日目【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-28T16:28:11Z"
  },
  {
    "videoId": "aUnxGEizyj8",
    "thumbnail": "https://i.ytimg.com/vi/aUnxGEizyj8/mqdefault.jpg",
    "title": "【#ホロARK】レイドにイベントにたのしむぞおおお～！🔥7日目【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-29T16:43:20Z"
  },
  {
    "videoId": "Yrt3H4VqIgI",
    "thumbnail": "https://i.ytimg.com/vi/Yrt3H4VqIgI/mqdefault.jpg",
    "title": "【#ホロARK】RIP『ちゃまのこさうるす』、しかし戦いは続く・・・！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-30T12:48:14Z"
  },
  {
    "videoId": "ACc_QQM0ymA",
    "thumbnail": "https://i.ytimg.com/vi/ACc_QQM0ymA/mqdefault.jpg",
    "title": "【#ホロARK】最後まで悔いなくたのしむぞおおおお！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-07-31T15:48:54Z"
  },
  {
    "videoId": "FkL5yJFkLMM",
    "thumbnail": "https://i.ytimg.com/vi/FkL5yJFkLMM/mqdefault.jpg",
    "title": "【 作戦会議 】夏だ！サマーだ！はあちゃまだ！！！🍉【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-03T16:36:39Z"
  },
  {
    "videoId": "wrxOGwp3uOw",
    "thumbnail": "https://i.ytimg.com/vi/wrxOGwp3uOw/mqdefault.jpg",
    "title": "【重大告知】！！！！！！！！！！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-08T14:23:46Z"
  },
  {
    "videoId": "NYkd50rRhUA",
    "thumbnail": "https://i.ytimg.com/vi/NYkd50rRhUA/mqdefault.jpg",
    "title": "【カウントダウン】うまれちゃった・・・・・☆彡【#はあちゃま爆誕祭2024】",
    "publishedAt": "2024-08-09T15:36:36Z"
  },
  {
    "videoId": "e4UUQwhMR4o",
    "thumbnail": "https://i.ytimg.com/vi/e4UUQwhMR4o/mqdefault.jpg",
    "title": "【#はあちゃま爆誕祭2024】🤪❤️‍🔥👆爆誕3DLIVE❤️‍🔥👆🤪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-10T11:59:07Z"
  },
  {
    "videoId": "8WphWiNYbzk",
    "thumbnail": "https://i.ytimg.com/vi/8WphWiNYbzk/mqdefault.jpg",
    "title": "BAN RTA / 赤井はあと (Official)【Original 3D MV】",
    "publishedAt": "2024-08-10T12:05:08Z"
  },
  {
    "videoId": "hfqgNwQhNyc",
    "thumbnail": "https://i.ytimg.com/vi/hfqgNwQhNyc/mqdefault.jpg",
    "title": "【裏話】感謝を込めて #はあちゃま爆誕祭2024 振り返るぜ・・・！❤️‍🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-11T12:03:57Z"
  },
  {
    "videoId": "aQZHjp5vD3U",
    "thumbnail": "https://i.ytimg.com/vi/aQZHjp5vD3U/mqdefault.jpg",
    "title": "悪のはあちゃま時代がやってきた・・・！#BANRTA #vtuber #ホロライブ",
    "publishedAt": "2024-08-11T15:04:32Z"
  },
  {
    "videoId": "re8xzZ4qMe0",
    "thumbnail": "https://i.ytimg.com/vi/re8xzZ4qMe0/mqdefault.jpg",
    "title": "【ドッキリ】⚠見るな危険⚠【DON'T LOOK!!!】",
    "publishedAt": "2024-08-16T10:01:02Z"
  },
  {
    "videoId": "f96XfRHpA8g",
    "thumbnail": "https://i.ytimg.com/vi/f96XfRHpA8g/mqdefault.jpg",
    "title": "【ドッキリ】Don’t be afraid.....................【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-16T12:58:06Z"
  },
  {
    "videoId": "zX18l7gc0_A",
    "thumbnail": "https://i.ytimg.com/vi/zX18l7gc0_A/mqdefault.jpg",
    "title": "I'm a PERFECT HUMAN........なっ！？#ホロライブ #ホロライブ切り抜き #hololive @OmaruPolka",
    "publishedAt": "2024-08-16T16:45:48Z"
  },
  {
    "videoId": "A_ZV9-nNzhw",
    "thumbnail": "https://i.ytimg.com/vi/A_ZV9-nNzhw/mqdefault.jpg",
    "title": "PERFECT HUMAN┊HAACHAMA （推しカメラ）♫RADIO FISH @OmaruPolka",
    "publishedAt": "2024-08-16T16:57:23Z"
  },
  {
    "videoId": "Tfz7Hr2vEa4",
    "thumbnail": "https://i.ytimg.com/vi/Tfz7Hr2vEa4/mqdefault.jpg",
    "title": "BAN RTA ┊HAACHAMA（推しカメラ）✧︎ ダンス映像！",
    "publishedAt": "2024-08-17T06:51:21Z"
  },
  {
    "videoId": "_OAhuQySSrU",
    "thumbnail": "https://i.ytimg.com/vi/_OAhuQySSrU/mqdefault.jpg",
    "title": "狂気とセクシーに満ち溢れたはあちゃまのダンス！💃💃💃#はあちゃま爆誕祭2024 #hololiveclip #ホロライブ",
    "publishedAt": "2024-08-17T07:14:32Z"
  },
  {
    "videoId": "tV1qRoBqnlg",
    "thumbnail": "https://i.ytimg.com/vi/tV1qRoBqnlg/mqdefault.jpg",
    "title": "【Minecraft】あてぃし、湊あくあ。【他のホロメンのモノマネをしながら一枠配信を取る】",
    "publishedAt": "2024-08-17T10:41:54Z"
  },
  {
    "videoId": "sytGyP9CvTw",
    "thumbnail": "https://i.ytimg.com/vi/sytGyP9CvTw/mqdefault.jpg",
    "title": "失礼しますがRIP♡┊HAACHAMA （推しカメラ）♫@MoriCalliope #はあちゃま爆誕祭2024 #hololiveclip #ホロライブ",
    "publishedAt": "2024-08-17T13:38:54Z"
  },
  {
    "videoId": "NViWVqXasXo",
    "thumbnail": "https://i.ytimg.com/vi/NViWVqXasXo/mqdefault.jpg",
    "title": "………………!!!😈#はあちゃま爆誕祭2024 #hololiveclip #ホロライブ @MoriCalliope",
    "publishedAt": "2024-08-17T13:46:49Z"
  },
  {
    "videoId": "_JsnGU3YPio",
    "thumbnail": "https://i.ytimg.com/vi/_JsnGU3YPio/mqdefault.jpg",
    "title": "がんばる君へ、ちゃまをお届け🎧 💓 -作業用BGM- 【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-18T21:31:45Z"
  },
  {
    "videoId": "kzIpNwKWxZw",
    "thumbnail": "https://i.ytimg.com/vi/kzIpNwKWxZw/mqdefault.jpg",
    "title": "合法的トビ方ノススメ✧︎Creepy nuts @LaplusDarknesss #はあちゃま爆誕祭2024 #hololiveclip #ホロライブ",
    "publishedAt": "2024-08-19T15:06:40Z"
  },
  {
    "videoId": "h5BqW7FL_-E",
    "thumbnail": "https://i.ytimg.com/vi/h5BqW7FL_-E/mqdefault.jpg",
    "title": "カップルチャンネル爆誕！？💍Love so sweet┊︎嵐 #はあちゃま爆誕祭2024 #ホロライブ #ホロライブ切り抜き #vtuber @TsunomakiWatame",
    "publishedAt": "2024-08-22T09:29:26Z"
  },
  {
    "videoId": "zFMjRZBI5YU",
    "thumbnail": "https://i.ytimg.com/vi/zFMjRZBI5YU/mqdefault.jpg",
    "title": "【お宝マウンテン】ホロメンつみつみまくり～～～～～ちゃまっ🌟【赤井はあと/ホロライブ】",
    "publishedAt": "2024-08-23T11:32:58Z"
  },
  {
    "videoId": "03w-t06FjaU",
    "thumbnail": "https://i.ytimg.com/vi/03w-t06FjaU/mqdefault.jpg",
    "title": "【エア同時視聴】ジブリの「となりのトトロ」同時視ちゃま！🌟金曜ロードショー【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-23T14:11:03Z"
  },
  {
    "videoId": "Hp2UM4bS3WQ",
    "thumbnail": "https://i.ytimg.com/vi/Hp2UM4bS3WQ/mqdefault.jpg",
    "title": "【オフコラボ】ロボちゃまの夜更かし。@Robocosan",
    "publishedAt": "2024-08-24T18:42:18Z"
  },
  {
    "videoId": "6ZB5E1NxwDU",
    "thumbnail": "https://i.ytimg.com/vi/6ZB5E1NxwDU/mqdefault.jpg",
    "title": "【龍が如く８】完全初見！！🐉とりまかちこみじゃあ！！！！！【ネタバレあり】【赤井はあと/ホロライブ】",
    "publishedAt": "2024-08-25T21:24:25Z"
  },
  {
    "videoId": "UYYyid7XLOg",
    "thumbnail": "https://i.ytimg.com/vi/UYYyid7XLOg/mqdefault.jpg",
    "title": "ギリギリダンス #はいよろこんで #踊ってみた #youtubeshorts #trending",
    "publishedAt": "2024-08-27T09:24:25Z"
  },
  {
    "videoId": "4W1A7v6e-HI",
    "thumbnail": "https://i.ytimg.com/vi/4W1A7v6e-HI/mqdefault.jpg",
    "title": "保健室で眼帯をねだるちゃま。 #youtubeshorts #hololive",
    "publishedAt": "2024-08-29T09:24:52Z"
  },
  {
    "videoId": "YjxiNauuWCQ",
    "thumbnail": "https://i.ytimg.com/vi/YjxiNauuWCQ/mqdefault.jpg",
    "title": "【エア同時視聴】「天空の城のラピュタ」金曜ロードショー【赤井はあと/ホロライブ】",
    "publishedAt": "2024-08-30T15:13:15Z"
  },
  {
    "videoId": "vud1gwlV-qY",
    "thumbnail": "https://i.ytimg.com/vi/vud1gwlV-qY/mqdefault.jpg",
    "title": "家　族　凸　待　ち　｜夏休み最終日【ホロライブ/赤井はあと】",
    "publishedAt": "2024-08-31T15:10:33Z"
  },
  {
    "videoId": "JM8kl3nXbwQ",
    "thumbnail": "https://i.ytimg.com/vi/JM8kl3nXbwQ/mqdefault.jpg",
    "title": "【告知】ついにアイツを出す時が来たか・・・・・・【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-03T10:16:23Z"
  },
  {
    "videoId": "hEREbySGRCE",
    "thumbnail": "https://i.ytimg.com/vi/hEREbySGRCE/mqdefault.jpg",
    "title": "保健室で #BANRTAダンス 踊ってみた！❤️‍🩹 #youtubeshorts #踊ってみた  #vtuber",
    "publishedAt": "2024-09-06T09:49:35Z"
  },
  {
    "videoId": "Qh7yVxIOykk",
    "thumbnail": "https://i.ytimg.com/vi/Qh7yVxIOykk/mqdefault.jpg",
    "title": "【NEW OUTFIT】血ゃ舞ってる奴いる！？＿＿＿＿いるよなぁ！！！？【新衣装お披露目/ホロライブ】",
    "publishedAt": "2024-09-06T13:15:26Z"
  },
  {
    "videoId": "OmEK-Q629oo",
    "thumbnail": "https://i.ytimg.com/vi/OmEK-Q629oo/mqdefault.jpg",
    "title": "やる気になる、ちゃまをお届け🎧⚡ -作業用BGM-【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-10T16:06:59Z"
  },
  {
    "videoId": "2QPPG6-9Za4",
    "thumbnail": "https://i.ytimg.com/vi/2QPPG6-9Za4/mqdefault.jpg",
    "title": "BAN RTA..................",
    "publishedAt": "2024-09-12T15:17:44Z"
  },
  {
    "videoId": "MphAJ-OoRVk",
    "thumbnail": "https://i.ytimg.com/vi/MphAJ-OoRVk/mqdefault.jpg",
    "title": "【お宝マウンテン】#夏色はあと で対決する時が来た・・・！？【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-13T10:44:41Z"
  },
  {
    "videoId": "7qjscR8wJe8",
    "thumbnail": "https://i.ytimg.com/vi/7qjscR8wJe8/mqdefault.jpg",
    "title": "壺男とイチ推しトーク振り返る！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-16T15:09:35Z"
  },
  {
    "videoId": "6D3HjzqF-R0",
    "thumbnail": "https://i.ytimg.com/vi/6D3HjzqF-R0/mqdefault.jpg",
    "title": "【#holoGTA】最強ギャングになるっちゃま！！！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-17T16:26:19Z"
  },
  {
    "videoId": "8RHs3F--A58",
    "thumbnail": "https://i.ytimg.com/vi/8RHs3F--A58/mqdefault.jpg",
    "title": "【#holoGTA】大人のギャング、ちゃま・・・・・・【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-18T16:46:23Z"
  },
  {
    "videoId": "lnehpuqHyF4",
    "thumbnail": "https://i.ytimg.com/vi/lnehpuqHyF4/mqdefault.jpg",
    "title": "【#holoGTA】ギャングに始まり、ギャングで終わる。【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-19T16:38:33Z"
  },
  {
    "videoId": "sCwcjWaiwBs",
    "thumbnail": "https://i.ytimg.com/vi/sCwcjWaiwBs/mqdefault.jpg",
    "title": "居酒屋でBAN RTA💃",
    "publishedAt": "2024-09-28T10:40:08Z"
  },
  {
    "videoId": "JcnD0tMweOQ",
    "thumbnail": "https://i.ytimg.com/vi/JcnD0tMweOQ/mqdefault.jpg",
    "title": "【寝る前に】壺男とアメリカ旅行の話！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-09-28T16:20:36Z"
  },
  {
    "videoId": "I-67b13zFzA",
    "thumbnail": "https://i.ytimg.com/vi/I-67b13zFzA/mqdefault.jpg",
    "title": "【FREE TALK】10月はじめの！こっそりおしゃべり♡【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-01T00:45:09Z"
  },
  {
    "videoId": "Y10LYonh3sw",
    "thumbnail": "https://i.ytimg.com/vi/Y10LYonh3sw/mqdefault.jpg",
    "title": "気晴らしに壺おじする！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-01T13:28:37Z"
  },
  {
    "videoId": "1MUrgIaIVTs",
    "thumbnail": "https://i.ytimg.com/vi/1MUrgIaIVTs/mqdefault.jpg",
    "title": "【FREE TALK】ほんのり酔い！乾杯しよ～！！！♡【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-05T22:02:05Z"
  },
  {
    "videoId": "QurzSoOib84",
    "thumbnail": "https://i.ytimg.com/vi/QurzSoOib84/mqdefault.jpg",
    "title": "【龍が如く８】完全初見！！！🐉気合で勝負じゃあああ！！！【ネタバレあり】【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-09T15:52:38Z"
  },
  {
    "videoId": "qkVL__RIaok",
    "thumbnail": "https://i.ytimg.com/vi/qkVL__RIaok/mqdefault.jpg",
    "title": "【歌枠】気ままに歌います。🎇【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-11T15:11:51Z"
  },
  {
    "videoId": "36OY9jnzarg",
    "thumbnail": "https://i.ytimg.com/vi/36OY9jnzarg/mqdefault.jpg",
    "title": "朝から壺おじ雑談！🌅【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-12T03:20:50Z"
  },
  {
    "videoId": "kR0hfKajaM4",
    "thumbnail": "https://i.ytimg.com/vi/kR0hfKajaM4/mqdefault.jpg",
    "title": "【 ASMR 】癖になる良い音💭Ear Massage/Sleep Whispering/KU100【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-16T16:22:48Z"
  },
  {
    "videoId": "sHPFhmzyIgs",
    "thumbnail": "https://i.ytimg.com/vi/sHPFhmzyIgs/mqdefault.jpg",
    "title": "【同時視聴】『ヴェノム/Venom』#ホロとヴェノム観ろ だ！！！！！！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-17T11:19:35Z"
  },
  {
    "videoId": "YuXCutGlIPI",
    "thumbnail": "https://i.ytimg.com/vi/YuXCutGlIPI/mqdefault.jpg",
    "title": "【Lethal Company】ウチら4人がいれば最強～～～！怖いもんなし！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-18T15:26:56Z"
  },
  {
    "videoId": "q7osZZe6naE",
    "thumbnail": "https://i.ytimg.com/vi/q7osZZe6naE/mqdefault.jpg",
    "title": "【歌枠】最強かわいいアイドル曲うたう！♡【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-19T11:17:08Z"
  },
  {
    "videoId": "VPZb2ykMJYo",
    "thumbnail": "https://i.ytimg.com/vi/VPZb2ykMJYo/mqdefault.jpg",
    "title": "【FREE TALK】もしもし、はあちゃまよ♡今あなたの前に……【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-20T15:05:16Z"
  },
  {
    "videoId": "Z_LwGCmrkPE",
    "thumbnail": "https://i.ytimg.com/vi/Z_LwGCmrkPE/mqdefault.jpg",
    "title": "【同時視聴】『ヴェノム：レット・ゼア・ビー・カーネイジ』#ホロとヴェノム観ろ だ！！！！！！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-23T12:15:30Z"
  },
  {
    "videoId": "5f9v8M1reec",
    "thumbnail": "https://i.ytimg.com/vi/5f9v8M1reec/mqdefault.jpg",
    "title": "【 ASMR 】眠れる読み聞かせ📚Ear Massage/Sleep Whispering/KU100【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-23T16:04:23Z"
  },
  {
    "videoId": "kdNOgAn5T4A",
    "thumbnail": "https://i.ytimg.com/vi/kdNOgAn5T4A/mqdefault.jpg",
    "title": "【ギャルゲ】何やらヤバい予感・・・【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-25T16:14:19Z"
  },
  {
    "videoId": "PtYmhh4vfGI",
    "thumbnail": "https://i.ytimg.com/vi/PtYmhh4vfGI/mqdefault.jpg",
    "title": "【歌枠】最強ロックにいくぜぇ！！！🔥【赤井はあと/ホロライブ】",
    "publishedAt": "2024-10-26T12:21:29Z"
  },
  {
    "videoId": "uUICBUJjle4",
    "thumbnail": "https://i.ytimg.com/vi/uUICBUJjle4/mqdefault.jpg",
    "title": "ਮ　ᘄ　⇂ȷ̶　ﾅ ̵̲   ㄘ  ԣ  𖤟",
    "publishedAt": "2024-10-30T15:01:13Z"
  },
  {
    "videoId": "miTDNq6GVYc",
    "thumbnail": "https://i.ytimg.com/vi/miTDNq6GVYc/mqdefault.jpg",
    "title": "狂気のモンスターつくった！【はあちゃまクッキング×ヴェノム編】",
    "publishedAt": "2024-10-31T10:01:05Z"
  },
  {
    "videoId": "YXX5QSVaRsE",
    "thumbnail": "https://i.ytimg.com/vi/YXX5QSVaRsE/mqdefault.jpg",
    "title": "【歌枠】ぬくぬく温泉カラオケ～★【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-01T15:21:59Z"
  },
  {
    "videoId": "JDSt-f6SzUY",
    "thumbnail": "https://i.ytimg.com/vi/JDSt-f6SzUY/mqdefault.jpg",
    "title": "【 ASMR 】真夜中の読み聞かせ⛩️Ear Massage/Sleep Whispering/KU100【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-02T16:54:14Z"
  },
  {
    "videoId": "NugGhLd_9lI",
    "thumbnail": "https://i.ytimg.com/vi/NugGhLd_9lI/mqdefault.jpg",
    "title": "旅に出る。おじいちゃんの後をつけて・・・【Old Man's Journey】",
    "publishedAt": "2024-11-08T16:59:10Z"
  },
  {
    "videoId": "10MjwU1pSLM",
    "thumbnail": "https://i.ytimg.com/vi/10MjwU1pSLM/mqdefault.jpg",
    "title": "【#1期生お披露目リレー配信 】ついに見せる時が来たわね・・・バサァ！！！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-09T10:48:56Z"
  },
  {
    "videoId": "xaBL5I-Cm5A",
    "thumbnail": "https://i.ytimg.com/vi/xaBL5I-Cm5A/mqdefault.jpg",
    "title": "【歌枠】全力夜更かしタイムだぁ～！！！💣【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-09T18:35:32Z"
  },
  {
    "videoId": "AlL8GlIxJ7k",
    "thumbnail": "https://i.ytimg.com/vi/AlL8GlIxJ7k/mqdefault.jpg",
    "title": "【歌枠】星に包まれてぐっすり...🌟【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-15T15:43:22Z"
  },
  {
    "videoId": "FEjPNQE3RMs",
    "thumbnail": "https://i.ytimg.com/vi/FEjPNQE3RMs/mqdefault.jpg",
    "title": "むむむ。【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-16T18:13:00Z"
  },
  {
    "videoId": "vbPmw_-7cxk",
    "thumbnail": "https://i.ytimg.com/vi/vbPmw_-7cxk/mqdefault.jpg",
    "title": "ENGLISH ENGLISH ENGLISH ENGLISH ENGLISH ENGLISH ENGLISH ENGLISH EN......GLISH???",
    "publishedAt": "2024-11-17T18:24:34Z"
  },
  {
    "videoId": "WFatuNgGbU4",
    "thumbnail": "https://i.ytimg.com/vi/WFatuNgGbU4/mqdefault.jpg",
    "title": "【歌枠】お・い・ろ・け..........💔【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-18T13:25:31Z"
  },
  {
    "videoId": "TnbY43G4q10",
    "thumbnail": "https://i.ytimg.com/vi/TnbY43G4q10/mqdefault.jpg",
    "title": "【 ASMR 】最強すやすや永眠💓Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2024-11-19T16:34:58Z"
  },
  {
    "videoId": "g2PEb9rg6SY",
    "thumbnail": "https://i.ytimg.com/vi/g2PEb9rg6SY/mqdefault.jpg",
    "title": "【Minecraft】うるとらこっそり【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-20T21:47:58Z"
  },
  {
    "videoId": "IgNLbpazgic",
    "thumbnail": "https://i.ytimg.com/vi/IgNLbpazgic/mqdefault.jpg",
    "title": "【】【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-21T21:35:53Z"
  },
  {
    "videoId": "Onk2Qalo4bk",
    "thumbnail": "https://i.ytimg.com/vi/Onk2Qalo4bk/mqdefault.jpg",
    "title": "【歌枠】秋の失恋ソング祭り!!!【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-22T16:41:42Z"
  },
  {
    "videoId": "Oaiaz4FJDRs",
    "thumbnail": "https://i.ytimg.com/vi/Oaiaz4FJDRs/mqdefault.jpg",
    "title": "・・・？【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-23T23:52:30Z"
  },
  {
    "videoId": "sMT2LsdAvmk",
    "thumbnail": "https://i.ytimg.com/vi/sMT2LsdAvmk/mqdefault.jpg",
    "title": "ERROR 404 NOT FOUND.............................................................",
    "publishedAt": "2024-11-25T03:12:43Z"
  },
  {
    "videoId": "2zPAWwtsWAw",
    "thumbnail": "https://i.ytimg.com/vi/2zPAWwtsWAw/mqdefault.jpg",
    "title": "ｚｚｚ（※すべて寝言）【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-25T22:36:01Z"
  },
  {
    "videoId": "0Prl6VmCepM",
    "thumbnail": "https://i.ytimg.com/vi/0Prl6VmCepM/mqdefault.jpg",
    "title": "【 ASMR 】激甘ほろよい永眠💭Ear Massage/Sleep Whispering/KU100【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-26T16:37:44Z"
  },
  {
    "videoId": "88Uf8-tV1gY",
    "thumbnail": "https://i.ytimg.com/vi/88Uf8-tV1gY/mqdefault.jpg",
    "title": "【Minecraft】もーにんぐまったり【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-26T22:45:12Z"
  },
  {
    "videoId": "tNc2cu5Wi4I",
    "thumbnail": "https://i.ytimg.com/vi/tNc2cu5Wi4I/mqdefault.jpg",
    "title": "【COSPLAY CONTEST!!】ゆるホロコスプレ選手権！やってみた・・・！？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-11-27T15:17:57Z"
  },
  {
    "videoId": "rSDtbM1wrnQ",
    "thumbnail": "https://i.ytimg.com/vi/rSDtbM1wrnQ/mqdefault.jpg",
    "title": "【#新人Vtuber】はじめての歌枠！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-28T15:56:17Z"
  },
  {
    "videoId": "VYgsscJyeBM",
    "thumbnail": "https://i.ytimg.com/vi/VYgsscJyeBM/mqdefault.jpg",
    "title": "【歌枠】いっぱいバラードを歌いつくす！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-11-30T20:47:34Z"
  },
  {
    "videoId": "-zGRQj-H--M",
    "thumbnail": "https://i.ytimg.com/vi/-zGRQj-H--M/mqdefault.jpg",
    "title": "【Steamオータムセール】ゲームの秋！まったりセールみよ～～～！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-02T09:10:17Z"
  },
  {
    "videoId": "yHLwv46yGag",
    "thumbnail": "https://i.ytimg.com/vi/yHLwv46yGag/mqdefault.jpg",
    "title": "【 Detroit: Become Human 】はあちゃま、世界を変える！ギリギリの戦い・・・！｜前半【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-02T23:37:06Z"
  },
  {
    "videoId": "RCuLie98Dms",
    "thumbnail": "https://i.ytimg.com/vi/RCuLie98Dms/mqdefault.jpg",
    "title": "【雑談】あたらしい朝が来た！【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-03T23:57:10Z"
  },
  {
    "videoId": "-wm7MmQ5M_o",
    "thumbnail": "https://i.ytimg.com/vi/-wm7MmQ5M_o/mqdefault.jpg",
    "title": "【HOLOCURE】FIRST TIME TO PLAY!!! ...IN ENGLISH【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-04T10:05:27Z"
  },
  {
    "videoId": "h7si-U-z2_Q",
    "thumbnail": "https://i.ytimg.com/vi/h7si-U-z2_Q/mqdefault.jpg",
    "title": "【重大】赤井はあとからお話があります。【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-05T13:37:22Z"
  },
  {
    "videoId": "OfMRbViwNGo",
    "thumbnail": "https://i.ytimg.com/vi/OfMRbViwNGo/mqdefault.jpg",
    "title": "【 ASMR 】君と海でぐっすり🏖️Ear Massage/Sleep Whispering/KU100【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-05T16:43:55Z"
  },
  {
    "videoId": "0qEg65WXf4s",
    "thumbnail": "https://i.ytimg.com/vi/0qEg65WXf4s/mqdefault.jpg",
    "title": "【雑談】よふかしのちゃまお【ホロライブ】",
    "publishedAt": "2024-12-05T22:14:58Z"
  },
  {
    "videoId": "-CP55tXPJx8",
    "thumbnail": "https://i.ytimg.com/vi/-CP55tXPJx8/mqdefault.jpg",
    "title": "【 Detroit: Become Human 】はあちゃま、世界を変える！ラストまでいくぞ～！！！｜後半【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-07T15:42:35Z"
  },
  {
    "videoId": "Rud47jbpADc",
    "thumbnail": "https://i.ytimg.com/vi/Rud47jbpADc/mqdefault.jpg",
    "title": "【雑】もしもし？【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-07T18:14:59Z"
  },
  {
    "videoId": "9T7j8ogN8sA",
    "thumbnail": "https://i.ytimg.com/vi/9T7j8ogN8sA/mqdefault.jpg",
    "title": "【歌枠】あさの癒しソングうたうよ！♡【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-08T00:22:38Z"
  },
  {
    "videoId": "uKPnQkchxxY",
    "thumbnail": "https://i.ytimg.com/vi/uKPnQkchxxY/mqdefault.jpg",
    "title": "【NEW OUTFIT REVEAL】ついに・・・！？#赤井はあと新衣装2024【赤井はあと/ホロライブ】",
    "publishedAt": "2024-12-09T10:04:39Z"
  },
  {
    "videoId": "c0EuOL_k7dI",
    "thumbnail": "https://i.ytimg.com/vi/c0EuOL_k7dI/mqdefault.jpg",
    "title": "【 DON'T SCREAM 】絶望的すぎるエンドを迎えました・・・。【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-10T15:33:28Z"
  },
  {
    "videoId": "JR9o1k0K1kA",
    "thumbnail": "https://i.ytimg.com/vi/JR9o1k0K1kA/mqdefault.jpg",
    "title": "【 帰ってきた 魔界村 】負けられない戦いのはじまりよ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-11T20:54:34Z"
  },
  {
    "videoId": "7NK783Gzu4s",
    "thumbnail": "https://i.ytimg.com/vi/7NK783Gzu4s/mqdefault.jpg",
    "title": "【 歌枠 】寝る前にのーんびり歌う♪【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-12T18:21:58Z"
  },
  {
    "videoId": "rRcfVdGbsns",
    "thumbnail": "https://i.ytimg.com/vi/rRcfVdGbsns/mqdefault.jpg",
    "title": "【帰ってきた 魔界村】負けてたまるか～！！！やれるとこまでやる！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-15T20:10:26Z"
  },
  {
    "videoId": "0E_8g-1Bblg",
    "thumbnail": "https://i.ytimg.com/vi/0E_8g-1Bblg/mqdefault.jpg",
    "title": "【 あつまれ どうぶつの森 】島の様子をみにいく朝！！！のんびり～【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-15T22:00:11Z"
  },
  {
    "videoId": "3bRGupHTr-E",
    "thumbnail": "https://i.ytimg.com/vi/3bRGupHTr-E/mqdefault.jpg",
    "title": "ｗｅｌｃｏｍｅ！💖【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-16T22:33:53Z"
  },
  {
    "videoId": "za53a55HziU",
    "thumbnail": "https://i.ytimg.com/vi/za53a55HziU/mqdefault.jpg",
    "title": "ねおきのくもくも聖人ちゃま！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-18T23:40:39Z"
  },
  {
    "videoId": "ylw7myDD3sQ",
    "thumbnail": "https://i.ytimg.com/vi/ylw7myDD3sQ/mqdefault.jpg",
    "title": "【朝ちゃま】みんなおっはよ～！みんな大好き朝ちゃまの時間！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-22T01:05:58Z"
  },
  {
    "videoId": "GRCRoNUmcvI",
    "thumbnail": "https://i.ytimg.com/vi/GRCRoNUmcvI/mqdefault.jpg",
    "title": "【同時視聴】「i,ROBOT」一緒にみよ～～～～～～！🎥✨【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-22T13:20:23Z"
  },
  {
    "videoId": "6Ujh2vVgW2A",
    "thumbnail": "https://i.ytimg.com/vi/6Ujh2vVgW2A/mqdefault.jpg",
    "title": "【 LITTLE NIGHTMARES 】悪夢から脱出するホラゲ・・・！！！【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2024-12-23T14:04:21Z"
  },
  {
    "videoId": "m-YosXlNifo",
    "thumbnail": "https://i.ytimg.com/vi/m-YosXlNifo/mqdefault.jpg",
    "title": "クリスマス・イブ・カウントダウン！🎄🎅【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-23T15:12:20Z"
  },
  {
    "videoId": "jInCaUyMyYM",
    "thumbnail": "https://i.ytimg.com/vi/jInCaUyMyYM/mqdefault.jpg",
    "title": "クリスマス🦌COOKING🎅🎄✨【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-24T10:05:20Z"
  },
  {
    "videoId": "T0DBq0wuk0I",
    "thumbnail": "https://i.ytimg.com/vi/T0DBq0wuk0I/mqdefault.jpg",
    "title": "【歌ってみた】撲殺天使ドクロちゃん【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-24T15:00:06Z"
  },
  {
    "videoId": "ETFfAShryL4",
    "thumbnail": "https://i.ytimg.com/vi/ETFfAShryL4/mqdefault.jpg",
    "title": "【クリスマスに】撲殺天使ドクロちゃん【歌ってみた】",
    "publishedAt": "2024-12-24T15:00:16Z"
  },
  {
    "videoId": "JfbZ4zkZStc",
    "thumbnail": "https://i.ytimg.com/vi/JfbZ4zkZStc/mqdefault.jpg",
    "title": "不穏なゲームでクリスマスを迎える・・・・【DYPING】",
    "publishedAt": "2024-12-24T15:03:34Z"
  },
  {
    "videoId": "Y0MSUO1PatA",
    "thumbnail": "https://i.ytimg.com/vi/Y0MSUO1PatA/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】心に染みる曲うたうぞ～～～！💘【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-25T05:42:45Z"
  },
  {
    "videoId": "CZkgYDnPtnE",
    "thumbnail": "https://i.ytimg.com/vi/CZkgYDnPtnE/mqdefault.jpg",
    "title": "【#ほしちゃま】闇のクリスマスパーティ！🎄【ホロライブ/赤井はあと/にじさんじ/星川サラ】",
    "publishedAt": "2024-12-25T13:15:07Z"
  },
  {
    "videoId": "uIQvI1KH8R4",
    "thumbnail": "https://i.ytimg.com/vi/uIQvI1KH8R4/mqdefault.jpg",
    "title": "【無】・・・・・・・・・【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-25T16:56:33Z"
  },
  {
    "videoId": "ncUHU4BaFxE",
    "thumbnail": "https://i.ytimg.com/vi/ncUHU4BaFxE/mqdefault.jpg",
    "title": "#1【 ドラゴンボールZ KAKAROT 】完全初見！ドラゴンボールの世界へ突入だあああ！🔥【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2024-12-26T14:46:10Z"
  },
  {
    "videoId": "95OElW-j8yk",
    "thumbnail": "https://i.ytimg.com/vi/95OElW-j8yk/mqdefault.jpg",
    "title": "#2【 ドラゴンボールZ KAKAROT 】完全初見！ドラゴンボールの世界で最強になるぞおおお！🔥【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2024-12-27T16:44:41Z"
  },
  {
    "videoId": "1tuKKFxidrg",
    "thumbnail": "https://i.ytimg.com/vi/1tuKKFxidrg/mqdefault.jpg",
    "title": "【 DARK SOULS III 】ゴリ押しこそ正義なり！初見のダクソ！【ホロライブ/赤井はあと】",
    "publishedAt": "2024-12-31T05:36:52Z"
  },
  {
    "videoId": "rR12KvmUYYQ",
    "thumbnail": "https://i.ytimg.com/vi/rR12KvmUYYQ/mqdefault.jpg",
    "title": "【新年】2025年！あけましておめでとん！今年もよろしくなああああ！🎍✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-02T00:11:53Z"
  },
  {
    "videoId": "BWBZS-meSOI",
    "thumbnail": "https://i.ytimg.com/vi/BWBZS-meSOI/mqdefault.jpg",
    "title": "#3【 ドラゴンボールZ KAKAROT 】完全初見！ドラゴンボールの世界で最強になるぞおおお！🔥【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2025-01-08T13:26:09Z"
  },
  {
    "videoId": "lfjhz_F1S40",
    "thumbnail": "https://i.ytimg.com/vi/lfjhz_F1S40/mqdefault.jpg",
    "title": "#4【 ドラゴンボールZ KAKAROT 】完全初見！ドラゴンボールの世界で超エンジョイだあああ！🔥【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2025-01-09T07:22:28Z"
  },
  {
    "videoId": "DmbbRx9Tum4",
    "thumbnail": "https://i.ytimg.com/vi/DmbbRx9Tum4/mqdefault.jpg",
    "title": "#5【 ドラゴンボールZ KAKAROT 】完全初見！ドラゴンボールの世界で最強になるぞおおお！🔥【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2025-01-15T14:27:38Z"
  },
  {
    "videoId": "w-oHPTR_lAQ",
    "thumbnail": "https://i.ytimg.com/vi/w-oHPTR_lAQ/mqdefault.jpg",
    "title": "#最終回【 ドラゴンボールZ KAKAROT 】完全初見！ドラゴンボールの世界で熱くバトルだああああ！🔥【ホロライブ/赤井はあと】※ネタバレあり",
    "publishedAt": "2025-01-16T10:37:58Z"
  },
  {
    "videoId": "XTqiaM0Slhw",
    "thumbnail": "https://i.ytimg.com/vi/XTqiaM0Slhw/mqdefault.jpg",
    "title": "【 ASMR 】お風呂でこっそり永眠🛀💕Ear Massage/Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-16T16:45:50Z"
  },
  {
    "videoId": "wAEevP_HvHA",
    "thumbnail": "https://i.ytimg.com/vi/wAEevP_HvHA/mqdefault.jpg",
    "title": "【 激辛 】限界を超えていけえぇぇ！！！？完食すべし🔥【 チャレンジ 】",
    "publishedAt": "2025-01-17T10:02:07Z"
  },
  {
    "videoId": "r8ayjEZoc-I",
    "thumbnail": "https://i.ytimg.com/vi/r8ayjEZoc-I/mqdefault.jpg",
    "title": "【 DARK SOULS III 】ゴリ押し魔導士！気合でいくぞおおお～！初見のダクソ！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-19T11:15:46Z"
  },
  {
    "videoId": "hs87ZR5KgXs",
    "thumbnail": "https://i.ytimg.com/vi/hs87ZR5KgXs/mqdefault.jpg",
    "title": "【完全初見】コードギアス 反逆のルルーシュ！アニメ同時試聴するぞ～～～！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-19T15:36:43Z"
  },
  {
    "videoId": "7UIschW1mh4",
    "thumbnail": "https://i.ytimg.com/vi/7UIschW1mh4/mqdefault.jpg",
    "title": "【激ムズ！】鬼畜だけど “クセになる” 音ゲー！？-Geometry Dash-【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-20T10:53:43Z"
  },
  {
    "videoId": "olYQU0xNYg8",
    "thumbnail": "https://i.ytimg.com/vi/olYQU0xNYg8/mqdefault.jpg",
    "title": "【 ASMR 】確実にねれるエグい音⚠️Sleep Whispering/KU100【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-22T16:50:01Z"
  },
  {
    "videoId": "KagqNQJtLuE",
    "thumbnail": "https://i.ytimg.com/vi/KagqNQJtLuE/mqdefault.jpg",
    "title": "【激ムズ！】鬼畜すぎだあああああああ-Geometry Dash-【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-23T00:26:04Z"
  },
  {
    "videoId": "rTEsZyFngII",
    "thumbnail": "https://i.ytimg.com/vi/rTEsZyFngII/mqdefault.jpg",
    "title": "【 #ほしちゃま 】宇宙１かわいいコンビでカラオケ～～～！🌟❤️‍🔥【ホロライブ/赤井はあと/にじさんじ/星川サラ】",
    "publishedAt": "2025-01-24T10:05:40Z"
  },
  {
    "videoId": "ZauljbGNM70",
    "thumbnail": "https://i.ytimg.com/vi/ZauljbGNM70/mqdefault.jpg",
    "title": "【 料理 】人生はじめての「ポテト🍟」揚げるぞおおおお～～～！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-01-27T10:09:37Z"
  },
  {
    "videoId": "LJnkBMDdWIs",
    "thumbnail": "https://i.ytimg.com/vi/LJnkBMDdWIs/mqdefault.jpg",
    "title": "【 鬼難度 】宇宙飛行士テストがヤバすぎた、、、、、、😭【赤井はあと/ホロライブ】",
    "publishedAt": "2025-01-29T09:54:54Z"
  },
  {
    "videoId": "79lSGlBdeZs",
    "thumbnail": "https://i.ytimg.com/vi/79lSGlBdeZs/mqdefault.jpg",
    "title": "【#ろぼちゃまRP】鬼太郎の新作ホラゲ！後輩ちゃんと4人協力だあああ！【ノロイカゴ ゲゲゲの夜】",
    "publishedAt": "2025-01-30T13:52:32Z"
  },
  {
    "videoId": "C_WHwvX5p5A",
    "thumbnail": "https://i.ytimg.com/vi/C_WHwvX5p5A/mqdefault.jpg",
    "title": "【OFF COLLAB】TEACH HOW TO COOK ''EHOUMAKI'' 🍣✨@FUWAMOCOch @KosekiBijou",
    "publishedAt": "2025-01-31T09:58:24Z"
  },
  {
    "videoId": "8m83tu3AmUw",
    "thumbnail": "https://i.ytimg.com/vi/8m83tu3AmUw/mqdefault.jpg",
    "title": "OUR OFF SHOT!!! @FUWAMOCOch @KosekiBijou",
    "publishedAt": "2025-01-31T17:19:56Z"
  },
  {
    "videoId": "-GvuhCwUma0",
    "thumbnail": "https://i.ytimg.com/vi/-GvuhCwUma0/mqdefault.jpg",
    "title": "深夜にノリでラップつくってみた #shorts",
    "publishedAt": "2025-02-01T08:00:00Z"
  },
  {
    "videoId": "ms5D_F_flOY",
    "thumbnail": "https://i.ytimg.com/vi/ms5D_F_flOY/mqdefault.jpg",
    "title": "ジブリ飯を再現してみた！？【新カメラ】#cooking #簡単レシピ #ジブリ",
    "publishedAt": "2025-02-02T08:00:38Z"
  },
  {
    "videoId": "H1VECFqSvb0",
    "thumbnail": "https://i.ytimg.com/vi/H1VECFqSvb0/mqdefault.jpg",
    "title": "【踊ってみた】どきどきキュン!で大暴走♡/いずれ菖蒲か杜若【にじさんじ】【ホロライブ/赤井はあと】#shorts",
    "publishedAt": "2025-02-02T20:00:10Z"
  },
  {
    "videoId": "jA6_PXxM3UQ",
    "thumbnail": "https://i.ytimg.com/vi/jA6_PXxM3UQ/mqdefault.jpg",
    "title": "【 Minecraft 】新ホロ鯖きた！？大冒険だああああああああああ～～～！！！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-03T19:39:23Z"
  },
  {
    "videoId": "o6HDonnzsE8",
    "thumbnail": "https://i.ytimg.com/vi/o6HDonnzsE8/mqdefault.jpg",
    "title": "巨大椎茸の一本焼きがうますぎる！#cooking #簡単レシピ #料理",
    "publishedAt": "2025-02-04T08:00:49Z"
  },
  {
    "videoId": "SBYYndEUgkc",
    "thumbnail": "https://i.ytimg.com/vi/SBYYndEUgkc/mqdefault.jpg",
    "title": "【MINECRAFT NEW WORLD SERVER】LET'SGOOOOO!!!🌟最　恐　計　画　‼【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-05T13:50:50Z"
  },
  {
    "videoId": "jnfOrnRH5Zc",
    "thumbnail": "https://i.ytimg.com/vi/jnfOrnRH5Zc/mqdefault.jpg",
    "title": "【踊ってみた】オトノケ/ Creepy Nuts 【ダンダダンOPアニメダンス】【ホロライブ/赤井はあと】#shorts",
    "publishedAt": "2025-02-07T08:00:42Z"
  },
  {
    "videoId": "lmwUZwLS4Qg",
    "thumbnail": "https://i.ytimg.com/vi/lmwUZwLS4Qg/mqdefault.jpg",
    "title": "卵の殻を簡単に剥がすライフハック #lifehacks #cooking #料理",
    "publishedAt": "2025-02-07T08:00:42Z"
  },
  {
    "videoId": "6W05z2dCqOQ",
    "thumbnail": "https://i.ytimg.com/vi/6W05z2dCqOQ/mqdefault.jpg",
    "title": "カップ焼きそばをキメるだけの動画 #shorts #簡単レシピ #料理",
    "publishedAt": "2025-02-08T08:00:08Z"
  },
  {
    "videoId": "GbjVVDP7KUQ",
    "thumbnail": "https://i.ytimg.com/vi/GbjVVDP7KUQ/mqdefault.jpg",
    "title": "【踊ってみた】テトリス/柊マグネタイトfeat.重音テトSV【Tiktok】【ホロライブ/赤井はあと】#shorts",
    "publishedAt": "2025-02-09T08:00:21Z"
  },
  {
    "videoId": "MKMk0BBKghY",
    "thumbnail": "https://i.ytimg.com/vi/MKMk0BBKghY/mqdefault.jpg",
    "title": "やる気出ない人へ【轟はじめ/オリジナル】#vtuber #dance #やる気出ないソング【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-11T08:00:18Z"
  },
  {
    "videoId": "KG54KQGU4Ts",
    "thumbnail": "https://i.ytimg.com/vi/KG54KQGU4Ts/mqdefault.jpg",
    "title": "【MINECRAFT NEW WORLD SERVER】ただいまホロ鯖～～～！！！🌟ドッキリ計画!?【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-12T08:24:06Z"
  },
  {
    "videoId": "Dd2c29DEnws",
    "thumbnail": "https://i.ytimg.com/vi/Dd2c29DEnws/mqdefault.jpg",
    "title": "【 激レア！ 】1500個に1つ⁉️チョコボールで当てるぞ！！！！！！！🍫🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-13T08:50:04Z"
  },
  {
    "videoId": "xuG9z5yJcJY",
    "thumbnail": "https://i.ytimg.com/vi/xuG9z5yJcJY/mqdefault.jpg",
    "title": "【オフコラボ】今年のバレンタインは #はあわた DE クッキング！🍫【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-14T10:22:01Z"
  },
  {
    "videoId": "9FXjcUpvjpI",
    "thumbnail": "https://i.ytimg.com/vi/9FXjcUpvjpI/mqdefault.jpg",
    "title": "【#すうはあ】ヤバい新人現れた！？はじめてのクッキング教室💘🍳【ホロライブ/赤井はあと/水宮枢】",
    "publishedAt": "2025-02-19T09:48:52Z"
  },
  {
    "videoId": "A-kEPKNH4ro",
    "thumbnail": "https://i.ytimg.com/vi/A-kEPKNH4ro/mqdefault.jpg",
    "title": "【MINECRAFT】ダイヤ掘り💎&天空都市つくりする～～～！！！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-19T22:13:48Z"
  },
  {
    "videoId": "KO6tEQIYzHE",
    "thumbnail": "https://i.ytimg.com/vi/KO6tEQIYzHE/mqdefault.jpg",
    "title": "ガチで危険すぎるスカイダイビング！？#shorts",
    "publishedAt": "2025-02-20T08:00:16Z"
  },
  {
    "videoId": "AJI3RgD_uNI",
    "thumbnail": "https://i.ytimg.com/vi/AJI3RgD_uNI/mqdefault.jpg",
    "title": "はじめての北海道旅行いってきた！！！#旅行Vlog #北海道",
    "publishedAt": "2025-02-22T08:00:11Z"
  },
  {
    "videoId": "W2R9ugq-ujU",
    "thumbnail": "https://i.ytimg.com/vi/W2R9ugq-ujU/mqdefault.jpg",
    "title": "【Minecraft】LET'S！ほろよい天空都市つくり～～～！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-23T03:52:56Z"
  },
  {
    "videoId": "yOJezFGKWE8",
    "thumbnail": "https://i.ytimg.com/vi/yOJezFGKWE8/mqdefault.jpg",
    "title": "日の出が美しすぎた・・・！#旅行Vlog #北海道",
    "publishedAt": "2025-02-23T08:00:50Z"
  },
  {
    "videoId": "11wxYePRtYY",
    "thumbnail": "https://i.ytimg.com/vi/11wxYePRtYY/mqdefault.jpg",
    "title": "Who2 / 赤井はあと (Official)",
    "publishedAt": "2025-02-24T09:00:06Z"
  },
  {
    "videoId": "QbfM6735DBE",
    "thumbnail": "https://i.ytimg.com/vi/QbfM6735DBE/mqdefault.jpg",
    "title": "【重大告知】激辛食べて告知だあああああ！！！🔥🔥🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-24T09:07:26Z"
  },
  {
    "videoId": "Ip_DlySo46g",
    "thumbnail": "https://i.ytimg.com/vi/Ip_DlySo46g/mqdefault.jpg",
    "title": "新曲『Who2』のMV制作したよおおお～！#shorts",
    "publishedAt": "2025-02-24T10:57:23Z"
  },
  {
    "videoId": "vJj43B53JrA",
    "thumbnail": "https://i.ytimg.com/vi/vJj43B53JrA/mqdefault.jpg",
    "title": "新オリ曲『Who2』踊って大暴れした！！！【赤井はあと/オリジナル】#shorts",
    "publishedAt": "2025-02-24T15:32:47Z"
  },
  {
    "videoId": "fxw_GLOszms",
    "thumbnail": "https://i.ytimg.com/vi/fxw_GLOszms/mqdefault.jpg",
    "title": "【Minecraft】YO！ほろよい建設ちゃまっちゃま～～～！💤【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-25T02:36:09Z"
  },
  {
    "videoId": "AaTRpp3-uLU",
    "thumbnail": "https://i.ytimg.com/vi/AaTRpp3-uLU/mqdefault.jpg",
    "title": "【OFF COLLAB】COOK PEPERONI PIZZA!!! with @holoen_raorapanthera",
    "publishedAt": "2025-02-25T09:07:57Z"
  },
  {
    "videoId": "w5Aflf4eVLs",
    "thumbnail": "https://i.ytimg.com/vi/w5Aflf4eVLs/mqdefault.jpg",
    "title": "【バラード歌枠】おやすみ前に、まったり歌う💭【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-25T16:46:02Z"
  },
  {
    "videoId": "MaDarTdAosU",
    "thumbnail": "https://i.ytimg.com/vi/MaDarTdAosU/mqdefault.jpg",
    "title": "【踊ってみた】一旦ステイ TONIGHT/不破湊 【にじさんじ】【ホロライブ/赤井はあと】",
    "publishedAt": "2025-02-26T10:31:48Z"
  },
  {
    "videoId": "s4P4Y5wV0Q4",
    "thumbnail": "https://i.ytimg.com/vi/s4P4Y5wV0Q4/mqdefault.jpg",
    "title": "氷の上をおさんぽしてきた！！！#北海道 #vlog",
    "publishedAt": "2025-02-27T08:00:47Z"
  },
  {
    "videoId": "bFZz0XiFQn0",
    "thumbnail": "https://i.ytimg.com/vi/bFZz0XiFQn0/mqdefault.jpg",
    "title": "【踊ってみた】UNDEAD/YOASOBI 【ホロライブ/赤井はあと】#shorts",
    "publishedAt": "2025-02-28T08:00:37Z"
  },
  {
    "videoId": "kbluUN2rXIQ",
    "thumbnail": "https://i.ytimg.com/vi/kbluUN2rXIQ/mqdefault.jpg",
    "title": "【踊ってみた】ふたりのきもちのほんとのひみつ/キルミーベイベー【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-01T08:00:39Z"
  },
  {
    "videoId": "nitYucBqtvM",
    "thumbnail": "https://i.ytimg.com/vi/nitYucBqtvM/mqdefault.jpg",
    "title": "体育館でアクロバットしてみた！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-02T08:00:46Z"
  },
  {
    "videoId": "sfnR3VU67Gk",
    "thumbnail": "https://i.ytimg.com/vi/sfnR3VU67Gk/mqdefault.jpg",
    "title": "風船割りチャレンジしてみた！！？【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-03T08:00:50Z"
  },
  {
    "videoId": "SWyifqQ8zNQ",
    "thumbnail": "https://i.ytimg.com/vi/SWyifqQ8zNQ/mqdefault.jpg",
    "title": "【劇場版プロセカ】『Worlders』踊ってみたよ！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-04T08:00:32Z"
  },
  {
    "videoId": "tkJ8uxMQMTE",
    "thumbnail": "https://i.ytimg.com/vi/tkJ8uxMQMTE/mqdefault.jpg",
    "title": "【OFF COLLAB】NICE TO MEAT UUU!!!🍖✨ @holoen_gigimurin @holoen_ceciliaimmergreen",
    "publishedAt": "2025-03-05T03:51:23Z"
  },
  {
    "videoId": "S1_3kucNb6M",
    "thumbnail": "https://i.ytimg.com/vi/S1_3kucNb6M/mqdefault.jpg",
    "title": "【踊ってみた】2.5次元の誘惑ED「Watch Me」【にごリリ】【ホロライブ/あ赤井はあと】",
    "publishedAt": "2025-03-05T08:00:27Z"
  },
  {
    "videoId": "RItyPQluytQ",
    "thumbnail": "https://i.ytimg.com/vi/RItyPQluytQ/mqdefault.jpg",
    "title": "人生初のSLに乗ってきた！！！🚋#旅行Vlog #北海道",
    "publishedAt": "2025-03-07T08:00:24Z"
  },
  {
    "videoId": "ZruOSdVajX4",
    "thumbnail": "https://i.ytimg.com/vi/ZruOSdVajX4/mqdefault.jpg",
    "title": "Hololive 6th FES当日に！「Who2」踊ってみた！#shorts",
    "publishedAt": "2025-03-07T08:00:30Z"
  },
  {
    "videoId": "ypxkNw05cfs",
    "thumbnail": "https://i.ytimg.com/vi/ypxkNw05cfs/mqdefault.jpg",
    "title": "【凸待ち＆歌枠】ライブ直前！ゆる凸待ち歌枠～～～！✨【ホロライブ/赤井はあと】@NatsuiroMatsuri @LaplusDarknesss",
    "publishedAt": "2025-03-07T12:15:21Z"
  },
  {
    "videoId": "SY3ugx34bMM",
    "thumbnail": "https://i.ytimg.com/vi/SY3ugx34bMM/mqdefault.jpg",
    "title": "ライブお疲れ様！Who2踊ってみてね～～～！！！#shorts",
    "publishedAt": "2025-03-09T08:00:32Z"
  },
  {
    "videoId": "WVETqytm00w",
    "thumbnail": "https://i.ytimg.com/vi/WVETqytm00w/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖に巨大建築つくるぞ～～～！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-11T21:38:15Z"
  },
  {
    "videoId": "ahkmskRuSNw",
    "thumbnail": "https://i.ytimg.com/vi/ahkmskRuSNw/mqdefault.jpg",
    "title": "【ENGLISH】英語テスト！どれくらい解けるかな！？✨【#FLOWGLOW｜ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-13T12:08:43Z"
  },
  {
    "videoId": "CflXVjPU3z8",
    "thumbnail": "https://i.ytimg.com/vi/CflXVjPU3z8/mqdefault.jpg",
    "title": "【耐久歌枠】もうすぐ１５５万人⁉突破まで歌うぞ～～～！！！❤️‍🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-13T19:26:38Z"
  },
  {
    "videoId": "pD7cJd3gS_M",
    "thumbnail": "https://i.ytimg.com/vi/pD7cJd3gS_M/mqdefault.jpg",
    "title": "【 モンハンワイルズ 】はあちゃま、狩猟解禁！！？人生初めてのモンハンだああああああ‼️🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-16T01:43:42Z"
  },
  {
    "videoId": "3VGi1-HNq9A",
    "thumbnail": "https://i.ytimg.com/vi/3VGi1-HNq9A/mqdefault.jpg",
    "title": "【モンハンワイルズ】人生はじめてのモンハン生活！！！！！！！強くなる！！！#2【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-19T12:49:55Z"
  },
  {
    "videoId": "sxd3VPK_b_E",
    "thumbnail": "https://i.ytimg.com/vi/sxd3VPK_b_E/mqdefault.jpg",
    "title": "【モンハンワイルズ】猛者たちとはじめてのモンハンコラボだ・・・！！！🌟【#ホロライブ１期生】",
    "publishedAt": "2025-03-19T18:43:08Z"
  },
  {
    "videoId": "oHMUipn-K28",
    "thumbnail": "https://i.ytimg.com/vi/oHMUipn-K28/mqdefault.jpg",
    "title": "【踊ってみた】なにから鑑定ダンス/儒烏風亭らでん【ホンモノ？ニセモノ？】赤井はあと",
    "publishedAt": "2025-03-20T21:39:01Z"
  },
  {
    "videoId": "GJQ-LZLzQeg",
    "thumbnail": "https://i.ytimg.com/vi/GJQ-LZLzQeg/mqdefault.jpg",
    "title": "【NGテイク】ふたりのきもちのほんとのひみつ/ミルキーベイベー踊ってみた【ホロライブ/赤井はあ",
    "publishedAt": "2025-03-22T08:00:12Z"
  },
  {
    "videoId": "G24hknGWxLU",
    "thumbnail": "https://i.ytimg.com/vi/G24hknGWxLU/mqdefault.jpg",
    "title": "【踊ってみた】雨トキメキ恋模様/いろはにほへっと あやふぶみ【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-22T09:00:18Z"
  },
  {
    "videoId": "CQHPuO1sfpY",
    "thumbnail": "https://i.ytimg.com/vi/CQHPuO1sfpY/mqdefault.jpg",
    "title": "【心霊物件】訳アリの格安アパートに住み始めてみた・・・・！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-22T16:35:42Z"
  },
  {
    "videoId": "vYV5lhE66_w",
    "thumbnail": "https://i.ytimg.com/vi/vYV5lhE66_w/mqdefault.jpg",
    "title": "【踊ってみた】ぎゅーどんかーにばる！【ホロライブ/白銀ノエル/赤井はあと】",
    "publishedAt": "2025-03-23T08:00:50Z"
  },
  {
    "videoId": "dH5rRJKrXHs",
    "thumbnail": "https://i.ytimg.com/vi/dH5rRJKrXHs/mqdefault.jpg",
    "title": "#ビビデバ サビダンス踊ってみたらめちゃこんがらがった！💃【ホロライブ/星街すいせい/赤井はあと】",
    "publishedAt": "2025-03-24T08:00:33Z"
  },
  {
    "videoId": "nbLZAp8wu6c",
    "thumbnail": "https://i.ytimg.com/vi/nbLZAp8wu6c/mqdefault.jpg",
    "title": "【踊ってみた】ハチャメチャにカリスマ・イン・ダ・ハウス！7人のカリスマ【ホロライブ/赤井はあと",
    "publishedAt": "2025-03-25T08:00:43Z"
  },
  {
    "videoId": "Ip0f_sKJRAw",
    "thumbnail": "https://i.ytimg.com/vi/Ip0f_sKJRAw/mqdefault.jpg",
    "title": "【歌枠】卒業ソングメドレー🌸おめでとうを込めて歌う！！！💌【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-25T17:41:53Z"
  },
  {
    "videoId": "KaOS69iB6Hw",
    "thumbnail": "https://i.ytimg.com/vi/KaOS69iB6Hw/mqdefault.jpg",
    "title": "【OFF COLLAB】HOTTEST TAKOYAKI EVERRR!!!!!!!!!!!!!!@NinomaeInanis",
    "publishedAt": "2025-03-26T07:18:48Z"
  },
  {
    "videoId": "6CtsltIsA9A",
    "thumbnail": "https://i.ytimg.com/vi/6CtsltIsA9A/mqdefault.jpg",
    "title": "【踊ってみた】DAIDAIDAIファンタジスタ/さくらみこ【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-26T08:00:08Z"
  },
  {
    "videoId": "xLB_856VBsI",
    "thumbnail": "https://i.ytimg.com/vi/xLB_856VBsI/mqdefault.jpg",
    "title": "【踊ってみた】シアワセ√コヨリニウム/博衣こより【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-27T08:00:58Z"
  },
  {
    "videoId": "zf7eXVyn26Y",
    "thumbnail": "https://i.ytimg.com/vi/zf7eXVyn26Y/mqdefault.jpg",
    "title": "【Minecraft】LET'S!!! ゆるっと巨大建築づくり～～～！！！💭✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-27T09:58:58Z"
  },
  {
    "videoId": "gUsecLa0m6A",
    "thumbnail": "https://i.ytimg.com/vi/gUsecLa0m6A/mqdefault.jpg",
    "title": "【モンハンワイルズ】はじめてのモンハン生活！上位突破だあああああ！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-28T12:05:51Z"
  },
  {
    "videoId": "TO8QJ7jNRu8",
    "thumbnail": "https://i.ytimg.com/vi/TO8QJ7jNRu8/mqdefault.jpg",
    "title": "【踊ってみた】ねねちのギラギラファンミーティング/桃鈴ねね【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-29T08:00:30Z"
  },
  {
    "videoId": "X6NxNJEAYFY",
    "thumbnail": "https://i.ytimg.com/vi/X6NxNJEAYFY/mqdefault.jpg",
    "title": "Who’s the Strongest Idol?! ARM WRESTLING TIME 💥👑@holoen_ceciliaimmergreen @holoen_gigimurin",
    "publishedAt": "2025-03-29T15:00:41Z"
  },
  {
    "videoId": "gY0LSfteNrU",
    "thumbnail": "https://i.ytimg.com/vi/gY0LSfteNrU/mqdefault.jpg",
    "title": "明日の自分へ届け！🌟『明日の私に幸あれ』/ナナヲアカリ #踊ってみた【ホロライブ/赤井はあと】",
    "publishedAt": "2025-03-31T09:00:43Z"
  },
  {
    "videoId": "zNvODGZLh8Y",
    "thumbnail": "https://i.ytimg.com/vi/zNvODGZLh8Y/mqdefault.jpg",
    "title": "エジプト(鳥取砂丘)にやってきた！！！✌️",
    "publishedAt": "2025-04-01T08:00:49Z"
  },
  {
    "videoId": "rOugHmUwiMw",
    "thumbnail": "https://i.ytimg.com/vi/rOugHmUwiMw/mqdefault.jpg",
    "title": "クセになる！🐣『ホットダック！』/ 大空スバル🌭#踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-01T09:00:59Z"
  },
  {
    "videoId": "ij-H5yEpAf0",
    "thumbnail": "https://i.ytimg.com/vi/ij-H5yEpAf0/mqdefault.jpg",
    "title": "【旅】はじめてのひとり旅！エジプト（鳥取砂丘）大冒険！！！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-01T10:19:30Z"
  },
  {
    "videoId": "xhAVePGFAvk",
    "thumbnail": "https://i.ytimg.com/vi/xhAVePGFAvk/mqdefault.jpg",
    "title": "【うろ覚え】踊れると思ったら全然ダメだった・・・🥹『III』#踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-01T11:19:48Z"
  },
  {
    "videoId": "h37V30vSjhI",
    "thumbnail": "https://i.ytimg.com/vi/h37V30vSjhI/mqdefault.jpg",
    "title": "【Minecraft】超絶イケボで女を惑わすマイクラ。【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-01T16:01:39Z"
  },
  {
    "videoId": "vrk6lREX-5o",
    "thumbnail": "https://i.ytimg.com/vi/vrk6lREX-5o/mqdefault.jpg",
    "title": "おやすみ前の儀式、見てく❔#ナイトルーティン #般若心経",
    "publishedAt": "2025-04-02T09:01:07Z"
  },
  {
    "videoId": "e4Xa7LdXYuw",
    "thumbnail": "https://i.ytimg.com/vi/e4Xa7LdXYuw/mqdefault.jpg",
    "title": "【ドッキリ】エイプリルフールに告白してみた！恋の行方は・・・⁉️【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-02T14:52:44Z"
  },
  {
    "videoId": "bM9O31wgDzg",
    "thumbnail": "https://i.ytimg.com/vi/bM9O31wgDzg/mqdefault.jpg",
    "title": "ここはどこでしょう・・・？正解はコメ欄🫶",
    "publishedAt": "2025-04-03T08:31:45Z"
  },
  {
    "videoId": "N9EHcT_MjGE",
    "thumbnail": "https://i.ytimg.com/vi/N9EHcT_MjGE/mqdefault.jpg",
    "title": "色気ダダ漏れで……💘『パイパイ仮面でどうかしらん？』/宝鍾マリン 踊ってみた【ホロライブ/赤井はあ",
    "publishedAt": "2025-04-03T09:00:27Z"
  },
  {
    "videoId": "0LDhpgL6EoU",
    "thumbnail": "https://i.ytimg.com/vi/0LDhpgL6EoU/mqdefault.jpg",
    "title": "ラスト事故った😂 『 Who2』踊ってみた【ホロライブ#赤井はあと】",
    "publishedAt": "2025-04-05T09:00:02Z"
  },
  {
    "videoId": "HPtXpRCwf9w",
    "thumbnail": "https://i.ytimg.com/vi/HPtXpRCwf9w/mqdefault.jpg",
    "title": "🔥HOLOLIVE in 2025【REDDIT SHITPOST REVIEW】",
    "publishedAt": "2025-04-06T02:54:48Z"
  },
  {
    "videoId": "Lhxk8A5MGNE",
    "thumbnail": "https://i.ytimg.com/vi/Lhxk8A5MGNE/mqdefault.jpg",
    "title": "【#すうはあ】俺のすうとモンハンデートだああああああ！💓✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-06T08:54:18Z"
  },
  {
    "videoId": "bIlxjHnlvZs",
    "thumbnail": "https://i.ytimg.com/vi/bIlxjHnlvZs/mqdefault.jpg",
    "title": "【 料理 】人生はじめての「ドーナツ🍩」揚げるぞおおおお～～～！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-08T10:11:14Z"
  },
  {
    "videoId": "EehCK3f7hWc",
    "thumbnail": "https://i.ytimg.com/vi/EehCK3f7hWc/mqdefault.jpg",
    "title": "【#ろぼちゃま】ロボ子とリスナーでモンハンだああああああ！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-09T13:27:27Z"
  },
  {
    "videoId": "LIxqQdUNlEo",
    "thumbnail": "https://i.ytimg.com/vi/LIxqQdUNlEo/mqdefault.jpg",
    "title": "人生ではじめてドーナツ作った結果・・・😱#cooking #asmr #料理",
    "publishedAt": "2025-04-10T08:10:08Z"
  },
  {
    "videoId": "PWblERrcmt4",
    "thumbnail": "https://i.ytimg.com/vi/PWblERrcmt4/mqdefault.jpg",
    "title": "カリッ、ジュワッ。伝説のからあげ作り方❗️#cooking #asmr #料理",
    "publishedAt": "2025-04-11T09:00:41Z"
  },
  {
    "videoId": "fJnqTFaZgq8",
    "thumbnail": "https://i.ytimg.com/vi/fJnqTFaZgq8/mqdefault.jpg",
    "title": "【Minecraft】あの子に🎁・・・！？ドッキリ計画だあああ～～～！！！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-11T19:30:32Z"
  },
  {
    "videoId": "TeyXZWSfAUw",
    "thumbnail": "https://i.ytimg.com/vi/TeyXZWSfAUw/mqdefault.jpg",
    "title": "【Minecraft】DOKI!DOKI! DATE!!!💘with@NanashiMumei",
    "publishedAt": "2025-04-12T04:55:49Z"
  },
  {
    "videoId": "RqJtxqWdlXg",
    "thumbnail": "https://i.ytimg.com/vi/RqJtxqWdlXg/mqdefault.jpg",
    "title": "旅先でバス降り忘れ事故。#vlog #一人旅",
    "publishedAt": "2025-04-12T08:00:34Z"
  },
  {
    "videoId": "OoLk5dRQUe8",
    "thumbnail": "https://i.ytimg.com/vi/OoLk5dRQUe8/mqdefault.jpg",
    "title": "【 #KROCHAMA COLLAB 】51 Clubhouse Games with  @OuroKronii #HololiveEN",
    "publishedAt": "2025-04-13T04:09:41Z"
  },
  {
    "videoId": "8P7vNMI944Q",
    "thumbnail": "https://i.ytimg.com/vi/8P7vNMI944Q/mqdefault.jpg",
    "title": "【耐久歌枠】もうすぐ１５６万人！？突破まで全力で歌うぞおおおおお！❤️‍🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-13T19:51:44Z"
  },
  {
    "videoId": "LEm9SHE2Wwk",
    "thumbnail": "https://i.ytimg.com/vi/LEm9SHE2Wwk/mqdefault.jpg",
    "title": "鳥取砂丘で女ひとり旅たのしすぎた！！！#vlog #鳥取 #一人旅",
    "publishedAt": "2025-04-17T08:00:19Z"
  },
  {
    "videoId": "jelFWBjk4qs",
    "thumbnail": "https://i.ytimg.com/vi/jelFWBjk4qs/mqdefault.jpg",
    "title": "【#でんちゃま】語り合おう、もんじゃで。【ホロライブ/赤井はあと/儒烏風亭らでん #ReGLOSS】",
    "publishedAt": "2025-04-17T10:07:07Z"
  },
  {
    "videoId": "sMlJmV6iufo",
    "thumbnail": "https://i.ytimg.com/vi/sMlJmV6iufo/mqdefault.jpg",
    "title": "え!?砂丘のスパイスでカレー作ったら、美味しすぎた… #料理 #cooking #cookingfail",
    "publishedAt": "2025-04-18T08:01:05Z"
  },
  {
    "videoId": "GhDbDlB-GgM",
    "thumbnail": "https://i.ytimg.com/vi/GhDbDlB-GgM/mqdefault.jpg",
    "title": "【#ホロ料理部】3人の絆で『伝説の唐揚げ 』作りに挑戦だあああ！！！🔥【ホロライブ/赤井はあと/博衣こより/一条莉々華 #REGLOSS】",
    "publishedAt": "2025-04-18T10:18:03Z"
  },
  {
    "videoId": "mofHSeTdCkI",
    "thumbnail": "https://i.ytimg.com/vi/mofHSeTdCkI/mqdefault.jpg",
    "title": "また行きたい！浪漫溢れる温泉宿。#鳥取  #一人旅 #旅行",
    "publishedAt": "2025-04-19T09:01:07Z"
  },
  {
    "videoId": "v7cNnZ66XzU",
    "thumbnail": "https://i.ytimg.com/vi/v7cNnZ66XzU/mqdefault.jpg",
    "title": "【 #holoRUST 】冒険するっちゃまああああ～～～！！！！！🔥🐎【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-19T15:22:12Z"
  },
  {
    "videoId": "w5Mam2lajaM",
    "thumbnail": "https://i.ytimg.com/vi/w5Mam2lajaM/mqdefault.jpg",
    "title": "のんびり一人旅、最強に整った！#旅行 #vlog #一人旅",
    "publishedAt": "2025-04-20T09:01:22Z"
  },
  {
    "videoId": "7KszU3A7eBs",
    "thumbnail": "https://i.ytimg.com/vi/7KszU3A7eBs/mqdefault.jpg",
    "title": "深夜にこれは罪すぎ・・・海鮮丸焼き！！！#料理 #cooking #夜食",
    "publishedAt": "2025-04-25T09:00:10Z"
  },
  {
    "videoId": "x2-TaEbZUEo",
    "thumbnail": "https://i.ytimg.com/vi/x2-TaEbZUEo/mqdefault.jpg",
    "title": "【旅】はじめてのひとり旅！グンマー帝国！！！♨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-26T10:35:19Z"
  },
  {
    "videoId": "PI_XzDu5Ji4",
    "thumbnail": "https://i.ytimg.com/vi/PI_XzDu5Ji4/mqdefault.jpg",
    "title": "かわいいだけじゃだめですか？？？🥹💖/CUTIE STREET #踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-29T09:00:26Z"
  },
  {
    "videoId": "jXX6SEzBxx0",
    "thumbnail": "https://i.ytimg.com/vi/jXX6SEzBxx0/mqdefault.jpg",
    "title": "【#すうはあ】2人の絆で星を旅する！？『違う星のぼくら』【はあちゃま視点/ホロライブ】",
    "publishedAt": "2025-04-29T14:11:30Z"
  },
  {
    "videoId": "kN0CNg7HmdM",
    "thumbnail": "https://i.ytimg.com/vi/kN0CNg7HmdM/mqdefault.jpg",
    "title": "ダイダイダイダイダイキライ になった？💔/雨良 #踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-04-30T09:01:07Z"
  },
  {
    "videoId": "afFK64i3c3g",
    "thumbnail": "https://i.ytimg.com/vi/afFK64i3c3g/mqdefault.jpg",
    "title": "さよなら、ありがとう。REFLECT - Gawr Gura (cover)",
    "publishedAt": "2025-05-01T06:00:03Z"
  },
  {
    "videoId": "7b-5-RUkpFQ",
    "thumbnail": "https://i.ytimg.com/vi/7b-5-RUkpFQ/mqdefault.jpg",
    "title": "は〜〜〜い‼️愛♡スクリ～ム!/AiScReamルビィちゃんパート【ラブライブ!】#踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-01T09:00:08Z"
  },
  {
    "videoId": "eOzo3aFAHF0",
    "thumbnail": "https://i.ytimg.com/vi/eOzo3aFAHF0/mqdefault.jpg",
    "title": "コナンのメインテーマ流したら旅が事件性増す説",
    "publishedAt": "2025-05-01T15:01:04Z"
  },
  {
    "videoId": "1XMx7bsScJ8",
    "thumbnail": "https://i.ytimg.com/vi/1XMx7bsScJ8/mqdefault.jpg",
    "title": "中毒性ある！⚡️『倍倍FIGHT!』/ CANDY TUNE #踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-02T09:00:02Z"
  },
  {
    "videoId": "fJ_D3tZKqV8",
    "thumbnail": "https://i.ytimg.com/vi/fJ_D3tZKqV8/mqdefault.jpg",
    "title": "なぜか笑っちゃった・・・NGテイク #テレパシ #ホロライブ #赤井はあと",
    "publishedAt": "2025-05-03T09:01:03Z"
  },
  {
    "videoId": "IELLseUfIGc",
    "thumbnail": "https://i.ytimg.com/vi/IELLseUfIGc/mqdefault.jpg",
    "title": "コンプレックス♡プリンセス #踊ってみた /宝鐘マリン 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-04T09:00:20Z"
  },
  {
    "videoId": "wn2DcixtE3w",
    "thumbnail": "https://i.ytimg.com/vi/wn2DcixtE3w/mqdefault.jpg",
    "title": "【 歌枠 】GW！✨おでかけでまったり聴きたい曲歌う！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-04T16:08:18Z"
  },
  {
    "videoId": "k2ymPusPlMw",
    "thumbnail": "https://i.ytimg.com/vi/k2ymPusPlMw/mqdefault.jpg",
    "title": "NG？やんなっちゃう！！！ｗ#テレパシ #踊ってみた / DECO*27 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-05T09:01:00Z"
  },
  {
    "videoId": "RC-UduPTuqg",
    "thumbnail": "https://i.ytimg.com/vi/RC-UduPTuqg/mqdefault.jpg",
    "title": "Caramel Pain です。/ 星街すいせい #踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-06T09:00:42Z"
  },
  {
    "videoId": "zrAUU7xjgFI",
    "thumbnail": "https://i.ytimg.com/vi/zrAUU7xjgFI/mqdefault.jpg",
    "title": "うーわぁ！『モニタリング』/ DECO*27 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-07T09:01:19Z"
  },
  {
    "videoId": "KO3RSQeR0R4",
    "thumbnail": "https://i.ytimg.com/vi/KO3RSQeR0R4/mqdefault.jpg",
    "title": "きょういくばんぐみのテーマ / MNS【神崎杏奈さん振り付け】#踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-08T09:00:34Z"
  },
  {
    "videoId": "ZvubfW4T3Hk",
    "thumbnail": "https://i.ytimg.com/vi/ZvubfW4T3Hk/mqdefault.jpg",
    "title": "【ｴｯﾎｴｯﾎの歌踊ってみた】みんなに伝えなきゃ!!🍞【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-09T09:01:01Z"
  },
  {
    "videoId": "msW-_S90HrE",
    "thumbnail": "https://i.ytimg.com/vi/msW-_S90HrE/mqdefault.jpg",
    "title": "IIIの振付でLOVE&JOY #踊ってみた 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-10T09:01:07Z"
  },
  {
    "videoId": "rXGCfETGsXs",
    "thumbnail": "https://i.ytimg.com/vi/rXGCfETGsXs/mqdefault.jpg",
    "title": "ついに踊れた！🌟『テレパシ』/ DECO*27 #踊ってみた【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-11T09:01:11Z"
  },
  {
    "videoId": "XGiH2xqoemo",
    "thumbnail": "https://i.ytimg.com/vi/XGiH2xqoemo/mqdefault.jpg",
    "title": "【旅】はじめてのひとり旅！山梨「富士山」の冒険！！！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-11T10:33:18Z"
  },
  {
    "videoId": "PrKjt2LLMeI",
    "thumbnail": "https://i.ytimg.com/vi/PrKjt2LLMeI/mqdefault.jpg",
    "title": "流行りの #踊ってみた 総まとめ！イチ推しはどれ？【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-12T09:00:36Z"
  },
  {
    "videoId": "dA-RDeGqMOY",
    "thumbnail": "https://i.ytimg.com/vi/dA-RDeGqMOY/mqdefault.jpg",
    "title": "旅先で遅刻しそうなのに山奥な件。#vlog",
    "publishedAt": "2025-05-13T09:00:54Z"
  },
  {
    "videoId": "MBGsn0u8VwA",
    "thumbnail": "https://i.ytimg.com/vi/MBGsn0u8VwA/mqdefault.jpg",
    "title": "【It Takes Two】Team BIBOCHAMA.....!!? Let's GO!!!!! @KosekiBijou",
    "publishedAt": "2025-05-13T09:19:42Z"
  },
  {
    "videoId": "UiaMp5Jyl6Y",
    "thumbnail": "https://i.ytimg.com/vi/UiaMp5Jyl6Y/mqdefault.jpg",
    "title": "【GeoGuessr】珍しい3人で旅にいく～～～！！✨対決も！？🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-13T12:33:04Z"
  },
  {
    "videoId": "wfOQpuSaXWU",
    "thumbnail": "https://i.ytimg.com/vi/wfOQpuSaXWU/mqdefault.jpg",
    "title": "ぐんまー帝国で大冒険してきたら最高すぎた❗️ #群馬 #vlog #旅行",
    "publishedAt": "2025-05-14T09:01:25Z"
  },
  {
    "videoId": "gO3G3oToQLY",
    "thumbnail": "https://i.ytimg.com/vi/gO3G3oToQLY/mqdefault.jpg",
    "title": "【#ホロ1期生】騙し合い！？ワードウルフであそぶぞおおお！！！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-14T12:21:16Z"
  },
  {
    "videoId": "6RquERugsQc",
    "thumbnail": "https://i.ytimg.com/vi/6RquERugsQc/mqdefault.jpg",
    "title": "【#ホロ1期生】枠取り直し！騙し合い！？ワードウルフであそぶぞおおお！！！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-14T13:22:23Z"
  },
  {
    "videoId": "l24N88m_FYE",
    "thumbnail": "https://i.ytimg.com/vi/l24N88m_FYE/mqdefault.jpg",
    "title": "波乱万丈、女ひとり旅！in四万温泉 #旅行 #vlog #一人旅",
    "publishedAt": "2025-05-15T09:01:11Z"
  },
  {
    "videoId": "4XJurve8uQI",
    "thumbnail": "https://i.ytimg.com/vi/4XJurve8uQI/mqdefault.jpg",
    "title": "【SUPER MARIO PARTY JAMBOREE】DOKI!DOKI! Party time!!!!!!!?",
    "publishedAt": "2025-05-16T03:43:41Z"
  },
  {
    "videoId": "xIvq8CDUkZk",
    "thumbnail": "https://i.ytimg.com/vi/xIvq8CDUkZk/mqdefault.jpg",
    "title": "まるで千と千尋…ジブリ感溢れる宿に泊まってきた！！#ジブリ #千と千尋の神隠し #vlog",
    "publishedAt": "2025-05-16T09:01:36Z"
  },
  {
    "videoId": "Skubs6sXmrg",
    "thumbnail": "https://i.ytimg.com/vi/Skubs6sXmrg/mqdefault.jpg",
    "title": "【料理】山梨グルメ‼️「ほうとう」クッキングだああああああああああああああああああああああ！！！🍲",
    "publishedAt": "2025-05-18T08:10:53Z"
  },
  {
    "videoId": "fdJ7OT_wDR8",
    "thumbnail": "https://i.ytimg.com/vi/fdJ7OT_wDR8/mqdefault.jpg",
    "title": "【晩酌】月曜から晩酌だ～～～！✨山梨づくしで飲むぞおおおお！！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-19T16:37:50Z"
  },
  {
    "videoId": "Py4FcEjmfmg",
    "thumbnail": "https://i.ytimg.com/vi/Py4FcEjmfmg/mqdefault.jpg",
    "title": "【PLATE UP！】Welcome to our restrant! LET US COOK!!!@ShioriNovella",
    "publishedAt": "2025-05-20T05:53:56Z"
  },
  {
    "videoId": "cwoIw99s970",
    "thumbnail": "https://i.ytimg.com/vi/cwoIw99s970/mqdefault.jpg",
    "title": "【It Takes Two】Time to adventure!!! We are RED STONE!!! @KosekiBijou",
    "publishedAt": "2025-05-25T08:07:49Z"
  },
  {
    "videoId": "tbCt9cMFNXw",
    "thumbnail": "https://i.ytimg.com/vi/tbCt9cMFNXw/mqdefault.jpg",
    "title": "ちょびっと飛んできた‼️#vlog #一人旅",
    "publishedAt": "2025-05-25T09:01:13Z"
  },
  {
    "videoId": "qpgOXKE1mfo",
    "thumbnail": "https://i.ytimg.com/vi/qpgOXKE1mfo/mqdefault.jpg",
    "title": "旅先でバス停に時刻表がない絶望。#vlog  #一人旅",
    "publishedAt": "2025-05-26T09:01:12Z"
  },
  {
    "videoId": "uWbizGyH31M",
    "thumbnail": "https://i.ytimg.com/vi/uWbizGyH31M/mqdefault.jpg",
    "title": "山梨のグルメのほうとうつくったぞおおお❗️#cooking #山梨",
    "publishedAt": "2025-05-27T09:01:17Z"
  },
  {
    "videoId": "z_du-y1gWxg",
    "thumbnail": "https://i.ytimg.com/vi/z_du-y1gWxg/mqdefault.jpg",
    "title": "有馬かなちゃんにハマり中！💖『POP IN 2』#踊ってみた #shorts",
    "publishedAt": "2025-05-28T09:01:37Z"
  },
  {
    "videoId": "ijgXBk7lFf4",
    "thumbnail": "https://i.ytimg.com/vi/ijgXBk7lFf4/mqdefault.jpg",
    "title": "#ロールプレイングゲーム 踊ってみた❗️#shorts #dance",
    "publishedAt": "2025-05-29T09:01:10Z"
  },
  {
    "videoId": "2GZgQOgAZRU",
    "thumbnail": "https://i.ytimg.com/vi/2GZgQOgAZRU/mqdefault.jpg",
    "title": "【旅】ちゃまと旅する！栃木で大冒険だああああ！⛩【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-30T10:25:29Z"
  },
  {
    "videoId": "OolewDXBH4M",
    "thumbnail": "https://i.ytimg.com/vi/OolewDXBH4M/mqdefault.jpg",
    "title": "【晩酌】栃木の晩酌だ～～～！✨歌ったり飲むぞおおおお！！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-05-30T15:57:47Z"
  },
  {
    "videoId": "R8hCVUl3ahA",
    "thumbnail": "https://i.ytimg.com/vi/R8hCVUl3ahA/mqdefault.jpg",
    "title": "はちゃめちゃ過ぎる新曲できちゃった‼️💖#めちゃゴミ完全食",
    "publishedAt": "2025-06-01T15:00:45Z"
  },
  {
    "videoId": "lr3K36IeqcQ",
    "thumbnail": "https://i.ytimg.com/vi/lr3K36IeqcQ/mqdefault.jpg",
    "title": "ゼロからピザ作りに挑戦！！🍕#cooking #shorts",
    "publishedAt": "2025-06-02T08:00:52Z"
  },
  {
    "videoId": "xO5d9xsAMns",
    "thumbnail": "https://i.ytimg.com/vi/xO5d9xsAMns/mqdefault.jpg",
    "title": "電脳ぴゅあ推し大宣言!!! めちゃカワアニメソロVer💖#ぴゅあ推しダンス 踊ってね〜✨",
    "publishedAt": "2025-06-02T09:01:22Z"
  },
  {
    "videoId": "EbwwnZLfLew",
    "thumbnail": "https://i.ytimg.com/vi/EbwwnZLfLew/mqdefault.jpg",
    "title": "【Original anime MV】めちゃゴミ♡完♡全♡食!! / 赤井はあと (official)",
    "publishedAt": "2025-06-02T09:30:06Z"
  },
  {
    "videoId": "9BAAxsn3-GI",
    "thumbnail": "https://i.ytimg.com/vi/9BAAxsn3-GI/mqdefault.jpg",
    "title": "新〇〇お披露目‼❤️‍🔥ついに新しい姿が・・・！？告知あり！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-02T11:32:01Z"
  },
  {
    "videoId": "uUeuSt0BAVI",
    "thumbnail": "https://i.ytimg.com/vi/uUeuSt0BAVI/mqdefault.jpg",
    "title": "とってもとっても!!アイシテほしい💕💕#電脳ぴゅあ推し大宣言 #dance #shorts",
    "publishedAt": "2025-06-03T09:01:23Z"
  },
  {
    "videoId": "9ldZK514pZk",
    "thumbnail": "https://i.ytimg.com/vi/9ldZK514pZk/mqdefault.jpg",
    "title": "THE SLIDE TAKE",
    "publishedAt": "2025-06-03T15:00:14Z"
  },
  {
    "videoId": "37XIfOrjhG8",
    "thumbnail": "https://i.ytimg.com/vi/37XIfOrjhG8/mqdefault.jpg",
    "title": "めちゃゴミ完全食GBフリー素材#shorts",
    "publishedAt": "2025-06-04T03:00:09Z"
  },
  {
    "videoId": "sZcUCkncCoQ",
    "thumbnail": "https://i.ytimg.com/vi/sZcUCkncCoQ/mqdefault.jpg",
    "title": "元気いっぱいで踊った💃#めちゃゴミ完全食 #shorts #dance",
    "publishedAt": "2025-06-04T03:00:59Z"
  },
  {
    "videoId": "8eeJn6tMZe0",
    "thumbnail": "https://i.ytimg.com/vi/8eeJn6tMZe0/mqdefault.jpg",
    "title": "#めちゃゴミ完全食 事務所で踊ってみた！💃#shorts #dance",
    "publishedAt": "2025-06-05T03:00:13Z"
  },
  {
    "videoId": "KECwumLt1Ss",
    "thumbnail": "https://i.ytimg.com/vi/KECwumLt1Ss/mqdefault.jpg",
    "title": "珍獣はい、あーん💘#めちゃゴミダンス #hololive #shorts",
    "publishedAt": "2025-06-06T03:00:21Z"
  },
  {
    "videoId": "vJRTYg_Rjcc",
    "thumbnail": "https://i.ytimg.com/vi/vJRTYg_Rjcc/mqdefault.jpg",
    "title": "ラーメン屋でめちゃゴミ完全食！🍜#hololive #shorts #dance",
    "publishedAt": "2025-06-07T03:01:13Z"
  },
  {
    "videoId": "LCRv4hr4rGY",
    "thumbnail": "https://i.ytimg.com/vi/LCRv4hr4rGY/mqdefault.jpg",
    "title": "めちゃゴミ完全食💃踊ってみた！#shorts #dance #hololive",
    "publishedAt": "2025-06-08T03:00:33Z"
  },
  {
    "videoId": "SDMgh7xiLbg",
    "thumbnail": "https://i.ytimg.com/vi/SDMgh7xiLbg/mqdefault.jpg",
    "title": "【振り返り】過去に遡り、記憶を旅する夜！🌙【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-08T17:31:31Z"
  },
  {
    "videoId": "ch8w0j2N1DQ",
    "thumbnail": "https://i.ytimg.com/vi/ch8w0j2N1DQ/mqdefault.jpg",
    "title": "めちゃNGテイク😵#hololive #dance #shorts #めちゃゴミ完全食",
    "publishedAt": "2025-06-09T05:04:39Z"
  },
  {
    "videoId": "QDPE1bSVxPQ",
    "thumbnail": "https://i.ytimg.com/vi/QDPE1bSVxPQ/mqdefault.jpg",
    "title": "【登山】千葉ラピュタ！？『鋸山』いってきたぞー！✊🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-10T10:14:46Z"
  },
  {
    "videoId": "VLpbjHxO_WU",
    "thumbnail": "https://i.ytimg.com/vi/VLpbjHxO_WU/mqdefault.jpg",
    "title": "千葉にある山が壮大過ぎた！#vlog #ジブリ#ghibli",
    "publishedAt": "2025-06-11T09:00:52Z"
  },
  {
    "videoId": "4xR3ZKa-6dg",
    "thumbnail": "https://i.ytimg.com/vi/4xR3ZKa-6dg/mqdefault.jpg",
    "title": "富士山の見える街で、のんびり旅！#山梨 #一人旅 #vlog",
    "publishedAt": "2025-06-12T09:00:11Z"
  },
  {
    "videoId": "UvxIJQqu6LE",
    "thumbnail": "https://i.ytimg.com/vi/UvxIJQqu6LE/mqdefault.jpg",
    "title": "【酒雑】いっぱい喋ろ～！！千葉のビールとおつまみ！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-12T17:52:28Z"
  },
  {
    "videoId": "4q5Q4pa89rs",
    "thumbnail": "https://i.ytimg.com/vi/4q5Q4pa89rs/mqdefault.jpg",
    "title": "モニタリング／赤井はあと×ロボ子さん(cover)",
    "publishedAt": "2025-06-13T09:00:06Z"
  },
  {
    "videoId": "ZdlNk_XY6ow",
    "thumbnail": "https://i.ytimg.com/vi/ZdlNk_XY6ow/mqdefault.jpg",
    "title": "サウナで整い三昧！？最高の旅館みつけた！！#vlog #山梨 #旅行",
    "publishedAt": "2025-06-13T09:00:56Z"
  },
  {
    "videoId": "MP0vO_6xod4",
    "thumbnail": "https://i.ytimg.com/vi/MP0vO_6xod4/mqdefault.jpg",
    "title": "【#ロボちゃま】Poppy playtime 告知までにクリアだああ！？😱【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-13T09:20:16Z"
  },
  {
    "videoId": "wZLvFlWwjQI",
    "thumbnail": "https://i.ytimg.com/vi/wZLvFlWwjQI/mqdefault.jpg",
    "title": "モニタリング歌ってみた出したよ‼️✨️#ろぼちゃま / DECO*27 #shorts",
    "publishedAt": "2025-06-14T09:01:31Z"
  },
  {
    "videoId": "AAEtNOG3zGY",
    "thumbnail": "https://i.ytimg.com/vi/AAEtNOG3zGY/mqdefault.jpg",
    "title": "【あつまれ どうぶつの森】0からスローライフ！島暮らし始め！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-14T18:54:22Z"
  },
  {
    "videoId": "1pHWGYiG0gs",
    "thumbnail": "https://i.ytimg.com/vi/1pHWGYiG0gs/mqdefault.jpg",
    "title": "【あつまれ どうぶつの森】0からスローライフ！のんびり島暮らし！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-15T21:59:57Z"
  },
  {
    "videoId": "Fz6Nzgk95_I",
    "thumbnail": "https://i.ytimg.com/vi/Fz6Nzgk95_I/mqdefault.jpg",
    "title": "【 Stardew Valley 】 はじめての農場スローライフ生活！＃ろぼちゃま！！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-17T17:22:57Z"
  },
  {
    "videoId": "O6jtnpzklOQ",
    "thumbnail": "https://i.ytimg.com/vi/O6jtnpzklOQ/mqdefault.jpg",
    "title": "モエチャッカファイア／赤井はあと×星川サラ(cover)【歌ってみた】",
    "publishedAt": "2025-06-19T10:00:06Z"
  },
  {
    "videoId": "uSnxAnXxx60",
    "thumbnail": "https://i.ytimg.com/vi/uSnxAnXxx60/mqdefault.jpg",
    "title": "【PLATE UP！】2人でレストランやってみる‼️✨【#ほしちゃま】",
    "publishedAt": "2025-06-19T10:09:09Z"
  },
  {
    "videoId": "uAO2gkpXhb4",
    "thumbnail": "https://i.ytimg.com/vi/uAO2gkpXhb4/mqdefault.jpg",
    "title": "【あつまれ どうぶつの森】0からスローライフ！島巡りの旅！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-19T17:38:46Z"
  },
  {
    "videoId": "c_f_un5Cwls",
    "thumbnail": "https://i.ytimg.com/vi/c_f_un5Cwls/mqdefault.jpg",
    "title": "モエチャッカファイア / 赤井はあと×星川サラ #歌ってみた",
    "publishedAt": "2025-06-20T09:01:11Z"
  },
  {
    "videoId": "0WLPsKREmN4",
    "thumbnail": "https://i.ytimg.com/vi/0WLPsKREmN4/mqdefault.jpg",
    "title": "【 歌枠 】1日の終わりにうたう💭✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-22T19:27:21Z"
  },
  {
    "videoId": "CWDpiEwlHBg",
    "thumbnail": "https://i.ytimg.com/vi/CWDpiEwlHBg/mqdefault.jpg",
    "title": "【あつまれ どうぶつの森】0からスローライフ！今日は海に潜るっ！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-24T21:09:37Z"
  },
  {
    "videoId": "Z9CYmxOd9Jk",
    "thumbnail": "https://i.ytimg.com/vi/Z9CYmxOd9Jk/mqdefault.jpg",
    "title": "【 雑談 】オカルトーク❓みんなの怖い話いっぱいきく～！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-06-25T16:46:25Z"
  },
  {
    "videoId": "WE4gDXl2wg0",
    "thumbnail": "https://i.ytimg.com/vi/WE4gDXl2wg0/mqdefault.jpg",
    "title": "【#ホロ英語伝言ゲーム】FLOW GLOW × JUSTICE!!! 9人で英会話伝言ゲーム！？【ホロライブ】",
    "publishedAt": "2025-06-29T04:11:23Z"
  },
  {
    "videoId": "wT6AdbV1Rbo",
    "thumbnail": "https://i.ytimg.com/vi/wT6AdbV1Rbo/mqdefault.jpg",
    "title": "かわいいだけじゃだめですか？／赤井はあと×水宮すう(cover)",
    "publishedAt": "2025-07-07T09:00:06Z"
  },
  {
    "videoId": "F7fifjdVv-M",
    "thumbnail": "https://i.ytimg.com/vi/F7fifjdVv-M/mqdefault.jpg",
    "title": "かわいいだけじゃだめですか？ / 赤井はあと×水宮すう #歌ってみた",
    "publishedAt": "2025-07-07T09:00:22Z"
  },
  {
    "videoId": "8_dCqWHHIFk",
    "thumbnail": "https://i.ytimg.com/vi/8_dCqWHHIFk/mqdefault.jpg",
    "title": "【 歌枠 】オフコラボでかわいい曲歌う～っ！💙❤【#すうはあ / 告知あり!!◎】",
    "publishedAt": "2025-07-07T09:09:10Z"
  },
  {
    "videoId": "LRZNrt1KvK0",
    "thumbnail": "https://i.ytimg.com/vi/LRZNrt1KvK0/mqdefault.jpg",
    "title": "【 歌枠 】1週間のおわりにうたうっ！🍋【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-12T17:56:02Z"
  },
  {
    "videoId": "DLb5AaS6c3E",
    "thumbnail": "https://i.ytimg.com/vi/DLb5AaS6c3E/mqdefault.jpg",
    "title": "いい写真、撮れたでしょ？#holonatsuParadise #ホロナツpiece #shorts【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-14T03:00:13Z"
  },
  {
    "videoId": "-1XSiZQcdZM",
    "thumbnail": "https://i.ytimg.com/vi/-1XSiZQcdZM/mqdefault.jpg",
    "title": "【あつまれ どうぶつの森】0からスローライフ！ついに家具屋さんができたっ！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-14T10:27:05Z"
  },
  {
    "videoId": "oXggD5SQkvA",
    "thumbnail": "https://i.ytimg.com/vi/oXggD5SQkvA/mqdefault.jpg",
    "title": "【オカルトーク】深夜の怖い話！みんなのお便りを読む～っ！👻【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-15T17:40:14Z"
  },
  {
    "videoId": "_R-6VsimnsQ",
    "thumbnail": "https://i.ytimg.com/vi/_R-6VsimnsQ/mqdefault.jpg",
    "title": "ふ･れ･ん･ど･し･た･い / ホロライブ1期生 (cover)",
    "publishedAt": "2025-07-18T09:00:08Z"
  },
  {
    "videoId": "gOfMLPuXxN4",
    "thumbnail": "https://i.ytimg.com/vi/gOfMLPuXxN4/mqdefault.jpg",
    "title": "ふ･れ･ん･ど･し･た･い / ホロライブ1期生 #歌ってみた",
    "publishedAt": "2025-07-18T09:15:09Z"
  },
  {
    "videoId": "sD0fNGILu8k",
    "thumbnail": "https://i.ytimg.com/vi/sD0fNGILu8k/mqdefault.jpg",
    "title": "【あつまれ どうぶつの森】0からスローライフ！夢のマイルームっ！！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-19T21:45:57Z"
  },
  {
    "videoId": "6_IwN7XvdcA",
    "thumbnail": "https://i.ytimg.com/vi/6_IwN7XvdcA/mqdefault.jpg",
    "title": "【歌枠】SINGING~!!🎤うたうぞ～～～っ！🎆🍉#ホロナツ歌枠リレー【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-26T05:04:14Z"
  },
  {
    "videoId": "xFa04bMu5AE",
    "thumbnail": "https://i.ytimg.com/vi/xFa04bMu5AE/mqdefault.jpg",
    "title": "神綺杏奈ちゃんが #めちゃゴミ完全食 踊ってくれたよおおお❤️‍🔥めちゃかわいいいい❗️#shorts #踊ってみた",
    "publishedAt": "2025-07-28T13:48:20Z"
  },
  {
    "videoId": "DpjNioJShPQ",
    "thumbnail": "https://i.ytimg.com/vi/DpjNioJShPQ/mqdefault.jpg",
    "title": "【】わぁ【】",
    "publishedAt": "2025-07-28T22:10:30Z"
  },
  {
    "videoId": "ORWwSRl570c",
    "thumbnail": "https://i.ytimg.com/vi/ORWwSRl570c/mqdefault.jpg",
    "title": "【睡眠導入】深夜の朗読！まったり眠れる読み聞かせ～っ！📖【ホロライブ/赤井はあと】",
    "publishedAt": "2025-07-29T16:11:23Z"
  },
  {
    "videoId": "HvwMsT_m5f8",
    "thumbnail": "https://i.ytimg.com/vi/HvwMsT_m5f8/mqdefault.jpg",
    "title": "【】おれ、おれおれ【】",
    "publishedAt": "2025-07-30T22:41:58Z"
  },
  {
    "videoId": "OBnOV4Of86I",
    "thumbnail": "https://i.ytimg.com/vi/OBnOV4Of86I/mqdefault.jpg",
    "title": "【ラジオ英会話】ちゃまー！サマー！イングリッシュ‼️🌅【RADIO ENGLISH】",
    "publishedAt": "2025-07-31T22:18:28Z"
  },
  {
    "videoId": "WbqkRIx4y8A",
    "thumbnail": "https://i.ytimg.com/vi/WbqkRIx4y8A/mqdefault.jpg",
    "title": "【料理】夏だ！修行だ！クリームソーダ作りっ‼️｜喫茶ちゃま☕【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-01T05:14:00Z"
  },
  {
    "videoId": "tmfdYJ28fqo",
    "thumbnail": "https://i.ytimg.com/vi/tmfdYJ28fqo/mqdefault.jpg",
    "title": "【ラジオ英会話】#3 ちゃまー！サマー！イングリッシュ‼️👻【RADIO ENGLISH｜ホラー編】",
    "publishedAt": "2025-08-01T22:06:25Z"
  },
  {
    "videoId": "m1v1dr_fDig",
    "thumbnail": "https://i.ytimg.com/vi/m1v1dr_fDig/mqdefault.jpg",
    "title": "【 料理 】ナポリタンたんったたたーーーんっ♪🍝❕❕❕🍝喫茶ちゃま☕【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-02T05:26:13Z"
  },
  {
    "videoId": "C1Vez7lA5Do",
    "thumbnail": "https://i.ytimg.com/vi/C1Vez7lA5Do/mqdefault.jpg",
    "title": "【重大告知】‼️‼️‼️重　大　告　知　‼️‼️‼️&旅特集～～～っ！✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-03T10:11:58Z"
  },
  {
    "videoId": "BzbMR_t2_jY",
    "thumbnail": "https://i.ytimg.com/vi/BzbMR_t2_jY/mqdefault.jpg",
    "title": "【ラジオ英会話】ちゃまー！サマー！イングリッシュ‼️👻【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-03T22:17:06Z"
  },
  {
    "videoId": "CwA0WRp6ML0",
    "thumbnail": "https://i.ytimg.com/vi/CwA0WRp6ML0/mqdefault.jpg",
    "title": "#赤井はあと爆誕祭2025 ゲスト発見‼️いったい何するんだ⁉️#shorts",
    "publishedAt": "2025-08-04T09:00:17Z"
  },
  {
    "videoId": "_GcNpYYTi2c",
    "thumbnail": "https://i.ytimg.com/vi/_GcNpYYTi2c/mqdefault.jpg",
    "title": "【歌】ずっと、おれ【枠】",
    "publishedAt": "2025-08-04T09:22:31Z"
  },
  {
    "videoId": "GSgfaaog8q8",
    "thumbnail": "https://i.ytimg.com/vi/GSgfaaog8q8/mqdefault.jpg",
    "title": "【ラジオ英会話】#4 ちゃまー！サマー！イングリッシュ‼️🛟【RADIO ENGLISH｜推し活編】",
    "publishedAt": "2025-08-04T22:17:48Z"
  },
  {
    "videoId": "B3yNIM5lZTI",
    "thumbnail": "https://i.ytimg.com/vi/B3yNIM5lZTI/mqdefault.jpg",
    "title": "#赤井はあと爆誕祭2025 ゲスト発見❗️なんの曲歌うでしょーか❕❔#shorts",
    "publishedAt": "2025-08-05T09:00:12Z"
  },
  {
    "videoId": "IB_40WNw_t8",
    "thumbnail": "https://i.ytimg.com/vi/IB_40WNw_t8/mqdefault.jpg",
    "title": "【】おなかすいちゃま【】",
    "publishedAt": "2025-08-05T22:07:23Z"
  },
  {
    "videoId": "zMt-bYSNkw8",
    "thumbnail": "https://i.ytimg.com/vi/zMt-bYSNkw8/mqdefault.jpg",
    "title": "【ラジオ英会話】ちゃまー！サマー！イングリッシュ‼️🛟#5【RADIO ENGLISH】",
    "publishedAt": "2025-08-05T23:32:53Z"
  },
  {
    "videoId": "ym0FabHu9bs",
    "thumbnail": "https://i.ytimg.com/vi/ym0FabHu9bs/mqdefault.jpg",
    "title": "【 プチ旅 】まったりお喋りしながら喫茶巡り！🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-06T15:10:44Z"
  },
  {
    "videoId": "JH-dLQAmbJI",
    "thumbnail": "https://i.ytimg.com/vi/JH-dLQAmbJI/mqdefault.jpg",
    "title": "#赤井はあと爆誕祭2025 SPECIAL GUESTS!!!❤️‍🔥❤️‍🔥❤️‍🔥#shorts",
    "publishedAt": "2025-08-07T09:00:23Z"
  },
  {
    "videoId": "DS0guZrrjzA",
    "thumbnail": "https://i.ytimg.com/vi/DS0guZrrjzA/mqdefault.jpg",
    "title": "【ラジオ英会話】ちゃまー！サマー！イングリッシュ‼️🛟#6【RADIO ENGLISH】",
    "publishedAt": "2025-08-07T22:14:22Z"
  },
  {
    "videoId": "ZWh6FQ1IfYM",
    "thumbnail": "https://i.ytimg.com/vi/ZWh6FQ1IfYM/mqdefault.jpg",
    "title": "#赤井はあと爆誕祭2025 3年ぶりのゲスト⁉️⁉️⁉️#shorts",
    "publishedAt": "2025-08-08T09:00:56Z"
  },
  {
    "videoId": "TDAi76m1GwU",
    "thumbnail": "https://i.ytimg.com/vi/TDAi76m1GwU/mqdefault.jpg",
    "title": "#赤井はあと爆誕祭2025 ゲスト発表‼️令嬢がやってきたーっ❕✨️#shorts",
    "publishedAt": "2025-08-09T09:00:43Z"
  },
  {
    "videoId": "3OGiP95SkRc",
    "thumbnail": "https://i.ytimg.com/vi/3OGiP95SkRc/mqdefault.jpg",
    "title": "【誕生日】クリアするまで、生まれません‼️‼️‼️‼️‼️‼️【カウントダウン!?】【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-09T15:42:35Z"
  },
  {
    "videoId": "WSO2xiVQdxY",
    "thumbnail": "https://i.ytimg.com/vi/WSO2xiVQdxY/mqdefault.jpg",
    "title": "#赤井はあと爆誕祭2025 本日開催‼️見に来てね〜〜〜っ！！✨✨",
    "publishedAt": "2025-08-10T10:39:11Z"
  },
  {
    "videoId": "sPVnvaBjQI0",
    "thumbnail": "https://i.ytimg.com/vi/sPVnvaBjQI0/mqdefault.jpg",
    "title": "感触 / 赤井はあと (official)",
    "publishedAt": "2025-08-10T13:00:06Z"
  },
  {
    "videoId": "vTsOdumJEOY",
    "thumbnail": "https://i.ytimg.com/vi/vTsOdumJEOY/mqdefault.jpg",
    "title": "【3DLIVE】夏のホラー満載‼️#赤井はあと爆誕祭2025 👻【ゲスト多数&告知あり◎】【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-10T13:15:44Z"
  },
  {
    "videoId": "Rf4Tj5prI3I",
    "thumbnail": "https://i.ytimg.com/vi/Rf4Tj5prI3I/mqdefault.jpg",
    "title": "【CM】赤井はあと生誕グッズの紹介っ！！✨✨【期間限定!!】",
    "publishedAt": "2025-08-10T15:00:56Z"
  },
  {
    "videoId": "PamZEa31omA",
    "thumbnail": "https://i.ytimg.com/vi/PamZEa31omA/mqdefault.jpg",
    "title": "【衝撃】気づいてた⁉️実はこうなってた・・・！【撮影の裏側】",
    "publishedAt": "2025-08-11T09:00:41Z"
  },
  {
    "videoId": "TcV8gN50ddo",
    "thumbnail": "https://i.ytimg.com/vi/TcV8gN50ddo/mqdefault.jpg",
    "title": "新曲の「感触」がレトロでお洒落すぎる⁉️✨️#shorts",
    "publishedAt": "2025-08-11T09:00:46Z"
  },
  {
    "videoId": "ad0cNlw6c8c",
    "thumbnail": "https://i.ytimg.com/vi/ad0cNlw6c8c/mqdefault.jpg",
    "title": "【Minecraft】デートスポット作りま・・・・・・・・・・・【ホロライブ/赤井はあと】#ホロ鯖サマーパーク",
    "publishedAt": "2025-08-11T21:24:43Z"
  },
  {
    "videoId": "-cCHsxq65wE",
    "thumbnail": "https://i.ytimg.com/vi/-cCHsxq65wE/mqdefault.jpg",
    "title": "新曲 #感触 💐美しく✨️踊ってみた！#shorts #dance #hololive",
    "publishedAt": "2025-08-12T09:00:01Z"
  },
  {
    "videoId": "sa8S6bQzOEQ",
    "thumbnail": "https://i.ytimg.com/vi/sa8S6bQzOEQ/mqdefault.jpg",
    "title": "【裏話】お披露目あり‼️✨#赤井はあと爆誕祭2025 最高だった～～～！！！❤️‍🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-12T19:03:31Z"
  },
  {
    "videoId": "L291YgdqNv8",
    "thumbnail": "https://i.ytimg.com/vi/L291YgdqNv8/mqdefault.jpg",
    "title": "【PEAK】LET'S TRIP TOGETHER!!!✈@ShioriNovella @IRyS",
    "publishedAt": "2025-08-13T03:33:08Z"
  },
  {
    "videoId": "xhDUTA39a3Q",
    "thumbnail": "https://i.ytimg.com/vi/xhDUTA39a3Q/mqdefault.jpg",
    "title": "【Minecraft】深夜に作る、夜行観覧車。#ホロ鯖サマーパーク 【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-13T23:23:51Z"
  },
  {
    "videoId": "ZpGxQSv0bfs",
    "thumbnail": "https://i.ytimg.com/vi/ZpGxQSv0bfs/mqdefault.jpg",
    "title": "お人形 / 赤井はあと 【ライブ映像切り抜き】",
    "publishedAt": "2025-08-14T03:00:46Z"
  },
  {
    "videoId": "1wy9bjlUX5o",
    "thumbnail": "https://i.ytimg.com/vi/1wy9bjlUX5o/mqdefault.jpg",
    "title": "まさかの共演⁉️3Dライブ感動シーン！✨️【正しくなれない/ずっと真夜中でいいのに。】#dance #shorts",
    "publishedAt": "2025-08-14T09:00:05Z"
  },
  {
    "videoId": "274_2pNSaCQ",
    "thumbnail": "https://i.ytimg.com/vi/274_2pNSaCQ/mqdefault.jpg",
    "title": "【Minecraft】#ホロ鯖サマーパーク SL機関車がつくりた～～～～いっ❕🥳【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-14T16:48:06Z"
  },
  {
    "videoId": "sI7zs4UYr_I",
    "thumbnail": "https://i.ytimg.com/vi/sI7zs4UYr_I/mqdefault.jpg",
    "title": "【絶叫】呪物コレクターの自宅にご訪問⁉️まさかの展開に…😱#オカルト #呪物",
    "publishedAt": "2025-08-15T09:01:19Z"
  },
  {
    "videoId": "3jylUgSiDns",
    "thumbnail": "https://i.ytimg.com/vi/3jylUgSiDns/mqdefault.jpg",
    "title": "【Minecraft】#ホロ鯖サマーパーク すうはあでジェットコースター作り～!!💭✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-15T20:12:55Z"
  },
  {
    "videoId": "2vW2JWnhTCo",
    "thumbnail": "https://i.ytimg.com/vi/2vW2JWnhTCo/mqdefault.jpg",
    "title": "新ゴスロリ衣装で #モニタリング 踊ってみた！🌟【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-16T09:13:04Z"
  },
  {
    "videoId": "48VtAMXiXGY",
    "thumbnail": "https://i.ytimg.com/vi/48VtAMXiXGY/mqdefault.jpg",
    "title": "【Minecraft】#ホロ鯖サマーパーク ついに当日‼️いっぱい楽しむぞおおお～～～！！🎆【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-16T15:32:10Z"
  },
  {
    "videoId": "rpTuxDBcwHA",
    "thumbnail": "https://i.ytimg.com/vi/rpTuxDBcwHA/mqdefault.jpg",
    "title": "新曲#お人形 ダンス❕浴衣で踊ったよー！⛩✨️#dance #shorts",
    "publishedAt": "2025-08-17T03:00:49Z"
  },
  {
    "videoId": "Ql-T_W7Y0RU",
    "thumbnail": "https://i.ytimg.com/vi/Ql-T_W7Y0RU/mqdefault.jpg",
    "title": "【衝撃】タランちゃま誕生秘話⁉️👀✨️ジャンプ力やばすぎ・・・！#shorts #dance",
    "publishedAt": "2025-08-18T09:00:38Z"
  },
  {
    "videoId": "ggnU4LLepaY",
    "thumbnail": "https://i.ytimg.com/vi/ggnU4LLepaY/mqdefault.jpg",
    "title": "【会談】呪物コレクターのお宅にご訪問！？【ホラー】",
    "publishedAt": "2025-08-18T17:00:06Z"
  },
  {
    "videoId": "HMKysSPCElM",
    "thumbnail": "https://i.ytimg.com/vi/HMKysSPCElM/mqdefault.jpg",
    "title": "【オカルトーク】深夜の怖い話！みんなのお便りを読む～っ！👻【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-18T17:09:14Z"
  },
  {
    "videoId": "MJtnII9bUqc",
    "thumbnail": "https://i.ytimg.com/vi/MJtnII9bUqc/mqdefault.jpg",
    "title": "新ゴスロリ衣装で #モエチャッカファイア 踊ってみた‼️✨️【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-19T09:00:37Z"
  },
  {
    "videoId": "PlSY-SBy0xU",
    "thumbnail": "https://i.ytimg.com/vi/PlSY-SBy0xU/mqdefault.jpg",
    "title": "【PEAK】サロメちゃんと一緒に山登りだあああああああ⁉️【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-19T14:00:15Z"
  },
  {
    "videoId": "3tMIzJjwTWE",
    "thumbnail": "https://i.ytimg.com/vi/3tMIzJjwTWE/mqdefault.jpg",
    "title": "虚無いちゃま・・・・・・・・【オフショット】#赤井はあと",
    "publishedAt": "2025-08-20T09:00:07Z"
  },
  {
    "videoId": "bUBqqv1scsY",
    "thumbnail": "https://i.ytimg.com/vi/bUBqqv1scsY/mqdefault.jpg",
    "title": "ダンスのラストに注目・・・‼️難しい！！#お人形【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-21T09:00:59Z"
  },
  {
    "videoId": "MnHz1ZE45Dc",
    "thumbnail": "https://i.ytimg.com/vi/MnHz1ZE45Dc/mqdefault.jpg",
    "title": "【 歌枠 】ご機嫌るんるんにうたうっ！🌷【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-21T17:51:55Z"
  },
  {
    "videoId": "cSyBghtyX44",
    "thumbnail": "https://i.ytimg.com/vi/cSyBghtyX44/mqdefault.jpg",
    "title": "振り付けもダンスも異次元すぎっ‼️✨️#お人形 可愛すぎる【オリジナル曲】#赤井はあと",
    "publishedAt": "2025-08-24T09:01:01Z"
  },
  {
    "videoId": "FkCfFccfzQY",
    "thumbnail": "https://i.ytimg.com/vi/FkCfFccfzQY/mqdefault.jpg",
    "title": "【着信】もしもしもしもしもしもしもしもしもしもし【あり】",
    "publishedAt": "2025-08-24T22:31:08Z"
  },
  {
    "videoId": "o4tKa0OdjQo",
    "thumbnail": "https://i.ytimg.com/vi/o4tKa0OdjQo/mqdefault.jpg",
    "title": "【おじさんと踊ってみた】お返事まだカナ💦❓おじさん構文😁❗️/雨衣【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-26T09:01:08Z"
  },
  {
    "videoId": "jRm8sne9CvU",
    "thumbnail": "https://i.ytimg.com/vi/jRm8sne9CvU/mqdefault.jpg",
    "title": "【 旅 】ちゃまと旅する！香川で大冒険だあああああああああ！！！✨🚃（前編）【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-26T14:30:57Z"
  },
  {
    "videoId": "PnMImRbpnAs",
    "thumbnail": "https://i.ytimg.com/vi/PnMImRbpnAs/mqdefault.jpg",
    "title": "最後まちがえました❕出直してきまNG🍒【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-27T09:00:42Z"
  },
  {
    "videoId": "vNNJG2wtd_Y",
    "thumbnail": "https://i.ytimg.com/vi/vNNJG2wtd_Y/mqdefault.jpg",
    "title": "【 旅 】ちゃまと旅する！香川の小豆島巡りだあああ～～～！！！🚲✨（後編）【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-27T15:52:02Z"
  },
  {
    "videoId": "2E4yPAJxKnA",
    "thumbnail": "https://i.ytimg.com/vi/2E4yPAJxKnA/mqdefault.jpg",
    "title": "ぼろぼろになっちゃうぞ～～～❕✨【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-28T09:00:09Z"
  },
  {
    "videoId": "qm39-KxbdhQ",
    "thumbnail": "https://i.ytimg.com/vi/qm39-KxbdhQ/mqdefault.jpg",
    "title": "Are you ready❓出来る限りの全力で、踊ってみた！✨️【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-29T09:01:29Z"
  },
  {
    "videoId": "BGiIKULBNKY",
    "thumbnail": "https://i.ytimg.com/vi/BGiIKULBNKY/mqdefault.jpg",
    "title": "【NG】#テレパシ 踊ってみた❕が即退場⚡️【踊ってみた】#赤井はあと",
    "publishedAt": "2025-08-30T09:00:22Z"
  },
  {
    "videoId": "Sr0xKJ6ZK_0",
    "thumbnail": "https://i.ytimg.com/vi/Sr0xKJ6ZK_0/mqdefault.jpg",
    "title": "【 歌枠 】寝る前に大熱唱なちゃま～～～っ💖!!!✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-08-30T16:54:55Z"
  },
  {
    "videoId": "BMYAM5l29WI",
    "thumbnail": "https://i.ytimg.com/vi/BMYAM5l29WI/mqdefault.jpg",
    "title": "おっおー、おじさんじゃダメかな💦❓踊ってみた😁❗️#お返事まだカナおじさん構文 #shorts #dance",
    "publishedAt": "2025-08-31T09:00:15Z"
  },
  {
    "videoId": "SC6mSzawuLA",
    "thumbnail": "https://i.ytimg.com/vi/SC6mSzawuLA/mqdefault.jpg",
    "title": "【心霊】はあちゃま、心霊スポット巡礼ツアーへ行く！？【ホラー】",
    "publishedAt": "2025-08-31T15:00:06Z"
  },
  {
    "videoId": "UMYpCbty1ok",
    "thumbnail": "https://i.ytimg.com/vi/UMYpCbty1ok/mqdefault.jpg",
    "title": "【作業用BGM】Cafe Time Jazz『感触』｜喫茶店の優雅なひととき",
    "publishedAt": "2025-08-31T21:30:06Z"
  },
  {
    "videoId": "uJFfvRdz8Gc",
    "thumbnail": "https://i.ytimg.com/vi/uJFfvRdz8Gc/mqdefault.jpg",
    "title": "振り付けが美しすぎる・・・！✨#感触 クセになる【オリジナル曲】",
    "publishedAt": "2025-09-01T09:01:22Z"
  },
  {
    "videoId": "AzgFbGhEYwk",
    "thumbnail": "https://i.ytimg.com/vi/AzgFbGhEYwk/mqdefault.jpg",
    "title": "まいどん先生の❕#感触 とにかく美しい・・・💐✨️ 【オリジナル曲】",
    "publishedAt": "2025-09-02T09:00:25Z"
  },
  {
    "videoId": "XI5oG8t6DiE",
    "thumbnail": "https://i.ytimg.com/vi/XI5oG8t6DiE/mqdefault.jpg",
    "title": "#チェリーポップ 🍒すきっ！すきっ！たかたったったっ❕【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-03T09:00:46Z"
  },
  {
    "videoId": "gqDqujgcC34",
    "thumbnail": "https://i.ytimg.com/vi/gqDqujgcC34/mqdefault.jpg",
    "title": "【 ゆけむり温泉郷2 】9月から、旅館経営はじめます‼️♨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-03T14:48:50Z"
  },
  {
    "videoId": "8_98JpKskLc",
    "thumbnail": "https://i.ytimg.com/vi/8_98JpKskLc/mqdefault.jpg",
    "title": "【レアNG】段々うしろに行っちゃった❕#テレパシ 【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-04T09:00:09Z"
  },
  {
    "videoId": "Exrmb_qhMys",
    "thumbnail": "https://i.ytimg.com/vi/Exrmb_qhMys/mqdefault.jpg",
    "title": "飛び跳ねるのに夢中で毎回出だしミスる❕💦【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-05T09:00:22Z"
  },
  {
    "videoId": "bPillswzShY",
    "thumbnail": "https://i.ytimg.com/vi/bPillswzShY/mqdefault.jpg",
    "title": "【ゆけむり温泉郷2】この旅館を世界一にしてみせましょう・・・❕[第二話]【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-05T17:02:48Z"
  },
  {
    "videoId": "Hln1dRNHCOI",
    "thumbnail": "https://i.ytimg.com/vi/Hln1dRNHCOI/mqdefault.jpg",
    "title": "振り付け最高!!めちゃかわいいね～っ！✨【オリジナル曲】#赤井はあと",
    "publishedAt": "2025-09-06T09:00:24Z"
  },
  {
    "videoId": "zUWRHQXSUyE",
    "thumbnail": "https://i.ytimg.com/vi/zUWRHQXSUyE/mqdefault.jpg",
    "title": "【 花火大会 】夏の思い出に！一緒に花火みよ～～～っ！🎆✨【同時視聴｜#ホロ花火】",
    "publishedAt": "2025-09-06T12:11:09Z"
  },
  {
    "videoId": "gGiKxFmF7XU",
    "thumbnail": "https://i.ytimg.com/vi/gGiKxFmF7XU/mqdefault.jpg",
    "title": "【おじさんが踊ってみた】ぶひぶひ🐽豚さんじゃダメかな❔【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-07T09:01:02Z"
  },
  {
    "videoId": "9dpdepyMm-I",
    "thumbnail": "https://i.ytimg.com/vi/9dpdepyMm-I/mqdefault.jpg",
    "title": "悔しいから、前に進む。【本音トーク】※切り抜き禁止",
    "publishedAt": "2025-09-07T16:01:52Z"
  },
  {
    "videoId": "sX-_vaHlFQw",
    "thumbnail": "https://i.ytimg.com/vi/sX-_vaHlFQw/mqdefault.jpg",
    "title": "あっ・・・・・・・・【NG】【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-08T09:01:16Z"
  },
  {
    "videoId": "glS_VOyrwN0",
    "thumbnail": "https://i.ytimg.com/vi/glS_VOyrwN0/mqdefault.jpg",
    "title": "振り付けかわいすぎーっ❕🫶🏻‎🎀んなああ！【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-09T09:00:59Z"
  },
  {
    "videoId": "EPLQ4GjjJb0",
    "thumbnail": "https://i.ytimg.com/vi/EPLQ4GjjJb0/mqdefault.jpg",
    "title": "歌って気合入れる！！！【魂の叫び歌枠】",
    "publishedAt": "2025-09-09T13:32:58Z"
  },
  {
    "videoId": "LbtwLfDNyFs",
    "thumbnail": "https://i.ytimg.com/vi/LbtwLfDNyFs/mqdefault.jpg",
    "title": "#感触 1ヶ月記念🎉ひとひらの記憶【赤井はあと】オリジナル曲！",
    "publishedAt": "2025-09-10T09:00:26Z"
  },
  {
    "videoId": "-CDvRQ9sEIQ",
    "thumbnail": "https://i.ytimg.com/vi/-CDvRQ9sEIQ/mqdefault.jpg",
    "title": "あれ？ノリノリで踊ってたら終わってた！🌟#テレパシ 【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-11T09:00:01Z"
  },
  {
    "videoId": "PXEBYPJKXHo",
    "thumbnail": "https://i.ytimg.com/vi/PXEBYPJKXHo/mqdefault.jpg",
    "title": "【ゆけむり温泉郷2】汚い旅館を、整えろ・・・！！！！！！【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-11T15:25:11Z"
  },
  {
    "videoId": "B96289H2vDA",
    "thumbnail": "https://i.ytimg.com/vi/B96289H2vDA/mqdefault.jpg",
    "title": "船長のホニマニダンス💘 全力セクシーで【踊ってみた】#赤井はあと",
    "publishedAt": "2025-09-12T09:00:26Z"
  },
  {
    "videoId": "GnFR0SbgkC0",
    "thumbnail": "https://i.ytimg.com/vi/GnFR0SbgkC0/mqdefault.jpg",
    "title": "【お知らせ】私から大事なお知らせがあります❕🌟【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-12T16:23:01Z"
  },
  {
    "videoId": "769i2CP-DBw",
    "thumbnail": "https://i.ytimg.com/vi/769i2CP-DBw/mqdefault.jpg",
    "title": "いつかは喝采クラップオーディエンス❕すいちゃんの☄️#ビビデバ #赤井はあと【踊ってみた】",
    "publishedAt": "2025-09-13T09:00:09Z"
  },
  {
    "videoId": "NplKSsbhqHc",
    "thumbnail": "https://i.ytimg.com/vi/NplKSsbhqHc/mqdefault.jpg",
    "title": "【 歌枠 】懐かしい曲うたう・・・！夏だけに！！！🍉✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-13T13:36:15Z"
  },
  {
    "videoId": "b8cTDF2jWjs",
    "thumbnail": "https://i.ytimg.com/vi/b8cTDF2jWjs/mqdefault.jpg",
    "title": "【最終回】ありがとう、はあちゃまクッキング・・・❤️‍🔥【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-14T12:30:40Z"
  },
  {
    "videoId": "u9fQlOhSJB0",
    "thumbnail": "https://i.ytimg.com/vi/u9fQlOhSJB0/mqdefault.jpg",
    "title": "意外と可愛くてセクシー❕❔#赤井はあと 【踊ってみた】",
    "publishedAt": "2025-09-15T09:01:28Z"
  },
  {
    "videoId": "A8V5nEwb3sc",
    "thumbnail": "https://i.ytimg.com/vi/A8V5nEwb3sc/mqdefault.jpg",
    "title": "【 旅 】「琴平」を盛り上げる!!地元の皆さんと魅力大紹介～～～！！🚃✨【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-15T12:17:52Z"
  },
  {
    "videoId": "pqf_M_yl7Cw",
    "thumbnail": "https://i.ytimg.com/vi/pqf_M_yl7Cw/mqdefault.jpg",
    "title": "【 雑談 】明日から休暇！寝る前にいっぱいしゃべろ～～～！💤【ホロライブ/赤井はあと】",
    "publishedAt": "2025-09-15T16:18:04Z"
  },
  {
    "videoId": "FgKlerazTDk",
    "thumbnail": "https://i.ytimg.com/vi/FgKlerazTDk/mqdefault.jpg",
    "title": "じぶんROCK / 赤井はあと(cover)【ONE OK ROCK】",
    "publishedAt": "2025-09-22T11:00:06Z"
  },
  {
    "videoId": "bIJtPbdRkRE",
    "thumbnail": "https://i.ytimg.com/vi/bIJtPbdRkRE/mqdefault.jpg",
    "title": "ジェットコースターみたいな寝台列車　#vlog #一人旅",
    "publishedAt": "2025-09-27T14:05:02Z"
  },
  {
    "videoId": "kcchLFMWOTE",
    "thumbnail": "https://i.ytimg.com/vi/kcchLFMWOTE/mqdefault.jpg",
    "title": "えっ・・・・・・・・・#vlog #一人旅",
    "publishedAt": "2025-09-30T15:38:04Z"
  },
  {
    "videoId": "GtlGKM5ILks",
    "thumbnail": "https://i.ytimg.com/vi/GtlGKM5ILks/mqdefault.jpg",
    "title": "人生はじめての挑戦❕📮#雑貨 #シーリング",
    "publishedAt": "2025-10-01T09:00:32Z"
  },
  {
    "videoId": "vfwk5m_zwv8",
    "thumbnail": "https://i.ytimg.com/vi/vfwk5m_zwv8/mqdefault.jpg",
    "title": "チェリーポップ / 赤井はあと(cover)【DECO*27】",
    "publishedAt": "2025-10-12T11:00:06Z"
  },
  {
    "videoId": "fUSmv-Aoy_Q",
    "thumbnail": "https://i.ytimg.com/vi/fUSmv-Aoy_Q/mqdefault.jpg",
    "title": "チェリーポップ歌ってみた出たよ〜🍒#赤井はあと",
    "publishedAt": "2025-10-12T12:09:31Z"
  },
  {
    "videoId": "YErOo0fUfmM",
    "thumbnail": "https://i.ytimg.com/vi/YErOo0fUfmM/mqdefault.jpg",
    "title": "えぶりでいホスト🍷踊ってみた！#赤井はあと",
    "publishedAt": "2025-10-13T09:00:51Z"
  },
  {
    "videoId": "-x3TS5gW_20",
    "thumbnail": "https://i.ytimg.com/vi/-x3TS5gW_20/mqdefault.jpg",
    "title": "【日本一】現役アイドル、富士山の頂上に挑戦⁉️【日本のてっぺんとっちゃま☆彡】",
    "publishedAt": "2025-10-14T12:00:06Z"
  },
  {
    "videoId": "hY7o1K_y-Zs",
    "thumbnail": "https://i.ytimg.com/vi/hY7o1K_y-Zs/mqdefault.jpg",
    "title": "【初配信】俺が、赤くゆになってやんよ！！！！！！🔥【重大告知あり◎】",
    "publishedAt": "2025-10-14T12:07:52Z"
  },
  {
    "videoId": "rjXpuQ9oMpI",
    "thumbnail": "https://i.ytimg.com/vi/rjXpuQ9oMpI/mqdefault.jpg",
    "title": "【富士山】いろんなことありました🗻振り返りトーーーク❗️【ホロライブ/赤井はあと】",
    "publishedAt": "2025-10-15T15:00:37Z"
  },
  {
    "videoId": "egpHivusivI",
    "thumbnail": "https://i.ytimg.com/vi/egpHivusivI/mqdefault.jpg",
    "title": "【考察】ホロライブメンバーを映画『ハリー・ポッター』のキャラに当てはめてみた⁉💌【ホロライブ/赤井はあと】",
    "publishedAt": "2025-10-21T11:26:42Z"
  },
  {
    "videoId": "ilUQFnrOuUY",
    "thumbnail": "https://i.ytimg.com/vi/ilUQFnrOuUY/mqdefault.jpg",
    "title": "【考察】ホロライブメンバーを映画『ハリー・ポッター』のキャラに当てはめてみた⁉💌【ホロライブ/赤井はあと】",
    "publishedAt": "2025-10-21T13:50:08Z"
  },
  {
    "videoId": "dVot2DYA03g",
    "thumbnail": "https://i.ytimg.com/vi/dVot2DYA03g/mqdefault.jpg",
    "title": "【＃PR】Switch2版を手にした赤井❗️今、立ち上がる・・・！！！『ホグワーツ・レガシー』-Hogwarts Legacy",
    "publishedAt": "2025-10-23T06:59:17Z"
  },
  {
    "videoId": "jjm6dSej2jU",
    "thumbnail": "https://i.ytimg.com/vi/jjm6dSej2jU/mqdefault.jpg",
    "title": "【寝る前】赤井はあと時々はあちゃま【♨トーク】",
    "publishedAt": "2025-10-23T18:17:54Z"
  },
  {
    "videoId": "G8wrjCkgyRM",
    "thumbnail": "https://i.ytimg.com/vi/G8wrjCkgyRM/mqdefault.jpg",
    "title": "【Hogwarts Legacy】LET'S GOOO!!!🕷『ホグワーツ・レガシー』【＃PR】",
    "publishedAt": "2025-10-24T17:55:12Z"
  },
  {
    "videoId": "J-XP9div4bs",
    "thumbnail": "https://i.ytimg.com/vi/J-XP9div4bs/mqdefault.jpg",
    "title": "【歌】DON’T LOSE MY TIME【ホロライブ/赤井はあと】",
    "publishedAt": "2025-10-27T23:29:49Z"
  }
],
  Aki :
  [
  {
    "videoId": "m-rMNVWzz-E",
    "thumbnail": "https://i.ytimg.com/vi/m-rMNVWzz-E/mqdefault.jpg",
    "title": "[ツイキャス] 録画ラジオ #469281717 (2018.06.05)",
    "publishedAt": "2018-06-08T09:04:46Z"
  },
  {
    "videoId": "QBwS7N0fjXY",
    "thumbnail": "https://i.ytimg.com/vi/QBwS7N0fjXY/mqdefault.jpg",
    "title": "はじめてのYouTubeテスト配信【1】 ＠アキ・ローゼンタール",
    "publishedAt": "2018-06-08T15:48:24Z"
  },
  {
    "videoId": "RhSdSgIaaq0",
    "thumbnail": "https://i.ytimg.com/vi/RhSdSgIaaq0/mqdefault.jpg",
    "title": "はじめてのYouTubeテスト配信【1】再チャレンジ ＠アキ・ローゼンタール",
    "publishedAt": "2018-06-08T16:43:50Z"
  },
  {
    "videoId": "di-i5HJxMsw",
    "thumbnail": "https://i.ytimg.com/vi/di-i5HJxMsw/mqdefault.jpg",
    "title": "6/14(木)夜アキに教えて🍎✨ #アキびゅーわーるど !異世界から来たバーチャルホロライバー！Mirrativ",
    "publishedAt": "2018-06-15T11:11:24Z"
  },
  {
    "videoId": "ymw8Mi5Jnts",
    "thumbnail": "https://i.ytimg.com/vi/ymw8Mi5Jnts/mqdefault.jpg",
    "title": "7/4(水)【毎日生放送】アキに教えて！アキびゅーわーるど【Vtuber】アキ・ローゼンタール",
    "publishedAt": "2018-07-04T04:34:11Z"
  },
  {
    "videoId": "rP34BaYf1x8",
    "thumbnail": "https://i.ytimg.com/vi/rP34BaYf1x8/mqdefault.jpg",
    "title": "【アキ・ローゼンタール】ボイス販売スペシャルコラボLIVE!【夏色まつり】",
    "publishedAt": "2018-07-06T15:41:46Z"
  },
  {
    "videoId": "LXbtwsmE478",
    "thumbnail": "https://i.ytimg.com/vi/LXbtwsmE478/mqdefault.jpg",
    "title": "【Vtuber】異世界女子高生がゼロから始めるマイクラ生活-１日目-【Minecraft】",
    "publishedAt": "2018-07-12T15:05:44Z"
  },
  {
    "videoId": "fSo4lp-6JYA",
    "thumbnail": "https://i.ytimg.com/vi/fSo4lp-6JYA/mqdefault.jpg",
    "title": "7/13(金)【毎日生放送‼】みんなで作る参加型ラジオ放送【アキ・ローゼンタール】",
    "publishedAt": "2018-07-13T04:37:34Z"
  },
  {
    "videoId": "UFm9KVNNifk",
    "thumbnail": "https://i.ytimg.com/vi/UFm9KVNNifk/mqdefault.jpg",
    "title": "【Vtuber】目で惚れさせる【アキ・ローゼンタール】",
    "publishedAt": "2018-07-15T20:55:50Z"
  },
  {
    "videoId": "SW06X_r-PB8",
    "thumbnail": "https://i.ytimg.com/vi/SW06X_r-PB8/mqdefault.jpg",
    "title": "まったり雑談【 Mirrativアーカイブ】【Vtuber/アキ・ローゼンタール】",
    "publishedAt": "2018-07-30T11:32:59Z"
  },
  {
    "videoId": "63vwRmugT5w",
    "thumbnail": "https://i.ytimg.com/vi/63vwRmugT5w/mqdefault.jpg",
    "title": "【Minecraft】ド初心者ダイヤを掘る？-マイクラ２日目-【Vtuber/アキロゼ】",
    "publishedAt": "2018-08-09T15:43:33Z"
  },
  {
    "videoId": "22I2RRuISmY",
    "thumbnail": "https://i.ytimg.com/vi/22I2RRuISmY/mqdefault.jpg",
    "title": "深夜のまったり雑談【Vtuber/アキロゼ】",
    "publishedAt": "2018-08-16T19:17:37Z"
  },
  {
    "videoId": "ZNAisjGOLv4",
    "thumbnail": "https://i.ytimg.com/vi/ZNAisjGOLv4/mqdefault.jpg",
    "title": "【ASMR/バイノーラル】一緒に腹筋する？耳もとでお話【Vtuber/アキロゼ】",
    "publishedAt": "2018-08-29T15:45:50Z"
  },
  {
    "videoId": "WABnq73-NRM",
    "thumbnail": "https://i.ytimg.com/vi/WABnq73-NRM/mqdefault.jpg",
    "title": "飾らない雑談配信【Vtuber/アキロゼ】",
    "publishedAt": "2018-08-31T15:05:38Z"
  },
  {
    "videoId": "HOrt6opcdPU",
    "thumbnail": "https://i.ytimg.com/vi/HOrt6opcdPU/mqdefault.jpg",
    "title": "【マリオカート8DX】ホロライブ杯に向けて練習しよう！【視聴者参加募集】",
    "publishedAt": "2018-09-05T15:48:30Z"
  },
  {
    "videoId": "MNE7CcZDrck",
    "thumbnail": "https://i.ytimg.com/vi/MNE7CcZDrck/mqdefault.jpg",
    "title": "#１【Overcooked! 2 /ゲーム実況】キャベツはボールじゃないよ",
    "publishedAt": "2018-09-12T15:39:45Z"
  },
  {
    "videoId": "LqpunfRl9-E",
    "thumbnail": "https://i.ytimg.com/vi/LqpunfRl9-E/mqdefault.jpg",
    "title": "【自己紹介】はじめまして！異世界ハーフエルフVTuberアキロゼです！",
    "publishedAt": "2018-10-03T10:00:03Z"
  },
  {
    "videoId": "rhiMhhmyp3I",
    "thumbnail": "https://i.ytimg.com/vi/rhiMhhmyp3I/mqdefault.jpg",
    "title": "1万人突破記念配信！！秋祭りの開幕！！【アキロゼch】",
    "publishedAt": "2018-10-03T16:24:13Z"
  },
  {
    "videoId": "Im-5c35I5F4",
    "thumbnail": "https://i.ytimg.com/vi/Im-5c35I5F4/mqdefault.jpg",
    "title": "アキスバッ！企画考えたりする雑談【初コラボ】",
    "publishedAt": "2018-10-04T04:40:39Z"
  },
  {
    "videoId": "Tvx2UWi59pQ",
    "thumbnail": "https://i.ytimg.com/vi/Tvx2UWi59pQ/mqdefault.jpg",
    "title": "未練レコード【ときのそら × 40mP】歌ってみた/アキロゼcover",
    "publishedAt": "2018-10-09T10:00:02Z"
  },
  {
    "videoId": "viJi2fZcitY",
    "thumbnail": "https://i.ytimg.com/vi/viJi2fZcitY/mqdefault.jpg",
    "title": "【ASMR】森で出会ったエルフがとろける甘い囁きで癒してくる【アキロゼch】Japanese Whisper binaural LIVE",
    "publishedAt": "2018-11-14T15:50:32Z"
  },
  {
    "videoId": "LU7es0xktRM",
    "thumbnail": "https://i.ytimg.com/vi/LU7es0xktRM/mqdefault.jpg",
    "title": "【ぷよテト】脳トレで筋トレでぷよを排除する【アキロゼ/VTuber】",
    "publishedAt": "2018-11-19T17:38:04Z"
  },
  {
    "videoId": "iEVvBxFreR0",
    "thumbnail": "https://i.ytimg.com/vi/iEVvBxFreR0/mqdefault.jpg",
    "title": "【バイノーラル】社畜向け～お耳とろける甘い夜～【アキロゼ/VTuber】whisper / 立体音響",
    "publishedAt": "2018-11-23T14:28:27Z"
  },
  {
    "videoId": "A0MdLVhgIpg",
    "thumbnail": "https://i.ytimg.com/vi/A0MdLVhgIpg/mqdefault.jpg",
    "title": "【お絵描きの森】アキロゼ親子＆えーちゃんのガチンコバトル【視聴者参加型】",
    "publishedAt": "2018-11-25T17:42:32Z"
  },
  {
    "videoId": "EB0h7V_2n5M",
    "thumbnail": "https://i.ytimg.com/vi/EB0h7V_2n5M/mqdefault.jpg",
    "title": "【Minecraft】これがゾンビモード!???死に戻りなんていやだ！【Vtuberアキロゼ/ホロライブ】",
    "publishedAt": "2018-11-27T05:46:52Z"
  },
  {
    "videoId": "owGSWTg7Brw",
    "thumbnail": "https://i.ytimg.com/vi/owGSWTg7Brw/mqdefault.jpg",
    "title": "ホロライブ１期生vs２期生　ガチンコクイズバトル!!!",
    "publishedAt": "2018-12-04T15:42:50Z"
  },
  {
    "videoId": "0r4rTB05Zbk",
    "thumbnail": "https://i.ytimg.com/vi/0r4rTB05Zbk/mqdefault.jpg",
    "title": "アキロゼ行ってきます！！！！！！！！！！！",
    "publishedAt": "2018-12-05T15:47:34Z"
  },
  {
    "videoId": "faEYcvJ1WRI",
    "thumbnail": "https://i.ytimg.com/vi/faEYcvJ1WRI/mqdefault.jpg",
    "title": "【ASMR/シチュエーションボイス】聖夜に繋がるのは…ASMR Situation voice【ホロライブ/アキロゼ】",
    "publishedAt": "2018-12-23T15:28:29Z"
  },
  {
    "videoId": "TCDg18PKatQ",
    "thumbnail": "https://i.ytimg.com/vi/TCDg18PKatQ/mqdefault.jpg",
    "title": "【バイノーラル/シチュエーションボイス】コタツでドキドキハプニング！？　Binaural  Situation voice",
    "publishedAt": "2019-01-03T14:28:22Z"
  },
  {
    "videoId": "DDUVTcHfiFY",
    "thumbnail": "https://i.ytimg.com/vi/DDUVTcHfiFY/mqdefault.jpg",
    "title": "緊急ゲリラ【#女子くらふと】みこちゃんが起きないのでこっそり練習【ホロライブ / アキロゼ】",
    "publishedAt": "2019-03-01T06:50:26Z"
  },
  {
    "videoId": "WmKSWIsXlQE",
    "thumbnail": "https://i.ytimg.com/vi/WmKSWIsXlQE/mqdefault.jpg",
    "title": "#2【#女子くらふと】かわいい、ああ、かわいい（内装編）【アキロゼ/さくらみこ】",
    "publishedAt": "2019-03-02T16:57:16Z"
  },
  {
    "videoId": "zfriw28y7E0",
    "thumbnail": "https://i.ytimg.com/vi/zfriw28y7E0/mqdefault.jpg",
    "title": "#3.1【#女子くらふと】Minecraft初心者のプレゼント作り【ホロライブ/アキロゼ】",
    "publishedAt": "2019-03-04T06:51:59Z"
  },
  {
    "videoId": "NwOof-mwSYU",
    "thumbnail": "https://i.ytimg.com/vi/NwOof-mwSYU/mqdefault.jpg",
    "title": "#4【#女子くらふと】お花屋さんとお部屋を飾り付け（内装編）【アキロゼ/さくらみこ】",
    "publishedAt": "2019-03-04T17:45:12Z"
  },
  {
    "videoId": "qJPV-07Qk3E",
    "thumbnail": "https://i.ytimg.com/vi/qJPV-07Qk3E/mqdefault.jpg",
    "title": "緊急ゲリラ…！失楽園で黄昏る【ホロライブ/アキロゼ】",
    "publishedAt": "2019-03-07T05:47:29Z"
  },
  {
    "videoId": "IN0KT2ABM10",
    "thumbnail": "https://i.ytimg.com/vi/IN0KT2ABM10/mqdefault.jpg",
    "title": "【KOKIA】I believe -海の底から-【cover/Aki Rosenthal】",
    "publishedAt": "2019-03-10T14:57:44Z"
  },
  {
    "videoId": "iVdlABmSrVk",
    "thumbnail": "https://i.ytimg.com/vi/iVdlABmSrVk/mqdefault.jpg",
    "title": "詫び【アキロゼ/Vtuber】",
    "publishedAt": "2019-04-06T16:24:53Z"
  },
  {
    "videoId": "hEzZEARg6SU",
    "thumbnail": "https://i.ytimg.com/vi/hEzZEARg6SU/mqdefault.jpg",
    "title": "階段積みの次は？初心者のぷよぷよ練習配信【アキロゼ/Vtuber】",
    "publishedAt": "2019-04-11T16:59:12Z"
  },
  {
    "videoId": "0d9c9B8cmjE",
    "thumbnail": "https://i.ytimg.com/vi/0d9c9B8cmjE/mqdefault.jpg",
    "title": "電子ドラムお披露目！？バーチャルエルフドラマーになる【アキロゼ/Vtuber】",
    "publishedAt": "2019-04-12T15:41:49Z"
  },
  {
    "videoId": "sozu-O_AyIg",
    "thumbnail": "https://i.ytimg.com/vi/sozu-O_AyIg/mqdefault.jpg",
    "title": "ストレッチしながらお話しよ【アキロゼ/Vtuber】",
    "publishedAt": "2019-04-14T16:58:28Z"
  },
  {
    "videoId": "34sNWWzFNQw",
    "thumbnail": "https://i.ytimg.com/vi/34sNWWzFNQw/mqdefault.jpg",
    "title": "【Vtuber】異世界エルフと話そう【アキロゼ/ホロライブ】",
    "publishedAt": "2019-04-23T14:14:46Z"
  },
  {
    "videoId": "UtaD7xlpJ54",
    "thumbnail": "https://i.ytimg.com/vi/UtaD7xlpJ54/mqdefault.jpg",
    "title": "【Vtuber】祝！解禁！！平成最後だから酒が飲めるぞ！！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2019-04-29T16:58:24Z"
  },
  {
    "videoId": "GBWz_9abI6o",
    "thumbnail": "https://i.ytimg.com/vi/GBWz_9abI6o/mqdefault.jpg",
    "title": "【立体音響映像付き】唐揚げ１kg揚げるまで終われまてん！初めての料理配信【Vtuber/ホロライブ】",
    "publishedAt": "2019-05-13T16:34:54Z"
  },
  {
    "videoId": "Sj3yVaqj_Lw",
    "thumbnail": "https://i.ytimg.com/vi/Sj3yVaqj_Lw/mqdefault.jpg",
    "title": "【立体音響映像付き】超絶品‼Vtuberの餃子作り！！【アキロゼ/ホロライブ】",
    "publishedAt": "2019-05-22T12:29:45Z"
  },
  {
    "videoId": "9n3kR0ed2ks",
    "thumbnail": "https://i.ytimg.com/vi/9n3kR0ed2ks/mqdefault.jpg",
    "title": "手回しオルゴール演奏しながら最近のことを話す【アキロゼ/Vtuber】",
    "publishedAt": "2019-05-27T17:32:06Z"
  },
  {
    "videoId": "PwVZU7-qrvM",
    "thumbnail": "https://i.ytimg.com/vi/PwVZU7-qrvM/mqdefault.jpg",
    "title": "【最速】7位以下で即放送終了マリオカート8DX【ホロライブ/アキロゼ】",
    "publishedAt": "2019-06-18T15:35:27Z"
  },
  {
    "videoId": "0s5J7dHK5Lo",
    "thumbnail": "https://i.ytimg.com/vi/0s5J7dHK5Lo/mqdefault.jpg",
    "title": "【#アキロゼ3D】夢の3D初お披露目LIVE！！【ホロライブ/Vtuber】",
    "publishedAt": "2019-06-29T13:35:42Z"
  },
  {
    "videoId": "-NlMrPletqM",
    "thumbnail": "https://i.ytimg.com/vi/-NlMrPletqM/mqdefault.jpg",
    "title": "【Minecraft】全身ダイヤコーデ目指す！ホロ鯖【ホロライブ/アキロゼ】",
    "publishedAt": "2019-08-05T06:49:55Z"
  },
  {
    "videoId": "MEFCNKjT5k8",
    "thumbnail": "https://i.ytimg.com/vi/MEFCNKjT5k8/mqdefault.jpg",
    "title": "【Minecraft】和風・露天風呂で晩酌したい【ホロライブ/アキロゼ】",
    "publishedAt": "2019-08-25T19:27:22Z"
  },
  {
    "videoId": "RkgOqIaLgfw",
    "thumbnail": "https://i.ytimg.com/vi/RkgOqIaLgfw/mqdefault.jpg",
    "title": "【バイノーラル-生活音-】キッチンで食器洗い【Vtuber/ホロライブ】",
    "publishedAt": "2019-09-27T08:44:31Z"
  },
  {
    "videoId": "6PskhWjbZl0",
    "thumbnail": "https://i.ytimg.com/vi/6PskhWjbZl0/mqdefault.jpg",
    "title": "【マリオカート8DX】世界最弱からの脱却！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2019-11-08T04:47:36Z"
  },
  {
    "videoId": "h4Eox8U9zy0",
    "thumbnail": "https://i.ytimg.com/vi/h4Eox8U9zy0/mqdefault.jpg",
    "title": "【マリオカート8DX】CPU相手なら余裕で勝てるでしょｗｗｗｗｗｗｗｗ【ホロライブ/アキロゼ】",
    "publishedAt": "2019-11-08T16:23:53Z"
  },
  {
    "videoId": "P89PzmOZE2Y",
    "thumbnail": "https://i.ytimg.com/vi/P89PzmOZE2Y/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】完全初見で挑むベリーダンサーの本気見せてあげる！！【ホロライブ/アキロゼ】",
    "publishedAt": "2019-11-13T16:44:51Z"
  },
  {
    "videoId": "9xvXyhb6Pjo",
    "thumbnail": "https://i.ytimg.com/vi/9xvXyhb6Pjo/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】1度でも叫んだら負荷MAXチャレンジ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2019-11-20T16:29:47Z"
  },
  {
    "videoId": "VoWHIX4tp5k",
    "thumbnail": "https://i.ytimg.com/vi/VoWHIX4tp5k/mqdefault_live.jpg",
    "title": "【free chat room】ロゼ隊応援会場【ロゼ隊コミュニティ広場】",
    "publishedAt": "2019-11-29T16:40:51Z"
  },
  {
    "videoId": "FZ_Ncg2Ho6M",
    "thumbnail": "https://i.ytimg.com/vi/FZ_Ncg2Ho6M/mqdefault.jpg",
    "title": "【back number】クリスマスソング /3DオリジナルMVアキロゼ【歌ってみた】",
    "publishedAt": "2019-12-24T07:00:02Z"
  },
  {
    "videoId": "pSg1XsA9W8I",
    "thumbnail": "https://i.ytimg.com/vi/pSg1XsA9W8I/mqdefault.jpg",
    "title": "【ASMR/ASMR Situation voice】電話越しの君と一緒に/生音収録【ホロライブ/アキロゼ】",
    "publishedAt": "2019-12-24T14:45:11Z"
  },
  {
    "videoId": "8fqjcg2uRYs",
    "thumbnail": "https://i.ytimg.com/vi/8fqjcg2uRYs/mqdefault.jpg",
    "title": "kawaii ASMR music 360°VR MV『Nekoze Punch!!』 朝ですよ～！【kAmP/アキロゼ】",
    "publishedAt": "2019-12-24T22:57:15Z"
  },
  {
    "videoId": "ilhdBq_RUrE",
    "thumbnail": "https://i.ytimg.com/vi/ilhdBq_RUrE/mqdefault.jpg",
    "title": "【Splatoon2】スプラにハマったのでじょばじょばに塗ってあげる！！【ホロライブ/Vtuber】",
    "publishedAt": "2020-01-22T15:58:46Z"
  },
  {
    "videoId": "P6KmSxx1S9A",
    "thumbnail": "https://i.ytimg.com/vi/P6KmSxx1S9A/mqdefault.jpg",
    "title": "初めてのARK！恐竜なら友達になってくれるって信じてる【ホロライブ/アキロゼ】",
    "publishedAt": "2020-01-29T16:50:34Z"
  },
  {
    "videoId": "6IxVQiOd66c",
    "thumbnail": "https://i.ytimg.com/vi/6IxVQiOd66c/mqdefault.jpg",
    "title": "【Ark】宴編：ムキロゼ太鼓シタイ前編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-01-30T15:43:10Z"
  },
  {
    "videoId": "XnvQkYVUUjM",
    "thumbnail": "https://i.ytimg.com/vi/XnvQkYVUUjM/mqdefault.jpg",
    "title": "【Ark】宴編：打ち鳴らせえええええぇえ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-01-31T16:32:47Z"
  },
  {
    "videoId": "3L0Drq-qayc",
    "thumbnail": "https://i.ytimg.com/vi/3L0Drq-qayc/mqdefault.jpg",
    "title": "【謎企画】豆つかみRTAで鬼神を宿す！？恵方巻お料理配信が天国or地獄【ホロライブ/アキロゼ】",
    "publishedAt": "2020-02-03T17:25:21Z"
  },
  {
    "videoId": "5Ezi_z0lzK4",
    "thumbnail": "https://i.ytimg.com/vi/5Ezi_z0lzK4/mqdefault.jpg",
    "title": "【Ark】冒険編：ついにFly Awayする！？【ホロライブ/ #夏アッキー 】",
    "publishedAt": "2020-02-04T07:27:07Z"
  },
  {
    "videoId": "2o7aA_7NqI0",
    "thumbnail": "https://i.ytimg.com/vi/2o7aA_7NqI0/mqdefault.jpg",
    "title": "【Ark】冒険編：異世界の戦士だと思い込んでいたムキロゼがヒモ男として堕ちる物語【ホロライブ/アキロゼ 】",
    "publishedAt": "2020-02-04T18:06:11Z"
  },
  {
    "videoId": "Jvk8d9OWHiU",
    "thumbnail": "https://i.ytimg.com/vi/Jvk8d9OWHiU/mqdefault.jpg",
    "title": "【Ark】冒険編：ルーナちゃんと初コラボ！アルゲンを可愛く捕まえちゃおう！【ホロライブ/アキロゼ×姫森ルーナ 】",
    "publishedAt": "2020-02-05T20:58:36Z"
  },
  {
    "videoId": "OmhkEzGa5JA",
    "thumbnail": "https://i.ytimg.com/vi/OmhkEzGa5JA/mqdefault.jpg",
    "title": "【Ark】ムキロゼ愛のマーキングベッド編【ホロライブ/アキロゼ 】",
    "publishedAt": "2020-02-06T05:37:19Z"
  },
  {
    "videoId": "OpUNNfti_Hs",
    "thumbnail": "https://i.ytimg.com/vi/OpUNNfti_Hs/mqdefault.jpg",
    "title": "【Ark】空の覇者編：ケツァルコアトル大作戦【ロボ子さん/夏色まつり/アキロゼ 】",
    "publishedAt": "2020-02-10T05:56:09Z"
  },
  {
    "videoId": "8c7ZHCnQKDQ",
    "thumbnail": "https://i.ytimg.com/vi/8c7ZHCnQKDQ/mqdefault.jpg",
    "title": "kawaii ASMR music『Chocolate Pandemic』キミの元に出荷します🍫【kAmP/アキロゼ（ホロライブ）】",
    "publishedAt": "2020-02-14T03:30:12Z"
  },
  {
    "videoId": "D7j-wbqDr4Y",
    "thumbnail": "https://i.ytimg.com/vi/D7j-wbqDr4Y/mqdefault.jpg",
    "title": "【Ark】ムキロゼ全力で洞窟攻略を応援！太鼓職人編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-06T20:28:22Z"
  },
  {
    "videoId": "bipUoDoHhxs",
    "thumbnail": "https://i.ytimg.com/vi/bipUoDoHhxs/mqdefault.jpg",
    "title": "【monopoly】世界一売れてるボードゲーム「モノポリー」でガチバトル【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-09T07:30:04Z"
  },
  {
    "videoId": "iyIJfMgJLzY",
    "thumbnail": "https://i.ytimg.com/vi/iyIJfMgJLzY/mqdefault.jpg",
    "title": "【monopoly】札束で殴り合い！？全資産を奪い尽くしちゃうぞ 第2回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-10T07:17:29Z"
  },
  {
    "videoId": "9tWSqYotg1I",
    "thumbnail": "https://i.ytimg.com/vi/9tWSqYotg1I/mqdefault.jpg",
    "title": "【monopoly】夜の💕モノポリー大人の遊び教えてあげる第3回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-11T17:50:00Z"
  },
  {
    "videoId": "PRmMc7FRM_U",
    "thumbnail": "https://i.ytimg.com/vi/PRmMc7FRM_U/mqdefault.jpg",
    "title": "【monopoly】激ヤバルール追加で大波乱！？アキロゼに勝てる人いる～？？？第4回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-12T06:48:45Z"
  },
  {
    "videoId": "HMDiKEMkIwo",
    "thumbnail": "https://i.ytimg.com/vi/HMDiKEMkIwo/mqdefault.jpg",
    "title": "【ProjectWinter】雪山でソウナンですか！？ホロライブ雪山人狼【アキロゼ視点】",
    "publishedAt": "2020-03-12T12:56:27Z"
  },
  {
    "videoId": "l5n32wRXJ4A",
    "thumbnail": "https://i.ytimg.com/vi/l5n32wRXJ4A/mqdefault.jpg",
    "title": "【monopoly】超鬼畜ルールにどこまで耐えられるか勝負しましょ♡第５回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-13T05:01:54Z"
  },
  {
    "videoId": "SOmIgQKU6QM",
    "thumbnail": "https://i.ytimg.com/vi/SOmIgQKU6QM/mqdefault.jpg",
    "title": "【monopoly】枠取り直し！激ヤバルール追加で大波乱！？アキロゼに勝てる人いる～？？？第5.5回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-13T07:44:07Z"
  },
  {
    "videoId": "MAISV_C02YM",
    "thumbnail": "https://i.ytimg.com/vi/MAISV_C02YM/mqdefault.jpg",
    "title": "Ark ラグナロク【#ホロ鯖最終決戦】死んだら即終了【アキロゼ視点/ホロライブ】",
    "publishedAt": "2020-03-14T13:15:15Z"
  },
  {
    "videoId": "X37I0eWwIhc",
    "thumbnail": "https://i.ytimg.com/vi/X37I0eWwIhc/mqdefault.jpg",
    "title": "Ark ラグナロク【#ホロ鯖最終決戦】前回ボスの5倍以上の戦闘力に至高の下半身で挑ムキロゼ【アキロゼ視点/ホロライブ】",
    "publishedAt": "2020-03-15T14:08:25Z"
  },
  {
    "videoId": "ukYhOnzELBc",
    "thumbnail": "https://i.ytimg.com/vi/ukYhOnzELBc/mqdefault.jpg",
    "title": "【monopoly】アキロゼに資産全部ちょうだい？？？第6回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-17T05:52:37Z"
  },
  {
    "videoId": "5O1S6wYTy4s",
    "thumbnail": "https://i.ytimg.com/vi/5O1S6wYTy4s/mqdefault.jpg",
    "title": "【Ark】そうだ写真をとろう！ムキロゼカメラマン編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-19T07:02:06Z"
  },
  {
    "videoId": "Jz38sDgvq6U",
    "thumbnail": "https://i.ytimg.com/vi/Jz38sDgvq6U/mqdefault.jpg",
    "title": "人生初！【あつまれどうぶつの森】無人島サバイバルするので釣り竿作る【アキロゼ/ホロライブ】",
    "publishedAt": "2020-03-21T20:48:01Z"
  },
  {
    "videoId": "BOEeJTa7wko",
    "thumbnail": "https://i.ytimg.com/vi/BOEeJTa7wko/mqdefault.jpg",
    "title": "【Ark】ムキロゼのラグナロク卒業、そして新MAPへ旅立ち編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-22T14:11:18Z"
  },
  {
    "videoId": "8gyStuhCMxU",
    "thumbnail": "https://i.ytimg.com/vi/8gyStuhCMxU/mqdefault.jpg",
    "title": "【Ark】アベレーション新MAPムキロゼ突撃訪問編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-22T19:16:59Z"
  },
  {
    "videoId": "298yVKLt7Ig",
    "thumbnail": "https://i.ytimg.com/vi/298yVKLt7Ig/mqdefault.jpg",
    "title": "【Ark】ムキロゼの新MAPアベレーション突入編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-22T23:29:09Z"
  },
  {
    "videoId": "CNGyElwa0U0",
    "thumbnail": "https://i.ytimg.com/vi/CNGyElwa0U0/mqdefault.jpg",
    "title": "【Ark】地下世界ムキロゼついに罠テイム！？【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-24T08:39:49Z"
  },
  {
    "videoId": "8byWkEDADVU",
    "thumbnail": "https://i.ytimg.com/vi/8byWkEDADVU/mqdefault.jpg",
    "title": "【10万人達成するまで終われない！】全資産の奪い合いゲームmonopolyで愛の札束往復ビンタ！【ホロライブ|アキロゼ】",
    "publishedAt": "2020-03-25T18:14:59Z"
  },
  {
    "videoId": "gJ92v6bqTu0",
    "thumbnail": "https://i.ytimg.com/vi/gJ92v6bqTu0/mqdefault.jpg",
    "title": "【Ark】動く投石機でカニテイム編！！ムキロゼの地下世界生活【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-27T09:10:32Z"
  },
  {
    "videoId": "0fmUJvmZbpo",
    "thumbnail": "https://i.ytimg.com/vi/0fmUJvmZbpo/mqdefault.jpg",
    "title": "【Ark】緊急ゲリラ！罠なしテイム縛り編：1時間スピノ狩りじゃああ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-28T18:43:42Z"
  },
  {
    "videoId": "ZBvPbsrbgBE",
    "thumbnail": "https://i.ytimg.com/vi/ZBvPbsrbgBE/mqdefault.jpg",
    "title": "ゲリラ！【Ark】危険度マシマシな美しき中層にフライアウェイ編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-29T18:57:41Z"
  },
  {
    "videoId": "fy_SRMgXfV4",
    "thumbnail": "https://i.ytimg.com/vi/fy_SRMgXfV4/mqdefault.jpg",
    "title": "緊急ゲリラ【Ark】宝石泥棒ムキロゼ編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-03-31T19:15:18Z"
  },
  {
    "videoId": "QIyxfLzP8dA",
    "thumbnail": "https://i.ytimg.com/vi/QIyxfLzP8dA/mqdefault.jpg",
    "title": "【Ark】動く巨神兵器でカニテイム&中層拠点探し【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-02T09:56:08Z"
  },
  {
    "videoId": "7SClUq1zZLg",
    "thumbnail": "https://i.ytimg.com/vi/7SClUq1zZLg/mqdefault.jpg",
    "title": "【Ark】高レべスピノとラベジャーを仲間にしてみせる！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-03T09:29:06Z"
  },
  {
    "videoId": "Q2eggcvfaXE",
    "thumbnail": "https://i.ytimg.com/vi/Q2eggcvfaXE/mqdefault.jpg",
    "title": "【Ark】移動型ハニートラップとFF7クライシスコア【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-07T09:28:56Z"
  },
  {
    "videoId": "2v-55pwCg0M",
    "thumbnail": "https://i.ytimg.com/vi/2v-55pwCg0M/mqdefault.jpg",
    "title": "【Ark】イースターイベント今日から！？どんな世界なんだ！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-08T09:10:23Z"
  },
  {
    "videoId": "6MUcbTFu5U8",
    "thumbnail": "https://i.ytimg.com/vi/6MUcbTFu5U8/mqdefault.jpg",
    "title": "【Ark】春の新イベで遊び尽くす！！【#林檎と姫】アキロゼ/姫森ルーナ|ホロライブ",
    "publishedAt": "2020-04-09T07:07:32Z"
  },
  {
    "videoId": "cKXNnTc8zYs",
    "thumbnail": "https://i.ytimg.com/vi/cKXNnTc8zYs/mqdefault.jpg",
    "title": "【FF7R】本日発売のファイナルファンタジー7リメイクを限界プレイ【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-09T19:53:46Z"
  },
  {
    "videoId": "bjsFR5wR2jw",
    "thumbnail": "https://i.ytimg.com/vi/bjsFR5wR2jw/mqdefault.jpg",
    "title": "【Ark】たまごガチャとハニートラップ改建築【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-10T07:29:58Z"
  },
  {
    "videoId": "e2dol-BTteE",
    "thumbnail": "https://i.ytimg.com/vi/e2dol-BTteE/mqdefault.jpg",
    "title": "【FF7R】本日発売!!ファイナルファンタジー7リメイク限界プレイアキロゼの場合 part2【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-10T09:55:43Z"
  },
  {
    "videoId": "McsqeRW9E60",
    "thumbnail": "https://i.ytimg.com/vi/McsqeRW9E60/mqdefault.jpg",
    "title": "【Ark】無敵ムキロゼ要塞で中層突入！快適ライフ間違いなし編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-13T06:55:10Z"
  },
  {
    "videoId": "C-hOZxV5T_g",
    "thumbnail": "https://i.ytimg.com/vi/C-hOZxV5T_g/mqdefault.jpg",
    "title": "【FF7R】バイクレースで勝ち！限界お姉さん実況アキロゼの場合 part3【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-13T09:53:30Z"
  },
  {
    "videoId": "gf-840wo7_Q",
    "thumbnail": "https://i.ytimg.com/vi/gf-840wo7_Q/mqdefault.jpg",
    "title": "【Ark】神立地発見！！！！ここに住む編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-14T06:48:45Z"
  },
  {
    "videoId": "yUOSLTMVrM0",
    "thumbnail": "https://i.ytimg.com/vi/yUOSLTMVrM0/mqdefault.jpg",
    "title": "【FF7R】話題の最新作の超バトル！限界お姉さん実況アキロゼの場合 part4【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-14T09:54:12Z"
  },
  {
    "videoId": "q-9WSutSNVM",
    "thumbnail": "https://i.ytimg.com/vi/q-9WSutSNVM/mqdefault.jpg",
    "title": "【Ark】工業科1年ムキロゼの科学発展の道【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-15T06:52:26Z"
  },
  {
    "videoId": "-6WPKz-fzSQ",
    "thumbnail": "https://i.ytimg.com/vi/-6WPKz-fzSQ/mqdefault.jpg",
    "title": "【FF7R】話題の最新作！伍番魔晄炉バトル回！！限界お姉さん実況アキロゼの場合 part5【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-15T10:53:44Z"
  },
  {
    "videoId": "POwPJzC-71A",
    "thumbnail": "https://i.ytimg.com/vi/POwPJzC-71A/mqdefault.jpg",
    "title": "【Ark】無法地帯を整備する！工業科1年ムキロゼの科学発展の道【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-16T06:42:31Z"
  },
  {
    "videoId": "cY8UpCrm4nI",
    "thumbnail": "https://i.ytimg.com/vi/cY8UpCrm4nI/mqdefault.jpg",
    "title": "【FF7R】エアリスと超ラブラブデート回！限界お姉さん実況アキロゼの場合 part6【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-16T10:26:26Z"
  },
  {
    "videoId": "BjugAbhAmBg",
    "thumbnail": "https://i.ytimg.com/vi/BjugAbhAmBg/mqdefault.jpg",
    "title": "【Ark】ムキロゼ楽園高校工業科1年ムキロゼ科学発展への道【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-17T07:05:44Z"
  },
  {
    "videoId": "akY4y7PSnwQ",
    "thumbnail": "https://i.ytimg.com/vi/akY4y7PSnwQ/mqdefault.jpg",
    "title": "【FF7R】ついに欲望の渦巻く街デビュー！？限界お姉さん実況アキロゼの場合 part7【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-17T10:44:26Z"
  },
  {
    "videoId": "2ax-fZadm4E",
    "thumbnail": "https://i.ytimg.com/vi/2ax-fZadm4E/mqdefault.jpg",
    "title": "【Ark】おしゃカワmodで建築する！ムキロゼ楽園高校に悪魔の保健医がくる！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-20T07:23:50Z"
  },
  {
    "videoId": "IkpmLBP-4Is",
    "thumbnail": "https://i.ytimg.com/vi/IkpmLBP-4Is/mqdefault.jpg",
    "title": "【FF7R】痛い目にあいたいみたいね？限界お姉さん実況アキロゼの場合 part8【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-20T09:53:06Z"
  },
  {
    "videoId": "nCX-69qvA0k",
    "thumbnail": "https://i.ytimg.com/vi/nCX-69qvA0k/mqdefault.jpg",
    "title": "【Ark】Steampunk Modで漢泣きムキロゼ楽園高校工業科建築回【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-21T06:10:23Z"
  },
  {
    "videoId": "zOnpP7inuyM",
    "thumbnail": "https://i.ytimg.com/vi/zOnpP7inuyM/mqdefault.jpg",
    "title": "【FF7R】バスターソード縛り激熱バトル必須…！限界お姉さん実況アキロゼの場合 part9【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-21T10:01:54Z"
  },
  {
    "videoId": "4Nu_gPSrLGc",
    "thumbnail": "https://i.ytimg.com/vi/4Nu_gPSrLGc/mqdefault.jpg",
    "title": "【Ark】ツインドリル！？機械仕掛けのムキロゼ楽園高校工業科Steampunk Mod建築その２【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-22T07:52:24Z"
  },
  {
    "videoId": "vPcm2MsNJ18",
    "thumbnail": "https://i.ytimg.com/vi/vPcm2MsNJ18/mqdefault.jpg",
    "title": "【Ark】気球でFly Away!?ムキロゼ楽園高校工業科Steampunk Mod建築その３【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-23T06:19:09Z"
  },
  {
    "videoId": "wdfvNUCN_WI",
    "thumbnail": "https://i.ytimg.com/vi/wdfvNUCN_WI/mqdefault.jpg",
    "title": "【FF7R】バスターソード縛りの限界お姉さん実況アキロゼの場合 part10【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-23T09:14:33Z"
  },
  {
    "videoId": "kEYjscbsu6Q",
    "thumbnail": "https://i.ytimg.com/vi/kEYjscbsu6Q/mqdefault.jpg",
    "title": "【Ark】高カロリー必須超巨大飛空艇！？ムキロゼ楽園高校工業科Steampunk Mod建築その４【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-24T07:00:03Z"
  },
  {
    "videoId": "u9BeVaF1PmI",
    "thumbnail": "https://i.ytimg.com/vi/u9BeVaF1PmI/mqdefault.jpg",
    "title": "【FF7R】高感度分岐点！？バスターソード縛りの限界お姉さん実況アキロゼの場合 part11【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-24T10:55:28Z"
  },
  {
    "videoId": "ljeOqLGIU0Y",
    "thumbnail": "https://i.ytimg.com/vi/ljeOqLGIU0Y/mqdefault.jpg",
    "title": "【Ark】高カロリー超巨大飛空艇を目指して！ムキロゼ楽園高校工業科Steampunk Mod建築その５【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-27T09:27:11Z"
  },
  {
    "videoId": "kL3aRrEsEsM",
    "thumbnail": "https://i.ytimg.com/vi/kL3aRrEsEsM/mqdefault.jpg",
    "title": "【FF7R】バスターソード縛りの限界お姉さん実況アキロゼの場合 part12【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2020-04-28T09:54:52Z"
  },
  {
    "videoId": "96iWO-gf7CI",
    "thumbnail": "https://i.ytimg.com/vi/96iWO-gf7CI/mqdefault.jpg",
    "title": "【Ark】超危険最下層の最カワ光源生物大量GET！ムキロゼ楽園高校工業科Steampunk Mod建築その7【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-29T10:52:56Z"
  },
  {
    "videoId": "m_QjdPHin0k",
    "thumbnail": "https://i.ytimg.com/vi/m_QjdPHin0k/mqdefault.jpg",
    "title": "【Ark】最強のゴリラを求めて！ムキロゼ楽園高校工業科Steampunk Modその８【ホロライブ/アキロゼ】",
    "publishedAt": "2020-04-30T06:04:11Z"
  },
  {
    "videoId": "FqYeYK3gW_c",
    "thumbnail": "https://i.ytimg.com/vi/FqYeYK3gW_c/mqdefault.jpg",
    "title": "【Ark】浪漫飛行なるか！？巨大飛空艇建造！ムキロゼ楽園高校工業科Steampunk Modその１０【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-02T12:58:10Z"
  },
  {
    "videoId": "k4Wj3myIp8c",
    "thumbnail": "https://i.ytimg.com/vi/k4Wj3myIp8c/mqdefault.jpg",
    "title": "【Ark】熱気球リベンジ!掃除屋ムキロゼ楽園高校工業科Steampunk Modその１１【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-07T10:18:19Z"
  },
  {
    "videoId": "657aHdisqkc",
    "thumbnail": "https://i.ytimg.com/vi/657aHdisqkc/mqdefault.jpg",
    "title": "【APEX】完全初見のデビュー戦！トワ先生に教えてもらおう！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-07T16:47:25Z"
  },
  {
    "videoId": "62qiWqDHj4w",
    "thumbnail": "https://i.ytimg.com/vi/62qiWqDHj4w/mqdefault.jpg",
    "title": "【Ark】完全初見だけどソロ攻略してみたい！ムキロゼ楽園高校工業科Steampunk Modその１２【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-08T07:37:14Z"
  },
  {
    "videoId": "DtyGEg82qpM",
    "thumbnail": "https://i.ytimg.com/vi/DtyGEg82qpM/mqdefault.jpg",
    "title": "【#ホロARKママ友】超リベンジ🍼最強の我が子を宿せ！ムキロゼ視点【ホロライブ/さくらみこ/桐生ココ/白銀ノエル/癒月ちょこ/天音かなた/角巻わため/兎田ぺこら/ロボ子さん/さくらみこ】",
    "publishedAt": "2020-05-10T16:26:27Z"
  },
  {
    "videoId": "EpP6dUuMSNw",
    "thumbnail": "https://i.ytimg.com/vi/EpP6dUuMSNw/mqdefault.jpg",
    "title": "【Ark】恐竜のお家と拠点強化で守りたい！ムキロゼ楽園高校工業科Steampunk Modその１３【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-11T10:02:08Z"
  },
  {
    "videoId": "IuSwsH-v4bk",
    "thumbnail": "https://i.ytimg.com/vi/IuSwsH-v4bk/mqdefault.jpg",
    "title": "【Ark】水中洞窟攻略準備！ムキロゼ楽園高校工業科Steampunk Modその１５【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-13T10:11:04Z"
  },
  {
    "videoId": "GZkKSOLLSy8",
    "thumbnail": "https://i.ytimg.com/vi/GZkKSOLLSy8/mqdefault.jpg",
    "title": "【Ark】潜水艦×カエル×ムキロゼ楽園高校工業科Steampunk Modその１６【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-14T09:07:45Z"
  },
  {
    "videoId": "-k4RZ-SZXgk",
    "thumbnail": "https://i.ytimg.com/vi/-k4RZ-SZXgk/mqdefault.jpg",
    "title": "【Ark】超鬼畜‘な地上クレートガチャで大量GET!?ムキロゼ楽園高校工業科Steampunk Modその１７【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-15T09:37:28Z"
  },
  {
    "videoId": "PapZbTm432M",
    "thumbnail": "https://i.ytimg.com/vi/PapZbTm432M/mqdefault.jpg",
    "title": "【APEX】超初心者ガイド配信！これで君もデビューだ！！【ホロライブ╎夏色まつり×アキロゼ】",
    "publishedAt": "2020-05-18T17:44:46Z"
  },
  {
    "videoId": "MSHhcM-HNcg",
    "thumbnail": "https://i.ytimg.com/vi/MSHhcM-HNcg/mqdefault.jpg",
    "title": "【Ark】洞窟攻略コラボ準備する！ムキロゼ楽園高校工業科Steampunk Modその１８【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-20T08:17:07Z"
  },
  {
    "videoId": "xgmnYJWlOxQ",
    "thumbnail": "https://i.ytimg.com/vi/xgmnYJWlOxQ/mqdefault.jpg",
    "title": "【Ark】廃人と行くアベレーション全洞窟！！いっきに攻略しーちゃお！ムキロゼ楽園高校工業科Steampunk Mod【ホロライブ/癒月ちょこ/角巻わためアキロゼ】",
    "publishedAt": "2020-05-20T19:54:19Z"
  },
  {
    "videoId": "zJ8ai-jQcO0",
    "thumbnail": "https://i.ytimg.com/vi/zJ8ai-jQcO0/mqdefault.jpg",
    "title": "【Ark】今日こそおしゃれ建築と阿鼻叫喚整理！！ムキロゼ楽園高校工業科Steampunk Modその１７【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-21T11:53:22Z"
  },
  {
    "videoId": "wUA5A68pNa8",
    "thumbnail": "https://i.ytimg.com/vi/wUA5A68pNa8/mqdefault.jpg",
    "title": "【Ark】テスラコイルでズババババ！ムキロゼ楽園高校工業科Steampunk Modその２０【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-25T09:16:12Z"
  },
  {
    "videoId": "7hUpvUsS3BQ",
    "thumbnail": "https://i.ytimg.com/vi/7hUpvUsS3BQ/mqdefault.jpg",
    "title": "【Ark】BOSS戦に備えよ！ムキロゼ楽園高校工業科Steampunk Modその２１【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-26T09:12:01Z"
  },
  {
    "videoId": "9DNMLLqPudw",
    "thumbnail": "https://i.ytimg.com/vi/9DNMLLqPudw/mqdefault.jpg",
    "title": "【Ark】最強🦍でBOSS戦準備ムキロゼ楽園高校工業科Steampunk Modその２２【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-27T07:21:14Z"
  },
  {
    "videoId": "xHucuUTP05k",
    "thumbnail": "https://i.ytimg.com/vi/xHucuUTP05k/mqdefault.jpg",
    "title": "【APEX】金髪なので優勝！！ちょんぽん注文します！【ホロライブ/癒月ちょこ/角巻わため/アキロゼ】",
    "publishedAt": "2020-05-27T17:51:34Z"
  },
  {
    "videoId": "5TUSLXaPWXo",
    "thumbnail": "https://i.ytimg.com/vi/5TUSLXaPWXo/mqdefault.jpg",
    "title": "【WATCHERS】ホラゲの謎解き？！カルト教団に2人で潜入！！【ホロライブ/常闇トワ×アキロゼ#画伯ルーキーズ】",
    "publishedAt": "2020-05-28T15:56:23Z"
  },
  {
    "videoId": "63E8EOGpE20",
    "thumbnail": "https://i.ytimg.com/vi/63E8EOGpE20/mqdefault.jpg",
    "title": "【Ark】ボス戦前日準備1時間RTAするムキロゼ楽園高校工業科Steampunk Modその２３【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-29T07:23:02Z"
  },
  {
    "videoId": "AUWe811Llb8",
    "thumbnail": "https://i.ytimg.com/vi/AUWe811Llb8/mqdefault.jpg",
    "title": "【Ark】死んだら即配信終了命がけのBOSS戦‼ホロライブアベレーション最終戦【ホロライブ/アキロゼ視点/桐生ココ/さくらみこ/癒月ちょこ】",
    "publishedAt": "2020-05-30T15:09:07Z"
  },
  {
    "videoId": "obELpJCspKw",
    "thumbnail": "https://i.ytimg.com/vi/obELpJCspKw/mqdefault.jpg",
    "title": "歌って盛り上げろ！ホロライブ1期生2周年カウントダウン【ホロライブ/アキロゼ】",
    "publishedAt": "2020-05-31T15:22:15Z"
  },
  {
    "videoId": "ZAMv75RvRqc",
    "thumbnail": "https://i.ytimg.com/vi/ZAMv75RvRqc/mqdefault.jpg",
    "title": "【2周年記念】3D配信で乾杯しよう！重大発表アリ【ホロライブ１期生/アキロゼ】",
    "publishedAt": "2020-06-01T17:21:04Z"
  },
  {
    "videoId": "kQs3yz_dLL8",
    "thumbnail": "https://i.ytimg.com/vi/kQs3yz_dLL8/mqdefault.jpg",
    "title": "【Ark】ボス戦のその後…ムキロゼSteampunk Modその２４【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-03T06:13:28Z"
  },
  {
    "videoId": "yhyTvO07jNY",
    "thumbnail": "https://i.ytimg.com/vi/yhyTvO07jNY/mqdefault.jpg",
    "title": "【Ark】廃人2人で挑むつよつよBOSS戦‼ホロライブアベレーション最終戦Extra【ホロライブ/アキロゼ視点/癒月ちょこ】",
    "publishedAt": "2020-06-03T08:30:48Z"
  },
  {
    "videoId": "pa4Pow-B3Do",
    "thumbnail": "https://i.ytimg.com/vi/pa4Pow-B3Do/mqdefault.jpg",
    "title": "【Ark】最強ゴリラ育成しながらアルファボス準備ムキロゼSteampunk Modその２５【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-04T06:12:40Z"
  },
  {
    "videoId": "FvgN7XfrobM",
    "thumbnail": "https://i.ytimg.com/vi/FvgN7XfrobM/mqdefault.jpg",
    "title": "【Ark】一番強いボスに挑む四天王！命がけのBOSS戦‼ホロライブアベレーション頂上最終決戦【ホロライブ/アキロゼ視点/桐生ココ/さくらみこ/癒月ちょこ】",
    "publishedAt": "2020-06-04T07:58:14Z"
  },
  {
    "videoId": "4ZOW2WjsM3k",
    "thumbnail": "https://i.ytimg.com/vi/4ZOW2WjsM3k/mqdefault.jpg",
    "title": "【PC Building Simulator】PC怖すぎ！！ヤケ酒でストレス下げて打ち勝てたらもう勝ち【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-04T16:21:58Z"
  },
  {
    "videoId": "wzlI9xjp2Ak",
    "thumbnail": "https://i.ytimg.com/vi/wzlI9xjp2Ak/mqdefault.jpg",
    "title": "【Ark】最強ゴリラとお料理Steampunk Modその２６【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-05T09:50:34Z"
  },
  {
    "videoId": "jXLiDicHfo0",
    "thumbnail": "https://i.ytimg.com/vi/jXLiDicHfo0/mqdefault.jpg",
    "title": "【Ark】嬢王バチさんと最強ゴリラとお料理Steampunk Modその２７【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-05T20:07:55Z"
  },
  {
    "videoId": "brGXBUpUfdA",
    "thumbnail": "https://i.ytimg.com/vi/brGXBUpUfdA/mqdefault.jpg",
    "title": "【Ark】ゴリラのお世話と武器作りSteampunk Modその２８【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-08T07:19:17Z"
  },
  {
    "videoId": "5z4gSqdtQag",
    "thumbnail": "https://i.ytimg.com/vi/5z4gSqdtQag/mqdefault.jpg",
    "title": "【APEX】完全初見のデビュー戦！トワ先生に教えてもらおう！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-08T17:01:02Z"
  },
  {
    "videoId": "CeEr96umOHk",
    "thumbnail": "https://i.ytimg.com/vi/CeEr96umOHk/mqdefault.jpg",
    "title": "【APEX】初野良！に放たれるピヨピヨでびゅー戦【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-10T16:56:50Z"
  },
  {
    "videoId": "xBLy-46rrmg",
    "thumbnail": "https://i.ytimg.com/vi/xBLy-46rrmg/mqdefault.jpg",
    "title": "【APEX】1キル目指してぴよぴよ5ペックス目！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-11T06:03:34Z"
  },
  {
    "videoId": "zjRn4rv2pBQ",
    "thumbnail": "https://i.ytimg.com/vi/zjRn4rv2pBQ/mqdefault.jpg",
    "title": "【乾杯雑談】ストロングにキメたレモンサワー飲み比べからのはしご酒【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-11T17:46:34Z"
  },
  {
    "videoId": "mgVE3NLLI1M",
    "thumbnail": "https://i.ytimg.com/vi/mgVE3NLLI1M/mqdefault.jpg",
    "title": "【APEX】先生捕まえた！ロボ子さんと特訓‼#ロボタール 【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-12T06:24:35Z"
  },
  {
    "videoId": "-Dt76XfR5Hc",
    "thumbnail": "https://i.ytimg.com/vi/-Dt76XfR5Hc/mqdefault.jpg",
    "title": "【地獄】お酒にのまれたVtuber寝落ち寝言同時視聴で大反省【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-13T15:12:40Z"
  },
  {
    "videoId": "_UI2YHWmthI",
    "thumbnail": "https://i.ytimg.com/vi/_UI2YHWmthI/mqdefault.jpg",
    "title": "【Ark￤Crystal Isles】新MAP突入！ムキロゼのクリスタルアイルズ弾丸旅行【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-13T21:32:00Z"
  },
  {
    "videoId": "clThEc8Be3I",
    "thumbnail": "https://i.ytimg.com/vi/clThEc8Be3I/mqdefault.jpg",
    "title": "【APEX】FPSガチ初心者の7ペックス目新キャラ解放できたらギター弾く【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-14T15:08:24Z"
  },
  {
    "videoId": "yTZxRkRS-GY",
    "thumbnail": "https://i.ytimg.com/vi/yTZxRkRS-GY/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】超攻撃的！？砂漠の巣に飛び込むムキロゼ【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-15T07:03:32Z"
  },
  {
    "videoId": "cVDSDtngqr8",
    "thumbnail": "https://i.ytimg.com/vi/cVDSDtngqr8/mqdefault.jpg",
    "title": "【特別配信 】生歌初披露&CM大公開 #新シャルイース【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-15T15:12:51Z"
  },
  {
    "videoId": "kY2UMZNhYEQ",
    "thumbnail": "https://i.ytimg.com/vi/kY2UMZNhYEQ/mqdefault.jpg",
    "title": "【APEX】FPSガチ初心者の８ペックス目新キャラ解放！目標3キルちゃんぽん【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-16T07:55:30Z"
  },
  {
    "videoId": "_fhtde4NvcI",
    "thumbnail": "https://i.ytimg.com/vi/_fhtde4NvcI/mqdefault.jpg",
    "title": "【Ark】ホロライブアベレーション頂上最終決戦ムキロゼ視点【ホロライブ/桐生ココ/天音かなた/癒月ちょこ/アキロゼ】",
    "publishedAt": "2020-06-16T14:17:36Z"
  },
  {
    "videoId": "XcJZFWArodU",
    "thumbnail": "https://i.ytimg.com/vi/XcJZFWArodU/mqdefault.jpg",
    "title": "【乾杯雑談 】打ち上げで乾杯！ARKに新シャルイースにお祝いだ！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-16T17:20:40Z"
  },
  {
    "videoId": "jqZ6Cer3KPI",
    "thumbnail": "https://i.ytimg.com/vi/jqZ6Cer3KPI/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】新MAPクリスタルアイルズでの足を確保せよ！【ホロライブ/アキロゼ/常闇トワ】",
    "publishedAt": "2020-06-17T06:18:16Z"
  },
  {
    "videoId": "nmwRFmUSMog",
    "thumbnail": "https://i.ytimg.com/vi/nmwRFmUSMog/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】拠点を決めたい！ムキロゼ【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-19T09:06:14Z"
  },
  {
    "videoId": "cywuUBh0RYg",
    "thumbnail": "https://i.ytimg.com/vi/cywuUBh0RYg/mqdefault.jpg",
    "title": "【APEX】FPSガチ初心者の9ペックス目（酔拳）ガスおじで目標3キルちゃんぽん【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-19T20:34:13Z"
  },
  {
    "videoId": "tkILQ1Go07k",
    "thumbnail": "https://i.ytimg.com/vi/tkILQ1Go07k/mqdefault.jpg",
    "title": "【ARK ╎Aberration→Crystal Isles】ムキロゼのお引越し大作戦（つらい）【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-23T07:12:59Z"
  },
  {
    "videoId": "zpBmbT0dAdg",
    "thumbnail": "https://i.ytimg.com/vi/zpBmbT0dAdg/mqdefault.jpg",
    "title": "【APEX】FPSガチ初心者の10ペックス目！目標3キルちゃんぽん【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-23T09:35:06Z"
  },
  {
    "videoId": "oaktfQvpTuE",
    "thumbnail": "https://i.ytimg.com/vi/oaktfQvpTuE/mqdefault.jpg",
    "title": "【たこ焼き】たこ焼きのプロはこう作る！アキロゼ×常闇トワ【ホロライブ】",
    "publishedAt": "2020-06-25T05:52:30Z"
  },
  {
    "videoId": "sJWaRUMHzww",
    "thumbnail": "https://i.ytimg.com/vi/sJWaRUMHzww/mqdefault.jpg",
    "title": "【ARK】緊急ゲリラまもなく鯖END！ムキロゼ爆誕の聖地と恐竜達【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-25T16:08:33Z"
  },
  {
    "videoId": "M9XXNbc1IwE",
    "thumbnail": "https://i.ytimg.com/vi/M9XXNbc1IwE/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】夏の新イベ解禁！カラフルな恐竜欲しい！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-26T03:23:58Z"
  },
  {
    "videoId": "m78SdnfqBZ8",
    "thumbnail": "https://i.ytimg.com/vi/m78SdnfqBZ8/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】枠とりなおし！夏の新イベ始まったよ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-26T07:31:43Z"
  },
  {
    "videoId": "Er8kR2mIrWA",
    "thumbnail": "https://i.ytimg.com/vi/Er8kR2mIrWA/mqdefault.jpg",
    "title": "【30分雑談】ゲリラですが告知とスパチャ読み【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-26T15:06:08Z"
  },
  {
    "videoId": "Ii7rtNaGlls",
    "thumbnail": "https://i.ytimg.com/vi/Ii7rtNaGlls/mqdefault.jpg",
    "title": "【3DMV】シャルイース /Aki Rosenthal【ホロライブ|民族調オリジナル】",
    "publishedAt": "2020-06-29T14:30:13Z"
  },
  {
    "videoId": "w0jPXVnmsys",
    "thumbnail": "https://i.ytimg.com/vi/w0jPXVnmsys/mqdefault.jpg",
    "title": "【特別3D配信!? 】今夜はスペシャルナイト！#新シャルイース【ホロライブ/アキロゼ】",
    "publishedAt": "2020-06-29T16:15:58Z"
  },
  {
    "videoId": "_zM_hPaWGBA",
    "thumbnail": "https://i.ytimg.com/vi/_zM_hPaWGBA/mqdefault.jpg",
    "title": "【飲み比べ企画】赤ワイン編|デイリーワインで6か国周遊気分！【風宮まつり(バルス)×アキロゼ(ホロライブ)】",
    "publishedAt": "2020-06-30T16:17:32Z"
  },
  {
    "videoId": "MxwGVrJXI4E",
    "thumbnail": "https://i.ytimg.com/vi/MxwGVrJXI4E/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】12:00～やっとできる！！サムネ準備中【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-01T07:14:37Z"
  },
  {
    "videoId": "tIh27saC8oA",
    "thumbnail": "https://i.ytimg.com/vi/tIh27saC8oA/mqdefault.jpg",
    "title": "【ARK ╎スコーチドアース】単身飛び込み観光！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-03T18:59:10Z"
  },
  {
    "videoId": "7-KQTMz1xyM",
    "thumbnail": "https://i.ytimg.com/vi/7-KQTMz1xyM/mqdefault.jpg",
    "title": "【乾杯雑談】シャルイース完成打ち上げ宴会！！赤ワイン飲む！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-04T18:50:47Z"
  },
  {
    "videoId": "aRb6sZptMIc",
    "thumbnail": "https://i.ytimg.com/vi/aRb6sZptMIc/mqdefault.jpg",
    "title": "【ARK ╎Aberration】最後のアベレーション…ついにお引越し…！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-06T18:28:14Z"
  },
  {
    "videoId": "Cov34iX5SVw",
    "thumbnail": "https://i.ytimg.com/vi/Cov34iX5SVw/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】寝起きゲリラARK【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-07T09:37:30Z"
  },
  {
    "videoId": "8PtLUzjSwzs",
    "thumbnail": "https://i.ytimg.com/vi/8PtLUzjSwzs/mqdefault.jpg",
    "title": "【ARK ╎Extinction】枠取り直し！初めてのエクスティンクションに弾丸観光！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-08T10:27:56Z"
  },
  {
    "videoId": "Vl_mJuohdtw",
    "thumbnail": "https://i.ytimg.com/vi/Vl_mJuohdtw/mqdefault.jpg",
    "title": "【歌と雑談】しっとり系の歌を歌ってみたい【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-08T16:51:45Z"
  },
  {
    "videoId": "26KJmaXS39g",
    "thumbnail": "https://i.ytimg.com/vi/26KJmaXS39g/mqdefault.jpg",
    "title": "【Ark: Crystal Isles】グリフォン＆ギガノトのイベカラーをテイムしたい！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-09T09:40:36Z"
  },
  {
    "videoId": "CzT62UAjgys",
    "thumbnail": "https://i.ytimg.com/vi/CzT62UAjgys/mqdefault.jpg",
    "title": "【Ark: Crystal Isles】ムキロゼ式罠ナシテイムを伝授する！【ホロライブ/アキロゼ&姫森ルーナ】",
    "publishedAt": "2020-07-10T05:25:28Z"
  },
  {
    "videoId": "JLeF4ALwBy4",
    "thumbnail": "https://i.ytimg.com/vi/JLeF4ALwBy4/mqdefault.jpg",
    "title": "【ARK ╎Extinction】生けるゴジラ…！？ギガノトをつかまえたい！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-10T09:37:39Z"
  },
  {
    "videoId": "UFQdRJZt0uU",
    "thumbnail": "https://i.ytimg.com/vi/UFQdRJZt0uU/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】ゲリラ！ARK歌でも歌いながらまったりなはず【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-10T20:38:28Z"
  },
  {
    "videoId": "dmrZEB2RWyU",
    "thumbnail": "https://i.ytimg.com/vi/dmrZEB2RWyU/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】建築するかテイムするかスコーチドアースの準備も【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-12T20:30:23Z"
  },
  {
    "videoId": "s8ErM2oKbLg",
    "thumbnail": "https://i.ytimg.com/vi/s8ErM2oKbLg/mqdefault.jpg",
    "title": "【ARK ╎Scorched Earth】🔥ワイバーン卵GET🔥超過酷な砂漠世界スコーチドアース突入編！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-13T10:07:11Z"
  },
  {
    "videoId": "9myUo4OfjTE",
    "thumbnail": "https://i.ytimg.com/vi/9myUo4OfjTE/mqdefault.jpg",
    "title": "【APEX】FPSガチ初心者の11ペックス目！マウス感度3000倍だった！？【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-14T09:07:20Z"
  },
  {
    "videoId": "vvpIlZdRI3U",
    "thumbnail": "https://i.ytimg.com/vi/vvpIlZdRI3U/mqdefault.jpg",
    "title": "【雑談】もう限界！新PC購入相談！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-14T16:38:29Z"
  },
  {
    "videoId": "C0zL-iVarnA",
    "thumbnail": "https://i.ytimg.com/vi/C0zL-iVarnA/mqdefault.jpg",
    "title": "【ARK ╎Extinction】超有能雪フクロウ厳選！？【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-15T09:07:36Z"
  },
  {
    "videoId": "Ia8oLe0ySw8",
    "thumbnail": "https://i.ytimg.com/vi/Ia8oLe0ySw8/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】超ハイテク！TEKレプリケーターを拠点におきたい【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-16T11:36:05Z"
  },
  {
    "videoId": "fNiEgV0kKN0",
    "thumbnail": "https://i.ytimg.com/vi/fNiEgV0kKN0/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】裏で高レベル恐竜に出会わな過ぎて心がボキボキ【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-17T08:46:13Z"
  },
  {
    "videoId": "DljKuk7g4d8",
    "thumbnail": "https://i.ytimg.com/vi/DljKuk7g4d8/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】深夜の安眠ARK建築配信BeachHouse編【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-17T19:29:50Z"
  },
  {
    "videoId": "K4-0rWlrq8U",
    "thumbnail": "https://i.ytimg.com/vi/K4-0rWlrq8U/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！伝説の荷運び人になるPart1【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-18T06:29:49Z"
  },
  {
    "videoId": "Obpx5mffXyc",
    "thumbnail": "https://i.ytimg.com/vi/Obpx5mffXyc/mqdefault.jpg",
    "title": "【ARK ╎Extinction】夏イベ終了間際だし雪フクロウ&ギガノトリベンジ！ガンガンテイム！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-20T10:45:25Z"
  },
  {
    "videoId": "Pjp14YD4kBk",
    "thumbnail": "https://i.ytimg.com/vi/Pjp14YD4kBk/mqdefault.jpg",
    "title": "【ARK ╎クロスＭＡＰ】フェニックス？ギガノト？肉パーティ？【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-22T07:54:42Z"
  },
  {
    "videoId": "chdMIfIjMug",
    "thumbnail": "https://i.ytimg.com/vi/chdMIfIjMug/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】深夜の安眠ARK建築配信BeachHouse編Part4【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-24T19:22:00Z"
  },
  {
    "videoId": "OPEgzyiFM88",
    "thumbnail": "https://i.ytimg.com/vi/OPEgzyiFM88/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！伝説の荷運び人になるPart2【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-25T07:25:03Z"
  },
  {
    "videoId": "gC5vXHFj9ng",
    "thumbnail": "https://i.ytimg.com/vi/gC5vXHFj9ng/mqdefault.jpg",
    "title": "【乾杯雑談】スルメ系Vtuberアキロゼ？！最近の話とスパチャ&メンバー感謝枠【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-25T19:31:02Z"
  },
  {
    "videoId": "7cY71XyeWGY",
    "thumbnail": "https://i.ytimg.com/vi/7cY71XyeWGY/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】金髪美女！？メルちゃんにゴリゴリ教えるぞ！【ホロライブ/アキロゼ&夜空メル】",
    "publishedAt": "2020-07-28T09:49:05Z"
  },
  {
    "videoId": "WiN4vmqnnbY",
    "thumbnail": "https://i.ytimg.com/vi/WiN4vmqnnbY/mqdefault.jpg",
    "title": "【Project Winter #ホロ雪山人狼】初心者だけど生き残りたい！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2020-07-29T11:50:27Z"
  },
  {
    "videoId": "HrNwbzRAi-M",
    "thumbnail": "https://i.ytimg.com/vi/HrNwbzRAi-M/mqdefault.jpg",
    "title": "【新Live2Dお披露目】ぬるぬるでパタパタするアキロゼ2.0で乾杯！【ホロライブ/#アキロゼ新2D】",
    "publishedAt": "2020-07-29T14:57:54Z"
  },
  {
    "videoId": "WZsKF58SNEo",
    "thumbnail": "https://i.ytimg.com/vi/WZsKF58SNEo/mqdefault.jpg",
    "title": "【乾杯雑談】はしご酒だあ！！新Live2D感想と感謝とともに【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-30T18:17:44Z"
  },
  {
    "videoId": "qbJEo5Im2mw",
    "thumbnail": "https://i.ytimg.com/vi/qbJEo5Im2mw/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】深夜の安眠ARK！ついに装飾できる！BeachHouse編Part5【ホロライブ/アキロゼ】",
    "publishedAt": "2020-07-31T20:46:40Z"
  },
  {
    "videoId": "b2u10EX3BNo",
    "thumbnail": "https://i.ytimg.com/vi/b2u10EX3BNo/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！伝説の荷運び人になるPart3【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-01T07:15:31Z"
  },
  {
    "videoId": "7fKFWslgoIY",
    "thumbnail": "https://i.ytimg.com/vi/7fKFWslgoIY/mqdefault.jpg",
    "title": "【ARK ╎Scorched Earth】砂漠のビックリ箱！？デスワーム撃退任務！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-03T08:19:02Z"
  },
  {
    "videoId": "j-A4ipZeKYU",
    "thumbnail": "https://i.ytimg.com/vi/j-A4ipZeKYU/mqdefault.jpg",
    "title": "【ARK ╎Extinction】エレメントがっぽり防衛戦【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-04T07:54:49Z"
  },
  {
    "videoId": "zNl6reD6lDE",
    "thumbnail": "https://i.ytimg.com/vi/zNl6reD6lDE/mqdefault.jpg",
    "title": "【#ホロアロマ講座】ホロメン達に勝手にリコメンド！！【ホロライブ/アキロゼ×友人A】",
    "publishedAt": "2020-08-05T15:33:42Z"
  },
  {
    "videoId": "9bfVUAr8O3o",
    "thumbnail": "https://i.ytimg.com/vi/9bfVUAr8O3o/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】ギガノトも欲しいし戦闘員育てたいし海の準備もしたい【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-06T10:43:52Z"
  },
  {
    "videoId": "AlSksitRtI0",
    "thumbnail": "https://i.ytimg.com/vi/AlSksitRtI0/mqdefault.jpg",
    "title": "【ゲリラ歌？】謎の民族楽器と鼻歌【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-06T17:04:50Z"
  },
  {
    "videoId": "4aKqwJVdYyQ",
    "thumbnail": "https://i.ytimg.com/vi/4aKqwJVdYyQ/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】くじら！イカ！？深海洞窟！？？【ホロライブ/アキロゼ×ロボ子さん】",
    "publishedAt": "2020-08-07T09:50:19Z"
  },
  {
    "videoId": "KWkPzu9nT88",
    "thumbnail": "https://i.ytimg.com/vi/KWkPzu9nT88/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！最強の荷運び人になるPart4【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-08T11:07:07Z"
  },
  {
    "videoId": "odhdZO6RAm4",
    "thumbnail": "https://i.ytimg.com/vi/odhdZO6RAm4/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】ムキロゼ式テイム術伝授【ホロライブ/アキロゼ×大空スバル】",
    "publishedAt": "2020-08-10T15:57:44Z"
  },
  {
    "videoId": "F8DKXISipkE",
    "thumbnail": "https://i.ytimg.com/vi/F8DKXISipkE/mqdefault.jpg",
    "title": "【#Rosetai200K】20万人突破記念！歌ってお祝い！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-11T06:18:07Z"
  },
  {
    "videoId": "_zagh3ksQY8",
    "thumbnail": "https://i.ytimg.com/vi/_zagh3ksQY8/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】飲酒ARKで洞窟攻略準備するムキロゼ！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-11T19:53:41Z"
  },
  {
    "videoId": "Eb4anmCtobI",
    "thumbnail": "https://i.ytimg.com/vi/Eb4anmCtobI/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】今夜のスコーチドアース洞窟RTAコラボ準備！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-12T09:17:20Z"
  },
  {
    "videoId": "SHSikWg-NB0",
    "thumbnail": "https://i.ytimg.com/vi/SHSikWg-NB0/mqdefault.jpg",
    "title": "【ARK ╎Scorched Earth】誰が優勝！？ARK廃人組によるデッドレース【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-12T16:57:16Z"
  },
  {
    "videoId": "9KV870x1vI4",
    "thumbnail": "https://i.ytimg.com/vi/9KV870x1vI4/mqdefault.jpg",
    "title": "【乾杯雑談】最近の話と Super Chat御礼枠【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-13T18:52:51Z"
  },
  {
    "videoId": "-A8o14ounVg",
    "thumbnail": "https://i.ytimg.com/vi/-A8o14ounVg/mqdefault.jpg",
    "title": "【Fall Guys】優勝したらご褒美手作りかき氷！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-14T20:41:20Z"
  },
  {
    "videoId": "_zavnolfnvw",
    "thumbnail": "https://i.ytimg.com/vi/_zavnolfnvw/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！最強の荷運び人になるPart5【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-15T07:46:22Z"
  },
  {
    "videoId": "whRqQZZQOOM",
    "thumbnail": "https://i.ytimg.com/vi/whRqQZZQOOM/mqdefault.jpg",
    "title": "【世界のアソビ大全51】負けるたび顔芸 #ガンギマリ姉妹 【ホロライブ/アキロゼ×角巻わため】",
    "publishedAt": "2020-08-16T14:31:57Z"
  },
  {
    "videoId": "LvsSptBNL1o",
    "thumbnail": "https://i.ytimg.com/vi/LvsSptBNL1o/mqdefault.jpg",
    "title": "【Fall Guys】優勝したらご褒美手作りかき氷！第2ROUND【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-18T19:52:28Z"
  },
  {
    "videoId": "XvxEFIcjqUU",
    "thumbnail": "https://i.ytimg.com/vi/XvxEFIcjqUU/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】復活のARK【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-24T06:18:41Z"
  },
  {
    "videoId": "wPaN1ZlEMYg",
    "thumbnail": "https://i.ytimg.com/vi/wPaN1ZlEMYg/mqdefault.jpg",
    "title": "【世界のアソビ大全51】負けるたびゴリラ化！？  #お清楚ゴリラ【ホロライブアキロゼ🍎×アイドル部神楽すず🍋】",
    "publishedAt": "2020-08-24T14:32:19Z"
  },
  {
    "videoId": "DWDGz98NBC0",
    "thumbnail": "https://i.ytimg.com/vi/DWDGz98NBC0/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】拠点整理…タスケテ‥‥うう！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-25T09:28:27Z"
  },
  {
    "videoId": "Y4h-hiKeNTg",
    "thumbnail": "https://i.ytimg.com/vi/Y4h-hiKeNTg/mqdefault.jpg",
    "title": "【晩酌配信】音MAD欲しいので素材提供し、飲み、感謝をする【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-25T18:39:43Z"
  },
  {
    "videoId": "Nx9FKPnxB4A",
    "thumbnail": "https://i.ytimg.com/vi/Nx9FKPnxB4A/mqdefault.jpg",
    "title": "【Fall Guys】ゲリラ！1時間で優勝したらご褒美かき氷【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-26T04:58:39Z"
  },
  {
    "videoId": "paBwW-10CAo",
    "thumbnail": "https://i.ytimg.com/vi/paBwW-10CAo/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】緊急ゲリラ！ココ会長のお手伝いするムキロゼ！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-26T22:02:46Z"
  },
  {
    "videoId": "JLxnn9e_QYk",
    "thumbnail": "https://i.ytimg.com/vi/JLxnn9e_QYk/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！最強の荷運び人になるPart6【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-29T08:12:49Z"
  },
  {
    "videoId": "VXWQN2wVrXA",
    "thumbnail": "https://i.ytimg.com/vi/VXWQN2wVrXA/mqdefault.jpg",
    "title": "【3D歌枠】25万人記念配信！Acoustic Session Live 1st 【ホロライブ/アキロゼ】",
    "publishedAt": "2020-08-31T16:37:34Z"
  },
  {
    "videoId": "arMe27Q_Sdo",
    "thumbnail": "https://i.ytimg.com/vi/arMe27Q_Sdo/mqdefault.jpg",
    "title": "【乾杯雑談】最近の話と Super Chat御礼枠【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-01T17:48:17Z"
  },
  {
    "videoId": "lg_Akn86qYI",
    "thumbnail": "https://i.ytimg.com/vi/lg_Akn86qYI/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】朝活RFA1日目【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-02T02:37:33Z"
  },
  {
    "videoId": "ZadiR9GlAh8",
    "thumbnail": "https://i.ytimg.com/vi/ZadiR9GlAh8/mqdefault.jpg",
    "title": "【Fall Guys】優勝したらかき氷【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-03T05:41:21Z"
  },
  {
    "videoId": "3KYR5zgG1wo",
    "thumbnail": "https://i.ytimg.com/vi/3KYR5zgG1wo/mqdefault.jpg",
    "title": "【ProjectWinter】一緒にいこう？アキロゼ視点【ホロライブ × どっとライブ】",
    "publishedAt": "2020-09-03T12:12:24Z"
  },
  {
    "videoId": "1-3VLFdrnW4",
    "thumbnail": "https://i.ytimg.com/vi/1-3VLFdrnW4/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！超脳筋で道を切り開くPart7【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-05T08:07:43Z"
  },
  {
    "videoId": "fbs2wkyZjNo",
    "thumbnail": "https://i.ytimg.com/vi/fbs2wkyZjNo/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】緊急ゲリラ！ムキロゼ新PCでARKプレイ！ココちゃんティタノお手伝いも！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-05T17:44:15Z"
  },
  {
    "videoId": "6CNh25Q7AX8",
    "thumbnail": "https://i.ytimg.com/vi/6CNh25Q7AX8/mqdefault.jpg",
    "title": "【ARK ╎Crystal Isles】初コラボ♡イオフィちゃんにムキロゼ式ARKをたたき込む！？【Hololive/Iofi×Akirose】",
    "publishedAt": "2020-09-07T16:35:07Z"
  },
  {
    "videoId": "5T9guCmnOmk",
    "thumbnail": "https://i.ytimg.com/vi/5T9guCmnOmk/mqdefault.jpg",
    "title": "【歌枠】ただいま復活でリハビリお歌 Song Live【#アキロゼ/ホロライブ】",
    "publishedAt": "2020-09-09T18:25:17Z"
  },
  {
    "videoId": "OKb8t0U0krA",
    "thumbnail": "https://i.ytimg.com/vi/OKb8t0U0krA/mqdefault.jpg",
    "title": "【Craftopia】なんでもできる話題の最新ゲーム！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-10T05:31:39Z"
  },
  {
    "videoId": "SMS8s66q7F4",
    "thumbnail": "https://i.ytimg.com/vi/SMS8s66q7F4/mqdefault.jpg",
    "title": "【歌枠】朝から声出しお歌練習！Moning Sing streming live【Hololive/アキロゼ】",
    "publishedAt": "2020-09-11T03:26:13Z"
  },
  {
    "videoId": "p_c-bI3aDSc",
    "thumbnail": "https://i.ytimg.com/vi/p_c-bI3aDSc/mqdefault.jpg",
    "title": "【Craftopia】#あんぽんたん姉妹　クラフトピア共同生活Day1【ホロライブ/アキロゼ視点】",
    "publishedAt": "2020-09-11T07:54:07Z"
  },
  {
    "videoId": "houkZ-xkVuE",
    "thumbnail": "https://i.ytimg.com/vi/houkZ-xkVuE/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！超脳筋で道を切り開くPart８【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-12T09:53:18Z"
  },
  {
    "videoId": "aNSVny8yySk",
    "thumbnail": "https://i.ytimg.com/vi/aNSVny8yySk/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】朝活RFA2日目【Hololive/Akirose】",
    "publishedAt": "2020-09-14T03:15:53Z"
  },
  {
    "videoId": "MnxY50_JsII",
    "thumbnail": "https://i.ytimg.com/vi/MnxY50_JsII/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】筋肉痛すごい朝活RFA3日目【Hololive/Akirose】",
    "publishedAt": "2020-09-15T03:29:39Z"
  },
  {
    "videoId": "mvTuSwlbBl8",
    "thumbnail": "https://i.ytimg.com/vi/mvTuSwlbBl8/mqdefault.jpg",
    "title": "【歌枠】朝から声出しお歌練習！Morning singing livestream【Hololive/アキロゼ】",
    "publishedAt": "2020-09-16T02:53:40Z"
  },
  {
    "videoId": "3Gdjf464VmQ",
    "thumbnail": "https://i.ytimg.com/vi/3Gdjf464VmQ/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】MUKIROSE Natural tame 超難関ロックエレメンタルをロケラン罠なしチャレンジ【Hololive/アキロゼ】",
    "publishedAt": "2020-09-16T06:15:26Z"
  },
  {
    "videoId": "w00AV0Lx6nU",
    "thumbnail": "https://i.ytimg.com/vi/w00AV0Lx6nU/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】苦しい楽しい朝活RFA4日目【Hololive/Akirose】",
    "publishedAt": "2020-09-17T02:56:03Z"
  },
  {
    "videoId": "FTMMA9QnEvY",
    "thumbnail": "https://i.ytimg.com/vi/FTMMA9QnEvY/mqdefault.jpg",
    "title": "【Spellbreak】初めてのDUO戦！最強の魔法バトロワに挑戦！【ホロライブ/ロボ子×アキロゼ】",
    "publishedAt": "2020-09-17T09:01:29Z"
  },
  {
    "videoId": "-CrEvk4dUBA",
    "thumbnail": "https://i.ytimg.com/vi/-CrEvk4dUBA/mqdefault.jpg",
    "title": "【飲み比べ企画】コンビニで買える日本酒勝手にランキング！？【#風宮まつり #アキロゼ/Hololive】",
    "publishedAt": "2020-09-18T17:21:18Z"
  },
  {
    "videoId": "Y2esPTdMDwU",
    "thumbnail": "https://i.ytimg.com/vi/Y2esPTdMDwU/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！超脳筋で道を切り開くPart9【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-19T09:14:02Z"
  },
  {
    "videoId": "zUg2dBSxBJU",
    "thumbnail": "https://i.ytimg.com/vi/zUg2dBSxBJU/mqdefault.jpg",
    "title": "【Minecraft】己の顔を刻む　#あんぽんたん姉妹 Day1【ホロライブ #ロボ子さん #姫森ルーナ/アキロゼ視点】",
    "publishedAt": "2020-09-19T19:34:56Z"
  },
  {
    "videoId": "BmHBJg7_4jE",
    "thumbnail": "https://i.ytimg.com/vi/BmHBJg7_4jE/mqdefault.jpg",
    "title": "三月のパンタシア-コラージュ『 衛宮さんちの今日のごはんED』Hololive/アキ・ローゼンタール(Cover)",
    "publishedAt": "2020-09-20T15:00:09Z"
  },
  {
    "videoId": "KaWl_rR-TGw",
    "thumbnail": "https://i.ytimg.com/vi/KaWl_rR-TGw/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】LOVE ARKギガノト交配したい【Hololive/ #癒月ちょこ #アキロゼ】",
    "publishedAt": "2020-09-25T05:34:46Z"
  },
  {
    "videoId": "9ieTJokhc-c",
    "thumbnail": "https://i.ytimg.com/vi/9ieTJokhc-c/mqdefault.jpg",
    "title": "【Minecraft】RE:STARTぽんこつマイクラ異世界生活Day1【Hololive/アキロゼ】",
    "publishedAt": "2020-09-25T18:05:01Z"
  },
  {
    "videoId": "py-M8OAlOM8",
    "thumbnail": "https://i.ytimg.com/vi/py-M8OAlOM8/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！超脳筋で道を切り開くPart10【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-26T05:04:19Z"
  },
  {
    "videoId": "guS-ybwhmD0",
    "thumbnail": "https://i.ytimg.com/vi/guS-ybwhmD0/mqdefault.jpg",
    "title": "【乾杯雑談】配信よてい！げりら！げりら！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-28T16:04:51Z"
  },
  {
    "videoId": "gq7CvmNWl0c",
    "thumbnail": "https://i.ytimg.com/vi/gq7CvmNWl0c/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】苦しい楽しい朝活RFA5日目【Hololive/Akirose】",
    "publishedAt": "2020-09-29T02:57:42Z"
  },
  {
    "videoId": "5lZDtFEdVtU",
    "thumbnail": "https://i.ytimg.com/vi/5lZDtFEdVtU/mqdefault.jpg",
    "title": "【おうち3D歌枠】Acoustic Session Live 2nd【ホロライブ/アキロゼ】",
    "publishedAt": "2020-09-30T15:27:49Z"
  },
  {
    "videoId": "hCXE6r6R7Po",
    "thumbnail": "https://i.ytimg.com/vi/hCXE6r6R7Po/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！超脳筋で道を切り開くPart11【ホロライブ/アキロゼ】",
    "publishedAt": "2020-10-03T06:17:22Z"
  },
  {
    "videoId": "hoNFZDwLoiI",
    "thumbnail": "https://i.ytimg.com/vi/hoNFZDwLoiI/mqdefault.jpg",
    "title": "【Minecraft】ぽんこつマイクラ異世界生活Day2【Hololive/アキロゼ】",
    "publishedAt": "2020-10-05T18:35:15Z"
  },
  {
    "videoId": "jFY-IN4H4Zg",
    "thumbnail": "https://i.ytimg.com/vi/jFY-IN4H4Zg/mqdefault.jpg",
    "title": "【乾杯雑談】KANPAI!!【ホロライブ/アキロゼ】",
    "publishedAt": "2020-10-08T16:50:18Z"
  },
  {
    "videoId": "tlKBqyUofuA",
    "thumbnail": "https://i.ytimg.com/vi/tlKBqyUofuA/mqdefault.jpg",
    "title": "【Fall Guys】シーズン２で初勝利が欲しい！【Hololive/Akirose】",
    "publishedAt": "2020-10-09T07:09:56Z"
  },
  {
    "videoId": "4Nt4sRqQtzI",
    "thumbnail": "https://i.ytimg.com/vi/4Nt4sRqQtzI/mqdefault.jpg",
    "title": "【作業work】ねむねむサムネ作りThumbnail making【ホロライブHololive/アキロゼAkirose】",
    "publishedAt": "2020-10-09T17:42:48Z"
  },
  {
    "videoId": "NmtrPjRvM9g",
    "thumbnail": "https://i.ytimg.com/vi/NmtrPjRvM9g/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】アキロゼの完全初見プレイ実況！超脳筋で道を切り開くPart12【Hololive/Akirose】",
    "publishedAt": "2020-10-10T04:49:57Z"
  },
  {
    "videoId": "x0UAlhYHdRw",
    "thumbnail": "https://i.ytimg.com/vi/x0UAlhYHdRw/mqdefault.jpg",
    "title": "【アソビ大全】勝負事には本気で負けたくない二人 #画伯ルーキーズ【ホロライブ/アキロゼ×常闇トワ】",
    "publishedAt": "2020-10-10T15:18:58Z"
  },
  {
    "videoId": "MSX8QbJR0eQ",
    "thumbnail": "https://i.ytimg.com/vi/MSX8QbJR0eQ/mqdefault.jpg",
    "title": "気まぐれメルシィKimagure Mercy/アキ・ローゼンタール【歌ってみた】",
    "publishedAt": "2020-10-11T14:15:12Z"
  },
  {
    "videoId": "96sBSzSp19o",
    "thumbnail": "https://i.ytimg.com/vi/96sBSzSp19o/mqdefault.jpg",
    "title": "【ASMR耳元雑談】新作歌ってみた同時視聴！【Hololive/Akirose】",
    "publishedAt": "2020-10-11T17:11:22Z"
  },
  {
    "videoId": "CilipcmSisM",
    "thumbnail": "https://i.ytimg.com/vi/CilipcmSisM/mqdefault.jpg",
    "title": "【Slither.io】TOP10耐久【Hololiveホロライブ/Akiroseアキロゼ】",
    "publishedAt": "2020-10-12T18:03:02Z"
  },
  {
    "videoId": "9W3_NEUTs7w",
    "thumbnail": "https://i.ytimg.com/vi/9W3_NEUTs7w/mqdefault.jpg",
    "title": "【乾杯雑談】麦ジュースで乾杯！【Hololiveホロライブ/Akiroseアキロゼ】",
    "publishedAt": "2020-10-13T16:38:36Z"
  },
  {
    "videoId": "ESo3w2bSwso",
    "thumbnail": "https://i.ytimg.com/vi/ESo3w2bSwso/mqdefault.jpg",
    "title": "【お料理配信】29万人記念手作りハンバーグ【Hololive/Akirose】",
    "publishedAt": "2020-10-14T05:38:14Z"
  },
  {
    "videoId": "FaTXDO3FvzM",
    "thumbnail": "https://i.ytimg.com/vi/FaTXDO3FvzM/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】30万人突破するまで負荷MAX30耐久【Hololive/Akirose】",
    "publishedAt": "2020-10-14T16:26:14Z"
  },
  {
    "videoId": "_T0zc4Poprw",
    "thumbnail": "https://i.ytimg.com/vi/_T0zc4Poprw/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】アキロゼの完全初見プレイ実況！超脳筋で道を切り開くPart12.5【Hololive/Akirose】",
    "publishedAt": "2020-10-17T07:14:27Z"
  },
  {
    "videoId": "HF-R_YOZVq4",
    "thumbnail": "https://i.ytimg.com/vi/HF-R_YOZVq4/mqdefault.jpg",
    "title": "【Minecraft】初めてのピクセルアート完成させる！#あんぽんたん姉妹【Hololive/アキロゼ】",
    "publishedAt": "2020-10-18T17:45:27Z"
  },
  {
    "videoId": "EjxJ-zE7NHs",
    "thumbnail": "https://i.ytimg.com/vi/EjxJ-zE7NHs/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】MUKIROSE 復活【Hololive/Akiroseアキロゼ】",
    "publishedAt": "2020-10-21T18:36:36Z"
  },
  {
    "videoId": "i1ibPrU7otc",
    "thumbnail": "https://i.ytimg.com/vi/i1ibPrU7otc/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】今日から！Happy ARK Halloween【Hololive/アキロゼ】",
    "publishedAt": "2020-10-24T02:56:11Z"
  },
  {
    "videoId": "lwr1xuAT9os",
    "thumbnail": "https://i.ytimg.com/vi/lwr1xuAT9os/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】アキロゼの完全初見プレイ実況！超脳筋で道を切り開くPart13【Hololive/Akirose】",
    "publishedAt": "2020-10-24T06:42:09Z"
  },
  {
    "videoId": "M2y_w6aywKk",
    "thumbnail": "https://i.ytimg.com/vi/M2y_w6aywKk/mqdefault.jpg",
    "title": "【おうち3D歌枠】Acoustic Session Live 3rd【ホロライブ/アキロゼ】",
    "publishedAt": "2020-10-27T15:27:39Z"
  },
  {
    "videoId": "nepPdxPAGvA",
    "thumbnail": "https://i.ytimg.com/vi/nepPdxPAGvA/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】 緊急クエスト発生！ Halloween【Hololive/アキロゼ/ロボ子さん】",
    "publishedAt": "2020-10-27T19:12:18Z"
  },
  {
    "videoId": "3eSlc2W-mlc",
    "thumbnail": "https://i.ytimg.com/vi/3eSlc2W-mlc/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】5期生見守りのムキロゼ【Hololive/アキロゼ】",
    "publishedAt": "2020-10-28T14:09:29Z"
  },
  {
    "videoId": "Aon2ZBATiLM",
    "thumbnail": "https://i.ytimg.com/vi/Aon2ZBATiLM/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】アキロゼの完全初見プレイ実況！超脳筋で道を切り開くPart14【Hololive/Akirose】",
    "publishedAt": "2020-10-31T06:04:08Z"
  },
  {
    "videoId": "M4eXY1VlLQ8",
    "thumbnail": "https://i.ytimg.com/vi/M4eXY1VlLQ8/mqdefault.jpg",
    "title": "【Heave Ho】#ちまつりお清楚ゴリラ  手を繋げ！協力セヨ！！",
    "publishedAt": "2020-11-02T15:12:40Z"
  },
  {
    "videoId": "4t1QBusdAwk",
    "thumbnail": "https://i.ytimg.com/vi/4t1QBusdAwk/mqdefault.jpg",
    "title": "【ドMホイホイ】タイトルなんて自分で考えなさいな【Cover/#アキ・ローゼンタール】",
    "publishedAt": "2020-11-03T03:00:11Z"
  },
  {
    "videoId": "ZzJUHawaF48",
    "thumbnail": "https://i.ytimg.com/vi/ZzJUHawaF48/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】イベントが終わっちゃう！！！【Hololive/アキロゼ】",
    "publishedAt": "2020-11-04T07:02:33Z"
  },
  {
    "videoId": "Icg8LHLn73E",
    "thumbnail": "https://i.ytimg.com/vi/Icg8LHLn73E/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】イベントが終わっちゃう！！！【Hololive/アキロゼ】",
    "publishedAt": "2020-11-06T19:54:59Z"
  },
  {
    "videoId": "q_iQxUInJ3k",
    "thumbnail": "https://i.ytimg.com/vi/q_iQxUInJ3k/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】アキロゼの完全初見プレイ実況！超脳筋で道を切り開くPart15【Hololive/Akirose】",
    "publishedAt": "2020-11-07T06:10:56Z"
  },
  {
    "videoId": "deWYVAbkyY0",
    "thumbnail": "https://i.ytimg.com/vi/deWYVAbkyY0/mqdefault.jpg",
    "title": "【#ホロ国際AmongUs】 宇宙人狼は誰だ！？【Hololive/アキロゼ視点】",
    "publishedAt": "2020-11-09T15:17:48Z"
  },
  {
    "videoId": "XWUK93Mj2yM",
    "thumbnail": "https://i.ytimg.com/vi/XWUK93Mj2yM/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】ムキ兄弟爆☆誕！！ARKで生きる漢達Muki bros【Hololive/尾丸ポルカ×アキロゼ】",
    "publishedAt": "2020-11-10T16:55:42Z"
  },
  {
    "videoId": "HbuHDmIgO28",
    "thumbnail": "https://i.ytimg.com/vi/HbuHDmIgO28/mqdefault.jpg",
    "title": "【新●●お披露目！？】NEW!!!!!!!!!!!!!!?【Hololive/アキロゼ】",
    "publishedAt": "2020-11-12T16:35:51Z"
  },
  {
    "videoId": "4dUT4HGB1P8",
    "thumbnail": "https://i.ytimg.com/vi/4dUT4HGB1P8/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】今からでも間に合う！考察する回！！ Part16【Hololive/Akirose】",
    "publishedAt": "2020-11-14T08:03:35Z"
  },
  {
    "videoId": "daNmg8UDQN0",
    "thumbnail": "https://i.ytimg.com/vi/daNmg8UDQN0/mqdefault.jpg",
    "title": "【歌枠】33万人ありがとう！Sing streaming【Hololive/アキロゼ】",
    "publishedAt": "2020-11-17T16:55:05Z"
  },
  {
    "videoId": "47bZB367YlQ",
    "thumbnail": "https://i.ytimg.com/vi/47bZB367YlQ/mqdefault.jpg",
    "title": "【Minecraft】運動会のお手伝いと下見&練習で優勝狙っていく！【Hololive/アキロゼ】",
    "publishedAt": "2020-11-20T18:49:23Z"
  },
  {
    "videoId": "tfpIWaqm7Ps",
    "thumbnail": "https://i.ytimg.com/vi/tfpIWaqm7Ps/mqdefault.jpg",
    "title": "【Minecraft】運動会の打ち上げする～～！【Hololive/アキロゼ】",
    "publishedAt": "2020-11-22T18:57:11Z"
  },
  {
    "videoId": "GnxldWFTLq8",
    "thumbnail": "https://i.ytimg.com/vi/GnxldWFTLq8/mqdefault.jpg",
    "title": "【歌特訓】課題曲：炎を一緒に覚えよう！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-11-24T18:18:42Z"
  },
  {
    "videoId": "YtXEelwocpk",
    "thumbnail": "https://i.ytimg.com/vi/YtXEelwocpk/mqdefault.jpg",
    "title": "【#あんシス3D】全身つかって動きまくる！【ホロライブ│ロボ子さん/姫森ルーナ/アキロゼ】",
    "publishedAt": "2020-11-26T11:10:12Z"
  },
  {
    "videoId": "Gi3vrgHhnrY",
    "thumbnail": "https://i.ytimg.com/vi/Gi3vrgHhnrY/mqdefault.jpg",
    "title": "【歌特訓】課題曲『フリージア』一緒に覚えよう！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-11-26T19:29:48Z"
  },
  {
    "videoId": "1uOuambEZ-4",
    "thumbnail": "https://i.ytimg.com/vi/1uOuambEZ-4/mqdefault.jpg",
    "title": "【おうち3D】Acoustic Session Live 4th【ホロライブ/アキロゼ】",
    "publishedAt": "2020-11-27T15:58:57Z"
  },
  {
    "videoId": "QvleVjxTekA",
    "thumbnail": "https://i.ytimg.com/vi/QvleVjxTekA/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】完全初見プレイ実況！伝説の荷運び人になる Part17【Hololive/Akirose】",
    "publishedAt": "2020-11-28T05:55:33Z"
  },
  {
    "videoId": "_gZFl_5oRho",
    "thumbnail": "https://i.ytimg.com/vi/_gZFl_5oRho/mqdefault.jpg",
    "title": "【ARK￤Crystal Isles】TurkeyEvent感謝祭だああ！！！【Hololive/アキロゼ】",
    "publishedAt": "2020-11-30T07:17:27Z"
  },
  {
    "videoId": "CLrgSADwdSQ",
    "thumbnail": "https://i.ytimg.com/vi/CLrgSADwdSQ/mqdefault.jpg",
    "title": "【急に来る重大発表】いつやるの？今でしょ！！！ Important announcement【ホロライブ/アキロゼ】",
    "publishedAt": "2020-11-30T08:03:57Z"
  },
  {
    "videoId": "3y5-Fl2ExIA",
    "thumbnail": "https://i.ytimg.com/vi/3y5-Fl2ExIA/mqdefault.jpg",
    "title": "【ローゼンメイデン】聖少女領域/coverd Aki Rosenthal【歌ってみた/4K】",
    "publishedAt": "2020-12-04T15:00:10Z"
  },
  {
    "videoId": "1f2nexHjlxM",
    "thumbnail": "https://i.ytimg.com/vi/1f2nexHjlxM/mqdefault.jpg",
    "title": "【 #アキロゼ新衣装  】お披露目!!Akirose NEW Costume!【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-04T15:22:16Z"
  },
  {
    "videoId": "iwIsK2F6UiU",
    "thumbnail": "https://i.ytimg.com/vi/iwIsK2F6UiU/mqdefault.jpg",
    "title": "【DEATH STRANDING:PC】最終回！完全初見プレイ実況！伝説の荷運び人になる Part18【Hololive/Akirose】",
    "publishedAt": "2020-12-05T07:07:18Z"
  },
  {
    "videoId": "2PH1jveELXo",
    "thumbnail": "https://i.ytimg.com/vi/2PH1jveELXo/mqdefault.jpg",
    "title": "【Reバース開封】フブキVSアキロゼホロライブブースターパック開封対決！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-05T17:05:43Z"
  },
  {
    "videoId": "tvl0X3M_GNM",
    "thumbnail": "https://i.ytimg.com/vi/tvl0X3M_GNM/mqdefault.jpg",
    "title": "【ARK】肉の感謝祭！ARK復興したい！！【Hololive/アキロゼ】",
    "publishedAt": "2020-12-08T07:22:20Z"
  },
  {
    "videoId": "MDjJ93WINH4",
    "thumbnail": "https://i.ytimg.com/vi/MDjJ93WINH4/mqdefault.jpg",
    "title": "【ARK】ガチャとアーティファクトあわよくばギガノト【Hololive/アキロゼ】",
    "publishedAt": "2020-12-10T19:02:41Z"
  },
  {
    "videoId": "EC6gQncr4hU",
    "thumbnail": "https://i.ytimg.com/vi/EC6gQncr4hU/mqdefault.jpg",
    "title": "【晩酌】DiscodeでThank you する！after time is thankyou super chat time【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-12T17:56:29Z"
  },
  {
    "videoId": "C7ntBJLq3FE",
    "thumbnail": "https://i.ytimg.com/vi/C7ntBJLq3FE/mqdefault.jpg",
    "title": "【ARK】ガチャタワー建築したい【Hololive/アキロゼ】",
    "publishedAt": "2020-12-13T19:20:45Z"
  },
  {
    "videoId": "LdSbsxqGHUk",
    "thumbnail": "https://i.ytimg.com/vi/LdSbsxqGHUk/mqdefault.jpg",
    "title": "【マリオカート8DX】３位以下で即ARK【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-15T16:59:50Z"
  },
  {
    "videoId": "_iuZDGzR8XA",
    "thumbnail": "https://i.ytimg.com/vi/_iuZDGzR8XA/mqdefault.jpg",
    "title": "【ARK】最近ARKがやりたくてしょうがない【Hololive/アキロゼ】",
    "publishedAt": "2020-12-15T19:11:03Z"
  },
  {
    "videoId": "sqVC-w96jhM",
    "thumbnail": "https://i.ytimg.com/vi/sqVC-w96jhM/mqdefault.jpg",
    "title": "【ARK】37万人達成までにボス討伐できなかったらホラゲ確定【Hololive/アキロゼ】",
    "publishedAt": "2020-12-16T19:22:04Z"
  },
  {
    "videoId": "jdFL246u2Sk",
    "thumbnail": "https://i.ytimg.com/vi/jdFL246u2Sk/mqdefault.jpg",
    "title": "【歌枠】アキロゼ歌う！SING SING SING【Hololive/akirose】",
    "publishedAt": "2020-12-17T17:23:32Z"
  },
  {
    "videoId": "4DcbW9xWbJY",
    "thumbnail": "https://i.ytimg.com/vi/4DcbW9xWbJY/mqdefault.jpg",
    "title": "【トイレの花子さん】超絶ビビりなのでDon't touch me【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-18T17:49:54Z"
  },
  {
    "videoId": "u21uPJBbLuE",
    "thumbnail": "https://i.ytimg.com/vi/u21uPJBbLuE/mqdefault.jpg",
    "title": "【マリオカートDX8】最弱王からの脱却！強くなるんだ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-21T07:08:40Z"
  },
  {
    "videoId": "jb8QJEA9qd0",
    "thumbnail": "https://i.ytimg.com/vi/jb8QJEA9qd0/mqdefault.jpg",
    "title": "ライブ打ち上げ会場！！【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-22T17:02:59Z"
  },
  {
    "videoId": "XthPDG6BBQo",
    "thumbnail": "https://i.ytimg.com/vi/XthPDG6BBQo/mqdefault.jpg",
    "title": "【恐怖の森RTA】SPEAK ENGLISH ONLY & TheDeathForest RTA【Hololive/akirose】",
    "publishedAt": "2020-12-23T16:06:39Z"
  },
  {
    "videoId": "jgK91XZGbNg",
    "thumbnail": "https://i.ytimg.com/vi/jgK91XZGbNg/mqdefault.jpg",
    "title": "【16:00jst】歌枠リレーでLet's SING !! #ホロライブクリスマス【Hololive/Akirose】",
    "publishedAt": "2020-12-25T07:34:00Z"
  },
  {
    "videoId": "9-eLr4F5EYc",
    "thumbnail": "https://i.ytimg.com/vi/9-eLr4F5EYc/mqdefault.jpg",
    "title": "【ASMR】初めてのカリンバ！癒されて眠ろう【Hololive/Akirose】",
    "publishedAt": "2020-12-25T19:22:53Z"
  },
  {
    "videoId": "T6FVHTz1jYM",
    "thumbnail": "https://i.ytimg.com/vi/T6FVHTz1jYM/mqdefault.jpg",
    "title": "【トイレの花子さん】フブキ&わための見守り付きホラゲ【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-26T16:30:51Z"
  },
  {
    "videoId": "fInMmHXBSJQ",
    "thumbnail": "https://i.ytimg.com/vi/fInMmHXBSJQ/mqdefault.jpg",
    "title": "【桃太郎電鉄】3年決戦！敏腕社長はだれ？！【ときのそら/桃鈴ねね/Takanashi Kiara/アキロゼ 】",
    "publishedAt": "2020-12-29T15:01:54Z"
  },
  {
    "videoId": "aXsMhy948No",
    "thumbnail": "https://i.ytimg.com/vi/aXsMhy948No/mqdefault.jpg",
    "title": "【おうち3D】Acoustic Session Live 5th【ホロライブ/アキロゼ】",
    "publishedAt": "2020-12-30T04:30:42Z"
  },
  {
    "videoId": "3qa5gKlRYN0",
    "thumbnail": "https://i.ytimg.com/vi/3qa5gKlRYN0/mqdefault.jpg",
    "title": "【ARK】クリスタルアイルズγボス戦！！ #年末ARKボス戦 【Hololive/癒月ちょこ/桐生ココ/天音かなた/尾丸ポルカ/アキロゼ視点】",
    "publishedAt": "2020-12-30T12:47:56Z"
  },
  {
    "videoId": "AYR0fFYnNv0",
    "thumbnail": "https://i.ytimg.com/vi/AYR0fFYnNv0/mqdefault.jpg",
    "title": "Belly Dance Akirose",
    "publishedAt": "2020-12-31T16:00:10Z"
  },
  {
    "videoId": "9gqIceAq74I",
    "thumbnail": "https://i.ytimg.com/vi/9gqIceAq74I/mqdefault.jpg",
    "title": "【乾杯雑談】New year 1st stream!!あつまれ晩酌だ～！！【Hololive/Akirose】",
    "publishedAt": "2021-01-03T18:01:14Z"
  },
  {
    "videoId": "dkm2NlZJQ38",
    "thumbnail": "https://i.ytimg.com/vi/dkm2NlZJQ38/mqdefault.jpg",
    "title": "【マリオカート8DX】視聴者参加OK!!練習するのみ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-04T19:47:26Z"
  },
  {
    "videoId": "719xsG7V8Pw",
    "thumbnail": "https://i.ytimg.com/vi/719xsG7V8Pw/mqdefault.jpg",
    "title": "【歌枠】Let's SING !! 40万人ありがとう！！【アキロゼ/ホロライブ】",
    "publishedAt": "2021-01-09T16:54:30Z"
  },
  {
    "videoId": "7ctuL5CtFGo",
    "thumbnail": "https://i.ytimg.com/vi/7ctuL5CtFGo/mqdefault.jpg",
    "title": "【マリオカート8DX】YABE!!大会直前のガチ練!!【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-10T21:24:52Z"
  },
  {
    "videoId": "yBrdp0x6bxM",
    "thumbnail": "https://i.ytimg.com/vi/yBrdp0x6bxM/mqdefault.jpg",
    "title": "【#ホロお正月CUP】最弱王からの下剋上/Cgroup【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-11T12:36:02Z"
  },
  {
    "videoId": "_KYZRtOP1Fs",
    "thumbnail": "https://i.ytimg.com/vi/_KYZRtOP1Fs/mqdefault.jpg",
    "title": "【マリオカート8DX】視聴者参加で打ち上げレース開催！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-11T17:53:18Z"
  },
  {
    "videoId": "_VKxgnk_PJ8",
    "thumbnail": "https://i.ytimg.com/vi/_VKxgnk_PJ8/mqdefault.jpg",
    "title": "【ARK】復活！！ついにエクステンション本格始動！？【Hololive/アキロゼ】",
    "publishedAt": "2021-01-14T09:45:13Z"
  },
  {
    "videoId": "PVAXh0EyiAA",
    "thumbnail": "https://i.ytimg.com/vi/PVAXh0EyiAA/mqdefault.jpg",
    "title": "【ARK】ほぼ歌枠/Let's SING!!子育てARK【Hololive/アキロゼ】",
    "publishedAt": "2021-01-15T20:20:41Z"
  },
  {
    "videoId": "63OiX135qoM",
    "thumbnail": "https://i.ytimg.com/vi/63OiX135qoM/mqdefault.jpg",
    "title": "【mother simulator】完全初見！絶対キレないママになる【Hololive/Akirose】",
    "publishedAt": "2021-01-19T16:26:23Z"
  },
  {
    "videoId": "ZfUQ_RqKgXw",
    "thumbnail": "https://i.ytimg.com/vi/ZfUQ_RqKgXw/mqdefault.jpg",
    "title": "【mother simulator】完全初見！壮絶育児バトル後半戦【Hololive/Akirose】",
    "publishedAt": "2021-01-20T16:19:21Z"
  },
  {
    "videoId": "KORmm7hB168",
    "thumbnail": "https://i.ytimg.com/vi/KORmm7hB168/mqdefault.jpg",
    "title": "【ARK】クローン製造機を作りたい【Hololive/アキロゼ】",
    "publishedAt": "2021-01-21T07:59:12Z"
  },
  {
    "videoId": "H_WCR_LaLqA",
    "thumbnail": "https://i.ytimg.com/vi/H_WCR_LaLqA/mqdefault.jpg",
    "title": "【モンスターハンターライズDEMO】世界観が守護い！！MONSTER HUNTER RISE !!【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-21T14:54:45Z"
  },
  {
    "videoId": "JFVtF9qVEdI",
    "thumbnail": "https://i.ytimg.com/vi/JFVtF9qVEdI/mqdefault.jpg",
    "title": "【ASMR】癒しの音色カリンバで子守歌 Healing  Kalimba【Hololive/Akirose】",
    "publishedAt": "2021-01-22T16:40:05Z"
  },
  {
    "videoId": "1twSX3XvBDM",
    "thumbnail": "https://i.ytimg.com/vi/1twSX3XvBDM/mqdefault.jpg",
    "title": "【マリオカート8DX/視聴者参加型】7th place or lowerImmediate end【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-23T15:47:21Z"
  },
  {
    "videoId": "8GX0BM-_RRc",
    "thumbnail": "https://i.ytimg.com/vi/8GX0BM-_RRc/mqdefault.jpg",
    "title": "【Teke Teke - テケテケ】都市伝説「テケテケ」に突撃するアキロゼちゃん【Hololive/Akirose】",
    "publishedAt": "2021-01-24T04:29:06Z"
  },
  {
    "videoId": "N0sdrfFUv80",
    "thumbnail": "https://i.ytimg.com/vi/N0sdrfFUv80/mqdefault.jpg",
    "title": "【#ゴリラ宇宙人狼​】超初心者はもともとウホくらいの情報しか言えないので通常運行【アキロゼ視点/ホロライブ】",
    "publishedAt": "2021-01-25T14:01:34Z"
  },
  {
    "videoId": "3Cwtw2f-95c",
    "thumbnail": "https://i.ytimg.com/vi/3Cwtw2f-95c/mqdefault.jpg",
    "title": "【Minecraft】#AKUKIN本社建設リレー​ 正直やばいと思っている【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-25T15:08:24Z"
  },
  {
    "videoId": "y_nAoXWnIr0",
    "thumbnail": "https://i.ytimg.com/vi/y_nAoXWnIr0/mqdefault.jpg",
    "title": "【乾杯雑談】晩酌しよ～！お酒案件きたあああ【Hololive/Akirose",
    "publishedAt": "2021-01-26T18:06:44Z"
  },
  {
    "videoId": "a-LYF3V5V-w",
    "thumbnail": "https://i.ytimg.com/vi/a-LYF3V5V-w/mqdefault.jpg",
    "title": "【Minecraft】Day1/作りたいものみつけた！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-01-28T17:10:32Z"
  },
  {
    "videoId": "M1E5pOJefpU",
    "thumbnail": "https://i.ytimg.com/vi/M1E5pOJefpU/mqdefault.jpg",
    "title": "【ARK】#ムキロゼ生誕祭 1歳になりました！！【Hololive/アキロゼ】",
    "publishedAt": "2021-01-29T08:34:05Z"
  },
  {
    "videoId": "Zvuhp33o--w",
    "thumbnail": "https://i.ytimg.com/vi/Zvuhp33o--w/mqdefault.jpg",
    "title": "【歌枠】Singing stream 【ホロライブ/アキロゼakirose】",
    "publishedAt": "2021-01-31T16:52:21Z"
  },
  {
    "videoId": "aBfh_aJK6TY",
    "thumbnail": "https://i.ytimg.com/vi/aBfh_aJK6TY/mqdefault.jpg",
    "title": "【FREE Talk】コメントなるべく拾いながらお話し& Superchat Reading【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-01T17:23:01Z"
  },
  {
    "videoId": "PLSFufsW8tU",
    "thumbnail": "https://i.ytimg.com/vi/PLSFufsW8tU/mqdefault.jpg",
    "title": "【 #ホロライブ9週連続リリース​ 】『Suspect』Release!!みんなで収録裏話【ホロライブ/ロボ子さん 百鬼あやめ アキロゼ】",
    "publishedAt": "2021-02-02T13:37:32Z"
  },
  {
    "videoId": "HRx3ZL__UiI",
    "thumbnail": "https://i.ytimg.com/vi/HRx3ZL__UiI/mqdefault.jpg",
    "title": "【ASMR/工業・日常系】FIT BOX開封&組み立て！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-03T18:22:10Z"
  },
  {
    "videoId": "Sc0KUhpaxCA",
    "thumbnail": "https://i.ytimg.com/vi/Sc0KUhpaxCA/mqdefault.jpg",
    "title": "【ARK】朝活してみる【Hololive/アキロゼ】",
    "publishedAt": "2021-02-04T22:21:01Z"
  },
  {
    "videoId": "Skjlpy5DTH8",
    "thumbnail": "https://i.ytimg.com/vi/Skjlpy5DTH8/mqdefault.jpg",
    "title": "【ARK】テレポーターを作りたい！【Hololive/アキロゼ】",
    "publishedAt": "2021-02-05T20:47:32Z"
  },
  {
    "videoId": "S21sTdpuXIE",
    "thumbnail": "https://i.ytimg.com/vi/S21sTdpuXIE/mqdefault.jpg",
    "title": "【ARK】FITBOXしながらサバイバル【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-08T09:39:26Z"
  },
  {
    "videoId": "WLbYL2joNc4",
    "thumbnail": "https://i.ytimg.com/vi/WLbYL2joNc4/mqdefault.jpg",
    "title": "【歌枠】Singing stream 【ホロライブ/アキロゼakirose】",
    "publishedAt": "2021-02-09T16:43:44Z"
  },
  {
    "videoId": "NalaYNpsFEU",
    "thumbnail": "https://i.ytimg.com/vi/NalaYNpsFEU/mqdefault.jpg",
    "title": "【歌枠】枠取り直し歌います！！SING stream!!!【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-09T18:11:43Z"
  },
  {
    "videoId": "lq0AWlWebzw",
    "thumbnail": "https://i.ytimg.com/vi/lq0AWlWebzw/mqdefault.jpg",
    "title": "【ARK】#AKICOCO is Destroyer!!!ワイバーンの巣に凸【ホロライブ/桐生ココ&アキロゼ】",
    "publishedAt": "2021-02-10T10:54:34Z"
  },
  {
    "videoId": "E6uMwEJQ1rY",
    "thumbnail": "https://i.ytimg.com/vi/E6uMwEJQ1rY/mqdefault.jpg",
    "title": "【FREE Talk】ライブまであと6日&  Superchat Reading 【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-11T18:47:42Z"
  },
  {
    "videoId": "qYc6l-7Ks9Q",
    "thumbnail": "https://i.ytimg.com/vi/qYc6l-7Ks9Q/mqdefault.jpg",
    "title": "ホロライブ桃鉄10年トライアル決定戦【アキロゼ視点】",
    "publishedAt": "2021-02-13T16:07:44Z"
  },
  {
    "videoId": "QQKLdyO7KbA",
    "thumbnail": "https://i.ytimg.com/vi/QQKLdyO7KbA/mqdefault.jpg",
    "title": "【ASMRあり！？】Happy Valentine💓【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-14T18:52:33Z"
  },
  {
    "videoId": "2HLNdKVU0GM",
    "thumbnail": "https://i.ytimg.com/vi/2HLNdKVU0GM/mqdefault.jpg",
    "title": "【誕生日カウントダウン】Happy BirthDay アキロゼ！一緒に迎えて欲しいな 【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-16T15:45:07Z"
  },
  {
    "videoId": "u4KOc1BImMY",
    "thumbnail": "https://i.ytimg.com/vi/u4KOc1BImMY/mqdefault.jpg",
    "title": "『ヒロインオーディション』発売！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-17T15:29:05Z"
  },
  {
    "videoId": "gLtGTM81tVM",
    "thumbnail": "https://i.ytimg.com/vi/gLtGTM81tVM/mqdefault.jpg",
    "title": "【晩酌】ライブ打ち上げ&感想会【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-18T18:08:56Z"
  },
  {
    "videoId": "1RHGYmMaos0",
    "thumbnail": "https://i.ytimg.com/vi/1RHGYmMaos0/mqdefault.jpg",
    "title": "【完全初見プレイ/First Play】Undertale 【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-22T22:28:46Z"
  },
  {
    "videoId": "OdkuT93Ok_w",
    "thumbnail": "https://i.ytimg.com/vi/OdkuT93Ok_w/mqdefault.jpg",
    "title": "【#ゴリラ宇宙人狼​】超初心者はもともとウホくらいの情報しか言えないので通常運行その２【アキロゼ視点/ホロライブ】",
    "publishedAt": "2021-02-25T14:28:42Z"
  },
  {
    "videoId": "3kWj3Bf2fRw",
    "thumbnail": "https://i.ytimg.com/vi/3kWj3Bf2fRw/mqdefault.jpg",
    "title": "【ARK】西成サーバーにカチコミ！突撃せよ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-26T16:41:59Z"
  },
  {
    "videoId": "-WxOxvDeoVA",
    "thumbnail": "https://i.ytimg.com/vi/-WxOxvDeoVA/mqdefault.jpg",
    "title": "【晩酌】Let's Drink !! お酒飲み比べ💓【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-27T16:10:11Z"
  },
  {
    "videoId": "IXsJQImDCl8",
    "thumbnail": "https://i.ytimg.com/vi/IXsJQImDCl8/mqdefault.jpg",
    "title": "【運動】エアロバイクしながら感謝のSuper chat Reading【ホロライブ/アキロゼ】",
    "publishedAt": "2021-02-28T08:45:47Z"
  },
  {
    "videoId": "tgU4lOdJVGE",
    "thumbnail": "https://i.ytimg.com/vi/tgU4lOdJVGE/mqdefault.jpg",
    "title": "【歌枠】Let's SING!!!!!!1週間ぶりの配信!!!!【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2021-03-08T17:02:23Z"
  },
  {
    "videoId": "HGleB170TfE",
    "thumbnail": "https://i.ytimg.com/vi/HGleB170TfE/mqdefault.jpg",
    "title": "【カニノケンカ-Fight Crab-】カニは美味しい！！！【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2021-03-09T16:59:07Z"
  },
  {
    "videoId": "nQxNGtQof8Y",
    "thumbnail": "https://i.ytimg.com/vi/nQxNGtQof8Y/mqdefault.jpg",
    "title": "【歌枠】歌うぞおお！！SING! SING! SING! 【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2021-03-11T09:05:02Z"
  },
  {
    "videoId": "1gTWJL1nqK8",
    "thumbnail": "https://i.ytimg.com/vi/1gTWJL1nqK8/mqdefault.jpg",
    "title": "【ARK】#ホロARK 緊急コラボ!!赤OSD戦でお宝GETしまくれ！【ホロライブ/癒月ちょこ/桐生ココ/尾丸ポルカ/アキロゼ】",
    "publishedAt": "2021-03-11T16:51:13Z"
  },
  {
    "videoId": "j72-0fU32Dw",
    "thumbnail": "https://i.ytimg.com/vi/j72-0fU32Dw/mqdefault.jpg",
    "title": "【#ホロARK】森の守護者フォレストタイタンをテイム！？【ホロライブ/癒月ちょこ/桐生ココ/アキロゼ】",
    "publishedAt": "2021-03-16T14:24:36Z"
  },
  {
    "videoId": "1Ts7X3vtYgQ",
    "thumbnail": "https://i.ytimg.com/vi/1Ts7X3vtYgQ/mqdefault.jpg",
    "title": "【#アキロゼ生誕祭2021 #AkiRoseBirthday2021】初アイドル衣装で3D生誕祭だ～！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-03-17T13:08:57Z"
  },
  {
    "videoId": "eN--w_NA6hs",
    "thumbnail": "https://i.ytimg.com/vi/eN--w_NA6hs/mqdefault.jpg",
    "title": "【Original】ヒロインオーディション 3DMV【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2021-03-17T13:15:18Z"
  },
  {
    "videoId": "ImG9CAyR5Kg",
    "thumbnail": "https://i.ytimg.com/vi/ImG9CAyR5Kg/mqdefault.jpg",
    "title": "【おうち3D】ゲリラFree Talk配信！生誕祭ありがとう！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-03-20T18:40:48Z"
  },
  {
    "videoId": "nH32kTt1NoU",
    "thumbnail": "https://i.ytimg.com/vi/nH32kTt1NoU/mqdefault.jpg",
    "title": "【#ホロ酒呑み組】オンライン飲み会開催なんだよ～【ホロライブ/白銀ノエル/雪花ラミィ/アキロゼ】",
    "publishedAt": "2021-03-22T14:31:48Z"
  },
  {
    "videoId": "S6kXAzNbG-4",
    "thumbnail": "https://i.ytimg.com/vi/S6kXAzNbG-4/mqdefault.jpg",
    "title": "【Belly Dance Akirose】月と太陽のめぐり【ホロライブ/ #アキロゼ】",
    "publishedAt": "2021-03-23T10:16:28Z"
  },
  {
    "videoId": "hCf-ml4AFb4",
    "thumbnail": "https://i.ytimg.com/vi/hCf-ml4AFb4/mqdefault.jpg",
    "title": "ビギナーポケモントレーナーの戦い1日目-追加DLCで伝説ポケモン欲しい！-【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-03-23T18:03:48Z"
  },
  {
    "videoId": "veytPh3toQQ",
    "thumbnail": "https://i.ytimg.com/vi/veytPh3toQQ/mqdefault.jpg",
    "title": "ビギナーポケモントレーナーの戦い2日目-追加DLCで伝説ポケモン欲しい！-【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-03-25T09:05:33Z"
  },
  {
    "videoId": "5QeUwqJaDDk",
    "thumbnail": "https://i.ytimg.com/vi/5QeUwqJaDDk/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】最新作のモンハンライズに突入だ！！【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-03-25T19:28:36Z"
  },
  {
    "videoId": "1dC1n93iva0",
    "thumbnail": "https://i.ytimg.com/vi/1dC1n93iva0/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】1時間限定!!モンハンライズ2日目【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-03-27T07:29:09Z"
  },
  {
    "videoId": "eF8fFEbhKes",
    "thumbnail": "https://i.ytimg.com/vi/eF8fFEbhKes/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】視聴者参加OK！ガンランスでいく！モンハンライズ3日目【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-04-04T20:05:49Z"
  },
  {
    "videoId": "THmgbnMkTXw",
    "thumbnail": "https://i.ytimg.com/vi/THmgbnMkTXw/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】視聴者参加OK！ガンランスでいく！モンハンライズ4日目【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-04-08T19:35:43Z"
  },
  {
    "videoId": "9uNwNT88xV4",
    "thumbnail": "https://i.ytimg.com/vi/9uNwNT88xV4/mqdefault.jpg",
    "title": "1曲まるっと振付レクチャー！！『ヒロインオーディション』Choreography lessons【ホロライブ/アキロゼ】",
    "publishedAt": "2021-04-10T14:38:05Z"
  },
  {
    "videoId": "-KSkoPaIzn4",
    "thumbnail": "https://i.ytimg.com/vi/-KSkoPaIzn4/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】百竜夜行いく！！モンハンライズ5日目【ホロライブ/#アキロゼ】",
    "publishedAt": "2021-04-10T17:08:20Z"
  },
  {
    "videoId": "iM8vuusxJGs",
    "thumbnail": "https://i.ytimg.com/vi/iM8vuusxJGs/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】#あんぽんたん姉妹 は一流ハンターになれるのか？！モンハンライズ【ホロライブ/アキロゼ視点】",
    "publishedAt": "2021-04-11T13:27:16Z"
  },
  {
    "videoId": "Tw-YyUPf528",
    "thumbnail": "https://i.ytimg.com/vi/Tw-YyUPf528/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】マリン船長を上位に連れて行く！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2021-04-16T10:14:04Z"
  },
  {
    "videoId": "oY0Wt7QJ-HE",
    "thumbnail": "https://i.ytimg.com/vi/oY0Wt7QJ-HE/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】誰が一番こんがり肉をバレずに焼けるか選手権【ホロライブ/アキロゼ視点】",
    "publishedAt": "2021-04-16T13:19:21Z"
  },
  {
    "videoId": "38Gm6opkdJQ",
    "thumbnail": "https://i.ytimg.com/vi/38Gm6opkdJQ/mqdefault.jpg",
    "title": "【雑談/Free Talk】オフコラボ話とかいろんな話【ホロライブ/アキロゼ】",
    "publishedAt": "2021-04-19T17:52:51Z"
  },
  {
    "videoId": "jGUfo-t4ocA",
    "thumbnail": "https://i.ytimg.com/vi/jGUfo-t4ocA/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】上位ガンランス武器と防具作る！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-04-23T22:54:36Z"
  },
  {
    "videoId": "nDPBcY30ErI",
    "thumbnail": "https://i.ytimg.com/vi/nDPBcY30ErI/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】TakoAki ラブラブHunting 【ホロライブ/Ninomae Ina'nis/アキロゼ】",
    "publishedAt": "2021-04-24T02:09:18Z"
  },
  {
    "videoId": "58wRREr9fz4",
    "thumbnail": "https://i.ytimg.com/vi/58wRREr9fz4/mqdefault.jpg",
    "title": "【ASMR】癒し音色カリンバで睡眠導入 Healing Kalimba【Hololive/Akirose】",
    "publishedAt": "2021-04-26T20:24:06Z"
  },
  {
    "videoId": "RKYk5oeuie8",
    "thumbnail": "https://i.ytimg.com/vi/RKYk5oeuie8/mqdefault.jpg",
    "title": "【Meat Beating: No More Horny】最強の肉叩き王になる！！【Hololive/Akirose】",
    "publishedAt": "2021-04-27T17:18:01Z"
  },
  {
    "videoId": "JB6Aw9VxW2s",
    "thumbnail": "https://i.ytimg.com/vi/JB6Aw9VxW2s/mqdefault.jpg",
    "title": "アキロゼ家に届いたプレゼントとは！？【Hololive/Akirose】",
    "publishedAt": "2021-04-28T15:07:37Z"
  },
  {
    "videoId": "LMUJ0b1QtWE",
    "thumbnail": "https://i.ytimg.com/vi/LMUJ0b1QtWE/mqdefault.jpg",
    "title": "【雑談/FreeTalk】キャンプ飯は最高って話【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-03T06:10:37Z"
  },
  {
    "videoId": "mdJ4KBC0bvo",
    "thumbnail": "https://i.ytimg.com/vi/mdJ4KBC0bvo/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】里クエストソロ攻略目指す！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-03T10:13:50Z"
  },
  {
    "videoId": "kQRPKNrjQcI",
    "thumbnail": "https://i.ytimg.com/vi/kQRPKNrjQcI/mqdefault.jpg",
    "title": "64人でバトル！？スーパーボンバーマン R オンライン【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-03T11:12:19Z"
  },
  {
    "videoId": "AEoRx6hxcrY",
    "thumbnail": "https://i.ytimg.com/vi/AEoRx6hxcrY/mqdefault.jpg",
    "title": "【Newポケモンスナップ】GWだ、写真をとろう【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-03T15:09:15Z"
  },
  {
    "videoId": "m1PaR-od4Dw",
    "thumbnail": "https://i.ytimg.com/vi/m1PaR-od4Dw/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】集会所★７攻略に向けてガンランス装備作る！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-04T11:19:50Z"
  },
  {
    "videoId": "VcyoS8iQzMI",
    "thumbnail": "https://i.ytimg.com/vi/VcyoS8iQzMI/mqdefault.jpg",
    "title": "【視聴者とガチバトル】50万人突破するまでモノポリーやめれません！！#Rosetai500k【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-04T17:05:38Z"
  },
  {
    "videoId": "6V0wX6ITVuE",
    "thumbnail": "https://i.ytimg.com/vi/6V0wX6ITVuE/mqdefault.jpg",
    "title": "【雑談】感謝のSuper Chat Reading【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-06T16:34:28Z"
  },
  {
    "videoId": "YkLMO2YaDPw",
    "thumbnail": "https://i.ytimg.com/vi/YkLMO2YaDPw/mqdefault.jpg",
    "title": "【雑談】50万人耐久の感謝Super Chat Reading【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-07T19:23:25Z"
  },
  {
    "videoId": "NxhNKX3uOxs",
    "thumbnail": "https://i.ytimg.com/vi/NxhNKX3uOxs/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】集会所★７クエストソロ攻略目指す！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-08T10:51:50Z"
  },
  {
    "videoId": "W7fIQ3mJ6xk",
    "thumbnail": "https://i.ytimg.com/vi/W7fIQ3mJ6xk/mqdefault.jpg",
    "title": "【歌枠】Let's SINGING ！！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-10T17:33:58Z"
  },
  {
    "videoId": "L0PeIWaPNTM",
    "thumbnail": "https://i.ytimg.com/vi/L0PeIWaPNTM/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】視聴者参加タイムあり！HRを上げていく！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-12T17:53:19Z"
  },
  {
    "videoId": "k8Tucgs070s",
    "thumbnail": "https://i.ytimg.com/vi/k8Tucgs070s/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】極貧ガンランサーのハンター生活【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-13T17:02:39Z"
  },
  {
    "videoId": "8D6ABOXWSJY",
    "thumbnail": "https://i.ytimg.com/vi/8D6ABOXWSJY/mqdefault.jpg",
    "title": "【モーリーオンライン】1時間でおかころグッズ何個とれるか！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-14T12:37:17Z"
  },
  {
    "videoId": "rL0L1FPRGbw",
    "thumbnail": "https://i.ytimg.com/vi/rL0L1FPRGbw/mqdefault.jpg",
    "title": "【いたストで大金持ちを目指す！】初挑戦！！いただきストリート ドラゴンクエスト&ファイナルファンタジー 【アキロゼ/ホロライブ】",
    "publishedAt": "2021-05-15T10:57:14Z"
  },
  {
    "videoId": "ZK87w5wAaMI",
    "thumbnail": "https://i.ytimg.com/vi/ZK87w5wAaMI/mqdefault.jpg",
    "title": "【Newポケモンスナップ】アキロゼ解釈で進めるカメラマン道【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-16T17:44:39Z"
  },
  {
    "videoId": "Vxjo_UbLFRs",
    "thumbnail": "https://i.ytimg.com/vi/Vxjo_UbLFRs/mqdefault.jpg",
    "title": "【ARK ╎Extinction】初めてのエクスティンクションに弾丸観光！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-17T06:54:49Z"
  },
  {
    "videoId": "-wVqPtjbxPE",
    "thumbnail": "https://i.ytimg.com/vi/-wVqPtjbxPE/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】25分以内！初見テオテスカトル討伐チャレンジ【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-18T13:08:01Z"
  },
  {
    "videoId": "GryGhHZZmow",
    "thumbnail": "https://i.ytimg.com/vi/GryGhHZZmow/mqdefault.jpg",
    "title": "【乾杯雑談】Drinking stream！最近の話するよ～！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-18T18:20:29Z"
  },
  {
    "videoId": "lcN5fo0gQb8",
    "thumbnail": "https://i.ytimg.com/vi/lcN5fo0gQb8/mqdefault.jpg",
    "title": "【歌枠】胸キュン歌枠！Heartful Song【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-19T13:12:41Z"
  },
  {
    "videoId": "lVvSu1pFEWk",
    "thumbnail": "https://i.ytimg.com/vi/lVvSu1pFEWk/mqdefault.jpg",
    "title": "【VRホラー実況】※大絶叫不可避 Home Sweet home【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-21T13:56:26Z"
  },
  {
    "videoId": "_MOxKjYuO4c",
    "thumbnail": "https://i.ytimg.com/vi/_MOxKjYuO4c/mqdefault.jpg",
    "title": "【ASMR解禁！】涼しさを感じる音と耳かきでリラックス安眠【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-23T15:55:19Z"
  },
  {
    "videoId": "8V6tABqkbWk",
    "thumbnail": "https://i.ytimg.com/vi/8V6tABqkbWk/mqdefault.jpg",
    "title": "【乾杯雑談】麦ジュース飲みながらお話し♬【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-24T17:56:56Z"
  },
  {
    "videoId": "TUHtS1_tsHQ",
    "thumbnail": "https://i.ytimg.com/vi/TUHtS1_tsHQ/mqdefault.jpg",
    "title": "【作業配信】Work stream!サインを描くのを見守る枠【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-25T18:27:54Z"
  },
  {
    "videoId": "Pl7IEelhwow",
    "thumbnail": "https://i.ytimg.com/vi/Pl7IEelhwow/mqdefault.jpg",
    "title": "【#from1st前夜祭】1期生歌枠リレーで明日へつなげ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2021-05-27T13:08:40Z"
  },
  {
    "videoId": "8wn7JqJT8Gs",
    "thumbnail": "https://i.ytimg.com/vi/8wn7JqJT8Gs/mqdefault.jpg",
    "title": "【Free Chat Room】ライブ盛り上がっていこ〜！感想枠もここでやるよ！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-28T18:16:47Z"
  },
  {
    "videoId": "lpiIp_QwcgU",
    "thumbnail": "https://i.ytimg.com/vi/lpiIp_QwcgU/mqdefault.jpg",
    "title": "【3rd Anniversary】3周年記年へカウントダウン！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-05-31T15:17:30Z"
  },
  {
    "videoId": "ps-b1fFd4c8",
    "thumbnail": "https://i.ytimg.com/vi/ps-b1fFd4c8/mqdefault.jpg",
    "title": "【ホロライブ1期生】#6月1日デビュー組 大集合！！【白上フブキ/夏色まつり/アキ・ローゼンタール】",
    "publishedAt": "2021-05-31T16:09:44Z"
  },
  {
    "videoId": "yzTtttxMxYY",
    "thumbnail": "https://i.ytimg.com/vi/yzTtttxMxYY/mqdefault.jpg",
    "title": "【3rd Anniversary】#アキロゼ3周年 記念配信だー！！！歌ライブでお祝いだ！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2021-06-01T15:19:15Z"
  },
  {
    "videoId": "ooMv898Mmn4",
    "thumbnail": "https://i.ytimg.com/vi/ooMv898Mmn4/mqdefault.jpg",
    "title": "【視聴者参加型】一緒にレベル上げしよ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2021-06-03T18:34:15Z"
  },
  {
    "videoId": "yUwB8codUPo",
    "thumbnail": "https://i.ytimg.com/vi/yUwB8codUPo/mqdefault.jpg",
    "title": "【雑談/Free Talk】昼活！！お話ししながらSuper Chat Reading【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-04T07:18:49Z"
  },
  {
    "videoId": "UUS2cWVso8U",
    "thumbnail": "https://i.ytimg.com/vi/UUS2cWVso8U/mqdefault.jpg",
    "title": "【#カプとれ】トワぴ！アキロゼの家においでよ！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-07T13:24:33Z"
  },
  {
    "videoId": "HxhJIyWL9GU",
    "thumbnail": "https://i.ytimg.com/vi/HxhJIyWL9GU/mqdefault.jpg",
    "title": "【ASMR】氷、炭酸、水の音で感じる涼しさでリラックス安眠Deep Sleep &relax&Get cool【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-08T16:28:54Z"
  },
  {
    "videoId": "obLMU_lmVxU",
    "thumbnail": "https://i.ytimg.com/vi/obLMU_lmVxU/mqdefault.jpg",
    "title": "【ARK-Genesis2-】ムキロゼ新MAPのぞき弾丸旅行！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-11T19:05:51Z"
  },
  {
    "videoId": "0PLpEHHyVf8",
    "thumbnail": "https://i.ytimg.com/vi/0PLpEHHyVf8/mqdefault.jpg",
    "title": "【ASMR】木のオルゴール/オルガニートゆっくり演奏Deep Sleep & relax【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-12T16:11:24Z"
  },
  {
    "videoId": "MFl7xd2GlTM",
    "thumbnail": "https://i.ytimg.com/vi/MFl7xd2GlTM/mqdefault.jpg",
    "title": "【例外配達|Night Delivery】シリーズ１怖い？！伝説の配達人ですが絶叫のプロなので大絶叫不可避【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-15T17:25:50Z"
  },
  {
    "videoId": "8hFWqxVbhrA",
    "thumbnail": "https://i.ytimg.com/vi/8hFWqxVbhrA/mqdefault.jpg",
    "title": "【ARK:Crystal isles】ムキロゼS〇SUKEパーク作りたい【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-16T19:37:25Z"
  },
  {
    "videoId": "f2iw5HqyxgQ",
    "thumbnail": "https://i.ytimg.com/vi/f2iw5HqyxgQ/mqdefault.jpg",
    "title": "【同時視聴】神 VS 人間の最終決戦！？アニメ「終末のワルキューレ」第1話一緒にみよう！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-18T10:54:04Z"
  },
  {
    "videoId": "OSviQ0etZcU",
    "thumbnail": "https://i.ytimg.com/vi/OSviQ0etZcU/mqdefault.jpg",
    "title": "【モーリーオンライン】夏色フブキをGETせよ！【ホロライブ/夜空メル×アキロゼ】",
    "publishedAt": "2021-06-23T11:55:38Z"
  },
  {
    "videoId": "yk_2KAbLxTY",
    "thumbnail": "https://i.ytimg.com/vi/yk_2KAbLxTY/mqdefault.jpg",
    "title": "一般観光客A、うさ建夏祭り観光へ行く。【ホロライブ/ロボ子さん アキロゼ】",
    "publishedAt": "2021-06-27T17:38:10Z"
  },
  {
    "videoId": "QP-caiSnm2Q",
    "thumbnail": "https://i.ytimg.com/vi/QP-caiSnm2Q/mqdefault.jpg",
    "title": "BLACK SHOUT/Roselia【 Coverd by ロボ子さん&アキロゼ】",
    "publishedAt": "2021-06-29T09:30:12Z"
  },
  {
    "videoId": "cR3DKLWGoAo",
    "thumbnail": "https://i.ytimg.com/vi/cR3DKLWGoAo/mqdefault.jpg",
    "title": "【Keep Talking and Nobody Explodes】ミッション：爆弾解除し同時視聴せよ！【ホロライブ/ロボ子さん・アキロゼ】",
    "publishedAt": "2021-06-29T10:32:22Z"
  },
  {
    "videoId": "cywyvUW4F_k",
    "thumbnail": "https://i.ytimg.com/vi/cywyvUW4F_k/mqdefault.jpg",
    "title": "【おうち3D歌枠】Acoustic Session Live 6th【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-29T14:20:42Z"
  },
  {
    "videoId": "tARo09yaF8k",
    "thumbnail": "https://i.ytimg.com/vi/tARo09yaF8k/mqdefault.jpg",
    "title": "【ARK:Crystal isles】ムキロゼパーク完成させてお祭りだ！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-30T10:01:06Z"
  },
  {
    "videoId": "ekSffO0n9nA",
    "thumbnail": "https://i.ytimg.com/vi/ekSffO0n9nA/mqdefault.jpg",
    "title": "【ARK:Crystal isles】視聴者鯖観光からのホロ鯖ムキロゼパークで豪遊【ホロライブ/アキロゼ】",
    "publishedAt": "2021-06-30T14:40:57Z"
  },
  {
    "videoId": "udfd3sHudLg",
    "thumbnail": "https://i.ytimg.com/vi/udfd3sHudLg/mqdefault.jpg",
    "title": "【重大発表】復活！はやく見せたいアキロゼちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-10T04:01:20Z"
  },
  {
    "videoId": "MFS9RZDaHIM",
    "thumbnail": "https://i.ytimg.com/vi/MFS9RZDaHIM/mqdefault.jpg",
    "title": "血沸き肉躍る熱き戦い-後半戦-【#ちまつりお清楚ゴリラ】",
    "publishedAt": "2021-07-10T11:40:39Z"
  },
  {
    "videoId": "acMdi_OMnZ8",
    "thumbnail": "https://i.ytimg.com/vi/acMdi_OMnZ8/mqdefault.jpg",
    "title": "【ARKムキロゼサーバー】おいでよ！視聴者サーバー！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-11T00:04:28Z"
  },
  {
    "videoId": "CnRI1kreeZ8",
    "thumbnail": "https://i.ytimg.com/vi/CnRI1kreeZ8/mqdefault.jpg",
    "title": "【Subnautica】完全初見！海洋サバイバルで生き残れ Part1【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-15T16:29:55Z"
  },
  {
    "videoId": "o868TURUNrI",
    "thumbnail": "https://i.ytimg.com/vi/o868TURUNrI/mqdefault.jpg",
    "title": "【Subnautica】完全初見！海洋サバイバルで生き残れ Part2【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-16T18:50:29Z"
  },
  {
    "videoId": "NV1ppOQOkFc",
    "thumbnail": "https://i.ytimg.com/vi/NV1ppOQOkFc/mqdefault.jpg",
    "title": "【Knockout City】EN vs JP ドッジボールで勝負！！#holododgeball【ホロライブ/アキロゼ視点】",
    "publishedAt": "2021-07-17T11:13:19Z"
  },
  {
    "videoId": "oKuTBHj7hkY",
    "thumbnail": "https://i.ytimg.com/vi/oKuTBHj7hkY/mqdefault.jpg",
    "title": "【Subnautica】完全初見！海洋サバイバルで生き残れ Part3【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-17T15:56:34Z"
  },
  {
    "videoId": "yuvv82uFMf4",
    "thumbnail": "https://i.ytimg.com/vi/yuvv82uFMf4/mqdefault.jpg",
    "title": "【Subnautica】完全初見！救助くるらしい！？ Part4【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-18T18:13:38Z"
  },
  {
    "videoId": "zUaI5EAcDXs",
    "thumbnail": "https://i.ytimg.com/vi/zUaI5EAcDXs/mqdefault.jpg",
    "title": "【Subnautica】完全初見！ついに水深300m超え！！ Part5【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-19T17:21:15Z"
  },
  {
    "videoId": "zxQAYfUYP3Y",
    "thumbnail": "https://i.ytimg.com/vi/zxQAYfUYP3Y/mqdefault.jpg",
    "title": "話す【ホロライブ/アキロゼ】",
    "publishedAt": "2021-07-28T14:54:34Z"
  },
  {
    "videoId": "lioS-IaBx9Q",
    "thumbnail": "https://i.ytimg.com/vi/lioS-IaBx9Q/mqdefault.jpg",
    "title": "【Minecraft】マイクラ1年生！目指せ初エンドラ討伐に向けて【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-07T17:14:04Z"
  },
  {
    "videoId": "E2JX5AdYhYs",
    "thumbnail": "https://i.ytimg.com/vi/E2JX5AdYhYs/mqdefault.jpg",
    "title": "【Subnautica】完全初見！深海の謎に迫る！？ Part6【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-08T18:45:11Z"
  },
  {
    "videoId": "po_BSkIuGCs",
    "thumbnail": "https://i.ytimg.com/vi/po_BSkIuGCs/mqdefault.jpg",
    "title": "【Minecraft】マイクラ1年生！目指せ初エンドラ討伐Part2【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-09T20:23:12Z"
  },
  {
    "videoId": "U_DlIYINaR4",
    "thumbnail": "https://i.ytimg.com/vi/U_DlIYINaR4/mqdefault.jpg",
    "title": "【Minecraft】マイクラ1年生！ネザーの世界へ行く！！Part3【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-14T17:34:38Z"
  },
  {
    "videoId": "aUSSC2Ql6WQ",
    "thumbnail": "https://i.ytimg.com/vi/aUSSC2Ql6WQ/mqdefault.jpg",
    "title": "【Free Talk】スパチャもリアタイで読みつつ色んな話！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-16T05:07:32Z"
  },
  {
    "videoId": "X5I4cijrqE4",
    "thumbnail": "https://i.ytimg.com/vi/X5I4cijrqE4/mqdefault.jpg",
    "title": "【Minecraft】マイクラ1年生！ネザー要塞見つけたけど帰れないPart4【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-17T17:06:50Z"
  },
  {
    "videoId": "OTXVB2MGBIA",
    "thumbnail": "https://i.ytimg.com/vi/OTXVB2MGBIA/mqdefault.jpg",
    "title": "【Subnautica】深海探索で大冒険 Part7【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-18T16:28:40Z"
  },
  {
    "videoId": "gHqWi-Qyny4",
    "thumbnail": "https://i.ytimg.com/vi/gHqWi-Qyny4/mqdefault.jpg",
    "title": "【ARKムキロゼサーバー】開設1か月！どんな生活してるん？【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-19T15:54:56Z"
  },
  {
    "videoId": "iOZUxoertso",
    "thumbnail": "https://i.ytimg.com/vi/iOZUxoertso/mqdefault.jpg",
    "title": "【Free Talk】ガチ恋距離！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-26T15:07:01Z"
  },
  {
    "videoId": "FCXW3PEZqyM",
    "thumbnail": "https://i.ytimg.com/vi/FCXW3PEZqyM/mqdefault.jpg",
    "title": "【マリオカート8DX】#ゆるホロチームカート 奇跡を信じよ【アキロゼ/ホロライブ】",
    "publishedAt": "2021-08-27T13:15:26Z"
  },
  {
    "videoId": "_NYe4bYT-Lg",
    "thumbnail": "https://i.ytimg.com/vi/_NYe4bYT-Lg/mqdefault.jpg",
    "title": "【Minecraft】マイクラ1年生！はじめて作るエンチャント部屋！Part5【ホロライブ/アキロゼ】",
    "publishedAt": "2021-08-29T18:40:39Z"
  },
  {
    "videoId": "gAnn8e0_i6M",
    "thumbnail": "https://i.ytimg.com/vi/gAnn8e0_i6M/mqdefault.jpg",
    "title": "PYON PYON #shorts",
    "publishedAt": "2021-08-30T16:29:58Z"
  },
  {
    "videoId": "XpTOljWYlh0",
    "thumbnail": "https://i.ytimg.com/vi/XpTOljWYlh0/mqdefault.jpg",
    "title": "【同時視聴】一緒にみよー！！FF7アドベントチルドレン【Hololive/Akirose】",
    "publishedAt": "2021-09-01T16:58:29Z"
  },
  {
    "videoId": "usG6ZK24L3Q",
    "thumbnail": "https://i.ytimg.com/vi/usG6ZK24L3Q/mqdefault.jpg",
    "title": "【アキロゼVS視聴者】ゲリラ！7位以下で即配信終了！！【マリオカート8DX】",
    "publishedAt": "2021-09-02T14:56:44Z"
  },
  {
    "videoId": "hWboOojIqW8",
    "thumbnail": "https://i.ytimg.com/vi/hWboOojIqW8/mqdefault.jpg",
    "title": "【アキロゼ視点】声が聞こえる！？いい声で鳴いてね【ホロライブ/#ホロAmongUs】",
    "publishedAt": "2021-09-05T15:59:50Z"
  },
  {
    "videoId": "7bVufHdSZWQ",
    "thumbnail": "https://i.ytimg.com/vi/7bVufHdSZWQ/mqdefault.jpg",
    "title": "【Minecraft】一緒に暮らそうね？ゾンビさん💕Part6【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-08T18:07:06Z"
  },
  {
    "videoId": "J_gTsNHZDrs",
    "thumbnail": "https://i.ytimg.com/vi/J_gTsNHZDrs/mqdefault.jpg",
    "title": "【Minecraft】エンチャントガチャ！これが沼？Part7【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-10T15:10:22Z"
  },
  {
    "videoId": "tRwvJA8eyxQ",
    "thumbnail": "https://i.ytimg.com/vi/tRwvJA8eyxQ/mqdefault.jpg",
    "title": "【Phasmophobia】ホラゲビビり組の悲鳴無限連鎖編【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-11T16:46:01Z"
  },
  {
    "videoId": "7Ow4RbGoFow",
    "thumbnail": "https://i.ytimg.com/vi/7Ow4RbGoFow/mqdefault.jpg",
    "title": "【Free Talk】おまた千手観音✋【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-18T15:41:15Z"
  },
  {
    "videoId": "Gklw3Nl3C3c",
    "thumbnail": "https://i.ytimg.com/vi/Gklw3Nl3C3c/mqdefault.jpg",
    "title": "【マリオカート8DX】#ゆるホロチームカート 補助輪つけない！【アキロゼ/ホロライブ】",
    "publishedAt": "2021-09-19T13:18:12Z"
  },
  {
    "videoId": "Ef_ort3l-VU",
    "thumbnail": "https://i.ytimg.com/vi/Ef_ort3l-VU/mqdefault.jpg",
    "title": "【Gartic Phone】視聴者参加型！愛があれば伝わるよね？【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-19T15:20:52Z"
  },
  {
    "videoId": "0ogdCMJ2Igw",
    "thumbnail": "https://i.ytimg.com/vi/0ogdCMJ2Igw/mqdefault.jpg",
    "title": "【Monopoly】カジノアキロゼへようこそ【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-22T19:12:20Z"
  },
  {
    "videoId": "BGh-e0xm8Fc",
    "thumbnail": "https://i.ytimg.com/vi/BGh-e0xm8Fc/mqdefault.jpg",
    "title": "【マリオカート8DX】トワぴにマリカの極意を教えてもらう！【アキロゼ/ホロライブ】",
    "publishedAt": "2021-09-25T12:18:28Z"
  },
  {
    "videoId": "oD_VDqumDY8",
    "thumbnail": "https://i.ytimg.com/vi/oD_VDqumDY8/mqdefault.jpg",
    "title": "【Knockout City】ドッジしようぜ！！！#バカタレVSあんシス【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-27T14:45:07Z"
  },
  {
    "videoId": "s6xC3ZEoOb0",
    "thumbnail": "https://i.ytimg.com/vi/s6xC3ZEoOb0/mqdefault.jpg",
    "title": "【Minecraft】ゲリラ！雑談しながらレベリング【ホロライブ/アキロゼ】",
    "publishedAt": "2021-09-28T17:48:26Z"
  },
  {
    "videoId": "fL_yxawvCGc",
    "thumbnail": "https://i.ytimg.com/vi/fL_yxawvCGc/mqdefault.jpg",
    "title": "【マリオカート8DX】やっぱアクセルは足で踏んでなんぼでしょ！【アキロゼ/ホロライブ】",
    "publishedAt": "2021-09-30T15:10:45Z"
  },
  {
    "videoId": "-WgZHAI-FCA",
    "thumbnail": "https://i.ytimg.com/vi/-WgZHAI-FCA/mqdefault.jpg",
    "title": "【#ホロハンコンマリカ】愛と涙のレース！！【アキロゼ/ホロライブ】",
    "publishedAt": "2021-10-01T12:06:31Z"
  },
  {
    "videoId": "VApkDoBFUSo",
    "thumbnail": "https://i.ytimg.com/vi/VApkDoBFUSo/mqdefault.jpg",
    "title": "【Minecraft】初挑戦！エンドラ討伐チャレンジ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-10-04T17:24:51Z"
  },
  {
    "videoId": "rlXznIzQN54",
    "thumbnail": "https://i.ytimg.com/vi/rlXznIzQN54/mqdefault.jpg",
    "title": "【Minecraft】スーパーゲリラ！地獄のネザー要塞再び！タスケテ【ホロライブ/アキロゼ】",
    "publishedAt": "2021-10-07T18:42:49Z"
  },
  {
    "videoId": "wY4ptBSga5Y",
    "thumbnail": "https://i.ytimg.com/vi/wY4ptBSga5Y/mqdefault.jpg",
    "title": "【Minecraft】いよいよ初心者のエンダードラゴン挑戦がはじまる！！【ホロライブ/アキロゼ】",
    "publishedAt": "2021-10-08T02:51:32Z"
  },
  {
    "videoId": "T3VxM1ae9uM",
    "thumbnail": "https://i.ytimg.com/vi/T3VxM1ae9uM/mqdefault.jpg",
    "title": "daze/じん ft.メイリア from GARNiDELiA//アキ・ローゼンタール(cover)",
    "publishedAt": "2021-10-11T12:30:13Z"
  },
  {
    "videoId": "z6D1hB-LlTY",
    "thumbnail": "https://i.ytimg.com/vi/z6D1hB-LlTY/mqdefault.jpg",
    "title": "【#アキロゼ新衣装】ゲーム？スポーティー？キャンプ？！とにかく可愛い！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-10-11T12:36:53Z"
  },
  {
    "videoId": "MbvCR30376M",
    "thumbnail": "https://i.ytimg.com/vi/MbvCR30376M/mqdefault.jpg",
    "title": "【カメラあり/開封】ヴァイスシュヴァルツコラボカードで神引きしたい！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-10-16T14:25:00Z"
  },
  {
    "videoId": "1F05CmkEb5Y",
    "thumbnail": "https://i.ytimg.com/vi/1F05CmkEb5Y/mqdefault.jpg",
    "title": "【マリオカート8DX】走りで勝負だ！#バカタレVSあんシス【ホロライブ/アキロゼ】",
    "publishedAt": "2021-10-18T14:11:09Z"
  },
  {
    "videoId": "FUKrQdrYi5w",
    "thumbnail": "https://i.ytimg.com/vi/FUKrQdrYi5w/mqdefault.jpg",
    "title": "【カメラあり/開封】ホロプロチョコ10箱チャレンジ！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-10-20T15:11:54Z"
  },
  {
    "videoId": "riJpUaTuMoc",
    "thumbnail": "https://i.ytimg.com/vi/riJpUaTuMoc/mqdefault.jpg",
    "title": "！？？？？？？？？？【アキロゼ/ホロライブ】",
    "publishedAt": "2021-10-21T15:52:59Z"
  },
  {
    "videoId": "yV_7GcHTiAY",
    "thumbnail": "https://i.ytimg.com/vi/yV_7GcHTiAY/mqdefault.jpg",
    "title": "【Splatoon 2】スプラで遊びたいよね！？【アキロゼ/ホロライブ】",
    "publishedAt": "2021-10-22T18:16:20Z"
  },
  {
    "videoId": "vojr6UfgW0E",
    "thumbnail": "https://i.ytimg.com/vi/vojr6UfgW0E/mqdefault.jpg",
    "title": "【歌枠/SIng live】アキロゼ60万人耐久！歌え！！！！！！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-10-26T15:55:13Z"
  },
  {
    "videoId": "Nv8BeUKyKUk",
    "thumbnail": "https://i.ytimg.com/vi/Nv8BeUKyKUk/mqdefault.jpg",
    "title": "【カメラあり】60万人感謝記念！いったい何ができる？？【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-10-28T16:29:01Z"
  },
  {
    "videoId": "on2UpyS-T_0",
    "thumbnail": "https://i.ytimg.com/vi/on2UpyS-T_0/mqdefault.jpg",
    "title": "【笑ったら即終了】今宵はハッピーナイト🎃【アキロゼ/ホロライブ】",
    "publishedAt": "2021-10-30T15:39:55Z"
  },
  {
    "videoId": "YFyR_2M1nJ0",
    "thumbnail": "https://i.ytimg.com/vi/YFyR_2M1nJ0/mqdefault.jpg",
    "title": "【歌枠/SIng live】秋の夜長に歌うよ【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-11-02T17:26:36Z"
  },
  {
    "videoId": "BVl_oFTbnIY",
    "thumbnail": "https://i.ytimg.com/vi/BVl_oFTbnIY/mqdefault.jpg",
    "title": "【Minecraft】運動会場でLet's play!!【ホロライブ/アキロゼ】",
    "publishedAt": "2021-11-08T16:40:48Z"
  },
  {
    "videoId": "beBzxqrrg8g",
    "thumbnail": "https://i.ytimg.com/vi/beBzxqrrg8g/mqdefault.jpg",
    "title": "【Splatoon 2】スプラ対決！！あんシスVSバカタレ【アキロゼ視点/ホロライブ】",
    "publishedAt": "2021-11-10T13:59:50Z"
  },
  {
    "videoId": "Iggf-g24JbQ",
    "thumbnail": "https://i.ytimg.com/vi/Iggf-g24JbQ/mqdefault.jpg",
    "title": "【雑談/Free talk】あのね！最近ね！！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-11-17T16:59:02Z"
  },
  {
    "videoId": "wsjnXprqba0",
    "thumbnail": "https://i.ytimg.com/vi/wsjnXprqba0/mqdefault.jpg",
    "title": "【Gartic Phone】おえかき伝言ゲームで遊ぶ！え？画伯枠？  #ぽんバカシスターズ【アキロゼ視点/Hololive】",
    "publishedAt": "2021-11-22T14:54:05Z"
  },
  {
    "videoId": "KS3n2M4x1kg",
    "thumbnail": "https://i.ytimg.com/vi/KS3n2M4x1kg/mqdefault.jpg",
    "title": "【Cooking live/料理配信】新企画発表&お披露目！？【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-11-22T16:46:22Z"
  },
  {
    "videoId": "wXhM-br30Kk",
    "thumbnail": "https://i.ytimg.com/vi/wXhM-br30Kk/mqdefault.jpg",
    "title": "【Cooking live/料理配信】アキロゼのおつまみクッキング【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-11-23T16:24:23Z"
  },
  {
    "videoId": "-rd7zJBsE04",
    "thumbnail": "https://i.ytimg.com/vi/-rd7zJBsE04/mqdefault.jpg",
    "title": "【Cooking live/料理配信】激うま！アキロゼのおつまみクッキング【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-11-25T15:14:59Z"
  },
  {
    "videoId": "YIGJuOnzovE",
    "thumbnail": "https://i.ytimg.com/vi/YIGJuOnzovE/mqdefault.jpg",
    "title": "【Cooking live/料理配信】アキロゼのおつまみクッキング～豪華サラダ編～【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-11-28T16:52:25Z"
  },
  {
    "videoId": "-1q5dNE6rFw",
    "thumbnail": "https://i.ytimg.com/vi/-1q5dNE6rFw/mqdefault.jpg",
    "title": "【Cooking live/カメラ配信】絶品！アキロゼのおつまみクッキング【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-12-03T16:20:18Z"
  },
  {
    "videoId": "EMjwD-zRpo8",
    "thumbnail": "https://i.ytimg.com/vi/EMjwD-zRpo8/mqdefault.jpg",
    "title": "【Cooking live/カメラ配信】最強おつまみコンテスト開催！！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-12-05T17:48:29Z"
  },
  {
    "videoId": "QtLipmqXX54",
    "thumbnail": "https://i.ytimg.com/vi/QtLipmqXX54/mqdefault.jpg",
    "title": "【Cooking live/カメラ配信】最終日はモツ煮×しじみで優勝する！【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2021-12-06T16:50:44Z"
  },
  {
    "videoId": "xUQCfMbxsbM",
    "thumbnail": "https://i.ytimg.com/vi/xUQCfMbxsbM/mqdefault.jpg",
    "title": "ゲリラ！鬼畜の壺おじさんチャレンジ｜Getting Over It with Bennett Foddy【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-11T12:26:47Z"
  },
  {
    "videoId": "9w3eoEQhYkw",
    "thumbnail": "https://i.ytimg.com/vi/9w3eoEQhYkw/mqdefault.jpg",
    "title": "VRライブってどんな感じ！？無料パートから同時視聴する！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-11T15:45:55Z"
  },
  {
    "videoId": "kqC6ll-Voig",
    "thumbnail": "https://i.ytimg.com/vi/kqC6ll-Voig/mqdefault.jpg",
    "title": "【Hacktag】こちらステルスエージェントAKI。相棒のハッカーを頼りに現場を制するわ【常闇トワ×アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-12T15:30:12Z"
  },
  {
    "videoId": "F-_qfzmQd7A",
    "thumbnail": "https://i.ytimg.com/vi/F-_qfzmQd7A/mqdefault.jpg",
    "title": "サンタ衣装　お　ま　た　せ　💖【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-22T16:17:46Z"
  },
  {
    "videoId": "z7KK0OxygXQ",
    "thumbnail": "https://i.ytimg.com/vi/z7KK0OxygXQ/mqdefault.jpg",
    "title": "【歌おう】リクエスト歌枠【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-23T18:52:06Z"
  },
  {
    "videoId": "8uTiu86BKpo",
    "thumbnail": "https://i.ytimg.com/vi/8uTiu86BKpo/mqdefault.jpg",
    "title": "【壺ってほんと？】てっぺんに星を飾りたい【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-24T17:46:17Z"
  },
  {
    "videoId": "cKRP6lZM240",
    "thumbnail": "https://i.ytimg.com/vi/cKRP6lZM240/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】冬の懐メロソングでメリークリスマス！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-25T07:46:54Z"
  },
  {
    "videoId": "sKwjjF8iIpk",
    "thumbnail": "https://i.ytimg.com/vi/sKwjjF8iIpk/mqdefault.jpg",
    "title": "【 視聴者参加型！】かかってこい！厄落とし大戦争！！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2021-12-29T17:26:47Z"
  },
  {
    "videoId": "rYc2RChPrB4",
    "thumbnail": "https://i.ytimg.com/vi/rYc2RChPrB4/mqdefault.jpg",
    "title": "【 おうち3Dガチ恋距離】新年初配信でがおー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-01-02T17:55:52Z"
  },
  {
    "videoId": "PECGQnR7pdM",
    "thumbnail": "https://i.ytimg.com/vi/PECGQnR7pdM/mqdefault.jpg",
    "title": "【マリオカート8DX】ゲリラ！初走りで爆走！世界中と実践特訓【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-01-03T09:30:00Z"
  },
  {
    "videoId": "NtqddJjDru4",
    "thumbnail": "https://i.ytimg.com/vi/NtqddJjDru4/mqdefault.jpg",
    "title": "【ARKムキロゼサーバー】ジェネシス2ラスト観光次なるMAPは…【ホロライブ/アキロゼ】",
    "publishedAt": "2022-01-04T06:29:59Z"
  },
  {
    "videoId": "BVqAhEA1KxI",
    "thumbnail": "https://i.ytimg.com/vi/BVqAhEA1KxI/mqdefault.jpg",
    "title": "【マリオカート8DX】お話しからの大会前ラスト練習！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-01-06T16:13:45Z"
  },
  {
    "videoId": "m6wtspgN7Ms",
    "thumbnail": "https://i.ytimg.com/vi/m6wtspgN7Ms/mqdefault.jpg",
    "title": "【#ホロお正月CUP2022 】慌てない！焦らない！諦めない！【アキロゼ視点/ホロライブ】",
    "publishedAt": "2022-01-07T05:36:04Z"
  },
  {
    "videoId": "J0XPHWe0nTk",
    "thumbnail": "https://i.ytimg.com/vi/J0XPHWe0nTk/mqdefault.jpg",
    "title": "【#ホロARK】新MAPロストアイランドにレッツゴー！！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2022-01-07T16:05:27Z"
  },
  {
    "videoId": "V1ppPg98dm0",
    "thumbnail": "https://i.ytimg.com/vi/V1ppPg98dm0/mqdefault.jpg",
    "title": "【ARK】声帯手術からただいま！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-01-29T17:13:56Z"
  },
  {
    "videoId": "8AnrvU5GZ6E",
    "thumbnail": "https://i.ytimg.com/vi/8AnrvU5GZ6E/mqdefault.jpg",
    "title": "【#hololiveERROR】3D制服放送 学校×青春×ホラーゲーム【ホロライブ/アキロゼ】",
    "publishedAt": "2022-01-30T15:49:29Z"
  },
  {
    "videoId": "WrDC94jjyVc",
    "thumbnail": "https://i.ytimg.com/vi/WrDC94jjyVc/mqdefault.jpg",
    "title": "【ARK】何が起きてもそれはARK【ホロライブ/アキロゼ】",
    "publishedAt": "2022-01-31T15:10:29Z"
  },
  {
    "videoId": "VY4iIdZhMhw",
    "thumbnail": "https://i.ytimg.com/vi/VY4iIdZhMhw/mqdefault.jpg",
    "title": "【ARK】ムキロゼ初のワイバーンチャレンジ【ホロライブ/アキロゼ】",
    "publishedAt": "2022-02-01T17:51:35Z"
  },
  {
    "videoId": "WBsRKAuiUFs",
    "thumbnail": "https://i.ytimg.com/vi/WBsRKAuiUFs/mqdefault.jpg",
    "title": "【ARK】バレンタインイベ始まった！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-02-10T19:26:50Z"
  },
  {
    "videoId": "qSzUz7l-Tyg",
    "thumbnail": "https://i.ytimg.com/vi/qSzUz7l-Tyg/mqdefault.jpg",
    "title": "【monopoly】世界一売れたボードゲーム「モノポリー」で勝負！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-02-12T06:00:40Z"
  },
  {
    "videoId": "2MDJhYdiioY",
    "thumbnail": "https://i.ytimg.com/vi/2MDJhYdiioY/mqdefault.jpg",
    "title": "【ARK】バレンタインデートしよ💕【ホロライブ/アキロゼ】",
    "publishedAt": "2022-02-14T18:50:58Z"
  },
  {
    "videoId": "sY7442ZQrXc",
    "thumbnail": "https://i.ytimg.com/vi/sY7442ZQrXc/mqdefault.jpg",
    "title": "【#アキロゼ生誕祭2022】お誕生日がやってくる！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-02-16T15:31:44Z"
  },
  {
    "videoId": "TsRo8VuubSk",
    "thumbnail": "https://i.ytimg.com/vi/TsRo8VuubSk/mqdefault.jpg",
    "title": "【#アキロゼ生誕祭2022】Wonder Shower Musical !!!!【3DLIVE】",
    "publishedAt": "2022-02-17T13:09:36Z"
  },
  {
    "videoId": "2Z9He6FcaEQ",
    "thumbnail": "https://i.ytimg.com/vi/2Z9He6FcaEQ/mqdefault.jpg",
    "title": "【生誕祭振り返り！】余韻に浸りたい人おいで【#アキロゼ生誕祭2022】",
    "publishedAt": "2022-02-18T14:17:33Z"
  },
  {
    "videoId": "hqGSpoBJlmg",
    "thumbnail": "https://i.ytimg.com/vi/hqGSpoBJlmg/mqdefault.jpg",
    "title": "ゲリラ配信！【ARK】キミもおいしくなろうね💕【ホロライブ/Akirose】",
    "publishedAt": "2022-02-22T19:54:09Z"
  },
  {
    "videoId": "2aFMCdmX-Xc",
    "thumbnail": "https://i.ytimg.com/vi/2aFMCdmX-Xc/mqdefault.jpg",
    "title": "【Vampire Survivors】超話題の神ゲー！倒せ！よけろ！進め！【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-02-24T18:15:24Z"
  },
  {
    "videoId": "ew_q773QxXc",
    "thumbnail": "https://i.ytimg.com/vi/ew_q773QxXc/mqdefault.jpg",
    "title": "【Vampire Survivors】神ゲ！クリア耐久！かかってこい！！【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-02-25T17:41:01Z"
  },
  {
    "videoId": "DPbfZwaFPOk",
    "thumbnail": "https://i.ytimg.com/vi/DPbfZwaFPOk/mqdefault.jpg",
    "title": "【Vampire Survivors】緊急チャレンジ！ハイパーの世界見に行こう【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-02-26T16:05:46Z"
  },
  {
    "videoId": "9AXPfVWJB4A",
    "thumbnail": "https://i.ytimg.com/vi/9AXPfVWJB4A/mqdefault.jpg",
    "title": "【Vampire Survivors】神ゲ！緑の地ハイパーモード絶対クリア耐久【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-02-27T18:08:26Z"
  },
  {
    "videoId": "HVA7qJJ0q2M",
    "thumbnail": "https://i.ytimg.com/vi/HVA7qJJ0q2M/mqdefault.jpg",
    "title": "【Windjammers 2 - フライング・パワー・ディスク】伝説の神ディスクゲー？フリスビーのプロになるかｗｗｗ【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-02-28T15:21:38Z"
  },
  {
    "videoId": "yw4iUrYa-M8",
    "thumbnail": "https://i.ytimg.com/vi/yw4iUrYa-M8/mqdefault.jpg",
    "title": "【Vampire Survivors】敵レベルMAX！？カースLv.5でクリア耐久【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-01T17:59:03Z"
  },
  {
    "videoId": "2lEJUhk0-YI",
    "thumbnail": "https://i.ytimg.com/vi/2lEJUhk0-YI/mqdefault.jpg",
    "title": "ラスト5分緊急配信！【Vampire Survivors】Lamaで敵レベルMAX強化済み！その結末とは・・・【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-01T19:09:44Z"
  },
  {
    "videoId": "g-d4ndC-acQ",
    "thumbnail": "https://i.ytimg.com/vi/g-d4ndC-acQ/mqdefault.jpg",
    "title": "【ARK】#ホロ薔薇組 どっちがボスかわからせテイム！ムキロゼwith 鷹嶺ルイ【ホロライブ/アキロゼ Akirose】",
    "publishedAt": "2022-03-02T18:07:02Z"
  },
  {
    "videoId": "rbh0OlKwgco",
    "thumbnail": "https://i.ytimg.com/vi/rbh0OlKwgco/mqdefault.jpg",
    "title": "緊急ゲリラ【ARK】え！BOSS戦！？ムキロゼ、カメラマンとしてのぞきにいこうｗ【ホロライブ/Akirose】",
    "publishedAt": "2022-03-03T13:19:11Z"
  },
  {
    "videoId": "BlWz9Mjh8BE",
    "thumbnail": "https://i.ytimg.com/vi/BlWz9Mjh8BE/mqdefault.jpg",
    "title": "【ARK】トラップだらけの迷宮があるらしい！宝探しじゃー！【ホロライブ/Akirose】",
    "publishedAt": "2022-03-04T18:08:17Z"
  },
  {
    "videoId": "0_RGpbmqh5E",
    "thumbnail": "https://i.ytimg.com/vi/0_RGpbmqh5E/mqdefault.jpg",
    "title": "【Subnautica】水深500mの世界！この世界の謎に迫る！Part8【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-05T11:04:58Z"
  },
  {
    "videoId": "6OrH-khfqk4",
    "thumbnail": "https://i.ytimg.com/vi/6OrH-khfqk4/mqdefault.jpg",
    "title": "【Vampire Survivors】patch0.3.0きた！プロバンパイアハンターアキロゼ、新マップへの挑戦【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-05T17:41:28Z"
  },
  {
    "videoId": "PVPsyPNeZ0c",
    "thumbnail": "https://i.ytimg.com/vi/PVPsyPNeZ0c/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #1】サイバーパンク2077 の世界へレッツゴー！【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-06T05:40:40Z"
  },
  {
    "videoId": "tX8u2YZ_r4c",
    "thumbnail": "https://i.ytimg.com/vi/tX8u2YZ_r4c/mqdefault.jpg",
    "title": "【ARK】アーティファクトが欲しいARK廃人ムキ兄弟【ホロライブ/Akirose】",
    "publishedAt": "2022-03-11T17:30:40Z"
  },
  {
    "videoId": "lHh2iPkf09k",
    "thumbnail": "https://i.ytimg.com/vi/lHh2iPkf09k/mqdefault.jpg",
    "title": "【Subnautica】深海デートしよ。お願いついてきて！何でもしますから Part9【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-12T11:44:43Z"
  },
  {
    "videoId": "5Q4-o-5C2dA",
    "thumbnail": "https://i.ytimg.com/vi/5Q4-o-5C2dA/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #2】 ぼっち任務に初挑戦！？サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-13T07:06:44Z"
  },
  {
    "videoId": "agRA8IKjFHo",
    "thumbnail": "https://i.ytimg.com/vi/agRA8IKjFHo/mqdefault.jpg",
    "title": "【ARK】免疫のアーティファクトとボス戦準備！【ホロライブ/Akirose】",
    "publishedAt": "2022-03-15T02:28:48Z"
  },
  {
    "videoId": "BvxGaYDWk14",
    "thumbnail": "https://i.ytimg.com/vi/BvxGaYDWk14/mqdefault.jpg",
    "title": "【ARK】βボスに挑戦！ムキロゼ太鼓の達人編【ホロライブ/Akirose】",
    "publishedAt": "2022-03-15T15:59:13Z"
  },
  {
    "videoId": "9cKccXjer44",
    "thumbnail": "https://i.ytimg.com/vi/9cKccXjer44/mqdefault.jpg",
    "title": "【#つながるホロライブDAY2】ライブ当日だよ！≪ FREE CHAT ≫ | hololive 3rd fes. Link Your Wish【#アキロゼ】",
    "publishedAt": "2022-03-20T16:33:02Z"
  },
  {
    "videoId": "Nuly5zw1t30",
    "thumbnail": "https://i.ytimg.com/vi/Nuly5zw1t30/mqdefault.jpg",
    "title": "【八月のシンデレラナイン】今日から私が監督です！俺たちの青春はここにあった…！【#ハチナイ_アキロゼ /ホロライブ】",
    "publishedAt": "2022-03-22T17:13:17Z"
  },
  {
    "videoId": "5ZuPUxYwQf4",
    "thumbnail": "https://i.ytimg.com/vi/5ZuPUxYwQf4/mqdefault.jpg",
    "title": "【Subnautica】めざせ女子力建築！深海でも生きれるもん！ Part10【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-26T10:56:18Z"
  },
  {
    "videoId": "CmDwTNzjgqk",
    "thumbnail": "https://i.ytimg.com/vi/CmDwTNzjgqk/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #3】 脳内に別人がいる！？サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-03-27T06:31:44Z"
  },
  {
    "videoId": "X1Sks-pF2oc",
    "thumbnail": "https://i.ytimg.com/vi/X1Sks-pF2oc/mqdefault.jpg",
    "title": "【シン・クロニクル】やり直しなどない…チャンスは一度きり！これは人生だ【#ホロとシンクロ /アキロゼ】",
    "publishedAt": "2022-03-28T13:55:25Z"
  },
  {
    "videoId": "oDQFO8fX_SA",
    "thumbnail": "https://i.ytimg.com/vi/oDQFO8fX_SA/mqdefault.jpg",
    "title": "【Free Talk】推しへの愛のために新口上作る？！そして占い結果でました【アキロゼ/ホロライブ】#Akirose",
    "publishedAt": "2022-03-29T18:02:04Z"
  },
  {
    "videoId": "8tg_cGumNOs",
    "thumbnail": "https://i.ytimg.com/vi/8tg_cGumNOs/mqdefault.jpg",
    "title": "ゲリラ！歌うよKARAOKE stream 【アキロゼ/ホロライブ】#Akirose",
    "publishedAt": "2022-04-01T18:13:49Z"
  },
  {
    "videoId": "nMSHB_56cto",
    "thumbnail": "https://i.ytimg.com/vi/nMSHB_56cto/mqdefault.jpg",
    "title": "【Subnautica】謎の 施設に潜入捜査！謎を解明する冒険記Part11【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-02T08:14:35Z"
  },
  {
    "videoId": "JU7WEBqkAL8",
    "thumbnail": "https://i.ytimg.com/vi/JU7WEBqkAL8/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #4】超危険な貨物船から強奪せよ！サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-03T05:31:22Z"
  },
  {
    "videoId": "aOM_BNM81yU",
    "thumbnail": "https://i.ytimg.com/vi/aOM_BNM81yU/mqdefault.jpg",
    "title": "【閉店事件|The Closing Shift】超絶ビビりのホラゲ配信。え？カフェのバイトですよね？【ホロライブ/アキロゼ(Aki Rosenthal)】",
    "publishedAt": "2022-04-08T16:47:44Z"
  },
  {
    "videoId": "D673Lo_X0mk",
    "thumbnail": "https://i.ytimg.com/vi/D673Lo_X0mk/mqdefault.jpg",
    "title": "【Subnautica】最終回！？未知の惑星からついに脱出できるのか？Part12【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-09T07:31:12Z"
  },
  {
    "videoId": "09yCuLjtuGQ",
    "thumbnail": "https://i.ytimg.com/vi/09yCuLjtuGQ/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #5】パレードで極秘ミッションを遂行せよ！サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-10T08:55:38Z"
  },
  {
    "videoId": "s8Tc1x7WS2s",
    "thumbnail": "https://i.ytimg.com/vi/s8Tc1x7WS2s/mqdefault.jpg",
    "title": "【ARK | LOST ISLAND】イースターイベントきちゃあ！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-04-13T18:34:58Z"
  },
  {
    "videoId": "YyvqUsejgzc",
    "thumbnail": "https://i.ytimg.com/vi/YyvqUsejgzc/mqdefault.jpg",
    "title": "【ELDEN RING】初めてのフロムゲー！リベンジ耐久 ムキデンリング【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2022-04-16T15:06:40Z"
  },
  {
    "videoId": "KMHnsewu9Rk",
    "thumbnail": "https://i.ytimg.com/vi/KMHnsewu9Rk/mqdefault.jpg",
    "title": "【雑談 | Free Talk】麦ジュース飲む！！！！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-04-16T16:10:55Z"
  },
  {
    "videoId": "2Odg1YcF_yg",
    "thumbnail": "https://i.ytimg.com/vi/2Odg1YcF_yg/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #6】ジュディからのヘルプが！？サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-17T07:35:32Z"
  },
  {
    "videoId": "9-7OXFVhIpk",
    "thumbnail": "https://i.ytimg.com/vi/9-7OXFVhIpk/mqdefault.jpg",
    "title": "【ARK | LOST ISLAND】卵ガチャの時間だー！！並走コラボ【ホロライブ/不知火フレア/アキロゼ】",
    "publishedAt": "2022-04-17T19:03:25Z"
  },
  {
    "videoId": "UCzUhJhIAUA",
    "thumbnail": "https://i.ytimg.com/vi/UCzUhJhIAUA/mqdefault.jpg",
    "title": "【ELDEN RING】初めてのフロムゲー！ 素寒貧ムキデンリングようやく冒険開始【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2022-04-19T17:38:54Z"
  },
  {
    "videoId": "oPz0drs85fY",
    "thumbnail": "https://i.ytimg.com/vi/oPz0drs85fY/mqdefault.jpg",
    "title": "新マイクきたのでゲリラ！歌うよKARAOKE stream 【アキロゼ/ホロライブ】#Akirose",
    "publishedAt": "2022-04-23T09:31:30Z"
  },
  {
    "videoId": "GDIZ18WP6v8",
    "thumbnail": "https://i.ytimg.com/vi/GDIZ18WP6v8/mqdefault.jpg",
    "title": "【ELDEN RING】今日の獲物：忌み鬼マルギット～素寒貧ムキデンリング～【ホロライブ/アキロゼ】※ネタバレあり",
    "publishedAt": "2022-04-23T17:22:40Z"
  },
  {
    "videoId": "_Dw7uCMPoh4",
    "thumbnail": "https://i.ytimg.com/vi/_Dw7uCMPoh4/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #7】ボクシングマシーンとパレード潜入ミッションがついに動く！サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-24T06:52:56Z"
  },
  {
    "videoId": "Zu_zJj6u5ak",
    "thumbnail": "https://i.ytimg.com/vi/Zu_zJj6u5ak/mqdefault.jpg",
    "title": "【Vampire Survivors】新MAP&新キャラ&新要素！？プロハンターなら余裕でしょｗ【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-04-27T19:23:20Z"
  },
  {
    "videoId": "_eCcmm-rygY",
    "thumbnail": "https://i.ytimg.com/vi/_eCcmm-rygY/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #8】スナイパーVロゼの潜入ミッション！サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-05-01T06:10:55Z"
  },
  {
    "videoId": "SRe0Ci65DRU",
    "thumbnail": "https://i.ytimg.com/vi/SRe0Ci65DRU/mqdefault.jpg",
    "title": "【つっぱり大相撲】誰が強いかぶつかり稽古！！！#ホロGGW",
    "publishedAt": "2022-05-01T11:09:06Z"
  },
  {
    "videoId": "g3QV6Af6l_Q",
    "thumbnail": "https://i.ytimg.com/vi/g3QV6Af6l_Q/mqdefault.jpg",
    "title": "【太鼓の達人】さいたま2000を背負えるのか #ホロGGW の特訓開始！！",
    "publishedAt": "2022-05-06T16:45:03Z"
  },
  {
    "videoId": "EFz4YWJUgrM",
    "thumbnail": "https://i.ytimg.com/vi/EFz4YWJUgrM/mqdefault.jpg",
    "title": "【太鼓の達人】太鼓組で集合！！大会直前に実力テスト！？#ホロGGW",
    "publishedAt": "2022-05-07T10:59:54Z"
  },
  {
    "videoId": "E4YjfsH2mFg",
    "thumbnail": "https://i.ytimg.com/vi/E4YjfsH2mFg/mqdefault.jpg",
    "title": "【つっぱり大相撲】出稽古じゃああああああ！！#ホロGGW",
    "publishedAt": "2022-05-07T13:06:30Z"
  },
  {
    "videoId": "MySIkwu9Rq0",
    "thumbnail": "https://i.ytimg.com/vi/MySIkwu9Rq0/mqdefault.jpg",
    "title": "【#ホロGGW】めざせ優勝！伝説をつかみ取れ！！！【アキロゼチーム】",
    "publishedAt": "2022-05-08T15:30:35Z"
  },
  {
    "videoId": "ykKZYLOu6eI",
    "thumbnail": "https://i.ytimg.com/vi/ykKZYLOu6eI/mqdefault.jpg",
    "title": "【Free talk】配信復活！！待たせたな！！！！！【アキロゼ/ホロライブ】#Akirose",
    "publishedAt": "2022-05-13T16:55:54Z"
  },
  {
    "videoId": "IRw5zihPdDE",
    "thumbnail": "https://i.ytimg.com/vi/IRw5zihPdDE/mqdefault.jpg",
    "title": "【歌枠/sing stream】土曜の夜にしっぽり歌【アキロゼ/ホロライブ】#Akirose",
    "publishedAt": "2022-05-14T15:32:39Z"
  },
  {
    "videoId": "qaXlqUkyzd4",
    "thumbnail": "https://i.ytimg.com/vi/qaXlqUkyzd4/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #9】この街で芽生える愛とは…！サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-05-15T08:34:20Z"
  },
  {
    "videoId": "kZSTG5Y1A6Q",
    "thumbnail": "https://i.ytimg.com/vi/kZSTG5Y1A6Q/mqdefault.jpg",
    "title": "【ARK | LOST ISLAND】アーティファクトハンター編|新MAP行く前に揃えたい！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-05-19T16:55:35Z"
  },
  {
    "videoId": "oKusI6i7nI8",
    "thumbnail": "https://i.ytimg.com/vi/oKusI6i7nI8/mqdefault.jpg",
    "title": "【ARK | LOST ISLAND】アーティファクトハンター編|最難関の洞窟から奪え！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-05-21T18:37:41Z"
  },
  {
    "videoId": "HQsVa6k-obo",
    "thumbnail": "https://i.ytimg.com/vi/HQsVa6k-obo/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #10】ロマンスいっぱい夢いっぱい！？ | サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-05-22T08:56:46Z"
  },
  {
    "videoId": "hj7xCK1aIbk",
    "thumbnail": "https://i.ytimg.com/vi/hj7xCK1aIbk/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】サンブレイク前にリハビリじゃああ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-05-24T16:39:07Z"
  },
  {
    "videoId": "BxsH-ElQgbU",
    "thumbnail": "https://i.ytimg.com/vi/BxsH-ElQgbU/mqdefault.jpg",
    "title": "【歌枠/sing stream】まったり話すよほぼ雑談配信【アキロゼ/ホロライブ】#Akirose",
    "publishedAt": "2022-05-25T17:05:47Z"
  },
  {
    "videoId": "l9eBmAo_NrA",
    "thumbnail": "https://i.ytimg.com/vi/l9eBmAo_NrA/mqdefault.jpg",
    "title": "【Vampire Survivors】アプデがきた！プロハンターなので（）【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-05-26T16:50:56Z"
  },
  {
    "videoId": "afEfvZcI1o8",
    "thumbnail": "https://i.ytimg.com/vi/afEfvZcI1o8/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #11】ジョニーの恋愛編 | サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-05-29T06:28:51Z"
  },
  {
    "videoId": "DcU8JCAXpKE",
    "thumbnail": "https://i.ytimg.com/vi/DcU8JCAXpKE/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】一狩りいこうぜ！視聴者参加型で百竜夜行だー！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-05-31T14:48:25Z"
  },
  {
    "videoId": "7dQioF1SJkU",
    "thumbnail": "https://i.ytimg.com/vi/7dQioF1SJkU/mqdefault.jpg",
    "title": "【ARK | LOST ISLAND】視聴者サーバーの建築がヤバすぎる！！弾丸観光編【ホロライブ/アキロゼ】",
    "publishedAt": "2022-05-31T16:16:19Z"
  },
  {
    "videoId": "1i7BDyp-tBw",
    "thumbnail": "https://i.ytimg.com/vi/1i7BDyp-tBw/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】フブキちゃんと一緒に4周年迎えたし記念狩り！フブ【ホロライブ/アキロゼ視点】",
    "publishedAt": "2022-05-31T18:38:14Z"
  },
  {
    "videoId": "mknggf96fuI",
    "thumbnail": "https://i.ytimg.com/vi/mknggf96fuI/mqdefault.jpg",
    "title": "【#アキロゼ4周年LIVE】全編歌ライブ！みんなと歌って踊って3D LIVE 「ROSE of the LAMP」【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-06-01T13:09:00Z"
  },
  {
    "videoId": "q2rpBJyOZck",
    "thumbnail": "https://i.ytimg.com/vi/q2rpBJyOZck/mqdefault.jpg",
    "title": "『ROSE of the LAMP』【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-06-01T14:45:01Z"
  },
  {
    "videoId": "owB9bIpw83M",
    "thumbnail": "https://i.ytimg.com/vi/owB9bIpw83M/mqdefault.jpg",
    "title": "【LIVE映像】ホロライブ1期生みんなで『 plasmagic seasons!』",
    "publishedAt": "2022-06-02T03:26:42Z"
  },
  {
    "videoId": "JWe3kpuzR3I",
    "thumbnail": "https://i.ytimg.com/vi/JWe3kpuzR3I/mqdefault.jpg",
    "title": "ライブ振り返り枠！制作秘話などはなしちゃう！【アキ・ローゼンタール/ホロライブ】#アキロゼ4周年LIVE",
    "publishedAt": "2022-06-02T15:41:00Z"
  },
  {
    "videoId": "ss1uZqiSbzM",
    "thumbnail": "https://i.ytimg.com/vi/ss1uZqiSbzM/mqdefault.jpg",
    "title": "【3DLIVE映像】『ROSE of the LAMP』歌って踊ってみた！【Aki Rosenthal】",
    "publishedAt": "2022-06-03T03:45:13Z"
  },
  {
    "videoId": "mVHIH5Uj6mA",
    "thumbnail": "https://i.ytimg.com/vi/mVHIH5Uj6mA/mqdefault.jpg",
    "title": "【3D LIVE映像】OP ACT ーAKIROSE WORLDー【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-06-04T05:11:21Z"
  },
  {
    "videoId": "-P6sDt0Yh30",
    "thumbnail": "https://i.ytimg.com/vi/-P6sDt0Yh30/mqdefault.jpg",
    "title": "【3D LIVE映像】君の銀の庭 \"Your silver Garden\"劇場版 魔法少女まどか☆マギカ [新編] 叛逆の物語 ED【AZKi/大神ミオ/アキ・ローゼンタール】",
    "publishedAt": "2022-06-04T07:00:14Z"
  },
  {
    "videoId": "7Ar8HnHegMA",
    "thumbnail": "https://i.ytimg.com/vi/7Ar8HnHegMA/mqdefault.jpg",
    "title": "【3D LIVE映像】Here   TVアニメ「魔法使いの嫁」OP曲【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-06-04T08:00:16Z"
  },
  {
    "videoId": "Ywld5Y1_ruI",
    "thumbnail": "https://i.ytimg.com/vi/Ywld5Y1_ruI/mqdefault.jpg",
    "title": "【3D LIVE映像】幸せになれる隠しコマンドがあるらしい【戌神ころね×アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-06-04T09:00:21Z"
  },
  {
    "videoId": "0PN_xbRCxjk",
    "thumbnail": "https://i.ytimg.com/vi/0PN_xbRCxjk/mqdefault.jpg",
    "title": "【3D LIVE映像】フォニィphonyー雨の街で歌ってみたー【猫又おかゆ×アキ・ローゼンタール】",
    "publishedAt": "2022-06-04T10:00:11Z"
  },
  {
    "videoId": "GyWPn8ADczQ",
    "thumbnail": "https://i.ytimg.com/vi/GyWPn8ADczQ/mqdefault.jpg",
    "title": "【3D LIVE映像】色彩のブルース-雨の街で気分よく歌って踊ってみた-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-06-04T11:00:14Z"
  },
  {
    "videoId": "6-2nAu8EycQ",
    "thumbnail": "https://i.ytimg.com/vi/6-2nAu8EycQ/mqdefault.jpg",
    "title": "【3D LIVE映像】MOON PRIDE【夜空メル×アキ・ローゼンタール×角巻わため×尾丸ポルカ】美少女戦士セーラームーンCrystal OPテーマ",
    "publishedAt": "2022-06-04T15:45:10Z"
  },
  {
    "videoId": "TaxnL_4hAv8",
    "thumbnail": "https://i.ytimg.com/vi/TaxnL_4hAv8/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #12】ジョニーの恋愛編パート２ | サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-06-05T06:59:04Z"
  },
  {
    "videoId": "8U_mkeZZAfQ",
    "thumbnail": "https://i.ytimg.com/vi/8U_mkeZZAfQ/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】わちゃわちゃモンハン！ナルハタ！！！！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2022-06-06T15:51:11Z"
  },
  {
    "videoId": "n_PJBtxvQ6g",
    "thumbnail": "https://i.ytimg.com/vi/n_PJBtxvQ6g/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】視聴者さん参加型|ゲリラ！眠いけど百竜夜行～！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-06-07T17:09:03Z"
  },
  {
    "videoId": "a1xhsYnmSgM",
    "thumbnail": "https://i.ytimg.com/vi/a1xhsYnmSgM/mqdefault.jpg",
    "title": "【Vampire Survivors】最新アプデきた！プロハンターのアチーブメント回収します【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-06-11T19:36:45Z"
  },
  {
    "videoId": "w-A7xdapMtQ",
    "thumbnail": "https://i.ytimg.com/vi/w-A7xdapMtQ/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #13】ハックスキル回収とノーマッドストーリー | サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-06-12T06:19:03Z"
  },
  {
    "videoId": "dMWr_OFXXA0",
    "thumbnail": "https://i.ytimg.com/vi/dMWr_OFXXA0/mqdefault.jpg",
    "title": "【復活雑談】謎の高熱の正体とは・・・【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-06-19T02:06:42Z"
  },
  {
    "videoId": "W_vFkt3VMgc",
    "thumbnail": "https://i.ytimg.com/vi/W_vFkt3VMgc/mqdefault.jpg",
    "title": "【Cyberpunk2077 | #14】ついにラストスパートに突入！ハナコ様ああああ！ | サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2022-06-19T07:07:25Z"
  },
  {
    "videoId": "nF6ZgGsYxus",
    "thumbnail": "https://i.ytimg.com/vi/nF6ZgGsYxus/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】視聴者さん参加型|ゲリラ！今日こそＨＲ100突破するぞ！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-06-20T18:05:14Z"
  },
  {
    "videoId": "9l4Hs-A2lN0",
    "thumbnail": "https://i.ytimg.com/vi/9l4Hs-A2lN0/mqdefault.jpg",
    "title": "【ARK | LOST ISLAND】視聴者サーバーの建築がヤバすぎる！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-06-23T08:50:42Z"
  },
  {
    "videoId": "qT-pFz8hA5Q",
    "thumbnail": "https://i.ytimg.com/vi/qT-pFz8hA5Q/mqdefault.jpg",
    "title": "【ARK | Fjordur】北欧神話の神MAPついに突入だー！！視聴者サーバーも同時解禁！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-06-24T21:56:13Z"
  },
  {
    "videoId": "XqDs8MKovas",
    "thumbnail": "https://i.ytimg.com/vi/XqDs8MKovas/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク DEMO】完全初見メル・ゼナ！4人で討伐チャレンジ【アキロゼ視点/不知火フレア/雪花ラミィ/尾丸ポルカ|ホロライブ】",
    "publishedAt": "2022-06-28T15:55:41Z"
  },
  {
    "videoId": "WQLRkvHIpq0",
    "thumbnail": "https://i.ytimg.com/vi/WQLRkvHIpq0/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE:SUNBREAK】サンブレイクに突入だー！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-06-29T20:08:59Z"
  },
  {
    "videoId": "3sb3dXYYXEg",
    "thumbnail": "https://i.ytimg.com/vi/3sb3dXYYXEg/mqdefault.jpg",
    "title": "【雑談+歌】ついにお披露目解禁！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-07-02T12:06:33Z"
  },
  {
    "videoId": "HjrKEInC_r8",
    "thumbnail": "https://i.ytimg.com/vi/HjrKEInC_r8/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】MR２クエストを攻略せよ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-07-03T06:02:02Z"
  },
  {
    "videoId": "7NzqlQWpKtM",
    "thumbnail": "https://i.ytimg.com/vi/7NzqlQWpKtM/mqdefault.jpg",
    "title": "【ARK | Fjordur】突然の夏イベ到来！イベカラーの恐竜が欲しい！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-07-03T18:09:21Z"
  },
  {
    "videoId": "smxJm4ZCULg",
    "thumbnail": "https://i.ytimg.com/vi/smxJm4ZCULg/mqdefault.jpg",
    "title": "【ARK | Fjordur】あぁ、これが無限ARK回廊ロックドレイクを求めて【ホロライブ/アキロゼ】",
    "publishedAt": "2022-07-05T20:28:35Z"
  },
  {
    "videoId": "vyFRI4ELvco",
    "thumbnail": "https://i.ytimg.com/vi/vyFRI4ELvco/mqdefault.jpg",
    "title": "【スペシャル歌枠！】Acoustic Session Live 7th【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-07-06T13:15:05Z"
  },
  {
    "videoId": "eQu14VUVFx4",
    "thumbnail": "https://i.ytimg.com/vi/eQu14VUVFx4/mqdefault.jpg",
    "title": "【第2走者・アキロゼ】1期生Live2Dver3.0お披露目リレー【ホロライブ/hololive】",
    "publishedAt": "2022-07-09T11:12:55Z"
  },
  {
    "videoId": "2MpWihL7l24",
    "thumbnail": "https://i.ytimg.com/vi/2MpWihL7l24/mqdefault.jpg",
    "title": "【ARK |LOSTISLAND】お遊びARKでボス戦コラボ！バイバイロストアイランド記念じゃ！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-07-09T17:49:01Z"
  },
  {
    "videoId": "Nf9mBMYbaDA",
    "thumbnail": "https://i.ytimg.com/vi/Nf9mBMYbaDA/mqdefault.jpg",
    "title": "【歌枠】深夜にまったり歌でも歌おう【アキロゼ(Akirose)/ホロライブ】",
    "publishedAt": "2022-07-13T17:34:40Z"
  },
  {
    "videoId": "gVv6qpssoCI",
    "thumbnail": "https://i.ytimg.com/vi/gVv6qpssoCI/mqdefault.jpg",
    "title": "【ARK | Fjordur】懐かしい顔ぶれに歓喜！孵化装置と緑の宝石【ホロライブ/アキロゼ】",
    "publishedAt": "2022-07-14T15:04:15Z"
  },
  {
    "videoId": "4Fn44QyRGOM",
    "thumbnail": "https://i.ytimg.com/vi/4Fn44QyRGOM/mqdefault.jpg",
    "title": "【ARK | Fjordur】枠録り直し！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-07-14T19:22:33Z"
  },
  {
    "videoId": "0qtmHGK-PLs",
    "thumbnail": "https://i.ytimg.com/vi/0qtmHGK-PLs/mqdefault.jpg",
    "title": "【ARK | Fjordur】夏イベ延長？いい色を探してがむしゃらテイム【ホロライブ/アキロゼ】",
    "publishedAt": "2022-07-15T20:33:32Z"
  },
  {
    "videoId": "wV62GhyzaOE",
    "thumbnail": "https://i.ytimg.com/vi/wV62GhyzaOE/mqdefault.jpg",
    "title": "【Minecraft】IDとJPのサーバーが繋がるポータルを作るんだ！【アキロゼ/ホロライブ】",
    "publishedAt": "2022-07-17T05:33:40Z"
  },
  {
    "videoId": "e0U3V6EtDH4",
    "thumbnail": "https://i.ytimg.com/vi/e0U3V6EtDH4/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第1夜 | アキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-07-19T15:20:49Z"
  },
  {
    "videoId": "m8-KxlBx-KE",
    "thumbnail": "https://i.ytimg.com/vi/m8-KxlBx-KE/mqdefault.jpg",
    "title": "【ホラゲ実況】あれ？まるでガチホラゲじゃないか・・・【夏色まつり×アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2022-07-24T13:42:44Z"
  },
  {
    "videoId": "Wb3rclQNh-M",
    "thumbnail": "https://i.ytimg.com/vi/Wb3rclQNh-M/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第2夜 | アキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-07-26T14:10:23Z"
  },
  {
    "videoId": "vpnEFjQqT1k",
    "thumbnail": "https://i.ytimg.com/vi/vpnEFjQqT1k/mqdefault.jpg",
    "title": "【ホロ麻雀大会】本番直前で調子をあげろ！！ -セガNET麻雀MJ-【アキロゼ/ホロライブ】",
    "publishedAt": "2022-07-29T08:09:38Z"
  },
  {
    "videoId": "W5bDJmQqnSw",
    "thumbnail": "https://i.ytimg.com/vi/W5bDJmQqnSw/mqdefault.jpg",
    "title": "【ホロ麻雀大会】超豪運を掴み取れ！！#超越エキシビジョン -セガNET麻雀MJ-【アキロゼ視点ホロライブ】",
    "publishedAt": "2022-07-29T12:46:31Z"
  },
  {
    "videoId": "YBFSEFf5YZk",
    "thumbnail": "https://i.ytimg.com/vi/YBFSEFf5YZk/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第3夜 | アキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-08-02T14:31:03Z"
  },
  {
    "videoId": "ti_woUJbrxw",
    "thumbnail": "https://i.ytimg.com/vi/ti_woUJbrxw/mqdefault.jpg",
    "title": "【ARK | Fjordur】強いシャドーメイン欲しい！拠点発展もしたい！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-08-04T21:57:07Z"
  },
  {
    "videoId": "1FB-O9jU3m8",
    "thumbnail": "https://i.ytimg.com/vi/1FB-O9jU3m8/mqdefault.jpg",
    "title": "【スペシャルゲスト回】Acoustic Session Live 8th【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-08-08T12:49:44Z"
  },
  {
    "videoId": "otGAFEyKd9Y",
    "thumbnail": "https://i.ytimg.com/vi/otGAFEyKd9Y/mqdefault.jpg",
    "title": "【全身3Dもあり！水着お披露目】水着で筋トレ！ビッグなお知らせアリ！#アキロゼ重大告知【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-08-12T14:07:19Z"
  },
  {
    "videoId": "N-Ke0oYP7zY",
    "thumbnail": "https://i.ytimg.com/vi/N-Ke0oYP7zY/mqdefault.jpg",
    "title": "【RUST】初プレイ！新たなサバイバルを求めて【ホロライブ/アキロゼ】",
    "publishedAt": "2022-08-14T19:42:30Z"
  },
  {
    "videoId": "1QxMEkna1aE",
    "thumbnail": "https://i.ytimg.com/vi/1QxMEkna1aE/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第4夜 | アキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-08-16T14:42:59Z"
  },
  {
    "videoId": "wIdwdbxjqos",
    "thumbnail": "https://i.ytimg.com/vi/wIdwdbxjqos/mqdefault.jpg",
    "title": "【RUST】枠たてなおし！これがRUST。そういうこと。Part2【ホロライブ/アキロゼ】",
    "publishedAt": "2022-08-18T15:47:18Z"
  },
  {
    "videoId": "Pz9K-u1u3Ak",
    "thumbnail": "https://i.ytimg.com/vi/Pz9K-u1u3Ak/mqdefault.jpg",
    "title": "【激辛実食！】激辛イベントに出るので激辛と和解したい【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-08-19T14:48:51Z"
  },
  {
    "videoId": "3bCJPXxQxEU",
    "thumbnail": "https://i.ytimg.com/vi/3bCJPXxQxEU/mqdefault.jpg",
    "title": "【復帰配信】コロナに打ち勝ったので麦ジュースで優勝する！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-09T13:59:21Z"
  },
  {
    "videoId": "pJk_oZA35Ks",
    "thumbnail": "https://i.ytimg.com/vi/pJk_oZA35Ks/mqdefault.jpg",
    "title": "【Splatoon3】スプラ3から本格参戦！レギュラーマッチで勝ちまくる（予言）【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-11T16:24:39Z"
  },
  {
    "videoId": "MJ4LAISbBQA",
    "thumbnail": "https://i.ytimg.com/vi/MJ4LAISbBQA/mqdefault.jpg",
    "title": "【Splatoon3】ウデマエB帯を目指す！スプラ3【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-12T14:49:06Z"
  },
  {
    "videoId": "IbCfwmi015w",
    "thumbnail": "https://i.ytimg.com/vi/IbCfwmi015w/mqdefault.jpg",
    "title": "【Splatoon3】スプラ3 ウデマエB+が魔境らしいがその先にいくぞ！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-13T14:40:36Z"
  },
  {
    "videoId": "uVmxs1wnSpo",
    "thumbnail": "https://i.ytimg.com/vi/uVmxs1wnSpo/mqdefault.jpg",
    "title": "【Splatoon3】スプラ3初心者が ウデマエA+にいく世界線【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-14T17:59:51Z"
  },
  {
    "videoId": "kjCGVqxT1co",
    "thumbnail": "https://i.ytimg.com/vi/kjCGVqxT1co/mqdefault.jpg",
    "title": "【公認ミラー配信】カプコン最新情報を一緒に見よう！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-15T15:08:07Z"
  },
  {
    "videoId": "M4sdLCSgWOg",
    "thumbnail": "https://i.ytimg.com/vi/M4sdLCSgWOg/mqdefault.jpg",
    "title": "【Splatoon3】サマーローズのナワバリじゃあ！！【ホロライブ/夏色まつり×アキ・ローゼンタール】",
    "publishedAt": "2022-09-17T16:01:21Z"
  },
  {
    "videoId": "c7wzrVZv9qU",
    "thumbnail": "https://i.ytimg.com/vi/c7wzrVZv9qU/mqdefault.jpg",
    "title": "【Splatoon3】ウデマエA+ にいきたい！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-18T13:05:22Z"
  },
  {
    "videoId": "LaOzM9TjeYg",
    "thumbnail": "https://i.ytimg.com/vi/LaOzM9TjeYg/mqdefault.jpg",
    "title": "【Splatoon3】バイトの時間ですよ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-18T19:12:53Z"
  },
  {
    "videoId": "EcrM25HLqlI",
    "thumbnail": "https://i.ytimg.com/vi/EcrM25HLqlI/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第5夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-09-20T15:56:01Z"
  },
  {
    "videoId": "R-45lVn1Z0Q",
    "thumbnail": "https://i.ytimg.com/vi/R-45lVn1Z0Q/mqdefault.jpg",
    "title": "【Splatoon3】ウデマエS+耐久配信！！ 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-21T22:53:28Z"
  },
  {
    "videoId": "XaFqJAmS7hY",
    "thumbnail": "https://i.ytimg.com/vi/XaFqJAmS7hY/mqdefault.jpg",
    "title": "【Splatoon3】ウデマエS+耐久配信！！ 続き！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-22T22:11:39Z"
  },
  {
    "videoId": "QwBaSbM-OG0",
    "thumbnail": "https://i.ytimg.com/vi/QwBaSbM-OG0/mqdefault.jpg",
    "title": "【Splatoon3】借金が止まらないウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-23T17:20:32Z"
  },
  {
    "videoId": "LpslzPnVJSY",
    "thumbnail": "https://i.ytimg.com/vi/LpslzPnVJSY/mqdefault.jpg",
    "title": "【Splatoon3】枠録り直し|借金が止まらないウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-23T20:20:21Z"
  },
  {
    "videoId": "7UPlG26Yfp0",
    "thumbnail": "https://i.ytimg.com/vi/7UPlG26Yfp0/mqdefault.jpg",
    "title": "【Splatoon3】初フェス！「道具」のみんな！勝つぞ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-24T19:54:40Z"
  },
  {
    "videoId": "5a0zWUwMnb8",
    "thumbnail": "https://i.ytimg.com/vi/5a0zWUwMnb8/mqdefault.jpg",
    "title": "【Splatoon3】初コラボ！「道具」チーム巻き返すぞ！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-25T10:27:16Z"
  },
  {
    "videoId": "6xiiviKeQas",
    "thumbnail": "https://i.ytimg.com/vi/6xiiviKeQas/mqdefault.jpg",
    "title": "【Splatoon3】借金って知ってる？すぐ増えるんだよ。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-09-30T02:45:49Z"
  },
  {
    "videoId": "KO0VIwwf8a8",
    "thumbnail": "https://i.ytimg.com/vi/KO0VIwwf8a8/mqdefault.jpg",
    "title": "【Splatoon3】借金？美味しいです。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-02T01:19:30Z"
  },
  {
    "videoId": "PjamBmpWxDM",
    "thumbnail": "https://i.ytimg.com/vi/PjamBmpWxDM/mqdefault.jpg",
    "title": "【Splatoon3】ここが地下労働？【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-02T15:32:30Z"
  },
  {
    "videoId": "KRJQ6q4-trU",
    "thumbnail": "https://i.ytimg.com/vi/KRJQ6q4-trU/mqdefault.jpg",
    "title": "【Splatoon3】また増えた借金。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-02T23:12:09Z"
  },
  {
    "videoId": "3l-pPSlNsRY",
    "thumbnail": "https://i.ytimg.com/vi/3l-pPSlNsRY/mqdefault.jpg",
    "title": "【Splatoon3】借金は美味しい？ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-03T21:39:23Z"
  },
  {
    "videoId": "Tgxpc_b5qWo",
    "thumbnail": "https://i.ytimg.com/vi/Tgxpc_b5qWo/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第6夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-10-04T15:23:08Z"
  },
  {
    "videoId": "kAIowHgQipo",
    "thumbnail": "https://i.ytimg.com/vi/kAIowHgQipo/mqdefault.jpg",
    "title": "【Splatoon3】借金返済プランどこ？ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-04T18:28:02Z"
  },
  {
    "videoId": "j5rDgeNw12Y",
    "thumbnail": "https://i.ytimg.com/vi/j5rDgeNw12Y/mqdefault.jpg",
    "title": "【Splatoon3】借金生活？いえ、投資です。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-05T18:52:58Z"
  },
  {
    "videoId": "acJ2PJ0aqug",
    "thumbnail": "https://i.ytimg.com/vi/acJ2PJ0aqug/mqdefault.jpg",
    "title": "【Splatoon3】借金いえ、収支黒字です。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-06T13:28:10Z"
  },
  {
    "videoId": "9SqDJt43Eto",
    "thumbnail": "https://i.ytimg.com/vi/9SqDJt43Eto/mqdefault.jpg",
    "title": "【#ホロスプラ部】かくれんぼ&武器縛りでエンジョイ！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-07T14:03:23Z"
  },
  {
    "videoId": "tkeB8h733Mw",
    "thumbnail": "https://i.ytimg.com/vi/tkeB8h733Mw/mqdefault.jpg",
    "title": "【Splatoon3】借金を返しましょう。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-08T00:48:11Z"
  },
  {
    "videoId": "c010r5U7DkU",
    "thumbnail": "https://i.ytimg.com/vi/c010r5U7DkU/mqdefault.jpg",
    "title": "【Splatoon3】借金返済スプラ生活。ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-08T17:37:51Z"
  },
  {
    "videoId": "JX1PSAaS2bo",
    "thumbnail": "https://i.ytimg.com/vi/JX1PSAaS2bo/mqdefault.jpg",
    "title": "【Splatoon3】借金生活返済プランどこ？スプラ生活ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-10T07:15:19Z"
  },
  {
    "videoId": "QmMETQxWq5w",
    "thumbnail": "https://i.ytimg.com/vi/QmMETQxWq5w/mqdefault.jpg",
    "title": "【Splatoon3】この借金生活を終わらせてやる！スプラ生活ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-10T18:31:26Z"
  },
  {
    "videoId": "LITubvHAPmQ",
    "thumbnail": "https://i.ytimg.com/vi/LITubvHAPmQ/mqdefault.jpg",
    "title": "【Splatoon3】ついに借金生活完済！？ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-11T14:05:12Z"
  },
  {
    "videoId": "ghyKn9gVwGI",
    "thumbnail": "https://i.ytimg.com/vi/ghyKn9gVwGI/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第7夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-10-11T15:24:50Z"
  },
  {
    "videoId": "rIWd0X2PjOc",
    "thumbnail": "https://i.ytimg.com/vi/rIWd0X2PjOc/mqdefault.jpg",
    "title": "枠とりなおし！【Splatoon3】ついに借金生活完済！？ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-11T20:01:01Z"
  },
  {
    "videoId": "bmw40AotTLw",
    "thumbnail": "https://i.ytimg.com/vi/bmw40AotTLw/mqdefault.jpg",
    "title": "【Splatoon3】潤い貯金！いくぞ昇格戦！！ウデマエS+への道【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-12T19:46:49Z"
  },
  {
    "videoId": "tdZYJSrH4_k",
    "thumbnail": "https://i.ytimg.com/vi/tdZYJSrH4_k/mqdefault.jpg",
    "title": "【Splatoon3】ヒーローモードで経験値ショッピングだ！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-14T19:32:18Z"
  },
  {
    "videoId": "fO11YZQ3kGQ",
    "thumbnail": "https://i.ytimg.com/vi/fO11YZQ3kGQ/mqdefault.jpg",
    "title": "【Splatoon3】ヒーローモードで経験値ショッピングだ！Part2【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-15T17:24:09Z"
  },
  {
    "videoId": "pfq2fw7edUQ",
    "thumbnail": "https://i.ytimg.com/vi/pfq2fw7edUQ/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第8夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-10-18T15:40:12Z"
  },
  {
    "videoId": "mzwlU09tCbQ",
    "thumbnail": "https://i.ytimg.com/vi/mzwlU09tCbQ/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第9夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-10-25T15:21:57Z"
  },
  {
    "videoId": "TeL5XCSdHOY",
    "thumbnail": "https://i.ytimg.com/vi/TeL5XCSdHOY/mqdefault.jpg",
    "title": "【Splatoon3】借金の後の世界線。ウデマエS+0バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-26T19:07:00Z"
  },
  {
    "videoId": "TGbSLCJ7khA",
    "thumbnail": "https://i.ytimg.com/vi/TGbSLCJ7khA/mqdefault.jpg",
    "title": "【Splatoon3】借金生活シーズン２。ウデマエS+0バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-27T19:04:02Z"
  },
  {
    "videoId": "-UAaCTA4Vv0",
    "thumbnail": "https://i.ytimg.com/vi/-UAaCTA4Vv0/mqdefault.jpg",
    "title": "【Splatoon3】ゲリラ配信中！クマサン武器&ウデマエS+0バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-28T19:05:06Z"
  },
  {
    "videoId": "4P-Od2nnzJ0",
    "thumbnail": "https://i.ytimg.com/vi/4P-Od2nnzJ0/mqdefault.jpg",
    "title": "【Splatoon3】ゲリラ配信中！借金なのか貯金なのか、ウデマエS+0～バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-10-30T20:28:47Z"
  },
  {
    "videoId": "WkHU5g9ZmBU",
    "thumbnail": "https://i.ytimg.com/vi/WkHU5g9ZmBU/mqdefault.jpg",
    "title": "？？？？？？？？？【R.B.J】",
    "publishedAt": "2022-10-31T15:02:52Z"
  },
  {
    "videoId": "d2nV-ZtolTI",
    "thumbnail": "https://i.ytimg.com/vi/d2nV-ZtolTI/mqdefault.jpg",
    "title": "【Minecraft】ホロライブ大運動会にむけて！黄&赤で合同練習する！！！！【アキロゼ視点】",
    "publishedAt": "2022-11-01T12:16:04Z"
  },
  {
    "videoId": "TPQEuZ8J094",
    "thumbnail": "https://i.ytimg.com/vi/TPQEuZ8J094/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】㊗第10夜㊗ | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-11-01T15:41:32Z"
  },
  {
    "videoId": "Q3ziscrVoyY",
    "thumbnail": "https://i.ytimg.com/vi/Q3ziscrVoyY/mqdefault.jpg",
    "title": "【Splatoon3】やばい、スランプ到来か！？？ウデマエS+0～バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-02T21:39:22Z"
  },
  {
    "videoId": "ck2HfmFM7Rk",
    "thumbnail": "https://i.ytimg.com/vi/ck2HfmFM7Rk/mqdefault.jpg",
    "title": "【Splatoon3】ヤグラで盛れるか盛れないか。ウデマエS+0～バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-03T20:26:39Z"
  },
  {
    "videoId": "fzA2KZ4s6XM",
    "thumbnail": "https://i.ytimg.com/vi/fzA2KZ4s6XM/mqdefault.jpg",
    "title": "【Splatoon3】もう投票した？ウデマエS+0～バンカラマッチ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-04T21:52:01Z"
  },
  {
    "videoId": "vQZkRsnlaIM",
    "thumbnail": "https://i.ytimg.com/vi/vQZkRsnlaIM/mqdefault.jpg",
    "title": "【Splatoon3】ついにウデマエS+1になるか！？？バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-05T16:25:43Z"
  },
  {
    "videoId": "55Tk1TlouPg",
    "thumbnail": "https://i.ytimg.com/vi/55Tk1TlouPg/mqdefault.jpg",
    "title": "【Splatoon3】急募：スランプを抜け出す方法！！ウデマエS+バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-06T18:18:14Z"
  },
  {
    "videoId": "maj0FT_uL7k",
    "thumbnail": "https://i.ytimg.com/vi/maj0FT_uL7k/mqdefault.jpg",
    "title": "【Splatoon3】ウデマエS+10を目指して！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-07T21:21:34Z"
  },
  {
    "videoId": "6xMniP3gjOQ",
    "thumbnail": "https://i.ytimg.com/vi/6xMniP3gjOQ/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第11夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-11-08T15:23:38Z"
  },
  {
    "videoId": "qwYfXHfU3sc",
    "thumbnail": "https://i.ytimg.com/vi/qwYfXHfU3sc/mqdefault.jpg",
    "title": "【Splatoon3】現在：S+2|ウデマエS+10を目指して！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-08T18:39:03Z"
  },
  {
    "videoId": "bf85QvSM2N0",
    "thumbnail": "https://i.ytimg.com/vi/bf85QvSM2N0/mqdefault.jpg",
    "title": "【Splatoon3】現在：S+3 |ウデマエS+10を目指して！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-10T20:03:21Z"
  },
  {
    "videoId": "v8YsAv6T9Eo",
    "thumbnail": "https://i.ytimg.com/vi/v8YsAv6T9Eo/mqdefault.jpg",
    "title": "【Splatoon3】くさタイプ優勝するぞおお！！！！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-12T04:55:16Z"
  },
  {
    "videoId": "CP7sOLFnzR4",
    "thumbnail": "https://i.ytimg.com/vi/CP7sOLFnzR4/mqdefault.jpg",
    "title": "【Splatoon3】草しか勝たん！トリカラしたい！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-13T05:08:50Z"
  },
  {
    "videoId": "yDVBOfV9I6U",
    "thumbnail": "https://i.ytimg.com/vi/yDVBOfV9I6U/mqdefault.jpg",
    "title": "ゲリラ！【Splatoon3】スプラフェス草陣営の追い込みじゃあ！！！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-14T00:49:14Z"
  },
  {
    "videoId": "xZpCevQXgFE",
    "thumbnail": "https://i.ytimg.com/vi/xZpCevQXgFE/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第12夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-11-15T15:26:23Z"
  },
  {
    "videoId": "fWsDox5AZu8",
    "thumbnail": "https://i.ytimg.com/vi/fWsDox5AZu8/mqdefault.jpg",
    "title": "【Splatoon3】現在：S+5 |ウデマエS+10を目指して！久しぶりバンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-16T23:06:01Z"
  },
  {
    "videoId": "nsmgobrqBj0",
    "thumbnail": "https://i.ytimg.com/vi/nsmgobrqBj0/mqdefault.jpg",
    "title": "【Splatoon3】現在：S+6 |ウデマエS+10を目指して！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-19T22:37:11Z"
  },
  {
    "videoId": "T3B0Qp3Tc5s",
    "thumbnail": "https://i.ytimg.com/vi/T3B0Qp3Tc5s/mqdefault.jpg",
    "title": "【Splatoon3】現在：ウデマエS+8 リセットまで時間がない！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-21T16:55:32Z"
  },
  {
    "videoId": "0iQ6Y9m1EW4",
    "thumbnail": "https://i.ytimg.com/vi/0iQ6Y9m1EW4/mqdefault.jpg",
    "title": "【Splatoon3】現在：ウデマエS+9 急げ！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-23T09:45:10Z"
  },
  {
    "videoId": "jhCV-d49mz0",
    "thumbnail": "https://i.ytimg.com/vi/jhCV-d49mz0/mqdefault.jpg",
    "title": "【Splatoon3】現在：ウデマエS+9 タスケテ…バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-23T18:28:20Z"
  },
  {
    "videoId": "PZfcDt22Rdw",
    "thumbnail": "https://i.ytimg.com/vi/PZfcDt22Rdw/mqdefault.jpg",
    "title": "【Splatoon3】現在：ウデマエS+9 ここにきて経験値ショッピングがとまらない！バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-24T19:52:47Z"
  },
  {
    "videoId": "wh4oR-24XZ0",
    "thumbnail": "https://i.ytimg.com/vi/wh4oR-24XZ0/mqdefault.jpg",
    "title": "【Splatoon3】現在：ウデマエS+9 昇格戦いくぞ！！（未来予測）バンカラマッチ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-25T22:49:20Z"
  },
  {
    "videoId": "J0-RS-xEuF0",
    "thumbnail": "https://i.ytimg.com/vi/J0-RS-xEuF0/mqdefault.jpg",
    "title": "【ポケモンSV】冒険の始まり！！ジムバッジ集めるぞー！！Part1【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-26T11:21:45Z"
  },
  {
    "videoId": "3qUi0iN5r2M",
    "thumbnail": "https://i.ytimg.com/vi/3qUi0iN5r2M/mqdefault.jpg",
    "title": "【ポケモンSVバイオレット】小生意気ショタっ子プレイでドラマティックポケモン！Part3【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-27T10:22:19Z"
  },
  {
    "videoId": "Gu3MXr4qCwM",
    "thumbnail": "https://i.ytimg.com/vi/Gu3MXr4qCwM/mqdefault.jpg",
    "title": "【ポケモンSVバイオレット】進んだ場所が道となる。Going my wayショタロゼのポケモン旅！ストーリー攻略Part4【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-27T18:32:45Z"
  },
  {
    "videoId": "ZthlXCJFhQE",
    "thumbnail": "https://i.ytimg.com/vi/ZthlXCJFhQE/mqdefault.jpg",
    "title": "枠とり直し！【ポケモンSVバイオレット】進んだ場所が道となる。Going my wayショタロゼのポケモン旅！ストーリー攻略Part4_2【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-27T18:38:45Z"
  },
  {
    "videoId": "XmoB0V6x7Iw",
    "thumbnail": "https://i.ytimg.com/vi/XmoB0V6x7Iw/mqdefault.jpg",
    "title": "最新枠！【ポケモンSVバイオレット】進んだ場所が道となる。Going my wayショタロゼのポケモン旅！ストーリー攻略Part4_3【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-11-27T22:29:08Z"
  },
  {
    "videoId": "sXwWUAhcQEo",
    "thumbnail": "https://i.ytimg.com/vi/sXwWUAhcQEo/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】新シーズン到来！新ブキ13種触ってみる！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-01T20:05:59Z"
  },
  {
    "videoId": "vwfKdKaO2N8",
    "thumbnail": "https://i.ytimg.com/vi/vwfKdKaO2N8/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】楽しい新シーズン遊び尽くせ！！いこうフレアどこまでも…【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-02T19:56:16Z"
  },
  {
    "videoId": "B5N5GvHl8Dg",
    "thumbnail": "https://i.ytimg.com/vi/B5N5GvHl8Dg/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第13夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2022-12-06T15:23:27Z"
  },
  {
    "videoId": "YdPXLxiv5EQ",
    "thumbnail": "https://i.ytimg.com/vi/YdPXLxiv5EQ/mqdefault.jpg",
    "title": "【ドライブ】ひよりんと茨城県を大満喫！ドライブ観光にレッツゴー！前編【茨ひより】",
    "publishedAt": "2022-12-07T09:00:12Z"
  },
  {
    "videoId": "rDQdGr0Cdn0",
    "thumbnail": "https://i.ytimg.com/vi/rDQdGr0Cdn0/mqdefault.jpg",
    "title": "ー魔女と旋律の街 ー/白上フブキ×アキ・ローゼンタール【歌ってみた】",
    "publishedAt": "2022-12-09T13:00:08Z"
  },
  {
    "videoId": "SSoMwcwluow",
    "thumbnail": "https://i.ytimg.com/vi/SSoMwcwluow/mqdefault.jpg",
    "title": "【世界のアソビ大全】アキフブ対決！運の女神はどちらに微笑む？【ホロライブ/白上フブキ×アキ・ローゼンタール】",
    "publishedAt": "2022-12-09T13:13:44Z"
  },
  {
    "videoId": "s46LCXacYqo",
    "thumbnail": "https://i.ytimg.com/vi/s46LCXacYqo/mqdefault.jpg",
    "title": "【クライシスコア-FF7-リユニオン】最推しザックス。ありがとうスクエニさんずっと待ってた/CRISIS CORE -FINAL FANTASY VII- REUNION 1章【ホロライブ/アキロゼ】",
    "publishedAt": "2022-12-10T11:27:34Z"
  },
  {
    "videoId": "EoNuCcSRIbk",
    "thumbnail": "https://i.ytimg.com/vi/EoNuCcSRIbk/mqdefault.jpg",
    "title": "【クライシスコア-FF7-リユニオン】ザックスが良すぎて限界化しています。/CRISIS CORE -FINAL FANTASY VII- REUNION ２章【ホロライブ/アキロゼ】",
    "publishedAt": "2022-12-11T10:19:40Z"
  },
  {
    "videoId": "w1K22FVxxig",
    "thumbnail": "https://i.ytimg.com/vi/w1K22FVxxig/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】パンパンパンパン！！はじめてのビッグランに挑戦！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-11T21:13:13Z"
  },
  {
    "videoId": "i5ZfnQW3sCs",
    "thumbnail": "https://i.ytimg.com/vi/i5ZfnQW3sCs/mqdefault.jpg",
    "title": "【ARK | Fjordur】㊗ムキロゼサーバー復活！みんなでワイワイ聖地作ろー！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-12-15T19:30:31Z"
  },
  {
    "videoId": "3VbJ_RHxa-4",
    "thumbnail": "https://i.ytimg.com/vi/3VbJ_RHxa-4/mqdefault.jpg",
    "title": "【-セガNET麻雀MJ-】雀荘ホロくらぶ杯に向けて特訓じゃ！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-12-16T20:37:14Z"
  },
  {
    "videoId": "HcJX8gxQ3ok",
    "thumbnail": "https://i.ytimg.com/vi/HcJX8gxQ3ok/mqdefault.jpg",
    "title": "【雀荘ホロくらぶ杯】声が出ない！！配牌で殴ればいいか。【ホロライブ/アキロゼ視点】",
    "publishedAt": "2022-12-18T13:17:03Z"
  },
  {
    "videoId": "UBmNujgBuqg",
    "thumbnail": "https://i.ytimg.com/vi/UBmNujgBuqg/mqdefault.jpg",
    "title": "【重大発表あり！】イメージ変わるかも！新髪形にあんな顔もお披露目～！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-23T12:09:53Z"
  },
  {
    "videoId": "nfO8EWPKmuc",
    "thumbnail": "https://i.ytimg.com/vi/nfO8EWPKmuc/mqdefault.jpg",
    "title": "【壺/Getting Over It】今年こそてっぺんに星を飾りたい【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-23T16:41:24Z"
  },
  {
    "videoId": "obGT9_B1V5k",
    "thumbnail": "https://i.ytimg.com/vi/obGT9_B1V5k/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー 】アニソンでメリークリスマス🎄🎅【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-25T09:42:43Z"
  },
  {
    "videoId": "Mo1vopI2Mws",
    "thumbnail": "https://i.ytimg.com/vi/Mo1vopI2Mws/mqdefault.jpg",
    "title": "【超美麗3DCG料理配信】麦ジュースに合う最強のおつまみ作る！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-25T12:51:57Z"
  },
  {
    "videoId": "NyTpnKZ3Ufs",
    "thumbnail": "https://i.ytimg.com/vi/NyTpnKZ3Ufs/mqdefault.jpg",
    "title": "【-セガNET麻雀MJ-】視聴者参加型！振り込めください！！【ホロライブ/アキロゼ】",
    "publishedAt": "2022-12-26T15:56:04Z"
  },
  {
    "videoId": "3vR1GYMZ-Pw",
    "thumbnail": "https://i.ytimg.com/vi/3vR1GYMZ-Pw/mqdefault.jpg",
    "title": "【ポケモンSVバイオレット】ギリギリで勝つロマンがそこにある！ストーリー攻略Part5【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-30T09:52:11Z"
  },
  {
    "videoId": "Cvj-UVpdybY",
    "thumbnail": "https://i.ytimg.com/vi/Cvj-UVpdybY/mqdefault.jpg",
    "title": "【ポケモンSVバイオレット】いざポケモンリーグ！ギリギリで勝つロマンがそこにある！ストーリー攻略Part6【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2022-12-31T05:09:11Z"
  },
  {
    "videoId": "rXoQtnBFlVk",
    "thumbnail": "https://i.ytimg.com/vi/rXoQtnBFlVk/mqdefault.jpg",
    "title": "【雑談/Free talk】麦ジュース飲みながらまったり今年の目標決める！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-01-01T18:20:15Z"
  },
  {
    "videoId": "Df-4paUusGo",
    "thumbnail": "https://i.ytimg.com/vi/Df-4paUusGo/mqdefault.jpg",
    "title": "【ポケモンSV】＃ホロゆびをふる まさかの準決勝で枠をとる【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-01-02T14:12:47Z"
  },
  {
    "videoId": "62Haj_4GTJI",
    "thumbnail": "https://i.ytimg.com/vi/62Haj_4GTJI/mqdefault.jpg",
    "title": "【歌謡曲縛り歌枠】第14夜 | スナックアキロゼの #火曜に歌謡曲 /Japanese old CITY POP【Aki Rosenthal/ホロライブ】",
    "publishedAt": "2023-01-03T15:31:39Z"
  },
  {
    "videoId": "2r1gnZ5HY8s",
    "thumbnail": "https://i.ytimg.com/vi/2r1gnZ5HY8s/mqdefault.jpg",
    "title": "【マリオカート8DX】ホロお正月カップ前日特訓！でもね、新ステージ今日が初めてです。YABE【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-01-06T18:51:45Z"
  },
  {
    "videoId": "B6QHz9TzF4I",
    "thumbnail": "https://i.ytimg.com/vi/B6QHz9TzF4I/mqdefault.jpg",
    "title": "【#ホロお正月CUP2023】いやらしいバナナはお断り！Cグループ予選を超えろ【ホロライブ/アキ・ローゼンタール視点】",
    "publishedAt": "2023-01-07T07:27:44Z"
  },
  {
    "videoId": "-033iWGFZT4",
    "thumbnail": "https://i.ytimg.com/vi/-033iWGFZT4/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】ひけ333倍！！すっぱいチームを勝たせたい！！フェスきちゃー！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-01-07T21:16:59Z"
  },
  {
    "videoId": "vgzDa8GDNfM",
    "thumbnail": "https://i.ytimg.com/vi/vgzDa8GDNfM/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】すっぱい派立ち上がれ！スプラフェス【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-01-08T20:08:16Z"
  },
  {
    "videoId": "8JXWAOtV2r8",
    "thumbnail": "https://i.ytimg.com/vi/8JXWAOtV2r8/mqdefault.jpg",
    "title": "【 HoloCure 】初！ホロキュア参戦！！そしてただいま♥【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-11T17:40:20Z"
  },
  {
    "videoId": "h0LBxG3Gl6I",
    "thumbnail": "https://i.ytimg.com/vi/h0LBxG3Gl6I/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】今から参戦！えいえんのホワイト耐久！スプラフェス【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-12T20:46:59Z"
  },
  {
    "videoId": "jn3zUat1XYo",
    "thumbnail": "https://i.ytimg.com/vi/jn3zUat1XYo/mqdefault.jpg",
    "title": "【 HoloCure 】自キャラ縛り！クリアぐらい簡単だよなああぁぁ！？？【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-15T13:52:52Z"
  },
  {
    "videoId": "uBIsnVeioZk",
    "thumbnail": "https://i.ytimg.com/vi/uBIsnVeioZk/mqdefault.jpg",
    "title": "【 はじめての凸待ち！ 】誕生日ケーキ食べながらパーティーだ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-17T14:12:34Z"
  },
  {
    "videoId": "oJIiRYMZ9fo",
    "thumbnail": "https://i.ytimg.com/vi/oJIiRYMZ9fo/mqdefault.jpg",
    "title": "【GeoGuessr 】方向音痴が場所当てゲーム！地球のどこかに飛ばされる異世界人【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-19T11:27:43Z"
  },
  {
    "videoId": "yE6M33qB7r0",
    "thumbnail": "https://i.ytimg.com/vi/yE6M33qB7r0/mqdefault.jpg",
    "title": "【 HoloCure 】初挑戦ステージへレッツゴー！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-22T17:24:26Z"
  },
  {
    "videoId": "OHc-Hswj-rU",
    "thumbnail": "https://i.ytimg.com/vi/OHc-Hswj-rU/mqdefault.jpg",
    "title": "ゲリラ配信中【GeoGuessr 】年間契約勢のゼロ距離ゲッサー【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-23T17:21:53Z"
  },
  {
    "videoId": "_8dVFpHBuNE",
    "thumbnail": "https://i.ytimg.com/vi/_8dVFpHBuNE/mqdefault.jpg",
    "title": "【雑談/Free Talk 】VRライブありがとう！お話ししよう！お知らせもアリ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-02-25T17:05:44Z"
  },
  {
    "videoId": "JFac6-u6U2M",
    "thumbnail": "https://i.ytimg.com/vi/JFac6-u6U2M/mqdefault.jpg",
    "title": "【#カゲマス 】陰の実力者になるための方法教えます！I need more power【ホロライブ/鷹嶺ルイ×アキ・ローゼンタール】",
    "publishedAt": "2023-03-03T11:37:04Z"
  },
  {
    "videoId": "374VxikPE4A",
    "thumbnail": "https://i.ytimg.com/vi/374VxikPE4A/mqdefault.jpg",
    "title": "【実食 】百味ビーンズ食べてみる…ッ！！！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-03-03T13:42:52Z"
  },
  {
    "videoId": "giEpkoLekt0",
    "thumbnail": "https://i.ytimg.com/vi/giEpkoLekt0/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】視聴者参加型スプラ！新武器縛り！バイトも行きたい【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-03-03T17:48:35Z"
  },
  {
    "videoId": "83TfdcTb3hg",
    "thumbnail": "https://i.ytimg.com/vi/83TfdcTb3hg/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】視聴者参加型スプラ！ビッグランいくぞ！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-03-05T16:56:16Z"
  },
  {
    "videoId": "XmuIwPNHaUc",
    "thumbnail": "https://i.ytimg.com/vi/XmuIwPNHaUc/mqdefault.jpg",
    "title": "🔴ゲリラ配信中【GeoGuessr 】決戦間近！？今日こそゼロ距離ゲッサー【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-03-06T18:42:12Z"
  },
  {
    "videoId": "vtEFQ1Sqdr8",
    "thumbnail": "https://i.ytimg.com/vi/vtEFQ1Sqdr8/mqdefault.jpg",
    "title": "🔴ゲリラ配信中【GeoGuessr 】ヒントを見つける力と知識を増やせ！を教えてゼロゲッサー【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-03-08T17:13:55Z"
  },
  {
    "videoId": "2CSnjBWz6vc",
    "thumbnail": "https://i.ytimg.com/vi/2CSnjBWz6vc/mqdefault.jpg",
    "title": "GeoGuessr のプロと日本のここどこ早く見つけた方が勝ちデュエル！！！【ホロライブ/AZKi×アキ・ローゼンタール】",
    "publishedAt": "2023-03-16T14:45:26Z"
  },
  {
    "videoId": "1kEKlKCqwA4",
    "thumbnail": "https://i.ytimg.com/vi/1kEKlKCqwA4/mqdefault.jpg",
    "title": "【ライブ直後！】感情爆発！濃いめ短め！！I LOVE Rosetai！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-19T15:58:05Z"
  },
  {
    "videoId": "6u1fkDyiAn8",
    "thumbnail": "https://i.ytimg.com/vi/6u1fkDyiAn8/mqdefault.jpg",
    "title": "【 hololive 4th fes.】みんなのツイートみたり振り返ったりいっぱい話そう！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-20T17:36:45Z"
  },
  {
    "videoId": "mdn4AmOSvQA",
    "thumbnail": "https://i.ytimg.com/vi/mdn4AmOSvQA/mqdefault.jpg",
    "title": "【ARK | Fjordur】ホロ鯖ARKを救いたい！お祭りワイバーン卵奪取するぞー！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-21T15:20:20Z"
  },
  {
    "videoId": "WLsPxWZPnZE",
    "thumbnail": "https://i.ytimg.com/vi/WLsPxWZPnZE/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】久しぶりにバンカラマッチカチコミ！勝ち方を思い出せ！！視聴者参加型スプラ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-03-23T18:15:36Z"
  },
  {
    "videoId": "cTV3SMbCwgc",
    "thumbnail": "https://i.ytimg.com/vi/cTV3SMbCwgc/mqdefault.jpg",
    "title": "【ARK | Fjordur】ホロ鯖ARKを救いたい！ムキロゼ工場を共同拠点まで拡大したい！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-24T17:43:44Z"
  },
  {
    "videoId": "ZW9Anbw2wX0",
    "thumbnail": "https://i.ytimg.com/vi/ZW9Anbw2wX0/mqdefault.jpg",
    "title": "【ARK | Fjordur】ホロメン合流予定！カワウソたんで心も体もポカポカになろう💕【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-25T17:10:13Z"
  },
  {
    "videoId": "X3dwoM5KmAc",
    "thumbnail": "https://i.ytimg.com/vi/X3dwoM5KmAc/mqdefault.jpg",
    "title": "【ARK | Fjordur】ホロメン合流予定！新恐竜カルカロドンを求めて！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-26T18:45:56Z"
  },
  {
    "videoId": "e9lUB4KhpJA",
    "thumbnail": "https://i.ytimg.com/vi/e9lUB4KhpJA/mqdefault.jpg",
    "title": "【ARK | Fjordur】1時間限定！ホロ鯖に夏イベきちゃー！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-03-27T16:39:07Z"
  },
  {
    "videoId": "UfcIvMHEeYQ",
    "thumbnail": "https://i.ytimg.com/vi/UfcIvMHEeYQ/mqdefault.jpg",
    "title": "【 雑談/Free Talk】新生活始まりました【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-03T17:36:09Z"
  },
  {
    "videoId": "xqA0sKaP01w",
    "thumbnail": "https://i.ytimg.com/vi/xqA0sKaP01w/mqdefault.jpg",
    "title": "【ARK | Fjordur】新PCでARKがしてみたい！！まったり夏イベ満喫！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-04T20:45:48Z"
  },
  {
    "videoId": "0WfIoqIiW54",
    "thumbnail": "https://i.ytimg.com/vi/0WfIoqIiW54/mqdefault.jpg",
    "title": "【 ぷよテト２】テトリスのいろはを何もしらない今日からはじめる！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-06T19:08:54Z"
  },
  {
    "videoId": "fxCPjfziVAY",
    "thumbnail": "https://i.ytimg.com/vi/fxCPjfziVAY/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】フルパでバイト出勤よー！！タツ狩りしたい【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-04-11T09:55:44Z"
  },
  {
    "videoId": "JSmFeM9TqcQ",
    "thumbnail": "https://i.ytimg.com/vi/JSmFeM9TqcQ/mqdefault.jpg",
    "title": "【 ぷよテト２】視聴者vsアキロゼ実践で経験値積みする！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-11T16:10:18Z"
  },
  {
    "videoId": "hfAdk0ky_Wo",
    "thumbnail": "https://i.ytimg.com/vi/hfAdk0ky_Wo/mqdefault.jpg",
    "title": "【 ぷよテト２】教えてすいちゃん！！大会直前１時間コーチング【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-16T09:07:08Z"
  },
  {
    "videoId": "7fSBBgIwfsU",
    "thumbnail": "https://i.ytimg.com/vi/7fSBBgIwfsU/mqdefault.jpg",
    "title": "【#ホロぷよテト大会】速攻ぶっぱ大作戦！あたたたたたあー！！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-16T11:31:19Z"
  },
  {
    "videoId": "cia2VLJt2Ew",
    "thumbnail": "https://i.ytimg.com/vi/cia2VLJt2Ew/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】参加型バイトコンテスト！！いくぞチームアキロゼ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-04-16T17:14:37Z"
  },
  {
    "videoId": "vKohpZqnQOY",
    "thumbnail": "https://i.ytimg.com/vi/vKohpZqnQOY/mqdefault.jpg",
    "title": "【 歌枠/Sing stream】5億ぶりの歌枠！カラオケアプリ(JOYSOUNDさん音源提供)でやってみる！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-17T21:05:56Z"
  },
  {
    "videoId": "0UG7iWgp96I",
    "thumbnail": "https://i.ytimg.com/vi/0UG7iWgp96I/mqdefault.jpg",
    "title": "【ARK | Fjordur】まったり雑談しつつハティスコ目指してみる【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-21T18:01:43Z"
  },
  {
    "videoId": "oz01-VSw_YA",
    "thumbnail": "https://i.ytimg.com/vi/oz01-VSw_YA/mqdefault.jpg",
    "title": "【 #ホロドロケイ 】全力マイクラ逃走中じゃああ！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-04-29T13:09:02Z"
  },
  {
    "videoId": "Lju5_87lRiI",
    "thumbnail": "https://i.ytimg.com/vi/Lju5_87lRiI/mqdefault.jpg",
    "title": "【雑談/Free Talk】あのね、近況報告です。【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-01T14:56:14Z"
  },
  {
    "videoId": "qIkKCMAwgcc",
    "thumbnail": "https://i.ytimg.com/vi/qIkKCMAwgcc/mqdefault.jpg",
    "title": "ゲリラ配信！【スーパーマリオメーカー2】マリオシリーズごと完全初見なんですよ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-04T19:03:51Z"
  },
  {
    "videoId": "DzovK8R98a0",
    "thumbnail": "https://i.ytimg.com/vi/DzovK8R98a0/mqdefault.jpg",
    "title": "【スーパーマリオメーカー2】完全初見マリオ！練習２回目ですがセンスのかまたりです。【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-05T18:05:08Z"
  },
  {
    "videoId": "gKnKRMlOwiQ",
    "thumbnail": "https://i.ytimg.com/vi/gKnKRMlOwiQ/mqdefault.jpg",
    "title": "【 ＃ホロライブワールド 】チームみらくる！ で目指せ優勝～！！【アキ・ローゼンタール視点/ホロライブ】",
    "publishedAt": "2023-05-06T14:35:38Z"
  },
  {
    "videoId": "VGq09ymdvYA",
    "thumbnail": "https://i.ytimg.com/vi/VGq09ymdvYA/mqdefault.jpg",
    "title": "ゲリラ配信！【Idol Showdown 】話題の格ゲー！！色々やばいらしい！！？？？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-09T17:15:22Z"
  },
  {
    "videoId": "kOLm1UHcWxY",
    "thumbnail": "https://i.ytimg.com/vi/kOLm1UHcWxY/mqdefault.jpg",
    "title": "【ARK | Fjordur】ほぼ雑談！工業鍋とメディカルブリュー仕込み【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-14T14:30:51Z"
  },
  {
    "videoId": "-KdAlUR-IIQ",
    "thumbnail": "https://i.ytimg.com/vi/-KdAlUR-IIQ/mqdefault.jpg",
    "title": "【スーパーマリオメーカー2】完全初見マリオ！全ステージ攻略めざす！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-15T17:33:47Z"
  },
  {
    "videoId": "pJhCLEynxYo",
    "thumbnail": "https://i.ytimg.com/vi/pJhCLEynxYo/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】新シーズン目前！バンカラマッチにカチコミ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-17T18:19:45Z"
  },
  {
    "videoId": "fuRvKVoFAY8",
    "thumbnail": "https://i.ytimg.com/vi/fuRvKVoFAY8/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】ついに・・・Xマッチに行く時がきた・・・うっ・・・【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-18T17:03:58Z"
  },
  {
    "videoId": "phc_DvnRTT8",
    "thumbnail": "https://i.ytimg.com/vi/phc_DvnRTT8/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】はじめてのXマッチは魔境でした！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-19T17:09:43Z"
  },
  {
    "videoId": "szQcivTvt7w",
    "thumbnail": "https://i.ytimg.com/vi/szQcivTvt7w/mqdefault.jpg",
    "title": "お知らせ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-20T12:55:19Z"
  },
  {
    "videoId": "cdGmmd3OCDQ",
    "thumbnail": "https://i.ytimg.com/vi/cdGmmd3OCDQ/mqdefault.jpg",
    "title": "2023年ミュージカルはコレだ！！！ #Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-20T14:01:22Z"
  },
  {
    "videoId": "_o5DybK7fFY",
    "thumbnail": "https://i.ytimg.com/vi/_o5DybK7fFY/mqdefault.jpg",
    "title": "アキロゼ5周年ティザームービー【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-20T14:17:27Z"
  },
  {
    "videoId": "cBu-JOCOlvc",
    "thumbnail": "https://i.ytimg.com/vi/cBu-JOCOlvc/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】はじめてのXマッチ！アサリ編！！視聴者参加クマフェスも！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-20T18:42:46Z"
  },
  {
    "videoId": "W7ffh87fnew",
    "thumbnail": "https://i.ytimg.com/vi/W7ffh87fnew/mqdefault.jpg",
    "title": "忙しい人のためのアキロゼ2022生誕祭振り返り①",
    "publishedAt": "2023-05-21T10:00:21Z"
  },
  {
    "videoId": "1b4m0og2p74",
    "thumbnail": "https://i.ytimg.com/vi/1b4m0og2p74/mqdefault.jpg",
    "title": "【スーパーマリオメーカー2】完全初見マリオ！ストーリー全ステージ攻略めざす！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-21T11:33:49Z"
  },
  {
    "videoId": "TNn0SHFDt00",
    "thumbnail": "https://i.ytimg.com/vi/TNn0SHFDt00/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】クマフェス！クマフェス！#ホロスプラ部 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-21T14:29:14Z"
  },
  {
    "videoId": "cRoTUffooO4",
    "thumbnail": "https://i.ytimg.com/vi/cRoTUffooO4/mqdefault.jpg",
    "title": "3Dミュージカルどう思う？ #Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-22T03:00:23Z"
  },
  {
    "videoId": "YSnlxR1qBNo",
    "thumbnail": "https://i.ytimg.com/vi/YSnlxR1qBNo/mqdefault.jpg",
    "title": "【Q REMASTERED】IQ５億【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-22T14:28:07Z"
  },
  {
    "videoId": "ja9z_mhvMLA",
    "thumbnail": "https://i.ytimg.com/vi/ja9z_mhvMLA/mqdefault.jpg",
    "title": "ホロメンとの大団円が最高すぎた！！#Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-23T03:00:08Z"
  },
  {
    "videoId": "_WF-NIIjhKc",
    "thumbnail": "https://i.ytimg.com/vi/_WF-NIIjhKc/mqdefault.jpg",
    "title": "【Q REMASTERED】IQ高めます【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-23T11:13:07Z"
  },
  {
    "videoId": "xsuRrj9KE4Q",
    "thumbnail": "https://i.ytimg.com/vi/xsuRrj9KE4Q/mqdefault.jpg",
    "title": "【雑談/Free Talk】安眠枠！雑談＆スパチャ読みます！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-23T17:06:08Z"
  },
  {
    "videoId": "mj0PmS8KDAI",
    "thumbnail": "https://i.ytimg.com/vi/mj0PmS8KDAI/mqdefault.jpg",
    "title": "【Trombone Champ】ぷぉおおおおおお！！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-24T11:05:31Z"
  },
  {
    "videoId": "6AwlRNnjThA",
    "thumbnail": "https://i.ytimg.com/vi/6AwlRNnjThA/mqdefault.jpg",
    "title": "【Pineapple on pizza】なんだこれ！？steamで98％の人が圧倒的高評価をした謎ゲーやってみる！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-25T10:23:01Z"
  },
  {
    "videoId": "ThV_R-SFf4A",
    "thumbnail": "https://i.ytimg.com/vi/ThV_R-SFf4A/mqdefault.jpg",
    "title": "【 Minecraft 】ついに初上陸！新ホロ鯖観光じゃー！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-25T15:59:05Z"
  },
  {
    "videoId": "Lo3vjfnSdk4",
    "thumbnail": "https://i.ytimg.com/vi/Lo3vjfnSdk4/mqdefault.jpg",
    "title": "【The Outlast Trials】コラボ前に予習するぞ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-26T12:16:08Z"
  },
  {
    "videoId": "L85OOgTymFY",
    "thumbnail": "https://i.ytimg.com/vi/L85OOgTymFY/mqdefault.jpg",
    "title": "【The Outlast Trials】激やば恐怖度MAX！#ホロ１期生コラボ   でハチャメチャホラー脱出ゲーム！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-26T15:24:08Z"
  },
  {
    "videoId": "n-pNnnM2ERs",
    "thumbnail": "https://i.ytimg.com/vi/n-pNnnM2ERs/mqdefault.jpg",
    "title": "【  #アキロゼ生誕祭2023 】ーStart your journeyー￤3DLIVE【ホロライブ】",
    "publishedAt": "2023-05-27T13:04:12Z"
  },
  {
    "videoId": "XVaZcvSpn5o",
    "thumbnail": "https://i.ytimg.com/vi/XVaZcvSpn5o/mqdefault.jpg",
    "title": "【The Outlast Trials】ホラゲ耐性０なのに、楽しい気持ちが芽生え始めてます。フブキちゃんと一緒にならクリア目指せるか！？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-28T15:52:05Z"
  },
  {
    "videoId": "spfhdey2KUw",
    "thumbnail": "https://i.ytimg.com/vi/spfhdey2KUw/mqdefault.jpg",
    "title": "【ARK | Fjordur】スーパーARK DAYその１【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-29T04:05:43Z"
  },
  {
    "videoId": "1uirWHKBzd8",
    "thumbnail": "https://i.ytimg.com/vi/1uirWHKBzd8/mqdefault.jpg",
    "title": "【ARK | Fjordur】スーパーARK DAYその２【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-29T05:07:10Z"
  },
  {
    "videoId": "eAkOFltRp-g",
    "thumbnail": "https://i.ytimg.com/vi/eAkOFltRp-g/mqdefault.jpg",
    "title": "【ARK | Fjordur】スーパーARK DAYその３【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-29T06:10:54Z"
  },
  {
    "videoId": "wtPVvRYyld8",
    "thumbnail": "https://i.ytimg.com/vi/wtPVvRYyld8/mqdefault.jpg",
    "title": "【 振り返り】制作秘話などなど！同時視聴もしつつ話すよ～ #アキロゼ生誕祭2023 【ホロライブ】",
    "publishedAt": "2023-05-29T13:44:30Z"
  },
  {
    "videoId": "nTOY9IlaVmw",
    "thumbnail": "https://i.ytimg.com/vi/nTOY9IlaVmw/mqdefault.jpg",
    "title": "【オフコラボ】ちょこ先生＆スバルちゃんとクレープパーティー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-05-30T12:16:36Z"
  },
  {
    "videoId": "UxBGTdUnZoE",
    "thumbnail": "https://i.ytimg.com/vi/UxBGTdUnZoE/mqdefault.jpg",
    "title": "はい！はい！はい！今ですよ！ #Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-31T12:30:44Z"
  },
  {
    "videoId": "5ptPdROWX5s",
    "thumbnail": "https://i.ytimg.com/vi/5ptPdROWX5s/mqdefault.jpg",
    "title": "待ち合わせ場所はここで #Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-05-31T22:24:34Z"
  },
  {
    "videoId": "AB34mfvKFoQ",
    "thumbnail": "https://i.ytimg.com/vi/AB34mfvKFoQ/mqdefault.jpg",
    "title": "いっち！に！さん！し！ #Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-01T03:00:04Z"
  },
  {
    "videoId": "GW1R1oTYngE",
    "thumbnail": "https://i.ytimg.com/vi/GW1R1oTYngE/mqdefault.jpg",
    "title": "くんくん #Shorts 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-01T10:00:08Z"
  },
  {
    "videoId": "hURqBaVxnSg",
    "thumbnail": "https://i.ytimg.com/vi/hURqBaVxnSg/mqdefault.jpg",
    "title": "【 #アキロゼ5周年Live 】ーHistoric ROUTE ５ー￤3DLIVE【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-01T13:21:59Z"
  },
  {
    "videoId": "6U3jnXOGCK4",
    "thumbnail": "https://i.ytimg.com/vi/6U3jnXOGCK4/mqdefault.jpg",
    "title": "【 アキロゼ祭打ち上げ会場】5周年ありがとー！！#アキロゼ5周年Live【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-06-01T14:42:33Z"
  },
  {
    "videoId": "6j-bfTGESMY",
    "thumbnail": "https://i.ytimg.com/vi/6j-bfTGESMY/mqdefault.jpg",
    "title": "ゲリラ！【Splatoon3/スプラトゥーン3】視聴者参加型！イベントマッチいこーよ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-03T14:56:37Z"
  },
  {
    "videoId": "WlI_4-3Xlro",
    "thumbnail": "https://i.ytimg.com/vi/WlI_4-3Xlro/mqdefault.jpg",
    "title": "視聴者参加型！【Splatoon3/スプラトゥーン3】ウルショ祭り！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-06T12:12:59Z"
  },
  {
    "videoId": "3D6RrbGzQpc",
    "thumbnail": "https://i.ytimg.com/vi/3D6RrbGzQpc/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】MR3～を攻略せよ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-07T18:36:53Z"
  },
  {
    "videoId": "ooQ661sVFq8",
    "thumbnail": "https://i.ytimg.com/vi/ooQ661sVFq8/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】★MR4～ガンランスソロ攻略！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-08T15:45:38Z"
  },
  {
    "videoId": "Ci4ZmFgMylQ",
    "thumbnail": "https://i.ytimg.com/vi/Ci4ZmFgMylQ/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】★MR5～ガンランスソロ攻略！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-09T14:44:06Z"
  },
  {
    "videoId": "RziCg5aQZeI",
    "thumbnail": "https://i.ytimg.com/vi/RziCg5aQZeI/mqdefault.jpg",
    "title": "【オフコラボ】ノエル団長＆ラミィちゃんとクレープパーティー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-06-10T10:14:05Z"
  },
  {
    "videoId": "WMmdo6xhoNc",
    "thumbnail": "https://i.ytimg.com/vi/WMmdo6xhoNc/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】★MR10～ガンランスソロ攻略！！究極のモロコシを求めて【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-11T11:49:06Z"
  },
  {
    "videoId": "ihb_jAV4DBI",
    "thumbnail": "https://i.ytimg.com/vi/ihb_jAV4DBI/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】#ホロスプラ部  バイトリーダーは誰だ！？【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-11T15:42:37Z"
  },
  {
    "videoId": "0KzP441zQP8",
    "thumbnail": "https://i.ytimg.com/vi/0KzP441zQP8/mqdefault.jpg",
    "title": "視聴者参加型！【Splatoon3/スプラトゥーン3】深夜のブキチ杯イベントマッチいこーぜ！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-15T20:24:21Z"
  },
  {
    "videoId": "hP09FTe5Do0",
    "thumbnail": "https://i.ytimg.com/vi/hP09FTe5Do0/mqdefault.jpg",
    "title": "【BLUE PROTOCOL】初MMOブルプロやってみる！冒険のはじまりだ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-16T19:14:49Z"
  },
  {
    "videoId": "8erEn22KeFI",
    "thumbnail": "https://i.ytimg.com/vi/8erEn22KeFI/mqdefault.jpg",
    "title": "【BLUE PROTOCOL:ブルプロ】課金ガチャで神引きします【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-17T12:20:26Z"
  },
  {
    "videoId": "6HXSEhzKnAM",
    "thumbnail": "https://i.ytimg.com/vi/6HXSEhzKnAM/mqdefault.jpg",
    "title": "【#ホロ１期生コラボ】みんなで餃子作るぞー！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-18T09:04:22Z"
  },
  {
    "videoId": "m8ySOYD1xWw",
    "thumbnail": "https://i.ytimg.com/vi/m8ySOYD1xWw/mqdefault.jpg",
    "title": "【カメラあり/お料理ASMR】餃子包みます！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-19T15:50:59Z"
  },
  {
    "videoId": "QGD0LlSD1fI",
    "thumbnail": "https://i.ytimg.com/vi/QGD0LlSD1fI/mqdefault.jpg",
    "title": "記念すべきスーパーラッキーセブン見守り配信！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-20T16:51:41Z"
  },
  {
    "videoId": "CfLH4egTl-w",
    "thumbnail": "https://i.ytimg.com/vi/CfLH4egTl-w/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】元借金返済勢再びS+への道！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-21T18:48:20Z"
  },
  {
    "videoId": "orxmprEWTk0",
    "thumbnail": "https://i.ytimg.com/vi/orxmprEWTk0/mqdefault.jpg",
    "title": "緊急ゲリラ！なにやら謎のタグが作られている！？【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-22T16:55:28Z"
  },
  {
    "videoId": "1-R04YELPxk",
    "thumbnail": "https://i.ytimg.com/vi/1-R04YELPxk/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】★MR１００をめざして！！ガンランスを信じよ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-23T18:20:09Z"
  },
  {
    "videoId": "dnMe6b_ZAsU",
    "thumbnail": "https://i.ytimg.com/vi/dnMe6b_ZAsU/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】Xマッチへの挑戦！Part1【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-24T19:54:04Z"
  },
  {
    "videoId": "BCMEfQHdUPY",
    "thumbnail": "https://i.ytimg.com/vi/BCMEfQHdUPY/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】Xマッチへの挑戦！Part2【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-06-26T19:39:24Z"
  },
  {
    "videoId": "Jxu9kULlRpw",
    "thumbnail": "https://i.ytimg.com/vi/Jxu9kULlRpw/mqdefault.jpg",
    "title": "【ARK | Fjordur】ブルードマザー目指して洞窟攻略！大物アーティファクト編【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-06-27T18:25:41Z"
  },
  {
    "videoId": "pMdYj5fy1F4",
    "thumbnail": "https://i.ytimg.com/vi/pMdYj5fy1F4/mqdefault.jpg",
    "title": "【ARK | Fjordur】ブルードマザー討伐編！！TEK文明を手に入れろ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-06-28T19:17:49Z"
  },
  {
    "videoId": "CYcY8aNV6wU",
    "thumbnail": "https://i.ytimg.com/vi/CYcY8aNV6wU/mqdefault.jpg",
    "title": "【ARK | Fjordur】ギガノト、カルカロ、ヴェロナ・・・強さが欲しい【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-06-29T18:28:46Z"
  },
  {
    "videoId": "EjaLM1Lpee4",
    "thumbnail": "https://i.ytimg.com/vi/EjaLM1Lpee4/mqdefault.jpg",
    "title": "【ARK | Fjordur】ギガノトお嫁さんが欲しい！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-06-30T18:47:00Z"
  },
  {
    "videoId": "TEwLLVazSo8",
    "thumbnail": "https://i.ytimg.com/vi/TEwLLVazSo8/mqdefault.jpg",
    "title": "【ARK | Fjordur】月末５日連続ARK！ギガノトが欲しい！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-01T17:19:58Z"
  },
  {
    "videoId": "ZV-YHf0ot6c",
    "thumbnail": "https://i.ytimg.com/vi/ZV-YHf0ot6c/mqdefault.jpg",
    "title": "やばい！夏がきている！！！！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-13T15:54:33Z"
  },
  {
    "videoId": "9mKJVNmYPYg",
    "thumbnail": "https://i.ytimg.com/vi/9mKJVNmYPYg/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】Xマッチョー！！！！Part3【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-14T20:00:16Z"
  },
  {
    "videoId": "BzIDE8BKsrE",
    "thumbnail": "https://i.ytimg.com/vi/BzIDE8BKsrE/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】#ホロスプラ部 ストロベリー派いくぞー！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-15T18:03:59Z"
  },
  {
    "videoId": "iV9LZWxIgUo",
    "thumbnail": "https://i.ytimg.com/vi/iV9LZWxIgUo/mqdefault.jpg",
    "title": "【オフコラボ】特別回!！いろはちゃん＆ルイルイとクレープパーティー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-16T11:11:47Z"
  },
  {
    "videoId": "o7QLF68I7yY",
    "thumbnail": "https://i.ytimg.com/vi/o7QLF68I7yY/mqdefault.jpg",
    "title": "【Only up!】完全初見プレイでどこまで登れるのか！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-20T18:32:41Z"
  },
  {
    "videoId": "bjamu7RA8fk",
    "thumbnail": "https://i.ytimg.com/vi/bjamu7RA8fk/mqdefault.jpg",
    "title": "【BLUE PROTOCOL:ブルプロ】水着だ！夏イベだ！ガチャで神引きだ！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-21T16:12:41Z"
  },
  {
    "videoId": "EwoptHBwyrM",
    "thumbnail": "https://i.ytimg.com/vi/EwoptHBwyrM/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】Xマッチョー！！！！Part4【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-23T18:41:39Z"
  },
  {
    "videoId": "fRRCe_iE5ts",
    "thumbnail": "https://i.ytimg.com/vi/fRRCe_iE5ts/mqdefault.jpg",
    "title": "だってシュワシュワ美味しいんだもん♡#ホロサマshorts #hololivesummer2023 #shorts",
    "publishedAt": "2023-07-24T03:00:28Z"
  },
  {
    "videoId": "kbv3OELrPiE",
    "thumbnail": "https://i.ytimg.com/vi/kbv3OELrPiE/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】Xマッチョー！！！！Part5【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-24T17:57:34Z"
  },
  {
    "videoId": "j79WBo79vcI",
    "thumbnail": "https://i.ytimg.com/vi/j79WBo79vcI/mqdefault.jpg",
    "title": "【ARK | Fjordur】月末５日連続ARK！ギガノト＆ベロナテイムする！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-25T19:08:32Z"
  },
  {
    "videoId": "1DjcJUupn0c",
    "thumbnail": "https://i.ytimg.com/vi/1DjcJUupn0c/mqdefault.jpg",
    "title": "【ARK | Fjordur】月末５日連続ARK！高レベルのギガノト来い！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-26T16:12:50Z"
  },
  {
    "videoId": "r44vYVuLOuQ",
    "thumbnail": "https://i.ytimg.com/vi/r44vYVuLOuQ/mqdefault.jpg",
    "title": "【ARK | Fjordur】月末５日連続ARK！ギガノトリベンジマッチ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-27T18:39:30Z"
  },
  {
    "videoId": "Nb2c6301nMs",
    "thumbnail": "https://i.ytimg.com/vi/Nb2c6301nMs/mqdefault.jpg",
    "title": "【ARK | Fjordur】月末５日連続ARK！極寒の地ヨトゥンヘイムへ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-28T17:39:00Z"
  },
  {
    "videoId": "RM_JOkYh1OM",
    "thumbnail": "https://i.ytimg.com/vi/RM_JOkYh1OM/mqdefault.jpg",
    "title": "【#ホロサマ歌枠リレー】水着でスプラッシュ歌枠！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-29T15:45:16Z"
  },
  {
    "videoId": "zIVXSbwIsLw",
    "thumbnail": "https://i.ytimg.com/vi/zIVXSbwIsLw/mqdefault.jpg",
    "title": "【ARK | Fjordur】月末５日連続ARK！最後の中ボス戦！くまあああああ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-07-29T18:42:31Z"
  },
  {
    "videoId": "JrMukhxcJAo",
    "thumbnail": "https://i.ytimg.com/vi/JrMukhxcJAo/mqdefault.jpg",
    "title": "【雑談/Free Talk】行ってきます！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-07-31T17:14:45Z"
  },
  {
    "videoId": "boxNfyKottw",
    "thumbnail": "https://i.ytimg.com/vi/boxNfyKottw/mqdefault.jpg",
    "title": "【オフコラボ】オリー＆アーニャと緊急ゲリラでクレープパーティー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-03T15:45:06Z"
  },
  {
    "videoId": "p4Vva2AP7EU",
    "thumbnail": "https://i.ytimg.com/vi/p4Vva2AP7EU/mqdefault.jpg",
    "title": "【オフコラボ】清楚組？アズアズ＆こんこよとクレープパーティー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-08T10:29:31Z"
  },
  {
    "videoId": "phiS-AmS0-k",
    "thumbnail": "https://i.ytimg.com/vi/phiS-AmS0-k/mqdefault.jpg",
    "title": "【雑談/Free Talk】激混み花火がヤバすぎた！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-09T16:22:12Z"
  },
  {
    "videoId": "YEC56yGJmzw",
    "thumbnail": "https://i.ytimg.com/vi/YEC56yGJmzw/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】アプデで寿司民大歓喜！フェス投票は〇〇！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-10T19:59:45Z"
  },
  {
    "videoId": "qmDb9TKJ4kI",
    "thumbnail": "https://i.ytimg.com/vi/qmDb9TKJ4kI/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】ゲリラ配信！視聴者参加タイムあり！イベントマッチいくぞー！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-11T12:15:44Z"
  },
  {
    "videoId": "wvJ7HkA5XHk",
    "thumbnail": "https://i.ytimg.com/vi/wvJ7HkA5XHk/mqdefault.jpg",
    "title": "【つぐのひシリーズ完全初見！】美魔女の真実？？？怖いの怖くないの？？【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-12T10:54:25Z"
  },
  {
    "videoId": "pho9jlDDoXo",
    "thumbnail": "https://i.ytimg.com/vi/pho9jlDDoXo/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】フェス！えいえん耐久！正直全部欲しいよね【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-12T18:37:54Z"
  },
  {
    "videoId": "218w-dZ1o0c",
    "thumbnail": "https://i.ytimg.com/vi/218w-dZ1o0c/mqdefault.jpg",
    "title": "【ピクミン１/完全初見！】ピクミンなにそれ美味しいの？原初のピクミンから始まる物語【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-13T12:19:35Z"
  },
  {
    "videoId": "LS2tIztzeLw",
    "thumbnail": "https://i.ytimg.com/vi/LS2tIztzeLw/mqdefault.jpg",
    "title": "【ピクミン１/完全初見！】ピクミンなにそれ美味しいの？原初のピクミンから始まる物語Part2【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-14T15:17:27Z"
  },
  {
    "videoId": "xpHW66fUIUQ",
    "thumbnail": "https://i.ytimg.com/vi/xpHW66fUIUQ/mqdefault.jpg",
    "title": "【激ムズ！ピクミン１】2度とバッドエンドにしない！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-17T12:05:34Z"
  },
  {
    "videoId": "fznR3yUZIPk",
    "thumbnail": "https://i.ytimg.com/vi/fznR3yUZIPk/mqdefault.jpg",
    "title": "【激ムズ！ピクミン１】絶滅で罰ゲーム！遭難１１日目～【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-18T14:57:21Z"
  },
  {
    "videoId": "0QJ-G8Juw34",
    "thumbnail": "https://i.ytimg.com/vi/0QJ-G8Juw34/mqdefault.jpg",
    "title": "【ドンキーコング２】#ホロ１期ドンキ２並走 絶対優勝！２位以下で罰ゲーム【アキ・ローゼンタールホロライブ】",
    "publishedAt": "2023-08-19T18:30:41Z"
  },
  {
    "videoId": "Wz8Oq2YMqco",
    "thumbnail": "https://i.ytimg.com/vi/Wz8Oq2YMqco/mqdefault.jpg",
    "title": "【ARK | Fjordur】ビンゴミッションほぼARKで埋められる説！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-22T17:59:09Z"
  },
  {
    "videoId": "CIeOl0Xs0hI",
    "thumbnail": "https://i.ytimg.com/vi/CIeOl0Xs0hI/mqdefault.jpg",
    "title": "【ARK | Fjordur】超危険な水中洞窟が絶対ヤバい。恐怖の洞窟攻略編！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-23T16:13:13Z"
  },
  {
    "videoId": "jD0feFSqkBk",
    "thumbnail": "https://i.ytimg.com/vi/jD0feFSqkBk/mqdefault.jpg",
    "title": "抜き打ち！４７都道府県テスト！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-08-24T03:49:32Z"
  },
  {
    "videoId": "L053dVxwJeU",
    "thumbnail": "https://i.ytimg.com/vi/L053dVxwJeU/mqdefault.jpg",
    "title": "【#ホロサマ大感謝祭 】クイズ！ビンゴ！夏イベきちゃー！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-25T12:30:30Z"
  },
  {
    "videoId": "oTZZeFT2rjA",
    "thumbnail": "https://i.ytimg.com/vi/oTZZeFT2rjA/mqdefault.jpg",
    "title": "真夜中ゲリラ配信！安眠雑談など【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-29T18:25:23Z"
  },
  {
    "videoId": "2nPf2YOlp8I",
    "thumbnail": "https://i.ytimg.com/vi/2nPf2YOlp8I/mqdefault.jpg",
    "title": "歌ってみた #強風オールバック  #shorts 【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-30T09:08:56Z"
  },
  {
    "videoId": "H5vST08SD6g",
    "thumbnail": "https://i.ytimg.com/vi/H5vST08SD6g/mqdefault.jpg",
    "title": "強風オールバック/アキ・ローゼンタール(cover)",
    "publishedAt": "2023-08-30T09:30:08Z"
  },
  {
    "videoId": "sEASg3pEANM",
    "thumbnail": "https://i.ytimg.com/vi/sEASg3pEANM/mqdefault.jpg",
    "title": "【ARK | Fjordur】うほほー！！！ゴリラボス戦バトルじゃー！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-30T10:53:48Z"
  },
  {
    "videoId": "5uf68xy1jgk",
    "thumbnail": "https://i.ytimg.com/vi/5uf68xy1jgk/mqdefault.jpg",
    "title": "【ARK | Fjordur】強者＆狡猾の洞窟攻略するぞ！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-30T16:11:19Z"
  },
  {
    "videoId": "bUeZ9E-mdoU",
    "thumbnail": "https://i.ytimg.com/vi/bUeZ9E-mdoU/mqdefault.jpg",
    "title": "エンジェルヘブン再出発【アキ・ローゼンタール×大空スバル/ホロライブ】",
    "publishedAt": "2023-08-31T14:47:48Z"
  },
  {
    "videoId": "gUgh1g7KObU",
    "thumbnail": "https://i.ytimg.com/vi/gUgh1g7KObU/mqdefault.jpg",
    "title": "【ARK | Fjordur】原始ボス！ドラゴン討伐戦じゃー！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-31T17:20:32Z"
  },
  {
    "videoId": "TPO2UVBnrH8",
    "thumbnail": "https://i.ytimg.com/vi/TPO2UVBnrH8/mqdefault.jpg",
    "title": "【ARK | Fjordur】ついにドラゴン討伐戦じゃー！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-08-31T18:40:25Z"
  },
  {
    "videoId": "Ba2-9IIEUEI",
    "thumbnail": "https://i.ytimg.com/vi/Ba2-9IIEUEI/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】新武器！新ステ！新シーズンきちゃああ！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-09-01T02:51:56Z"
  },
  {
    "videoId": "9HMwcMmnPaw",
    "thumbnail": "https://i.ytimg.com/vi/9HMwcMmnPaw/mqdefault.jpg",
    "title": "【漢字でGO!】間違えるわけないｗｗｗ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-09-02T15:36:24Z"
  },
  {
    "videoId": "Nhcbe3JinAQ",
    "thumbnail": "https://i.ytimg.com/vi/Nhcbe3JinAQ/mqdefault.jpg",
    "title": "【漢字でGO！】超鬼ムズ漢字を乗り越えろ！！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-09-05T16:57:55Z"
  },
  {
    "videoId": "dFl6h4cUrs0",
    "thumbnail": "https://i.ytimg.com/vi/dFl6h4cUrs0/mqdefault.jpg",
    "title": "【 Minecraft 】実は二人で初コラボ！住んでもいい場所があるって聞いてきました！【猫又おかゆ×アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-06T15:01:32Z"
  },
  {
    "videoId": "fDJUBhzbOA0",
    "thumbnail": "https://i.ytimg.com/vi/fDJUBhzbOA0/mqdefault.jpg",
    "title": "【 Minecraft 】住所が決まったので暮らし始めるぞ！なお地下なので日当たりなし【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-07T15:56:34Z"
  },
  {
    "videoId": "gTNyTiG63uQ",
    "thumbnail": "https://i.ytimg.com/vi/gTNyTiG63uQ/mqdefault.jpg",
    "title": "【 Minecraft 】拠点作り！巨大な地下空間を求めて！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-08T15:24:47Z"
  },
  {
    "videoId": "3jv_p7nbr_M",
    "thumbnail": "https://i.ytimg.com/vi/3jv_p7nbr_M/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】#あっぷれあ でマンタロー陣営 フェス応援参戦！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-09-09T17:39:15Z"
  },
  {
    "videoId": "yi2krayV8wo",
    "thumbnail": "https://i.ytimg.com/vi/yi2krayV8wo/mqdefault.jpg",
    "title": "【 Minecraft 】マイクラ！！！！！！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-11T12:12:57Z"
  },
  {
    "videoId": "eRdlybIfqQ8",
    "thumbnail": "https://i.ytimg.com/vi/eRdlybIfqQ8/mqdefault.jpg",
    "title": "【超ゲリラ！】初見さん大歓迎！コメントのみんなとお話し！聞きたいこと、聞いてほしいことどうぞ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-12T10:25:04Z"
  },
  {
    "videoId": "nQRe8Ltw-0k",
    "thumbnail": "https://i.ytimg.com/vi/nQRe8Ltw-0k/mqdefault.jpg",
    "title": "【晩酌雑談】BJライブお疲れ様♡みんなで乾杯しよ～！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-14T16:06:41Z"
  },
  {
    "videoId": "eons3WlEeuQ",
    "thumbnail": "https://i.ytimg.com/vi/eons3WlEeuQ/mqdefault.jpg",
    "title": "【 Minecraft 】地底開拓するぞ！冒険もしたいよ！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-15T19:50:38Z"
  },
  {
    "videoId": "53R-hq5AY0M",
    "thumbnail": "https://i.ytimg.com/vi/53R-hq5AY0M/mqdefault.jpg",
    "title": "【 Minecraft 】建築レベル赤ちゃんを見守る会【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-16T16:40:02Z"
  },
  {
    "videoId": "_O5USb9QfH0",
    "thumbnail": "https://i.ytimg.com/vi/_O5USb9QfH0/mqdefault.jpg",
    "title": "配信したい！！！タスク終わらなかったら少しお話などでも考えている【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-20T17:19:40Z"
  },
  {
    "videoId": "bY_lOP9sHjg",
    "thumbnail": "https://i.ytimg.com/vi/bY_lOP9sHjg/mqdefault.jpg",
    "title": "【 Minecraft 】桜が欲しい！冒険と地下拠点開拓！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-21T19:55:00Z"
  },
  {
    "videoId": "TNTFa2sgTLA",
    "thumbnail": "https://i.ytimg.com/vi/TNTFa2sgTLA/mqdefault.jpg",
    "title": "【 Minecraft 】にもつパンパンの旅～スニッファーどこにいるん？～【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-22T17:37:04Z"
  },
  {
    "videoId": "ZI0rVVvzSuI",
    "thumbnail": "https://i.ytimg.com/vi/ZI0rVVvzSuI/mqdefault.jpg",
    "title": "【同時視聴】前編￤サイバーパンクエッジランナーズを見るよ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-23T13:31:09Z"
  },
  {
    "videoId": "6dcLiF7Cb08",
    "thumbnail": "https://i.ytimg.com/vi/6dcLiF7Cb08/mqdefault.jpg",
    "title": "【同時視聴】後編￤サイバーパンクエッジランナーズを見るよ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-24T14:05:42Z"
  },
  {
    "videoId": "4Nv0n_NMXlo",
    "thumbnail": "https://i.ytimg.com/vi/4Nv0n_NMXlo/mqdefault.jpg",
    "title": "【Cyberpunk2077】最新DLC最速先行プレイ！！ 仮初めの自由 | サイバーパンク2077【ホロライブ/アキロゼAkirose】",
    "publishedAt": "2023-09-25T15:57:43Z"
  },
  {
    "videoId": "C7vIIhDnO78",
    "thumbnail": "https://i.ytimg.com/vi/C7vIIhDnO78/mqdefault.jpg",
    "title": "【 Minecraft 】にもつパンパンの旅～ここはどこ編～【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-26T12:32:04Z"
  },
  {
    "videoId": "8fVGXZgMXPo",
    "thumbnail": "https://i.ytimg.com/vi/8fVGXZgMXPo/mqdefault.jpg",
    "title": "【オフコラボ】そらみこと甘々クレープパーティー！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-27T12:29:49Z"
  },
  {
    "videoId": "RVzcNoKo5Tw",
    "thumbnail": "https://i.ytimg.com/vi/RVzcNoKo5Tw/mqdefault.jpg",
    "title": "【スイカゲーム】ウワサのゲーム！3,000点とるぞー！！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-28T16:25:41Z"
  },
  {
    "videoId": "XVPIyoEDj3Y",
    "thumbnail": "https://i.ytimg.com/vi/XVPIyoEDj3Y/mqdefault.jpg",
    "title": "【 Minecraft 】借金×島流し×一発逆転【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-29T15:48:17Z"
  },
  {
    "videoId": "hkDwO9j21Qw",
    "thumbnail": "https://i.ytimg.com/vi/hkDwO9j21Qw/mqdefault.jpg",
    "title": "【ARK | Fjordur】ムキロゼサーバーありがとう！！弾丸建築観光！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-09-30T18:44:59Z"
  },
  {
    "videoId": "VLEshNlEHms",
    "thumbnail": "https://i.ytimg.com/vi/VLEshNlEHms/mqdefault.jpg",
    "title": "【オフコラボ】Welcome！TAKAMORI！！Let's Crepe Party 【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-01T11:09:08Z"
  },
  {
    "videoId": "vwXWrZGfFYw",
    "thumbnail": "https://i.ytimg.com/vi/vwXWrZGfFYw/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-02T13:09:59Z"
  },
  {
    "videoId": "pHRqpS1whig",
    "thumbnail": "https://i.ytimg.com/vi/pHRqpS1whig/mqdefault.jpg",
    "title": "枠コチラ！【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-02T23:14:37Z"
  },
  {
    "videoId": "FN7NS8qwEhs",
    "thumbnail": "https://i.ytimg.com/vi/FN7NS8qwEhs/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart2【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-03T23:01:11Z"
  },
  {
    "videoId": "Zj9PgJGH0H8",
    "thumbnail": "https://i.ytimg.com/vi/Zj9PgJGH0H8/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart3【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-04T03:45:02Z"
  },
  {
    "videoId": "WkqtTxIgPcs",
    "thumbnail": "https://i.ytimg.com/vi/WkqtTxIgPcs/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart４【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-04T23:27:50Z"
  },
  {
    "videoId": "zDqLPMfmmN0",
    "thumbnail": "https://i.ytimg.com/vi/zDqLPMfmmN0/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart５【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-05T23:29:14Z"
  },
  {
    "videoId": "T55whEQCJtg",
    "thumbnail": "https://i.ytimg.com/vi/T55whEQCJtg/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart６【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-06T18:52:28Z"
  },
  {
    "videoId": "6DrUtAfqtJc",
    "thumbnail": "https://i.ytimg.com/vi/6DrUtAfqtJc/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart７【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-07T23:28:51Z"
  },
  {
    "videoId": "c17QzBHR4IE",
    "thumbnail": "https://i.ytimg.com/vi/c17QzBHR4IE/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart８【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-08T01:17:24Z"
  },
  {
    "videoId": "9wBXoFnW1xE",
    "thumbnail": "https://i.ytimg.com/vi/9wBXoFnW1xE/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart９【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-08T04:53:08Z"
  },
  {
    "videoId": "qvoaC1eus90",
    "thumbnail": "https://i.ytimg.com/vi/qvoaC1eus90/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart１０【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-09T00:37:41Z"
  },
  {
    "videoId": "H6nDWr9bnSo",
    "thumbnail": "https://i.ytimg.com/vi/H6nDWr9bnSo/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart１１【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-09T00:55:12Z"
  },
  {
    "videoId": "OtJ-qHgqzvQ",
    "thumbnail": "https://i.ytimg.com/vi/OtJ-qHgqzvQ/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart１２【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-09T18:25:01Z"
  },
  {
    "videoId": "nmugVckd0RQ",
    "thumbnail": "https://i.ytimg.com/vi/nmugVckd0RQ/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart１３【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-10T22:57:19Z"
  },
  {
    "videoId": "WOcdANAnHmQ",
    "thumbnail": "https://i.ytimg.com/vi/WOcdANAnHmQ/mqdefault.jpg",
    "title": "【VCR ARK】初参戦！！スト鯖ARKにムキロゼ降りたつPart１４【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-11T02:30:19Z"
  },
  {
    "videoId": "WFmPAZANCRk",
    "thumbnail": "https://i.ytimg.com/vi/WFmPAZANCRk/mqdefault.jpg",
    "title": "【VCR ARK】ついに最終決戦！初参戦！！スト鯖ARKにムキロゼ降りたつPart１5【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-11T18:47:36Z"
  },
  {
    "videoId": "sl3FjNoD9Ho",
    "thumbnail": "https://i.ytimg.com/vi/sl3FjNoD9Ho/mqdefault.jpg",
    "title": "【VCR ARK】ありがとうスト鯖ARK！振り返りなど！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-13T01:41:02Z"
  },
  {
    "videoId": "NPDMjBFgzZQ",
    "thumbnail": "https://i.ytimg.com/vi/NPDMjBFgzZQ/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part2【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-14T02:14:40Z"
  },
  {
    "videoId": "YhA_5QMmQ6w",
    "thumbnail": "https://i.ytimg.com/vi/YhA_5QMmQ6w/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part３【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-14T02:35:56Z"
  },
  {
    "videoId": "muol6CLCtPQ",
    "thumbnail": "https://i.ytimg.com/vi/muol6CLCtPQ/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part４【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-14T23:42:53Z"
  },
  {
    "videoId": "ZwiHLJfwG3o",
    "thumbnail": "https://i.ytimg.com/vi/ZwiHLJfwG3o/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part５【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-15T19:17:23Z"
  },
  {
    "videoId": "gtoSr_pDgcI",
    "thumbnail": "https://i.ytimg.com/vi/gtoSr_pDgcI/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part６【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-16T19:22:44Z"
  },
  {
    "videoId": "ZbXTNsyGuhQ",
    "thumbnail": "https://i.ytimg.com/vi/ZbXTNsyGuhQ/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part７【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-17T20:18:08Z"
  },
  {
    "videoId": "xknOe1QncVU",
    "thumbnail": "https://i.ytimg.com/vi/xknOe1QncVU/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part８【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-18T23:41:28Z"
  },
  {
    "videoId": "r0BrXG6KSn8",
    "thumbnail": "https://i.ytimg.com/vi/r0BrXG6KSn8/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part９【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-19T23:10:56Z"
  },
  {
    "videoId": "dbsxkeBVEzk",
    "thumbnail": "https://i.ytimg.com/vi/dbsxkeBVEzk/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１０【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-21T01:50:30Z"
  },
  {
    "videoId": "EjlANGU6wok",
    "thumbnail": "https://i.ytimg.com/vi/EjlANGU6wok/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１１【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-22T01:51:26Z"
  },
  {
    "videoId": "Z_HTyh1-XPc",
    "thumbnail": "https://i.ytimg.com/vi/Z_HTyh1-XPc/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】フルパで仮装ブキチ杯！！#ホロスプラ部 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-10-22T14:36:38Z"
  },
  {
    "videoId": "z1IFCZN_z_8",
    "thumbnail": "https://i.ytimg.com/vi/z1IFCZN_z_8/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１２【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-22T19:38:03Z"
  },
  {
    "videoId": "puumVkiAFVk",
    "thumbnail": "https://i.ytimg.com/vi/puumVkiAFVk/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１３【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-23T20:55:14Z"
  },
  {
    "videoId": "H0Jkm8TPea4",
    "thumbnail": "https://i.ytimg.com/vi/H0Jkm8TPea4/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１４【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-24T22:47:24Z"
  },
  {
    "videoId": "ngM7PxROiSU",
    "thumbnail": "https://i.ytimg.com/vi/ngM7PxROiSU/mqdefault.jpg",
    "title": "【雑談￤Free talk】ゆっくりお話し！聞きたいこと募！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-25T14:08:01Z"
  },
  {
    "videoId": "OzqXVytv85M",
    "thumbnail": "https://i.ytimg.com/vi/OzqXVytv85M/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１５【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-25T18:42:37Z"
  },
  {
    "videoId": "K9MNIhDCEik",
    "thumbnail": "https://i.ytimg.com/vi/K9MNIhDCEik/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１６+ASA散歩テスト【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-26T18:11:36Z"
  },
  {
    "videoId": "Qh-QURnw9lQ",
    "thumbnail": "https://i.ytimg.com/vi/Qh-QURnw9lQ/mqdefault.jpg",
    "title": "【VCR ARK】終わらないスト鯖ARK新MAP編Part１７+新土井さん鯖見学あるかも？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-27T20:12:02Z"
  },
  {
    "videoId": "Yt5neDTYOuE",
    "thumbnail": "https://i.ytimg.com/vi/Yt5neDTYOuE/mqdefault.jpg",
    "title": "【VCR ARK】タイタン6体で挑むキングタイタンベータ戦スト鯖ARK新MAP編Part１８【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-28T16:33:19Z"
  },
  {
    "videoId": "CgeJKjUuP_0",
    "thumbnail": "https://i.ytimg.com/vi/CgeJKjUuP_0/mqdefault.jpg",
    "title": "【スイカゲーム】でっっっっっかいカボチャ作ります！めざせ最高記録更新【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-29T16:45:14Z"
  },
  {
    "videoId": "zpu1N5XqLps",
    "thumbnail": "https://i.ytimg.com/vi/zpu1N5XqLps/mqdefault.jpg",
    "title": "【 Minecraft 】ワクドキ！競技キメ！ #ホロライブ大運動会2023 【アキ・ローゼンタール視点】",
    "publishedAt": "2023-10-30T14:40:56Z"
  },
  {
    "videoId": "TqWKFZvS4d4",
    "thumbnail": "https://i.ytimg.com/vi/TqWKFZvS4d4/mqdefault.jpg",
    "title": "【VCR ARK】最終決戦前夜！準備だああ！スト鯖ARK新MAP編Part１９【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-30T23:00:46Z"
  },
  {
    "videoId": "4axw1G-MMRY",
    "thumbnail": "https://i.ytimg.com/vi/4axw1G-MMRY/mqdefault.jpg",
    "title": "【笑ったら即終了】？？？？？？？？？【R.B.J】",
    "publishedAt": "2023-10-31T11:53:35Z"
  },
  {
    "videoId": "sSIHC7UK5eQ",
    "thumbnail": "https://i.ytimg.com/vi/sSIHC7UK5eQ/mqdefault.jpg",
    "title": "【VCR ARK】ついに最終決戦キングタイタンアルファ戦！スト鯖ARK新MAP編Part２０【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-31T16:07:03Z"
  },
  {
    "videoId": "hf8mFsbjo4g",
    "thumbnail": "https://i.ytimg.com/vi/hf8mFsbjo4g/mqdefault.jpg",
    "title": "二次会ゴッフィー【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-10-31T18:24:47Z"
  },
  {
    "videoId": "AGj3EW2Kd24",
    "thumbnail": "https://i.ytimg.com/vi/AGj3EW2Kd24/mqdefault.jpg",
    "title": "【ASMR】深夜ゲリラ！お試しASMRセリフ集！※アーカイブの保証はないです【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-01T15:50:03Z"
  },
  {
    "videoId": "E9RHu3GHRL8",
    "thumbnail": "https://i.ytimg.com/vi/E9RHu3GHRL8/mqdefault.jpg",
    "title": "【 Minecraft 】メルちゃんとこそ練する！ #ホロライブ大運動会2023 【アキ・ローゼンタール視点】",
    "publishedAt": "2023-11-02T14:32:33Z"
  },
  {
    "videoId": "1dqC7MZjI5A",
    "thumbnail": "https://i.ytimg.com/vi/1dqC7MZjI5A/mqdefault.jpg",
    "title": "【 Minecraft 】紅組勝つぞ！！本番！！ #ホロライブ大運動会2023 【アキ・ローゼンタール視点】",
    "publishedAt": "2023-11-04T12:52:59Z"
  },
  {
    "videoId": "-XlEjQsSHhE",
    "thumbnail": "https://i.ytimg.com/vi/-XlEjQsSHhE/mqdefault.jpg",
    "title": "【スト６】 STREET FIGHTER 6デビューするぞ！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-07T17:55:01Z"
  },
  {
    "videoId": "6Dca-ziyL9A",
    "thumbnail": "https://i.ytimg.com/vi/6Dca-ziyL9A/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6初心者2日目の回！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-08T14:56:34Z"
  },
  {
    "videoId": "vkkVCMniRws",
    "thumbnail": "https://i.ytimg.com/vi/vkkVCMniRws/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】基礎から学べ！助っ人登場！？スト6初心者3日目！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-09T17:04:55Z"
  },
  {
    "videoId": "harIhncS7J0",
    "thumbnail": "https://i.ytimg.com/vi/harIhncS7J0/mqdefault.jpg",
    "title": "【絶対間違えられない】以心伝心ゲームやってみた　#マーベルズ　#PR",
    "publishedAt": "2023-11-10T10:00:37Z"
  },
  {
    "videoId": "YS2LkaPIW08",
    "thumbnail": "https://i.ytimg.com/vi/YS2LkaPIW08/mqdefault.jpg",
    "title": "【雑談】深夜ゲリラ！寝る前にちょっとだけ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-11T17:52:13Z"
  },
  {
    "videoId": "KNEtliBb4XQ",
    "thumbnail": "https://i.ytimg.com/vi/KNEtliBb4XQ/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6初心者4日目の回！経験値ショッピング【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-13T16:28:29Z"
  },
  {
    "videoId": "tGkG99KhRNY",
    "thumbnail": "https://i.ytimg.com/vi/tGkG99KhRNY/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6初心者5日目の回！経験値ショッピング【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-14T16:28:07Z"
  },
  {
    "videoId": "0r1hJ5gGruE",
    "thumbnail": "https://i.ytimg.com/vi/0r1hJ5gGruE/mqdefault.jpg",
    "title": "【 Refind Self 】ゲームで性格が丸裸に？？？？可愛い癒しゲーと聞いて【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-16T16:20:19Z"
  },
  {
    "videoId": "sywGZunpfbQ",
    "thumbnail": "https://i.ytimg.com/vi/sywGZunpfbQ/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】フェスきちゃ！今川焼き派いくぞー！！！！ 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-11-18T16:11:34Z"
  },
  {
    "videoId": "nx736Pic54E",
    "thumbnail": "https://i.ytimg.com/vi/nx736Pic54E/mqdefault.jpg",
    "title": "【ARK | Fjordur】ホロ鯖に人がいる！！！全ロスからのストーリー【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-19T16:07:24Z"
  },
  {
    "videoId": "t63eN8LKOMA",
    "thumbnail": "https://i.ytimg.com/vi/t63eN8LKOMA/mqdefault.jpg",
    "title": "【ASA￤Island】ARKリメイク版に突撃じゃー！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-21T16:01:07Z"
  },
  {
    "videoId": "T46nakwmFNQ",
    "thumbnail": "https://i.ytimg.com/vi/T46nakwmFNQ/mqdefault.jpg",
    "title": "【ASA￤Island】ARKリメイク版！今日からはじまる新生活【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-22T21:23:27Z"
  },
  {
    "videoId": "rkxt-IoSILk",
    "thumbnail": "https://i.ytimg.com/vi/rkxt-IoSILk/mqdefault.jpg",
    "title": "【ARK | Fjordur】トワぴ＆いろはちゃんと洞窟？デイノブリもレベリングもしたい【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-23T15:27:10Z"
  },
  {
    "videoId": "DqK6rOMmpHI",
    "thumbnail": "https://i.ytimg.com/vi/DqK6rOMmpHI/mqdefault.jpg",
    "title": "【ASA￤Island】ARKリメイク版！借りぐらしのムキエッティ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-23T19:20:44Z"
  },
  {
    "videoId": "04ez3gB9IBU",
    "thumbnail": "https://i.ytimg.com/vi/04ez3gB9IBU/mqdefault.jpg",
    "title": "【ARK | Fjordur】デイノ育てる！もしかしたら大ボス？レベリング！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-25T15:45:23Z"
  },
  {
    "videoId": "lzXfReLx-Bg",
    "thumbnail": "https://i.ytimg.com/vi/lzXfReLx-Bg/mqdefault.jpg",
    "title": "【ASA￤Island】ARKリメイク版！リニオグナタ欲しい！もしくはケツァル【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-25T16:47:02Z"
  },
  {
    "videoId": "5Xz2kavJFkk",
    "thumbnail": "https://i.ytimg.com/vi/5Xz2kavJFkk/mqdefault.jpg",
    "title": "【GTAⅤ】はじめてのGTA！#ホロギャング【フブさん、みこさん、アキさん/ホロライブ】",
    "publishedAt": "2023-11-26T15:59:36Z"
  },
  {
    "videoId": "BWTdi5AfoIQ",
    "thumbnail": "https://i.ytimg.com/vi/BWTdi5AfoIQ/mqdefault.jpg",
    "title": "【ASMR】体験版♡セリフOnlyリクエストに全力で答えちゃうよ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-27T13:18:12Z"
  },
  {
    "videoId": "zVE9CatjYPw",
    "thumbnail": "https://i.ytimg.com/vi/zVE9CatjYPw/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】スプラ大会チーム決定！  #マリコロンタール で練習！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2023-11-28T17:44:11Z"
  },
  {
    "videoId": "LJG6D2HyYd8",
    "thumbnail": "https://i.ytimg.com/vi/LJG6D2HyYd8/mqdefault.jpg",
    "title": "【ASA￤Island】ARKリメイク版！え！？αボス戦！？？？？？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-29T23:18:50Z"
  },
  {
    "videoId": "zCR3-cJA_qk",
    "thumbnail": "https://i.ytimg.com/vi/zCR3-cJA_qk/mqdefault.jpg",
    "title": "【ARK | Fjordur】ついにきた！リベンジドラゴンボス！フェンリルもいっちゃうよ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-11-30T16:40:33Z"
  },
  {
    "videoId": "4qKZi0W_dgw",
    "thumbnail": "https://i.ytimg.com/vi/4qKZi0W_dgw/mqdefault.jpg",
    "title": "【GTAⅤ】ついに合流──────リベンジ #ホロギャング【フブさん、みこさん、アキさん/ホロライブ】",
    "publishedAt": "2023-12-01T13:45:59Z"
  },
  {
    "videoId": "Oq49WOxW8b0",
    "thumbnail": "https://i.ytimg.com/vi/Oq49WOxW8b0/mqdefault.jpg",
    "title": "【重大告知】ついに完成！！約束を果たす時がきた！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-03T12:56:01Z"
  },
  {
    "videoId": "X08hSrIZdek",
    "thumbnail": "https://i.ytimg.com/vi/X08hSrIZdek/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】チーム練！声だそ～～！！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2023-12-06T16:39:31Z"
  },
  {
    "videoId": "ff1Sw7umBJQ",
    "thumbnail": "https://i.ytimg.com/vi/ff1Sw7umBJQ/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】#宝神秋祭WIN 前日練習！マリまつアキでナワバリ！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2023-12-08T10:16:54Z"
  },
  {
    "videoId": "CurTpbK8J-A",
    "thumbnail": "https://i.ytimg.com/vi/CurTpbK8J-A/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】#宝神秋祭WIN フルパで前日練習ー後半ー【ホロライブ/アキロゼ視点】",
    "publishedAt": "2023-12-08T14:47:52Z"
  },
  {
    "videoId": "mTgWavSB-ok",
    "thumbnail": "https://i.ytimg.com/vi/mTgWavSB-ok/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】#宝神秋祭WIN 大会本番！いくぞ！！！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2023-12-09T12:04:17Z"
  },
  {
    "videoId": "CcgVeQJPiY0",
    "thumbnail": "https://i.ytimg.com/vi/CcgVeQJPiY0/mqdefault.jpg",
    "title": "【#ホロ競馬部 】師匠不在なので１番弟子がんばります！阪神ジュベナイルフィリーズ🏇【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-10T07:02:16Z"
  },
  {
    "videoId": "AKNiiUXkzgs",
    "thumbnail": "https://i.ytimg.com/vi/AKNiiUXkzgs/mqdefault.jpg",
    "title": "【VCR GTA2】ギャングひしめく街ロスサントスへ初参戦！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-10T21:29:47Z"
  },
  {
    "videoId": "GH5bMV5zdUc",
    "thumbnail": "https://i.ytimg.com/vi/GH5bMV5zdUc/mqdefault.jpg",
    "title": "【VCR GTA2】ギャングひしめく街ロスサントスへ初参戦！！2日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-11T21:29:24Z"
  },
  {
    "videoId": "DVSJPbeG244",
    "thumbnail": "https://i.ytimg.com/vi/DVSJPbeG244/mqdefault.jpg",
    "title": "【VCR GTA2】ギャングひしめく街ロスサントスへ初参戦！！３日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-12T21:52:49Z"
  },
  {
    "videoId": "07d8b6i4YPo",
    "thumbnail": "https://i.ytimg.com/vi/07d8b6i4YPo/mqdefault.jpg",
    "title": "【-セガNET麻雀MJ-】こよちゃんに麻雀弟子入りする！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-13T14:12:48Z"
  },
  {
    "videoId": "g7YfcIHXsAQ",
    "thumbnail": "https://i.ytimg.com/vi/g7YfcIHXsAQ/mqdefault.jpg",
    "title": "【VCR GTA2】ギャングひしめく街ロスサントスへ初参戦！！４日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-13T21:22:05Z"
  },
  {
    "videoId": "ZQ1WSte6PG4",
    "thumbnail": "https://i.ytimg.com/vi/ZQ1WSte6PG4/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！５日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-14T21:25:44Z"
  },
  {
    "videoId": "qr-Ef8Fihcc",
    "thumbnail": "https://i.ytimg.com/vi/qr-Ef8Fihcc/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！６日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-15T21:26:17Z"
  },
  {
    "videoId": "SdSkS5lpEak",
    "thumbnail": "https://i.ytimg.com/vi/SdSkS5lpEak/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！7日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-16T21:27:33Z"
  },
  {
    "videoId": "UbQkPTmw8hU",
    "thumbnail": "https://i.ytimg.com/vi/UbQkPTmw8hU/mqdefault.jpg",
    "title": "【#ホロ競馬部 】師匠不在なので１番弟子がんばります！朝日杯フューチュリティステークス🏇【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-17T07:00:07Z"
  },
  {
    "videoId": "y2a-2uubq_Y",
    "thumbnail": "https://i.ytimg.com/vi/y2a-2uubq_Y/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！８日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-17T21:42:56Z"
  },
  {
    "videoId": "bXZwf6vC8LE",
    "thumbnail": "https://i.ytimg.com/vi/bXZwf6vC8LE/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！９日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-18T21:32:48Z"
  },
  {
    "videoId": "QLL-xvoBXxs",
    "thumbnail": "https://i.ytimg.com/vi/QLL-xvoBXxs/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！１０日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-19T21:37:37Z"
  },
  {
    "videoId": "P9WUAZbX350",
    "thumbnail": "https://i.ytimg.com/vi/P9WUAZbX350/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！11日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-20T21:04:59Z"
  },
  {
    "videoId": "U4wTvnX9Scw",
    "thumbnail": "https://i.ytimg.com/vi/U4wTvnX9Scw/mqdefault.jpg",
    "title": "【VCR GTA2】緊急カーレース大会【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-20T21:12:00Z"
  },
  {
    "videoId": "3Ga5ldRiYzg",
    "thumbnail": "https://i.ytimg.com/vi/3Ga5ldRiYzg/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！12日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-21T21:34:41Z"
  },
  {
    "videoId": "t6jWlueuYAM",
    "thumbnail": "https://i.ytimg.com/vi/t6jWlueuYAM/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！最終日ー前半ー【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-22T07:04:51Z"
  },
  {
    "videoId": "lVGQBKXUwQM",
    "thumbnail": "https://i.ytimg.com/vi/lVGQBKXUwQM/mqdefault.jpg",
    "title": "【VCR GTA2】ロスサントスへ初参戦！ネオポリスギャング道！最終日ー後半ー【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-22T18:09:07Z"
  },
  {
    "videoId": "I2odBvMPS68",
    "thumbnail": "https://i.ytimg.com/vi/I2odBvMPS68/mqdefault.jpg",
    "title": "【#ホロ競馬部 】今年ラスト競馬予想！有馬あてるぞ！🏇【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-24T07:13:41Z"
  },
  {
    "videoId": "jK-CPAUk_VE",
    "thumbnail": "https://i.ytimg.com/vi/jK-CPAUk_VE/mqdefault.jpg",
    "title": "【壺/Getting Over It】今年こそてっぺんに星を飾りたい2023【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-12-24T15:59:46Z"
  },
  {
    "videoId": "Buv5NZA0UJs",
    "thumbnail": "https://i.ytimg.com/vi/Buv5NZA0UJs/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー 】メリークリスマス！歌っちゃうよ～【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-25T08:23:05Z"
  },
  {
    "videoId": "Zm82nLe-OA4",
    "thumbnail": "https://i.ytimg.com/vi/Zm82nLe-OA4/mqdefault.jpg",
    "title": "【VCR GTA2】振り返り配信！ありがとうネオポリス！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-25T19:20:01Z"
  },
  {
    "videoId": "exc-aLfvxFY",
    "thumbnail": "https://i.ytimg.com/vi/exc-aLfvxFY/mqdefault.jpg",
    "title": "【縦型配信】初めての縦型配信！ちょっと歌ってみたり【ホロライブ/アキ・ローゼンタール】#shorts",
    "publishedAt": "2023-12-29T17:46:29Z"
  },
  {
    "videoId": "RM0eiklvKBI",
    "thumbnail": "https://i.ytimg.com/vi/RM0eiklvKBI/mqdefault.jpg",
    "title": "【縦型配信】2023年振り返り！ちょっと歌ってみたり #shorts【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2023-12-30T13:59:50Z"
  },
  {
    "videoId": "GExL39-XUQo",
    "thumbnail": "https://i.ytimg.com/vi/GExL39-XUQo/mqdefault.jpg",
    "title": "【マリオカート8DX】新コースめっちゃ増えたってま！？最強への道！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2023-12-30T17:01:15Z"
  },
  {
    "videoId": "1XkKQGeJkD0",
    "thumbnail": "https://i.ytimg.com/vi/1XkKQGeJkD0/mqdefault.jpg",
    "title": "【雑談/FreeTalk】2024年初配信！今年の目標決める！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-01-02T15:51:22Z"
  },
  {
    "videoId": "X6y8CG3rvLM",
    "thumbnail": "https://i.ytimg.com/vi/X6y8CG3rvLM/mqdefault.jpg",
    "title": "【-セガNET麻雀MJ-】エビオさん、レイドくん、らんちゃんと麻雀バトル！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-04T12:04:00Z"
  },
  {
    "videoId": "Rnb-Z_xBXhw",
    "thumbnail": "https://i.ytimg.com/vi/Rnb-Z_xBXhw/mqdefault.jpg",
    "title": "【マリオカート8DX】まつりちゃんと練習するよ～【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-05T12:18:37Z"
  },
  {
    "videoId": "42Tcm6yUF8g",
    "thumbnail": "https://i.ytimg.com/vi/42Tcm6yUF8g/mqdefault.jpg",
    "title": "【#ホロお正月CUP2024】予選Cブロック！頼む！キラー恋！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-07T09:48:07Z"
  },
  {
    "videoId": "5wpJuR7gl9I",
    "thumbnail": "https://i.ytimg.com/vi/5wpJuR7gl9I/mqdefault.jpg",
    "title": "【#ホロお正月CUP2024】本戦Dブロック！アイテム被弾率おかしいて！！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-08T08:49:41Z"
  },
  {
    "videoId": "uld7WeJx9gw",
    "thumbnail": "https://i.ytimg.com/vi/uld7WeJx9gw/mqdefault.jpg",
    "title": "【#ホロお正月CUP2024】まさかの？ざこ杯！！さすがに優勝するかｗｗ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-08T11:08:57Z"
  },
  {
    "videoId": "r-0xoNsUMhE",
    "thumbnail": "https://i.ytimg.com/vi/r-0xoNsUMhE/mqdefault.jpg",
    "title": "【VALORANT】FPS初心者が今日から始めるヴァロラント with Mother3【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-09T13:38:38Z"
  },
  {
    "videoId": "KE04DUmNsPk",
    "thumbnail": "https://i.ytimg.com/vi/KE04DUmNsPk/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ぼたんちゃんとスト6！そして豪華格闘ゲームプロたちと #賞金首スト6交流会【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-10T13:37:39Z"
  },
  {
    "videoId": "WQiO5HF3Dfs",
    "thumbnail": "https://i.ytimg.com/vi/WQiO5HF3Dfs/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ピザ屋のアルさんがガイル村外交大使らしい！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-11T14:37:15Z"
  },
  {
    "videoId": "bi8qo-4uiGQ",
    "thumbnail": "https://i.ytimg.com/vi/bi8qo-4uiGQ/mqdefault.jpg",
    "title": "【Gartic Phone】 元祖画伯枠をなめるなよ？#ホロお絵かき伝言ゲーム【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-12T14:40:16Z"
  },
  {
    "videoId": "zRp6AxOXBOY",
    "thumbnail": "https://i.ytimg.com/vi/zRp6AxOXBOY/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#ラシード公園を救いたい オウガニキにMラシードを教わる！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-13T16:17:05Z"
  },
  {
    "videoId": "6m-iyqxh2As",
    "thumbnail": "https://i.ytimg.com/vi/6m-iyqxh2As/mqdefault.jpg",
    "title": "【Escape from Tarkov】FPS初心者が今日から始めるタルコフ with ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-14T16:18:44Z"
  },
  {
    "videoId": "RsVc3yGkcIM",
    "thumbnail": "https://i.ytimg.com/vi/RsVc3yGkcIM/mqdefault.jpg",
    "title": "【Minecraft】らいカン🦕マイクラハードコアエンドラ討伐チャレンジ！【アキ・ローゼンタール視点/ホロライブ】",
    "publishedAt": "2024-01-15T18:47:41Z"
  },
  {
    "videoId": "dvKERtikcNg",
    "thumbnail": "https://i.ytimg.com/vi/dvKERtikcNg/mqdefault.jpg",
    "title": "【LoL】今日から始めるLOL！ネオポリス初期３人組とわちゃわちゃ初心者LOL【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-16T19:09:06Z"
  },
  {
    "videoId": "o1wNE2wfauI",
    "thumbnail": "https://i.ytimg.com/vi/o1wNE2wfauI/mqdefault.jpg",
    "title": "【Lethal Company】命からがらガラクタ集め？！ネオポリスで協力ホラゲ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-01-17T15:47:13Z"
  },
  {
    "videoId": "lQgcHlOqYJ4",
    "thumbnail": "https://i.ytimg.com/vi/lQgcHlOqYJ4/mqdefault.jpg",
    "title": "【Minecraft】1回でも死んだらリセット！10人でエンドラ討伐！  #ネオポリスマイクラハードコア  【アキロゼ視点/ホロライブ】",
    "publishedAt": "2024-01-20T19:33:15Z"
  },
  {
    "videoId": "X6JV7QW8XOY",
    "thumbnail": "https://i.ytimg.com/vi/X6JV7QW8XOY/mqdefault.jpg",
    "title": "【Palworld】ホロ鯖ができた！？色々話題のこのゲームいっちょやってみますか！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-01-21T16:09:09Z"
  },
  {
    "videoId": "jblG4FulTzk",
    "thumbnail": "https://i.ytimg.com/vi/jblG4FulTzk/mqdefault.jpg",
    "title": "【LoL】初心者LOLミスフォーチュンADC道【アキロゼ/ホロライブ】",
    "publishedAt": "2024-01-23T16:36:36Z"
  },
  {
    "videoId": "39ZGHFE6vqo",
    "thumbnail": "https://i.ytimg.com/vi/39ZGHFE6vqo/mqdefault.jpg",
    "title": "【LoL】The k4sen 初心者LOL1日目だー！！ガチめに🔰 #thek4sen【アキロゼ/ホロライブ】",
    "publishedAt": "2024-01-24T21:34:36Z"
  },
  {
    "videoId": "jKPeJ2_d-yE",
    "thumbnail": "https://i.ytimg.com/vi/jKPeJ2_d-yE/mqdefault.jpg",
    "title": "【LoL】The k4sen 初心者LOL2日目🔰ミスフォーチュンがんばる！ #thek4sen【アキロゼ/ホロライブ】",
    "publishedAt": "2024-01-25T20:45:10Z"
  },
  {
    "videoId": "QJTUbz_pL54",
    "thumbnail": "https://i.ytimg.com/vi/QJTUbz_pL54/mqdefault.jpg",
    "title": "【LoL】The k4sen 🔰初心者LOL本番いくぞ！！ 天月さん,エビオさん,のあちゃん,しろまんたママ,うるかコーチ,ゼロストコーチ【アキロゼ/ホロライブ】#thek4sen",
    "publishedAt": "2024-01-26T17:49:32Z"
  },
  {
    "videoId": "eKPXzp18xok",
    "thumbnail": "https://i.ytimg.com/vi/eKPXzp18xok/mqdefault.jpg",
    "title": "【雑談/Free Talk】最近のこと話すなど！ゲリラ雑談！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-01-27T17:18:55Z"
  },
  {
    "videoId": "itsrh4AnWYU",
    "thumbnail": "https://i.ytimg.com/vi/itsrh4AnWYU/mqdefault.jpg",
    "title": "【ARK￤ラグナロク】 ハードコアARKで #ムキロゼ爆誕祭 ☆【ホロライブ/アキロゼ】",
    "publishedAt": "2024-01-29T19:56:24Z"
  },
  {
    "videoId": "vuI66W_JrWo",
    "thumbnail": "https://i.ytimg.com/vi/vuI66W_JrWo/mqdefault.jpg",
    "title": "【LoL】フルパLOLきちゃー！ピザ屋にお邪魔します！アルランディス/とおこ/dtto./昏昏アリア【アキロゼ視点/ホロライブ】",
    "publishedAt": "2024-01-30T19:58:35Z"
  },
  {
    "videoId": "sikBikWJI_4",
    "thumbnail": "https://i.ytimg.com/vi/sikBikWJI_4/mqdefault.jpg",
    "title": "【LoL】座学したり練習したりしたい【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-02T21:58:16Z"
  },
  {
    "videoId": "nAQuYNlOzG0",
    "thumbnail": "https://i.ytimg.com/vi/nAQuYNlOzG0/mqdefault.jpg",
    "title": "【LoL】カスタムフルパにお邪魔！midを勉強したい【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-03T21:26:23Z"
  },
  {
    "videoId": "BsCGVPvfhL8",
    "thumbnail": "https://i.ytimg.com/vi/BsCGVPvfhL8/mqdefault.jpg",
    "title": "【LoL】mid担当になったよ！フルパ練習など！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-04T23:17:14Z"
  },
  {
    "videoId": "vk4knu_Nmqg",
    "thumbnail": "https://i.ytimg.com/vi/vk4knu_Nmqg/mqdefault.jpg",
    "title": "【LoL】#thek4sen １日目いくぞ！ゼロストさん/あしゅみちゃん/LEON代表/らむねちゃん/XQQさん【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-05T23:51:27Z"
  },
  {
    "videoId": "IFTpX2oS-oM",
    "thumbnail": "https://i.ytimg.com/vi/IFTpX2oS-oM/mqdefault.jpg",
    "title": "【LoL】#thek4sen ２日目いくぞ！ゼロストさん/あしゅみちゃん/LEON代表/らむねちゃん/XQQさん【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-06T20:40:01Z"
  },
  {
    "videoId": "9WZdd5PqafY",
    "thumbnail": "https://i.ytimg.com/vi/9WZdd5PqafY/mqdefault.jpg",
    "title": "【LoL】#thek4sen ３日目いよいよ本番いくぞ！ゼロストさん/あしゅみちゃん/LEON代表/らむねちゃん/XQQさん【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-07T18:54:09Z"
  },
  {
    "videoId": "wGWVL4qHT0A",
    "thumbnail": "https://i.ytimg.com/vi/wGWVL4qHT0A/mqdefault.jpg",
    "title": "【雑談/Free Talk】晩酌しちゃおうかな！LOL大会＆オールナイトニッポンお疲れさま～！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-09T19:12:40Z"
  },
  {
    "videoId": "Dp1KuQZkzZg",
    "thumbnail": "https://i.ytimg.com/vi/Dp1KuQZkzZg/mqdefault.jpg",
    "title": "【人生相談】 聞いてよロボタール！お悩み相談室【ホロライブ/アキロゼ/ロボ子さん】#ロボタール",
    "publishedAt": "2024-02-12T09:02:12Z"
  },
  {
    "videoId": "4c3oam6pnrA",
    "thumbnail": "https://i.ytimg.com/vi/4c3oam6pnrA/mqdefault.jpg",
    "title": "【 五目並べ 】みこちからの引き継ぎ企画ｗ全ＣＰＵに速攻で全勝する配信【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-12T10:45:41Z"
  },
  {
    "videoId": "gDwRt-o11-k",
    "thumbnail": "https://i.ytimg.com/vi/gDwRt-o11-k/mqdefault.jpg",
    "title": "アキロゼ生誕祭2024！2/17 21時やるよ～！【ホロライブ】",
    "publishedAt": "2024-02-13T10:42:27Z"
  },
  {
    "videoId": "tME6Qc6wyCc",
    "thumbnail": "https://i.ytimg.com/vi/tME6Qc6wyCc/mqdefault.jpg",
    "title": "【LoL】豪華フルパカスタムだー！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-13T20:15:23Z"
  },
  {
    "videoId": "lt3UIaX7BOo",
    "thumbnail": "https://i.ytimg.com/vi/lt3UIaX7BOo/mqdefault.jpg",
    "title": "【推しカメラ】「ハピチョコ」恥ずかしいけど可愛く踊ってみた【アキロゼ/ホロライブ】 #Shorts #hoshimaticproject",
    "publishedAt": "2024-02-14T14:27:50Z"
  },
  {
    "videoId": "3UvEnAIUndM",
    "thumbnail": "https://i.ytimg.com/vi/3UvEnAIUndM/mqdefault.jpg",
    "title": "【推しカメラ】「MY舞☆TONIGHT」ひらひらダンス踊ってみた【アキロゼ/ホロライブ】 #Shorts #hoshimaticproject",
    "publishedAt": "2024-02-14T14:54:03Z"
  },
  {
    "videoId": "ZP6RnBpVnWg",
    "thumbnail": "https://i.ytimg.com/vi/ZP6RnBpVnWg/mqdefault.jpg",
    "title": "【雑談/Free Talk】バレンタインだね～？【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-14T18:55:56Z"
  },
  {
    "videoId": "oYU6gldeCQQ",
    "thumbnail": "https://i.ytimg.com/vi/oYU6gldeCQQ/mqdefault.jpg",
    "title": "【LoL】ネオポリスでEnjoyフルパカスタムLOLやるよ～！ #ネオポリスLOL【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-15T21:34:36Z"
  },
  {
    "videoId": "GcMmFLJ6-7E",
    "thumbnail": "https://i.ytimg.com/vi/GcMmFLJ6-7E/mqdefault.jpg",
    "title": "【一緒にカウントダウンしよ】まもなく誕生日！！明日の友情出演ゲストも発表するよ！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-16T15:35:54Z"
  },
  {
    "videoId": "pFZiKpoxuvw",
    "thumbnail": "https://i.ytimg.com/vi/pFZiKpoxuvw/mqdefault.jpg",
    "title": "【 #アキロゼ生誕祭2024 】ーFantasia of Bremenー￤3DLIVE【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-02-17T13:02:56Z"
  },
  {
    "videoId": "huqARGqDrbM",
    "thumbnail": "https://i.ytimg.com/vi/huqARGqDrbM/mqdefault.jpg",
    "title": "【After Talk】生誕祭ありがとう！制作秘話などお話し！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-18T14:04:27Z"
  },
  {
    "videoId": "o8T-CLc32bc",
    "thumbnail": "https://i.ytimg.com/vi/o8T-CLc32bc/mqdefault.jpg",
    "title": "【縦型配信】寝る前雑談。低気圧めっちゃ眠くない！？？【ホロライブ/アキロゼ】#shorts",
    "publishedAt": "2024-02-19T16:40:13Z"
  },
  {
    "videoId": "0J1khq_xpkc",
    "thumbnail": "https://i.ytimg.com/vi/0J1khq_xpkc/mqdefault.jpg",
    "title": "【LoL】今夜決着！？豪華カスタムフルパLOL！#レオカス【アキロゼ/ホロライブ】",
    "publishedAt": "2024-02-20T22:45:25Z"
  },
  {
    "videoId": "TVT0WjoGbHY",
    "thumbnail": "https://i.ytimg.com/vi/TVT0WjoGbHY/mqdefault.jpg",
    "title": "【Lethal Company】アキフブはあとで働くぞ！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-02-22T15:07:39Z"
  },
  {
    "videoId": "SGXn9aUi43s",
    "thumbnail": "https://i.ytimg.com/vi/SGXn9aUi43s/mqdefault.jpg",
    "title": "【ARK￤ラグナロク】 死ぬまでハードコアARK生活２日目【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-24T14:58:44Z"
  },
  {
    "videoId": "Q8Ymm2dhX8w",
    "thumbnail": "https://i.ytimg.com/vi/Q8Ymm2dhX8w/mqdefault.jpg",
    "title": "【雑談/Free Talk】ただいま！！！！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-28T13:38:29Z"
  },
  {
    "videoId": "l7ns298sSqE",
    "thumbnail": "https://i.ytimg.com/vi/l7ns298sSqE/mqdefault.jpg",
    "title": "【FFⅦ】先行プレイするぞ～！FINAL FANTASY VII REBIRTH【ホロライブ/アキロゼ】",
    "publishedAt": "2024-02-28T15:17:00Z"
  },
  {
    "videoId": "W5Kuz67o1JI",
    "thumbnail": "https://i.ytimg.com/vi/W5Kuz67o1JI/mqdefault.jpg",
    "title": "【#ネオポリスVSゆぐどらしる 】夢の20人マイクラDEサバゲー対決！！！【ホロライブ/アキロゼ視点】",
    "publishedAt": "2024-02-29T15:19:04Z"
  },
  {
    "videoId": "5tbLnY6Iivc",
    "thumbnail": "https://i.ytimg.com/vi/5tbLnY6Iivc/mqdefault.jpg",
    "title": "【Minecraft 】ネオポリスマイクラ鯖爆誕？ぷち2次会的な/ととみっくす【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-02-29T18:47:04Z"
  },
  {
    "videoId": "tHznKf7f1Y0",
    "thumbnail": "https://i.ytimg.com/vi/tHznKf7f1Y0/mqdefault.jpg",
    "title": "ゲリラ配信！【Splatoon3/スプラトゥーン3】新シーズン開幕！新武器とか！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-01T22:22:00Z"
  },
  {
    "videoId": "WzBBcBJq6Cg",
    "thumbnail": "https://i.ytimg.com/vi/WzBBcBJq6Cg/mqdefault.jpg",
    "title": "【APEX】新シーズンがめっちゃ面白いとウワサのエペ（初心者）/エビオ、レイド【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-03T17:08:39Z"
  },
  {
    "videoId": "tWX4oAGAQz4",
    "thumbnail": "https://i.ytimg.com/vi/tWX4oAGAQz4/mqdefault.jpg",
    "title": "【Lethal Company】─劇場版─　#劇場版ホロカンパニー【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-05T18:37:50Z"
  },
  {
    "videoId": "_XAUXYMxVKA",
    "thumbnail": "https://i.ytimg.com/vi/_XAUXYMxVKA/mqdefault.jpg",
    "title": "【雑談/Free Talk】季節の変わり目の話と友達に身バレした話と最近の話【ホロライブ/アキロゼ】",
    "publishedAt": "2024-03-10T15:33:36Z"
  },
  {
    "videoId": "jY310aBP-nI",
    "thumbnail": "https://i.ytimg.com/vi/jY310aBP-nI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】獅白杯に向けてスト6練習始めるぞ～！使用キャラ決めたい【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-12T17:35:12Z"
  },
  {
    "videoId": "XJapeUecqbQ",
    "thumbnail": "https://i.ytimg.com/vi/XJapeUecqbQ/mqdefault.jpg",
    "title": "【 Dead by Daylight 】悪魔の鬼ごっこ！フルパDBD/ヘンディー/ありさか/きなこ/ちょこ先【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-13T17:08:27Z"
  },
  {
    "videoId": "FqC2a9rNiPk",
    "thumbnail": "https://i.ytimg.com/vi/FqC2a9rNiPk/mqdefault.jpg",
    "title": "【APEX】ゲリラ配信！よちよちAPEX【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-14T16:58:33Z"
  },
  {
    "videoId": "7N4gdKSwBY8",
    "thumbnail": "https://i.ytimg.com/vi/7N4gdKSwBY8/mqdefault.jpg",
    "title": "DAY1打ち上げ会場に集合～！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-16T15:58:29Z"
  },
  {
    "videoId": "i4XRJwJogt0",
    "thumbnail": "https://i.ytimg.com/vi/i4XRJwJogt0/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】しゃがめ！！！サマソ！ソニブ！！！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-18T15:12:29Z"
  },
  {
    "videoId": "jrotlXrWgkg",
    "thumbnail": "https://i.ytimg.com/vi/jrotlXrWgkg/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ガイル村ひぐち村長直々コーチングだって～！？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-19T11:43:43Z"
  },
  {
    "videoId": "gZsNAY7qwW8",
    "thumbnail": "https://i.ytimg.com/vi/gZsNAY7qwW8/mqdefault.jpg",
    "title": "【Lethal Company】優秀なエージェント集めました。（予定）【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-19T14:33:02Z"
  },
  {
    "videoId": "fE-OgTJn_Lw",
    "thumbnail": "https://i.ytimg.com/vi/fE-OgTJn_Lw/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】2回目￤ガイル村ひぐち村長直々コーチングだって～！？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-20T16:15:11Z"
  },
  {
    "videoId": "duUjmbFV3zA",
    "thumbnail": "https://i.ytimg.com/vi/duUjmbFV3zA/mqdefault.jpg",
    "title": "【 Minecraft 】ダイヤ100個あげたい！そして・・・💖【猫又おかゆ×アキ・ローゼンタール視点/ホロライブ】",
    "publishedAt": "2024-03-22T14:12:04Z"
  },
  {
    "videoId": "nEWxV0EsZec",
    "thumbnail": "https://i.ytimg.com/vi/nEWxV0EsZec/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】最初からみんなで始める！w/エビオ、秋雪こはく、ととみっくす #ネオポリスモンハン部 1日目【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-23T17:30:05Z"
  },
  {
    "videoId": "ctVA5WdwkXs",
    "thumbnail": "https://i.ytimg.com/vi/ctVA5WdwkXs/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】3回目￤ガイル村ひぐち村長！タスケテケスタ！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-26T15:08:03Z"
  },
  {
    "videoId": "0zOc3fH3_ls",
    "thumbnail": "https://i.ytimg.com/vi/0zOc3fH3_ls/mqdefault.jpg",
    "title": "【APEX】エペ練習！！！！！w/秋雪こはく、エビオ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-27T15:00:56Z"
  },
  {
    "videoId": "9HcSGqAxkWU",
    "thumbnail": "https://i.ytimg.com/vi/9HcSGqAxkWU/mqdefault.jpg",
    "title": "【APEX】ネオポリエペ部！大会前日練習だ！w/秋雪こはく、エビオ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-28T16:54:42Z"
  },
  {
    "videoId": "67WBLsH6Xgc",
    "thumbnail": "https://i.ytimg.com/vi/67WBLsH6Xgc/mqdefault.jpg",
    "title": "【APEX】 #ネオポリエペ部WIN  猫鯖フェスやっぞー！！秋雪こはく、エビオ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-03-29T15:29:33Z"
  },
  {
    "videoId": "SbC-WmWQNmI",
    "thumbnail": "https://i.ytimg.com/vi/SbC-WmWQNmI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】4回目￤獅白杯いよいよ明日！ガイル村ひぐち村長と最終調整だ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-30T19:40:12Z"
  },
  {
    "videoId": "LRXoxBSvswI",
    "thumbnail": "https://i.ytimg.com/vi/LRXoxBSvswI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#獅白杯 本番！ソニブ！！！サマソ！！！ #ガイル村WIN 【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-03-31T15:37:26Z"
  },
  {
    "videoId": "2PuJ58xDS-Y",
    "thumbnail": "https://i.ytimg.com/vi/2PuJ58xDS-Y/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】縛りありで最初からみんなで始める！ #ネオポリスモンハン部 2日目w/エビオ、秋雪こはく、ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-01T19:07:27Z"
  },
  {
    "videoId": "AbXCE8WyyM4",
    "thumbnail": "https://i.ytimg.com/vi/AbXCE8WyyM4/mqdefault.jpg",
    "title": "【雑談/Free Talk】猫鯖エペ大会も獅白杯もおつかれさまー！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-02T14:03:35Z"
  },
  {
    "videoId": "swa06DAo9qs",
    "thumbnail": "https://i.ytimg.com/vi/swa06DAo9qs/mqdefault.jpg",
    "title": "【MJ麻雀】#かみちゃまろーぜ 1期生で麻雀練習？？？？？！w/白上フブキ、赤井はあと【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-05T15:40:01Z"
  },
  {
    "videoId": "_cnEpE74CIA",
    "thumbnail": "https://i.ytimg.com/vi/_cnEpE74CIA/mqdefault.jpg",
    "title": "【セガNET麻雀 MJ￤#ホロ麻雀チーム大会】#かみちゃまろーぜ で目指せエンジョイ優勝！w/白上フブキ、赤井はあと【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-06T12:11:28Z"
  },
  {
    "videoId": "Y4ffiGeI7d8",
    "thumbnail": "https://i.ytimg.com/vi/Y4ffiGeI7d8/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】MRアイスボーン突入編！#ネオポリスモンハン部 3日目w/エビオ、秋雪こはく、ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-07T16:40:35Z"
  },
  {
    "videoId": "KqKxX5SDBTY",
    "thumbnail": "https://i.ytimg.com/vi/KqKxX5SDBTY/mqdefault.jpg",
    "title": "【Lethal Company】高額ハンター目指して！？？w/フブちゃ、アルさん、青くゆ【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-08T12:16:35Z"
  },
  {
    "videoId": "DqNUZvTdB54",
    "thumbnail": "https://i.ytimg.com/vi/DqNUZvTdB54/mqdefault.jpg",
    "title": "【雑談/Free Talk】ゲリララララララ！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-09T14:46:43Z"
  },
  {
    "videoId": "MCLI1pC5UzM",
    "thumbnail": "https://i.ytimg.com/vi/MCLI1pC5UzM/mqdefault.jpg",
    "title": "【Content Warning】獅白杯おつかれ様！ガイル村でホラー系Youtuber目指します【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-10T16:00:52Z"
  },
  {
    "videoId": "-4nqA1wK8Dg",
    "thumbnail": "https://i.ytimg.com/vi/-4nqA1wK8Dg/mqdefault.jpg",
    "title": "【Warlander】はちゃめちゃ攻城バトルらしい！？完全初見！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-11T18:36:24Z"
  },
  {
    "videoId": "zvNMY-BHmk4",
    "thumbnail": "https://i.ytimg.com/vi/zvNMY-BHmk4/mqdefault.jpg",
    "title": "【時代は完全栄養食】Huel（ヒュエル）を食レポするよ！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-12T11:32:46Z"
  },
  {
    "videoId": "Io1_bmym3X0",
    "thumbnail": "https://i.ytimg.com/vi/Io1_bmym3X0/mqdefault.jpg",
    "title": "【APEX】えーぺっすくやろうの会！！！w/ころねん、ねねち【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-04-12T15:08:33Z"
  },
  {
    "videoId": "CpOl8ddr1fk",
    "thumbnail": "https://i.ytimg.com/vi/CpOl8ddr1fk/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！とりあえず出発だー！！！-１日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-13T21:48:03Z"
  },
  {
    "videoId": "IGI0Wjy3Az4",
    "thumbnail": "https://i.ytimg.com/vi/IGI0Wjy3Az4/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！とりあえず出発だー！！！-1.5日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-14T02:30:33Z"
  },
  {
    "videoId": "726FZsH5rww",
    "thumbnail": "https://i.ytimg.com/vi/726FZsH5rww/mqdefault.jpg",
    "title": "【Warlander】Rakuten esports cup本番いくぞ～～！！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-04-14T13:09:32Z"
  },
  {
    "videoId": "HYKlSwrcxiw",
    "thumbnail": "https://i.ytimg.com/vi/HYKlSwrcxiw/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！とりあえず出発だー！！！-2日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-14T21:30:52Z"
  },
  {
    "videoId": "5-xVlaOBsn8",
    "thumbnail": "https://i.ytimg.com/vi/5-xVlaOBsn8/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！とりあえず出発だー！！！-3日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-15T21:39:33Z"
  },
  {
    "videoId": "17qWjp-7ang",
    "thumbnail": "https://i.ytimg.com/vi/17qWjp-7ang/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！残り半分！！-4日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-16T21:50:54Z"
  },
  {
    "videoId": "-Qoz8bJEwNM",
    "thumbnail": "https://i.ytimg.com/vi/-Qoz8bJEwNM/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！限界RUST組でエンジョイ！！-5日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-17T21:40:25Z"
  },
  {
    "videoId": "_V77tZs0PMg",
    "thumbnail": "https://i.ytimg.com/vi/_V77tZs0PMg/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！限界RUST組でエンジョイ！！-6日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-18T20:27:29Z"
  },
  {
    "videoId": "luRiOtxuCdM",
    "thumbnail": "https://i.ytimg.com/vi/luRiOtxuCdM/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！限界RUST組でエンジョイ！！-7日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-19T17:02:46Z"
  },
  {
    "videoId": "6bvFfRhhIlg",
    "thumbnail": "https://i.ytimg.com/vi/6bvFfRhhIlg/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！限界RUST組でエンジョイ！！-7.5日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-19T21:17:43Z"
  },
  {
    "videoId": "XcrBaFYIFN0",
    "thumbnail": "https://i.ytimg.com/vi/XcrBaFYIFN0/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！いくぞ！限界RUST組！！最後までエンジョイ！！-8日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-20T13:33:16Z"
  },
  {
    "videoId": "jQcj3ffFXlk",
    "thumbnail": "https://i.ytimg.com/vi/jQcj3ffFXlk/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！限界RUST組でエンジョイ！！-8.5日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-20T21:32:28Z"
  },
  {
    "videoId": "bII7Dwn1f-s",
    "thumbnail": "https://i.ytimg.com/vi/bII7Dwn1f-s/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！チーム「限界コントRUST」最終日いくぞー！-9日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-21T11:33:54Z"
  },
  {
    "videoId": "Tt8XhNSGf4A",
    "thumbnail": "https://i.ytimg.com/vi/Tt8XhNSGf4A/mqdefault.jpg",
    "title": "【VCR RUSTⅡ】スト鯖RUST初参戦！チーム「限界コントRUST」最終日いくぞー！-9.5日目-【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-21T18:18:36Z"
  },
  {
    "videoId": "Rjvp-PL5LXM",
    "thumbnail": "https://i.ytimg.com/vi/Rjvp-PL5LXM/mqdefault.jpg",
    "title": "【雑談/Free Talk】体調復活！振り返りや雑談など！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-24T15:03:40Z"
  },
  {
    "videoId": "96pkqM6NAPo",
    "thumbnail": "https://i.ytimg.com/vi/96pkqM6NAPo/mqdefault.jpg",
    "title": "【Buckshot Roulette】頭脳×運×命がけのロシアンルーレット【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-25T17:46:32Z"
  },
  {
    "videoId": "J6_mHIaMlEk",
    "thumbnail": "https://i.ytimg.com/vi/J6_mHIaMlEk/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】久しぶりのガイル！ランクにいってみる！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-26T17:04:50Z"
  },
  {
    "videoId": "ilOBnpsaPxw",
    "thumbnail": "https://i.ytimg.com/vi/ilOBnpsaPxw/mqdefault.jpg",
    "title": "【#ホロドロケイ2024】泥棒しちゃうぞ♡【ホロライブ/アキロゼ】",
    "publishedAt": "2024-04-28T13:48:39Z"
  },
  {
    "videoId": "1yWINqm_1k4",
    "thumbnail": "https://i.ytimg.com/vi/1yWINqm_1k4/mqdefault.jpg",
    "title": "にっこり^^調査隊のテーマ / エクスアルビオ×白雪レイド×アキロゼ(cover)",
    "publishedAt": "2024-04-29T12:00:06Z"
  },
  {
    "videoId": "7B55XS6iIYY",
    "thumbnail": "https://i.ytimg.com/vi/7B55XS6iIYY/mqdefault.jpg",
    "title": "【Human: Fall Flat】へっぽこ3人組改めふにゃふにゃ3人組になった！w/エビオ、レイド【アキロゼ/ホロライブ】",
    "publishedAt": "2024-04-29T15:04:43Z"
  },
  {
    "videoId": "vpgwli8GYx0",
    "thumbnail": "https://i.ytimg.com/vi/vpgwli8GYx0/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】MRアイスボーン攻略編！ #ネオポリスモンハン部 4日目w/エビオ、秋雪こはく、ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-04-30T19:35:28Z"
  },
  {
    "videoId": "XQQpJy_8PBg",
    "thumbnail": "https://i.ytimg.com/vi/XQQpJy_8PBg/mqdefault.jpg",
    "title": "【8番出口】あのゲームをついにやる！異変調査にレッツゴー【ホロライブ/アキロゼ】",
    "publishedAt": "2024-05-01T16:36:49Z"
  },
  {
    "videoId": "2A8U-Ds275s",
    "thumbnail": "https://i.ytimg.com/vi/2A8U-Ds275s/mqdefault.jpg",
    "title": "【#ホロドロケイ2024】後夜祭だってー！！泥棒も警察もごちゃ混ぜ？【アキロゼ視点/ホロライブ】",
    "publishedAt": "2024-05-02T12:44:43Z"
  },
  {
    "videoId": "Cnh7taVCE7w",
    "thumbnail": "https://i.ytimg.com/vi/Cnh7taVCE7w/mqdefault.jpg",
    "title": "【Lethal Company】ガイル村で惑星探索旅行にレッツゴー！！ #ガイル村カンパニー【アキロゼ/ホロライブ】",
    "publishedAt": "2024-05-03T15:44:21Z"
  },
  {
    "videoId": "uOcZ3jvUm3Q",
    "thumbnail": "https://i.ytimg.com/vi/uOcZ3jvUm3Q/mqdefault.jpg",
    "title": "【雑談/Free Talk】リフレッシュ休暇から帰還！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-05-07T14:04:17Z"
  },
  {
    "videoId": "E3FcWrMbbDo",
    "thumbnail": "https://i.ytimg.com/vi/E3FcWrMbbDo/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】5回目￤新デバイス買ってみた！ガイル村村長からついに緑の光の伝授！？【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-07T17:26:32Z"
  },
  {
    "videoId": "BvxSL-HSxFw",
    "thumbnail": "https://i.ytimg.com/vi/BvxSL-HSxFw/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】アイスボーンでついにMR開放！？  #ネオポリスモンハン部 5日目w/エビオ、秋雪こはく、ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-08T17:01:48Z"
  },
  {
    "videoId": "kO6TumzT48I",
    "thumbnail": "https://i.ytimg.com/vi/kO6TumzT48I/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】CR Cupスクリム初日！レバレス触りたてのモダンガイル【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-09T19:33:10Z"
  },
  {
    "videoId": "nRnwAQGrNwY",
    "thumbnail": "https://i.ytimg.com/vi/nRnwAQGrNwY/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】CR Cupスクリム2日目！レバレスモダンガイル【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-10T15:05:38Z"
  },
  {
    "videoId": "2XjJ5cdxSfM",
    "thumbnail": "https://i.ytimg.com/vi/2XjJ5cdxSfM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】CR Cupスクリム3日目！レバレスモダンガイル【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-11T18:41:05Z"
  },
  {
    "videoId": "qmXSFvmxQXo",
    "thumbnail": "https://i.ytimg.com/vi/qmXSFvmxQXo/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#CRカップ 本番！がんばる！レバレスモダンガイル #まおのこWIN【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-12T14:56:40Z"
  },
  {
    "videoId": "8ZW2sJycSlc",
    "thumbnail": "https://i.ytimg.com/vi/8ZW2sJycSlc/mqdefault.jpg",
    "title": "【Minecraft】危険なお仕事お任せください！！ #ホロ鯖マイクラハードコア【ホロライブ/アキロゼ】",
    "publishedAt": "2024-05-16T16:08:59Z"
  },
  {
    "videoId": "5MAUUr2bieY",
    "thumbnail": "https://i.ytimg.com/vi/5MAUUr2bieY/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】CR Cupおつかれさま会！雑談しながらバトルハブいってみる【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-17T16:53:21Z"
  },
  {
    "videoId": "R5QQMyw6BYU",
    "thumbnail": "https://i.ytimg.com/vi/R5QQMyw6BYU/mqdefault.jpg",
    "title": "【Content Warning】限界RUST初期メン4人娘でバズ動画撮影しに行ってみた！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-05-18T15:11:37Z"
  },
  {
    "videoId": "qyajTVfDc2A",
    "thumbnail": "https://i.ytimg.com/vi/qyajTVfDc2A/mqdefault.jpg",
    "title": "【MHW:IB/モンハンワールド 】視聴者参加型！ひと狩りいこーぜ！珠とか素材とか集めたい！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-05-22T17:40:15Z"
  },
  {
    "videoId": "zHgOQan16jo",
    "thumbnail": "https://i.ytimg.com/vi/zHgOQan16jo/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】臨界ブラキやアルバとご対面！？  #ネオポリスモンハン部 6日目w/エビオ、秋雪こはく、ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-23T19:07:31Z"
  },
  {
    "videoId": "OTPKRiEA8us",
    "thumbnail": "https://i.ytimg.com/vi/OTPKRiEA8us/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】アプデきた！モダンかクラシックか決めたい！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-24T17:28:12Z"
  },
  {
    "videoId": "2v7aAiB6XeQ",
    "thumbnail": "https://i.ytimg.com/vi/2v7aAiB6XeQ/mqdefault.jpg",
    "title": "【VALHEIM】#限界コントRUST 北欧神話の世界で海賊生活始めます！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-05-26T19:29:10Z"
  },
  {
    "videoId": "S8VdfLEszQg",
    "thumbnail": "https://i.ytimg.com/vi/S8VdfLEszQg/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】実戦が足りない！体当たりで修行するぞ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-29T16:00:07Z"
  },
  {
    "videoId": "cgwGgH09zVo",
    "thumbnail": "https://i.ytimg.com/vi/cgwGgH09zVo/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】体当たりで修行！明日でデビュー6周年なので6連勝したい【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-05-31T14:46:28Z"
  },
  {
    "videoId": "_nt5WqcUg6Y",
    "thumbnail": "https://i.ytimg.com/vi/_nt5WqcUg6Y/mqdefault.jpg",
    "title": "【 #アキロゼ活動6周年】1期生でリレー告知！まさかのアレ・・・がグッズに！？？【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-02T12:46:44Z"
  },
  {
    "videoId": "tskTnmDOXdI",
    "thumbnail": "https://i.ytimg.com/vi/tskTnmDOXdI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】今日も今日とてガイル筋育てる！！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-05T13:49:02Z"
  },
  {
    "videoId": "_lM7W3OjSos",
    "thumbnail": "https://i.ytimg.com/vi/_lM7W3OjSos/mqdefault.jpg",
    "title": "【 Escape the Backrooms】脱出ホラー！無限空間って怖いよね＞＜【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-05T15:57:03Z"
  },
  {
    "videoId": "_ptumosmJGI",
    "thumbnail": "https://i.ytimg.com/vi/_ptumosmJGI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#Vスト６律可杯 顔合わせ対戦会！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-06T17:30:45Z"
  },
  {
    "videoId": "G1hUBcm7wG8",
    "thumbnail": "https://i.ytimg.com/vi/G1hUBcm7wG8/mqdefault.jpg",
    "title": "【MHW/モンハンワールド 】アルバ装備欲しいけどいったいどうなる！？  #ネオポリスモンハン部 7日目w/エビオ、秋雪こはく、ととみっくす【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-07T18:02:10Z"
  },
  {
    "videoId": "VrwSfZ8fHv8",
    "thumbnail": "https://i.ytimg.com/vi/VrwSfZ8fHv8/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ドンさんコーチングで練習するぞ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-08T17:57:45Z"
  },
  {
    "videoId": "WIwIqmU29JM",
    "thumbnail": "https://i.ytimg.com/vi/WIwIqmU29JM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ひぐち村長コーチングで練習するぞ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-09T10:55:30Z"
  },
  {
    "videoId": "d7d5w-PhcXI",
    "thumbnail": "https://i.ytimg.com/vi/d7d5w-PhcXI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】今日も今日とてドンさんコーチングで練習するぞ！【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-09T16:47:25Z"
  },
  {
    "videoId": "ekDyqPOnG2A",
    "thumbnail": "https://i.ytimg.com/vi/ekDyqPOnG2A/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】深夜のコソ練【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-10T18:33:18Z"
  },
  {
    "videoId": "LEw0zvJj71U",
    "thumbnail": "https://i.ytimg.com/vi/LEw0zvJj71U/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】前日スクリム練習会！！ #Vスト6律可杯 【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-11T18:21:05Z"
  },
  {
    "videoId": "zf3L_B1jGIo",
    "thumbnail": "https://i.ytimg.com/vi/zf3L_B1jGIo/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】本番！！！！#老WIN  #Vスト6律可杯 【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2024-06-12T15:56:21Z"
  },
  {
    "videoId": "oWd4S6va9mE",
    "thumbnail": "https://i.ytimg.com/vi/oWd4S6va9mE/mqdefault.jpg",
    "title": "【雑談/Free Talk】アキフブみこめっとでグランピング行ってきた！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-16T17:10:09Z"
  },
  {
    "videoId": "2bjDi0SU4t8",
    "thumbnail": "https://i.ytimg.com/vi/2bjDi0SU4t8/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ホロひぐち顔合わせ！ビーストカップに出るぞー！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-06-17T16:54:15Z"
  },
  {
    "videoId": "u1r9r22YdaA",
    "thumbnail": "https://i.ytimg.com/vi/u1r9r22YdaA/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ホロひぐちでビーストカップ練習会！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-06-21T16:45:43Z"
  },
  {
    "videoId": "sz97dvJRTTs",
    "thumbnail": "https://i.ytimg.com/vi/sz97dvJRTTs/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ビーストカップ本番！！ #ホロひぐちWIN【アキロゼ/ホロライブ】",
    "publishedAt": "2024-06-22T08:30:10Z"
  },
  {
    "videoId": "7SnZgst17w8",
    "thumbnail": "https://i.ytimg.com/vi/7SnZgst17w8/mqdefault.jpg",
    "title": "#ビビデバ 踊ってみた #bibbidibachallenge #shorts #short",
    "publishedAt": "2024-06-25T12:00:07Z"
  },
  {
    "videoId": "bDy1dR_Udd8",
    "thumbnail": "https://i.ytimg.com/vi/bDy1dR_Udd8/mqdefault.jpg",
    "title": "【雑談/Free Talk】まったりしNight【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-25T16:50:09Z"
  },
  {
    "videoId": "ci6rvwhuHco",
    "thumbnail": "https://i.ytimg.com/vi/ci6rvwhuHco/mqdefault.jpg",
    "title": "【VALHEIM】#限界コントRUST 北欧神話の世界で海賊生活始めます！Part2【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-27T20:35:09Z"
  },
  {
    "videoId": "i4kEItVC-lo",
    "thumbnail": "https://i.ytimg.com/vi/i4kEItVC-lo/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-28T20:51:21Z"
  },
  {
    "videoId": "7bBcxHW7YWk",
    "thumbnail": "https://i.ytimg.com/vi/7bBcxHW7YWk/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part2【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-29T06:30:28Z"
  },
  {
    "videoId": "eErqk2ISVNk",
    "thumbnail": "https://i.ytimg.com/vi/eErqk2ISVNk/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！建築とかまったり作業予定Part3【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-30T15:42:36Z"
  },
  {
    "videoId": "6KkGfLJ5hXI",
    "thumbnail": "https://i.ytimg.com/vi/6KkGfLJ5hXI/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part4【ホロライブ/アキロゼ】",
    "publishedAt": "2024-06-30T23:22:30Z"
  },
  {
    "videoId": "nG2nQtMPWDI",
    "thumbnail": "https://i.ytimg.com/vi/nG2nQtMPWDI/mqdefault.jpg",
    "title": "ゲリラ！【麻雀一番街】第4回HP麻雀杯に出るので深夜にコソ練！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-03T18:24:11Z"
  },
  {
    "videoId": "DxMY2BL5afU",
    "thumbnail": "https://i.ytimg.com/vi/DxMY2BL5afU/mqdefault.jpg",
    "title": "【麻雀一番街】明日は大会なので直前練習する！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-04T16:14:36Z"
  },
  {
    "videoId": "bA4QEEy7qfM",
    "thumbnail": "https://i.ytimg.com/vi/bA4QEEy7qfM/mqdefault.jpg",
    "title": "【麻雀一番街】大会本番いくぞ！第4回HP麻雀杯【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-05T15:53:19Z"
  },
  {
    "videoId": "2nuQpFp_VCw",
    "thumbnail": "https://i.ytimg.com/vi/2nuQpFp_VCw/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part5【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-06T20:38:48Z"
  },
  {
    "videoId": "fbbg9hg5C3c",
    "thumbnail": "https://i.ytimg.com/vi/fbbg9hg5C3c/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part6【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-07T05:38:25Z"
  },
  {
    "videoId": "VqqCuR6UQfY",
    "thumbnail": "https://i.ytimg.com/vi/VqqCuR6UQfY/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part7【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-08T00:25:25Z"
  },
  {
    "videoId": "G1jR2MDQJyU",
    "thumbnail": "https://i.ytimg.com/vi/G1jR2MDQJyU/mqdefault.jpg",
    "title": "【ASA￤Center】全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part８【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-08T06:16:23Z"
  },
  {
    "videoId": "yUhfv5Nfptk",
    "thumbnail": "https://i.ytimg.com/vi/yUhfv5Nfptk/mqdefault.jpg",
    "title": "しかのこのこのここしたんたん #anime #memes #shorts",
    "publishedAt": "2024-07-08T12:45:21Z"
  },
  {
    "videoId": "h6V4llist4Q",
    "thumbnail": "https://i.ytimg.com/vi/h6V4llist4Q/mqdefault.jpg",
    "title": "【Chained Together】鎖のゲームクリアまで？！連帯責任なので！！！！ #ネオポリ女子会 【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-09T20:25:26Z"
  },
  {
    "videoId": "Wwv1umW5fME",
    "thumbnail": "https://i.ytimg.com/vi/Wwv1umW5fME/mqdefault.jpg",
    "title": "【雑談/Free Talk】まったりお話ししよ！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-10T16:27:53Z"
  },
  {
    "videoId": "_qumBO9p22o",
    "thumbnail": "https://i.ytimg.com/vi/_qumBO9p22o/mqdefault.jpg",
    "title": "撮影してるとこ全部晒されたwしかのこのこのここしたんたん #vtuber #ホロライブ #踊ってみた 【シカ色デイズ/アキロゼ】",
    "publishedAt": "2024-07-11T11:13:23Z"
  },
  {
    "videoId": "wKe1FkpbzIQ",
    "thumbnail": "https://i.ytimg.com/vi/wKe1FkpbzIQ/mqdefault.jpg",
    "title": "【僕、アルバイトォォ！！】迷惑客はお帰りくださいっっ！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-11T16:33:47Z"
  },
  {
    "videoId": "LiHkAUXttUw",
    "thumbnail": "https://i.ytimg.com/vi/LiHkAUXttUw/mqdefault.jpg",
    "title": "うぃっうぃっうぃっ #vtuber #ホロライブ #踊ってみた #アキロゼ  【 #うい麦畑でつかまえて 】 #shorts",
    "publishedAt": "2024-07-11T22:30:05Z"
  },
  {
    "videoId": "hmOLxKkW9yQ",
    "thumbnail": "https://i.ytimg.com/vi/hmOLxKkW9yQ/mqdefault.jpg",
    "title": "【Overcooked 2】ガイル村料理店開店！ビーストカップ打ち上げ！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-07-12T18:23:17Z"
  },
  {
    "videoId": "AyliXYiZxlM",
    "thumbnail": "https://i.ytimg.com/vi/AyliXYiZxlM/mqdefault.jpg",
    "title": "NGシーンも可愛いすぎてヤバいw #うい麦畑でつかまえて #vtuber #ホロライブ #踊ってみた #アキロゼ #shorts",
    "publishedAt": "2024-07-12T23:58:55Z"
  },
  {
    "videoId": "c0HDUWIMRto",
    "thumbnail": "https://i.ytimg.com/vi/c0HDUWIMRto/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】遊園地貸し切り派いくよ～！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-13T18:13:40Z"
  },
  {
    "videoId": "Mc_UPFbLoN8",
    "thumbnail": "https://i.ytimg.com/vi/Mc_UPFbLoN8/mqdefault.jpg",
    "title": "【ASA￤Center】最終回（たぶん）全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part9【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-14T16:03:19Z"
  },
  {
    "videoId": "iWZ6mNZxIP4",
    "thumbnail": "https://i.ytimg.com/vi/iWZ6mNZxIP4/mqdefault.jpg",
    "title": "【ASA￤Center】最終回（たぶん）全恐竜捕まえるまで終われまテン！新MAPに新要素も味わうぞ！！Part10【アキロゼ/ホロライブ】",
    "publishedAt": "2024-07-14T23:38:04Z"
  },
  {
    "videoId": "r8cKkO824-4",
    "thumbnail": "https://i.ytimg.com/vi/r8cKkO824-4/mqdefault.jpg",
    "title": "ぱぱっぱ #愛包ダンスホール  #vtuber #ホロライブ #踊ってみた #アキロゼ",
    "publishedAt": "2024-07-15T08:55:23Z"
  },
  {
    "videoId": "g9l82VXzQdc",
    "thumbnail": "https://i.ytimg.com/vi/g9l82VXzQdc/mqdefault.jpg",
    "title": "【APEX】エーペックスやるぞ～～！！ w/八雲べに、エビオ【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-15T17:53:36Z"
  },
  {
    "videoId": "8H19Kod9a08",
    "thumbnail": "https://i.ytimg.com/vi/8H19Kod9a08/mqdefault.jpg",
    "title": "練習中にキメ顔してる瞬間とられてたw #愛包ダンスホール  #踊ってみた #ホロライブ #vtuber #shorts #アキロゼ",
    "publishedAt": "2024-07-17T12:26:33Z"
  },
  {
    "videoId": "eopZf74wUSY",
    "thumbnail": "https://i.ytimg.com/vi/eopZf74wUSY/mqdefault.jpg",
    "title": "【APEX】4人モードで遊ぶ！！ #ちくまろ【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-17T15:18:26Z"
  },
  {
    "videoId": "8FgMTVj7Tco",
    "thumbnail": "https://i.ytimg.com/vi/8FgMTVj7Tco/mqdefault.jpg",
    "title": "【APEX】小粋な雑談をしながらできたらそりゃあもう【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-18T17:27:54Z"
  },
  {
    "videoId": "-ob6LhI86yo",
    "thumbnail": "https://i.ytimg.com/vi/-ob6LhI86yo/mqdefault.jpg",
    "title": "【VALHEIM】#限界コントRUST 北欧神話の世界で海賊生活始めます！Part3【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-19T18:31:33Z"
  },
  {
    "videoId": "IcUbcxGiNZk",
    "thumbnail": "https://i.ytimg.com/vi/IcUbcxGiNZk/mqdefault.jpg",
    "title": "【祇：Path of the Goddess】カプコンの完全新作！舞え！戦え！穢れを払え！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-20T12:07:49Z"
  },
  {
    "videoId": "4PDsTHJEWno",
    "thumbnail": "https://i.ytimg.com/vi/4PDsTHJEWno/mqdefault.jpg",
    "title": "【ゲリラ雑談】明日からホロ鯖ARK始まるらしいのでもはや緊急作戦会議まである【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-22T14:38:51Z"
  },
  {
    "videoId": "wCs18_YULmQ",
    "thumbnail": "https://i.ytimg.com/vi/wCs18_YULmQ/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】1日目 さてと始めるか。【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-23T17:49:11Z"
  },
  {
    "videoId": "lzKZkJoR8-A",
    "thumbnail": "https://i.ytimg.com/vi/lzKZkJoR8-A/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】2日目 初レイドに備えねば。【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-24T18:44:41Z"
  },
  {
    "videoId": "eqXC_5jSCtI",
    "thumbnail": "https://i.ytimg.com/vi/eqXC_5jSCtI/mqdefault.jpg",
    "title": "【APEX】コーチング配信がきた！w/なっちさん【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-25T09:28:44Z"
  },
  {
    "videoId": "faipAVoreuo",
    "thumbnail": "https://i.ytimg.com/vi/faipAVoreuo/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】3日目 文明開化させたい【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-25T19:42:48Z"
  },
  {
    "videoId": "R0g0Rm3B5HE",
    "thumbnail": "https://i.ytimg.com/vi/R0g0Rm3B5HE/mqdefault.jpg",
    "title": "【 #ホロ1期生コラボ 】みんなで歌うぞ～🎤【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-26T10:18:34Z"
  },
  {
    "videoId": "2PikrkD2yoA",
    "thumbnail": "https://i.ytimg.com/vi/2PikrkD2yoA/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】4日目 強くなれ、そして見知らぬ地へ【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-26T18:40:52Z"
  },
  {
    "videoId": "bA35pOX9Unk",
    "thumbnail": "https://i.ytimg.com/vi/bA35pOX9Unk/mqdefault.jpg",
    "title": "III💕 #vtuber #ホロライブ #shorts #踊ってみた #アキロゼ",
    "publishedAt": "2024-07-27T06:16:27Z"
  },
  {
    "videoId": "9I6j9ZF6GiI",
    "thumbnail": "https://i.ytimg.com/vi/9I6j9ZF6GiI/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】5日目 地下世界へ【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-27T22:18:52Z"
  },
  {
    "videoId": "bCevSpH8s5I",
    "thumbnail": "https://i.ytimg.com/vi/bCevSpH8s5I/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】6日目 ケツァル空母そして洞窟へ【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-28T19:49:39Z"
  },
  {
    "videoId": "Zr3T64cfF_I",
    "thumbnail": "https://i.ytimg.com/vi/Zr3T64cfF_I/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】7日目 いけるのかTEK文明【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-29T20:34:45Z"
  },
  {
    "videoId": "3km8ZrHl1Os",
    "thumbnail": "https://i.ytimg.com/vi/3km8ZrHl1Os/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】8日目 まさかのタイタンテイムつまり【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-30T20:48:18Z"
  },
  {
    "videoId": "6M_MMLOy0iY",
    "thumbnail": "https://i.ytimg.com/vi/6M_MMLOy0iY/mqdefault.jpg",
    "title": "【#ホロARK ￤valguero】9日目 最終日どちらが勝つか【ホロライブ/アキロゼ】",
    "publishedAt": "2024-07-31T16:00:35Z"
  },
  {
    "videoId": "RACw0KVooKo",
    "thumbnail": "https://i.ytimg.com/vi/RACw0KVooKo/mqdefault.jpg",
    "title": "【APEX】V最顔合わせ！最協メンバーはこの3人だ！！wメイカさん/dttoちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-01T17:49:04Z"
  },
  {
    "videoId": "ZPw0SiYmojM",
    "thumbnail": "https://i.ytimg.com/vi/ZPw0SiYmojM/mqdefault.jpg",
    "title": "【#ホロARK  振り返り感想枠！】この時こう考えてました！的な振り返り雑談【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-03T13:42:05Z"
  },
  {
    "videoId": "845IXEc72g0",
    "thumbnail": "https://i.ytimg.com/vi/845IXEc72g0/mqdefault.jpg",
    "title": "ブギウギばんばん #pokedance #vtuber #踊ってみた #ホロライブ #アキロゼ #shorts",
    "publishedAt": "2024-08-09T12:41:24Z"
  },
  {
    "videoId": "OOlKrEnpU44",
    "thumbnail": "https://i.ytimg.com/vi/OOlKrEnpU44/mqdefault.jpg",
    "title": "マリン船長の #美少女無罪パイレーツ #踊ってみた #ホロライブ #vtuber #アキロゼ #shorts",
    "publishedAt": "2024-08-10T08:00:23Z"
  },
  {
    "videoId": "2ow6ag-MJhs",
    "thumbnail": "https://i.ytimg.com/vi/2ow6ag-MJhs/mqdefault.jpg",
    "title": "【APEX】V最練習！視聴者カスタムやるぞ！w/なっちさん、dtto.ちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-12T21:14:20Z"
  },
  {
    "videoId": "oGdgAf8B3mM",
    "thumbnail": "https://i.ytimg.com/vi/oGdgAf8B3mM/mqdefault.jpg",
    "title": "【APEX】今夜もV最練習！w/dtto.ちゃん、メイカちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-14T04:53:10Z"
  },
  {
    "videoId": "XBtFXFOvnOY",
    "thumbnail": "https://i.ytimg.com/vi/XBtFXFOvnOY/mqdefault.jpg",
    "title": "【APEX】今夜もV最練習！w/dtto.ちゃん、むかいコーチ【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-16T23:43:31Z"
  },
  {
    "videoId": "Hh6GFLqtQlU",
    "thumbnail": "https://i.ytimg.com/vi/Hh6GFLqtQlU/mqdefault.jpg",
    "title": "【APEX】V最練習！w/dtto.ちゃん、こはくちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-17T00:14:19Z"
  },
  {
    "videoId": "a9Ioxe-NV0o",
    "thumbnail": "https://i.ytimg.com/vi/a9Ioxe-NV0o/mqdefault.jpg",
    "title": "【APEX】肩にサロンパス、今夜もV最練習！w/なっちさん,dtto.ちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-17T20:56:07Z"
  },
  {
    "videoId": "eSJ51Gl0GhU",
    "thumbnail": "https://i.ytimg.com/vi/eSJ51Gl0GhU/mqdefault.jpg",
    "title": "【APEX】V最スクリム初日！w/【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-18T19:34:08Z"
  },
  {
    "videoId": "iFS1oU_n-AM",
    "thumbnail": "https://i.ytimg.com/vi/iFS1oU_n-AM/mqdefault.jpg",
    "title": "【APEX】V最スクリム2日me！w/【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-19T20:15:24Z"
  },
  {
    "videoId": "zdm8bsoaZ-4",
    "thumbnail": "https://i.ytimg.com/vi/zdm8bsoaZ-4/mqdefault.jpg",
    "title": "【APEX】チーム名「ぷれでたーといっしょ」呼び名はWith P！ V最スクリム3日目！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-20T21:37:26Z"
  },
  {
    "videoId": "GHBiK4T95Sk",
    "thumbnail": "https://i.ytimg.com/vi/GHBiK4T95Sk/mqdefault.jpg",
    "title": "【APEX】応援お願いします！「ぷれでたーといっしょ」呼び名はWith P！ V最スクリム4日目！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-21T21:21:04Z"
  },
  {
    "videoId": "x4iHoV867MY",
    "thumbnail": "https://i.ytimg.com/vi/x4iHoV867MY/mqdefault.jpg",
    "title": "【APEX】応援お願いします！「ぷれでたーといっしょ」呼び名はWith P！ V最スクリム5日目！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-22T17:00:47Z"
  },
  {
    "videoId": "8gqr-bxdKMM",
    "thumbnail": "https://i.ytimg.com/vi/8gqr-bxdKMM/mqdefault.jpg",
    "title": "【APEX】応援お願いします！ #ぷれでたーといっしょ 呼び名はWith P！ V最前日【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-23T18:45:48Z"
  },
  {
    "videoId": "pdt6FNE3MPk",
    "thumbnail": "https://i.ytimg.com/vi/pdt6FNE3MPk/mqdefault.jpg",
    "title": "【APEX】全力応援お願いします！ #ぷれでたーといっしょ  #With P  V最本番！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-24T15:10:27Z"
  },
  {
    "videoId": "Uknn26qQgkY",
    "thumbnail": "https://i.ytimg.com/vi/Uknn26qQgkY/mqdefault.jpg",
    "title": "【オーバーウォッチ2】二次会 #ぷれでたーといっしょ 呼び名はWith P！ 【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-24T18:33:56Z"
  },
  {
    "videoId": "9CoP4Ne_0Sk",
    "thumbnail": "https://i.ytimg.com/vi/9CoP4Ne_0Sk/mqdefault.jpg",
    "title": "【雑談/Free Talk】V最おつかれー！！！！！！！【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-25T17:21:04Z"
  },
  {
    "videoId": "uMfh7yjWi98",
    "thumbnail": "https://i.ytimg.com/vi/uMfh7yjWi98/mqdefault.jpg",
    "title": "ルイルイの #魔眼ウィンク  #踊ってみた #ホロライブ #vtuber #アキロゼ #shorts",
    "publishedAt": "2024-08-26T08:00:39Z"
  },
  {
    "videoId": "gfUQ2m2a7pc",
    "thumbnail": "https://i.ytimg.com/vi/gfUQ2m2a7pc/mqdefault.jpg",
    "title": "あてぃしのこと好きすぎ『l LOVE ME』#湊あくあ forever✨🥲 #ナナヲアカリ #踊ってみた #アキロゼ #shorts",
    "publishedAt": "2024-08-27T03:33:52Z"
  },
  {
    "videoId": "PEPcgAJa0PE",
    "thumbnail": "https://i.ytimg.com/vi/PEPcgAJa0PE/mqdefault.jpg",
    "title": "ココロをください #111 #踊ってみた #vtuber #ホロライブ #アキロゼ #shorts",
    "publishedAt": "2024-08-28T03:00:29Z"
  },
  {
    "videoId": "aUGv7bNGMT4",
    "thumbnail": "https://i.ytimg.com/vi/aUGv7bNGMT4/mqdefault.jpg",
    "title": "【たこパサバイバル】タコパします/wエビオ、日ノ隈らん【アキロゼ/ホロライブ】",
    "publishedAt": "2024-08-29T11:41:36Z"
  },
  {
    "videoId": "zJ9oGw1aLWI",
    "thumbnail": "https://i.ytimg.com/vi/zJ9oGw1aLWI/mqdefault.jpg",
    "title": "【Overcooked 2】きっちんが次の戦場【アキロゼ/ホロライブ】",
    "publishedAt": "2024-08-29T11:55:10Z"
  },
  {
    "videoId": "qrB0wJ7e72s",
    "thumbnail": "https://i.ytimg.com/vi/qrB0wJ7e72s/mqdefault.jpg",
    "title": "【 Escape the Backrooms】謎解き脱出ホラー/wエビオ、日ノ隈らん、秋雪こはく【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-29T14:14:11Z"
  },
  {
    "videoId": "zXhf3SL8rMQ",
    "thumbnail": "https://i.ytimg.com/vi/zXhf3SL8rMQ/mqdefault.jpg",
    "title": "【School Labyrinth】夜の学校にきました【アキロゼ/ホロライブ】",
    "publishedAt": "2024-08-29T15:20:37Z"
  },
  {
    "videoId": "gHTF57MTIwM",
    "thumbnail": "https://i.ytimg.com/vi/gHTF57MTIwM/mqdefault.jpg",
    "title": "ギリギリダンス #はいよろこんで #こっちのけんと #踊ってみた #Vtuber #ホロライブ #アキロゼ",
    "publishedAt": "2024-08-30T22:23:48Z"
  },
  {
    "videoId": "tkSLqr7BzEk",
    "thumbnail": "https://i.ytimg.com/vi/tkSLqr7BzEk/mqdefault.jpg",
    "title": "【ゲリラ雑談】8月と9月のはざま【ホロライブ/アキロゼ】",
    "publishedAt": "2024-08-31T18:18:24Z"
  },
  {
    "videoId": "n_zdUJpn7m4",
    "thumbnail": "https://i.ytimg.com/vi/n_zdUJpn7m4/mqdefault.jpg",
    "title": "練習中のギリギリダンス #はいよろこんで #こっちのけんと #踊ってみた #Vtuber #ホロライブ #アキロゼ",
    "publishedAt": "2024-08-31T22:30:06Z"
  },
  {
    "videoId": "3ss3xhHPPNA",
    "thumbnail": "https://i.ytimg.com/vi/3ss3xhHPPNA/mqdefault.jpg",
    "title": "#男の子のために可愛いわけじゃない #踊ってみた #Vtuber #ホロライブ #アキロゼ",
    "publishedAt": "2024-09-01T22:55:14Z"
  },
  {
    "videoId": "X3Ly-WxALqo",
    "thumbnail": "https://i.ytimg.com/vi/X3Ly-WxALqo/mqdefault.jpg",
    "title": "『ツッパリHigh School Rock'n Roll』 #踊ってみた #ツッパリハイスクールロックンロール #ホロライブ #アキロゼ #vtuber",
    "publishedAt": "2024-09-02T23:02:53Z"
  },
  {
    "videoId": "NlKXYw4HhXk",
    "thumbnail": "https://i.ytimg.com/vi/NlKXYw4HhXk/mqdefault.jpg",
    "title": "NGテイク晒されたw『ツッパリHigh School Rock'n Roll』 #踊ってみた #ツッパリハイスクールロックンロール #ホロライブ #アキロゼ #vtuber",
    "publishedAt": "2024-09-03T22:42:39Z"
  },
  {
    "videoId": "rqGK9Xaqs50",
    "thumbnail": "https://i.ytimg.com/vi/rqGK9Xaqs50/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】超久しぶりなのでガイル筋思い出し！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-04T15:59:30Z"
  },
  {
    "videoId": "WyAzRtGszHY",
    "thumbnail": "https://i.ytimg.com/vi/WyAzRtGszHY/mqdefault.jpg",
    "title": "みこちの『DAI DAI DAIファンタジスタ』踊ってみた！#ホロライブ #アキロゼ #vtuber",
    "publishedAt": "2024-09-05T13:19:41Z"
  },
  {
    "videoId": "_aDOJHK1XEI",
    "thumbnail": "https://i.ytimg.com/vi/_aDOJHK1XEI/mqdefault.jpg",
    "title": "ぎり、ぎり、ぎりハッピー #踊ってみた #ホロライブ #アキロゼ #Vtuber #shorts",
    "publishedAt": "2024-09-05T23:01:58Z"
  },
  {
    "videoId": "svDaPgvwJ-E",
    "thumbnail": "https://i.ytimg.com/vi/svDaPgvwJ-E/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ひぐち村長と特訓！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-06T11:05:18Z"
  },
  {
    "videoId": "YbWTqskmnAU",
    "thumbnail": "https://i.ytimg.com/vi/YbWTqskmnAU/mqdefault.jpg",
    "title": "全方向美少女✨ #踊ってみた #ホロライブ #Vtuber #アキロゼ",
    "publishedAt": "2024-09-07T00:09:51Z"
  },
  {
    "videoId": "olOgIqND5VY",
    "thumbnail": "https://i.ytimg.com/vi/olOgIqND5VY/mqdefault.jpg",
    "title": "【ASA￤アベレーション】続・全恐竜捕まえるまで終われまテン！Part 1【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-07T21:02:50Z"
  },
  {
    "videoId": "lM_0SS23zog",
    "thumbnail": "https://i.ytimg.com/vi/lM_0SS23zog/mqdefault.jpg",
    "title": "【ASA￤アベレーション】続・全恐竜捕まえるまで終われまテン！Part 2【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-08T00:37:26Z"
  },
  {
    "videoId": "4SWT9DdFIeI",
    "thumbnail": "https://i.ytimg.com/vi/4SWT9DdFIeI/mqdefault.jpg",
    "title": "【ASA￤アベレーション】まったり？建築とか観光とか！続・全恐竜捕まえるまで終われまテン！Part 3【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-09T00:39:04Z"
  },
  {
    "videoId": "eke0WrrcOys",
    "thumbnail": "https://i.ytimg.com/vi/eke0WrrcOys/mqdefault.jpg",
    "title": "【ASA￤アベレーション】ロックドレイクの巣にイーリンで突撃！！続・全恐竜捕まえるまで終われまテン！Part 4【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-09T01:21:17Z"
  },
  {
    "videoId": "Q3r6fZMkbSQ",
    "thumbnail": "https://i.ytimg.com/vi/Q3r6fZMkbSQ/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】チームひぐちで練習するよ～！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-09T14:42:49Z"
  },
  {
    "videoId": "M-UxFFcAiGg",
    "thumbnail": "https://i.ytimg.com/vi/M-UxFFcAiGg/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#師弟電流デスマッチ 村長の健康がいちばん！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-11T13:10:19Z"
  },
  {
    "videoId": "GYCpVs2quu4",
    "thumbnail": "https://i.ytimg.com/vi/GYCpVs2quu4/mqdefault.jpg",
    "title": "【ASA￤アベレーション】まったり建築したい！続・全恐竜捕まえるまで終われまテン！Part 5【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-11T17:24:27Z"
  },
  {
    "videoId": "0vqx-s9JFhc",
    "thumbnail": "https://i.ytimg.com/vi/0vqx-s9JFhc/mqdefault.jpg",
    "title": "いったんゲリラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-12T13:34:16Z"
  },
  {
    "videoId": "3LfnWnfKZX0",
    "thumbnail": "https://i.ytimg.com/vi/3LfnWnfKZX0/mqdefault.jpg",
    "title": "【ASA￤アベレーション】拠点を建築したいんだ！続・全恐竜捕まえるまで終われまテン！Part 6【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-12T18:14:08Z"
  },
  {
    "videoId": "lmCOCe26CG0",
    "thumbnail": "https://i.ytimg.com/vi/lmCOCe26CG0/mqdefault.jpg",
    "title": "パシャっと📷✨【2.5次元の誘惑ED】ニゴリリダンス『watch me』踊ってみた！ #アキロゼ #ホロライブ #vtuber",
    "publishedAt": "2024-09-13T21:53:03Z"
  },
  {
    "videoId": "UQvAHpOas8w",
    "thumbnail": "https://i.ytimg.com/vi/UQvAHpOas8w/mqdefault.jpg",
    "title": "練習中【2.5次元の誘惑ED】ニゴリリダンス踊ってみた #アキロゼ #ホロライブ #vtuber",
    "publishedAt": "2024-09-14T22:30:03Z"
  },
  {
    "videoId": "1DGBfYr392Y",
    "thumbnail": "https://i.ytimg.com/vi/1DGBfYr392Y/mqdefault.jpg",
    "title": "【Eggy Party】視聴者参加タイムあり！ロボタールと遊ぼ！！ #ホロeggy 【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-15T10:08:31Z"
  },
  {
    "videoId": "QVvs9Cggh_8",
    "thumbnail": "https://i.ytimg.com/vi/QVvs9Cggh_8/mqdefault.jpg",
    "title": "【VCR Minecraft β】マイクラだけどMMO !??  part1 #VCRマイクラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-15T21:52:08Z"
  },
  {
    "videoId": "yjvGiej1NQs",
    "thumbnail": "https://i.ytimg.com/vi/yjvGiej1NQs/mqdefault.jpg",
    "title": "【VCR Minecraft β】マイクラだけどMMO !??  part2 #VCRマイクラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-16T21:43:14Z"
  },
  {
    "videoId": "-E74H_GecA4",
    "thumbnail": "https://i.ytimg.com/vi/-E74H_GecA4/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.1【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-17T16:33:12Z"
  },
  {
    "videoId": "NedBZMJIJLU",
    "thumbnail": "https://i.ytimg.com/vi/NedBZMJIJLU/mqdefault.jpg",
    "title": "【VCR Minecraft β】マイクラだけどMMO !??  part3 #VCRマイクラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-17T21:17:05Z"
  },
  {
    "videoId": "WSr06P7LYK4",
    "thumbnail": "https://i.ytimg.com/vi/WSr06P7LYK4/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.2【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-18T16:25:57Z"
  },
  {
    "videoId": "q7_X3BRrCyY",
    "thumbnail": "https://i.ytimg.com/vi/q7_X3BRrCyY/mqdefault.jpg",
    "title": "【VCR Minecraft β】マイクラだけどMMO !??  part4 #VCRマイクラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-18T21:24:12Z"
  },
  {
    "videoId": "oWXqAOG6MNM",
    "thumbnail": "https://i.ytimg.com/vi/oWXqAOG6MNM/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.3【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-19T16:29:13Z"
  },
  {
    "videoId": "q4JGglWpNVA",
    "thumbnail": "https://i.ytimg.com/vi/q4JGglWpNVA/mqdefault.jpg",
    "title": "【VCR Minecraft β】マイクラだけどMMO !??  part5 #VCRマイクラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-19T21:17:41Z"
  },
  {
    "videoId": "3tmDP2ZID8E",
    "thumbnail": "https://i.ytimg.com/vi/3tmDP2ZID8E/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.4【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-20T16:28:46Z"
  },
  {
    "videoId": "PlKITzUO2tQ",
    "thumbnail": "https://i.ytimg.com/vi/PlKITzUO2tQ/mqdefault.jpg",
    "title": "【VCR Minecraft β】マイクラだけどMMO !??  part6 #VCRマイクラ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-20T21:58:01Z"
  },
  {
    "videoId": "PgMLCG0TIx0",
    "thumbnail": "https://i.ytimg.com/vi/PgMLCG0TIx0/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.5【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-21T16:26:52Z"
  },
  {
    "videoId": "6HdFWI2U2Xg",
    "thumbnail": "https://i.ytimg.com/vi/6HdFWI2U2Xg/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.6【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-22T16:32:30Z"
  },
  {
    "videoId": "jWzMXVs8GW0",
    "thumbnail": "https://i.ytimg.com/vi/jWzMXVs8GW0/mqdefault.jpg",
    "title": "【 #holoGTA 】ギャングのアンダーボスとして Day.7【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-23T17:11:26Z"
  },
  {
    "videoId": "Tfy8y1w1blY",
    "thumbnail": "https://i.ytimg.com/vi/Tfy8y1w1blY/mqdefault.jpg",
    "title": "【 #ホロAmongUs 】MAPが一番の強敵、きっとそうなんだ【アキロゼ視点/ホロライブ】",
    "publishedAt": "2024-09-25T15:14:04Z"
  },
  {
    "videoId": "ytvnghjyoPc",
    "thumbnail": "https://i.ytimg.com/vi/ytvnghjyoPc/mqdefault.jpg",
    "title": "【雑談/Free Talk】GTA＆マイクラとかの話する！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-09-28T16:26:13Z"
  },
  {
    "videoId": "a9j9ipvJskk",
    "thumbnail": "https://i.ytimg.com/vi/a9j9ipvJskk/mqdefault.jpg",
    "title": "【ASA￤アベレーション】拠点を建築したいんだ！続・全恐竜捕まえるまで終われまテン！Part 7【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-04T21:16:27Z"
  },
  {
    "videoId": "8e4-0EtQHgQ",
    "thumbnail": "https://i.ytimg.com/vi/8e4-0EtQHgQ/mqdefault.jpg",
    "title": "【Minecraft】最多デス賞はイヤだ！！  #チームともだちマイクラハードコア 【アキロゼ視点/ホロライブ】",
    "publishedAt": "2024-10-05T20:22:42Z"
  },
  {
    "videoId": "8NzV9x_pHY8",
    "thumbnail": "https://i.ytimg.com/vi/8NzV9x_pHY8/mqdefault.jpg",
    "title": "【ASA￤アベレーション】超危険地上テイム！？新恐竜ファソラ突撃！続・全恐竜捕まえるまで終われまテン！Part 8【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-06T17:03:05Z"
  },
  {
    "videoId": "ZSWKjLEvWXw",
    "thumbnail": "https://i.ytimg.com/vi/ZSWKjLEvWXw/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ドンさんと特訓いくぞ！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-08T17:58:07Z"
  },
  {
    "videoId": "OfYkYmiYAl0",
    "thumbnail": "https://i.ytimg.com/vi/OfYkYmiYAl0/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ひぐち村長と特訓いくぞ！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-09T18:14:37Z"
  },
  {
    "videoId": "P6TtS9udhjM",
    "thumbnail": "https://i.ytimg.com/vi/P6TtS9udhjM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ドンさんと特訓いくぞ！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-10T18:22:12Z"
  },
  {
    "videoId": "_DnfwrOfUWU",
    "thumbnail": "https://i.ytimg.com/vi/_DnfwrOfUWU/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ドンさんコーチングでガイル筋を鍛えろ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-11T14:12:30Z"
  },
  {
    "videoId": "IsF6Gi-5C70",
    "thumbnail": "https://i.ytimg.com/vi/IsF6Gi-5C70/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】獅白杯前日！村長＆ドンさんコーチングでガイル筋を鍛える！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-12T15:58:56Z"
  },
  {
    "videoId": "dtwm_x8lNuM",
    "thumbnail": "https://i.ytimg.com/vi/dtwm_x8lNuM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】獅白杯本番！ガイルを信じて！！ #獅白杯2nd 【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-13T11:08:26Z"
  },
  {
    "videoId": "Zydk-pmj7_s",
    "thumbnail": "https://i.ytimg.com/vi/Zydk-pmj7_s/mqdefault.jpg",
    "title": "【 #ホロ三ツ星ファーム 】ごはん革命です！実食レポあり！数量限定コラボセットあり！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-16T12:34:17Z"
  },
  {
    "videoId": "Kvy0xUUhAr0",
    "thumbnail": "https://i.ytimg.com/vi/Kvy0xUUhAr0/mqdefault.jpg",
    "title": "【麻雀一番街】たすけて渋ハル！脱・初心者麻雀編【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-17T16:11:20Z"
  },
  {
    "videoId": "ktuN7wfqJY4",
    "thumbnail": "https://i.ytimg.com/vi/ktuN7wfqJY4/mqdefault.jpg",
    "title": "【麻雀一番街】甘狼このみちゃんと麻雀練習するぞ！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-18T10:42:30Z"
  },
  {
    "videoId": "WPA6o4vHePQ",
    "thumbnail": "https://i.ytimg.com/vi/WPA6o4vHePQ/mqdefault.jpg",
    "title": "【VALORANT】阿鼻叫喚の #よちよちばぶらんと w/ yue / 柚原いづみ/ アルランディス /兎鞠まり / 水無世燐央【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-18T14:37:56Z"
  },
  {
    "videoId": "6kfN5mJJlPY",
    "thumbnail": "https://i.ytimg.com/vi/6kfN5mJJlPY/mqdefault.jpg",
    "title": "おはよ😉 #ホロライブ #アキロゼ #vtuber",
    "publishedAt": "2024-10-18T21:25:44Z"
  },
  {
    "videoId": "WDiF4h4SRuY",
    "thumbnail": "https://i.ytimg.com/vi/WDiF4h4SRuY/mqdefault.jpg",
    "title": "【麻雀一番街】第5回HP麻雀杯めざせ優勝！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-19T14:29:18Z"
  },
  {
    "videoId": "g8OwpvgbEyU",
    "thumbnail": "https://i.ytimg.com/vi/g8OwpvgbEyU/mqdefault.jpg",
    "title": "『 #唱 』🎃レッスンの合間にホロメンと踊ってみた🎃#shorts #アキロゼ #ホロライブ #vtuber",
    "publishedAt": "2024-10-19T23:13:16Z"
  },
  {
    "videoId": "ZDMPLLSrxoM",
    "thumbnail": "https://i.ytimg.com/vi/ZDMPLLSrxoM/mqdefault.jpg",
    "title": "【雑談/Free Talk】マイクラにスト6に案件にValoに麻雀に振り返りざつだーん！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-20T16:20:03Z"
  },
  {
    "videoId": "98iDMTkGMc0",
    "thumbnail": "https://i.ytimg.com/vi/98iDMTkGMc0/mqdefault.jpg",
    "title": "ぴょん🐰💕#ラビットホール #shorts #踊ってみた #ホロライブ #vtuber #アキロゼ",
    "publishedAt": "2024-10-20T22:00:05Z"
  },
  {
    "videoId": "7GiJZvoXMDc",
    "thumbnail": "https://i.ytimg.com/vi/7GiJZvoXMDc/mqdefault.jpg",
    "title": "撮影中もにょもにょしてるアキロゼが可愛すぎた　#shorts #ホロライブ",
    "publishedAt": "2024-10-21T22:00:06Z"
  },
  {
    "videoId": "77ANFA0XBEI",
    "thumbnail": "https://i.ytimg.com/vi/77ANFA0XBEI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6対戦＆交流会 w/どぐらさん、あくあさん、渋ハル、ねこたつ、こんちゃん【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-22T14:32:22Z"
  },
  {
    "videoId": "3Hx_k55oP2g",
    "thumbnail": "https://i.ytimg.com/vi/3Hx_k55oP2g/mqdefault.jpg",
    "title": "【ASA￤アベレーション】飛空艇欲しい話！続・全恐竜捕まえるまで終われまテン！Part 9【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-23T17:50:01Z"
  },
  {
    "videoId": "_djDWmxTX4I",
    "thumbnail": "https://i.ytimg.com/vi/_djDWmxTX4I/mqdefault.jpg",
    "title": "【ASA￤アベレーション】洞窟も行きたい！めざせ飛空艇！続・全恐竜捕まえるまで終われまテン！Part 10【アキロゼ/ホロライブ】",
    "publishedAt": "2024-10-24T17:16:26Z"
  },
  {
    "videoId": "WeHauL_P3Dk",
    "thumbnail": "https://i.ytimg.com/vi/WeHauL_P3Dk/mqdefault.jpg",
    "title": "【VALHEIM】#限界コントRUST 北欧神話の世界で海賊生活始めます！Part4【ホロライブ/アキロゼ】",
    "publishedAt": "2024-10-27T18:34:57Z"
  },
  {
    "videoId": "6goa61t-AVI",
    "thumbnail": "https://i.ytimg.com/vi/6goa61t-AVI/mqdefault.jpg",
    "title": "ぶぶぶーん🎶 #BANCHO ばんちょーとカッコよく踊ってみた！#shorts #ホロライブ #アキロゼ #vtuber",
    "publishedAt": "2024-10-27T22:00:04Z"
  },
  {
    "videoId": "Y1RPAvEDObw",
    "thumbnail": "https://i.ytimg.com/vi/Y1RPAvEDObw/mqdefault.jpg",
    "title": "ぐるぐる🌀#まいたけダンス らでんちゃんのキノコミーム踊ってみたⰔෆ #アキロゼ #ホロライブ #shorts",
    "publishedAt": "2024-10-28T22:00:20Z"
  },
  {
    "videoId": "VXq3LLAhTMM",
    "thumbnail": "https://i.ytimg.com/vi/VXq3LLAhTMM/mqdefault.jpg",
    "title": "ｼﾒｼﾒ(∩皿^∩)#しめじダンス らでんちゃんのキノコミーム好き #shorts #アキロゼ #ホロライブ #踊ってみた",
    "publishedAt": "2024-10-29T22:00:30Z"
  },
  {
    "videoId": "QsdDDkPI70s",
    "thumbnail": "https://i.ytimg.com/vi/QsdDDkPI70s/mqdefault.jpg",
    "title": "ねぇねぇ❣️はやくして❣️らでんちゃんの #しいたけダンス キノコミーム踊ってみた #shorts #ホロライブ #アキロゼ",
    "publishedAt": "2024-10-30T22:25:00Z"
  },
  {
    "videoId": "3YW0jlr71vM",
    "thumbnail": "https://i.ytimg.com/vi/3YW0jlr71vM/mqdefault.jpg",
    "title": "【凸待ち】RBJのこども電話相談室🎃【R.B.J】",
    "publishedAt": "2024-10-31T10:08:35Z"
  },
  {
    "videoId": "m9-wHVuJrv0",
    "thumbnail": "https://i.ytimg.com/vi/m9-wHVuJrv0/mqdefault.jpg",
    "title": "ﾊﾞﾝﾊﾞﾊﾞﾝ💥🔫 ルイ姉の #ひみつのおしごと カッコよく踊ってみた❣️#ホロライブ #shorts #アキロゼ",
    "publishedAt": "2024-10-31T22:00:36Z"
  },
  {
    "videoId": "bRhUr472X6U",
    "thumbnail": "https://i.ytimg.com/vi/bRhUr472X6U/mqdefault.jpg",
    "title": "【VRChat】久しぶりのVRChatで超ハッピー🎃 #JusticeHalloween 【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-01T06:12:39Z"
  },
  {
    "videoId": "1wQwCU-266I",
    "thumbnail": "https://i.ytimg.com/vi/1wQwCU-266I/mqdefault.jpg",
    "title": "オレ達UCHIDA1 ✌️#踊ってみた #ホロライブ #アキロゼ",
    "publishedAt": "2024-11-01T22:00:02Z"
  },
  {
    "videoId": "JmfqPEvAaS4",
    "thumbnail": "https://i.ytimg.com/vi/JmfqPEvAaS4/mqdefault.jpg",
    "title": "【モンハンワイルズ】オープンベータ 版やってみる！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-02T19:20:20Z"
  },
  {
    "videoId": "0KoQfe3oukc",
    "thumbnail": "https://i.ytimg.com/vi/0KoQfe3oukc/mqdefault.jpg",
    "title": "笑顔であっぷっぷ #モエチャッカファイア #shorts #ホロライブ #アキロゼ #踊ってみた #vtuber",
    "publishedAt": "2024-11-02T22:40:00Z"
  },
  {
    "videoId": "o1cOGGVm3q8",
    "thumbnail": "https://i.ytimg.com/vi/o1cOGGVm3q8/mqdefault.jpg",
    "title": "【Liar's Bar】視聴者参加きゃもん！！！！！！ 【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-03T10:15:45Z"
  },
  {
    "videoId": "E3oRvHtytng",
    "thumbnail": "https://i.ytimg.com/vi/E3oRvHtytng/mqdefault.jpg",
    "title": "【WINTICKET】ミッドナイト競輪でアキロゼと予想しよ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-03T13:48:14Z"
  },
  {
    "videoId": "mlpfRSxAR_Q",
    "thumbnail": "https://i.ytimg.com/vi/mlpfRSxAR_Q/mqdefault.jpg",
    "title": "Vtuberが『絶対アイドル辞めないで=𝑳‌𝑶‌𝑽‌𝑬』踊ってみた🎀 #shorts #ホロライブ #アキロゼ",
    "publishedAt": "2024-11-03T22:00:23Z"
  },
  {
    "videoId": "gdmUfPwz4xo",
    "thumbnail": "https://i.ytimg.com/vi/gdmUfPwz4xo/mqdefault.jpg",
    "title": "すきっちゅーの！気付いてよね(`･н･´) #shorts #アキロゼ #ホロライブ #honeyworks",
    "publishedAt": "2024-11-05T11:00:48Z"
  },
  {
    "videoId": "I6h9mskzaiA",
    "thumbnail": "https://i.ytimg.com/vi/I6h9mskzaiA/mqdefault.jpg",
    "title": "【麻雀一番街】たすけて渋ハル！脱・初心者麻雀編パート2【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-05T17:39:29Z"
  },
  {
    "videoId": "Od2NUNAuuTs",
    "thumbnail": "https://i.ytimg.com/vi/Od2NUNAuuTs/mqdefault.jpg",
    "title": "キルミーベイベー『ふたりのきもちのほんとのひみつ』踊ってみた🎀 #ホロライブ #アキロゼ #shorts #vtuber",
    "publishedAt": "2024-11-06T11:40:00Z"
  },
  {
    "videoId": "Lh23C_aW8CI",
    "thumbnail": "https://i.ytimg.com/vi/Lh23C_aW8CI/mqdefault.jpg",
    "title": "【ASA￤アベレーション】テイムラストスパートやっちゃうか！続・全恐竜捕まえるまで終われまテン！Part 11【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-06T17:26:30Z"
  },
  {
    "videoId": "HyVKzMWHyOY",
    "thumbnail": "https://i.ytimg.com/vi/HyVKzMWHyOY/mqdefault.jpg",
    "title": "【オフコラボ】#アップルソーダ  で女子会！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-07T13:44:58Z"
  },
  {
    "videoId": "1oXpA962PbY",
    "thumbnail": "https://i.ytimg.com/vi/1oXpA962PbY/mqdefault.jpg",
    "title": "ルカルカ★ナイトフィーバー💃💕 #vtuber が #踊ってみた #shorts",
    "publishedAt": "2024-11-07T14:55:00Z"
  },
  {
    "videoId": "AdttCaVSxcI",
    "thumbnail": "https://i.ytimg.com/vi/AdttCaVSxcI/mqdefault.jpg",
    "title": "船長の『#パイパイ仮面 』ガチ恋距離で踊ってみた #shorts #ホロライブ #アキロゼ",
    "publishedAt": "2024-11-07T22:00:07Z"
  },
  {
    "videoId": "hQECS3wrwno",
    "thumbnail": "https://i.ytimg.com/vi/hQECS3wrwno/mqdefault.jpg",
    "title": "【 #1期生お披露目リレー配信 】かわいいやつできたGYAO!【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-09T11:05:09Z"
  },
  {
    "videoId": "87GMw2q04XM",
    "thumbnail": "https://i.ytimg.com/vi/87GMw2q04XM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6対戦会！w/チームともだち【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-11T15:01:27Z"
  },
  {
    "videoId": "FpM9Rf40NtY",
    "thumbnail": "https://i.ytimg.com/vi/FpM9Rf40NtY/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6対戦会！w/ししろん、ドンさん、ぷげらさん【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-12T18:03:38Z"
  },
  {
    "videoId": "10fmQ9eVsyo",
    "thumbnail": "https://i.ytimg.com/vi/10fmQ9eVsyo/mqdefault.jpg",
    "title": "可愛くラミィちゃんの『 #わたしを甘やかすなら 』踊ってみた💕 #shorts #ホロライブ #アキロゼ",
    "publishedAt": "2024-11-13T15:25:00Z"
  },
  {
    "videoId": "4uNcCG7bJYc",
    "thumbnail": "https://i.ytimg.com/vi/4uNcCG7bJYc/mqdefault.jpg",
    "title": "ラミィちゃんの『ハツコイ♡パティシエール』可愛く踊ってみた！#shorts #ホロライブ #アキロゼ",
    "publishedAt": "2024-11-15T09:00:09Z"
  },
  {
    "videoId": "gG3IeaDBav0",
    "thumbnail": "https://i.ytimg.com/vi/gG3IeaDBav0/mqdefault.jpg",
    "title": "【バイオハザード6│バイオ初見】#へっぽこ3人組 で協力バイオ！バイオから逃げるな/w 白雪レイド,エビオ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-15T17:49:23Z"
  },
  {
    "videoId": "41My77A3LKU",
    "thumbnail": "https://i.ytimg.com/vi/41My77A3LKU/mqdefault.jpg",
    "title": "【GIGABYTE/インテル】ガチ構成のつよつよPCでARKするよ～！ASA￤The Center【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-16T11:21:07Z"
  },
  {
    "videoId": "Lg1b3h-EaFM",
    "thumbnail": "https://i.ytimg.com/vi/Lg1b3h-EaFM/mqdefault.jpg",
    "title": "【ミラー配信】ガイル村で全力応援するぞ！LEGENDUS STREET FIGHTER 6 師弟杯 ~2024冬 後楽園の陣~ 本戦【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-18T15:40:59Z"
  },
  {
    "videoId": "U0_m_c_y0bk",
    "thumbnail": "https://i.ytimg.com/vi/U0_m_c_y0bk/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】わいわいスト6対戦会！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-18T18:14:47Z"
  },
  {
    "videoId": "nWZfNl6O-kQ",
    "thumbnail": "https://i.ytimg.com/vi/nWZfNl6O-kQ/mqdefault.jpg",
    "title": "【雑談/Free Talk】深夜にまったり話そ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-19T17:28:39Z"
  },
  {
    "videoId": "heLzS8RA01g",
    "thumbnail": "https://i.ytimg.com/vi/heLzS8RA01g/mqdefault.jpg",
    "title": "【APEX】V最顔合わせまとめ│FPSやってきてないガチばぶ（初心者）の現場はコチラ【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-11-20T12:30:40Z"
  },
  {
    "videoId": "EIfXornDH_s",
    "thumbnail": "https://i.ytimg.com/vi/EIfXornDH_s/mqdefault.jpg",
    "title": "【PAYDAY 2】#ホロ管理職 それゆけレッツ強奪！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-20T15:18:47Z"
  },
  {
    "videoId": "6yFn4pIiaz8",
    "thumbnail": "https://i.ytimg.com/vi/6yFn4pIiaz8/mqdefault.jpg",
    "title": "【APEX】でっけぇ背中にワンマガ撃つアキロゼ",
    "publishedAt": "2024-11-21T09:04:01Z"
  },
  {
    "videoId": "5SaYUHUmg74",
    "thumbnail": "https://i.ytimg.com/vi/5SaYUHUmg74/mqdefault.jpg",
    "title": "【APEX】V最コーチング開始編│超強力コーチングで真実がバレる！？【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-11-21T09:08:35Z"
  },
  {
    "videoId": "ynd_omjmqyA",
    "thumbnail": "https://i.ytimg.com/vi/ynd_omjmqyA/mqdefault.jpg",
    "title": "【APEX】どれがホンモノか分かる？？？？",
    "publishedAt": "2024-11-22T09:01:13Z"
  },
  {
    "videoId": "CUjpSURBsdQ",
    "thumbnail": "https://i.ytimg.com/vi/CUjpSURBsdQ/mqdefault.jpg",
    "title": "【chained together #ホロ大並走鎖バトル】フブキ＆アキロゼは #俺達白亜紀【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-22T13:53:59Z"
  },
  {
    "videoId": "U_yamR9SM2E",
    "thumbnail": "https://i.ytimg.com/vi/U_yamR9SM2E/mqdefault.jpg",
    "title": "【APEX】V最スクリム│感度3000倍！？マウスは置物説【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-11-24T09:30:11Z"
  },
  {
    "videoId": "TOzwzA5ijSA",
    "thumbnail": "https://i.ytimg.com/vi/TOzwzA5ijSA/mqdefault.jpg",
    "title": "【DeadbyDaylight】#にじホロすぽ で2vs8鬼ごっこ【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-25T13:34:57Z"
  },
  {
    "videoId": "seZmjv894sM",
    "thumbnail": "https://i.ytimg.com/vi/seZmjv894sM/mqdefault.jpg",
    "title": "【歌＆雑談/Song ＆Free Talk】チルチルチル【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-26T17:28:06Z"
  },
  {
    "videoId": "NT5ACjscVbw",
    "thumbnail": "https://i.ytimg.com/vi/NT5ACjscVbw/mqdefault.jpg",
    "title": "【バイオハザード6│バイオ初見】2人で協力バイオ！バイオから逃げるな/w 白雪レイド【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-28T15:14:01Z"
  },
  {
    "videoId": "PcAEEpPZ95Y",
    "thumbnail": "https://i.ytimg.com/vi/PcAEEpPZ95Y/mqdefault.jpg",
    "title": "【ASA￤アベレーション】残り3匹！洞窟レッツゴー？！続・全恐竜捕まえるまで終われまテン！Part 12【アキロゼ/ホロライブ】",
    "publishedAt": "2024-11-29T18:04:29Z"
  },
  {
    "videoId": "AM_RS6Nv5pM",
    "thumbnail": "https://i.ytimg.com/vi/AM_RS6Nv5pM/mqdefault.jpg",
    "title": "【holoGTA】1日目まとめ│ギャングのサポートお姉さんになる【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-11-30T12:00:06Z"
  },
  {
    "videoId": "mpbWH-uwFZE",
    "thumbnail": "https://i.ytimg.com/vi/mpbWH-uwFZE/mqdefault.jpg",
    "title": "【 #ホロGTA 】新米ギャングの暴れっぷりに笑いが止まらないアキロゼ",
    "publishedAt": "2024-11-30T13:00:53Z"
  },
  {
    "videoId": "NRqtjpQRBMc",
    "thumbnail": "https://i.ytimg.com/vi/NRqtjpQRBMc/mqdefault.jpg",
    "title": "【 #ホロGTA 】パトカー大量！事故りすぎて笑いが止まらないアキロゼ",
    "publishedAt": "2024-12-01T11:50:00Z"
  },
  {
    "videoId": "ruUA6zjaelk",
    "thumbnail": "https://i.ytimg.com/vi/ruUA6zjaelk/mqdefault.jpg",
    "title": "【holoGTA】2日目まとめ│ギャング「ミリモン」爆誕☆【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-12-01T12:30:06Z"
  },
  {
    "videoId": "V1WFAmPorp8",
    "thumbnail": "https://i.ytimg.com/vi/V1WFAmPorp8/mqdefault.jpg",
    "title": "【 #ホロGTA 】とんでもない性癖暴露をするアキロゼ",
    "publishedAt": "2024-12-01T13:00:38Z"
  },
  {
    "videoId": "urxyplQnYyU",
    "thumbnail": "https://i.ytimg.com/vi/urxyplQnYyU/mqdefault.jpg",
    "title": "【VCR GTA 3】１日目！近未来都市ロスサントスへいざ出発！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-02T21:53:31Z"
  },
  {
    "videoId": "yFTnVm9PwFU",
    "thumbnail": "https://i.ytimg.com/vi/yFTnVm9PwFU/mqdefault.jpg",
    "title": "【VCR GTA 3】２日目！新米警察として街を守れ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-03T21:42:30Z"
  },
  {
    "videoId": "qX66R1FkQgQ",
    "thumbnail": "https://i.ytimg.com/vi/qX66R1FkQgQ/mqdefault.jpg",
    "title": "【VCR GTA 3】３日目！今日も出勤！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-04T22:05:11Z"
  },
  {
    "videoId": "8OhFv-nYuhw",
    "thumbnail": "https://i.ytimg.com/vi/8OhFv-nYuhw/mqdefault.jpg",
    "title": "【VCR GTA 3】１日目まとめ│警察になる！【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-12-05T09:30:07Z"
  },
  {
    "videoId": "x7SO1EJHmjs",
    "thumbnail": "https://i.ytimg.com/vi/x7SO1EJHmjs/mqdefault.jpg",
    "title": "【VCR GTA 3】4日目！エンジョイ＆ガンガンゴー！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-05T22:03:31Z"
  },
  {
    "videoId": "Rqc9A0Z2gRo",
    "thumbnail": "https://i.ytimg.com/vi/Rqc9A0Z2gRo/mqdefault.jpg",
    "title": "【VCR GTA 3】5日目！もう折り返し？？？？！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-06T21:51:13Z"
  },
  {
    "videoId": "0nPZQ6fvciw",
    "thumbnail": "https://i.ytimg.com/vi/0nPZQ6fvciw/mqdefault.jpg",
    "title": "【VCR GTA 3】6日目！街の平和を守る！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-07T21:49:17Z"
  },
  {
    "videoId": "Vt2oL8y5u24",
    "thumbnail": "https://i.ytimg.com/vi/Vt2oL8y5u24/mqdefault.jpg",
    "title": "【VCR GTA 3】7日目！しゅっきん！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-08T13:53:45Z"
  },
  {
    "videoId": "vR9WyCrgbFM",
    "thumbnail": "https://i.ytimg.com/vi/vR9WyCrgbFM/mqdefault.jpg",
    "title": "【VCR GTA 3】7日目-2！しゅっきん！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-08T21:31:59Z"
  },
  {
    "videoId": "OFhwA-aWRsg",
    "thumbnail": "https://i.ytimg.com/vi/OFhwA-aWRsg/mqdefault.jpg",
    "title": "【VCR GTA 3】8日目警察24時！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-09T22:43:52Z"
  },
  {
    "videoId": "yypXKY0KpNg",
    "thumbnail": "https://i.ytimg.com/vi/yypXKY0KpNg/mqdefault.jpg",
    "title": "【VCR GTA 3】9日目！レッツエンジョイ警察！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-10T21:45:55Z"
  },
  {
    "videoId": "8lsTpCukDLg",
    "thumbnail": "https://i.ytimg.com/vi/8lsTpCukDLg/mqdefault.jpg",
    "title": "【VCR GTA 3】2日目まとめ│やはり大爆発！ヘリからは逃げられない【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-12-11T11:30:06Z"
  },
  {
    "videoId": "4S860iv5wDI",
    "thumbnail": "https://i.ytimg.com/vi/4S860iv5wDI/mqdefault.jpg",
    "title": "【VCR GTA 3】10日目！レッツエンジョイ警察！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-11T21:48:08Z"
  },
  {
    "videoId": "bTjWDabqDk8",
    "thumbnail": "https://i.ytimg.com/vi/bTjWDabqDk8/mqdefault.jpg",
    "title": "【VCR GTA 3】最終日！レッツエンジョイ警察！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-12T18:22:17Z"
  },
  {
    "videoId": "XjPGrupm60Q",
    "thumbnail": "https://i.ytimg.com/vi/XjPGrupm60Q/mqdefault.jpg",
    "title": "【 #VCRGTA3 】爆笑！？オススメクリップ鑑賞会！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-14T15:36:28Z"
  },
  {
    "videoId": "zP5qhXp1NZc",
    "thumbnail": "https://i.ytimg.com/vi/zP5qhXp1NZc/mqdefault.jpg",
    "title": "【Riot Games ONE 2024 Offline Day x Watch Party】ミラー配信あり！LOLみるよ～～！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-15T05:31:18Z"
  },
  {
    "videoId": "oe7ss511wyc",
    "thumbnail": "https://i.ytimg.com/vi/oe7ss511wyc/mqdefault.jpg",
    "title": "【Philips TAE7009】ロボタールで音を楽しむASA！￤アベレーション【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-18T11:11:03Z"
  },
  {
    "videoId": "kU-uQapqmmg",
    "thumbnail": "https://i.ytimg.com/vi/kU-uQapqmmg/mqdefault.jpg",
    "title": "【APEX】チームかまぼこ！？第8回 Rakuten esports cup！【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-19T15:17:06Z"
  },
  {
    "videoId": "h2O_UsC0hK0",
    "thumbnail": "https://i.ytimg.com/vi/h2O_UsC0hK0/mqdefault.jpg",
    "title": "【Minecraft】🎁はもらったー！！ #ホロライブサンタバトル 【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-20T13:23:44Z"
  },
  {
    "videoId": "D8J9nyNsy7Q",
    "thumbnail": "https://i.ytimg.com/vi/D8J9nyNsy7Q/mqdefault.jpg",
    "title": "【VCR GTA 3】4日目まとめ│市民安全課アキロゼ出勤！ぎゃうカフェの押し売りやばすぎた【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-12-23T09:00:08Z"
  },
  {
    "videoId": "Frbpsu5VdyA",
    "thumbnail": "https://i.ytimg.com/vi/Frbpsu5VdyA/mqdefault.jpg",
    "title": "【バイオハザード6│バイオ初見】2人で協力バイオ！バイオから逃げるな Part3/w 白雪レイド【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-23T14:19:09Z"
  },
  {
    "videoId": "esUQIfvgxtk",
    "thumbnail": "https://i.ytimg.com/vi/esUQIfvgxtk/mqdefault.jpg",
    "title": "【VCR GTA 3】3日目まとめ│新人警察の日常ダイジェスト【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-12-24T09:00:06Z"
  },
  {
    "videoId": "wgP2CD7JmOY",
    "thumbnail": "https://i.ytimg.com/vi/wgP2CD7JmOY/mqdefault.jpg",
    "title": "【壺/Getting Over It】てっぺんに星を飾りたい2024【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-12-24T15:19:29Z"
  },
  {
    "videoId": "Y2vtr70_xRc",
    "thumbnail": "https://i.ytimg.com/vi/Y2vtr70_xRc/mqdefault.jpg",
    "title": "【ASA￤アベレーション】最終回！！続・全恐竜捕まえるまで終われまテン！Part 13【アキロゼ/ホロライブ】",
    "publishedAt": "2024-12-26T18:55:42Z"
  },
  {
    "videoId": "kG4jjuNkqEY",
    "thumbnail": "https://i.ytimg.com/vi/kG4jjuNkqEY/mqdefault.jpg",
    "title": "【VCR GTA 3】5日目まとめ│パトロール珍道中【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2024-12-28T09:00:06Z"
  },
  {
    "videoId": "KOWWMwmBShs",
    "thumbnail": "https://i.ytimg.com/vi/KOWWMwmBShs/mqdefault.jpg",
    "title": "【雑談/FreeTalk】2024納め！よいお年ってなんだろうね【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2024-12-31T10:14:23Z"
  },
  {
    "videoId": "3LCksp7pnkg",
    "thumbnail": "https://i.ytimg.com/vi/3LCksp7pnkg/mqdefault.jpg",
    "title": "【雑談/FreeTalk】2025年あけおめ！ことよろ！今年の目標は【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-03T15:53:31Z"
  },
  {
    "videoId": "Bcl-0ZwKq7E",
    "thumbnail": "https://i.ytimg.com/vi/Bcl-0ZwKq7E/mqdefault.jpg",
    "title": "【1/8192】新春運試し！！開運できないやついる？ｗ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-04T14:40:14Z"
  },
  {
    "videoId": "CqOXeIFYXBs",
    "thumbnail": "https://i.ytimg.com/vi/CqOXeIFYXBs/mqdefault.jpg",
    "title": "【五目並べ】深夜のスーパーゲリラ！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-06T17:18:12Z"
  },
  {
    "videoId": "TPLahU4TIMw",
    "thumbnail": "https://i.ytimg.com/vi/TPLahU4TIMw/mqdefault.jpg",
    "title": "【マリオカート8DX】参加型：すうちゃんとゲーム祭りの練習する！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-10T13:15:50Z"
  },
  {
    "videoId": "sT4OOo-SuXo",
    "thumbnail": "https://i.ytimg.com/vi/sT4OOo-SuXo/mqdefault.jpg",
    "title": "【Minecraft】誰か死んだら最初からやり直しエンドラ討伐リベンジ！ #ネオポリスマイクラハードコア 【アキロゼ視点/ホロライブ】",
    "publishedAt": "2025-01-12T22:00:19Z"
  },
  {
    "videoId": "HwIiAGyLzq4",
    "thumbnail": "https://i.ytimg.com/vi/HwIiAGyLzq4/mqdefault.jpg",
    "title": "【 #ホロ新春ゲーム祭2025 】鎖～マリカ～FallGuysれっつえんじょい！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-13T14:38:15Z"
  },
  {
    "videoId": "tKGdlbqaGcA",
    "thumbnail": "https://i.ytimg.com/vi/tKGdlbqaGcA/mqdefault.jpg",
    "title": "【モンハンワールド】#ドズル社狩猟祭 おおはらMENチーム始動！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-17T19:03:58Z"
  },
  {
    "videoId": "JGNbX9PWh88",
    "thumbnail": "https://i.ytimg.com/vi/JGNbX9PWh88/mqdefault.jpg",
    "title": "【モンハンワールド】上位へGO！ おおはらMENチーム #ドズル社狩猟祭 Part2【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-18T19:26:19Z"
  },
  {
    "videoId": "iLrdKKWflyU",
    "thumbnail": "https://i.ytimg.com/vi/iLrdKKWflyU/mqdefault.jpg",
    "title": "【モンハンワールド】ゼノジーヴァ！ おおはらMENチーム #ドズル社狩猟祭 Part3【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-19T18:44:16Z"
  },
  {
    "videoId": "eQRQ_JVSa7g",
    "thumbnail": "https://i.ytimg.com/vi/eQRQ_JVSa7g/mqdefault.jpg",
    "title": "【モンハンワールド】武器と防具と揃えなきゃ！ おおはらMENチーム腕相撲 #ドズル社狩猟祭 Part4【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-20T18:59:38Z"
  },
  {
    "videoId": "ETbWoiB57og",
    "thumbnail": "https://i.ytimg.com/vi/ETbWoiB57og/mqdefault.jpg",
    "title": "【モンハンワールド】転職活動！ おおはらMENチーム腕相撲 #ドズル社狩猟祭 Part5【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-21T19:14:46Z"
  },
  {
    "videoId": "j-xMoNsylRI",
    "thumbnail": "https://i.ytimg.com/vi/j-xMoNsylRI/mqdefault.jpg",
    "title": "【モンハンワールド】笛ピスト道へ！ おおはらMENチーム腕相撲 #ドズル社狩猟祭 Part6【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-22T19:55:52Z"
  },
  {
    "videoId": "qY2AZUh3jyE",
    "thumbnail": "https://i.ytimg.com/vi/qY2AZUh3jyE/mqdefault.jpg",
    "title": "【モンハンワールド】HR50そして練習！ おおはらMENチーム腕相撲 #ドズル社狩猟祭 Part7【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-23T19:17:48Z"
  },
  {
    "videoId": "ew8g-IEEm7E",
    "thumbnail": "https://i.ytimg.com/vi/ew8g-IEEm7E/mqdefault.jpg",
    "title": "【モンハンワールド】最後の練習日！ おおはらMENチーム腕相撲 #ドズル社狩猟祭 Part8【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-24T19:10:06Z"
  },
  {
    "videoId": "XLQPaQvMUeE",
    "thumbnail": "https://i.ytimg.com/vi/XLQPaQvMUeE/mqdefault.jpg",
    "title": "【モンハンワールド】いよいよ大会本番だ！ おおはらMEN #チーム腕相撲WIN #ドズル社狩猟祭 Part9【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-01-25T20:58:16Z"
  },
  {
    "videoId": "EOLW5X2wfzc",
    "thumbnail": "https://i.ytimg.com/vi/EOLW5X2wfzc/mqdefault.jpg",
    "title": "【APEX】アーニャ、こんちゃんとフルパ！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-01-26T16:50:53Z"
  },
  {
    "videoId": "QpQ4BDcf3Ac",
    "thumbnail": "https://i.ytimg.com/vi/QpQ4BDcf3Ac/mqdefault.jpg",
    "title": "【雑談/FreeTalk】今年は外にめちゃくちゃ出てる【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-01T16:27:27Z"
  },
  {
    "videoId": "zmKiKTJm-Yc",
    "thumbnail": "https://i.ytimg.com/vi/zmKiKTJm-Yc/mqdefault.jpg",
    "title": "【リアル凸待ち！】節分だ！太巻きだ！オフコラボだ！ルイ、わため、フレア、らでん、ちょこ先、青くゆ【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-03T23:53:44Z"
  },
  {
    "videoId": "BuQnVnw84jI",
    "thumbnail": "https://i.ytimg.com/vi/BuQnVnw84jI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ガイル村で舞やってみる！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-05T15:29:01Z"
  },
  {
    "videoId": "Mci4dmZ2QBM",
    "thumbnail": "https://i.ytimg.com/vi/Mci4dmZ2QBM/mqdefault.jpg",
    "title": "【忙しい現代人の味方！】完全栄養食Huel（ヒュエル）アレンジレシピ試してみる！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-08T12:12:47Z"
  },
  {
    "videoId": "zX54jDsth3M",
    "thumbnail": "https://i.ytimg.com/vi/zX54jDsth3M/mqdefault.jpg",
    "title": "【APEX】dtto.ちゃん、こはくちゃんとフルパ！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-09T14:22:09Z"
  },
  {
    "videoId": "H0Ganrq84C8",
    "thumbnail": "https://i.ytimg.com/vi/H0Ganrq84C8/mqdefault.jpg",
    "title": "【APEX】試練を超えたら告知チャンス！フルパエペw/渋ハル、レイドくん【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-10T13:20:52Z"
  },
  {
    "videoId": "vZdIg2OReCw",
    "thumbnail": "https://i.ytimg.com/vi/vZdIg2OReCw/mqdefault.jpg",
    "title": "【雑談/FreeTalk】誕生日のライブ告知したぞー！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-10T16:35:41Z"
  },
  {
    "videoId": "w1xBvp9w8Gs",
    "thumbnail": "https://i.ytimg.com/vi/w1xBvp9w8Gs/mqdefault.jpg",
    "title": "【Minecraft】新ホロ鯖についに上陸！冒険＆やりたいこと探す！ 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-11T18:34:36Z"
  },
  {
    "videoId": "QIlmdyssX4s",
    "thumbnail": "https://i.ytimg.com/vi/QIlmdyssX4s/mqdefault.jpg",
    "title": "【MHW:IB/モンハンワールド 】ついにミラボレアス討伐戦！！  #ネオポリスモンハン部 8日目w/エビオ、こはく、ととみっくす【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-12T23:43:45Z"
  },
  {
    "videoId": "JDmU0hcOdgc",
    "thumbnail": "https://i.ytimg.com/vi/JDmU0hcOdgc/mqdefault.jpg",
    "title": "【MHW:IB/モンハンワールド 】ついにミラボレアス討伐戦！！  #ネオポリスモンハン部 8-2日目w/エビオ、こはく、ととみっくす【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-13T03:21:58Z"
  },
  {
    "videoId": "rs7iePCuLIQ",
    "thumbnail": "https://i.ytimg.com/vi/rs7iePCuLIQ/mqdefault.jpg",
    "title": "キスの４倍チョコ食べると幸福感じるって知ってた？ #バレンタインキッス🍫💋 #shorts  #踊ってみた 【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-14T09:03:12Z"
  },
  {
    "videoId": "91TG5UWhZLU",
    "thumbnail": "https://i.ytimg.com/vi/91TG5UWhZLU/mqdefault.jpg",
    "title": "【APEX】あれるチームでdtto.cupいくぞーーーー！！w/あれるさん、巫神こんちゃん【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-15T13:22:09Z"
  },
  {
    "videoId": "-oZ6HVULmKA",
    "thumbnail": "https://i.ytimg.com/vi/-oZ6HVULmKA/mqdefault.jpg",
    "title": "【#アキロゼ生誕祭2025 】Your True Colorsティザームービー【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-16T02:09:25Z"
  },
  {
    "videoId": "Mnio_U_4uCA",
    "thumbnail": "https://i.ytimg.com/vi/Mnio_U_4uCA/mqdefault.jpg",
    "title": "【モンハンワイルズ】フルパでひと狩りいこーぜ！w/フレア、ぺこちゃん、わためぇ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-16T14:30:49Z"
  },
  {
    "videoId": "p9MLt51AVzE",
    "thumbnail": "https://i.ytimg.com/vi/p9MLt51AVzE/mqdefault.jpg",
    "title": "誕生日カウントダウンして一緒に迎えたい！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-16T15:40:09Z"
  },
  {
    "videoId": "etiR9Qnqlmc",
    "thumbnail": "https://i.ytimg.com/vi/etiR9Qnqlmc/mqdefault.jpg",
    "title": "【 3DLIVE 】#アキロゼ生誕祭2025 ーYour True Colorsー【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-17T13:22:54Z"
  },
  {
    "videoId": "de3v2n6hPHk",
    "thumbnail": "https://i.ytimg.com/vi/de3v2n6hPHk/mqdefault.jpg",
    "title": "『異薔薇-IBARA-』獅子志司【アキ・ローゼンタール/ホロライブ】",
    "publishedAt": "2025-02-18T11:01:34Z"
  },
  {
    "videoId": "1a4NQUVFAnM",
    "thumbnail": "https://i.ytimg.com/vi/1a4NQUVFAnM/mqdefault.jpg",
    "title": "【 振り返り雑談！ 】生誕ライブありがとう！いっしょに見たり話したり！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-18T14:46:25Z"
  },
  {
    "videoId": "muoFTCtdxN8",
    "thumbnail": "https://i.ytimg.com/vi/muoFTCtdxN8/mqdefault.jpg",
    "title": "【MHW:IB/モンハンワールド 】MR83→MR100いけんのかって！？たすけてください【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-19T04:09:52Z"
  },
  {
    "videoId": "-PqUwzol03Y",
    "thumbnail": "https://i.ytimg.com/vi/-PqUwzol03Y/mqdefault.jpg",
    "title": "【MHW:IB/モンハンワールド 】再戦の時。ミラボレアス討伐リベンジ！！  #ネオポリスモンハン部 w/エビオ、こはく、ととみっくす【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-19T15:15:05Z"
  },
  {
    "videoId": "TvxTfKCrwAk",
    "thumbnail": "https://i.ytimg.com/vi/TvxTfKCrwAk/mqdefault.jpg",
    "title": "【雑談/FreeTalk】生誕3Dライブおつかれさま！w/渋ハル、レイドくん【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-20T13:27:46Z"
  },
  {
    "videoId": "D4vKqU9HeMs",
    "thumbnail": "https://i.ytimg.com/vi/D4vKqU9HeMs/mqdefault.jpg",
    "title": "【ASA￤Astraeos】最新MAPアストレオス！緊急スト鯖OPENされたのでいってみる！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-20T22:25:48Z"
  },
  {
    "videoId": "nRXSvkCchCI",
    "thumbnail": "https://i.ytimg.com/vi/nRXSvkCchCI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】わいわいスト6対戦会！/w.渋ハル、こんちゃん、テンちゃん、はなびちゃん【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-21T13:50:54Z"
  },
  {
    "videoId": "hFcitUvWF80",
    "thumbnail": "https://i.ytimg.com/vi/hFcitUvWF80/mqdefault.jpg",
    "title": "【 Farming Simulator 】フブミオ農場の新入りです！！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-21T18:02:34Z"
  },
  {
    "videoId": "E3qulgvDWX4",
    "thumbnail": "https://i.ytimg.com/vi/E3qulgvDWX4/mqdefault.jpg",
    "title": "【ASA￤Astraeos】最新MAPアストレオス！緊急スト鯖OPENされたのでいってみる！Part2【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-23T02:10:42Z"
  },
  {
    "videoId": "nYjJyXUN3Mw",
    "thumbnail": "https://i.ytimg.com/vi/nYjJyXUN3Mw/mqdefault.jpg",
    "title": "【ASA￤Astraeos】最新MAPアストレオス！緊急スト鯖OPENされたのでいってみる！Part3【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-24T01:58:08Z"
  },
  {
    "videoId": "x5dTStj5FTU",
    "thumbnail": "https://i.ytimg.com/vi/x5dTStj5FTU/mqdefault.jpg",
    "title": "【ASA￤Astraeos】最新MAPアストレオス！緊急スト鯖OPENされたのでいってみる！Part4【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-25T02:42:12Z"
  },
  {
    "videoId": "Frpgmz5SPd0",
    "thumbnail": "https://i.ytimg.com/vi/Frpgmz5SPd0/mqdefault.jpg",
    "title": "【ASA￤Astraeos】最新MAPアストレオス！緊急スト鯖OPENされたのでいってみる！Part5【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-26T02:22:02Z"
  },
  {
    "videoId": "KLUbbkHEeMA",
    "thumbnail": "https://i.ytimg.com/vi/KLUbbkHEeMA/mqdefault.jpg",
    "title": "【ASA￤Astraeos】ファイナル？！最新MAPアストレオス！緊急スト鯖OPENされたのでいってみる！Part6【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-26T22:08:04Z"
  },
  {
    "videoId": "7juJzyvfI2Y",
    "thumbnail": "https://i.ytimg.com/vi/7juJzyvfI2Y/mqdefault.jpg",
    "title": "【Fast Food Simulator】バーガーショップはじめました！w/あれるさん、巫神こんちゃん【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-02-27T09:05:31Z"
  },
  {
    "videoId": "UQGnyyOr_D0",
    "thumbnail": "https://i.ytimg.com/vi/UQGnyyOr_D0/mqdefault.jpg",
    "title": "【VALHEIM】#限界コントRUST 北欧神話の世界で海賊生活始めます！Part5【ホロライブ/アキロゼ】",
    "publishedAt": "2025-02-27T15:50:40Z"
  },
  {
    "videoId": "O3Wf6TM3Wl4",
    "thumbnail": "https://i.ytimg.com/vi/O3Wf6TM3Wl4/mqdefault.jpg",
    "title": "【モンハンワイルズ】モンハンスタートダッシュいくぞ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-28T17:24:58Z"
  },
  {
    "videoId": "b6SwA3KPqzo",
    "thumbnail": "https://i.ytimg.com/vi/b6SwA3KPqzo/mqdefault.jpg",
    "title": "【モンハンワイルズ】モンハンスタートダッシュいくぞ！！Part2【アキロゼ/ホロライブ】",
    "publishedAt": "2025-02-28T21:24:13Z"
  },
  {
    "videoId": "tqMShJpBi3s",
    "thumbnail": "https://i.ytimg.com/vi/tqMShJpBi3s/mqdefault.jpg",
    "title": "【モンハンワイルズ】上位の世界にいくぞ！！！Part3【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-02T00:24:38Z"
  },
  {
    "videoId": "y7R-iWniar4",
    "thumbnail": "https://i.ytimg.com/vi/y7R-iWniar4/mqdefault.jpg",
    "title": "『 #いばらダンス 』踊ってみてね！ #異薔薇 #アキロゼ  #vtuber",
    "publishedAt": "2025-03-02T11:26:04Z"
  },
  {
    "videoId": "0AUlCHTlfGI",
    "thumbnail": "https://i.ytimg.com/vi/0AUlCHTlfGI/mqdefault.jpg",
    "title": "【モンハンワイルズ】上位ラストスパート！どこまでいけんのかって！Part4【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-03T00:18:46Z"
  },
  {
    "videoId": "F2jq0A0sWl4",
    "thumbnail": "https://i.ytimg.com/vi/F2jq0A0sWl4/mqdefault.jpg",
    "title": "【モンハンワイルズ】歴戦の世界へ！HRあげたり装備作ったりワチャワチャなのかソロなのかPart5【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-03T20:26:44Z"
  },
  {
    "videoId": "b9iixAxEYIA",
    "thumbnail": "https://i.ytimg.com/vi/b9iixAxEYIA/mqdefault.jpg",
    "title": "【モンハンワイルズ】爆キャリーしてくれるらしいです/w.エビオ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-05T14:37:11Z"
  },
  {
    "videoId": "sGvIIYAN-CM",
    "thumbnail": "https://i.ytimg.com/vi/sGvIIYAN-CM/mqdefault.jpg",
    "title": "【モンハンワイルズ】めっちゃチルい配信☆明日からExpo＆Fes【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-07T16:12:15Z"
  },
  {
    "videoId": "G14DjhFYZJg",
    "thumbnail": "https://i.ytimg.com/vi/G14DjhFYZJg/mqdefault.jpg",
    "title": "【雑談/free Talk】眠れない子おいで～からの明日いってくるよ！【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-03-08T14:16:10Z"
  },
  {
    "videoId": "ya2IIAUEuPs",
    "thumbnail": "https://i.ytimg.com/vi/ya2IIAUEuPs/mqdefault.jpg",
    "title": "【hololive 6th fes. ＆ EXPO打ち上げ会場】打ち上げしよー！#hololivefesEXPO25_DAY2【ホロライブ/アキ・ローゼンタール】",
    "publishedAt": "2025-03-09T17:56:32Z"
  },
  {
    "videoId": "cK7NcYwFfpE",
    "thumbnail": "https://i.ytimg.com/vi/cK7NcYwFfpE/mqdefault.jpg",
    "title": "【モンハンワイルズ】ここを打ち上げとする #俺達白亜紀 生粋のハンター【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-09T20:47:15Z"
  },
  {
    "videoId": "8b5pr_cubd4",
    "thumbnail": "https://i.ytimg.com/vi/8b5pr_cubd4/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ガイルガイルガイル【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-11T19:03:19Z"
  },
  {
    "videoId": "stzeLVuXXTQ",
    "thumbnail": "https://i.ytimg.com/vi/stzeLVuXXTQ/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】村長召喚！！！！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-12T15:57:36Z"
  },
  {
    "videoId": "4YOmRQbSBZ4",
    "thumbnail": "https://i.ytimg.com/vi/4YOmRQbSBZ4/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】チーム1顔合わせ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-13T16:08:33Z"
  },
  {
    "videoId": "LBvSWYJRtto",
    "thumbnail": "https://i.ytimg.com/vi/LBvSWYJRtto/mqdefault.jpg",
    "title": "手振りだけで踊ってみた！『 #いばらダンス 』 #異薔薇 #アキロゼ  #vtuber",
    "publishedAt": "2025-03-14T11:39:56Z"
  },
  {
    "videoId": "hBbc1-jnlRk",
    "thumbnail": "https://i.ytimg.com/vi/hBbc1-jnlRk/mqdefault.jpg",
    "title": "【VCR GTA 3】6日目まとめ│新人警官の日常【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2025-03-14T13:00:06Z"
  },
  {
    "videoId": "Pl4nTWPUVNs",
    "thumbnail": "https://i.ytimg.com/vi/Pl4nTWPUVNs/mqdefault.jpg",
    "title": "【VCR GTA 3】7日目まとめ│ロスサントスの光と闇とマジナイス！【アキロゼ切り抜き/ホロライブ】",
    "publishedAt": "2025-03-15T03:00:06Z"
  },
  {
    "videoId": "W_2asRHyQ6w",
    "thumbnail": "https://i.ytimg.com/vi/W_2asRHyQ6w/mqdefault.jpg",
    "title": "【モンハンワイルズ】演奏会会場はコチラ。それゆけ！ #ホロモンハン部 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-15T15:48:55Z"
  },
  {
    "videoId": "inIOmo_1XS8",
    "thumbnail": "https://i.ytimg.com/vi/inIOmo_1XS8/mqdefault.jpg",
    "title": "『 #一旦ステイTONIGHT 』#踊ってみた  #ホロライブ #アキロゼ #shorts #vtuber",
    "publishedAt": "2025-03-16T03:00:41Z"
  },
  {
    "videoId": "giaKCF6T5VU",
    "thumbnail": "https://i.ytimg.com/vi/giaKCF6T5VU/mqdefault.jpg",
    "title": "【麻雀一番街】第6回HP麻雀杯今度こそ優勝！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-16T13:33:14Z"
  },
  {
    "videoId": "rLAgW3eTt6A",
    "thumbnail": "https://i.ytimg.com/vi/rLAgW3eTt6A/mqdefault.jpg",
    "title": "【モンハンワイルズ】フルパでひと狩りいこーぜ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-17T13:21:57Z"
  },
  {
    "videoId": "X4wqtzQt77Q",
    "thumbnail": "https://i.ytimg.com/vi/X4wqtzQt77Q/mqdefault.jpg",
    "title": "【モンハンワイルズ】#ホロライブ１期生 で狩りにいくぞーっ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-19T18:43:41Z"
  },
  {
    "videoId": "W04qNzJQMac",
    "thumbnail": "https://i.ytimg.com/vi/W04qNzJQMac/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】村長と練習するぞ！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-20T18:51:37Z"
  },
  {
    "videoId": "Mrj52QgrRwY",
    "thumbnail": "https://i.ytimg.com/vi/Mrj52QgrRwY/mqdefault.jpg",
    "title": "【モンハンワイルズ】限界コントRUSTフルパでひと狩りいこーぜ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-22T12:49:31Z"
  },
  {
    "videoId": "D9rwYOA5US8",
    "thumbnail": "https://i.ytimg.com/vi/D9rwYOA5US8/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】V最とレジェンダスにむけて練習【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-23T19:00:11Z"
  },
  {
    "videoId": "K9OSvViu4K4",
    "thumbnail": "https://i.ytimg.com/vi/K9OSvViu4K4/mqdefault.jpg",
    "title": "【 Red Bull LEGENDUS SF6 最強道場決定戦 】ガイル村でいくぞ～～～！#ガイル村WIN 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-24T11:03:14Z"
  },
  {
    "videoId": "bMJmli1YsN4",
    "thumbnail": "https://i.ytimg.com/vi/bMJmli1YsN4/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】V最スクリム1日目！VSチーム2【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-24T16:56:06Z"
  },
  {
    "videoId": "apdPo6pm9ro",
    "thumbnail": "https://i.ytimg.com/vi/apdPo6pm9ro/mqdefault.jpg",
    "title": "【 Red Bull LEGENDUS SF6 最強道場決定戦 】決勝戦だ！！！ #ガイル村WIN 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-25T09:25:08Z"
  },
  {
    "videoId": "hwbehU-sAyk",
    "thumbnail": "https://i.ytimg.com/vi/hwbehU-sAyk/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#V最協第一幕 スクリム2日目VSチーム3【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-25T17:35:01Z"
  },
  {
    "videoId": "i1VvCd53z-Y",
    "thumbnail": "https://i.ytimg.com/vi/i1VvCd53z-Y/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】チーム名は「ひいろうず」#V最協第一幕 スクリム3日目VSチーム4【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-26T18:25:22Z"
  },
  {
    "videoId": "CpedkJ_87rI",
    "thumbnail": "https://i.ytimg.com/vi/CpedkJ_87rI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】チーム名は「ひいろうず」#V最協第一幕 スクリム4日目VSチーム5＆6【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-27T20:28:31Z"
  },
  {
    "videoId": "p-A6dAjWFMQ",
    "thumbnail": "https://i.ytimg.com/vi/p-A6dAjWFMQ/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ぷげらさんと練習！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-28T08:53:24Z"
  },
  {
    "videoId": "EkyrF8mMYQA",
    "thumbnail": "https://i.ytimg.com/vi/EkyrF8mMYQA/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】チーム名は「ひいろうず」#V最協第一幕 スクリム最終日VSチーム7＆8【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-28T17:26:44Z"
  },
  {
    "videoId": "gWociYqIfOo",
    "thumbnail": "https://i.ytimg.com/vi/gWociYqIfOo/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#ひいろうずWIN 1日目応援よろしく！！！！！#V最協第一幕 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-29T15:55:59Z"
  },
  {
    "videoId": "GvvJ2xOfxug",
    "thumbnail": "https://i.ytimg.com/vi/GvvJ2xOfxug/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】#ひいろうずWIN 2日目ラスト応援よろしく！！！！！#V最協第一幕 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-03-30T15:13:56Z"
  },
  {
    "videoId": "vcfoXFo5BlM",
    "thumbnail": "https://i.ytimg.com/vi/vcfoXFo5BlM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ゲリラ！数日お休みいただきからのランクマ雑談【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-04T20:02:17Z"
  },
  {
    "videoId": "ObjjY1aQE64",
    "thumbnail": "https://i.ytimg.com/vi/ObjjY1aQE64/mqdefault.jpg",
    "title": "【モンハンワイルズ】#チーム腕相撲再集結 ！ってことは【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-06T17:31:25Z"
  },
  {
    "videoId": "tW8VA64elow",
    "thumbnail": "https://i.ytimg.com/vi/tW8VA64elow/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シュミレーション！世界一の博物館作るよ～🦖【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-07T19:57:09Z"
  },
  {
    "videoId": "XrdmXPrjqW8",
    "thumbnail": "https://i.ytimg.com/vi/XrdmXPrjqW8/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シュミレーションでおばけ博物館作り！？👻【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-08T23:45:59Z"
  },
  {
    "videoId": "dvhEzeRjb0E",
    "thumbnail": "https://i.ytimg.com/vi/dvhEzeRjb0E/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シュミレーションで謎の植物園作る！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-09T21:43:06Z"
  },
  {
    "videoId": "9x_eU5eye7I",
    "thumbnail": "https://i.ytimg.com/vi/9x_eU5eye7I/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】Mガイル1時間ランクマ潜り！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-11T16:09:48Z"
  },
  {
    "videoId": "7OfDi4fOLho",
    "thumbnail": "https://i.ytimg.com/vi/7OfDi4fOLho/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シュミレーションで続・おばけ博物館作り！？👻【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-12T02:04:52Z"
  },
  {
    "videoId": "EPoWsAAPkio",
    "thumbnail": "https://i.ytimg.com/vi/EPoWsAAPkio/mqdefault.jpg",
    "title": "【モンハンワイルズ】アーティア笛作りたい！ #あっぷれあ #ホロモンハン部 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-12T17:16:53Z"
  },
  {
    "videoId": "wdaSCPbUlOk",
    "thumbnail": "https://i.ytimg.com/vi/wdaSCPbUlOk/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】本日の1時間ランクマ潜り！Mガイル【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-13T16:20:53Z"
  },
  {
    "videoId": "MCuNaxzBxHQ",
    "thumbnail": "https://i.ytimg.com/vi/MCuNaxzBxHQ/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！海の博物館作り🐟.。o○【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-13T23:00:53Z"
  },
  {
    "videoId": "WhinoeuvfIg",
    "thumbnail": "https://i.ytimg.com/vi/WhinoeuvfIg/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！化学未来博物館作る🛸【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-14T23:35:19Z"
  },
  {
    "videoId": "wHnq4pAxuBs",
    "thumbnail": "https://i.ytimg.com/vi/wHnq4pAxuBs/mqdefault.jpg",
    "title": "【UNDERWARD】廃病院の地下で“実験体”を回収せよ！ #ちくまろ 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-17T13:24:49Z"
  },
  {
    "videoId": "SklqpgrBH18",
    "thumbnail": "https://i.ytimg.com/vi/SklqpgrBH18/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！エイリアン博物館！？👽【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-18T22:43:29Z"
  },
  {
    "videoId": "bHnmHTHS4Qo",
    "thumbnail": "https://i.ytimg.com/vi/bHnmHTHS4Qo/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST出撃！！1日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-19T19:22:42Z"
  },
  {
    "videoId": "u06szu4hEg4",
    "thumbnail": "https://i.ytimg.com/vi/u06szu4hEg4/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST出撃！！2日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-21T00:00:44Z"
  },
  {
    "videoId": "nsMmm_HnTo4",
    "thumbnail": "https://i.ytimg.com/vi/nsMmm_HnTo4/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST！農園作るために水の浄化のための…3日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-21T19:17:05Z"
  },
  {
    "videoId": "6jOSc44w1EM",
    "thumbnail": "https://i.ytimg.com/vi/6jOSc44w1EM/mqdefault.jpg",
    "title": "【R.E.P.O】協力ホラゲー！雇われロボットとして任務をこなせ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-22T13:52:39Z"
  },
  {
    "videoId": "rGMtBa2LrgA",
    "thumbnail": "https://i.ytimg.com/vi/rGMtBa2LrgA/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST！ガレージ作りたい！そして水4日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-22T23:50:18Z"
  },
  {
    "videoId": "AiEyQYKrfb0",
    "thumbnail": "https://i.ytimg.com/vi/AiEyQYKrfb0/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST！小麦でアキパイ作り！5日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-24T00:05:05Z"
  },
  {
    "videoId": "WDsPCkZhdl8",
    "thumbnail": "https://i.ytimg.com/vi/WDsPCkZhdl8/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST！セクシーガーデン初出勤！そしてアキパイ作り！6日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-24T20:29:41Z"
  },
  {
    "videoId": "cvSvKMXspXA",
    "thumbnail": "https://i.ytimg.com/vi/cvSvKMXspXA/mqdefault.jpg",
    "title": "【#holoRUST】ホロ鯖RUST！パイ＆ティーSHOPそして攻略！7日目【アキロゼ/ホロライブ】",
    "publishedAt": "2025-04-26T00:31:30Z"
  },
  {
    "videoId": "Ad7p4o8UVuY",
    "thumbnail": "https://i.ytimg.com/vi/Ad7p4o8UVuY/mqdefault.jpg",
    "title": "【モンハンワイルズ】#チーム腕相撲 で歴戦王対戦よろしく！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-01T14:38:25Z"
  },
  {
    "videoId": "fnX8cyF-E1E",
    "thumbnail": "https://i.ytimg.com/vi/fnX8cyF-E1E/mqdefault.jpg",
    "title": "【Fast Food Simulator】バーガー店で覇権とる！！ #あっぷれあ 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-03T17:53:39Z"
  },
  {
    "videoId": "-ntd79oLn0k",
    "thumbnail": "https://i.ytimg.com/vi/-ntd79oLn0k/mqdefault.jpg",
    "title": "【FINAL FANTASY XIV】人生初MMO！踊り子で舞うぞー！8人で極タイタン討滅戦の道 DAY1 【#HOLOXIV アキロゼ視点/ホロライブ】",
    "publishedAt": "2025-05-04T15:43:45Z"
  },
  {
    "videoId": "Kw4H2a84kCc",
    "thumbnail": "https://i.ytimg.com/vi/Kw4H2a84kCc/mqdefault.jpg",
    "title": "【FINAL FANTASY XIV】人生初MMO！踊り子で舞うぞー！フルパ下限で極タイタン討滅戦の道 DAY2 【#HOLOXIV アキロゼ視点/ホロライブ】",
    "publishedAt": "2025-05-05T17:36:39Z"
  },
  {
    "videoId": "Sk16uDKFkes",
    "thumbnail": "https://i.ytimg.com/vi/Sk16uDKFkes/mqdefault.jpg",
    "title": "【FINAL FANTASY XIV】最終日人生初MMO！踊り子で舞うぞー！フルパ下限で極タイタン討滅戦の道 DAY3【#HOLOXIV アキロゼ視点/ホロライブ】",
    "publishedAt": "2025-05-06T17:34:41Z"
  },
  {
    "videoId": "PY84uqiM_so",
    "thumbnail": "https://i.ytimg.com/vi/PY84uqiM_so/mqdefault.jpg",
    "title": "【みんなでワイワイ!スペランカー】シリーズ初見！かるびちゃん/ぷるるちゃん/ズズさん【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-07T16:32:28Z"
  },
  {
    "videoId": "YeOCZaXWdCY",
    "thumbnail": "https://i.ytimg.com/vi/YeOCZaXWdCY/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！投資は投資です！学芸員クラス6になるのだ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-08T22:31:31Z"
  },
  {
    "videoId": "4YiA-xN5G3E",
    "thumbnail": "https://i.ytimg.com/vi/4YiA-xN5G3E/mqdefault.jpg",
    "title": "【ゴッドフィールド：緊急企業雑談！？】本間ひまわり、八雲べに、アキロゼで企業を語る【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-09T12:44:05Z"
  },
  {
    "videoId": "2h-8pZODE4s",
    "thumbnail": "https://i.ytimg.com/vi/2h-8pZODE4s/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！！社員の最高動線思いついた！学芸員クラス6への道【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-10T00:14:26Z"
  },
  {
    "videoId": "WDabbOTV-qc",
    "thumbnail": "https://i.ytimg.com/vi/WDabbOTV-qc/mqdefault.jpg",
    "title": "【 #アキロゼ100万人耐久 】チャンネル登録100万人いくまで歌うぞ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-11T10:11:25Z"
  },
  {
    "videoId": "uLxNac7CMa8",
    "thumbnail": "https://i.ytimg.com/vi/uLxNac7CMa8/mqdefault.jpg",
    "title": "【 ホロアース 】ホロライブのメタバース空間ゲーム！？今日から始めます！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-11T20:57:55Z"
  },
  {
    "videoId": "X2B8n5FZf08",
    "thumbnail": "https://i.ytimg.com/vi/X2B8n5FZf08/mqdefault.jpg",
    "title": "【R.E.P.O】#ガイル村 で協力ホラゲー！社畜ロボになるぞ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-13T17:52:37Z"
  },
  {
    "videoId": "5CjaH8iKJhg",
    "thumbnail": "https://i.ytimg.com/vi/5CjaH8iKJhg/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！！今夜は学芸員クラス6超えて攻略最前線いくぞｗ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-15T22:12:27Z"
  },
  {
    "videoId": "Xh5xGkC3cy8",
    "thumbnail": "https://i.ytimg.com/vi/Xh5xGkC3cy8/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ゲリラ！獅白杯にむけてまったり触る【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-16T19:14:48Z"
  },
  {
    "videoId": "aQoztQMhUWA",
    "thumbnail": "https://i.ytimg.com/vi/aQoztQMhUWA/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】どぐらチームで #獅白杯3rd エキシビジョンマッチ！1日目いくよー！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-17T15:38:36Z"
  },
  {
    "videoId": "atX1z909TX4",
    "thumbnail": "https://i.ytimg.com/vi/atX1z909TX4/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！！おばけ博物館を豪華にするよ～【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-20T21:12:59Z"
  },
  {
    "videoId": "DdGHo3DaTB0",
    "thumbnail": "https://i.ytimg.com/vi/DdGHo3DaTB0/mqdefault.jpg",
    "title": "【Fast Food Simulator】バーガー屋店長が従業員に振り回される店2 #あっぷれあ 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-21T17:37:11Z"
  },
  {
    "videoId": "hzL8dJ81ss4",
    "thumbnail": "https://i.ytimg.com/vi/hzL8dJ81ss4/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】深夜のランクマ！ダイヤいっちゃうか～！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-23T17:53:45Z"
  },
  {
    "videoId": "zKilPAKBqt4",
    "thumbnail": "https://i.ytimg.com/vi/zKilPAKBqt4/mqdefault.jpg",
    "title": "【ツーポイントミュージアム】経営シミュレーション！宇宙人いっぱい博物館！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-24T22:29:00Z"
  },
  {
    "videoId": "o-pvsz211To",
    "thumbnail": "https://i.ytimg.com/vi/o-pvsz211To/mqdefault.jpg",
    "title": "【Overcooked 2】みんなでワイワイ出勤！かるびちゃん/ぷるるちゃん/ズズさん【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-28T17:46:54Z"
  },
  {
    "videoId": "WNWUIYi-bZw",
    "thumbnail": "https://i.ytimg.com/vi/WNWUIYi-bZw/mqdefault.jpg",
    "title": "【アキロゼ100万人達成記念レース開催！？】ばんえい競馬やるぞ！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-05-31T07:45:22Z"
  },
  {
    "videoId": "P8y7SWLGCn8",
    "thumbnail": "https://i.ytimg.com/vi/P8y7SWLGCn8/mqdefault.jpg",
    "title": "可愛すぎるからまねして😍 #ぴゅあ推しダンス #アキロゼ #ホロライブ1期生『電脳ぴゅあ推し大宣言』モーションデータも配布中🫶",
    "publishedAt": "2025-06-02T06:37:32Z"
  },
  {
    "videoId": "9PUyXekcnms",
    "thumbnail": "https://i.ytimg.com/vi/9PUyXekcnms/mqdefault.jpg",
    "title": "オリジナルミュージカル『MUSICAL Fantasia of Bremen』/Oster project 【ホロライブ/アキロゼ】",
    "publishedAt": "2025-06-02T09:00:06Z"
  },
  {
    "videoId": "8CWG7id2axo",
    "thumbnail": "https://i.ytimg.com/vi/8CWG7id2axo/mqdefault.jpg",
    "title": "【Delta Force】Delta Force×性格診断アキロゼは INFP仲介者！Y軍【アキロゼ/ホロライブ】",
    "publishedAt": "2025-06-15T07:59:24Z"
  },
  {
    "videoId": "-unuCnZHQvU",
    "thumbnail": "https://i.ytimg.com/vi/-unuCnZHQvU/mqdefault.jpg",
    "title": "【R.E.P.O】敵をなぎ倒せば稼ぎ放題！？w∥dtto./歌衣メイカ/Mukai/Nacchi #ぷれでたーといっしょ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-06-23T14:52:52Z"
  },
  {
    "videoId": "mx_UYZtypno",
    "thumbnail": "https://i.ytimg.com/vi/mx_UYZtypno/mqdefault.jpg",
    "title": "【ゲーミングPC初心者歓迎】グラボ博士 vs 視聴者！あなたは何問正解できる？【アキロゼ/ホロライブ】",
    "publishedAt": "2025-06-28T13:39:35Z"
  },
  {
    "videoId": "J3uKWbdu4zI",
    "thumbnail": "https://i.ytimg.com/vi/J3uKWbdu4zI/mqdefault.jpg",
    "title": "【雑談/FreeTalk】1か月半ぶりの復帰配信！ただいま！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-12T11:04:44Z"
  },
  {
    "videoId": "l3HhJi8ePDo",
    "thumbnail": "https://i.ytimg.com/vi/l3HhJi8ePDo/mqdefault.jpg",
    "title": "【#DeathStranding2】孤独とつながり、生と死の狭間でまた会おう─デススト2 始めます【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-12T12:53:54Z"
  },
  {
    "videoId": "7YFWAmAMyJA",
    "thumbnail": "https://i.ytimg.com/vi/7YFWAmAMyJA/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ガイルくん元気してた？本日のランクマ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-13T17:21:11Z"
  },
  {
    "videoId": "p7g5JYy-X8Q",
    "thumbnail": "https://i.ytimg.com/vi/p7g5JYy-X8Q/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】アキガイル本日の深夜ランクマ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-17T16:53:31Z"
  },
  {
    "videoId": "fhjMgm68Zys",
    "thumbnail": "https://i.ytimg.com/vi/fhjMgm68Zys/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】アキガイル本日も深夜ランクマ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-18T16:30:55Z"
  },
  {
    "videoId": "9W4JHGQZCGo",
    "thumbnail": "https://i.ytimg.com/vi/9W4JHGQZCGo/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】いくぞアキガイル！本日も深夜ランクマ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-20T18:26:00Z"
  },
  {
    "videoId": "2TEg5T0jZ54",
    "thumbnail": "https://i.ytimg.com/vi/2TEg5T0jZ54/mqdefault.jpg",
    "title": "👙キミ君と選ぶ とびきり可愛い夏🌴#holonatsuParadise #ホロナツpiece #shorts",
    "publishedAt": "2025-07-21T03:00:06Z"
  },
  {
    "videoId": "LodaIf_M29A",
    "thumbnail": "https://i.ytimg.com/vi/LodaIf_M29A/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ダイヤ帯をすすめアキガイル。深夜ランクマ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-22T16:52:39Z"
  },
  {
    "videoId": "LvxxOhAYCWc",
    "thumbnail": "https://i.ytimg.com/vi/LvxxOhAYCWc/mqdefault.jpg",
    "title": "【 PEAK 】はじめての山登り協力ゲーム！ｗ.水無瀬/まんさや/RiskivzyAt’z【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-24T14:54:41Z"
  },
  {
    "videoId": "GcVoE26Ywb8",
    "thumbnail": "https://i.ytimg.com/vi/GcVoE26Ywb8/mqdefault.jpg",
    "title": "【歌枠】#ホロナツ歌枠リレー 23時の会【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-25T14:26:36Z"
  },
  {
    "videoId": "dSAlW1t6QlA",
    "thumbnail": "https://i.ytimg.com/vi/dSAlW1t6QlA/mqdefault.jpg",
    "title": "【VRChat】ホロナツクイーン決定戦じゃああ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-26T13:33:22Z"
  },
  {
    "videoId": "jkc7unNjew4",
    "thumbnail": "https://i.ytimg.com/vi/jkc7unNjew4/mqdefault.jpg",
    "title": "【ホロアース】特別企画！アキロゼ降臨祭！みんな集まれ～【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-27T12:52:42Z"
  },
  {
    "videoId": "keVfbWqMcnM",
    "thumbnail": "https://i.ytimg.com/vi/keVfbWqMcnM/mqdefault.jpg",
    "title": "【 PEAK 】#ホロ1期生 の4人で山登りピクニックきた【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-27T15:18:42Z"
  },
  {
    "videoId": "cesJkLRLsBY",
    "thumbnail": "https://i.ytimg.com/vi/cesJkLRLsBY/mqdefault.jpg",
    "title": "【REJECT FIGHT NIGHT EXTRA｜運命のトリガー 】新次元異能ヒーローバトロワイベントじゃああ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-28T14:02:23Z"
  },
  {
    "videoId": "8E17k6kpFGQ",
    "thumbnail": "https://i.ytimg.com/vi/8E17k6kpFGQ/mqdefault.jpg",
    "title": "【ELDEN RING NIGHTREIGN】初プレイ！ナイトレインの世界へ  #あっぷれあ ￤ネタバレあり【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-28T17:40:39Z"
  },
  {
    "videoId": "l7gVCLtMS3c",
    "thumbnail": "https://i.ytimg.com/vi/l7gVCLtMS3c/mqdefault.jpg",
    "title": "【#DeathStranding2】孤独とつながり、生と死の狭間でまた会おう─デススト2 Part2 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-07-31T14:04:35Z"
  },
  {
    "videoId": "TLCuNwIApHE",
    "thumbnail": "https://i.ytimg.com/vi/TLCuNwIApHE/mqdefault.jpg",
    "title": "【#DeathStranding2】新章 キミはどこにいってしまったのか─デススト2 Part3【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-01T15:40:24Z"
  },
  {
    "videoId": "1sf43z_2ogM",
    "thumbnail": "https://i.ytimg.com/vi/1sf43z_2ogM/mqdefault.jpg",
    "title": "【#DeathStranding2】武闘派で自分の道を切り開きたい─デススト2 Part4【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-02T16:41:10Z"
  },
  {
    "videoId": "RgWS1af3zg8",
    "thumbnail": "https://i.ytimg.com/vi/RgWS1af3zg8/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6深夜のガイル道場🌀ダイヤ帯ランクマ奮闘記！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-03T15:48:36Z"
  },
  {
    "videoId": "mGgXThiHsUU",
    "thumbnail": "https://i.ytimg.com/vi/mGgXThiHsUU/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】スト6 この深夜にガイルはまた立ち上がる🌀ダイヤ帯ランクマ奮闘記！第2夜【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-04T17:08:42Z"
  },
  {
    "videoId": "tgjy9FsU3Wg",
    "thumbnail": "https://i.ytimg.com/vi/tgjy9FsU3Wg/mqdefault.jpg",
    "title": "【ELDEN RING NIGHTREIGN】3人で初夜渡り！w.フレア/かなたん【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-05T15:11:39Z"
  },
  {
    "videoId": "VDQzTIcQdhs",
    "thumbnail": "https://i.ytimg.com/vi/VDQzTIcQdhs/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】ドンさんコーチングでガイル筋育てる～！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-06T14:59:37Z"
  },
  {
    "videoId": "aDL44MJrTm4",
    "thumbnail": "https://i.ytimg.com/vi/aDL44MJrTm4/mqdefault.jpg",
    "title": "#ZIG ZAG いっしょに踊っちゃった💗見てってね🩰鷹嶺ルイ×アキ・ローゼンタール #ホロライブ #shorts",
    "publishedAt": "2025-08-07T03:00:00Z"
  },
  {
    "videoId": "GS-d1aHPfA4",
    "thumbnail": "https://i.ytimg.com/vi/GS-d1aHPfA4/mqdefault.jpg",
    "title": "【Raft】4人で海に放り出されたけど、絶対クリアする旅その1🌊🏝️#チーム腕相撲 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-07T23:30:45Z"
  },
  {
    "videoId": "bVJelT43VVE",
    "thumbnail": "https://i.ytimg.com/vi/bVJelT43VVE/mqdefault.jpg",
    "title": "【Raft】4人で海に放り出されたけど、絶対クリアする旅その2🌊🏝️#チーム腕相撲 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-08T02:09:39Z"
  },
  {
    "videoId": "xIA3L36uiJ8",
    "thumbnail": "https://i.ytimg.com/vi/xIA3L36uiJ8/mqdefault.jpg",
    "title": "【Raft】4人で海に放り出されたけど、絶対クリアする旅その3🌊🏝️#チーム腕相撲 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-09T00:20:26Z"
  },
  {
    "videoId": "45nu2hWoH18",
    "thumbnail": "https://i.ytimg.com/vi/45nu2hWoH18/mqdefault.jpg",
    "title": "【Raft】4人で海に放り出されたけど、絶対クリアする旅その4🌊🏝️#チーム腕相撲 【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-09T16:18:11Z"
  },
  {
    "videoId": "S20KQBljnmI",
    "thumbnail": "https://i.ytimg.com/vi/S20KQBljnmI/mqdefault.jpg",
    "title": "【新企画】「アキロゼ×癒月ちょこ」の～ホロライブ深夜ラジオ～（仮）第0回",
    "publishedAt": "2025-08-11T15:07:02Z"
  },
  {
    "videoId": "0h4MXp0TLJU",
    "thumbnail": "https://i.ytimg.com/vi/0h4MXp0TLJU/mqdefault.jpg",
    "title": "【 Minecraft 】ゲリラ参加！#ホロ鯖サマーパーク 花火大会とか！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-08-16T15:57:28Z"
  },
  {
    "videoId": "grVbrq1y9_g",
    "thumbnail": "https://i.ytimg.com/vi/grVbrq1y9_g/mqdefault.jpg",
    "title": "アキちょこナイトパレット第1回～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-08-18T15:14:58Z"
  },
  {
    "videoId": "bnVpHxLcdb0",
    "thumbnail": "https://i.ytimg.com/vi/bnVpHxLcdb0/mqdefault.jpg",
    "title": "【チームファイト タクティクス】最速でTFTを学ぶイベント「FAST8」はじまる！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-08-22T18:15:29Z"
  },
  {
    "videoId": "ux72wczZ4P8",
    "thumbnail": "https://i.ytimg.com/vi/ux72wczZ4P8/mqdefault.jpg",
    "title": "【チームファイト タクティクス】スクリム！最速でTFTを学ぶイベント「FAST8」#2【ホロライブ/アキロゼ】",
    "publishedAt": "2025-08-23T19:13:59Z"
  },
  {
    "videoId": "Pa-mkg-F9mc",
    "thumbnail": "https://i.ytimg.com/vi/Pa-mkg-F9mc/mqdefault.jpg",
    "title": "【チームファイト タクティクス】大会本番！最速でTFTを学ぶイベント「FAST8」#3【ホロライブ/アキロゼ】",
    "publishedAt": "2025-08-24T14:48:21Z"
  },
  {
    "videoId": "hC2uo7EPbiA",
    "thumbnail": "https://i.ytimg.com/vi/hC2uo7EPbiA/mqdefault.jpg",
    "title": "アキちょこナイトパレット第2回～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-08-25T15:15:33Z"
  },
  {
    "videoId": "9gSLbJ5QreI",
    "thumbnail": "https://i.ytimg.com/vi/9gSLbJ5QreI/mqdefault.jpg",
    "title": "【 PEAK 】フレア、りりーかと山登り🏔今日のＭＡＰ難易度はいったい…ゴクリ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-26T15:03:09Z"
  },
  {
    "videoId": "zVV65KtpyNc",
    "thumbnail": "https://i.ytimg.com/vi/zVV65KtpyNc/mqdefault.jpg",
    "title": "【 雑談/Free Talk 】ひさしぶりにゆっくり話そー！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-27T16:38:52Z"
  },
  {
    "videoId": "JFpXdix3ylI",
    "thumbnail": "https://i.ytimg.com/vi/JFpXdix3ylI/mqdefault.jpg",
    "title": "【 マリオカートワールド 】緊急配信！ついにswitch2ゲットしたので遊んでみる！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-29T16:28:37Z"
  },
  {
    "videoId": "uDeU9gqulxs",
    "thumbnail": "https://i.ytimg.com/vi/uDeU9gqulxs/mqdefault.jpg",
    "title": "【チームファイト タクティクス】TFTはじめたばかりのド新人だけどいけますか！？ 【ホロライブ/アキロゼ】",
    "publishedAt": "2025-08-30T12:28:28Z"
  },
  {
    "videoId": "32zodqjXvpU",
    "thumbnail": "https://i.ytimg.com/vi/32zodqjXvpU/mqdefault.jpg",
    "title": "【 マリオカートワールド 】ちょっとまってマリオカート楽しすぎない？【アキロゼ/ホロライブ】",
    "publishedAt": "2025-08-31T17:29:04Z"
  },
  {
    "videoId": "5xJdss0U-_o",
    "thumbnail": "https://i.ytimg.com/vi/5xJdss0U-_o/mqdefault.jpg",
    "title": "アキちょこナイトパレット第3回～ホロライブ深夜ラジオ～ #アキちょこナイパレ",
    "publishedAt": "2025-09-01T15:08:40Z"
  },
  {
    "videoId": "pdfsVtAozB4",
    "thumbnail": "https://i.ytimg.com/vi/pdfsVtAozB4/mqdefault.jpg",
    "title": "【チームファイト タクティクス】第1回FAST8の仲間たちでTFTダブルアップカスタム！ 【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-03T14:01:32Z"
  },
  {
    "videoId": "m5xkd6r43GA",
    "thumbnail": "https://i.ytimg.com/vi/m5xkd6r43GA/mqdefault.jpg",
    "title": "【雀魂】DREAM MATCH 🀄雀魂下剋上リーグUNLIMITチームで顔合わせ！！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-03T17:34:56Z"
  },
  {
    "videoId": "5cyKQhAgRhM",
    "thumbnail": "https://i.ytimg.com/vi/5cyKQhAgRhM/mqdefault.jpg",
    "title": "【ELDEN RING NIGHTREIGN】3人でリベンジ夜渡り！！！w.フレア/かなたん【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-05T15:31:41Z"
  },
  {
    "videoId": "19L0ekSjHd8",
    "thumbnail": "https://i.ytimg.com/vi/19L0ekSjHd8/mqdefault.jpg",
    "title": "【Delta Force】DTTO. UNITY FESいくぞー！！！！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-06T11:19:44Z"
  },
  {
    "videoId": "_MbIE1RFUSU",
    "thumbnail": "https://i.ytimg.com/vi/_MbIE1RFUSU/mqdefault.jpg",
    "title": "【雀魂】深夜の練習～🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-06T16:50:50Z"
  },
  {
    "videoId": "ht5e9Bv59Kc",
    "thumbnail": "https://i.ytimg.com/vi/ht5e9Bv59Kc/mqdefault.jpg",
    "title": "『夜中にこっそりやっていること💕』～ホロライブ深夜ラジオ～ アキちょこナイトパレット第4回 #アキちょこナイパレ",
    "publishedAt": "2025-09-08T15:10:48Z"
  },
  {
    "videoId": "M3Ea1BgqdZI",
    "thumbnail": "https://i.ytimg.com/vi/M3Ea1BgqdZI/mqdefault.jpg",
    "title": "【雀魂】明日からはじまるので士気高めるぞ🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-08T17:36:28Z"
  },
  {
    "videoId": "s-YRUvMvac8",
    "thumbnail": "https://i.ytimg.com/vi/s-YRUvMvac8/mqdefault.jpg",
    "title": "【雀魂】今日からリーグ戦開幕！ぜったい勝つ！！！！🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-09T13:27:15Z"
  },
  {
    "videoId": "qiVARqRLdp8",
    "thumbnail": "https://i.ytimg.com/vi/qiVARqRLdp8/mqdefault.jpg",
    "title": "【雀魂】鳴きあがり縛りで練習！？？？？？🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-11T16:55:33Z"
  },
  {
    "videoId": "lZhfvdtjKYU",
    "thumbnail": "https://i.ytimg.com/vi/lZhfvdtjKYU/mqdefault.jpg",
    "title": "【雀魂】放銃したら罰ゲーム！？？？🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-12T13:21:13Z"
  },
  {
    "videoId": "pgRpMR_lpw8",
    "thumbnail": "https://i.ytimg.com/vi/pgRpMR_lpw8/mqdefault.jpg",
    "title": "【雀魂】放銃したら罰ゲームりべんじ！？？？🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-13T16:02:16Z"
  },
  {
    "videoId": "6OD3BCSYswI",
    "thumbnail": "https://i.ytimg.com/vi/6OD3BCSYswI/mqdefault.jpg",
    "title": "【雀魂】東南戦の戦い方ってなんだ？🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-14T15:56:13Z"
  },
  {
    "videoId": "_ByC1NlFHN8",
    "thumbnail": "https://i.ytimg.com/vi/_ByC1NlFHN8/mqdefault.jpg",
    "title": "【R.E.P.O】頭だけでも働きなさい！！！？w/フレア,ちょこ,かなた【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-15T14:18:38Z"
  },
  {
    "videoId": "NUcqPRn_1Xk",
    "thumbnail": "https://i.ytimg.com/vi/NUcqPRn_1Xk/mqdefault.jpg",
    "title": "『ダメだと分かっていて止められなかった💕』～ホロライブ深夜ラジオ～ アキちょこナイトパレット第5回 #アキちょこナイパレ",
    "publishedAt": "2025-09-15T15:04:10Z"
  },
  {
    "videoId": "JmKWSN9VZU4",
    "thumbnail": "https://i.ytimg.com/vi/JmKWSN9VZU4/mqdefault.jpg",
    "title": "【雀魂】2週目！ぜったい勝つぞ～～！！！！🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-16T12:54:52Z"
  },
  {
    "videoId": "qThwfHi8GdM",
    "thumbnail": "https://i.ytimg.com/vi/qThwfHi8GdM/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】常闇祭にむけてアップはじめるぞおお！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-17T17:16:12Z"
  },
  {
    "videoId": "2I5GungkPHQ",
    "thumbnail": "https://i.ytimg.com/vi/2I5GungkPHQ/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】常闇祭チーム顔合わせ練習会！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-18T19:37:03Z"
  },
  {
    "videoId": "Teq8nxbGnxI",
    "thumbnail": "https://i.ytimg.com/vi/Teq8nxbGnxI/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】強キ者求ム！視聴者参加募集でカスタム体当たり特訓するよ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-19T15:24:40Z"
  },
  {
    "videoId": "5SnCcnPijjs",
    "thumbnail": "https://i.ytimg.com/vi/5SnCcnPijjs/mqdefault.jpg",
    "title": "【 STREET FIGHTER 6】常闇祭本番！どこまでいけるのか！？w/ だいだら,RiskivzyAt'z【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-20T04:41:46Z"
  },
  {
    "videoId": "sf8TkVS63oc",
    "thumbnail": "https://i.ytimg.com/vi/sf8TkVS63oc/mqdefault.jpg",
    "title": "【Keep Digging】地下1,000mまで穴を掘らないと帰れない！？/w.だいだら,RiskivzyAt'z【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-20T10:00:36Z"
  },
  {
    "videoId": "mLF8QZzlYgE",
    "thumbnail": "https://i.ytimg.com/vi/mLF8QZzlYgE/mqdefault.jpg",
    "title": "3Dで1時間拡張版！今日のテーマ『母性を感じた瞬間💕』 アキちょこナイトパレット第6回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-09-22T15:05:17Z"
  },
  {
    "videoId": "SxSAc2P-t_c",
    "thumbnail": "https://i.ytimg.com/vi/SxSAc2P-t_c/mqdefault.jpg",
    "title": "【雀魂】３週目！ラスト試合予定！1位とりたい！🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-23T13:20:57Z"
  },
  {
    "videoId": "ar7eKok38vI",
    "thumbnail": "https://i.ytimg.com/vi/ar7eKok38vI/mqdefault.jpg",
    "title": "【運命のトリガー】新作FPS明日のために練習！サブPCチェックも兼ねて【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-24T17:53:48Z"
  },
  {
    "videoId": "hcDsaKkYfgM",
    "thumbnail": "https://i.ytimg.com/vi/hcDsaKkYfgM/mqdefault.jpg",
    "title": "【運命のトリガー∥TGS2025】壁！壁！壁！運命の前哨戦はじまる！w/ Euriece,歌衣メイカ,玉餅かずよ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-25T09:13:19Z"
  },
  {
    "videoId": "8HKBjzRT1Qw",
    "thumbnail": "https://i.ytimg.com/vi/8HKBjzRT1Qw/mqdefault.jpg",
    "title": "【運命のトリガー∥TGS2025】スペシャルステージだし勝ちたい！w/1tappy,ズズ,ととみっくす【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-27T08:30:55Z"
  },
  {
    "videoId": "kV4ekYm0aqM",
    "thumbnail": "https://i.ytimg.com/vi/kV4ekYm0aqM/mqdefault.jpg",
    "title": "【雀魂】続・放銃したら罰ゲーム！？？？🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-28T16:31:12Z"
  },
  {
    "videoId": "cCMpP2If6_0",
    "thumbnail": "https://i.ytimg.com/vi/cCMpP2If6_0/mqdefault.jpg",
    "title": "【nosh】実食レポ！毎日食べたいダイエットの味方ごはんランキング！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-29T11:24:44Z"
  },
  {
    "videoId": "zXvteHt38Fw",
    "thumbnail": "https://i.ytimg.com/vi/zXvteHt38Fw/mqdefault.jpg",
    "title": "【雀魂】４週目！今日こそ1位とりたい！🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-09-30T12:29:44Z"
  },
  {
    "videoId": "5Brg1odurzI",
    "thumbnail": "https://i.ytimg.com/vi/5Brg1odurzI/mqdefault.jpg",
    "title": "【 #ホロAmongUs3D 】PONなメンバーで3Dアモアスやったらどうなるか検証します【アキロゼ/ホロライブ】",
    "publishedAt": "2025-09-30T15:44:02Z"
  },
  {
    "videoId": "dz_tFFYTiak",
    "thumbnail": "https://i.ytimg.com/vi/dz_tFFYTiak/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】ついに上陸！マッドタウンいってみるよ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-01T18:37:59Z"
  },
  {
    "videoId": "jITpevpR5hE",
    "thumbnail": "https://i.ytimg.com/vi/jITpevpR5hE/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】卍お金稼いだりの珍道中卍【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-02T18:31:19Z"
  },
  {
    "videoId": "15_uQvAkBVA",
    "thumbnail": "https://i.ytimg.com/vi/15_uQvAkBVA/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】ほしい車と兼業シスター珍道中【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-03T18:26:04Z"
  },
  {
    "videoId": "cVArBufL5ro",
    "thumbnail": "https://i.ytimg.com/vi/cVArBufL5ro/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】ギャング設立抗争の行く果ては？【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-04T18:46:37Z"
  },
  {
    "videoId": "HyxGrpaRS7I",
    "thumbnail": "https://i.ytimg.com/vi/HyxGrpaRS7I/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】今日からはじまる白ギャングPart1【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-05T10:34:07Z"
  },
  {
    "videoId": "90FvqLvk7F8",
    "thumbnail": "https://i.ytimg.com/vi/90FvqLvk7F8/mqdefault.jpg",
    "title": "【チームファイト タクティクス】麻雀勢とTFTで遊ぶよー！！ 【ホロライブ/アキロゼ】",
    "publishedAt": "2025-10-05T14:14:10Z"
  },
  {
    "videoId": "chIoOmbD0xY",
    "thumbnail": "https://i.ytimg.com/vi/chIoOmbD0xY/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】今日からはじまる白ギャングPart2【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-05T18:20:59Z"
  },
  {
    "videoId": "qWn4pb2wv2k",
    "thumbnail": "https://i.ytimg.com/vi/qWn4pb2wv2k/mqdefault.jpg",
    "title": "『#あざとすぎる小悪魔女💕』 アキちょこナイトパレット第7回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-10-06T15:08:44Z"
  },
  {
    "videoId": "TtuRUfJOWhQ",
    "thumbnail": "https://i.ytimg.com/vi/TtuRUfJOWhQ/mqdefault.jpg",
    "title": "【雀魂】5週目！東風戦に挑む次こそ1位！🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-10-07T13:01:16Z"
  },
  {
    "videoId": "KktkKSiwra4",
    "thumbnail": "https://i.ytimg.com/vi/KktkKSiwra4/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】マッドアリエス教会初ミサ始動！？白狐の顔も添えて【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-09T09:26:06Z"
  },
  {
    "videoId": "OlXoBjAhzy0",
    "thumbnail": "https://i.ytimg.com/vi/OlXoBjAhzy0/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】マッドアリエス教会初ミサ始動！？白狐の顔も添えて【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-09T18:33:42Z"
  },
  {
    "videoId": "JWOEtCYZ2Rc",
    "thumbnail": "https://i.ytimg.com/vi/JWOEtCYZ2Rc/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】まだやってないこともいっぱいやってみたい【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-10T18:30:30Z"
  },
  {
    "videoId": "WrW4dAjvEN0",
    "thumbnail": "https://i.ytimg.com/vi/WrW4dAjvEN0/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】ヘリ買っちゃおうかな！？【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-11T18:26:07Z"
  },
  {
    "videoId": "FUSqlpGuX2A",
    "thumbnail": "https://i.ytimg.com/vi/FUSqlpGuX2A/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】悪魔が現れる！？白狐新メンバー加入まであるか？【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-12T18:35:11Z"
  },
  {
    "videoId": "mB9kZtSrFyc",
    "thumbnail": "https://i.ytimg.com/vi/mB9kZtSrFyc/mqdefault.jpg",
    "title": "『今まで惚れた異性の特徴 💕』 アキちょこナイトパレット第9回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-10-13T15:12:57Z"
  },
  {
    "videoId": "VNmON_Hi7A8",
    "thumbnail": "https://i.ytimg.com/vi/VNmON_Hi7A8/mqdefault.jpg",
    "title": "【雀魂】6週目！プロ×プロ×ととさん卓に勝てたらすなわち最強なのでは🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-10-14T12:20:26Z"
  },
  {
    "videoId": "GBCibBNLtcA",
    "thumbnail": "https://i.ytimg.com/vi/GBCibBNLtcA/mqdefault.jpg",
    "title": "【FFL Delta Force】秋雪こはく分隊で勝ちにいくぞ！！w/ 猫麦とろろ.Naxhoneko #FFL天使軍WIN 【アキロゼ視点/ホロライブ】",
    "publishedAt": "2025-10-15T13:20:55Z"
  },
  {
    "videoId": "HmRuSA2f_08",
    "thumbnail": "https://i.ytimg.com/vi/HmRuSA2f_08/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】聖杯戦争・・・？！ちょっとだけのIN【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-15T18:13:23Z"
  },
  {
    "videoId": "KOO081meKXg",
    "thumbnail": "https://i.ytimg.com/vi/KOO081meKXg/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】今日もこの街で生きていく【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-16T18:29:01Z"
  },
  {
    "videoId": "S0Ef362K5qo",
    "thumbnail": "https://i.ytimg.com/vi/S0Ef362K5qo/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】よちよち予約あり！？コンテンダー活躍の場面はあるかな【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-17T18:25:01Z"
  },
  {
    "videoId": "ul1PaNh4k7Y",
    "thumbnail": "https://i.ytimg.com/vi/ul1PaNh4k7Y/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】なんだか今日も濃そうな日【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-18T18:32:41Z"
  },
  {
    "videoId": "mOyeTau73XQ",
    "thumbnail": "https://i.ytimg.com/vi/mOyeTau73XQ/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】白狐も成長しつついろんなこと楽しむ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-19T18:35:01Z"
  },
  {
    "videoId": "qyRxUlxFq5g",
    "thumbnail": "https://i.ytimg.com/vi/qyRxUlxFq5g/mqdefault.jpg",
    "title": "『言われてうれしかったひとこと 💕』 アキちょこナイトパレット第10回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-10-20T15:12:35Z"
  },
  {
    "videoId": "U4yrotubI6g",
    "thumbnail": "https://i.ytimg.com/vi/U4yrotubI6g/mqdefault.jpg",
    "title": "【雀魂】アキロゼラスト出陣！1位をつかめ！！第7週🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-10-21T14:11:06Z"
  },
  {
    "videoId": "HuA4wn03Ack",
    "thumbnail": "https://i.ytimg.com/vi/HuA4wn03Ack/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】ついに聖水が！？白狐に新しい風が吹く【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-22T18:25:50Z"
  },
  {
    "videoId": "0tWwzoXzzaE",
    "thumbnail": "https://i.ytimg.com/vi/0tWwzoXzzaE/mqdefault.jpg",
    "title": "【 #ホロ鉄千】 一番早く鉄を1000個集めたチームが勝ち！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-25T13:43:43Z"
  },
  {
    "videoId": "HspUPwd9Ap4",
    "thumbnail": "https://i.ytimg.com/vi/HspUPwd9Ap4/mqdefault.jpg",
    "title": "『#メロかった体験談  💕』 アキちょこナイトパレット第11回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-10-27T15:10:24Z"
  },
  {
    "videoId": "MwnVTKmOcG8",
    "thumbnail": "https://i.ytimg.com/vi/MwnVTKmOcG8/mqdefault.jpg",
    "title": "【雀魂】いよいよ最終節！下剋上がどのチームに！？🀄DREAM MATCH 🀄雀魂下剋上リーグ【ホロライブ/アキロゼ】",
    "publishedAt": "2025-10-28T13:56:44Z"
  },
  {
    "videoId": "dYM94kC-5fQ",
    "thumbnail": "https://i.ytimg.com/vi/dYM94kC-5fQ/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】もう10月がおわっちゃう！？ちょっとだけIN【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-29T18:23:13Z"
  },
  {
    "videoId": "EeE5pKh4DX4",
    "thumbnail": "https://i.ytimg.com/vi/EeE5pKh4DX4/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】いよいよ明日でラスト！？終わりたくない【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-30T12:35:14Z"
  },
  {
    "videoId": "AtTiexIvTug",
    "thumbnail": "https://i.ytimg.com/vi/AtTiexIvTug/mqdefault.jpg",
    "title": "【GTA5│MAD TOWN】白狐そしてマッドアリエス教会ありがとう最終日です【アキロゼ/ホロライブ】",
    "publishedAt": "2025-10-31T18:44:24Z"
  },
  {
    "videoId": "nx9DVRTdy1Q",
    "thumbnail": "https://i.ytimg.com/vi/nx9DVRTdy1Q/mqdefault.jpg",
    "title": "【The Headliners】ニューヨークにクリーチャーが現る！？ガイル村で潜入捜査！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-01T17:04:24Z"
  },
  {
    "videoId": "sfkS3JwesKk",
    "thumbnail": "https://i.ytimg.com/vi/sfkS3JwesKk/mqdefault.jpg",
    "title": "【MADTOWN】KAMIKAGO アキロゼ/狂蘭メロコ/心白てと/小森めと/鷹宮リオン/二十日ネル/かんせる/梟雄しろや/たちばな/水無瀬/ミラン/わきを│聖マッドアリエス教会テーマソング",
    "publishedAt": "2025-11-03T14:00:08Z"
  },
  {
    "videoId": "XXgBZiDqsRc",
    "thumbnail": "https://i.ytimg.com/vi/XXgBZiDqsRc/mqdefault.jpg",
    "title": "『#ちょっと恥ずかしかった地元の常識 💕』 アキちょこナイトパレット第12回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-11-03T15:16:21Z"
  },
  {
    "videoId": "4-jQQHNgPxg",
    "thumbnail": "https://i.ytimg.com/vi/4-jQQHNgPxg/mqdefault.jpg",
    "title": "【R.E.P.O】#ホロ１期REPO でアプデ後のレポ！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-04T15:47:31Z"
  },
  {
    "videoId": "Q7vqnvES2-g",
    "thumbnail": "https://i.ytimg.com/vi/Q7vqnvES2-g/mqdefault.jpg",
    "title": "#madtown 新車に乗って1秒でとまらない大爆発！ #shorts",
    "publishedAt": "2025-11-05T14:58:55Z"
  },
  {
    "videoId": "_tbLO3RZeBc",
    "thumbnail": "https://i.ytimg.com/vi/_tbLO3RZeBc/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 1日目まとめ公式切り抜き│運命に身を任せて上陸【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-05T15:00:06Z"
  },
  {
    "videoId": "Us4BA9sFV8o",
    "thumbnail": "https://i.ytimg.com/vi/Us4BA9sFV8o/mqdefault.jpg",
    "title": "【運命のトリガー∥TGS2025】肉壁大作戦からの貢ぎ癖発覚！？異能力バトルロイヤルシューター【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-06T09:16:02Z"
  },
  {
    "videoId": "Uqe6QLq5oJ8",
    "thumbnail": "https://i.ytimg.com/vi/Uqe6QLq5oJ8/mqdefault.jpg",
    "title": "#madtown 叫びながらトラックに撥ねられ空を舞うアキロゼ #shorts",
    "publishedAt": "2025-11-06T09:19:40Z"
  },
  {
    "videoId": "dx779AGF7i0",
    "thumbnail": "https://i.ytimg.com/vi/dx779AGF7i0/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 2日目まとめ公式切り抜き│弟子ができる！そして教会に勧誘【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-06T11:00:07Z"
  },
  {
    "videoId": "bt-SV0TJ-Oc",
    "thumbnail": "https://i.ytimg.com/vi/bt-SV0TJ-Oc/mqdefault.jpg",
    "title": "【APEX】幼稚園えーぺっくすで新シーズンGO w.まるーん/おおはらMEN【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-06T16:47:10Z"
  },
  {
    "videoId": "JqWNoHVFPck",
    "thumbnail": "https://i.ytimg.com/vi/JqWNoHVFPck/mqdefault.jpg",
    "title": "【APEX】Dtto.カップ顔合わせやるよ～！ w.秋雪こはく/甘狼このみ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-07T15:21:24Z"
  },
  {
    "videoId": "LBB-D7yFvpc",
    "thumbnail": "https://i.ytimg.com/vi/LBB-D7yFvpc/mqdefault.jpg",
    "title": "【APEX】本番れちご！ DTTO. UNITY FES  w.秋雪こはく/甘狼このみ【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-08T12:52:16Z"
  },
  {
    "videoId": "cxKUmG71L8k",
    "thumbnail": "https://i.ytimg.com/vi/cxKUmG71L8k/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 3日目まとめ公式切り抜き│シスターローズで教会参戦【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-10T15:00:06Z"
  },
  {
    "videoId": "6ZuR-_TTwAQ",
    "thumbnail": "https://i.ytimg.com/vi/6ZuR-_TTwAQ/mqdefault.jpg",
    "title": "『#最近興奮したこと 💕』 アキちょこナイトパレット第13回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-11-10T15:12:36Z"
  },
  {
    "videoId": "Ig1ewJj4Zy8",
    "thumbnail": "https://i.ytimg.com/vi/Ig1ewJj4Zy8/mqdefault.jpg",
    "title": "#madtown アキロゼ流新人犯罪研修の時間だー！ #shorts",
    "publishedAt": "2025-11-11T10:42:42Z"
  },
  {
    "videoId": "LqMUCd67GIc",
    "thumbnail": "https://i.ytimg.com/vi/LqMUCd67GIc/mqdefault.jpg",
    "title": "#madtown ホロライブからの❤で大炎上不可避で草 #shorts",
    "publishedAt": "2025-11-12T22:00:32Z"
  },
  {
    "videoId": "REn29GBpjdQ",
    "thumbnail": "https://i.ytimg.com/vi/REn29GBpjdQ/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 4日目まとめ公式切り抜き│ギャング設立大白熱チンチロバトルそして人質コントからのコントまみれ【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-13T09:00:06Z"
  },
  {
    "videoId": "ycX-QNM-LpQ",
    "thumbnail": "https://i.ytimg.com/vi/ycX-QNM-LpQ/mqdefault.jpg",
    "title": "【 #ホロ鉄千】 リベンジマッチ！？ホロでソロで一番早く鉄を1000個集めた奴が優勝【アキロゼ/ホロライブ】",
    "publishedAt": "2025-11-13T15:12:07Z"
  },
  {
    "videoId": "b9EhU8UqWS8",
    "thumbnail": "https://i.ytimg.com/vi/b9EhU8UqWS8/mqdefault.jpg",
    "title": "#madtown 燃えることから逃げられない配信者達 #shorts",
    "publishedAt": "2025-11-14T03:00:43Z"
  },
  {
    "videoId": "jSzMT37L1OY",
    "thumbnail": "https://i.ytimg.com/vi/jSzMT37L1OY/mqdefault.jpg",
    "title": "#madtown 新人警官ゆう。VSアキロゼの激熱チェイス #shorts",
    "publishedAt": "2025-11-15T03:00:56Z"
  },
  {
    "videoId": "quSMquqGYuU",
    "thumbnail": "https://i.ytimg.com/vi/quSMquqGYuU/mqdefault.jpg",
    "title": "#madtown アマルVSアキロゼの逮捕コント #shorts",
    "publishedAt": "2025-11-15T09:01:30Z"
  },
  {
    "videoId": "hxuWTgPlDJs",
    "thumbnail": "https://i.ytimg.com/vi/hxuWTgPlDJs/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 5日目まとめ公式切り抜き│教会のウラの顔！？初の宝石店強盗でキルをとりまくるアキロゼ！【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-15T11:00:06Z"
  },
  {
    "videoId": "izsKEfXSXGU",
    "thumbnail": "https://i.ytimg.com/vi/izsKEfXSXGU/mqdefault.jpg",
    "title": "カリオペの【Orpheus】踊ってみた💀💕 #MoriCalliope #Orpheus #shorts",
    "publishedAt": "2025-11-19T10:02:48Z"
  },
  {
    "videoId": "dypFWIuSK00",
    "thumbnail": "https://i.ytimg.com/vi/dypFWIuSK00/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 6日目まとめ公式切り抜き│迷えるバブ達のママになる。【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-22T11:00:07Z"
  },
  {
    "videoId": "CsYvwwyRH6M",
    "thumbnail": "https://i.ytimg.com/vi/CsYvwwyRH6M/mqdefault.jpg",
    "title": "#madtown アイドルの生お許しボイス公開収録💕 #shorts",
    "publishedAt": "2025-11-22T13:00:23Z"
  },
  {
    "videoId": "5Ja3ti0bmnM",
    "thumbnail": "https://i.ytimg.com/vi/5Ja3ti0bmnM/mqdefault.jpg",
    "title": "#madtown お叱りボイスを公開収録するアキロゼ💕 #shorts",
    "publishedAt": "2025-11-23T03:00:07Z"
  },
  {
    "videoId": "Fu12fSsgXfI",
    "thumbnail": "https://i.ytimg.com/vi/Fu12fSsgXfI/mqdefault.jpg",
    "title": "#madtown アキロゼ、ママになる #shorts 【シード/花ノ木まる/Day1/U者/アキ・ローゼンタール】",
    "publishedAt": "2025-11-23T08:00:31Z"
  },
  {
    "videoId": "h3N99vOWD1Q",
    "thumbnail": "https://i.ytimg.com/vi/h3N99vOWD1Q/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 7日目まとめ公式切り抜き│警察の猛者を巻き込んで大コントがとまらない【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-23T09:00:06Z"
  },
  {
    "videoId": "m-O_DsIobZ8",
    "thumbnail": "https://i.ytimg.com/vi/m-O_DsIobZ8/mqdefault.jpg",
    "title": "#madtown ズズが嬉しかったコメントとは #shorts",
    "publishedAt": "2025-11-24T03:01:03Z"
  },
  {
    "videoId": "xrZteuJLOGA",
    "thumbnail": "https://i.ytimg.com/vi/xrZteuJLOGA/mqdefault.jpg",
    "title": "#madtown 警察プロの叶の圧にパソコンが屈した奇跡の脱出 #shorts",
    "publishedAt": "2025-11-24T06:59:56Z"
  },
  {
    "videoId": "_uf90OUFlwE",
    "thumbnail": "https://i.ytimg.com/vi/_uf90OUFlwE/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 8日目まとめ公式切り抜き│ヘリ購入！？狂犬dtto.がメカニックで大暴れ【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-24T11:00:07Z"
  },
  {
    "videoId": "NfeQ_gcHCQo",
    "thumbnail": "https://i.ytimg.com/vi/NfeQ_gcHCQo/mqdefault.jpg",
    "title": "『#嫉妬した瞬間💕』 アキちょこナイトパレット第14回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-11-24T15:26:46Z"
  },
  {
    "videoId": "1IJ5Wj44diI",
    "thumbnail": "https://i.ytimg.com/vi/1IJ5Wj44diI/mqdefault.jpg",
    "title": "#madtown 暴走する2人の日常、dtto.VS秋雪こはく #shorts",
    "publishedAt": "2025-11-25T03:00:03Z"
  },
  {
    "videoId": "OGJebu8JeFc",
    "thumbnail": "https://i.ytimg.com/vi/OGJebu8JeFc/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 9日目まとめ公式切り抜き│ゲーム内で生歌披露/新人加入コント炸裂/ツルギ母おなつのにびたし VS dtto.アキロゼ&アルランディス夫妻【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-25T11:00:06Z"
  },
  {
    "videoId": "ZoEkIx7MaJ0",
    "thumbnail": "https://i.ytimg.com/vi/ZoEkIx7MaJ0/mqdefault.jpg",
    "title": "#madtown GTAヘリあるあるコント #shorts",
    "publishedAt": "2025-11-26T03:00:50Z"
  },
  {
    "videoId": "7pB401cx9d4",
    "thumbnail": "https://i.ytimg.com/vi/7pB401cx9d4/mqdefault.jpg",
    "title": "【 Lethal Company 】 白狐でリーサルカンパニーに就職だ！稼ぎ頭は誰だと思う？【ホロライブ/アキロゼ】",
    "publishedAt": "2025-11-26T14:07:36Z"
  },
  {
    "videoId": "XePgkVisJDQ",
    "thumbnail": "https://i.ytimg.com/vi/XePgkVisJDQ/mqdefault.jpg",
    "title": "#madtown 人間と思ってNPCに声をかけるアキロゼ #shorts",
    "publishedAt": "2025-11-27T03:00:47Z"
  },
  {
    "videoId": "jaWjnlVNEBo",
    "thumbnail": "https://i.ytimg.com/vi/jaWjnlVNEBo/mqdefault.jpg",
    "title": "GTA5│MAD TOWN 10日目まとめ公式切り抜き│天才作戦で警察を騙そうとする白狐/教会で悪魔に憑りつかれるアキロゼ【アキロゼ│ホロライブ】",
    "publishedAt": "2025-11-27T11:00:06Z"
  },
  {
    "videoId": "zNiJVFb2DTY",
    "thumbnail": "https://i.ytimg.com/vi/zNiJVFb2DTY/mqdefault.jpg",
    "title": "#madtown 絶対に結婚させたい教会わきを、絶対に結婚したくないツルギ #shorts【アキロゼ/アルランディス/dtto./おなつのにびたし/柊ツルギ/わきを】",
    "publishedAt": "2025-11-28T03:01:13Z"
  },
  {
    "videoId": "GnlhGZhIM3M",
    "thumbnail": "https://i.ytimg.com/vi/GnlhGZhIM3M/mqdefault.jpg",
    "title": "【チームファイト タクティクス】明日から始まるTFTイベントのチーム顔合わせ＆スクリムやるよ！【ホロライブ/アキロゼ】",
    "publishedAt": "2025-11-28T17:03:45Z"
  },
  {
    "videoId": "B1IP-mWMH8k",
    "thumbnail": "https://i.ytimg.com/vi/B1IP-mWMH8k/mqdefault.jpg",
    "title": "#madtown ムキさんと呼ぶととみっくす #shorts",
    "publishedAt": "2025-11-29T03:00:24Z"
  },
  {
    "videoId": "oJ_fhQNmjVc",
    "thumbnail": "https://i.ytimg.com/vi/oJ_fhQNmjVc/mqdefault.jpg",
    "title": "【チームファイト タクティクス】 賞金がっぽりしたいぞ！TFTイベント本番！Day 1【ホロライブ/アキロゼ】",
    "publishedAt": "2025-11-29T13:56:09Z"
  },
  {
    "videoId": "QUvz-4Kkpig",
    "thumbnail": "https://i.ytimg.com/vi/QUvz-4Kkpig/mqdefault.jpg",
    "title": "#madtown アキロゼ、屋上の警察を撃破しようとするが・・・ #shorts",
    "publishedAt": "2025-11-30T03:00:37Z"
  },
  {
    "videoId": "OnTeaa0Jd8s",
    "thumbnail": "https://i.ytimg.com/vi/OnTeaa0Jd8s/mqdefault.jpg",
    "title": "【チームファイト タクティクス】 今日で大勝ち！TOP4に入れ！TFTイベント本番！Day 2【ホロライブ/アキロゼ】",
    "publishedAt": "2025-11-30T14:25:56Z"
  },
  {
    "videoId": "Jjxtjz7JuUo",
    "thumbnail": "https://i.ytimg.com/vi/Jjxtjz7JuUo/mqdefault.jpg",
    "title": "3Dすぺしゃる回！今日のテーマ『#この一言で私落ちました💕』 アキちょこナイトパレット第15回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-12-01T15:10:08Z"
  },
  {
    "videoId": "wO3Evw6nBXk",
    "thumbnail": "https://i.ytimg.com/vi/wO3Evw6nBXk/mqdefault.jpg",
    "title": "3Dラジオ！『ホロメン流恋愛格言とは！？』 アキちょこナイトパレット第16回 ～ホロライブ深夜ラジオ～",
    "publishedAt": "2025-12-08T15:15:56Z"
  },
  {
    "videoId": "QJtjJL__7GI",
    "thumbnail": "https://i.ytimg.com/vi/QJtjJL__7GI/mqdefault.jpg",
    "title": "【ゲリラ雑談】めずらしい朝活で近況報告でも！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-12-08T23:16:09Z"
  },
  {
    "videoId": "fXXYqKNohnk",
    "thumbnail": "https://i.ytimg.com/vi/fXXYqKNohnk/mqdefault.jpg",
    "title": "【Fish Stick Protocol】ホロメンとトレジャーカンパニー バタバタ回収隊！いきます！【アキロゼ/ホロライブ】",
    "publishedAt": "2025-12-10T13:06:54Z"
  }
],
  Matsuri :
  [
  {
    "videoId": "dJ-8EGi5zCs",
    "thumbnail": "https://i.ytimg.com/vi/dJ-8EGi5zCs/mqdefault.jpg",
    "title": "Matsuri Channel 夏色まつり の初配信",
    "publishedAt": "2018-06-01T15:39:00Z"
  },
  {
    "videoId": "KUtueqFkYZc",
    "thumbnail": "https://i.ytimg.com/vi/KUtueqFkYZc/mqdefault.jpg",
    "title": "【自己紹介】はじめましての動画！！！【音量注意？】",
    "publishedAt": "2018-06-09T13:30:05Z"
  },
  {
    "videoId": "Um83o_qmRAw",
    "thumbnail": "https://i.ytimg.com/vi/Um83o_qmRAw/mqdefault.jpg",
    "title": "【夏まつch】おやすみのお昼はなにしてますか？【ASMR】",
    "publishedAt": "2018-08-19T08:34:26Z"
  },
  {
    "videoId": "peAGiR4pCVE",
    "thumbnail": "https://i.ytimg.com/vi/peAGiR4pCVE/mqdefault.jpg",
    "title": "【ASMR】ねむねむ・・・【夏まつch】",
    "publishedAt": "2018-09-02T16:01:59Z"
  },
  {
    "videoId": "T1tAcIsKWrg",
    "thumbnail": "https://i.ytimg.com/vi/T1tAcIsKWrg/mqdefault.jpg",
    "title": "【ホロライブ】マリオカート８DXで勝負！【ゲーム部プロジェクト】",
    "publishedAt": "2018-09-27T13:43:23Z"
  },
  {
    "videoId": "B36UmZMp7MA",
    "thumbnail": "https://i.ytimg.com/vi/B36UmZMp7MA/mqdefault.jpg",
    "title": "【雑談】げりらでおはなすの！！！！！！！",
    "publishedAt": "2018-10-18T15:36:37Z"
  },
  {
    "videoId": "NNzuZUccW3w",
    "thumbnail": "https://i.ytimg.com/vi/NNzuZUccW3w/mqdefault.jpg",
    "title": "【大食い】ミスドのドーナツ全種類たべる！？【VTuber】",
    "publishedAt": "2018-10-31T13:34:51Z"
  },
  {
    "videoId": "DQE2J9SqTrc",
    "thumbnail": "https://i.ytimg.com/vi/DQE2J9SqTrc/mqdefault.jpg",
    "title": "【VTuber】夏色まつりの新衣装発表だって！！見なきゃ！！！【５か月記念】【夏色まつり/ホロライブ】",
    "publishedAt": "2018-11-01T15:39:48Z"
  },
  {
    "videoId": "1mOL7Hi46h8",
    "thumbnail": "https://i.ytimg.com/vi/1mOL7Hi46h8/mqdefault.jpg",
    "title": "【歌ってみた】未練レコード／夏色まつり【ときのそら × 40mP】",
    "publishedAt": "2018-11-12T15:28:34Z"
  },
  {
    "videoId": "yZaivJy609A",
    "thumbnail": "https://i.ytimg.com/vi/yZaivJy609A/mqdefault.jpg",
    "title": "【２万人記念】起きたら何か生えていた件",
    "publishedAt": "2018-11-27T15:33:44Z"
  },
  {
    "videoId": "vZ0Pe__ETfc",
    "thumbnail": "https://i.ytimg.com/vi/vZ0Pe__ETfc/mqdefault.jpg",
    "title": "【半年記念】お耳を癒すにゃんにゃん配信♡【ASMR】",
    "publishedAt": "2018-12-02T15:34:09Z"
  },
  {
    "videoId": "lnfMtP4zrvk",
    "thumbnail": "https://i.ytimg.com/vi/lnfMtP4zrvk/mqdefault.jpg",
    "title": "ドキドキッ！初めてのスマブラ！#2【大乱闘スマッシュブラザーズ SPECIAL】",
    "publishedAt": "2018-12-13T15:35:08Z"
  },
  {
    "videoId": "nZ-g1pPNfts",
    "thumbnail": "https://i.ytimg.com/vi/nZ-g1pPNfts/mqdefault.jpg",
    "title": "【歌ってみた】好き！雪！本気マジック ／夏色まつり",
    "publishedAt": "2018-12-24T14:57:44Z"
  },
  {
    "videoId": "Q8E_PDynC1g",
    "thumbnail": "https://i.ytimg.com/vi/Q8E_PDynC1g/mqdefault.jpg",
    "title": "【雑談】２０１８年もあと少しだね！！！！",
    "publishedAt": "2018-12-29T14:37:34Z"
  },
  {
    "videoId": "kMPx3AHvwtA",
    "thumbnail": "https://i.ytimg.com/vi/kMPx3AHvwtA/mqdefault.jpg",
    "title": "【歌ってみた】お願いダーリン ／夏色まつり",
    "publishedAt": "2019-02-13T14:58:45Z"
  },
  {
    "videoId": "IW5b7btfayI",
    "thumbnail": "https://i.ytimg.com/vi/IW5b7btfayI/mqdefault.jpg",
    "title": "【ガチ母登場！？】赤裸々にいろいろ話す！",
    "publishedAt": "2019-02-26T13:32:29Z"
  },
  {
    "videoId": "INFI9FahPY0",
    "thumbnail": "https://i.ytimg.com/vi/INFI9FahPY0/mqdefault_live.jpg",
    "title": "🏮みんなの交流場🏮",
    "publishedAt": "2019-03-04T10:23:01Z"
  },
  {
    "videoId": "P2OmnlPzIcg",
    "thumbnail": "https://i.ytimg.com/vi/P2OmnlPzIcg/mqdefault.jpg",
    "title": "【APEX LEGENDS】初心者でもちゃんぽん食べたい！",
    "publishedAt": "2019-03-05T13:28:36Z"
  },
  {
    "videoId": "z2pWWKSPofA",
    "thumbnail": "https://i.ytimg.com/vi/z2pWWKSPofA/mqdefault.jpg",
    "title": "【歌ってみた】スイートマジック 【夏色まつり×紫咲シオン】",
    "publishedAt": "2019-03-13T14:58:43Z"
  },
  {
    "videoId": "nG7TJzkwMb4",
    "thumbnail": "https://i.ytimg.com/vi/nG7TJzkwMb4/mqdefault.jpg",
    "title": "【APEX LEGENDS】初心者のソロあぺあぺ",
    "publishedAt": "2019-03-14T15:35:13Z"
  },
  {
    "videoId": "u-hndx5mqIQ",
    "thumbnail": "https://i.ytimg.com/vi/u-hndx5mqIQ/mqdefault.jpg",
    "title": "【APEX LEGENDS】初心者２人の全力Apex!!!!!!!!!!!!!!!!!",
    "publishedAt": "2019-03-17T08:44:16Z"
  },
  {
    "videoId": "ChR1yxJBCjs",
    "thumbnail": "https://i.ytimg.com/vi/ChR1yxJBCjs/mqdefault.jpg",
    "title": "【APEX LEGENDS】巨〇たちのchampion",
    "publishedAt": "2019-03-21T13:23:16Z"
  },
  {
    "videoId": "wRyLH2EN0-U",
    "thumbnail": "https://i.ytimg.com/vi/wRyLH2EN0-U/mqdefault.jpg",
    "title": "【雑談】都会の女になったぜ！",
    "publishedAt": "2019-04-07T13:47:39Z"
  },
  {
    "videoId": "ZYJFZg80YPU",
    "thumbnail": "https://i.ytimg.com/vi/ZYJFZg80YPU/mqdefault.jpg",
    "title": "【雑談】新居大公開！？乙女のお部屋へようこそ",
    "publishedAt": "2019-04-12T13:32:49Z"
  },
  {
    "videoId": "7bh1PI06wXA",
    "thumbnail": "https://i.ytimg.com/vi/7bh1PI06wXA/mqdefault.jpg",
    "title": "【ドベは@まな板】本当の巨乳なのは誰だ！！【巨乳王】",
    "publishedAt": "2019-04-17T12:57:46Z"
  },
  {
    "videoId": "AX9LovWlMns",
    "thumbnail": "https://i.ytimg.com/vi/AX9LovWlMns/mqdefault.jpg",
    "title": "【APEX legends】野良でちゃんぽん獲るまでおわれまてん！！！",
    "publishedAt": "2019-04-20T07:40:12Z"
  },
  {
    "videoId": "u8JlVnXIz_Q",
    "thumbnail": "https://i.ytimg.com/vi/u8JlVnXIz_Q/mqdefault.jpg",
    "title": "【衝撃】きき昆虫食は出来るのか！？",
    "publishedAt": "2019-04-28T12:32:04Z"
  },
  {
    "videoId": "2uIE5ctDaHA",
    "thumbnail": "https://i.ytimg.com/vi/2uIE5ctDaHA/mqdefault.jpg",
    "title": "【雑談】実家に帰還した！！平成もおわりですな",
    "publishedAt": "2019-04-30T13:32:37Z"
  },
  {
    "videoId": "vWfBqDOd5Q8",
    "thumbnail": "https://i.ytimg.com/vi/vWfBqDOd5Q8/mqdefault.jpg",
    "title": "【雑談】天才清楚な天使とお話しましょ！",
    "publishedAt": "2019-05-07T13:36:51Z"
  },
  {
    "videoId": "ECo-ps8IP-M",
    "thumbnail": "https://i.ytimg.com/vi/ECo-ps8IP-M/mqdefault.jpg",
    "title": "夏色まつりの寝起きドッキリ【#ホロライブお泊り会】",
    "publishedAt": "2019-05-14T22:15:13Z"
  },
  {
    "videoId": "hCNd-sBOL04",
    "thumbnail": "https://i.ytimg.com/vi/hCNd-sBOL04/mqdefault.jpg",
    "title": "【雑談】みんなの心をいやすよ♡",
    "publishedAt": "2019-05-21T11:51:05Z"
  },
  {
    "videoId": "KnOctlFt88M",
    "thumbnail": "https://i.ytimg.com/vi/KnOctlFt88M/mqdefault.jpg",
    "title": "【地獄企画】嫌いなもの大食い選手権！！！！！！！！！！",
    "publishedAt": "2019-05-22T11:33:13Z"
  },
  {
    "videoId": "qxz8oMvTuqc",
    "thumbnail": "https://i.ytimg.com/vi/qxz8oMvTuqc/mqdefault.jpg",
    "title": "【第一回】リスナーさんとの作戦会議【まつりす大集合】",
    "publishedAt": "2019-05-26T10:31:52Z"
  },
  {
    "videoId": "3DFP_V9Kyn8",
    "thumbnail": "https://i.ytimg.com/vi/3DFP_V9Kyn8/mqdefault.jpg",
    "title": "【雑談】明日で１周年ってまじ？楽しく話す",
    "publishedAt": "2019-05-31T15:51:17Z"
  },
  {
    "videoId": "VehPJgAaR3k",
    "thumbnail": "https://i.ytimg.com/vi/VehPJgAaR3k/mqdefault.jpg",
    "title": "【大食い】二人なら１kgのステーキも余裕でしょ！",
    "publishedAt": "2019-06-04T05:25:12Z"
  },
  {
    "videoId": "KSd37WJ7g9M",
    "thumbnail": "https://i.ytimg.com/vi/KSd37WJ7g9M/mqdefault.jpg",
    "title": "【マリカ】7位以下で即終了！？マリオカート8DX！【VTuber】",
    "publishedAt": "2019-06-15T14:35:24Z"
  },
  {
    "videoId": "TT6gTs2B1Uw",
    "thumbnail": "https://i.ytimg.com/vi/TT6gTs2B1Uw/mqdefault.jpg",
    "title": "カタオモイ(Aimer)  /  夏色まつり cover",
    "publishedAt": "2019-06-25T11:58:14Z"
  },
  {
    "videoId": "mM9QSXnBBbI",
    "thumbnail": "https://i.ytimg.com/vi/mM9QSXnBBbI/mqdefault.jpg",
    "title": "【記念配信】1.4.5.6.7万人記念まとめて祝う！【VTuber】",
    "publishedAt": "2019-06-25T14:50:40Z"
  },
  {
    "videoId": "wD2fkUNitBw",
    "thumbnail": "https://i.ytimg.com/vi/wD2fkUNitBw/mqdefault.jpg",
    "title": "【晩酌？】甘酒飲みながらほわほわ話す！【VTuber】",
    "publishedAt": "2019-06-28T15:37:56Z"
  },
  {
    "videoId": "hGlbSxPDVW4",
    "thumbnail": "https://i.ytimg.com/vi/hGlbSxPDVW4/mqdefault.jpg",
    "title": "【VTuber】そろそろ夏がやってくる！【雑談】",
    "publishedAt": "2019-07-02T14:37:44Z"
  },
  {
    "videoId": "NNAtH_RCj5I",
    "thumbnail": "https://i.ytimg.com/vi/NNAtH_RCj5I/mqdefault.jpg",
    "title": "【#マリホロメーカー】初めてのマリオメーカー２！みんなと遊べる楽しいマップつくる！【VTuber】",
    "publishedAt": "2019-07-04T15:39:08Z"
  },
  {
    "videoId": "9NndiRjLtjk",
    "thumbnail": "https://i.ytimg.com/vi/9NndiRjLtjk/mqdefault.jpg",
    "title": "【#マリホロメーカー】世界のコースやっていく！鬼畜でもかかってこい！【VTuber】",
    "publishedAt": "2019-07-06T07:33:33Z"
  },
  {
    "videoId": "PJ8wu93L4lQ",
    "thumbnail": "https://i.ytimg.com/vi/PJ8wu93L4lQ/mqdefault.jpg",
    "title": "【寝起き】まつりとシオンの早起き競争【ドッキリ】",
    "publishedAt": "2019-07-07T00:26:07Z"
  },
  {
    "videoId": "ZT3LRX2Qa6o",
    "thumbnail": "https://i.ytimg.com/vi/ZT3LRX2Qa6o/mqdefault.jpg",
    "title": "【雑談】こしょこしょおはなしする【VTuber】",
    "publishedAt": "2019-07-14T15:34:28Z"
  },
  {
    "videoId": "i4E_HkYycAY",
    "thumbnail": "https://i.ytimg.com/vi/i4E_HkYycAY/mqdefault.jpg",
    "title": "【８万人記念】これからも止まらねぇぞ・・・！【雑談】",
    "publishedAt": "2019-07-16T15:37:28Z"
  },
  {
    "videoId": "-aCicd6UkE0",
    "thumbnail": "https://i.ytimg.com/vi/-aCicd6UkE0/mqdefault.jpg",
    "title": "【ファイナルフェス】えいえんの称号を手に入れるまで終われない！【VTuber】",
    "publishedAt": "2019-07-18T20:59:00Z"
  },
  {
    "videoId": "e6s8ee4hj30",
    "thumbnail": "https://i.ytimg.com/vi/e6s8ee4hj30/mqdefault.jpg",
    "title": "【雑談】ホロライブの清楚代表はこの私♡【ホロライブ/夏色まつり】",
    "publishedAt": "2019-07-19T15:37:55Z"
  },
  {
    "videoId": "SPqDQMUVglY",
    "thumbnail": "https://i.ytimg.com/vi/SPqDQMUVglY/mqdefault.jpg",
    "title": "【誕生日】みんなでまつりが生まれた日をむかえたい！【カウントダウン】",
    "publishedAt": "2019-07-21T16:31:21Z"
  },
  {
    "videoId": "jcCGvpvxqVQ",
    "thumbnail": "https://i.ytimg.com/vi/jcCGvpvxqVQ/mqdefault.jpg",
    "title": "【誕生日！】愛言葉Ⅲ／夏色まつり cover",
    "publishedAt": "2019-07-22T13:12:49Z"
  },
  {
    "videoId": "D5FI94dDbNQ",
    "thumbnail": "https://i.ytimg.com/vi/D5FI94dDbNQ/mqdefault.jpg",
    "title": "【雑談】お土産話を持って帰ってくるからな！【VTuber】",
    "publishedAt": "2019-08-01T13:30:57Z"
  },
  {
    "videoId": "xpUQ-5dSJTk",
    "thumbnail": "https://i.ytimg.com/vi/xpUQ-5dSJTk/mqdefault.jpg",
    "title": "【HoneyWorks】ファンサ／夏色まつり cover",
    "publishedAt": "2019-08-03T12:58:14Z"
  },
  {
    "videoId": "u-ijT1HTFt4",
    "thumbnail": "https://i.ytimg.com/vi/u-ijT1HTFt4/mqdefault.jpg",
    "title": "【雑談】家に帰れなくて泣いたんだが？？？？？？？？？【VTuber】",
    "publishedAt": "2019-08-06T18:51:15Z"
  },
  {
    "videoId": "Q9iJ-dA4ucA",
    "thumbnail": "https://i.ytimg.com/vi/Q9iJ-dA4ucA/mqdefault.jpg",
    "title": "【雑談】明日から24時間配信なんだが？コミケはどうだい？【VTuber】",
    "publishedAt": "2019-08-10T15:31:33Z"
  },
  {
    "videoId": "p6xpyHjbHW0",
    "thumbnail": "https://i.ytimg.com/vi/p6xpyHjbHW0/mqdefault.jpg",
    "title": "【記念】9万人を祝ってくれないか！？【雑談】",
    "publishedAt": "2019-08-26T15:41:15Z"
  },
  {
    "videoId": "E7Mf0OBm62Y",
    "thumbnail": "https://i.ytimg.com/vi/E7Mf0OBm62Y/mqdefault.jpg",
    "title": "【晩酌？】一番近い距離で一緒に乾杯しよっ！【ASMR】",
    "publishedAt": "2019-08-28T15:24:38Z"
  },
  {
    "videoId": "0Dr_qvnXJPE",
    "thumbnail": "https://i.ytimg.com/vi/0Dr_qvnXJPE/mqdefault.jpg",
    "title": "君の知らない物語(supercell) / 夏色まつり cover【アコギver】",
    "publishedAt": "2019-08-31T14:00:09Z"
  },
  {
    "videoId": "C4IATezjOoI",
    "thumbnail": "https://i.ytimg.com/vi/C4IATezjOoI/mqdefault.jpg",
    "title": "アカリがやってきたぞっ / 夏色まつり【歌ってみた】",
    "publishedAt": "2019-09-12T15:30:12Z"
  },
  {
    "videoId": "zUAoqdJvcHk",
    "thumbnail": "https://i.ytimg.com/vi/zUAoqdJvcHk/mqdefault.jpg",
    "title": "【にじさんじ×ホロライブ】TVアニメ「ダンベル何キロ持てる？」OP　お願いマッスル【社築×夏色まつり】",
    "publishedAt": "2019-09-15T13:00:14Z"
  },
  {
    "videoId": "DR2yzt-opgw",
    "thumbnail": "https://i.ytimg.com/vi/DR2yzt-opgw/mqdefault.jpg",
    "title": "【空気読み。３】女社会で生きていくには空気を読むしかないらしい。【ホロライブ/夏色まつり】",
    "publishedAt": "2019-09-20T15:32:46Z"
  },
  {
    "videoId": "GG_l80iUpQ0",
    "thumbnail": "https://i.ytimg.com/vi/GG_l80iUpQ0/mqdefault.jpg",
    "title": "【雑談】遊ぼうぜ。いいぜぇ【ホロライブ/夏色まつり】",
    "publishedAt": "2019-09-21T15:37:49Z"
  },
  {
    "videoId": "CWlf9uNvvyU",
    "thumbnail": "https://i.ytimg.com/vi/CWlf9uNvvyU/mqdefault.jpg",
    "title": "【雑談】きゅうりを食べていきていく。【ホロライブ/夏色まつり】",
    "publishedAt": "2019-09-24T15:38:13Z"
  },
  {
    "videoId": "TKvs2Auq_SI",
    "thumbnail": "https://i.ytimg.com/vi/TKvs2Auq_SI/mqdefault.jpg",
    "title": "【ガストコラボ】カレーうどんでぷるぷるする夏色まつり【#ホロの美食紀行 第1部】",
    "publishedAt": "2019-09-27T10:00:04Z"
  },
  {
    "videoId": "-SKFvgSPb6E",
    "thumbnail": "https://i.ytimg.com/vi/-SKFvgSPb6E/mqdefault.jpg",
    "title": "【新人VTuber爆誕！？】夏色まつ彦くん単独配信。【ホロライブ/夏色まつり】",
    "publishedAt": "2019-09-27T15:31:25Z"
  },
  {
    "videoId": "rqTXW-0WxAg",
    "thumbnail": "https://i.ytimg.com/vi/rqTXW-0WxAg/mqdefault.jpg",
    "title": "【朝活】おはよう！！起きれてえらい！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-09-30T00:27:38Z"
  },
  {
    "videoId": "cNJZg34Yzeo",
    "thumbnail": "https://i.ytimg.com/vi/cNJZg34Yzeo/mqdefault.jpg",
    "title": "【雑談】ガチ恋距離でまったりお話する！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-04T15:35:23Z"
  },
  {
    "videoId": "hRGU2UEh3Qo",
    "thumbnail": "https://i.ytimg.com/vi/hRGU2UEh3Qo/mqdefault.jpg",
    "title": "マリーゴールド(あいみょん) / 夏色まつり cover",
    "publishedAt": "2019-10-06T14:00:11Z"
  },
  {
    "videoId": "zGd6EEMcr3c",
    "thumbnail": "https://i.ytimg.com/vi/zGd6EEMcr3c/mqdefault.jpg",
    "title": "【おはよう】起きないと遅刻するぞ！！！！！朝活！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-09T00:30:41Z"
  },
  {
    "videoId": "9S-OPompzX0",
    "thumbnail": "https://i.ytimg.com/vi/9S-OPompzX0/mqdefault.jpg",
    "title": "【朝活】おはよおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおお【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-16T00:34:38Z"
  },
  {
    "videoId": "17isoDag4bk",
    "thumbnail": "https://i.ytimg.com/vi/17isoDag4bk/mqdefault.jpg",
    "title": "【雑談】今年もあと２ヶ月もないのでこれからのこといろいろ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-16T15:32:55Z"
  },
  {
    "videoId": "7U1RI3pv18k",
    "thumbnail": "https://i.ytimg.com/vi/7U1RI3pv18k/mqdefault.jpg",
    "title": "【APEX LEGENDS】５億年ぶりに戦地におりたったJK【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-18T15:37:03Z"
  },
  {
    "videoId": "S2zPuSefEHA",
    "thumbnail": "https://i.ytimg.com/vi/S2zPuSefEHA/mqdefault.jpg",
    "title": "【朝活】土曜日の朝に起きれるって天才じゃないか？【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-19T01:24:24Z"
  },
  {
    "videoId": "yhI46CrFGOI",
    "thumbnail": "https://i.ytimg.com/vi/yhI46CrFGOI/mqdefault.jpg",
    "title": "【ネタ動画】一発芸【ホロライブ/夏色まつり】",
    "publishedAt": "2019-10-21T18:33:27Z"
  },
  {
    "videoId": "XYxndf2Nt_s",
    "thumbnail": "https://i.ytimg.com/vi/XYxndf2Nt_s/mqdefault.jpg",
    "title": "【ネタ動画】VTuberの学習能力ってすごい！スキップ編【犬山たまき/夏色まつり】",
    "publishedAt": "2019-11-02T19:09:52Z"
  },
  {
    "videoId": "KFJ1UNcgc1o",
    "thumbnail": "https://i.ytimg.com/vi/KFJ1UNcgc1o/mqdefault.jpg",
    "title": "【マリカ8D】CPU相手なら１位余裕なんだがｗｗｗｗｗ？【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-03T14:43:36Z"
  },
  {
    "videoId": "k_cQMMIqD5M",
    "thumbnail": "https://i.ytimg.com/vi/k_cQMMIqD5M/mqdefault.jpg",
    "title": "【記念配信】すごくおめでたいね！この日を迎えられてうれしい！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-04T15:36:05Z"
  },
  {
    "videoId": "-bPgb4Fb1yc",
    "thumbnail": "https://i.ytimg.com/vi/-bPgb4Fb1yc/mqdefault.jpg",
    "title": "【視聴者参加型】まつりと走りたい？追いつけるかな？ｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-07T15:42:36Z"
  },
  {
    "videoId": "b14yzGF5gTw",
    "thumbnail": "https://i.ytimg.com/vi/b14yzGF5gTw/mqdefault.jpg",
    "title": "【マリカホロライブ杯】前回のホロライブ杯で1位をとった女は何位になれるのか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-10T12:23:48Z"
  },
  {
    "videoId": "swEXYxRIP9o",
    "thumbnail": "https://i.ytimg.com/vi/swEXYxRIP9o/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】ガチで太ったんです。服が入らなくなるんです・・・【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-10T13:55:37Z"
  },
  {
    "videoId": "Q5Y1gUGrsU4",
    "thumbnail": "https://i.ytimg.com/vi/Q5Y1gUGrsU4/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】筋肉痛やばすぎて発狂しながら運動します【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-11T13:29:21Z"
  },
  {
    "videoId": "fYGxaAUSdZw",
    "thumbnail": "https://i.ytimg.com/vi/fYGxaAUSdZw/mqdefault.jpg",
    "title": "【視聴者参加型】互いのリスナーを仲間につけろ！マリカー大戦！！【宝鐘マリン/夏色まつり】",
    "publishedAt": "2019-11-13T15:52:00Z"
  },
  {
    "videoId": "JJSet28IRKE",
    "thumbnail": "https://i.ytimg.com/vi/JJSet28IRKE/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】わからせ企画！？負荷１でイキる女が負荷３０強制体験！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-11-15T14:34:27Z"
  },
  {
    "videoId": "sz6V9PknsXM",
    "thumbnail": "https://i.ytimg.com/vi/sz6V9PknsXM/mqdefault.jpg",
    "title": "【鬼畜企画】発狂しまくり！？きのことるたびハイテンションｗｗｗ【星川サラ/夏色まつり】",
    "publishedAt": "2019-11-29T13:31:36Z"
  },
  {
    "videoId": "tuUMgRsPiAM",
    "thumbnail": "https://i.ytimg.com/vi/tuUMgRsPiAM/mqdefault.jpg",
    "title": "Maths VTuber over 9000 level meme",
    "publishedAt": "2019-11-30T09:54:23Z"
  },
  {
    "videoId": "iq88lVOLN30",
    "thumbnail": "https://i.ytimg.com/vi/iq88lVOLN30/mqdefault.jpg",
    "title": "【Super Bunny Man】黒上様とまつ彦くんのクールコンビがカオスなゲームにチャレンジ！？【白上フブキ/夏色まつり】",
    "publishedAt": "2019-12-04T14:35:42Z"
  },
  {
    "videoId": "_cnvBYkCOVA",
    "thumbnail": "https://i.ytimg.com/vi/_cnvBYkCOVA/mqdefault.jpg",
    "title": "【雑談】あなたとは終わりね！！実家に帰らせていただきます！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-12-05T04:38:37Z"
  },
  {
    "videoId": "hPi3mUGZGVE",
    "thumbnail": "https://i.ytimg.com/vi/hPi3mUGZGVE/mqdefault.jpg",
    "title": "🐱Nyan🐱",
    "publishedAt": "2019-12-06T14:45:38Z"
  },
  {
    "videoId": "MNcnT8wBcdw",
    "thumbnail": "https://i.ytimg.com/vi/MNcnT8wBcdw/mqdefault.jpg",
    "title": "心做し / 夏色まつり cover【オリジナルPV/4K】",
    "publishedAt": "2019-12-13T15:00:16Z"
  },
  {
    "videoId": "7ghsoMuzOjE",
    "thumbnail": "https://i.ytimg.com/vi/7ghsoMuzOjE/mqdefault.jpg",
    "title": "【#ホロライブすぷら部】5億年ぶりのスプラ！大会もうすぐ！こそ練すっぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-12-15T03:04:12Z"
  },
  {
    "videoId": "JP2VR0NEggo",
    "thumbnail": "https://i.ytimg.com/vi/JP2VR0NEggo/mqdefault.jpg",
    "title": "【#ホロライブスプラ部】本番前夜！台パンしません！本当です！！嘘じゃないです！！【ホロライブ/夏色まつり】",
    "publishedAt": "2019-12-18T15:33:27Z"
  },
  {
    "videoId": "j84IEsVYGyE",
    "thumbnail": "https://i.ytimg.com/vi/j84IEsVYGyE/mqdefault.jpg",
    "title": "白日 / King Gnu (Covered by 夏色まつり&律可)",
    "publishedAt": "2019-12-21T14:00:14Z"
  },
  {
    "videoId": "VwLy4BBqul0",
    "thumbnail": "https://i.ytimg.com/vi/VwLy4BBqul0/mqdefault.jpg",
    "title": "【急募】サンタさんからプレゼントを無理やりにでももらう方法ｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2019-12-24T16:03:10Z"
  },
  {
    "videoId": "pKDJ6kc9vA8",
    "thumbnail": "https://i.ytimg.com/vi/pKDJ6kc9vA8/mqdefault.jpg",
    "title": "【神企画】まだ見ぬ新人を超勝手にキャラ付けしちゃう！？【ホロライブ/夏色まつり】",
    "publishedAt": "2019-12-26T13:46:29Z"
  },
  {
    "videoId": "Xt20gAtIX5s",
    "thumbnail": "https://i.ytimg.com/vi/Xt20gAtIX5s/mqdefault.jpg",
    "title": "【雑談】後輩に企業のガンと言われた女ｗｗｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2019-12-30T15:10:34Z"
  },
  {
    "videoId": "DHMUymmD-eE",
    "thumbnail": "https://i.ytimg.com/vi/DHMUymmD-eE/mqdefault.jpg",
    "title": "【新衣装お披露目】新衣装チキンレースｗｗこれくらいなら見せてもセーフやろｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-01-01T10:31:13Z"
  },
  {
    "videoId": "0LpwU4QqHLM",
    "thumbnail": "https://i.ytimg.com/vi/0LpwU4QqHLM/mqdefault.jpg",
    "title": "✟卍卍爆速女の大暴走！！7位以下で即終了マリカ卍卍✟",
    "publishedAt": "2020-01-07T13:42:57Z"
  },
  {
    "videoId": "TdVzrWISD-8",
    "thumbnail": "https://i.ytimg.com/vi/TdVzrWISD-8/mqdefault.jpg",
    "title": "【緊急事態】私たち、入れ替わってる！？愛の力で元に戻れ！！【白上フブキ/夏色まつり】",
    "publishedAt": "2020-02-05T13:41:14Z"
  },
  {
    "videoId": "V7zXmhLLV0U",
    "thumbnail": "https://i.ytimg.com/vi/V7zXmhLLV0U/mqdefault.jpg",
    "title": "【同時視聴】ホロライブの1stライブ！ここから始まるとまらない物語！【夏色まつり/友人A】",
    "publishedAt": "2020-02-09T12:31:44Z"
  },
  {
    "videoId": "9nD7aQ_cKAM",
    "thumbnail": "https://i.ytimg.com/vi/9nD7aQ_cKAM/mqdefault.jpg",
    "title": "【兎田ぺこら/さくらみこ】バレンタイン・キッス　歌ってみた【宝鐘マリン/夏色まつり】",
    "publishedAt": "2020-02-14T12:00:14Z"
  },
  {
    "videoId": "h_IOAKRgtDo",
    "thumbnail": "https://i.ytimg.com/vi/h_IOAKRgtDo/mqdefault.jpg",
    "title": "【謝罪】寝坊しました。本当にすみませんでした。",
    "publishedAt": "2020-02-21T05:41:42Z"
  },
  {
    "videoId": "nH9-Njvjm58",
    "thumbnail": "https://i.ytimg.com/vi/nH9-Njvjm58/mqdefault.jpg",
    "title": "【お披露目/雑談】新ビジュアルも可愛すぎる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-02-28T15:48:29Z"
  },
  {
    "videoId": "PQ-VwhRfNSo",
    "thumbnail": "https://i.ytimg.com/vi/PQ-VwhRfNSo/mqdefault.jpg",
    "title": "【雑談】推しとデートしたDTムーブ全開のオタクの話をきいてくれ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-03T08:12:33Z"
  },
  {
    "videoId": "d7v06WPysHQ",
    "thumbnail": "https://i.ytimg.com/vi/d7v06WPysHQ/mqdefault.jpg",
    "title": "【マリオカート8デラックス】晩酌マリカー！どきやがれぇｗｗｗ俺がホロライブだあああｗｗｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-07T15:41:24Z"
  },
  {
    "videoId": "aeHBnXLrlpY",
    "thumbnail": "https://i.ytimg.com/vi/aeHBnXLrlpY/mqdefault.jpg",
    "title": "【対談】後輩にうなぎをおごった件。私服チェック！？【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-03-17T16:28:15Z"
  },
  {
    "videoId": "DcWwNlCnNyg",
    "thumbnail": "https://i.ytimg.com/vi/DcWwNlCnNyg/mqdefault.jpg",
    "title": "【25万人記念】凸待ち0人？こっちからかけちまえばいいんだろ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-18T13:29:05Z"
  },
  {
    "videoId": "tj9yvSvVQ8s",
    "thumbnail": "https://i.ytimg.com/vi/tj9yvSvVQ8s/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】未来に生きるまつりは釣りで金を稼ぐのだ。【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-20T16:27:29Z"
  },
  {
    "videoId": "Uucrmm2RW1U",
    "thumbnail": "https://i.ytimg.com/vi/Uucrmm2RW1U/mqdefault.jpg",
    "title": "【スマブラSP】視聴者参加型！くそ雑魚だけど１勝くらいはできるよなぁ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-25T09:51:59Z"
  },
  {
    "videoId": "HwGFVwk6xlY",
    "thumbnail": "https://i.ytimg.com/vi/HwGFVwk6xlY/mqdefault.jpg",
    "title": "【あつ森】カブで一儲け！！絶対に負けたくない！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-29T13:55:00Z"
  },
  {
    "videoId": "XUilxF-KCig",
    "thumbnail": "https://i.ytimg.com/vi/XUilxF-KCig/mqdefault.jpg",
    "title": "【ショートアニメ】夏色まつりのいる日常【ホロライブ/夏色まつり】",
    "publishedAt": "2020-03-29T21:30:11Z"
  },
  {
    "videoId": "Eqi3627cozE",
    "thumbnail": "https://i.ytimg.com/vi/Eqi3627cozE/mqdefault.jpg",
    "title": "【同時視聴】アニメ「グレイプニル」第一話視聴会！【湊あくあ/宝鐘マリン/夏色まつり】",
    "publishedAt": "2020-04-05T15:30:20Z"
  },
  {
    "videoId": "SFAmcakroAo",
    "thumbnail": "https://i.ytimg.com/vi/SFAmcakroAo/mqdefault.jpg",
    "title": "【マリカ】卍７位以下で即終了！１時間余裕卍【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-06T14:41:38Z"
  },
  {
    "videoId": "ecuFlApASdQ",
    "thumbnail": "https://i.ytimg.com/vi/ecuFlApASdQ/mqdefault.jpg",
    "title": "【耐久】アプデまでにチャンピオンとれなかったら罰ゲーム【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-07T15:35:45Z"
  },
  {
    "videoId": "Tywbx0LcAwY",
    "thumbnail": "https://i.ytimg.com/vi/Tywbx0LcAwY/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】寝れないといわれますが本人は真面目に睡眠導入しようとしています。【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-07T18:15:58Z"
  },
  {
    "videoId": "zGqqVh1EPfA",
    "thumbnail": "https://i.ytimg.com/vi/zGqqVh1EPfA/mqdefault.jpg",
    "title": "【逆凸】3D晩酌！ガチ酔いしながら逆凸でうざ絡み！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-14T15:51:47Z"
  },
  {
    "videoId": "1KyLE_Ejf-U",
    "thumbnail": "https://i.ytimg.com/vi/1KyLE_Ejf-U/mqdefault.jpg",
    "title": "Preserved Roses / T.M.Revolution×水樹奈々(Covered by 夏色まつり&律可)",
    "publishedAt": "2020-04-18T11:00:12Z"
  },
  {
    "videoId": "49RQ_h0pwCM",
    "thumbnail": "https://i.ytimg.com/vi/49RQ_h0pwCM/mqdefault.jpg",
    "title": "【APEX】初心者ルーナたんをキャリーできるのか！？【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-04-18T17:37:22Z"
  },
  {
    "videoId": "aUKSBDPdd8k",
    "thumbnail": "https://i.ytimg.com/vi/aUKSBDPdd8k/mqdefault.jpg",
    "title": "【APEX】はじめてのランクマッチ！ビギナーズラックで勝利！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-20T09:35:15Z"
  },
  {
    "videoId": "vnQa8hQGlww",
    "thumbnail": "https://i.ytimg.com/vi/vnQa8hQGlww/mqdefault.jpg",
    "title": "【APEX】APEXにはまりまくったので朝活！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-21T04:36:55Z"
  },
  {
    "videoId": "6z2xdGk-64k",
    "thumbnail": "https://i.ytimg.com/vi/6z2xdGk-64k/mqdefault.jpg",
    "title": "【APEX】FPSやめられないんだけど～ｗｗハンマーほしいんです～；；【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-24T06:36:21Z"
  },
  {
    "videoId": "AkpEj-uSV4Q",
    "thumbnail": "https://i.ytimg.com/vi/AkpEj-uSV4Q/mqdefault.jpg",
    "title": "【マリカ】7位以下で□リ化!?かわいければスナイプ勢が動揺して勝てる説【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-26T15:52:28Z"
  },
  {
    "videoId": "4KfH8wRkjZA",
    "thumbnail": "https://i.ytimg.com/vi/4KfH8wRkjZA/mqdefault.jpg",
    "title": "【APEX】ちゃんぽんちゃれんじ！？つっこむぞおおおおおおおお【姫森ルーナ/星街すいせい/夏色まつり】",
    "publishedAt": "2020-04-27T12:45:14Z"
  },
  {
    "videoId": "jUZxojSCXaM",
    "thumbnail": "https://i.ytimg.com/vi/jUZxojSCXaM/mqdefault.jpg",
    "title": "【APEX】ほかのメンバーをキャリーできるようになりたい！こそ練！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-28T05:53:50Z"
  },
  {
    "videoId": "1lndcGr-qAA",
    "thumbnail": "https://i.ytimg.com/vi/1lndcGr-qAA/mqdefault.jpg",
    "title": "【まったり】スパチャをありがとうする！うれしいからね！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-04-29T07:37:24Z"
  },
  {
    "videoId": "xQjsa-06O4I",
    "thumbnail": "https://i.ytimg.com/vi/xQjsa-06O4I/mqdefault.jpg",
    "title": "【白銀ノエル/姫森ルーナ】マリカー真剣ボムヘイバトルで大騒ぎ！？【星街すいせい/夏色まつり】",
    "publishedAt": "2020-04-30T13:28:59Z"
  },
  {
    "videoId": "dsdpK6Vm0ig",
    "thumbnail": "https://i.ytimg.com/vi/dsdpK6Vm0ig/mqdefault.jpg",
    "title": "【凸待ち】今□リ化流行ってるし誘えばホロライブ□リ組がきてくれるのでは！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-02T00:40:06Z"
  },
  {
    "videoId": "GOS-KUPGKrM",
    "thumbnail": "https://i.ytimg.com/vi/GOS-KUPGKrM/mqdefault.jpg",
    "title": "【APEX】今日も今日とて超エンジョイ！【姫森ルーナ/白上フブキ/夏色まつり】",
    "publishedAt": "2020-05-06T07:53:24Z"
  },
  {
    "videoId": "tS_Bks2jKJA",
    "thumbnail": "https://i.ytimg.com/vi/tS_Bks2jKJA/mqdefault.jpg",
    "title": "【APEX】はじめてのAPEXどうすれば楽しませられる！？【犬山たまき/夏色まつり】",
    "publishedAt": "2020-05-07T12:49:21Z"
  },
  {
    "videoId": "SGymJ14fopQ",
    "thumbnail": "https://i.ytimg.com/vi/SGymJ14fopQ/mqdefault.jpg",
    "title": "【APEX】ソロでチャンピオン取るまで終われない！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-08T13:57:54Z"
  },
  {
    "videoId": "djXjBGRDhWE",
    "thumbnail": "https://i.ytimg.com/vi/djXjBGRDhWE/mqdefault.jpg",
    "title": "【APEX】ばちぼこにあそぶのがこのゲーム【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-11T18:14:11Z"
  },
  {
    "videoId": "BRgka4ZHMww",
    "thumbnail": "https://i.ytimg.com/vi/BRgka4ZHMww/mqdefault.jpg",
    "title": "【APEX】パスファインダーはでるのか！？100連ガチャ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-12T14:34:01Z"
  },
  {
    "videoId": "akTHtRPRjIE",
    "thumbnail": "https://i.ytimg.com/vi/akTHtRPRjIE/mqdefault.jpg",
    "title": "【APEX】シーズン5はじまります！スタートダッシュ！【白上フブキ/夏色まつり】",
    "publishedAt": "2020-05-12T19:55:08Z"
  },
  {
    "videoId": "xjF5-uGluRI",
    "thumbnail": "https://i.ytimg.com/vi/xjF5-uGluRI/mqdefault.jpg",
    "title": "【APEX】星色組でぼこぼこにするぞッ♡【星川サラ/夏色まつり】",
    "publishedAt": "2020-05-14T12:24:26Z"
  },
  {
    "videoId": "lMNuQML_BIk",
    "thumbnail": "https://i.ytimg.com/vi/lMNuQML_BIk/mqdefault.jpg",
    "title": "【APEX】エンジョイランク戦！ゴールドの敵強すぎん？？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-17T15:37:11Z"
  },
  {
    "videoId": "AzGuNUVp1yg",
    "thumbnail": "https://i.ytimg.com/vi/AzGuNUVp1yg/mqdefault.jpg",
    "title": "【APEX】初心者でも安心！APEXでまずすること！【アキロゼ/夏色まつり】",
    "publishedAt": "2020-05-18T17:46:59Z"
  },
  {
    "videoId": "NvDCj6XkhqE",
    "thumbnail": "https://i.ytimg.com/vi/NvDCj6XkhqE/mqdefault.jpg",
    "title": "【耐久】APEXでプラチナに行くまで終われない！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-19T06:53:44Z"
  },
  {
    "videoId": "qrqbqhSu9jE",
    "thumbnail": "https://i.ytimg.com/vi/qrqbqhSu9jE/mqdefault.jpg",
    "title": "【APEX】リベンジ100連！運を味方にスパレジェをひく！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-20T07:49:48Z"
  },
  {
    "videoId": "KfzT1h_eshw",
    "thumbnail": "https://i.ytimg.com/vi/KfzT1h_eshw/mqdefault.jpg",
    "title": "【APEX】俺たちはクールに勝つぜ。逃げろおおおおおおおお！！！【天神子兎音/夏色まつり】",
    "publishedAt": "2020-05-21T16:41:39Z"
  },
  {
    "videoId": "m-mNZ1rRNPg",
    "thumbnail": "https://i.ytimg.com/vi/m-mNZ1rRNPg/mqdefault.jpg",
    "title": "【APEX】戦場デート！俺がこいつを守る！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-22T14:14:11Z"
  },
  {
    "videoId": "JUix0zkO09Y",
    "thumbnail": "https://i.ytimg.com/vi/JUix0zkO09Y/mqdefault.jpg",
    "title": "【APEX】ランクマッチ！プラチナ隊の洗礼を受けろ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-24T09:50:55Z"
  },
  {
    "videoId": "UxkreiYAiH4",
    "thumbnail": "https://i.ytimg.com/vi/UxkreiYAiH4/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】約束された筋肉痛。痩せるために俺は走る。【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-25T14:06:59Z"
  },
  {
    "videoId": "Rm-qKS6rhAM",
    "thumbnail": "https://i.ytimg.com/vi/Rm-qKS6rhAM/mqdefault.jpg",
    "title": "【APEX】我らの戦いは終わらない！目指せちゃんぽん！【潤羽るしあ/夏色まつり】",
    "publishedAt": "2020-05-29T14:49:07Z"
  },
  {
    "videoId": "eCSWRcFPj6Y",
    "thumbnail": "https://i.ytimg.com/vi/eCSWRcFPj6Y/mqdefault.jpg",
    "title": "【APEX】プラチナのどん底なう！あがりたいの極み【ロボ子さん/夏色まつり】",
    "publishedAt": "2020-05-30T07:33:39Z"
  },
  {
    "videoId": "ZGvb8QzrE3c",
    "thumbnail": "https://i.ytimg.com/vi/ZGvb8QzrE3c/mqdefault.jpg",
    "title": "【2周年】デビューして2年たつけど皆にどう思われてるの？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-05-31T15:48:41Z"
  },
  {
    "videoId": "6m0cP9Ehgck",
    "thumbnail": "https://i.ytimg.com/vi/6m0cP9Ehgck/mqdefault.jpg",
    "title": "【ガチャ】2周年だしAPEX200連ガチャ対決しないか？【白上フブキ/夏色まつり】",
    "publishedAt": "2020-06-01T14:03:10Z"
  },
  {
    "videoId": "UJoZ5stt1uc",
    "thumbnail": "https://i.ytimg.com/vi/UJoZ5stt1uc/mqdefault.jpg",
    "title": "【VALORANT】初めてのヴァロラント！どんなゲームなのか楽しみだねッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-03T06:45:52Z"
  },
  {
    "videoId": "QcQ5Tnqh8PM",
    "thumbnail": "https://i.ytimg.com/vi/QcQ5Tnqh8PM/mqdefault.jpg",
    "title": "【Human:Fall Flat】初心者をキャリーできる？激むずふにゃふにゃゲームに挑戦！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-03T14:18:52Z"
  },
  {
    "videoId": "NfhyLT2Mwh4",
    "thumbnail": "https://i.ytimg.com/vi/NfhyLT2Mwh4/mqdefault.jpg",
    "title": "【VALORANT】今日は何人倒せる？アタッカーまつり！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-05T05:36:38Z"
  },
  {
    "videoId": "KB2hJEKMxbo",
    "thumbnail": "https://i.ytimg.com/vi/KB2hJEKMxbo/mqdefault.jpg",
    "title": "【歌枠】きゅんきゅんしちゃう歌枠♡【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-05T15:27:49Z"
  },
  {
    "videoId": "_xN1688eWtc",
    "thumbnail": "https://i.ytimg.com/vi/_xN1688eWtc/mqdefault.jpg",
    "title": "【同時視聴】相席食堂！爆笑してる声を聴く配信。【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-06T13:55:06Z"
  },
  {
    "videoId": "5Xg-kNOKTjk",
    "thumbnail": "https://i.ytimg.com/vi/5Xg-kNOKTjk/mqdefault.jpg",
    "title": "【VALORANT】ヘッドショット【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-06-08T06:54:35Z"
  },
  {
    "videoId": "B9yS8e_e1HU",
    "thumbnail": "https://i.ytimg.com/vi/B9yS8e_e1HU/mqdefault.jpg",
    "title": "【APEX】久しぶりのAPEX！ワットソンパンチ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-09T11:31:36Z"
  },
  {
    "videoId": "T_CiAuQESlk",
    "thumbnail": "https://i.ytimg.com/vi/T_CiAuQESlk/mqdefault.jpg",
    "title": "【APEX】カービンが最強ってこと。【天神子兎音/癒月ちょこ/夏色まつり】",
    "publishedAt": "2020-06-09T15:59:07Z"
  },
  {
    "videoId": "MgB_pyZBybA",
    "thumbnail": "https://i.ytimg.com/vi/MgB_pyZBybA/mqdefault.jpg",
    "title": "【雀魂】視聴者VSまつり！勝利の一歩は鳴かないこと！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-09T18:09:33Z"
  },
  {
    "videoId": "8w-S0L_v6os",
    "thumbnail": "https://i.ytimg.com/vi/8w-S0L_v6os/mqdefault.jpg",
    "title": "【VALORANT】仲間同士でも戦いましょう！【アルランディス/夏色まつり】",
    "publishedAt": "2020-06-10T13:20:06Z"
  },
  {
    "videoId": "g_rpXG_QMP4",
    "thumbnail": "https://i.ytimg.com/vi/g_rpXG_QMP4/mqdefault.jpg",
    "title": "【APEX】夜活！！キルするぞぉ！！！【天神子兎音/夏色まつり】",
    "publishedAt": "2020-06-11T15:46:18Z"
  },
  {
    "videoId": "1HUnL1DZF9Y",
    "thumbnail": "https://i.ytimg.com/vi/1HUnL1DZF9Y/mqdefault.jpg",
    "title": "【APEX】久しぶりのランクマ！ワットソンパンチ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-13T08:11:58Z"
  },
  {
    "videoId": "cmhMgju-uP0",
    "thumbnail": "https://i.ytimg.com/vi/cmhMgju-uP0/mqdefault.jpg",
    "title": "【APEX】超鬼畜！モザビ＋ピストル縛り！！【姫森ルーナ/白上フブキ/夏色まつり】",
    "publishedAt": "2020-06-13T16:20:26Z"
  },
  {
    "videoId": "phGUYXm1e_I",
    "thumbnail": "https://i.ytimg.com/vi/phGUYXm1e_I/mqdefault.jpg",
    "title": "Colorful World  / 夏色まつりcover ( 1cho.ver )",
    "publishedAt": "2020-06-13T16:58:58Z"
  },
  {
    "videoId": "Ek5oHAWhxY4",
    "thumbnail": "https://i.ytimg.com/vi/Ek5oHAWhxY4/mqdefault.jpg",
    "title": "【歌枠】アイドルなんだからアイドルしちゃいますよッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-15T14:49:44Z"
  },
  {
    "videoId": "LMvQUIFvbzg",
    "thumbnail": "https://i.ytimg.com/vi/LMvQUIFvbzg/mqdefault.jpg",
    "title": "【地獄企画】厨二病って痛いっていうけど正直かっこいい。【荒咬オウガ/夏色まつり】",
    "publishedAt": "2020-06-17T15:06:49Z"
  },
  {
    "videoId": "RfFuTNcPP5U",
    "thumbnail": "https://i.ytimg.com/vi/RfFuTNcPP5U/mqdefault.jpg",
    "title": "【雀魂-じゃんたま-】リスナーより先にタンヤオする！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-18T15:25:04Z"
  },
  {
    "videoId": "APN3rNzfNnw",
    "thumbnail": "https://i.ytimg.com/vi/APN3rNzfNnw/mqdefault.jpg",
    "title": "【3Dライブ】2周年記念！今夜だけはまつりが主役！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-20T12:44:26Z"
  },
  {
    "videoId": "llv_1-WEQGg",
    "thumbnail": "https://i.ytimg.com/vi/llv_1-WEQGg/mqdefault.jpg",
    "title": "君と眺める夏の花 / 夏色まつり【オリジナル曲】",
    "publishedAt": "2020-06-20T13:15:03Z"
  },
  {
    "videoId": "MZm_Xy2zJq8",
    "thumbnail": "https://i.ytimg.com/vi/MZm_Xy2zJq8/mqdefault.jpg",
    "title": "「ぼくの夢、メチャクソ無限湧き」ARuFa / 夏色まつりcover",
    "publishedAt": "2020-06-27T11:00:14Z"
  },
  {
    "videoId": "xhCxOgKPsOw",
    "thumbnail": "https://i.ytimg.com/vi/xhCxOgKPsOw/mqdefault.jpg",
    "title": "【APEX】ライフラインの時代が来ました。テンション高めでお送りします。【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-30T10:33:20Z"
  },
  {
    "videoId": "UIZdCMBkGvs",
    "thumbnail": "https://i.ytimg.com/vi/UIZdCMBkGvs/mqdefault.jpg",
    "title": "【PIEN】ホラゲ苦手でもこれなら余裕でしょｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-06-30T14:38:37Z"
  },
  {
    "videoId": "CXT4MA9DE7g",
    "thumbnail": "https://i.ytimg.com/vi/CXT4MA9DE7g/mqdefault.jpg",
    "title": "【Minecraft】私たち、同居します。【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-07-01T11:08:20Z"
  },
  {
    "videoId": "0Fsmx98_6y0",
    "thumbnail": "https://i.ytimg.com/vi/0Fsmx98_6y0/mqdefault.jpg",
    "title": "【雀魂-じゃんたま-】平和にいこうよ！あ、それロンｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-02T16:52:55Z"
  },
  {
    "videoId": "FKPUxNw1YD4",
    "thumbnail": "https://i.ytimg.com/vi/FKPUxNw1YD4/mqdefault.jpg",
    "title": "【APEX】1時間で出したダメージ＝明日の食費！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-04T15:23:20Z"
  },
  {
    "videoId": "F6_lCfZL90I",
    "thumbnail": "https://i.ytimg.com/vi/F6_lCfZL90I/mqdefault.jpg",
    "title": "【Minecraft】今日から始まる同居生活！完成編！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-05T10:57:04Z"
  },
  {
    "videoId": "T1YVQ21K0lU",
    "thumbnail": "https://i.ytimg.com/vi/T1YVQ21K0lU/mqdefault.jpg",
    "title": "【APEX】キル【天神子兎音/夏色まつり】",
    "publishedAt": "2020-07-05T13:37:57Z"
  },
  {
    "videoId": "u4e-uPe7Jm4",
    "thumbnail": "https://i.ytimg.com/vi/u4e-uPe7Jm4/mqdefault.jpg",
    "title": "【40万人記念】鬼畜トークテーマで雑談！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-05T15:11:36Z"
  },
  {
    "videoId": "0vBL5id-IXk",
    "thumbnail": "https://i.ytimg.com/vi/0vBL5id-IXk/mqdefault.jpg",
    "title": "【歌枠】エモいアイドルは好きですよね！知ってます！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-06T15:50:33Z"
  },
  {
    "videoId": "k0Ob7JztJGw",
    "thumbnail": "https://i.ytimg.com/vi/k0Ob7JztJGw/mqdefault.jpg",
    "title": "【スパチャ読み】最近の話とかしつつスパチャよみまする～！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-09T11:19:56Z"
  },
  {
    "videoId": "9fUMPjSzC7Q",
    "thumbnail": "https://i.ytimg.com/vi/9fUMPjSzC7Q/mqdefault.jpg",
    "title": "【APEX】倒す【星川サラ/郡道美玲/夏色まつり】",
    "publishedAt": "2020-07-10T11:07:40Z"
  },
  {
    "videoId": "-SbB25mB8XQ",
    "thumbnail": "https://i.ytimg.com/vi/-SbB25mB8XQ/mqdefault.jpg",
    "title": "【歌枠】二人の可愛さにガチ恋不可避！【夜空メル/夏色まつり】",
    "publishedAt": "2020-07-10T14:55:45Z"
  },
  {
    "videoId": "mIvQfU2GxW0",
    "thumbnail": "https://i.ytimg.com/vi/mIvQfU2GxW0/mqdefault.jpg",
    "title": "【マイクラらぶらぶ計画♡】嫉妬の激情に呑まれたルーナ姫に許してもらうためにある計画を始める....！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-12T10:34:10Z"
  },
  {
    "videoId": "Wi_C3GzlVGo",
    "thumbnail": "https://i.ytimg.com/vi/Wi_C3GzlVGo/mqdefault.jpg",
    "title": "【対談】かわいい女は大体あたおか？【幽ヶ崎海愛/夏色まつり】",
    "publishedAt": "2020-07-12T14:04:04Z"
  },
  {
    "videoId": "n7TnDUBEGvU",
    "thumbnail": "https://i.ytimg.com/vi/n7TnDUBEGvU/mqdefault.jpg",
    "title": "【同時視聴】ゴーストシャークってどんなサメ？【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-07-12T17:13:23Z"
  },
  {
    "videoId": "LZ6ftB11LzM",
    "thumbnail": "https://i.ytimg.com/vi/LZ6ftB11LzM/mqdefault.jpg",
    "title": "【Minecraft】一緒にダイヤを探す！って思うじゃん・・・？【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-07-13T06:12:52Z"
  },
  {
    "videoId": "0hI_SLrIXLE",
    "thumbnail": "https://i.ytimg.com/vi/0hI_SLrIXLE/mqdefault.jpg",
    "title": "【APEX】超最強女にちゃんぽんごちそうしてもらえるってマ？【神成きゅぴ/夏色まつり】",
    "publishedAt": "2020-07-13T11:26:24Z"
  },
  {
    "videoId": "Dq62N0N8qnU",
    "thumbnail": "https://i.ytimg.com/vi/Dq62N0N8qnU/mqdefault.jpg",
    "title": "【APEX】えんじょいの日【聖女れりあ/律可/夏色まつり】",
    "publishedAt": "2020-07-16T18:06:51Z"
  },
  {
    "videoId": "FjCvQ0CzNz8",
    "thumbnail": "https://i.ytimg.com/vi/FjCvQ0CzNz8/mqdefault.jpg",
    "title": "【APEX】なにがとは言わないがまつりは進化シールド。【花京院ちえり/夏色まつり】",
    "publishedAt": "2020-07-17T16:58:18Z"
  },
  {
    "videoId": "QWjZ87GcvHI",
    "thumbnail": "https://i.ytimg.com/vi/QWjZ87GcvHI/mqdefault.jpg",
    "title": "【Minecraft】～睡眠導入～整地とかご飯つくったりとか！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-17T22:12:44Z"
  },
  {
    "videoId": "4b1GxrN4QPM",
    "thumbnail": "https://i.ytimg.com/vi/4b1GxrN4QPM/mqdefault.jpg",
    "title": "【歌枠】おうち3Dでかわいく歌うよ✌【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-18T15:07:53Z"
  },
  {
    "videoId": "brXrIIQFQJ0",
    "thumbnail": "https://i.ytimg.com/vi/brXrIIQFQJ0/mqdefault.jpg",
    "title": "【Minecraft】～睡眠導入～鉄不足！たくさん掘るよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-18T18:28:01Z"
  },
  {
    "videoId": "NqMDDXE85nU",
    "thumbnail": "https://i.ytimg.com/vi/NqMDDXE85nU/mqdefault.jpg",
    "title": "【APEX】大会に出ることになりました！ランクもあげたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-20T10:18:33Z"
  },
  {
    "videoId": "KMuggh_NyX4",
    "thumbnail": "https://i.ytimg.com/vi/KMuggh_NyX4/mqdefault.jpg",
    "title": "【雀魂-じゃんたま-】今日はエンジョイ日！ロンする～！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-20T15:32:05Z"
  },
  {
    "videoId": "HhJw0Lq5Tko",
    "thumbnail": "https://i.ytimg.com/vi/HhJw0Lq5Tko/mqdefault.jpg",
    "title": "【誕生日カウントダウン】君と一緒に誕生日を迎えたい！お祝いしてくれますか？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-21T15:21:46Z"
  },
  {
    "videoId": "LPpDDSajl1M",
    "thumbnail": "https://i.ytimg.com/vi/LPpDDSajl1M/mqdefault.jpg",
    "title": "ヤングドーナツのうた / #夏色吹雪 cover",
    "publishedAt": "2020-07-22T03:00:07Z"
  },
  {
    "videoId": "bxy2oLe7VwU",
    "thumbnail": "https://i.ytimg.com/vi/bxy2oLe7VwU/mqdefault.jpg",
    "title": "【#夏色まつり誕生祭3D】🏮夏色まつり誕生祭2020🏮本日の主役はこのまつり！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-22T12:24:12Z"
  },
  {
    "videoId": "yOBFiOEXzDI",
    "thumbnail": "https://i.ytimg.com/vi/yOBFiOEXzDI/mqdefault.jpg",
    "title": "【APEX】僕、ついていく。てちてち【かわせ/夏色まつり】",
    "publishedAt": "2020-07-23T17:17:05Z"
  },
  {
    "videoId": "g2InKgUPAA4",
    "thumbnail": "https://i.ytimg.com/vi/g2InKgUPAA4/mqdefault.jpg",
    "title": "【新live2Dお披露目会】生まれ変わったまつりを見て！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-28T14:40:16Z"
  },
  {
    "videoId": "GB2Up8pUWbA",
    "thumbnail": "https://i.ytimg.com/vi/GB2Up8pUWbA/mqdefault.jpg",
    "title": "【Project Winter】雪山に遊びに来ただけだったのに・・・【ホロライブ/夏色まつり】",
    "publishedAt": "2020-07-29T11:48:10Z"
  },
  {
    "videoId": "OBUtLsPmelo",
    "thumbnail": "https://i.ytimg.com/vi/OBUtLsPmelo/mqdefault.jpg",
    "title": "【APEX】深夜の最協決定戦練習会【百鬼あやめ/夏色まつり】",
    "publishedAt": "2020-07-30T19:14:45Z"
  },
  {
    "videoId": "6FgTwX8htSA",
    "thumbnail": "https://i.ytimg.com/vi/6FgTwX8htSA/mqdefault.jpg",
    "title": "【#VTuber最協決定戦】我らハッピーセット！練習【ロボ子さん/百鬼あやめ/夏色まつり】",
    "publishedAt": "2020-08-02T08:41:13Z"
  },
  {
    "videoId": "fs-p-j6eXb4",
    "thumbnail": "https://i.ytimg.com/vi/fs-p-j6eXb4/mqdefault.jpg",
    "title": "【#VTuber最協決定戦】我らハッピーセット！本番【ロボ子さん/百鬼あやめ/夏色まつり】",
    "publishedAt": "2020-08-02T12:46:26Z"
  },
  {
    "videoId": "HZ6rFJkTsc8",
    "thumbnail": "https://i.ytimg.com/vi/HZ6rFJkTsc8/mqdefault.jpg",
    "title": "【#VTuber最協決定戦】後夜祭！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-02T17:35:42Z"
  },
  {
    "videoId": "EGBirYfGPgI",
    "thumbnail": "https://i.ytimg.com/vi/EGBirYfGPgI/mqdefault.jpg",
    "title": "#たんもしライブ『探偵はもう、死んでいる。』紹介しちゃうぞ！",
    "publishedAt": "2020-08-04T12:06:09Z"
  },
  {
    "videoId": "b-ZVPej1Vso",
    "thumbnail": "https://i.ytimg.com/vi/b-ZVPej1Vso/mqdefault.jpg",
    "title": "【Minecraft】相方と眠くなるまでなんかする【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-08-04T17:33:37Z"
  },
  {
    "videoId": "3ZyXmrFNaDY",
    "thumbnail": "https://i.ytimg.com/vi/3ZyXmrFNaDY/mqdefault.jpg",
    "title": "【APEX】ランク！！めざせダイヤ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-05T08:17:36Z"
  },
  {
    "videoId": "Yx4CGLjxFzc",
    "thumbnail": "https://i.ytimg.com/vi/Yx4CGLjxFzc/mqdefault.jpg",
    "title": "【歌枠】夏だ！歌だ！アイドルだ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-05T14:29:28Z"
  },
  {
    "videoId": "xu0BUNcUNr8",
    "thumbnail": "https://i.ytimg.com/vi/xu0BUNcUNr8/mqdefault.jpg",
    "title": "【Minecraft】～睡眠導入～相方のためになにかするやつ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-05T17:51:38Z"
  },
  {
    "videoId": "7u1sErfii7M",
    "thumbnail": "https://i.ytimg.com/vi/7u1sErfii7M/mqdefault.jpg",
    "title": "寝起きチャレンジ失敗!【APEX】ソロランクの洗礼に打ちひしがれる女！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-06T08:42:40Z"
  },
  {
    "videoId": "Z7VCpaixat4",
    "thumbnail": "https://i.ytimg.com/vi/Z7VCpaixat4/mqdefault.jpg",
    "title": "【雑談】５億年ぶりにまったりお話しない！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-07T15:34:03Z"
  },
  {
    "videoId": "JHuR-x4OJVE",
    "thumbnail": "https://i.ytimg.com/vi/JHuR-x4OJVE/mqdefault.jpg",
    "title": "【APEX】カジュアルでちゃんぽんとる！！【天神子兎音/夏色まつり】",
    "publishedAt": "2020-08-07T17:42:02Z"
  },
  {
    "videoId": "DMFcYR-TyGI",
    "thumbnail": "https://i.ytimg.com/vi/DMFcYR-TyGI/mqdefault.jpg",
    "title": "【世界のアソビ大全51】世界を遊びつくす女になるぜ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-09T13:00:08Z"
  },
  {
    "videoId": "JCiX0SWbFQo",
    "thumbnail": "https://i.ytimg.com/vi/JCiX0SWbFQo/mqdefault.jpg",
    "title": "【APEX】1時間で出したダメージ＝明日の食費！贅沢orもやし？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-10T11:35:50Z"
  },
  {
    "videoId": "QWZIwFxTQps",
    "thumbnail": "https://i.ytimg.com/vi/QWZIwFxTQps/mqdefault.jpg",
    "title": "【APEX】褒められて伸びますねぇ～！【杏戸ゆげ/不磨わっと/夏色まつり】",
    "publishedAt": "2020-08-12T16:26:33Z"
  },
  {
    "videoId": "HjZjy6jG3IQ",
    "thumbnail": "https://i.ytimg.com/vi/HjZjy6jG3IQ/mqdefault.jpg",
    "title": "【歌枠】50万人いくまで歌います！！見届けるぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-14T05:04:14Z"
  },
  {
    "videoId": "DYMUtrrkZrY",
    "thumbnail": "https://i.ytimg.com/vi/DYMUtrrkZrY/mqdefault.jpg",
    "title": "【Fall Guys】ガチギレ注意！？I am No.1！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-14T12:02:32Z"
  },
  {
    "videoId": "No3QRIr0GOM",
    "thumbnail": "https://i.ytimg.com/vi/No3QRIr0GOM/mqdefault.jpg",
    "title": "【Minecraft】どうぶつさんたち大集合だわいわい♡【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-08-14T18:39:23Z"
  },
  {
    "videoId": "ezMtFkAI90U",
    "thumbnail": "https://i.ytimg.com/vi/ezMtFkAI90U/mqdefault.jpg",
    "title": "【Fall Guys】清楚に戦いまｓあ、おい！触るな！！てめぇ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-16T15:29:47Z"
  },
  {
    "videoId": "YPb3mcUWPIk",
    "thumbnail": "https://i.ytimg.com/vi/YPb3mcUWPIk/mqdefault.jpg",
    "title": "【Fall Guys】仲いいので協力します✌【杏戸ゆげ/夏色まつり】",
    "publishedAt": "2020-08-17T16:07:07Z"
  },
  {
    "videoId": "1sx0Gbfj36c",
    "thumbnail": "https://i.ytimg.com/vi/1sx0Gbfj36c/mqdefault.jpg",
    "title": "【APEX】ランパートの煽り性能の高さやびーｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-18T13:59:19Z"
  },
  {
    "videoId": "XX_PKGt72eU",
    "thumbnail": "https://i.ytimg.com/vi/XX_PKGt72eU/mqdefault.jpg",
    "title": "【APEX】キルするまでしゃべれない地獄！？【姫森ルーナ/白上フブキ/夏色まつり】",
    "publishedAt": "2020-08-20T14:10:06Z"
  },
  {
    "videoId": "nHqiLRNB_OE",
    "thumbnail": "https://i.ytimg.com/vi/nHqiLRNB_OE/mqdefault.jpg",
    "title": "【同時視聴】あくあ色すーぱー☆どり〜むの感動をもう一度！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-22T15:14:47Z"
  },
  {
    "videoId": "t8bjxc955I8",
    "thumbnail": "https://i.ytimg.com/vi/t8bjxc955I8/mqdefault.jpg",
    "title": "【歌枠】sing＆song【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-24T16:02:21Z"
  },
  {
    "videoId": "atySpn8jH_s",
    "thumbnail": "https://i.ytimg.com/vi/atySpn8jH_s/mqdefault.jpg",
    "title": "【APEX】あさ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-28T00:54:54Z"
  },
  {
    "videoId": "UZUcOiVH95w",
    "thumbnail": "https://i.ytimg.com/vi/UZUcOiVH95w/mqdefault.jpg",
    "title": "【Fall Guys】１番好きなの一等賞！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-28T15:23:39Z"
  },
  {
    "videoId": "oWlJEVDKY70",
    "thumbnail": "https://i.ytimg.com/vi/oWlJEVDKY70/mqdefault.jpg",
    "title": "【Fall Guys】協力してくれると思った相手に邪魔される気分はどうだ【天神子兎音/夏色まつり】",
    "publishedAt": "2020-08-29T14:12:44Z"
  },
  {
    "videoId": "46ZOQoms58s",
    "thumbnail": "https://i.ytimg.com/vi/46ZOQoms58s/mqdefault.jpg",
    "title": "【マリオカート8DX】7位以下にならないもんっ【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-30T14:08:16Z"
  },
  {
    "videoId": "pND_U3jlT4I",
    "thumbnail": "https://i.ytimg.com/vi/pND_U3jlT4I/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】何カ月も放置した島をきれいにする！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-08-31T18:29:32Z"
  },
  {
    "videoId": "O6MrhsSknHo",
    "thumbnail": "https://i.ytimg.com/vi/O6MrhsSknHo/mqdefault.jpg",
    "title": "【3D】祝！50万人記念！！暴れる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-01T12:02:04Z"
  },
  {
    "videoId": "HFkIla5rMu4",
    "thumbnail": "https://i.ytimg.com/vi/HFkIla5rMu4/mqdefault.jpg",
    "title": "【雑談】しゃべるをする！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-02T15:50:14Z"
  },
  {
    "videoId": "0iCGUQr4JWo",
    "thumbnail": "https://i.ytimg.com/vi/0iCGUQr4JWo/mqdefault.jpg",
    "title": "【ヨッシーアイランド】赤子をのせてどこまでも#1【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-03T08:08:12Z"
  },
  {
    "videoId": "b5LS9I6bp9A",
    "thumbnail": "https://i.ytimg.com/vi/b5LS9I6bp9A/mqdefault.jpg",
    "title": "【#ホロどっと雪山人狼】雪食べるやつは俺【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-03T12:15:42Z"
  },
  {
    "videoId": "dha55sQQqY0",
    "thumbnail": "https://i.ytimg.com/vi/dha55sQQqY0/mqdefault.jpg",
    "title": "【世界のアソビ大全51】アソビを本気でやる！！【白銀ノエル/夏色まつり】",
    "publishedAt": "2020-09-03T15:12:59Z"
  },
  {
    "videoId": "pd3rEJGoj84",
    "thumbnail": "https://i.ytimg.com/vi/pd3rEJGoj84/mqdefault.jpg",
    "title": "【APEX】アーマーの仕様になれる配信【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-04T15:54:22Z"
  },
  {
    "videoId": "KhOJ-E362cY",
    "thumbnail": "https://i.ytimg.com/vi/KhOJ-E362cY/mqdefault.jpg",
    "title": "【APEX】やる【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-05T17:41:01Z"
  },
  {
    "videoId": "4JIfygypgq0",
    "thumbnail": "https://i.ytimg.com/vi/4JIfygypgq0/mqdefault.jpg",
    "title": "【夏休み】実家に帰らせていただきます！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-06T06:21:42Z"
  },
  {
    "videoId": "dZ9ICLuC7c8",
    "thumbnail": "https://i.ytimg.com/vi/dZ9ICLuC7c8/mqdefault.jpg",
    "title": "I am very cute♡ understand?",
    "publishedAt": "2020-09-09T12:26:38Z"
  },
  {
    "videoId": "Do-mWnVbBAo",
    "thumbnail": "https://i.ytimg.com/vi/Do-mWnVbBAo/mqdefault.jpg",
    "title": "【ただいま】ひさしぶり！さみしかったか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-12T16:05:08Z"
  },
  {
    "videoId": "QigfmlDmH88",
    "thumbnail": "https://i.ytimg.com/vi/QigfmlDmH88/mqdefault.jpg",
    "title": "【APEX】脳みそ停止あぺぺ【天神 子兎音/パカエル/夏色まつり】",
    "publishedAt": "2020-09-12T21:04:04Z"
  },
  {
    "videoId": "ovMslN3omXw",
    "thumbnail": "https://i.ytimg.com/vi/ovMslN3omXw/mqdefault.jpg",
    "title": "【APEX】今日も脳みそ停止→ちゃんぽん耐久【天神 子兎音/パカエル/夏色まつり】",
    "publishedAt": "2020-09-15T00:43:11Z"
  },
  {
    "videoId": "WhUnYvxtmG4",
    "thumbnail": "https://i.ytimg.com/vi/WhUnYvxtmG4/mqdefault.jpg",
    "title": "【ヨッシーアイランド】運ぶでな('ω')【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-15T03:53:51Z"
  },
  {
    "videoId": "-wV0AH0u8ik",
    "thumbnail": "https://i.ytimg.com/vi/-wV0AH0u8ik/mqdefault.jpg",
    "title": "楓 / スピッツ (Covered by 夏色まつり&律可)",
    "publishedAt": "2020-09-15T13:00:11Z"
  },
  {
    "videoId": "rFlcivRc0P4",
    "thumbnail": "https://i.ytimg.com/vi/rFlcivRc0P4/mqdefault.jpg",
    "title": "【Fall Guys】1時間チャレンジ！1位目指してぶちぎれます！【律可/夏色まつり】",
    "publishedAt": "2020-09-15T13:11:04Z"
  },
  {
    "videoId": "GHzs4tnDizw",
    "thumbnail": "https://i.ytimg.com/vi/GHzs4tnDizw/mqdefault.jpg",
    "title": "【世界のアソビ大全51】実力？運で押し切っちゃうよーん！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-15T15:19:58Z"
  },
  {
    "videoId": "mAZi73QnuEs",
    "thumbnail": "https://i.ytimg.com/vi/mAZi73QnuEs/mqdefault.jpg",
    "title": "【Fall Guys】よちよち歩き('ω')【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-16T15:42:57Z"
  },
  {
    "videoId": "lf8vm_U8O8U",
    "thumbnail": "https://i.ytimg.com/vi/lf8vm_U8O8U/mqdefault.jpg",
    "title": "【APEX】俺にはこの拳がある。【天神 子兎音/パカエル/夏色まつり】",
    "publishedAt": "2020-09-16T19:31:48Z"
  },
  {
    "videoId": "5cEWDMcdPlg",
    "thumbnail": "https://i.ytimg.com/vi/5cEWDMcdPlg/mqdefault.jpg",
    "title": "【APEX LEGENDS】I don't speak English?【GreatMoonAroma/白上フブキ/夏色まつり】",
    "publishedAt": "2020-09-17T13:52:04Z"
  },
  {
    "videoId": "zk1g2zLeD2M",
    "thumbnail": "https://i.ytimg.com/vi/zk1g2zLeD2M/mqdefault.jpg",
    "title": "【歌枠】なんでも歌いたい～【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-18T16:11:31Z"
  },
  {
    "videoId": "f5DoB8sgZkE",
    "thumbnail": "https://i.ytimg.com/vi/f5DoB8sgZkE/mqdefault.jpg",
    "title": "【APEX】そろそろちゃんぽんとらん？【天神 子兎音/パカエル/夏色まつり】",
    "publishedAt": "2020-09-18T20:17:40Z"
  },
  {
    "videoId": "8Xis1SlN0X4",
    "thumbnail": "https://i.ytimg.com/vi/8Xis1SlN0X4/mqdefault.jpg",
    "title": "【Minecraft】初！ハードコアで生き残れ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-21T11:32:50Z"
  },
  {
    "videoId": "7HtLexvqeKw",
    "thumbnail": "https://i.ytimg.com/vi/7HtLexvqeKw/mqdefault.jpg",
    "title": "【ヨッシーアイランド】深夜に赤子を連れて('ω')【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-21T17:56:53Z"
  },
  {
    "videoId": "Zla5S2lblug",
    "thumbnail": "https://i.ytimg.com/vi/Zla5S2lblug/mqdefault.jpg",
    "title": "【APEX】English only! I'm GOD:)【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-21T23:15:27Z"
  },
  {
    "videoId": "N-GI7ClSBvU",
    "thumbnail": "https://i.ytimg.com/vi/N-GI7ClSBvU/mqdefault.jpg",
    "title": "【食費APEX】ハンポ縛りで何が食べれる？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-22T11:16:03Z"
  },
  {
    "videoId": "3nQkQ8n3ZFI",
    "thumbnail": "https://i.ytimg.com/vi/3nQkQ8n3ZFI/mqdefault.jpg",
    "title": "【世界のアソビ大全51】今日は勝ちますけどね！【カルロ・ピノ/夏色まつり】",
    "publishedAt": "2020-09-22T14:04:09Z"
  },
  {
    "videoId": "2snSsqb-TXw",
    "thumbnail": "https://i.ytimg.com/vi/2snSsqb-TXw/mqdefault.jpg",
    "title": "【世界のアソビ大全51】ホロ最高得点とったら焼肉！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-24T14:24:23Z"
  },
  {
    "videoId": "qwvvXmOdkUA",
    "thumbnail": "https://i.ytimg.com/vi/qwvvXmOdkUA/mqdefault.jpg",
    "title": "【歌枠】のんびり歌う深夜のまったりタイム～【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-24T18:19:32Z"
  },
  {
    "videoId": "AaXt2KVJApE",
    "thumbnail": "https://i.ytimg.com/vi/AaXt2KVJApE/mqdefault.jpg",
    "title": "【Fall Guys】夏色吹雪の邪魔するやつはどこじゃい！！【白上フブキ/夏色まつり】",
    "publishedAt": "2020-09-26T14:11:09Z"
  },
  {
    "videoId": "UxSWmPL8Qv0",
    "thumbnail": "https://i.ytimg.com/vi/UxSWmPL8Qv0/mqdefault.jpg",
    "title": "【APEX】エンジョイあぺっくしゅ【癒月ちょこ/夏色まつり】",
    "publishedAt": "2020-09-26T18:30:37Z"
  },
  {
    "videoId": "bnMivys-2Wo",
    "thumbnail": "https://i.ytimg.com/vi/bnMivys-2Wo/mqdefault.jpg",
    "title": "【雑談】かきかきしながらまったりはなそ～【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-27T18:05:08Z"
  },
  {
    "videoId": "5M2Hy5GcmMc",
    "thumbnail": "https://i.ytimg.com/vi/5M2Hy5GcmMc/mqdefault.jpg",
    "title": "【世界のアソビ大全51】最高点と最低点をたたき出した女【ホロライブ/夏色まつり】",
    "publishedAt": "2020-09-28T16:27:25Z"
  },
  {
    "videoId": "0mX5k-2-eoQ",
    "thumbnail": "https://i.ytimg.com/vi/0mX5k-2-eoQ/mqdefault.jpg",
    "title": "【APEX】おひさしぶりのらんくしうますか？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-01T06:03:03Z"
  },
  {
    "videoId": "WuBHliWe5S8",
    "thumbnail": "https://i.ytimg.com/vi/WuBHliWe5S8/mqdefault.jpg",
    "title": "【ホロライブ参戦！】自分のナビボイスを解禁させる！【グルーヴコースターワイワイパーティー!!!!】",
    "publishedAt": "2020-10-03T14:06:19Z"
  },
  {
    "videoId": "eGa8ESnuk04",
    "thumbnail": "https://i.ytimg.com/vi/eGa8ESnuk04/mqdefault.jpg",
    "title": "【APEX】敵強すぎん！？わあああああ【パカエル/夏色まつり】",
    "publishedAt": "2020-10-04T07:08:44Z"
  },
  {
    "videoId": "BBRPXia3cu0",
    "thumbnail": "https://i.ytimg.com/vi/BBRPXia3cu0/mqdefault.jpg",
    "title": "【パスパルトゥー】サイン入れるんで！買ってください！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-06T15:31:04Z"
  },
  {
    "videoId": "JonQ09L2N0U",
    "thumbnail": "https://i.ytimg.com/vi/JonQ09L2N0U/mqdefault.jpg",
    "title": "ワタシノテンシ / 夏色まつり cover【オリジナルPV】",
    "publishedAt": "2020-10-09T16:00:13Z"
  },
  {
    "videoId": "fSw2Fm27KBU",
    "thumbnail": "https://i.ytimg.com/vi/fSw2Fm27KBU/mqdefault.jpg",
    "title": "【ただいま】さみしかったから構ってクレメンス～＾【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-14T10:23:35Z"
  },
  {
    "videoId": "DTy0nqoiD7s",
    "thumbnail": "https://i.ytimg.com/vi/DTy0nqoiD7s/mqdefault.jpg",
    "title": "【朝活】お話しながらまったりAPEX～！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-14T23:03:22Z"
  },
  {
    "videoId": "bZgtDwGOvVY",
    "thumbnail": "https://i.ytimg.com/vi/bZgtDwGOvVY/mqdefault.jpg",
    "title": "【ガチャ】APEX100連ガチャで沼発狂RTA！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-15T14:49:03Z"
  },
  {
    "videoId": "qhIYVLFgb8g",
    "thumbnail": "https://i.ytimg.com/vi/qhIYVLFgb8g/mqdefault.jpg",
    "title": "【Minecraft】ホロトラップダンジョン制作！～素材集め編～#1【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-17T08:45:59Z"
  },
  {
    "videoId": "IpO7fxGw5V8",
    "thumbnail": "https://i.ytimg.com/vi/IpO7fxGw5V8/mqdefault.jpg",
    "title": "「風吹けば恋」short ver. -IMAGINATION vol.3 収録-",
    "publishedAt": "2020-10-17T11:00:14Z"
  },
  {
    "videoId": "Pw6X2mocMRQ",
    "thumbnail": "https://i.ytimg.com/vi/Pw6X2mocMRQ/mqdefault.jpg",
    "title": "月曜日の憂鬱 / 夏色まつり cover",
    "publishedAt": "2020-10-18T15:00:11Z"
  },
  {
    "videoId": "pOedpmOV5Lg",
    "thumbnail": "https://i.ytimg.com/vi/pOedpmOV5Lg/mqdefault.jpg",
    "title": "【Minecraft】ホロトラップダンジョン制作！～素材集め編～#2【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-20T08:35:03Z"
  },
  {
    "videoId": "kw9d1h1I8yE",
    "thumbnail": "https://i.ytimg.com/vi/kw9d1h1I8yE/mqdefault.jpg",
    "title": "【晩酌】よってま～す！！YEEEEEEEE！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-20T15:20:58Z"
  },
  {
    "videoId": "P9oQwhOlLcM",
    "thumbnail": "https://i.ytimg.com/vi/P9oQwhOlLcM/mqdefault.jpg",
    "title": "【歌枠】いつもお疲れ様！癒します！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-24T15:45:52Z"
  },
  {
    "videoId": "cq-ZMQaorIk",
    "thumbnail": "https://i.ytimg.com/vi/cq-ZMQaorIk/mqdefault.jpg",
    "title": "【Minecraft】初めての大冒険！？フレアについていくぜ！！【不知火フレア/夏色まつり】",
    "publishedAt": "2020-10-26T08:19:31Z"
  },
  {
    "videoId": "F7DIH581eyg",
    "thumbnail": "https://i.ytimg.com/vi/F7DIH581eyg/mqdefault.jpg",
    "title": "【CRカップ】APEXのプロの中にいれられた赤ちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-26T16:00:58Z"
  },
  {
    "videoId": "a79OC870YZY",
    "thumbnail": "https://i.ytimg.com/vi/a79OC870YZY/mqdefault.jpg",
    "title": "【新衣装お披露目】本気の新衣装！ラフ案まで全部見せますッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-28T13:02:34Z"
  },
  {
    "videoId": "8qXKnEEHoB0",
    "thumbnail": "https://i.ytimg.com/vi/8qXKnEEHoB0/mqdefault.jpg",
    "title": "【APEX】大会前日カスタム練習会！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-10-31T17:09:01Z"
  },
  {
    "videoId": "18-1mWJhlyM",
    "thumbnail": "https://i.ytimg.com/vi/18-1mWJhlyM/mqdefault.jpg",
    "title": "【CRカップ】ひよこですが噛みつきます！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-01T12:51:53Z"
  },
  {
    "videoId": "9KVh6wHvQx0",
    "thumbnail": "https://i.ytimg.com/vi/9KVh6wHvQx0/mqdefault.jpg",
    "title": "【Minecraft】1時間真剣勝負！ダイアの神よ降りてこい！【角巻わため/夏色まつり】",
    "publishedAt": "2020-11-02T13:23:54Z"
  },
  {
    "videoId": "zM2jFsd5MrU",
    "thumbnail": "https://i.ytimg.com/vi/zM2jFsd5MrU/mqdefault.jpg",
    "title": "【Human Fall Flat】私服組の楽しいおデート・・・？【白銀ノエル/夏色まつり】",
    "publishedAt": "2020-11-03T14:13:54Z"
  },
  {
    "videoId": "8xLkaBFWRg4",
    "thumbnail": "https://i.ytimg.com/vi/8xLkaBFWRg4/mqdefault.jpg",
    "title": "【おうち3D】ガチ恋距離でおはなししよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-07T15:39:02Z"
  },
  {
    "videoId": "xVKhKLLEFQg",
    "thumbnail": "https://i.ytimg.com/vi/xVKhKLLEFQg/mqdefault.jpg",
    "title": "【AmongUs】はじめての宇宙人狼！リスナーさんをがぶがぶ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-08T14:53:17Z"
  },
  {
    "videoId": "ZtIUwdk_ZBk",
    "thumbnail": "https://i.ytimg.com/vi/ZtIUwdk_ZBk/mqdefault.jpg",
    "title": "【同時視聴】鬼滅の刃の主人公の名前言えないんだが・・・？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-09T13:03:34Z"
  },
  {
    "videoId": "n0hSKdLWZGk",
    "thumbnail": "https://i.ytimg.com/vi/n0hSKdLWZGk/mqdefault.jpg",
    "title": "【Minecraft】マイクラ冒険初心者二人で行く！【桃鈴ねね/夏色まつり】",
    "publishedAt": "2020-11-10T11:58:34Z"
  },
  {
    "videoId": "1_M1SxvRZno",
    "thumbnail": "https://i.ytimg.com/vi/1_M1SxvRZno/mqdefault.jpg",
    "title": "【同時視聴】鬼滅の刃のヒロインが誰なのかわからないんだが・・・？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-10T17:03:47Z"
  },
  {
    "videoId": "yrZnX1qIkCo",
    "thumbnail": "https://i.ytimg.com/vi/yrZnX1qIkCo/mqdefault.jpg",
    "title": "【Minecraft】一緒に住むと思ったら別居を強いられました。【天神 子兎音/夏色まつり】",
    "publishedAt": "2020-11-13T15:29:21Z"
  },
  {
    "videoId": "3MZyZOiLV9g",
    "thumbnail": "https://i.ytimg.com/vi/3MZyZOiLV9g/mqdefault.jpg",
    "title": "pizza time",
    "publishedAt": "2020-11-14T08:22:38Z"
  },
  {
    "videoId": "gJcbc1FAnG4",
    "thumbnail": "https://i.ytimg.com/vi/gJcbc1FAnG4/mqdefault.jpg",
    "title": "【天穂のサクナヒメ】強くなるために米を作る！目指せ農業ガチ勢！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-14T22:06:27Z"
  },
  {
    "videoId": "u5uLgEs-JOc",
    "thumbnail": "https://i.ytimg.com/vi/u5uLgEs-JOc/mqdefault.jpg",
    "title": "【スプラトゥーン2】負けたら即終了！がちキレ注意！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-15T14:18:18Z"
  },
  {
    "videoId": "kYQbH_FfoxY",
    "thumbnail": "https://i.ytimg.com/vi/kYQbH_FfoxY/mqdefault.jpg",
    "title": "【歌枠？】口ずさむ曲は大体フルで歌えない。でも歌ってみたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-16T14:46:29Z"
  },
  {
    "videoId": "t79-LiIBCIU",
    "thumbnail": "https://i.ytimg.com/vi/t79-LiIBCIU/mqdefault.jpg",
    "title": "【天穂のサクナヒメ】配信外で5時間やり続けた女の米作り【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-16T17:59:44Z"
  },
  {
    "videoId": "tGMvxFuYr_M",
    "thumbnail": "https://i.ytimg.com/vi/tGMvxFuYr_M/mqdefault.jpg",
    "title": "【オフコラボ】みんなでピザを囲んで女子会！！【夏色まつり/星街すいせい/天音かなた/桃鈴ねね】",
    "publishedAt": "2020-11-17T10:24:40Z"
  },
  {
    "videoId": "Ff7-9ZUtlM4",
    "thumbnail": "https://i.ytimg.com/vi/Ff7-9ZUtlM4/mqdefault.jpg",
    "title": "【はたらくUFO】アルバイトで目指せ億万長者！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-17T15:14:18Z"
  },
  {
    "videoId": "Fve-NcGGZYg",
    "thumbnail": "https://i.ytimg.com/vi/Fve-NcGGZYg/mqdefault.jpg",
    "title": "【Among Us】I am God. OK?実はタスクのほうが得意です！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-18T13:55:53Z"
  },
  {
    "videoId": "u-BfgkPq59s",
    "thumbnail": "https://i.ytimg.com/vi/u-BfgkPq59s/mqdefault.jpg",
    "title": "【祝えッ！】65万人記念！スーパーアイドルまつりちゃん爆誕！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-18T16:25:43Z"
  },
  {
    "videoId": "ASCKzO7JBrE",
    "thumbnail": "https://i.ytimg.com/vi/ASCKzO7JBrE/mqdefault.jpg",
    "title": "【鳥魂】チキン度診断？余裕ｗ余裕ｗ Let's Chicken race！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-19T15:27:40Z"
  },
  {
    "videoId": "sAUvYu8ctXY",
    "thumbnail": "https://i.ytimg.com/vi/sAUvYu8ctXY/mqdefault.jpg",
    "title": "【晩酌】たまには甘えさせろー！一緒にのもー！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-20T15:26:39Z"
  },
  {
    "videoId": "AkrLD1_r1eA",
    "thumbnail": "https://i.ytimg.com/vi/AkrLD1_r1eA/mqdefault.jpg",
    "title": "【#ホロライブ運動会】写真家まつりとみる思い出の写真たち【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-21T15:34:24Z"
  },
  {
    "videoId": "rOOdXIm9Lfk",
    "thumbnail": "https://i.ytimg.com/vi/rOOdXIm9Lfk/mqdefault.jpg",
    "title": "【#ホロライブ運動会】運動場貸し切り！ぼっちの運動会！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-24T14:25:47Z"
  },
  {
    "videoId": "UyEeqam5_M0",
    "thumbnail": "https://i.ytimg.com/vi/UyEeqam5_M0/mqdefault.jpg",
    "title": "【APEX】雑談しながら2週間ぶりにエイム調査【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-25T16:06:44Z"
  },
  {
    "videoId": "1a2WakPF6dM",
    "thumbnail": "https://i.ytimg.com/vi/1a2WakPF6dM/mqdefault_live.jpg",
    "title": "【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-25T17:00:46Z"
  },
  {
    "videoId": "mn8KnMecTSg",
    "thumbnail": "https://i.ytimg.com/vi/mn8KnMecTSg/mqdefault.jpg",
    "title": "【スマブラSP】超発狂！？リスナーさんに１勝するまで終われません！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-26T12:38:22Z"
  },
  {
    "videoId": "rYJb_VTSvjQ",
    "thumbnail": "https://i.ytimg.com/vi/rYJb_VTSvjQ/mqdefault.jpg",
    "title": "【Papers, Please】悪い人は通しません！出直してこい！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-27T16:42:02Z"
  },
  {
    "videoId": "j-9AYRR45-E",
    "thumbnail": "https://i.ytimg.com/vi/j-9AYRR45-E/mqdefault.jpg",
    "title": "【APEXガチャ】地獄へようこそ。天井でしかひけない女が奇跡を起こす！？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-29T16:44:23Z"
  },
  {
    "videoId": "QdOrC4gdtfM",
    "thumbnail": "https://i.ytimg.com/vi/QdOrC4gdtfM/mqdefault.jpg",
    "title": "【雑談】お話聞いてッ！ダンスレッスン頑張れてえらい！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-11-30T15:13:31Z"
  },
  {
    "videoId": "vQl8JAlKOMU",
    "thumbnail": "https://i.ytimg.com/vi/vQl8JAlKOMU/mqdefault.jpg",
    "title": "【HoneyWorks Premium Live】ハニワ新作音ゲー！？神曲プレイしていくぅ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-02T15:24:52Z"
  },
  {
    "videoId": "9yS6O2ckzH8",
    "thumbnail": "https://i.ytimg.com/vi/9yS6O2ckzH8/mqdefault.jpg",
    "title": "【Phasmophobia】唯一ホラーが苦手なJKがプロ幽霊調査隊に強制送還！？【白上フブキ/夏色まつり】",
    "publishedAt": "2020-12-02T17:01:28Z"
  },
  {
    "videoId": "w2ydtA7CTPM",
    "thumbnail": "https://i.ytimg.com/vi/w2ydtA7CTPM/mqdefault.jpg",
    "title": "【 RFA対決 】勝ち＾＾✌【姫森ルーナ/夏色まつり】",
    "publishedAt": "2020-12-04T11:11:25Z"
  },
  {
    "videoId": "vf2E5gmzf_I",
    "thumbnail": "https://i.ytimg.com/vi/vf2E5gmzf_I/mqdefault.jpg",
    "title": "【歌枠】恋愛ソング縛りでガチ恋させるッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-04T13:07:56Z"
  },
  {
    "videoId": "ikNzIO0B1Vw",
    "thumbnail": "https://i.ytimg.com/vi/ikNzIO0B1Vw/mqdefault.jpg",
    "title": "【60 Seconds!】世紀末でも充実した毎日を！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-05T16:06:53Z"
  },
  {
    "videoId": "ebFrd7Rrs44",
    "thumbnail": "https://i.ytimg.com/vi/ebFrd7Rrs44/mqdefault.jpg",
    "title": "【APEX】スパレジェを見届けてカジュアルへ向かう！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-06T15:19:08Z"
  },
  {
    "videoId": "LNz07Aj8Ur8",
    "thumbnail": "https://i.ytimg.com/vi/LNz07Aj8Ur8/mqdefault.jpg",
    "title": "【メンバー限定（おためし）】15分だけメンバー限定配信を感じてみませんか？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-07T13:33:59Z"
  },
  {
    "videoId": "LCLKP6tBCZs",
    "thumbnail": "https://i.ytimg.com/vi/LCLKP6tBCZs/mqdefault.jpg",
    "title": "【LITTLE FRIENDS】犬過激派と見るわんこの日常【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-08T14:30:06Z"
  },
  {
    "videoId": "2F4gU3ktSsk",
    "thumbnail": "https://i.ytimg.com/vi/2F4gU3ktSsk/mqdefault.jpg",
    "title": "【桃太郎電鉄】27都道府県しか言えないけど社長になります！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-09T16:06:13Z"
  },
  {
    "videoId": "_Oe2Nk1y2gc",
    "thumbnail": "https://i.ytimg.com/vi/_Oe2Nk1y2gc/mqdefault.jpg",
    "title": "【歌枠】Let's sing a song!!かわいくうたうよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-11T09:04:47Z"
  },
  {
    "videoId": "CwYTPIpW6kY",
    "thumbnail": "https://i.ytimg.com/vi/CwYTPIpW6kY/mqdefault.jpg",
    "title": "【オフコラボ】チキン食べながら歌ったりお話したり！！【小鳥遊キアラ/夏色まつり】",
    "publishedAt": "2020-12-12T08:11:46Z"
  },
  {
    "videoId": "LnA0N-ZGI_U",
    "thumbnail": "https://i.ytimg.com/vi/LnA0N-ZGI_U/mqdefault.jpg",
    "title": "【マリオカート8DX】Let's Challenge! English only!!!!!YEEEEEEEEE!!!【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-12T16:25:29Z"
  },
  {
    "videoId": "nToOodtxjgY",
    "thumbnail": "https://i.ytimg.com/vi/nToOodtxjgY/mqdefault.jpg",
    "title": "【歌枠】70万人目指してノンストップで歌う！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-13T05:23:13Z"
  },
  {
    "videoId": "dUgAx7JQuSE",
    "thumbnail": "https://i.ytimg.com/vi/dUgAx7JQuSE/mqdefault.jpg",
    "title": "【Good Job!】学生ニート初出勤！ホワイト企業ですか・・・？【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-13T15:34:11Z"
  },
  {
    "videoId": "XhwBSYCvQsc",
    "thumbnail": "https://i.ytimg.com/vi/XhwBSYCvQsc/mqdefault.jpg",
    "title": "【APEX】まったり友と遊ぶやつをする【西園チグサ/夏色まつり】",
    "publishedAt": "2020-12-14T09:55:45Z"
  },
  {
    "videoId": "nQLBKZRhDkc",
    "thumbnail": "https://i.ytimg.com/vi/nQLBKZRhDkc/mqdefault.jpg",
    "title": "【Minecraft】１時間真剣勝負！ダイア大量GET！！【天神子兎音/夏色まつり】",
    "publishedAt": "2020-12-14T15:14:18Z"
  },
  {
    "videoId": "PZDSo7qimVw",
    "thumbnail": "https://i.ytimg.com/vi/PZDSo7qimVw/mqdefault.jpg",
    "title": "【Among Us】imposterを暴いていく！名探偵まつり参上！【ホロライブ/にじさんじ/夏色まつり】",
    "publishedAt": "2020-12-16T11:48:58Z"
  },
  {
    "videoId": "LmSBrJM75iQ",
    "thumbnail": "https://i.ytimg.com/vi/LmSBrJM75iQ/mqdefault.jpg",
    "title": "【Superliminal】非常識女が常識が通用しない世界へ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-17T14:24:15Z"
  },
  {
    "videoId": "G6d7mR9T5U0",
    "thumbnail": "https://i.ytimg.com/vi/G6d7mR9T5U0/mqdefault.jpg",
    "title": "【雑談】何かが新しくなった！最近のこといろいろ！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-17T16:19:27Z"
  },
  {
    "videoId": "bhMDjEwbmmw",
    "thumbnail": "https://i.ytimg.com/vi/bhMDjEwbmmw/mqdefault.jpg",
    "title": "【前夜祭】LIVE目前！歌おうじゃないか！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-20T15:15:48Z"
  },
  {
    "videoId": "J1G27-PTyZk",
    "thumbnail": "https://i.ytimg.com/vi/J1G27-PTyZk/mqdefault.jpg",
    "title": "【#こえていくホロライブSTAGE2 】LIVE裏話会場！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-23T15:38:17Z"
  },
  {
    "videoId": "8DcScnD9Jl0",
    "thumbnail": "https://i.ytimg.com/vi/8DcScnD9Jl0/mqdefault.jpg",
    "title": "【クリスマス】ケーキ食べてチキン食べていいお知らせする！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-24T10:53:52Z"
  },
  {
    "videoId": "u8av8uICNtE",
    "thumbnail": "https://i.ytimg.com/vi/u8av8uICNtE/mqdefault.jpg",
    "title": "【#ホロライブクリスマス】SINGING!!プレゼントはお歌でどうですか！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-25T08:03:05Z"
  },
  {
    "videoId": "WC-zS1vVA3c",
    "thumbnail": "https://i.ytimg.com/vi/WC-zS1vVA3c/mqdefault.jpg",
    "title": "【APEX】ソロランク！RP盛りたい！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-25T18:41:42Z"
  },
  {
    "videoId": "JWmYsAiluf0",
    "thumbnail": "https://i.ytimg.com/vi/JWmYsAiluf0/mqdefault.jpg",
    "title": "【 ピクミン３ デラックス 】初めてのピクミン！みんな集合ッ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-26T11:08:10Z"
  },
  {
    "videoId": "iJvMQTZDTPI",
    "thumbnail": "https://i.ytimg.com/vi/iJvMQTZDTPI/mqdefault.jpg",
    "title": "【桃太郎電鉄】今宵は戦争じゃいッッッ！！！！！！！！！【鷹宮リオン/フレン・E・ルスタリオ/白銀ノエル/夏色まつり】",
    "publishedAt": "2020-12-27T12:24:04Z"
  },
  {
    "videoId": "4IvbRsntWyo",
    "thumbnail": "https://i.ytimg.com/vi/4IvbRsntWyo/mqdefault.jpg",
    "title": "hi✋",
    "publishedAt": "2020-12-27T15:36:36Z"
  },
  {
    "videoId": "KQsZmcIbCo0",
    "thumbnail": "https://i.ytimg.com/vi/KQsZmcIbCo0/mqdefault.jpg",
    "title": "【晩酌】百年梅酒ぺこらver飲んでみるでぇ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-28T14:44:35Z"
  },
  {
    "videoId": "5PGdqe9dCBU",
    "thumbnail": "https://i.ytimg.com/vi/5PGdqe9dCBU/mqdefault.jpg",
    "title": "【歌枠】2020年最後の歌枠！今年もたくさんのありがとう！【ホロライブ/夏色まつり】",
    "publishedAt": "2020-12-30T15:37:08Z"
  },
  {
    "videoId": "zqyeiNrsdWc",
    "thumbnail": "https://i.ytimg.com/vi/zqyeiNrsdWc/mqdefault.jpg",
    "title": "【筆おろし】君の名前も書かれちゃう！？デジタル書初め大会！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-01T16:19:16Z"
  },
  {
    "videoId": "MjPtXDAHeOs",
    "thumbnail": "https://i.ytimg.com/vi/MjPtXDAHeOs/mqdefault.jpg",
    "title": "【ガチ親】ママはVTuber志望らしい。【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-02T14:53:38Z"
  },
  {
    "videoId": "uKGrmRbvzUs",
    "thumbnail": "https://i.ytimg.com/vi/uKGrmRbvzUs/mqdefault.jpg",
    "title": "【APEXガチャ】新年でめでたいし天井じゃなくてもひける説【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-03T15:37:35Z"
  },
  {
    "videoId": "TwwvMmuLG6I",
    "thumbnail": "https://i.ytimg.com/vi/TwwvMmuLG6I/mqdefault.jpg",
    "title": "【マリオカート8DX】ぼくは三輪車でいく✊【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-04T14:35:18Z"
  },
  {
    "videoId": "tFxdKsQql1Y",
    "thumbnail": "https://i.ytimg.com/vi/tFxdKsQql1Y/mqdefault.jpg",
    "title": "【APEX】短編キル集#1【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-05T06:34:32Z"
  },
  {
    "videoId": "f8htakwZrv0",
    "thumbnail": "https://i.ytimg.com/vi/f8htakwZrv0/mqdefault.jpg",
    "title": "【マリオカート8DX】補助輪卒業！ショートカットを覚える！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-05T09:14:19Z"
  },
  {
    "videoId": "D90Nz7uD5iY",
    "thumbnail": "https://i.ytimg.com/vi/D90Nz7uD5iY/mqdefault.jpg",
    "title": "【マリオカート8DX】補助輪卒業2日目！まつりの成長みてね！先生ッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-06T07:41:20Z"
  },
  {
    "videoId": "g7pPDkuW7pI",
    "thumbnail": "https://i.ytimg.com/vi/g7pPDkuW7pI/mqdefault.jpg",
    "title": "險ｱ縺輔↑縺",
    "publishedAt": "2021-01-09T11:21:32Z"
  },
  {
    "videoId": "CLuJ43KDNR8",
    "thumbnail": "https://i.ytimg.com/vi/CLuJ43KDNR8/mqdefault.jpg",
    "title": "Avocados from Mexico🥑",
    "publishedAt": "2021-01-09T11:37:03Z"
  },
  {
    "videoId": "f4dJFe4MGcs",
    "thumbnail": "https://i.ytimg.com/vi/f4dJFe4MGcs/mqdefault.jpg",
    "title": "KING／夏色まつり cover【歌ってみた】",
    "publishedAt": "2021-01-10T10:30:13Z"
  },
  {
    "videoId": "u3D3az4r-MQ",
    "thumbnail": "https://i.ytimg.com/vi/u3D3az4r-MQ/mqdefault.jpg",
    "title": "【歌枠】かわいく歌うッ！KING同時視聴もしよっ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-10T10:58:37Z"
  },
  {
    "videoId": "eNHB2dON8kk",
    "thumbnail": "https://i.ytimg.com/vi/eNHB2dON8kk/mqdefault.jpg",
    "title": "【APEX】練習会！とーますGO☆GOがチーム名です！！！！！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-10T15:29:35Z"
  },
  {
    "videoId": "TkPuf--ZZSc",
    "thumbnail": "https://i.ytimg.com/vi/TkPuf--ZZSc/mqdefault.jpg",
    "title": "【#ホロお正月CUP】補助輪卒業１週間が挑む！世界一楽しむ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-11T12:35:38Z"
  },
  {
    "videoId": "8qhduadHdtM",
    "thumbnail": "https://i.ytimg.com/vi/8qhduadHdtM/mqdefault.jpg",
    "title": "【ゴッドフィールド】夏色まつり最強！！初レート挑戦！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-12T15:17:48Z"
  },
  {
    "videoId": "S6jAKAs0lOY",
    "thumbnail": "https://i.ytimg.com/vi/S6jAKAs0lOY/mqdefault.jpg",
    "title": "【APEX】練習会！ホライゾンふわっとやっていくわね！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-13T15:04:34Z"
  },
  {
    "videoId": "NXb5dSmdxe0",
    "thumbnail": "https://i.ytimg.com/vi/NXb5dSmdxe0/mqdefault.jpg",
    "title": "【耐久歌枠】目指せッ！77万7777人！ラッキー7まで歌う!!!Singing♪【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-14T09:46:30Z"
  },
  {
    "videoId": "GXQyX3bFcaw",
    "thumbnail": "https://i.ytimg.com/vi/GXQyX3bFcaw/mqdefault.jpg",
    "title": "【When the Past was Around】本当の愛を求めて。癒しのゲームに挑戦ッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-15T07:59:14Z"
  },
  {
    "videoId": "5On0iHNXmUs",
    "thumbnail": "https://i.ytimg.com/vi/5On0iHNXmUs/mqdefault.jpg",
    "title": "【APEX】カジュアル練習からのカスタム練習へGO!【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-15T16:11:26Z"
  },
  {
    "videoId": "8XVfkHPU1Kk",
    "thumbnail": "https://i.ytimg.com/vi/8XVfkHPU1Kk/mqdefault.jpg",
    "title": "【スプラトゥーン2】5億年ぶりに夏色吹雪でスプラするでぇ！！【白上フブキ/夏色まつり】",
    "publishedAt": "2021-01-17T09:44:03Z"
  },
  {
    "videoId": "1mbBpKtSzSQ",
    "thumbnail": "https://i.ytimg.com/vi/1mbBpKtSzSQ/mqdefault.jpg",
    "title": "【APEX】少し成長をしました！カジュアル→カスタム【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-18T15:14:44Z"
  },
  {
    "videoId": "MW_S3t5Qui8",
    "thumbnail": "https://i.ytimg.com/vi/MW_S3t5Qui8/mqdefault.jpg",
    "title": "lol",
    "publishedAt": "2021-01-18T17:01:36Z"
  },
  {
    "videoId": "0chaqsd6sqk",
    "thumbnail": "https://i.ytimg.com/vi/0chaqsd6sqk/mqdefault.jpg",
    "title": "【APEX】大きな声で報告しましょう！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-19T13:45:31Z"
  },
  {
    "videoId": "6i6vEggI4mI",
    "thumbnail": "https://i.ytimg.com/vi/6i6vEggI4mI/mqdefault.jpg",
    "title": "【Among Us】VTuberに裏切り者なんているわけないよなぁ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-20T12:44:58Z"
  },
  {
    "videoId": "IFS75EcONqU",
    "thumbnail": "https://i.ytimg.com/vi/IFS75EcONqU/mqdefault.jpg",
    "title": "【APEX】初めてのオーダーにチャレンジしてみましょう！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-20T15:27:54Z"
  },
  {
    "videoId": "2Tp7VvbuqqU",
    "thumbnail": "https://i.ytimg.com/vi/2Tp7VvbuqqU/mqdefault.jpg",
    "title": "【APEX】二人の援護はまつりに任せろッ！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-22T15:59:33Z"
  },
  {
    "videoId": "YzjJolBwPbM",
    "thumbnail": "https://i.ytimg.com/vi/YzjJolBwPbM/mqdefault.jpg",
    "title": "【APEX】練習カスタム最終日！＆前夜祭で大暴れ！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-23T16:23:55Z"
  },
  {
    "videoId": "EiHu9OHbUhc",
    "thumbnail": "https://i.ytimg.com/vi/EiHu9OHbUhc/mqdefault.jpg",
    "title": "【APEX】VTuber最協決定戦本番！【花芽すみれ/常闇トワ/夏色まつり】",
    "publishedAt": "2021-01-24T12:01:30Z"
  },
  {
    "videoId": "W3mTgS3JPTY",
    "thumbnail": "https://i.ytimg.com/vi/W3mTgS3JPTY/mqdefault.jpg",
    "title": "【APEX】後夜祭！！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-24T18:21:03Z"
  },
  {
    "videoId": "g0VkVCs1L1c",
    "thumbnail": "https://i.ytimg.com/vi/g0VkVCs1L1c/mqdefault.jpg",
    "title": "【Minecraft】ひさびさマイクラで豪運釣り名人！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-26T16:54:17Z"
  },
  {
    "videoId": "ovrbuhF8G54",
    "thumbnail": "https://i.ytimg.com/vi/ovrbuhF8G54/mqdefault.jpg",
    "title": "【APEX】初PAD！操作方法なにもわからんブロンズ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-27T15:32:02Z"
  },
  {
    "videoId": "S6_R3s5v0qY",
    "thumbnail": "https://i.ytimg.com/vi/S6_R3s5v0qY/mqdefault.jpg",
    "title": "【渋谷ハルカスタム】初めましてのメンツですが('ω')【パカエル/季咲あんこ/夏色まつり】",
    "publishedAt": "2021-01-28T14:03:59Z"
  },
  {
    "videoId": "iYUiSuej5Vs",
    "thumbnail": "https://i.ytimg.com/vi/iYUiSuej5Vs/mqdefault.jpg",
    "title": "【歌枠】深夜のお歌！Sing a Song!【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-29T15:39:47Z"
  },
  {
    "videoId": "ziFq-n_rwQ8",
    "thumbnail": "https://i.ytimg.com/vi/ziFq-n_rwQ8/mqdefault.jpg",
    "title": "【感想会】アイドルらしくおしゃフェスとイベント出演してきました！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-01-31T16:47:26Z"
  },
  {
    "videoId": "Llltp4-C_Os",
    "thumbnail": "https://i.ytimg.com/vi/Llltp4-C_Os/mqdefault.jpg",
    "title": "【不仲コラボ!?】VTuberオタクがVTuberの実況ゲームした結果ｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-02T14:30:12Z"
  },
  {
    "videoId": "jJzSCpmy344",
    "thumbnail": "https://i.ytimg.com/vi/jJzSCpmy344/mqdefault.jpg",
    "title": "【公式切り抜き】大会1週間前に補助輪外して猛特訓！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-03T07:00:13Z"
  },
  {
    "videoId": "9NacYwCqIII",
    "thumbnail": "https://i.ytimg.com/vi/9NacYwCqIII/mqdefault.jpg",
    "title": "【Fall Guys】ぶちぎれシーズン3【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-03T15:32:34Z"
  },
  {
    "videoId": "ZNuiVUdPNEw",
    "thumbnail": "https://i.ytimg.com/vi/ZNuiVUdPNEw/mqdefault.jpg",
    "title": "【APEX】ランク【杏戸ゆげ/パカエル/夏色まつり】",
    "publishedAt": "2021-02-04T00:23:06Z"
  },
  {
    "videoId": "xSFioR6PTdA",
    "thumbnail": "https://i.ytimg.com/vi/xSFioR6PTdA/mqdefault.jpg",
    "title": "【公式切り抜き】大会本番で熱すぎる戦いをする！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-04T07:00:18Z"
  },
  {
    "videoId": "cYSzA2BUNmI",
    "thumbnail": "https://i.ytimg.com/vi/cYSzA2BUNmI/mqdefault.jpg",
    "title": "【Ib】ギャリーガチ恋勢によるクリアまで神ゲー実況【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-04T14:35:16Z"
  },
  {
    "videoId": "zNR8zumhAkE",
    "thumbnail": "https://i.ytimg.com/vi/zNR8zumhAkE/mqdefault.jpg",
    "title": "【歌枠】Singing♪【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-05T12:32:24Z"
  },
  {
    "videoId": "Ol_sQySgij0",
    "thumbnail": "https://i.ytimg.com/vi/Ol_sQySgij0/mqdefault.jpg",
    "title": "【Papers, Please】チッププリーズ！OK！通ってどうぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-05T15:27:19Z"
  },
  {
    "videoId": "IWwVOMcLfLg",
    "thumbnail": "https://i.ytimg.com/vi/IWwVOMcLfLg/mqdefault.jpg",
    "title": "【Cooking Simulator】花嫁修業！あなたの胃袋つかんじゃうぞッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-06T13:31:17Z"
  },
  {
    "videoId": "JxgU0RSYSw0",
    "thumbnail": "https://i.ytimg.com/vi/JxgU0RSYSw0/mqdefault.jpg",
    "title": "【晩酌APEX】エイムあわねぇ～ｗｗｗｗ【胡桃のあ/小森めと/夏色まつり】",
    "publishedAt": "2021-02-07T16:13:40Z"
  },
  {
    "videoId": "rTqon_4uU94",
    "thumbnail": "https://i.ytimg.com/vi/rTqon_4uU94/mqdefault.jpg",
    "title": "PA!!!",
    "publishedAt": "2021-02-10T10:37:38Z"
  },
  {
    "videoId": "cA2tXPwUn34",
    "thumbnail": "https://i.ytimg.com/vi/cA2tXPwUn34/mqdefault.jpg",
    "title": "【Fall Guys】視聴者参加型！夏色グランプリ開幕✨【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-10T15:01:47Z"
  },
  {
    "videoId": "dxjyNAMcDQM",
    "thumbnail": "https://i.ytimg.com/vi/dxjyNAMcDQM/mqdefault.jpg",
    "title": "【雑談】レッスンであの子にあったョ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-11T16:47:25Z"
  },
  {
    "videoId": "RQ0zVegRnDo",
    "thumbnail": "https://i.ytimg.com/vi/RQ0zVegRnDo/mqdefault.jpg",
    "title": "【APEX】モザビで3333ダメチャレンジ！【杏戸ゆげ/夏色まつり】",
    "publishedAt": "2021-02-12T11:57:47Z"
  },
  {
    "videoId": "wyO3N-4nTUo",
    "thumbnail": "https://i.ytimg.com/vi/wyO3N-4nTUo/mqdefault.jpg",
    "title": "【桃太郎電鉄】ホロライブ10年トライアル王決定戦！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-13T14:21:27Z"
  },
  {
    "videoId": "s97csg-WFN4",
    "thumbnail": "https://i.ytimg.com/vi/s97csg-WFN4/mqdefault.jpg",
    "title": "【犬 犬（PHOGS!）】バレンタインだし一心同体になりましょう！わんっ！【Kureiji Ollie/夏色まつり】",
    "publishedAt": "2021-02-14T12:08:54Z"
  },
  {
    "videoId": "3IKs5dr1Wd0",
    "thumbnail": "https://i.ytimg.com/vi/3IKs5dr1Wd0/mqdefault.jpg",
    "title": "【歌枠】バレンタイン！君に歌のプレゼント♡【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-14T15:43:51Z"
  },
  {
    "videoId": "yWaonILkd1g",
    "thumbnail": "https://i.ytimg.com/vi/yWaonILkd1g/mqdefault.jpg",
    "title": "【Among Us】清楚を証明します！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-15T15:21:26Z"
  },
  {
    "videoId": "HKVF62sTh4g",
    "thumbnail": "https://i.ytimg.com/vi/HKVF62sTh4g/mqdefault.jpg",
    "title": "【歌枠】ライブ前日！楽しむ準備はできてるか！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-16T15:09:35Z"
  },
  {
    "videoId": "ciQh8GrSwQk",
    "thumbnail": "https://i.ytimg.com/vi/ciQh8GrSwQk/mqdefault.jpg",
    "title": "【感想会】アイドルにしてくれてありがとう！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-18T13:10:18Z"
  },
  {
    "videoId": "6lD3Ap9FssQ",
    "thumbnail": "https://i.ytimg.com/vi/6lD3Ap9FssQ/mqdefault.jpg",
    "title": "【APEX】会話デッキ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-18T17:38:25Z"
  },
  {
    "videoId": "0eTQkv3blAA",
    "thumbnail": "https://i.ytimg.com/vi/0eTQkv3blAA/mqdefault.jpg",
    "title": "【つぐのひ】ホラー苦手なんですが余裕な気がし【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-19T16:05:32Z"
  },
  {
    "videoId": "bp90-c2fOXc",
    "thumbnail": "https://i.ytimg.com/vi/bp90-c2fOXc/mqdefault.jpg",
    "title": "【歌枠】まつり成分補充しろ～！/singing【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-24T10:27:30Z"
  },
  {
    "videoId": "vtOASL1tYF4",
    "thumbnail": "https://i.ytimg.com/vi/vtOASL1tYF4/mqdefault.jpg",
    "title": "【Among Us】推理は得意なほうなのですッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-24T13:45:47Z"
  },
  {
    "videoId": "a4ui3Td2QE4",
    "thumbnail": "https://i.ytimg.com/vi/a4ui3Td2QE4/mqdefault.jpg",
    "title": "【同時視聴】主人公は五条さんって人ですか・・・？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-25T15:00:46Z"
  },
  {
    "videoId": "K6uh2jGMtX4",
    "thumbnail": "https://i.ytimg.com/vi/K6uh2jGMtX4/mqdefault.jpg",
    "title": "【Minecraft】バグ牧場で大パニック大作戦！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-26T16:10:16Z"
  },
  {
    "videoId": "bMgTpRtxheY",
    "thumbnail": "https://i.ytimg.com/vi/bMgTpRtxheY/mqdefault.jpg",
    "title": "【APEX】ダイア帯！ソロランクチャレンジ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-27T15:16:16Z"
  },
  {
    "videoId": "PYR6t2lk3Xc",
    "thumbnail": "https://i.ytimg.com/vi/PYR6t2lk3Xc/mqdefault.jpg",
    "title": "【＃１】UNDERTALE / 初見Gルート【ホロライブ/夏色まつり】",
    "publishedAt": "2021-02-28T15:26:51Z"
  },
  {
    "videoId": "CcOd4l9zVX0",
    "thumbnail": "https://i.ytimg.com/vi/CcOd4l9zVX0/mqdefault.jpg",
    "title": "【＃2】UNDERTALE / 初見Gルート【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-01T12:17:26Z"
  },
  {
    "videoId": "04Gsa4oWoWE",
    "thumbnail": "https://i.ytimg.com/vi/04Gsa4oWoWE/mqdefault.jpg",
    "title": "【歌枠】元気っ子が癒し担当になっちゃうぞッ！/relax song【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-02T15:19:46Z"
  },
  {
    "videoId": "MkN88jkA4vk",
    "thumbnail": "https://i.ytimg.com/vi/MkN88jkA4vk/mqdefault.jpg",
    "title": "【APEX】CRカップ練習しまっ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-03T15:44:35Z"
  },
  {
    "videoId": "4LhBoySUnjA",
    "thumbnail": "https://i.ytimg.com/vi/4LhBoySUnjA/mqdefault.jpg",
    "title": "pun pun♬︎♡",
    "publishedAt": "2021-03-05T13:31:07Z"
  },
  {
    "videoId": "l9sZF3F0kFE",
    "thumbnail": "https://i.ytimg.com/vi/l9sZF3F0kFE/mqdefault.jpg",
    "title": "【犬 犬（PHOGS!）】かわいいわんこが大暴れッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-05T16:43:45Z"
  },
  {
    "videoId": "lXjcd_dcjkw",
    "thumbnail": "https://i.ytimg.com/vi/lXjcd_dcjkw/mqdefault.jpg",
    "title": "【APEX】誘われてごきげんまつりちゃ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-06T12:12:00Z"
  },
  {
    "videoId": "2ozLVMjz_Kg",
    "thumbnail": "https://i.ytimg.com/vi/2ozLVMjz_Kg/mqdefault.jpg",
    "title": "【歌枠】突然始まるよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-06T23:47:23Z"
  },
  {
    "videoId": "jyBfP35FMxI",
    "thumbnail": "https://i.ytimg.com/vi/jyBfP35FMxI/mqdefault.jpg",
    "title": "【APEX】CRカップ練習カスタム#1【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-07T16:23:23Z"
  },
  {
    "videoId": "Ew0H4G_6tsI",
    "thumbnail": "https://i.ytimg.com/vi/Ew0H4G_6tsI/mqdefault.jpg",
    "title": "run",
    "publishedAt": "2021-03-07T18:14:25Z"
  },
  {
    "videoId": "vGR9oVzcqiQ",
    "thumbnail": "https://i.ytimg.com/vi/vGR9oVzcqiQ/mqdefault.jpg",
    "title": "【APEX】CRカップ練習カスタム#2【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-08T15:44:54Z"
  },
  {
    "videoId": "OnlPD_zZPYo",
    "thumbnail": "https://i.ytimg.com/vi/OnlPD_zZPYo/mqdefault.jpg",
    "title": "ＡＮＧＲＹ",
    "publishedAt": "2021-03-08T17:15:42Z"
  },
  {
    "videoId": "Uf1Sf1D1N2M",
    "thumbnail": "https://i.ytimg.com/vi/Uf1Sf1D1N2M/mqdefault.jpg",
    "title": "【APEX】CRカップ練習カスタム#3【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-10T16:45:08Z"
  },
  {
    "videoId": "YltkLkEKi_U",
    "thumbnail": "https://i.ytimg.com/vi/YltkLkEKi_U/mqdefault.jpg",
    "title": "【ウマ娘 】今日から始まるウマ娘生活！ガチャ編！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-11T09:20:44Z"
  },
  {
    "videoId": "lslF7EgIitU",
    "thumbnail": "https://i.ytimg.com/vi/lslF7EgIitU/mqdefault.jpg",
    "title": "【APEX】大会は敵でも私たち友達だよね！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-11T11:58:24Z"
  },
  {
    "videoId": "oeOHNSYUktw",
    "thumbnail": "https://i.ytimg.com/vi/oeOHNSYUktw/mqdefault.jpg",
    "title": "【APEX】CRカップ練習カスタム#4【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-11T16:04:31Z"
  },
  {
    "videoId": "sp_qg6SfCyA",
    "thumbnail": "https://i.ytimg.com/vi/sp_qg6SfCyA/mqdefault.jpg",
    "title": "【APEX】CRカップ練習カスタム#5【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-12T17:04:25Z"
  },
  {
    "videoId": "NUXgISi5XWc",
    "thumbnail": "https://i.ytimg.com/vi/NUXgISi5XWc/mqdefault.jpg",
    "title": "?????",
    "publishedAt": "2021-03-13T11:33:18Z"
  },
  {
    "videoId": "PhSfJhxxzAQ",
    "thumbnail": "https://i.ytimg.com/vi/PhSfJhxxzAQ/mqdefault.jpg",
    "title": "【APEX】CRカップ練習カスタム#最終日【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-13T16:14:05Z"
  },
  {
    "videoId": "f5RJguGVO9E",
    "thumbnail": "https://i.ytimg.com/vi/f5RJguGVO9E/mqdefault.jpg",
    "title": "【APEX】CRカップ本番！絶対勝つ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-14T12:42:48Z"
  },
  {
    "videoId": "fj_LmKKEZPQ",
    "thumbnail": "https://i.ytimg.com/vi/fj_LmKKEZPQ/mqdefault.jpg",
    "title": "【歌枠】ホワイトデーなので歌います！お返しくださいっ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-14T16:37:27Z"
  },
  {
    "videoId": "2IXDuBpriLU",
    "thumbnail": "https://i.ytimg.com/vi/2IXDuBpriLU/mqdefault.jpg",
    "title": "【Minecraft】フェスティバルーナのエンドラ討伐激！#準備編【姫森ルーナ/夏色まつり】",
    "publishedAt": "2021-03-15T08:51:00Z"
  },
  {
    "videoId": "fZFrkKYBXpc",
    "thumbnail": "https://i.ytimg.com/vi/fZFrkKYBXpc/mqdefault.jpg",
    "title": "【Minecraft】フェスティバルーナのエンドラ討伐激！#素材集め編【姫森ルーナ/夏色まつり】",
    "publishedAt": "2021-03-17T10:55:23Z"
  },
  {
    "videoId": "VVGEwhL6ujY",
    "thumbnail": "https://i.ytimg.com/vi/VVGEwhL6ujY/mqdefault.jpg",
    "title": "To go",
    "publishedAt": "2021-03-18T13:19:56Z"
  },
  {
    "videoId": "1KfjOPXtY0Y",
    "thumbnail": "https://i.ytimg.com/vi/1KfjOPXtY0Y/mqdefault.jpg",
    "title": "【ポケモン剣盾】ポケモン交換会！メタメタモンモン～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-19T13:35:02Z"
  },
  {
    "videoId": "ps8Jbud6_Ps",
    "thumbnail": "https://i.ytimg.com/vi/ps8Jbud6_Ps/mqdefault.jpg",
    "title": "【マリオカート8DX】視聴者参加型！感覚忘れてませんか？【星街すいせい/夏色まつり】",
    "publishedAt": "2021-03-20T10:11:14Z"
  },
  {
    "videoId": "lzDOg8DQOGE",
    "thumbnail": "https://i.ytimg.com/vi/lzDOg8DQOGE/mqdefault.jpg",
    "title": "【APEX】大会一緒に出た仲なら何しても許してくれる説【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-20T15:44:10Z"
  },
  {
    "videoId": "kUDFeq-dxY8",
    "thumbnail": "https://i.ytimg.com/vi/kUDFeq-dxY8/mqdefault.jpg",
    "title": "【歌枠】かわいく歌うよ！ / Let's Singing!【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-20T16:48:57Z"
  },
  {
    "videoId": "iIf__bnqYz8",
    "thumbnail": "https://i.ytimg.com/vi/iIf__bnqYz8/mqdefault.jpg",
    "title": "【みんなで空気読み。３】空気は読むものじゃなくて吸うもの！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-21T15:13:13Z"
  },
  {
    "videoId": "lGXifUxfMe8",
    "thumbnail": "https://i.ytimg.com/vi/lGXifUxfMe8/mqdefault.jpg",
    "title": "prrrrrrrr",
    "publishedAt": "2021-03-21T18:22:29Z"
  },
  {
    "videoId": "ZrO-fIE6ALc",
    "thumbnail": "https://i.ytimg.com/vi/ZrO-fIE6ALc/mqdefault.jpg",
    "title": "【Minecraft】初心者2人の初見エンドラ討伐！【姫森ルーナ/夏色まつり】",
    "publishedAt": "2021-03-23T09:07:58Z"
  },
  {
    "videoId": "sVBURnrGGqQ",
    "thumbnail": "https://i.ytimg.com/vi/sVBURnrGGqQ/mqdefault.jpg",
    "title": "【速すぎるRPG】本編よりミニゲームが長いゲーム！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-24T14:55:31Z"
  },
  {
    "videoId": "2-mEsuP1DJo",
    "thumbnail": "https://i.ytimg.com/vi/2-mEsuP1DJo/mqdefault.jpg",
    "title": "【APEX】夜中にいきりさ、APEXしようってディスコード♪【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-25T21:25:04Z"
  },
  {
    "videoId": "tjhUj-qG54Q",
    "thumbnail": "https://i.ytimg.com/vi/tjhUj-qG54Q/mqdefault.jpg",
    "title": "【Minecraft】ホロハウスをみんなに使ってもらいたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-26T12:56:15Z"
  },
  {
    "videoId": "i5vNpoWx5WE",
    "thumbnail": "https://i.ytimg.com/vi/i5vNpoWx5WE/mqdefault.jpg",
    "title": "【耐久】90万人超耐久！歌い続けろ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-28T17:56:09Z"
  },
  {
    "videoId": "fEuhfksPlMg",
    "thumbnail": "https://i.ytimg.com/vi/fEuhfksPlMg/mqdefault.jpg",
    "title": "【Minecraft】初心者2人で海底神殿攻略チャレンジ！【姫森ルーナ/夏色まつり】",
    "publishedAt": "2021-03-29T09:15:07Z"
  },
  {
    "videoId": "2ys9IS5r9yA",
    "thumbnail": "https://i.ytimg.com/vi/2ys9IS5r9yA/mqdefault.jpg",
    "title": "空色デイズ Sorairo Days / 中川翔子 (Covered by 夏色まつり＆Gawr Gura)",
    "publishedAt": "2021-03-30T09:00:17Z"
  },
  {
    "videoId": "9JVjOw3hUSM",
    "thumbnail": "https://i.ytimg.com/vi/9JVjOw3hUSM/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】初心者ハンターの1日目！さぁ、冒険へ出かけましょう✨【ホロライブ/夏色まつり】",
    "publishedAt": "2021-03-31T16:54:43Z"
  },
  {
    "videoId": "SMCm5yq-PME",
    "thumbnail": "https://i.ytimg.com/vi/SMCm5yq-PME/mqdefault.jpg",
    "title": "【エイプリルフール】まつり(5さい)のおうたはいしん！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-01T14:50:47Z"
  },
  {
    "videoId": "FFc1IaMleW4",
    "thumbnail": "https://i.ytimg.com/vi/FFc1IaMleW4/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】初心者ハンター2日目！一気に進めるぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-02T17:05:50Z"
  },
  {
    "videoId": "W-9GEmHS2Zs",
    "thumbnail": "https://i.ytimg.com/vi/W-9GEmHS2Zs/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】気づいたらHR6になってた！？里クエすすめる！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-04T15:42:23Z"
  },
  {
    "videoId": "8qblczbIMt0",
    "thumbnail": "https://i.ytimg.com/vi/8qblczbIMt0/mqdefault.jpg",
    "title": "【APEXランク】本気だそうとしたら過去最高に緩くなったランク！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-06T11:41:59Z"
  },
  {
    "videoId": "WTuhsdWiVII",
    "thumbnail": "https://i.ytimg.com/vi/WTuhsdWiVII/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】リスナー参加型！集会所にレッツゴー！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-08T21:52:43Z"
  },
  {
    "videoId": "0skVik-rf6E",
    "thumbnail": "https://i.ytimg.com/vi/0skVik-rf6E/mqdefault.jpg",
    "title": "【APEX】ランクを垂れ流すやつをする！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-09T16:24:20Z"
  },
  {
    "videoId": "rJFvXsdOFrY",
    "thumbnail": "https://i.ytimg.com/vi/rJFvXsdOFrY/mqdefault.jpg",
    "title": "【APEX】久しぶりにライフライン行きますか！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-10T14:40:36Z"
  },
  {
    "videoId": "8nvjHibgA4I",
    "thumbnail": "https://i.ytimg.com/vi/8nvjHibgA4I/mqdefault.jpg",
    "title": "【歌枠】夜中にアニソン歌うぞいッ♪singing anime songs【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-10T17:29:06Z"
  },
  {
    "videoId": "WWRUfjkKnpQ",
    "thumbnail": "https://i.ytimg.com/vi/WWRUfjkKnpQ/mqdefault.jpg",
    "title": "【The Caregiver | 終焉介護】介護のお手伝いに・・・え、いやあああああああぁぁぁぁぁaaaaaa【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-11T15:04:39Z"
  },
  {
    "videoId": "OkhpJw6SbSw",
    "thumbnail": "https://i.ytimg.com/vi/OkhpJw6SbSw/mqdefault.jpg",
    "title": "【 Slither.io 】ぶつかったら即終了！？目指せNo.1！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-14T13:04:25Z"
  },
  {
    "videoId": "NlY1Bdnk8Lk",
    "thumbnail": "https://i.ytimg.com/vi/NlY1Bdnk8Lk/mqdefault.jpg",
    "title": "【Duolingo】Let’s study English! I'm God! / 通知表の英語の欄はいつも2です。【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-15T04:22:41Z"
  },
  {
    "videoId": "A5PAj7tJ1yI",
    "thumbnail": "https://i.ytimg.com/vi/A5PAj7tJ1yI/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】ソロでも集会所いけるの！？初の試み！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-15T18:18:56Z"
  },
  {
    "videoId": "WzLH-girQiQ",
    "thumbnail": "https://i.ytimg.com/vi/WzLH-girQiQ/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】HR7なので下位とか回復なしでもいけるよねぇ？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-16T10:17:52Z"
  },
  {
    "videoId": "5YJQlNr5s6o",
    "thumbnail": "https://i.ytimg.com/vi/5YJQlNr5s6o/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】3年も一緒なら息ピッタリだよね！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-16T13:13:10Z"
  },
  {
    "videoId": "u_He7IDSvio",
    "thumbnail": "https://i.ytimg.com/vi/u_He7IDSvio/mqdefault.jpg",
    "title": "【げりら】あそぼ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-17T19:09:16Z"
  },
  {
    "videoId": "IfVtd0Ob0VU",
    "thumbnail": "https://i.ytimg.com/vi/IfVtd0Ob0VU/mqdefault.jpg",
    "title": "【お悩み解決!】明日からお休みもらうので皆の悩みをバチッと解決しておきます！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-19T19:09:55Z"
  },
  {
    "videoId": "k9hr3N9_QxE",
    "thumbnail": "https://i.ytimg.com/vi/k9hr3N9_QxE/mqdefault.jpg",
    "title": "【APEX】朝まで遊ぼう！ね？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-20T19:38:15Z"
  },
  {
    "videoId": "T5WDu_Vp6t0",
    "thumbnail": "https://i.ytimg.com/vi/T5WDu_Vp6t0/mqdefault.jpg",
    "title": "【VALORANT】朝だね～遊ぶよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-20T21:04:09Z"
  },
  {
    "videoId": "JGFJjDI4-9U",
    "thumbnail": "https://i.ytimg.com/vi/JGFJjDI4-9U/mqdefault.jpg",
    "title": "【ただいま】さみしかったかまつりす～！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-23T16:43:11Z"
  },
  {
    "videoId": "zH9V62UOojY",
    "thumbnail": "https://i.ytimg.com/vi/zH9V62UOojY/mqdefault.jpg",
    "title": "【Minecraft】深夜だしお眠配信ですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-24T19:29:47Z"
  },
  {
    "videoId": "eBVaq3c2REc",
    "thumbnail": "https://i.ytimg.com/vi/eBVaq3c2REc/mqdefault.jpg",
    "title": "【APEX】感謝のランク配信！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-25T14:56:36Z"
  },
  {
    "videoId": "Ca6tU0j3TqQ",
    "thumbnail": "https://i.ytimg.com/vi/Ca6tU0j3TqQ/mqdefault.jpg",
    "title": "【APEX】はい！起きてます！【星街すいせい/夏色まつり】",
    "publishedAt": "2021-04-25T20:13:16Z"
  },
  {
    "videoId": "FiZy0Rk259A",
    "thumbnail": "https://i.ytimg.com/vi/FiZy0Rk259A/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】片手剣使い！神アプデきちゃぁ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-28T13:09:30Z"
  },
  {
    "videoId": "eSMI6zeqLrw",
    "thumbnail": "https://i.ytimg.com/vi/eSMI6zeqLrw/mqdefault.jpg",
    "title": "pop cat",
    "publishedAt": "2021-04-29T12:22:11Z"
  },
  {
    "videoId": "q5GNufPxdDQ",
    "thumbnail": "https://i.ytimg.com/vi/q5GNufPxdDQ/mqdefault.jpg",
    "title": "【歌枠】昭和にタイムスリップするヨ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-29T15:31:46Z"
  },
  {
    "videoId": "1NxRKQjDLo4",
    "thumbnail": "https://i.ytimg.com/vi/1NxRKQjDLo4/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】※金欠中※鉱石掘って億万長者！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-04-30T16:46:00Z"
  },
  {
    "videoId": "Z-WUSm70q9U",
    "thumbnail": "https://i.ytimg.com/vi/Z-WUSm70q9U/mqdefault.jpg",
    "title": "【スーパーボンバーマン R オンライン】生まれて初めてのボンバーマン！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-01T13:24:32Z"
  },
  {
    "videoId": "5ECJDfEBu5I",
    "thumbnail": "https://i.ytimg.com/vi/5ECJDfEBu5I/mqdefault.jpg",
    "title": "【Minecraft】睡眠導入 / まったりお話しましょ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-01T17:26:10Z"
  },
  {
    "videoId": "2j1ZyC_ZlT4",
    "thumbnail": "https://i.ytimg.com/vi/2j1ZyC_ZlT4/mqdefault.jpg",
    "title": "【Newポケモンスナップ】ポケモンだいすきクラブ出動！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-02T11:31:39Z"
  },
  {
    "videoId": "psKKVlEkHu0",
    "thumbnail": "https://i.ytimg.com/vi/psKKVlEkHu0/mqdefault.jpg",
    "title": "【APEX】オールの準備完了しました！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-02T22:28:43Z"
  },
  {
    "videoId": "gySuNrj469I",
    "thumbnail": "https://i.ytimg.com/vi/gySuNrj469I/mqdefault.jpg",
    "title": "【APEX】初めまして～💦あっ・・・スーッ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-03T10:41:57Z"
  },
  {
    "videoId": "-htsjNTaHk4",
    "thumbnail": "https://i.ytimg.com/vi/-htsjNTaHk4/mqdefault.jpg",
    "title": "【L4D2】まつり以外全員経験者！？キャリーミー！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-03T15:01:21Z"
  },
  {
    "videoId": "q99n2o9sQEc",
    "thumbnail": "https://i.ytimg.com/vi/q99n2o9sQEc/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】ねねちのハンターランクあげ！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-04T13:53:36Z"
  },
  {
    "videoId": "KZ7bTpl0cIk",
    "thumbnail": "https://i.ytimg.com/vi/KZ7bTpl0cIk/mqdefault.jpg",
    "title": "【APEX】あそびたかっただけなのに；；ｗｗｗｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-04T20:05:44Z"
  },
  {
    "videoId": "cMuhk1iRghU",
    "thumbnail": "https://i.ytimg.com/vi/cMuhk1iRghU/mqdefault.jpg",
    "title": "寝れないぺこだにぇなんだワ",
    "publishedAt": "2021-05-06T20:23:41Z"
  },
  {
    "videoId": "GkFhzL0owhg",
    "thumbnail": "https://i.ytimg.com/vi/GkFhzL0owhg/mqdefault.jpg",
    "title": "3VS3",
    "publishedAt": "2021-05-07T19:56:25Z"
  },
  {
    "videoId": "W06QUPwu0JY",
    "thumbnail": "https://i.ytimg.com/vi/W06QUPwu0JY/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/ランク→CRカスタム【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-08T16:38:05Z"
  },
  {
    "videoId": "4Cvx0unIE5I",
    "thumbnail": "https://i.ytimg.com/vi/4Cvx0unIE5I/mqdefault.jpg",
    "title": "【Newポケモンスナップ】深夜にまったりポケモン監査！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-08T20:24:02Z"
  },
  {
    "videoId": "s6WGiEDD-TQ",
    "thumbnail": "https://i.ytimg.com/vi/s6WGiEDD-TQ/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/ランク→CRカスタム#2【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-10T16:10:48Z"
  },
  {
    "videoId": "NPc4cc1l5Rk",
    "thumbnail": "https://i.ytimg.com/vi/NPc4cc1l5Rk/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/CRカスタム#3【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-11T15:52:04Z"
  },
  {
    "videoId": "64VS3Ulpr2I",
    "thumbnail": "https://i.ytimg.com/vi/64VS3Ulpr2I/mqdefault.jpg",
    "title": "【Minecraft】睡眠導入 / まったりお話～！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-11T19:31:27Z"
  },
  {
    "videoId": "xu-6ms_gLkQ",
    "thumbnail": "https://i.ytimg.com/vi/xu-6ms_gLkQ/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/CRカスタム#4【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-12T18:27:09Z"
  },
  {
    "videoId": "naMIA9mhMMQ",
    "thumbnail": "https://i.ytimg.com/vi/naMIA9mhMMQ/mqdefault.jpg",
    "title": "【歌枠】絶対に寝かしつけたいまつりちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-12T18:56:56Z"
  },
  {
    "videoId": "Ovw9BypURUI",
    "thumbnail": "https://i.ytimg.com/vi/Ovw9BypURUI/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/CRカスタム#5【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-13T16:05:16Z"
  },
  {
    "videoId": "tpVtbVVBnSs",
    "thumbnail": "https://i.ytimg.com/vi/tpVtbVVBnSs/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/CRカスタム#6【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-14T19:18:15Z"
  },
  {
    "videoId": "zCsjFi9ppY0",
    "thumbnail": "https://i.ytimg.com/vi/zCsjFi9ppY0/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/CRカップ本番前練習会！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-15T08:54:03Z"
  },
  {
    "videoId": "JjnM36syho4",
    "thumbnail": "https://i.ytimg.com/vi/JjnM36syho4/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組/CRカスタム本番！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-15T13:00:10Z"
  },
  {
    "videoId": "zxvJegPk8v0",
    "thumbnail": "https://i.ytimg.com/vi/zxvJegPk8v0/mqdefault.jpg",
    "title": "【おはよう】朝活の時間じゃ～！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-16T00:44:34Z"
  },
  {
    "videoId": "OKbS_LPVVRU",
    "thumbnail": "https://i.ytimg.com/vi/OKbS_LPVVRU/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】ねねちは強くなる女です！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-16T16:11:37Z"
  },
  {
    "videoId": "jDANZuw6IDM",
    "thumbnail": "https://i.ytimg.com/vi/jDANZuw6IDM/mqdefault.jpg",
    "title": "【Minecraft】睡眠導入 / ムーンハウス作成！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-16T19:43:44Z"
  },
  {
    "videoId": "VcYGuSR6zpM",
    "thumbnail": "https://i.ytimg.com/vi/VcYGuSR6zpM/mqdefault.jpg",
    "title": "【APEX】にこにこランク～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-17T18:25:52Z"
  },
  {
    "videoId": "GOwrVBau7kM",
    "thumbnail": "https://i.ytimg.com/vi/GOwrVBau7kM/mqdefault.jpg",
    "title": "【日本地図テスト】中間テストは地理16点でした。自信だけはあります！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-18T14:13:55Z"
  },
  {
    "videoId": "xAAIsirmPco",
    "thumbnail": "https://i.ytimg.com/vi/xAAIsirmPco/mqdefault.jpg",
    "title": "【歌枠】アニソンうたうぞー！/singing anime songs【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-19T14:16:03Z"
  },
  {
    "videoId": "EbQ2a-khQkM",
    "thumbnail": "https://i.ytimg.com/vi/EbQ2a-khQkM/mqdefault.jpg",
    "title": "【世界のアソビ大全51】配信外でもアソビまくってます！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-21T15:54:28Z"
  },
  {
    "videoId": "Yb8r6cB2b_k",
    "thumbnail": "https://i.ytimg.com/vi/Yb8r6cB2b_k/mqdefault.jpg",
    "title": "【Minecraft】睡眠導入 / 大空建設としてがんばるぞっ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-22T16:48:34Z"
  },
  {
    "videoId": "aoyXaLxmrjw",
    "thumbnail": "https://i.ytimg.com/vi/aoyXaLxmrjw/mqdefault.jpg",
    "title": "【ダンガンロンパ】超高校級の清楚参上！華麗に謎を解くッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-23T12:18:31Z"
  },
  {
    "videoId": "1tRcfgtjCCg",
    "thumbnail": "https://i.ytimg.com/vi/1tRcfgtjCCg/mqdefault.jpg",
    "title": "【朝活】おはようのあさまちゅ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-24T00:37:44Z"
  },
  {
    "videoId": "PiAKDqqf0NU",
    "thumbnail": "https://i.ytimg.com/vi/PiAKDqqf0NU/mqdefault.jpg",
    "title": "【ダンガンロンパ】絶対に見逃さない！論破！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-25T14:09:04Z"
  },
  {
    "videoId": "0rRr8Dpy9K4",
    "thumbnail": "https://i.ytimg.com/vi/0rRr8Dpy9K4/mqdefault.jpg",
    "title": "【ダンガンロンパ】ついにクライマックス！探索→学級会議！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-26T11:53:24Z"
  },
  {
    "videoId": "Ru7OFsuHa8s",
    "thumbnail": "https://i.ytimg.com/vi/Ru7OFsuHa8s/mqdefault.jpg",
    "title": "くらべられっ子 / ツユ (Covered by 夏色まつり)",
    "publishedAt": "2021-05-26T15:00:13Z"
  },
  {
    "videoId": "kpMqkFocHbM",
    "thumbnail": "https://i.ytimg.com/vi/kpMqkFocHbM/mqdefault.jpg",
    "title": "【朝活】おはよう！あさまちゅ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-27T00:39:56Z"
  },
  {
    "videoId": "SAoZrDbJaOk",
    "thumbnail": "https://i.ytimg.com/vi/SAoZrDbJaOk/mqdefault.jpg",
    "title": "【#from1st前夜祭】ついに明日はライブ当日だぁ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-27T12:33:56Z"
  },
  {
    "videoId": "iiqvVO7Us38",
    "thumbnail": "https://i.ytimg.com/vi/iiqvVO7Us38/mqdefault.jpg",
    "title": "#from1st ライブ感想会",
    "publishedAt": "2021-05-29T16:23:42Z"
  },
  {
    "videoId": "IeE_4w_-B-w",
    "thumbnail": "https://i.ytimg.com/vi/IeE_4w_-B-w/mqdefault.jpg",
    "title": "【世界のアソビ大全51】あそびた～い！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-30T10:32:13Z"
  },
  {
    "videoId": "n7EE_wuGnc0",
    "thumbnail": "https://i.ytimg.com/vi/n7EE_wuGnc0/mqdefault.jpg",
    "title": "【APEXガチャ】半年間徳をつみました。いけます！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-30T15:15:42Z"
  },
  {
    "videoId": "w-3RU9QvUcE",
    "thumbnail": "https://i.ytimg.com/vi/w-3RU9QvUcE/mqdefault.jpg",
    "title": "【3rd anniversary】3周年カウントダウンじゃーい！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-05-31T15:10:11Z"
  },
  {
    "videoId": "SPyhmWLg9xM",
    "thumbnail": "https://i.ytimg.com/vi/SPyhmWLg9xM/mqdefault.jpg",
    "title": "【100万人耐久】歌って歌って歌い続けろ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-01T08:30:50Z"
  },
  {
    "videoId": "o-7kgTUKyOA",
    "thumbnail": "https://i.ytimg.com/vi/o-7kgTUKyOA/mqdefault.jpg",
    "title": "【#夏色まつり3周年】3周年だ！あれもこれも見せちゃいます！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-01T12:57:35Z"
  },
  {
    "videoId": "TUb9mM2HA_U",
    "thumbnail": "https://i.ytimg.com/vi/TUb9mM2HA_U/mqdefault.jpg",
    "title": "【APEX】初顔合わせ！ばり緊張しとる～＾【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-03T15:56:38Z"
  },
  {
    "videoId": "ZsVnMMOm74Q",
    "thumbnail": "https://i.ytimg.com/vi/ZsVnMMOm74Q/mqdefault.jpg",
    "title": "【#ホロカラ覗き見】ホロライブのカラオケを覗き見!? / 3Dstream【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-04T11:17:10Z"
  },
  {
    "videoId": "1mLi4HxwgYY",
    "thumbnail": "https://i.ytimg.com/vi/1mLi4HxwgYY/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】筋肉が悲鳴をあげる。【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-05T10:46:17Z"
  },
  {
    "videoId": "l_az0NPThvw",
    "thumbnail": "https://i.ytimg.com/vi/l_az0NPThvw/mqdefault.jpg",
    "title": "【歌枠】かわいくうたうよ♡【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-07T15:56:55Z"
  },
  {
    "videoId": "zq2f6BUPS1s",
    "thumbnail": "https://i.ytimg.com/vi/zq2f6BUPS1s/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】本気のダイエット！#1【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-09T08:57:00Z"
  },
  {
    "videoId": "YYeHnux1vKc",
    "thumbnail": "https://i.ytimg.com/vi/YYeHnux1vKc/mqdefault.jpg",
    "title": "【APEX】つっこめええええええ！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-10T14:41:21Z"
  },
  {
    "videoId": "dBJtgHCvKSM",
    "thumbnail": "https://i.ytimg.com/vi/dBJtgHCvKSM/mqdefault.jpg",
    "title": "【APEX】カスタム練習最終日ですが！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-11T15:09:54Z"
  },
  {
    "videoId": "Mf0-nJ8KvCI",
    "thumbnail": "https://i.ytimg.com/vi/Mf0-nJ8KvCI/mqdefault.jpg",
    "title": "【APEX】本番直前カジュアル！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-12T09:02:45Z"
  },
  {
    "videoId": "MU7huAiZ66Q",
    "thumbnail": "https://i.ytimg.com/vi/MU7huAiZ66Q/mqdefault.jpg",
    "title": "【APEX】#にじPEX 本番！全力で楽しもう！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-12T13:28:27Z"
  },
  {
    "videoId": "ZWefP1vdIc4",
    "thumbnail": "https://i.ytimg.com/vi/ZWefP1vdIc4/mqdefault.jpg",
    "title": "【 例外配達／Night Delivery】この配達が終わったら、彼女に会いに行くんだ・・・【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-13T16:39:58Z"
  },
  {
    "videoId": "VbydjE51sgY",
    "thumbnail": "https://i.ytimg.com/vi/VbydjE51sgY/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖Ver1.17　最新アプデでウーパールーパーGET!!【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-14T16:29:17Z"
  },
  {
    "videoId": "aS8iePgIRcw",
    "thumbnail": "https://i.ytimg.com/vi/aS8iePgIRcw/mqdefault.jpg",
    "title": "【Overcooked2】新人バイトが来ました。【不磨わっと/夏色まつり】",
    "publishedAt": "2021-06-15T13:44:45Z"
  },
  {
    "videoId": "PtgxoyWM3bc",
    "thumbnail": "https://i.ytimg.com/vi/PtgxoyWM3bc/mqdefault.jpg",
    "title": "【APEX】顔合わせの約束時間の2分前に起きた女【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-17T07:15:48Z"
  },
  {
    "videoId": "rG3M8HauNcM",
    "thumbnail": "https://i.ytimg.com/vi/rG3M8HauNcM/mqdefault.jpg",
    "title": "【APEX】謎メンカスタム練習【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-17T13:49:26Z"
  },
  {
    "videoId": "qMCVnQ9Qyj4",
    "thumbnail": "https://i.ytimg.com/vi/qMCVnQ9Qyj4/mqdefault.jpg",
    "title": "【歌枠】深夜の癒しお歌配信【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-17T16:43:43Z"
  },
  {
    "videoId": "yG-eaFkWMP8",
    "thumbnail": "https://i.ytimg.com/vi/yG-eaFkWMP8/mqdefault.jpg",
    "title": "【APEX】VISCt 本番！楽しんでいこ～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-19T12:45:18Z"
  },
  {
    "videoId": "f8MnQVSAObk",
    "thumbnail": "https://i.ytimg.com/vi/f8MnQVSAObk/mqdefault.jpg",
    "title": "【APEX】ぶいあぱの保管庫と乙女ゲーにでてきそうな子とランク【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-21T14:06:10Z"
  },
  {
    "videoId": "-E02OJdHic4",
    "thumbnail": "https://i.ytimg.com/vi/-E02OJdHic4/mqdefault.jpg",
    "title": "【#大空建設】この中にマイクラ得意な人おりゅ？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-23T12:41:59Z"
  },
  {
    "videoId": "3X3QoofzG38",
    "thumbnail": "https://i.ytimg.com/vi/3X3QoofzG38/mqdefault.jpg",
    "title": "【モーリーオンライン】夏色吹雪絶対ほしい！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-24T13:43:43Z"
  },
  {
    "videoId": "yXUPlFjikr0",
    "thumbnail": "https://i.ytimg.com/vi/yXUPlFjikr0/mqdefault.jpg",
    "title": "太陽になれるかな / ツユ (Covered by 夏色まつり)",
    "publishedAt": "2021-06-25T15:00:15Z"
  },
  {
    "videoId": "RS7KqotAwlY",
    "thumbnail": "https://i.ytimg.com/vi/RS7KqotAwlY/mqdefault.jpg",
    "title": "【歌枠】歌みたあげたよ！癒し歌枠～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-26T15:47:30Z"
  },
  {
    "videoId": "HInPynvwYko",
    "thumbnail": "https://i.ytimg.com/vi/HInPynvwYko/mqdefault.jpg",
    "title": "【#うさ建夏祭り】この夏一番の思い出作りぺこ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-27T15:09:02Z"
  },
  {
    "videoId": "EBaHhUAvepE",
    "thumbnail": "https://i.ytimg.com/vi/EBaHhUAvepE/mqdefault.jpg",
    "title": "【 #ラグオリ】視聴者参加型！新たな冒険に出かけよう！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-29T13:12:11Z"
  },
  {
    "videoId": "IT2Nlh3WWbY",
    "thumbnail": "https://i.ytimg.com/vi/IT2Nlh3WWbY/mqdefault.jpg",
    "title": "【APEX】スカルタウンってどこですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-06-29T19:36:38Z"
  },
  {
    "videoId": "Tv3MSVm7nRE",
    "thumbnail": "https://i.ytimg.com/vi/Tv3MSVm7nRE/mqdefault.jpg",
    "title": "すこしだけ",
    "publishedAt": "2021-07-01T14:33:18Z"
  },
  {
    "videoId": "1Lrzy4z9tOI",
    "thumbnail": "https://i.ytimg.com/vi/1Lrzy4z9tOI/mqdefault.jpg",
    "title": "【歌枠】最強アイドルによるかわいいお歌♪【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-02T11:13:08Z"
  },
  {
    "videoId": "37VlnQvt5ns",
    "thumbnail": "https://i.ytimg.com/vi/37VlnQvt5ns/mqdefault.jpg",
    "title": "【Minecraft】おまつりまだ間に合いますか？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-03T15:04:11Z"
  },
  {
    "videoId": "dndIfSNTutc",
    "thumbnail": "https://i.ytimg.com/vi/dndIfSNTutc/mqdefault.jpg",
    "title": "【Minecraft】よふかし('ω')✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-05T18:57:36Z"
  },
  {
    "videoId": "AieynXbEPho",
    "thumbnail": "https://i.ytimg.com/vi/AieynXbEPho/mqdefault.jpg",
    "title": "【VALORANT】初心者でもランクしていいですか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-08T16:24:34Z"
  },
  {
    "videoId": "oBR1WJ3D-xg",
    "thumbnail": "https://i.ytimg.com/vi/oBR1WJ3D-xg/mqdefault.jpg",
    "title": "【歌枠】雨の日は一緒にいたくなりますよね【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-11T15:25:56Z"
  },
  {
    "videoId": "VXQR_B_sB-o",
    "thumbnail": "https://i.ytimg.com/vi/VXQR_B_sB-o/mqdefault.jpg",
    "title": "フルスクリーンブロンズなんでちゅ",
    "publishedAt": "2021-07-12T09:32:24Z"
  },
  {
    "videoId": "P6fE7IKXdM0",
    "thumbnail": "https://i.ytimg.com/vi/P6fE7IKXdM0/mqdefault.jpg",
    "title": "【APEX】本当に集まって大丈夫なんですか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-12T11:42:21Z"
  },
  {
    "videoId": "KFmkiIesH2k",
    "thumbnail": "https://i.ytimg.com/vi/KFmkiIesH2k/mqdefault.jpg",
    "title": "【APEX】FFL SELeCT CUP / 顔合わせ＆カスタム1日目！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-14T15:58:44Z"
  },
  {
    "videoId": "Efgg0NIS-AI",
    "thumbnail": "https://i.ytimg.com/vi/Efgg0NIS-AI/mqdefault.jpg",
    "title": "【おはよう】ちょこ先生をまったりまちます～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-14T23:31:09Z"
  },
  {
    "videoId": "71ItRFQUyic",
    "thumbnail": "https://i.ytimg.com/vi/71ItRFQUyic/mqdefault.jpg",
    "title": "【APEX】FFL SELeCT CUP / 顔合わせ＆カスタム2日目！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-15T15:42:18Z"
  },
  {
    "videoId": "KOAYVYCmWkM",
    "thumbnail": "https://i.ytimg.com/vi/KOAYVYCmWkM/mqdefault.jpg",
    "title": "【APEX】FFL SELeCT CUP / カスタム練習最終日！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-16T15:37:10Z"
  },
  {
    "videoId": "RAh_CDEHQ6g",
    "thumbnail": "https://i.ytimg.com/vi/RAh_CDEHQ6g/mqdefault.jpg",
    "title": "【Minecraft】青ウパまだ間に合う？？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-17T10:00:35Z"
  },
  {
    "videoId": "6bjwt6nOX3U",
    "thumbnail": "https://i.ytimg.com/vi/6bjwt6nOX3U/mqdefault.jpg",
    "title": "【告知】来週は誕生日ですね？？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-17T15:23:17Z"
  },
  {
    "videoId": "Pbrg5hHex3A",
    "thumbnail": "https://i.ytimg.com/vi/Pbrg5hHex3A/mqdefault.jpg",
    "title": "【APEX】FFL SELeCT CUP / 大会本番！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-18T13:47:26Z"
  },
  {
    "videoId": "VL6PS3QHHsE",
    "thumbnail": "https://i.ytimg.com/vi/VL6PS3QHHsE/mqdefault.jpg",
    "title": "まつりの運動神経 / Motor nerves",
    "publishedAt": "2021-07-21T04:09:57Z"
  },
  {
    "videoId": "C-J0mGVamNc",
    "thumbnail": "https://i.ytimg.com/vi/C-J0mGVamNc/mqdefault.jpg",
    "title": "【#夏色まつり生誕祭】4回目のバースデー♪【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-22T12:59:22Z"
  },
  {
    "videoId": "-ivI-Vb920I",
    "thumbnail": "https://i.ytimg.com/vi/-ivI-Vb920I/mqdefault.jpg",
    "title": "【オリジナル曲】HiHiハイテンション!",
    "publishedAt": "2021-07-22T13:30:09Z"
  },
  {
    "videoId": "n7hZx0cW1hg",
    "thumbnail": "https://i.ytimg.com/vi/n7hZx0cW1hg/mqdefault.jpg",
    "title": "【ポケモンユナイト】初プレイ！最強キャラってなんだろう？？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-23T18:44:05Z"
  },
  {
    "videoId": "dHnFHQSGK3Q",
    "thumbnail": "https://i.ytimg.com/vi/dHnFHQSGK3Q/mqdefault.jpg",
    "title": "ルーザーガール / ツユ (Covered by 夏色まつり)【オリジナルMV】",
    "publishedAt": "2021-07-25T11:30:13Z"
  },
  {
    "videoId": "vkhQq7fhbFg",
    "thumbnail": "https://i.ytimg.com/vi/vkhQq7fhbFg/mqdefault.jpg",
    "title": "【歌枠】夏だ！祭だ！歌枠だぁ！ / 歌ってみた同時視聴【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-25T12:50:00Z"
  },
  {
    "videoId": "q6fC2_ywBVk",
    "thumbnail": "https://i.ytimg.com/vi/q6fC2_ywBVk/mqdefault.jpg",
    "title": "【Gartic Phone】まつりすとお絵かき伝言ゲーム！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-25T16:11:00Z"
  },
  {
    "videoId": "VwRCVFsoZNo",
    "thumbnail": "https://i.ytimg.com/vi/VwRCVFsoZNo/mqdefault.jpg",
    "title": "【APEX】視聴者参加型カスタム！テスト編【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-28T14:51:45Z"
  },
  {
    "videoId": "tug2L6uFme0",
    "thumbnail": "https://i.ytimg.com/vi/tug2L6uFme0/mqdefault.jpg",
    "title": "【ポケモンユナイト】二人でなら勝率5億％！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-07-31T04:02:35Z"
  },
  {
    "videoId": "stmq4PMKd40",
    "thumbnail": "https://i.ytimg.com/vi/stmq4PMKd40/mqdefault.jpg",
    "title": "【同時視聴】犬鳴村　恐怖回避ばーじょん！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-01T08:55:56Z"
  },
  {
    "videoId": "2Ae1MBuuIcM",
    "thumbnail": "https://i.ytimg.com/vi/2Ae1MBuuIcM/mqdefault.jpg",
    "title": "【歌枠】8月最初のおうた！夏を乗り越えるぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-01T15:19:10Z"
  },
  {
    "videoId": "eCrZIw2zmZk",
    "thumbnail": "https://i.ytimg.com/vi/eCrZIw2zmZk/mqdefault.jpg",
    "title": "【APEX】初顔合わせ！マブ２人集合させました✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-02T16:10:33Z"
  },
  {
    "videoId": "5lkY6F3cOW8",
    "thumbnail": "https://i.ytimg.com/vi/5lkY6F3cOW8/mqdefault.jpg",
    "title": "ILoveYou",
    "publishedAt": "2021-08-02T20:02:34Z"
  },
  {
    "videoId": "pETVWMhjL34",
    "thumbnail": "https://i.ytimg.com/vi/pETVWMhjL34/mqdefault.jpg",
    "title": "【APEX】メンヘラ三銃士を連れてきたよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-05T17:06:16Z"
  },
  {
    "videoId": "kMXEpTAlVcA",
    "thumbnail": "https://i.ytimg.com/vi/kMXEpTAlVcA/mqdefault.jpg",
    "title": "【雑談】激レア雑談！いろいろはなそ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-08T07:52:25Z"
  },
  {
    "videoId": "N1ykpGcwD_E",
    "thumbnail": "https://i.ytimg.com/vi/N1ykpGcwD_E/mqdefault.jpg",
    "title": "【ポケモンユナイト】夏色吹雪なら無双できるよなぁ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-10T13:23:41Z"
  },
  {
    "videoId": "LfZNBr-00vw",
    "thumbnail": "https://i.ytimg.com/vi/LfZNBr-00vw/mqdefault.jpg",
    "title": "【APEX】RENSHU✌/視聴者参加型カスタム【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-11T17:28:49Z"
  },
  {
    "videoId": "vrL5EvwF4FY",
    "thumbnail": "https://i.ytimg.com/vi/vrL5EvwF4FY/mqdefault.jpg",
    "title": "【Minecraft】ハードコアで生き残れ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-12T07:30:37Z"
  },
  {
    "videoId": "0Phc8DvFjtI",
    "thumbnail": "https://i.ytimg.com/vi/0Phc8DvFjtI/mqdefault.jpg",
    "title": "【歌枠】バラードで癒します / Ballade Song【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-12T15:16:42Z"
  },
  {
    "videoId": "xN4SHAfl5pY",
    "thumbnail": "https://i.ytimg.com/vi/xN4SHAfl5pY/mqdefault.jpg",
    "title": "【Minecraft】ハードコアで生き残れ！2世界目【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-13T17:04:27Z"
  },
  {
    "videoId": "NFbn6ZduOyI",
    "thumbnail": "https://i.ytimg.com/vi/NFbn6ZduOyI/mqdefault.jpg",
    "title": "【APEX】火力を守ります【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-16T15:10:49Z"
  },
  {
    "videoId": "64YZd-lZ-vQ",
    "thumbnail": "https://i.ytimg.com/vi/64YZd-lZ-vQ/mqdefault.jpg",
    "title": "【よ！】おきた！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-17T01:00:49Z"
  },
  {
    "videoId": "xwo5Kt6W-OU",
    "thumbnail": "https://i.ytimg.com/vi/xwo5Kt6W-OU/mqdefault.jpg",
    "title": "【APEX】ちょっと強気な2日目カスタム【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-17T15:09:41Z"
  },
  {
    "videoId": "b748TNCX7Bk",
    "thumbnail": "https://i.ytimg.com/vi/b748TNCX7Bk/mqdefault.jpg",
    "title": "【Minecraft】ハードコアで生き残れ！2世界目#2【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-17T18:58:01Z"
  },
  {
    "videoId": "Mm8Ej2xG_O8",
    "thumbnail": "https://i.ytimg.com/vi/Mm8Ej2xG_O8/mqdefault.jpg",
    "title": "SummerTime / cinnamons × evening cinema(Covered by 夏色まつり&夕刻ロベル)",
    "publishedAt": "2021-08-18T10:00:12Z"
  },
  {
    "videoId": "GD8qpt_eb_Y",
    "thumbnail": "https://i.ytimg.com/vi/GD8qpt_eb_Y/mqdefault.jpg",
    "title": "【APEX】Lスターと4日カスタム【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-19T15:41:53Z"
  },
  {
    "videoId": "iyXAdZMH3zc",
    "thumbnail": "https://i.ytimg.com/vi/iyXAdZMH3zc/mqdefault.jpg",
    "title": "【APEX】きらきらエネルギー【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-20T15:29:07Z"
  },
  {
    "videoId": "XK9C19MQ1qw",
    "thumbnail": "https://i.ytimg.com/vi/XK9C19MQ1qw/mqdefault.jpg",
    "title": "【#ホロ鯖ENポータルリレー / #HOLOserverPORTAL】装飾担当('ω')✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-21T08:01:08Z"
  },
  {
    "videoId": "wffLxqqAl4I",
    "thumbnail": "https://i.ytimg.com/vi/wffLxqqAl4I/mqdefault.jpg",
    "title": "【APEX】初動の圧を求めて。前夜祭もあるよ～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-21T14:31:20Z"
  },
  {
    "videoId": "Advb4d8YyZw",
    "thumbnail": "https://i.ytimg.com/vi/Advb4d8YyZw/mqdefault.jpg",
    "title": "【APEX】VTuber最協決定戦本番！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-22T13:50:44Z"
  },
  {
    "videoId": "3VUwGAzolHU",
    "thumbnail": "https://i.ytimg.com/vi/3VUwGAzolHU/mqdefault.jpg",
    "title": "【APEX】VTuber最協決定戦後夜祭！/時間未定【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-22T18:54:43Z"
  },
  {
    "videoId": "o8Nj1H5lQM0",
    "thumbnail": "https://i.ytimg.com/vi/o8Nj1H5lQM0/mqdefault.jpg",
    "title": "ほかほか",
    "publishedAt": "2021-08-23T12:39:40Z"
  },
  {
    "videoId": "RqGFosJpz-M",
    "thumbnail": "https://i.ytimg.com/vi/RqGFosJpz-M/mqdefault.jpg",
    "title": "【５さい】おうたをうたいます【ホロライブ/夏色まつり】",
    "publishedAt": "2021-08-31T15:26:40Z"
  },
  {
    "videoId": "9QNUsp2g33A",
    "thumbnail": "https://i.ytimg.com/vi/9QNUsp2g33A/mqdefault.jpg",
    "title": "【帰り道/The Night Way Home】夏色吹雪で怖すぎる下校道【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-01T13:23:16Z"
  },
  {
    "videoId": "GIyivoFEYhs",
    "thumbnail": "https://i.ytimg.com/vi/GIyivoFEYhs/mqdefault.jpg",
    "title": "【デレステ】データ消えたのでガチャひかせてください！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-02T15:39:01Z"
  },
  {
    "videoId": "OgrkkhX8ofU",
    "thumbnail": "https://i.ytimg.com/vi/OgrkkhX8ofU/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖に作りたいものがあるよ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-03T17:42:46Z"
  },
  {
    "videoId": "loL40i1Jm_E",
    "thumbnail": "https://i.ytimg.com/vi/loL40i1Jm_E/mqdefault.jpg",
    "title": "【Minecraft】深夜ならほろ鯖にいたずらしてもバレない説！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-05T17:46:46Z"
  },
  {
    "videoId": "c1UfiMpJDPI",
    "thumbnail": "https://i.ytimg.com/vi/c1UfiMpJDPI/mqdefault.jpg",
    "title": "【APEX】rprさんとイカさんには洗礼を受けてもらいます✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-06T11:58:18Z"
  },
  {
    "videoId": "4LuPx5btxNo",
    "thumbnail": "https://i.ytimg.com/vi/4LuPx5btxNo/mqdefault.jpg",
    "title": "【歌枠】いろんな曲をたくさん歌うの会！/singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-07T15:43:34Z"
  },
  {
    "videoId": "fSgyfjY6jV4",
    "thumbnail": "https://i.ytimg.com/vi/fSgyfjY6jV4/mqdefault.jpg",
    "title": "【NGなし!?】スーパーアイドルがどんな質問でも答えます！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-09T15:28:28Z"
  },
  {
    "videoId": "ds3bEt4gn8o",
    "thumbnail": "https://i.ytimg.com/vi/ds3bEt4gn8o/mqdefault.jpg",
    "title": "【Phasmophobia】自分よりビビりがいたらホラーも怖くない説！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-11T16:38:33Z"
  },
  {
    "videoId": "iV01zjhd4kY",
    "thumbnail": "https://i.ytimg.com/vi/iV01zjhd4kY/mqdefault.jpg",
    "title": "【おすそわけるメイドインワリオ】おすそわけません。全部俺のものです【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-13T11:12:50Z"
  },
  {
    "videoId": "lEz32I1hmeM",
    "thumbnail": "https://i.ytimg.com/vi/lEz32I1hmeM/mqdefault.jpg",
    "title": "【APEX】何メンランク？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-13T16:24:55Z"
  },
  {
    "videoId": "HH1LDj4e1Hg",
    "thumbnail": "https://i.ytimg.com/vi/HH1LDj4e1Hg/mqdefault.jpg",
    "title": "【Phasmophobia】ソロでも無敵説でてきてます！レベ上げ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-14T17:29:22Z"
  },
  {
    "videoId": "rk1cMCuOSBM",
    "thumbnail": "https://i.ytimg.com/vi/rk1cMCuOSBM/mqdefault.jpg",
    "title": "【Phasmophobia】レベル1番低いですが関係ありません【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-15T12:45:56Z"
  },
  {
    "videoId": "XFZ0qKdWxuA",
    "thumbnail": "https://i.ytimg.com/vi/XFZ0qKdWxuA/mqdefault.jpg",
    "title": "【歌枠】どんな夜をおすごしですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-17T16:02:57Z"
  },
  {
    "videoId": "jnEfOYS9aDo",
    "thumbnail": "https://i.ytimg.com/vi/jnEfOYS9aDo/mqdefault.jpg",
    "title": "【Phasmophobia】キャリーします✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-19T14:41:38Z"
  },
  {
    "videoId": "yqA2QHRfDyo",
    "thumbnail": "https://i.ytimg.com/vi/yqA2QHRfDyo/mqdefault.jpg",
    "title": "【ぷよテト２】星街がいれば初心者でも1時間で成長できる説！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-20T15:06:39Z"
  },
  {
    "videoId": "N65CHVJ_PQ0",
    "thumbnail": "https://i.ytimg.com/vi/N65CHVJ_PQ0/mqdefault.jpg",
    "title": "【ポケモンDP】シオンと対決！愛しのぽっちゃまと一緒に勝つ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-23T13:45:59Z"
  },
  {
    "videoId": "LmWTu_XhAe8",
    "thumbnail": "https://i.ytimg.com/vi/LmWTu_XhAe8/mqdefault.jpg",
    "title": "【Phasmophobia】にじホロ幽霊調査隊！ホロメンはにこにこです✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-24T13:27:31Z"
  },
  {
    "videoId": "PLDne95aE54",
    "thumbnail": "https://i.ytimg.com/vi/PLDne95aE54/mqdefault.jpg",
    "title": "【#夏色まつり新衣装】かっこかわいいとはまつりのことよ！！ / New costume【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-25T12:56:57Z"
  },
  {
    "videoId": "udNejjPETRY",
    "thumbnail": "https://i.ytimg.com/vi/udNejjPETRY/mqdefault.jpg",
    "title": "【朝活】おはようのあさまちゅ会！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-25T23:52:56Z"
  },
  {
    "videoId": "o034MGboh-g",
    "thumbnail": "https://i.ytimg.com/vi/o034MGboh-g/mqdefault.jpg",
    "title": "【It takes two】協力余裕だよね！！・・・ってねねち？！？！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-28T13:30:38Z"
  },
  {
    "videoId": "yPjMc4L3HXU",
    "thumbnail": "https://i.ytimg.com/vi/yPjMc4L3HXU/mqdefault.jpg",
    "title": "【APEX】罵られたい女VS口悪APEX最強男【ホロライブ/夏色まつり】",
    "publishedAt": "2021-09-28T16:44:23Z"
  },
  {
    "videoId": "ZGYT1x4bNUo",
    "thumbnail": "https://i.ytimg.com/vi/ZGYT1x4bNUo/mqdefault.jpg",
    "title": "シンデレラ/夏色まつり(cover)",
    "publishedAt": "2021-09-30T10:00:14Z"
  },
  {
    "videoId": "7PGQIrHeMf8",
    "thumbnail": "https://i.ytimg.com/vi/7PGQIrHeMf8/mqdefault.jpg",
    "title": "【スーパー マリオパーティ】バチボコ！？楽しくガチバトル！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-01T14:45:56Z"
  },
  {
    "videoId": "8ZkOVA0WWAE",
    "thumbnail": "https://i.ytimg.com/vi/8ZkOVA0WWAE/mqdefault.jpg",
    "title": "【APEX】え？レイス使うんじゃないんですか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-03T16:02:30Z"
  },
  {
    "videoId": "ZmjH0JlbCak",
    "thumbnail": "https://i.ytimg.com/vi/ZmjH0JlbCak/mqdefault.jpg",
    "title": "【APEX】あーさーさんに泣かされる準備はできてるか？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-05T16:23:57Z"
  },
  {
    "videoId": "se257gE8M9M",
    "thumbnail": "https://i.ytimg.com/vi/se257gE8M9M/mqdefault.jpg",
    "title": "【歌枠】ねれない人のためのまったり歌枠【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-06T18:07:21Z"
  },
  {
    "videoId": "DKB35LoRpLk",
    "thumbnail": "https://i.ytimg.com/vi/DKB35LoRpLk/mqdefault.jpg",
    "title": "【APEX】声だしていこおおおおおおおおおおおおおお【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-07T14:22:57Z"
  },
  {
    "videoId": "52QvreBE96Y",
    "thumbnail": "https://i.ytimg.com/vi/52QvreBE96Y/mqdefault.jpg",
    "title": "【APEX】あふぅ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-08T16:15:37Z"
  },
  {
    "videoId": "Ypl7Wo-bsME",
    "thumbnail": "https://i.ytimg.com/vi/Ypl7Wo-bsME/mqdefault.jpg",
    "title": "【APEX】CRカップ本番！！プラウラーには負けません・・・【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-09T13:15:20Z"
  },
  {
    "videoId": "OjQNKNT5jQY",
    "thumbnail": "https://i.ytimg.com/vi/OjQNKNT5jQY/mqdefault.jpg",
    "title": "【開封/カメラ枠】ヴァイスシュヴァルツ×ホロライブ / サインカード何枚でる！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-11T12:06:27Z"
  },
  {
    "videoId": "MsnqT15GhNY",
    "thumbnail": "https://i.ytimg.com/vi/MsnqT15GhNY/mqdefault.jpg",
    "title": "matsuri god video🤣🤣",
    "publishedAt": "2021-10-13T10:34:56Z"
  },
  {
    "videoId": "n1nKfEI32Po",
    "thumbnail": "https://i.ytimg.com/vi/n1nKfEI32Po/mqdefault.jpg",
    "title": "【開封/カメラ枠】ヴァイスシュヴァルツ×ホロライブ / 自分のだしたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-13T15:17:58Z"
  },
  {
    "videoId": "cIbY4zejR6A",
    "thumbnail": "https://i.ytimg.com/vi/cIbY4zejR6A/mqdefault.jpg",
    "title": "【晩酌】おひさしぶりに呑むZE！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-14T15:08:25Z"
  },
  {
    "videoId": "RXGH7TXZSqE",
    "thumbnail": "https://i.ytimg.com/vi/RXGH7TXZSqE/mqdefault.jpg",
    "title": "【歌枠】アニソン歌うしかねぇよなぁ！？ / singing anime song【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-15T16:42:28Z"
  },
  {
    "videoId": "00AvKYA6AGY",
    "thumbnail": "https://i.ytimg.com/vi/00AvKYA6AGY/mqdefault.jpg",
    "title": "【APEX】え？ソロランクですか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-16T21:51:34Z"
  },
  {
    "videoId": "Ws5Y6OPTHBs",
    "thumbnail": "https://i.ytimg.com/vi/Ws5Y6OPTHBs/mqdefault.jpg",
    "title": "【あさ】おはようのあさまちゅ✌【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-18T23:59:31Z"
  },
  {
    "videoId": "ixrjndyc3II",
    "thumbnail": "https://i.ytimg.com/vi/ixrjndyc3II/mqdefault.jpg",
    "title": "【アソビ大全】ダーツの実力はいかほどか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-19T19:11:03Z"
  },
  {
    "videoId": "tBtZPbJTTrY",
    "thumbnail": "https://i.ytimg.com/vi/tBtZPbJTTrY/mqdefault.jpg",
    "title": "【PICO PARK】え！本当に協力できるんですか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-20T15:13:19Z"
  },
  {
    "videoId": "JF4pzpQesEo",
    "thumbnail": "https://i.ytimg.com/vi/JF4pzpQesEo/mqdefault.jpg",
    "title": "【歌枠】ハニワ曲たくさん歌う会！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-23T10:56:36Z"
  },
  {
    "videoId": "2ME9XiBcXgg",
    "thumbnail": "https://i.ytimg.com/vi/2ME9XiBcXgg/mqdefault.jpg",
    "title": "【Minecraft】EN鯖観光させてくれないか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-25T15:02:55Z"
  },
  {
    "videoId": "w91RDtERLfE",
    "thumbnail": "https://i.ytimg.com/vi/w91RDtERLfE/mqdefault.jpg",
    "title": "【APEX】ぶいぶい行こうぜ！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-26T14:30:58Z"
  },
  {
    "videoId": "gn_jf1bVnkQ",
    "thumbnail": "https://i.ytimg.com/vi/gn_jf1bVnkQ/mqdefault.jpg",
    "title": "【APEXガチャ】新シーズン前にスパレジェでもだして景気づけ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-27T14:14:41Z"
  },
  {
    "videoId": "yPKt55j7GoQ",
    "thumbnail": "https://i.ytimg.com/vi/yPKt55j7GoQ/mqdefault.jpg",
    "title": "【おひる】ひるほ～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-30T05:22:12Z"
  },
  {
    "videoId": "5Ug_p4P8zu8",
    "thumbnail": "https://i.ytimg.com/vi/5Ug_p4P8zu8/mqdefault.jpg",
    "title": "【ハロウィン企画】目が覚めたらゾンビになってたんですが！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-10-31T13:54:55Z"
  },
  {
    "videoId": "uC43P-ygMoc",
    "thumbnail": "https://i.ytimg.com/vi/uC43P-ygMoc/mqdefault.jpg",
    "title": "【APEXガチャ】リベンジ！！クレカもう復活したよ！！やったね！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-02T13:09:32Z"
  },
  {
    "videoId": "hHYQpeGaz54",
    "thumbnail": "https://i.ytimg.com/vi/hHYQpeGaz54/mqdefault.jpg",
    "title": "【Minecraft】めっちゃ前の個人鯖ひっぱりだした【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-04T10:09:28Z"
  },
  {
    "videoId": "UfbKM6ZKLO0",
    "thumbnail": "https://i.ytimg.com/vi/UfbKM6ZKLO0/mqdefault.jpg",
    "title": "【Minecraft】運動場貸し切り！一人でも楽しめるもん！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-08T16:39:58Z"
  },
  {
    "videoId": "gdyq0T5NDNA",
    "thumbnail": "https://i.ytimg.com/vi/gdyq0T5NDNA/mqdefault.jpg",
    "title": "【Human Fall Flat】協力？初心者狩り！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-09T13:19:07Z"
  },
  {
    "videoId": "v6ZVWS5s7zs",
    "thumbnail": "https://i.ytimg.com/vi/v6ZVWS5s7zs/mqdefault.jpg",
    "title": "【APEX】渋ハルカスタムにさんかするなの～【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-11T15:24:49Z"
  },
  {
    "videoId": "D6tCJ5OzY4M",
    "thumbnail": "https://i.ytimg.com/vi/D6tCJ5OzY4M/mqdefault.jpg",
    "title": "【風邪】現状報告('ω')【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-13T06:34:34Z"
  },
  {
    "videoId": "ruC8uatmxDI",
    "thumbnail": "https://i.ytimg.com/vi/ruC8uatmxDI/mqdefault.jpg",
    "title": "【復活】完治したぞ！！歌うぞ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-16T13:00:15Z"
  },
  {
    "videoId": "cInZ3urAIiY",
    "thumbnail": "https://i.ytimg.com/vi/cInZ3urAIiY/mqdefault.jpg",
    "title": "【APEX】今日だけは仲良くやろうよ！圧テルくん！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-17T13:10:37Z"
  },
  {
    "videoId": "2O44WzIoVjE",
    "thumbnail": "https://i.ytimg.com/vi/2O44WzIoVjE/mqdefault.jpg",
    "title": "【ポケモン ブリリアントダイヤモンド/BDSP】念願のダイパリメイク！！ポッチャマ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-19T19:44:34Z"
  },
  {
    "videoId": "t1eXF3I473U",
    "thumbnail": "https://i.ytimg.com/vi/t1eXF3I473U/mqdefault.jpg",
    "title": "【雑談】おぼえとる～？|ω·`)【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-24T10:15:33Z"
  },
  {
    "videoId": "-YdULX4T36A",
    "thumbnail": "https://i.ytimg.com/vi/-YdULX4T36A/mqdefault.jpg",
    "title": "【歌枠】愛をこめて歌います♡ / singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-26T15:03:38Z"
  },
  {
    "videoId": "p6UOax-WRkw",
    "thumbnail": "https://i.ytimg.com/vi/p6UOax-WRkw/mqdefault.jpg",
    "title": "【あさ】おはようございました('ω')【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-29T00:00:11Z"
  },
  {
    "videoId": "yV_PsooyW5k",
    "thumbnail": "https://i.ytimg.com/vi/yV_PsooyW5k/mqdefault.jpg",
    "title": "【ポケモンBD】いつまで地下に潜ってるんですか！出てきなさい！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-29T14:50:05Z"
  },
  {
    "videoId": "9S3nXGW7ajU",
    "thumbnail": "https://i.ytimg.com/vi/9S3nXGW7ajU/mqdefault.jpg",
    "title": "【歌枠】寝れない人のためのお歌 / singing  KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2021-11-30T17:53:05Z"
  },
  {
    "videoId": "FVKA1jGmuCI",
    "thumbnail": "https://i.ytimg.com/vi/FVKA1jGmuCI/mqdefault.jpg",
    "title": "【朝活】朝5時からポケカを探した女の結果【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-02T22:03:19Z"
  },
  {
    "videoId": "5fPTlV45Eg8",
    "thumbnail": "https://i.ytimg.com/vi/5fPTlV45Eg8/mqdefault.jpg",
    "title": "【ポケカ開封】大量開封！豪運をまつりに！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-04T16:04:22Z"
  },
  {
    "videoId": "Sb5SthN4lPM",
    "thumbnail": "https://i.ytimg.com/vi/Sb5SthN4lPM/mqdefault.jpg",
    "title": "【重大告知/歌枠】ホロライブ縛り歌枠！ /  HOLOLIVE SONG SINGING STREAM【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-05T14:46:57Z"
  },
  {
    "videoId": "GSEPCWHDtaU",
    "thumbnail": "https://i.ytimg.com/vi/GSEPCWHDtaU/mqdefault.jpg",
    "title": "【ポケモンBD】ストーリー一気に進めます！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-06T07:56:19Z"
  },
  {
    "videoId": "nOBY1XPeOyg",
    "thumbnail": "https://i.ytimg.com/vi/nOBY1XPeOyg/mqdefault.jpg",
    "title": "【ポケモンBD】草タイプ@1してます！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-06T21:38:06Z"
  },
  {
    "videoId": "0cZeJwCsh6Q",
    "thumbnail": "https://i.ytimg.com/vi/0cZeJwCsh6Q/mqdefault.jpg",
    "title": "【ポケカ開封】VMAXクライマックス7箱大量開封！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-09T16:46:38Z"
  },
  {
    "videoId": "blAapIx25ug",
    "thumbnail": "https://i.ytimg.com/vi/blAapIx25ug/mqdefault.jpg",
    "title": "【歌枠】いろいろ歌う～！ / singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-10T10:24:05Z"
  },
  {
    "videoId": "JzUaZcxZa70",
    "thumbnail": "https://i.ytimg.com/vi/JzUaZcxZa70/mqdefault.jpg",
    "title": "【アナザーエデン】ホロライブ×アナザーエデンWeek２日目！全力で楽しむ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-10T13:22:07Z"
  },
  {
    "videoId": "WELdC0CxYFc",
    "thumbnail": "https://i.ytimg.com/vi/WELdC0CxYFc/mqdefault.jpg",
    "title": "【#冬でも夏色ライブ】寒い冬に夏色を感じませんか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-11T13:10:18Z"
  },
  {
    "videoId": "wtzsiwOTGGA",
    "thumbnail": "https://i.ytimg.com/vi/wtzsiwOTGGA/mqdefault.jpg",
    "title": "チチンプイプイ/夏色まつり(cover)",
    "publishedAt": "2021-12-13T10:00:13Z"
  },
  {
    "videoId": "vmTRPtV7YtU",
    "thumbnail": "https://i.ytimg.com/vi/vmTRPtV7YtU/mqdefault.jpg",
    "title": "【歌枠】なんでも歌うからリクエストしてみな！ / singing anime songs KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-17T14:56:35Z"
  },
  {
    "videoId": "wHCUhrwJNZw",
    "thumbnail": "https://i.ytimg.com/vi/wHCUhrwJNZw/mqdefault.jpg",
    "title": "【ポケカ開封】すでに13BOXあけてました。ユウリはでません。【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-23T13:45:53Z"
  },
  {
    "videoId": "eqc6L7ookIE",
    "thumbnail": "https://i.ytimg.com/vi/eqc6L7ookIE/mqdefault.jpg",
    "title": "【オフコラボ】メンヘラ三銃士のクリスマスケーキ作り！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-24T11:55:13Z"
  },
  {
    "videoId": "rChh655_-6w",
    "thumbnail": "https://i.ytimg.com/vi/rChh655_-6w/mqdefault.jpg",
    "title": "【#夏ちょこ】1年ぶりのコラボはオフコラボパーティー！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-25T06:48:05Z"
  },
  {
    "videoId": "cZxU1znGQZc",
    "thumbnail": "https://i.ytimg.com/vi/cZxU1znGQZc/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー】クリスマスは冬だけじゃありません！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-25T11:02:56Z"
  },
  {
    "videoId": "rAfNiQzw7lU",
    "thumbnail": "https://i.ytimg.com/vi/rAfNiQzw7lU/mqdefault.jpg",
    "title": "【Cake Bash】最強のお菓子パーティー勝負！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-26T13:13:26Z"
  },
  {
    "videoId": "lzIxEIdClas",
    "thumbnail": "https://i.ytimg.com/vi/lzIxEIdClas/mqdefault.jpg",
    "title": "【#ホロ宇宙人狼】無害安全安心夏色まつりです！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-29T14:39:15Z"
  },
  {
    "videoId": "a0Die22aELg",
    "thumbnail": "https://i.ytimg.com/vi/a0Die22aELg/mqdefault.jpg",
    "title": "【歌枠】今年最後のうたわく！！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-29T19:30:22Z"
  },
  {
    "videoId": "zO7wYhQqfLU",
    "thumbnail": "https://i.ytimg.com/vi/zO7wYhQqfLU/mqdefault.jpg",
    "title": "【マリオカート8DX】各チーム１人ずつ来てもらったぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-30T06:53:49Z"
  },
  {
    "videoId": "NRt9ChWwAY8",
    "thumbnail": "https://i.ytimg.com/vi/NRt9ChWwAY8/mqdefault.jpg",
    "title": "【同時視聴】だんらんのばしょ【ホロライブ/夏色まつり】",
    "publishedAt": "2021-12-31T12:08:13Z"
  },
  {
    "videoId": "D1PZR6E1U6c",
    "thumbnail": "https://i.ytimg.com/vi/D1PZR6E1U6c/mqdefault.jpg",
    "title": "【正月衣装】2.0お披露目するよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-01T04:01:22Z"
  },
  {
    "videoId": "XqEYsaarwO4",
    "thumbnail": "https://i.ytimg.com/vi/XqEYsaarwO4/mqdefault.jpg",
    "title": "【筆おろし】書初め大会で君の名前も書かれちゃう！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-01T08:11:36Z"
  },
  {
    "videoId": "aUroIp0sPtw",
    "thumbnail": "https://i.ytimg.com/vi/aUroIp0sPtw/mqdefault.jpg",
    "title": "【ポケモンBD】そろそろバッジ全部ゲットしようぜってな【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-01T20:29:47Z"
  },
  {
    "videoId": "2tkXs3LexGc",
    "thumbnail": "https://i.ytimg.com/vi/2tkXs3LexGc/mqdefault.jpg",
    "title": "【ポケモンBD】トゲピーゆびをふる。の巻【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-02T18:45:10Z"
  },
  {
    "videoId": "V_37ZLfBaHk",
    "thumbnail": "https://i.ytimg.com/vi/V_37ZLfBaHk/mqdefault.jpg",
    "title": "【APEXガチャ】新年一発目大豪運ガチャ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-04T09:32:46Z"
  },
  {
    "videoId": "qvb2KFUhDbM",
    "thumbnail": "https://i.ytimg.com/vi/qvb2KFUhDbM/mqdefault.jpg",
    "title": "【ポケカ】100万円福袋開封！！【夏色まつり/ホロライブ】",
    "publishedAt": "2022-01-06T11:09:39Z"
  },
  {
    "videoId": "TjCn4Nn92MI",
    "thumbnail": "https://i.ytimg.com/vi/TjCn4Nn92MI/mqdefault.jpg",
    "title": "【マリオカート8DX】え？明日？？？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-06T19:38:07Z"
  },
  {
    "videoId": "RjOoP2GldoA",
    "thumbnail": "https://i.ytimg.com/vi/RjOoP2GldoA/mqdefault.jpg",
    "title": "【マリオカート8DX】駆け抜けろ！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-07T06:05:28Z"
  },
  {
    "videoId": "PojFPdpfRO4",
    "thumbnail": "https://i.ytimg.com/vi/PojFPdpfRO4/mqdefault.jpg",
    "title": "【APEXランク】5億年ぶりに戦場に舞い降りたスーパーアイドル【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-08T06:07:23Z"
  },
  {
    "videoId": "7KEty6ktLis",
    "thumbnail": "https://i.ytimg.com/vi/7KEty6ktLis/mqdefault.jpg",
    "title": "【ポケモンBD】絶対に殿堂入りします！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-12T12:02:49Z"
  },
  {
    "videoId": "Fb6Rz5-SsR4",
    "thumbnail": "https://i.ytimg.com/vi/Fb6Rz5-SsR4/mqdefault.jpg",
    "title": "【APEX】戦場を連れまわします✌【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-12T15:58:39Z"
  },
  {
    "videoId": "9H04NOzqWrg",
    "thumbnail": "https://i.ytimg.com/vi/9H04NOzqWrg/mqdefault.jpg",
    "title": "【ARK】新世界！一気に発展させましょうよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-13T17:37:05Z"
  },
  {
    "videoId": "kXhKJ73NinY",
    "thumbnail": "https://i.ytimg.com/vi/kXhKJ73NinY/mqdefault.jpg",
    "title": "【 #hololiveERROR 】3D制服放送 / ホラー苦手ですが頑張ります（）【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-14T14:05:21Z"
  },
  {
    "videoId": "092thNLy3uU",
    "thumbnail": "https://i.ytimg.com/vi/092thNLy3uU/mqdefault.jpg",
    "title": "【Phasmophobia】久しぶりにおばけ見に行くョ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-15T13:36:35Z"
  },
  {
    "videoId": "TLA7-9vf2Xs",
    "thumbnail": "https://i.ytimg.com/vi/TLA7-9vf2Xs/mqdefault.jpg",
    "title": "【ARK】プテラないなった！基地と冒険と！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-16T20:18:24Z"
  },
  {
    "videoId": "DtKo560OJNM",
    "thumbnail": "https://i.ytimg.com/vi/DtKo560OJNM/mqdefault.jpg",
    "title": "【お礼雑談】スパチャお礼～！いつもありがと！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-18T12:26:49Z"
  },
  {
    "videoId": "P6DrtuqVisQ",
    "thumbnail": "https://i.ytimg.com/vi/P6DrtuqVisQ/mqdefault.jpg",
    "title": "【ポケモンBD】ポケモン交換会！！めた・・も・・【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-18T16:54:59Z"
  },
  {
    "videoId": "K0vfObwCJYk",
    "thumbnail": "https://i.ytimg.com/vi/K0vfObwCJYk/mqdefault.jpg",
    "title": "【APEXランク】ソロランクチャレンジ💎【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-19T18:34:57Z"
  },
  {
    "videoId": "jgPfb5_Qy3A",
    "thumbnail": "https://i.ytimg.com/vi/jgPfb5_Qy3A/mqdefault.jpg",
    "title": "【歌枠】 歌いたい衝動にかられて / singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-20T15:18:43Z"
  },
  {
    "videoId": "7OcJWZmmpR8",
    "thumbnail": "https://i.ytimg.com/vi/7OcJWZmmpR8/mqdefault.jpg",
    "title": "【ARK】鉄の時代がやってくる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-22T01:28:59Z"
  },
  {
    "videoId": "YCBQGjsKOC8",
    "thumbnail": "https://i.ytimg.com/vi/YCBQGjsKOC8/mqdefault.jpg",
    "title": "【ポケモンBD】おくびょうなラティアスちゃんに出会いたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-22T18:01:37Z"
  },
  {
    "videoId": "_-ZKUp08D2w",
    "thumbnail": "https://i.ytimg.com/vi/_-ZKUp08D2w/mqdefault.jpg",
    "title": "【APEXランク】ゆるゆるソロランク～✌【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-24T05:05:54Z"
  },
  {
    "videoId": "g5RMVdasVtg",
    "thumbnail": "https://i.ytimg.com/vi/g5RMVdasVtg/mqdefault.jpg",
    "title": "【ARK】のえたんに最強ティラノを！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-24T14:59:37Z"
  },
  {
    "videoId": "5KdQyI6DUxI",
    "thumbnail": "https://i.ytimg.com/vi/5KdQyI6DUxI/mqdefault.jpg",
    "title": "【プロセカ】ほぼ初見で音ゲー楽しむぞいッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-28T14:37:00Z"
  },
  {
    "videoId": "xmglNmofZ3g",
    "thumbnail": "https://i.ytimg.com/vi/xmglNmofZ3g/mqdefault.jpg",
    "title": "【ARK】海に行きませんか！？海の王者になるために進むでな【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-29T20:37:52Z"
  },
  {
    "videoId": "lOz1vpoqEIk",
    "thumbnail": "https://i.ytimg.com/vi/lOz1vpoqEIk/mqdefault.jpg",
    "title": "【ポケカ対決】夏色吹雪で開封＆プレイ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-30T15:04:05Z"
  },
  {
    "videoId": "dVhHaBrmB6Y",
    "thumbnail": "https://i.ytimg.com/vi/dVhHaBrmB6Y/mqdefault.jpg",
    "title": "【プロセカ】みんなで一緒に遊ぶ朝枠！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-01-30T23:29:44Z"
  },
  {
    "videoId": "rwDvJ1NUcZQ",
    "thumbnail": "https://i.ytimg.com/vi/rwDvJ1NUcZQ/mqdefault.jpg",
    "title": "【歌枠】コメントで言われた曲を歌いますです！ / Singing Stream【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-03T07:01:14Z"
  },
  {
    "videoId": "e9xHNzNfSXU",
    "thumbnail": "https://i.ytimg.com/vi/e9xHNzNfSXU/mqdefault.jpg",
    "title": "【歌枠】バラードとか【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-05T10:08:08Z"
  },
  {
    "videoId": "jlbjnWJUu3g",
    "thumbnail": "https://i.ytimg.com/vi/jlbjnWJUu3g/mqdefault.jpg",
    "title": "【Phasmophobia】幽霊調査隊まいります！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-05T12:14:59Z"
  },
  {
    "videoId": "-d7ixtoSn-c",
    "thumbnail": "https://i.ytimg.com/vi/-d7ixtoSn-c/mqdefault.jpg",
    "title": "【歌枠】ただいまのうたわく～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-11T10:10:57Z"
  },
  {
    "videoId": "2oCe1HHf88Q",
    "thumbnail": "https://i.ytimg.com/vi/2oCe1HHf88Q/mqdefault.jpg",
    "title": "【ポケモンレジェンズアルセウス】完全初見！行くぜヒスイ地方！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-12T10:01:04Z"
  },
  {
    "videoId": "SA4hdV_jjvs",
    "thumbnail": "https://i.ytimg.com/vi/SA4hdV_jjvs/mqdefault.jpg",
    "title": "【ARK】バレンタインで釣りするでな～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-12T15:58:46Z"
  },
  {
    "videoId": "L0mcZ91y59I",
    "thumbnail": "https://i.ytimg.com/vi/L0mcZ91y59I/mqdefault.jpg",
    "title": "【#ほろ酔いAmongUs】わーい！まつりがインポスターでーす！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-13T14:30:02Z"
  },
  {
    "videoId": "5y5lurjMrLI",
    "thumbnail": "https://i.ytimg.com/vi/5y5lurjMrLI/mqdefault.jpg",
    "title": "【バレンタイン】らぶらぶ歌枠♡/Singing KARAKOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-14T13:34:39Z"
  },
  {
    "videoId": "p-oBkPSodYo",
    "thumbnail": "https://i.ytimg.com/vi/p-oBkPSodYo/mqdefault.jpg",
    "title": "【ARK】ついに！海最恐のイカをテイムしちゃいましょう！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-16T14:38:08Z"
  },
  {
    "videoId": "UTJ1neX3p24",
    "thumbnail": "https://i.ytimg.com/vi/UTJ1neX3p24/mqdefault.jpg",
    "title": "【VALORANT】ド初心者ですが！がんばりますです【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-18T12:50:16Z"
  },
  {
    "videoId": "fJpsHlYvHM0",
    "thumbnail": "https://i.ytimg.com/vi/fJpsHlYvHM0/mqdefault.jpg",
    "title": "【2D Platformer GAME (Toy Factory)】イヌのアクションゲーム！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-19T13:15:47Z"
  },
  {
    "videoId": "3tH7Blaj3Lw",
    "thumbnail": "https://i.ytimg.com/vi/3tH7Blaj3Lw/mqdefault.jpg",
    "title": "【雑談/FREETALK】イチ推しトークありがとう！感想とかいろいろ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-20T14:27:36Z"
  },
  {
    "videoId": "elUoUq9oKqU",
    "thumbnail": "https://i.ytimg.com/vi/elUoUq9oKqU/mqdefault.jpg",
    "title": "【APEXランク】まつりがうごかない　ので　たちえ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-21T16:41:06Z"
  },
  {
    "videoId": "6EhLBmyu7wU",
    "thumbnail": "https://i.ytimg.com/vi/6EhLBmyu7wU/mqdefault.jpg",
    "title": "【プロセカ】視聴者参加型でセカイで遊ぶぞ('ω')！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-22T10:36:33Z"
  },
  {
    "videoId": "dsZk8HAvaGM",
    "thumbnail": "https://i.ytimg.com/vi/dsZk8HAvaGM/mqdefault.jpg",
    "title": "【歌枠】癒しのうたごえ / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-22T15:36:14Z"
  },
  {
    "videoId": "m5_wNQr60DQ",
    "thumbnail": "https://i.ytimg.com/vi/m5_wNQr60DQ/mqdefault.jpg",
    "title": "【PowerWash Simulator】A型を発狂されるお掃除屋さん【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-23T15:08:17Z"
  },
  {
    "videoId": "b-c3XGhUHMg",
    "thumbnail": "https://i.ytimg.com/vi/b-c3XGhUHMg/mqdefault.jpg",
    "title": "【 ARK 】肉食恐竜さんたちを住みやすくする！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-02-26T14:51:04Z"
  },
  {
    "videoId": "1wBBOniY5is",
    "thumbnail": "https://i.ytimg.com/vi/1wBBOniY5is/mqdefault.jpg",
    "title": "ファンサ/夏色まつり(cover) -VARK LIVE version",
    "publishedAt": "2022-02-28T09:00:00Z"
  },
  {
    "videoId": "XnbxAaIJHfI",
    "thumbnail": "https://i.ytimg.com/vi/XnbxAaIJHfI/mqdefault.jpg",
    "title": "夜もすがら君想ふ / 夏色まつり cover",
    "publishedAt": "2022-03-01T15:30:23Z"
  },
  {
    "videoId": "4WwRfd6peTc",
    "thumbnail": "https://i.ytimg.com/vi/4WwRfd6peTc/mqdefault.jpg",
    "title": "【APEX】うるか幼稚園まゆげ組でAPEX遠足じゃい！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-01T15:58:13Z"
  },
  {
    "videoId": "_wq2EjyKwSs",
    "thumbnail": "https://i.ytimg.com/vi/_wq2EjyKwSs/mqdefault.jpg",
    "title": "【歌枠】歌を届けます！ / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-02T16:33:05Z"
  },
  {
    "videoId": "6-3ROyigr24",
    "thumbnail": "https://i.ytimg.com/vi/6-3ROyigr24/mqdefault.jpg",
    "title": "【朝活】あさかつやさん開店【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-03T02:36:31Z"
  },
  {
    "videoId": "Ar3TP88SKFo",
    "thumbnail": "https://i.ytimg.com/vi/Ar3TP88SKFo/mqdefault.jpg",
    "title": "【ARK】初めての洞窟にいくらしい～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-04T18:00:26Z"
  },
  {
    "videoId": "CVz6PkJcuwo",
    "thumbnail": "https://i.ytimg.com/vi/CVz6PkJcuwo/mqdefault.jpg",
    "title": "【APEX】1年半ぶりにいじるときが来た！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-05T15:55:22Z"
  },
  {
    "videoId": "fCxLZY9C3Mw",
    "thumbnail": "https://i.ytimg.com/vi/fCxLZY9C3Mw/mqdefault.jpg",
    "title": "【 Vampire Survivors 】超話題の神ゲー！いっちょプレイしてみっか！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-06T12:40:12Z"
  },
  {
    "videoId": "pXMyOp_elu8",
    "thumbnail": "https://i.ytimg.com/vi/pXMyOp_elu8/mqdefault.jpg",
    "title": "【PowerWash Simulator】きれいにするやさん【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-06T19:40:39Z"
  },
  {
    "videoId": "CWy_fOtgEAY",
    "thumbnail": "https://i.ytimg.com/vi/CWy_fOtgEAY/mqdefault.jpg",
    "title": "【歌枠】リクエストを歌うなどするッ！ / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-07T12:32:42Z"
  },
  {
    "videoId": "A3pwZwqWhlg",
    "thumbnail": "https://i.ytimg.com/vi/A3pwZwqWhlg/mqdefault.jpg",
    "title": "【こだわりラーメン館】作るより食べる派【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-08T16:42:10Z"
  },
  {
    "videoId": "9TopYFAgGDo",
    "thumbnail": "https://i.ytimg.com/vi/9TopYFAgGDo/mqdefault.jpg",
    "title": "【ARK】睡眠導入作業やさん【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-10T21:44:13Z"
  },
  {
    "videoId": "VZ3sioC-cnw",
    "thumbnail": "https://i.ytimg.com/vi/VZ3sioC-cnw/mqdefault.jpg",
    "title": "【こだわりラーメン館】おいしやさん開店～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-11T22:06:58Z"
  },
  {
    "videoId": "6_9LtIL_UTU",
    "thumbnail": "https://i.ytimg.com/vi/6_9LtIL_UTU/mqdefault.jpg",
    "title": "【 Vampire Survivors 】もう負けない！最強を目指して【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-14T06:04:19Z"
  },
  {
    "videoId": "LedeXNGmpwc",
    "thumbnail": "https://i.ytimg.com/vi/LedeXNGmpwc/mqdefault.jpg",
    "title": "【歌枠】楽しく歌うそれ一番大事♪/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-15T09:50:46Z"
  },
  {
    "videoId": "DquKw98eH7s",
    "thumbnail": "https://i.ytimg.com/vi/DquKw98eH7s/mqdefault.jpg",
    "title": "【ARK】ボス戦！？どきどきだ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-15T16:04:48Z"
  },
  {
    "videoId": "8SGfzGMCg3w",
    "thumbnail": "https://i.ytimg.com/vi/8SGfzGMCg3w/mqdefault.jpg",
    "title": "【スプラトゥーン2】ロラコラキッズの発狂スプラ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-16T10:23:13Z"
  },
  {
    "videoId": "M0gtKqSsWcE",
    "thumbnail": "https://i.ytimg.com/vi/M0gtKqSsWcE/mqdefault.jpg",
    "title": "【APEX】はじめまして！えるさん！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-17T05:10:12Z"
  },
  {
    "videoId": "FQCnnWaKjeU",
    "thumbnail": "https://i.ytimg.com/vi/FQCnnWaKjeU/mqdefault.jpg",
    "title": "【 Vampire Survivors 】敗北をしりたい！最強になっちまうZE！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-18T08:15:48Z"
  },
  {
    "videoId": "0i_S6UITNnE",
    "thumbnail": "https://i.ytimg.com/vi/0i_S6UITNnE/mqdefault.jpg",
    "title": "【#つながるホロライブ】ライブ感想会！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-19T14:43:16Z"
  },
  {
    "videoId": "y6t1I9EBk4Q",
    "thumbnail": "https://i.ytimg.com/vi/y6t1I9EBk4Q/mqdefault.jpg",
    "title": "【#つながるホロライブDAY2】hololive 3rd fes. Link Your Wish同時視聴！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-20T10:48:00Z"
  },
  {
    "videoId": "NxlQfdrOTGQ",
    "thumbnail": "https://i.ytimg.com/vi/NxlQfdrOTGQ/mqdefault.jpg",
    "title": "【歌枠】ライブで歌った曲を歌うなどする～ / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-21T11:59:44Z"
  },
  {
    "videoId": "wRLb1v0rS1A",
    "thumbnail": "https://i.ytimg.com/vi/wRLb1v0rS1A/mqdefault.jpg",
    "title": "【APEX】このチームは最叫です。【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-24T12:29:13Z"
  },
  {
    "videoId": "QEP2L9BUvmc",
    "thumbnail": "https://i.ytimg.com/vi/QEP2L9BUvmc/mqdefault.jpg",
    "title": "【ソロランク】一人でプレマス帯に遊びにきました～('ω')【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-25T09:45:56Z"
  },
  {
    "videoId": "l1tEckLbvj4",
    "thumbnail": "https://i.ytimg.com/vi/l1tEckLbvj4/mqdefault.jpg",
    "title": "【APEX】視聴者参加型カスタム練習会【#ぴかぴか星空フェス】",
    "publishedAt": "2022-03-25T13:08:43Z"
  },
  {
    "videoId": "AJ5IpMrFtOM",
    "thumbnail": "https://i.ytimg.com/vi/AJ5IpMrFtOM/mqdefault.jpg",
    "title": "【閉店事件】閉店してるのに働くんですか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-26T15:25:57Z"
  },
  {
    "videoId": "q0jgiNnc4i8",
    "thumbnail": "https://i.ytimg.com/vi/q0jgiNnc4i8/mqdefault.jpg",
    "title": "【Minecraft】まるばつクイズつくるぞッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-28T13:25:38Z"
  },
  {
    "videoId": "rp64hrLMbKc",
    "thumbnail": "https://i.ytimg.com/vi/rp64hrLMbKc/mqdefault.jpg",
    "title": "【APEX】なんか強い二人に挟まれてて草【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-28T16:16:44Z"
  },
  {
    "videoId": "eytjrWAsH8I",
    "thumbnail": "https://i.ytimg.com/vi/eytjrWAsH8I/mqdefault.jpg",
    "title": "【#ぴかフェスWIN】どうやらカスタムに参加するらしい【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-29T16:58:23Z"
  },
  {
    "videoId": "AWbNiQ-Xn9E",
    "thumbnail": "https://i.ytimg.com/vi/AWbNiQ-Xn9E/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】ぶーん🏍まつりちゃんが通ります～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-30T15:01:44Z"
  },
  {
    "videoId": "paw_eVC6ZcY",
    "thumbnail": "https://i.ytimg.com/vi/paw_eVC6ZcY/mqdefault.jpg",
    "title": "【歌枠】おひさしぶりに歌う～！！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-03-31T15:08:08Z"
  },
  {
    "videoId": "wMRCp-5rcqk",
    "thumbnail": "https://i.ytimg.com/vi/wMRCp-5rcqk/mqdefault.jpg",
    "title": "【エイプリルフール】口リまつり参上！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-02T10:10:53Z"
  },
  {
    "videoId": "VRLurq3XkW8",
    "thumbnail": "https://i.ytimg.com/vi/VRLurq3XkW8/mqdefault.jpg",
    "title": "【#ぴかフェスWIN】カスタム行きますわよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-02T17:20:40Z"
  },
  {
    "videoId": "cQPmZrftwjc",
    "thumbnail": "https://i.ytimg.com/vi/cQPmZrftwjc/mqdefault.jpg",
    "title": "【APEX】リベンジマスター【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-05T09:06:32Z"
  },
  {
    "videoId": "JKnqzOUze3A",
    "thumbnail": "https://i.ytimg.com/vi/JKnqzOUze3A/mqdefault.jpg",
    "title": "【#ぴかフェスWIN】カスタムで今日もがんばるやさん開店【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-05T16:54:32Z"
  },
  {
    "videoId": "JQbVDqEZ2og",
    "thumbnail": "https://i.ytimg.com/vi/JQbVDqEZ2og/mqdefault.jpg",
    "title": "【#ホロカラ覗き見】ホロメンのカラオケ覗き見！？ / 3Dstream【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-06T11:10:26Z"
  },
  {
    "videoId": "euKNO97QpZE",
    "thumbnail": "https://i.ytimg.com/vi/euKNO97QpZE/mqdefault.jpg",
    "title": "【#ホロとシンクロ】自分だけの運命を切り開け――【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-08T12:49:53Z"
  },
  {
    "videoId": "Klw0NsJgxlE",
    "thumbnail": "https://i.ytimg.com/vi/Klw0NsJgxlE/mqdefault.jpg",
    "title": "【Cake Bash】ホロライブケーキたちの戦い！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-09T10:09:06Z"
  },
  {
    "videoId": "xXZ4nYscAZU",
    "thumbnail": "https://i.ytimg.com/vi/xXZ4nYscAZU/mqdefault.jpg",
    "title": "【Minecraft】まるばつクイズ完成させるやさん！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-10T13:41:39Z"
  },
  {
    "videoId": "apF1q16Y9uY",
    "thumbnail": "https://i.ytimg.com/vi/apF1q16Y9uY/mqdefault.jpg",
    "title": "【APEX】V最協練習カスタム１日目【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-11T14:43:20Z"
  },
  {
    "videoId": "JpzU_epG2A8",
    "thumbnail": "https://i.ytimg.com/vi/JpzU_epG2A8/mqdefault.jpg",
    "title": "【APEX】V最協練習カスタム2日目【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-12T15:31:15Z"
  },
  {
    "videoId": "lpADFM-T64o",
    "thumbnail": "https://i.ytimg.com/vi/lpADFM-T64o/mqdefault.jpg",
    "title": "【APEX】V最協練習カスタム3日目【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-13T15:12:47Z"
  },
  {
    "videoId": "16gkaojSfZA",
    "thumbnail": "https://i.ytimg.com/vi/16gkaojSfZA/mqdefault.jpg",
    "title": "【歌枠】気分上げていきたい歌枠～♪/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-14T09:18:35Z"
  },
  {
    "videoId": "3Scks4RBDRA",
    "thumbnail": "https://i.ytimg.com/vi/3Scks4RBDRA/mqdefault.jpg",
    "title": "【APEX】根性のV最協練習カスタム4日目【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-14T15:54:13Z"
  },
  {
    "videoId": "zJvq8Ov0tts",
    "thumbnail": "https://i.ytimg.com/vi/zJvq8Ov0tts/mqdefault.jpg",
    "title": "【APEX】V最協練習カスタム5日目【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-15T15:00:53Z"
  },
  {
    "videoId": "jokJPL1BLeE",
    "thumbnail": "https://i.ytimg.com/vi/jokJPL1BLeE/mqdefault.jpg",
    "title": "【APEX】V最協練習カスタム最終日！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-16T17:15:51Z"
  },
  {
    "videoId": "ngbB4Sc5L44",
    "thumbnail": "https://i.ytimg.com/vi/ngbB4Sc5L44/mqdefault.jpg",
    "title": "【APEX】V最協S4本番！最後まであきらめない。【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-17T13:18:39Z"
  },
  {
    "videoId": "23I-Vgcq17Y",
    "thumbnail": "https://i.ytimg.com/vi/23I-Vgcq17Y/mqdefault.jpg",
    "title": "ひる【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-19T03:27:44Z"
  },
  {
    "videoId": "f8r6wgZdUVY",
    "thumbnail": "https://i.ytimg.com/vi/f8r6wgZdUVY/mqdefault.jpg",
    "title": "【復活】ただいま～！休暇から復帰したやさん！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-26T10:23:25Z"
  },
  {
    "videoId": "iKD7DnHcUP4",
    "thumbnail": "https://i.ytimg.com/vi/iKD7DnHcUP4/mqdefault.jpg",
    "title": "【APEX】英語禁止！？アーマーは鎧ですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-26T14:56:02Z"
  },
  {
    "videoId": "kLfzh5vU5Tw",
    "thumbnail": "https://i.ytimg.com/vi/kLfzh5vU5Tw/mqdefault.jpg",
    "title": "【APEXガチャ】デビットカードを作ったのでもう何も怖くありません。【ホロライブ/夏色まつり】",
    "publishedAt": "2022-04-27T11:51:19Z"
  },
  {
    "videoId": "x4-nI6Bh0U8",
    "thumbnail": "https://i.ytimg.com/vi/x4-nI6Bh0U8/mqdefault.jpg",
    "title": "【歌枠】ねこを飼い始めました🐈/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-01T05:46:26Z"
  },
  {
    "videoId": "EhZ1qgucsY4",
    "thumbnail": "https://i.ytimg.com/vi/EhZ1qgucsY4/mqdefault.jpg",
    "title": "【太鼓の達人】課題曲練習屋さん～ #ホロGGW【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-03T14:36:45Z"
  },
  {
    "videoId": "_-RdpoIjbTU",
    "thumbnail": "https://i.ytimg.com/vi/_-RdpoIjbTU/mqdefault.jpg",
    "title": "【ネタバレあり】Ib 美術館に遊びに来たやさん～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-05T16:24:35Z"
  },
  {
    "videoId": "j9aCvotKr8s",
    "thumbnail": "https://i.ytimg.com/vi/j9aCvotKr8s/mqdefault.jpg",
    "title": "【NEEDY GIRL OVERDOSE】メンヘラ彼女とトップ配信者を目指す！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-09T13:33:31Z"
  },
  {
    "videoId": "GPU8TraRPn4",
    "thumbnail": "https://i.ytimg.com/vi/GPU8TraRPn4/mqdefault.jpg",
    "title": "【APEX】新シーズン開幕ランク！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-10T20:22:28Z"
  },
  {
    "videoId": "1VQ8ba_kF5E",
    "thumbnail": "https://i.ytimg.com/vi/1VQ8ba_kF5E/mqdefault.jpg",
    "title": "【春ゆきてレトロチカ】天才めんたんていやさん始動！【ホロライブ/夏色まつり】※ネタバレあり",
    "publishedAt": "2022-05-11T15:10:39Z"
  },
  {
    "videoId": "Nu3BfKCUhVA",
    "thumbnail": "https://i.ytimg.com/vi/Nu3BfKCUhVA/mqdefault.jpg",
    "title": "【歌枠】おうたやさん開店/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-12T15:45:44Z"
  },
  {
    "videoId": "qVB6UG29bUw",
    "thumbnail": "https://i.ytimg.com/vi/qVB6UG29bUw/mqdefault.jpg",
    "title": "【APEX】めとちとランク！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-13T13:29:58Z"
  },
  {
    "videoId": "oUXGWi3atTE",
    "thumbnail": "https://i.ytimg.com/vi/oUXGWi3atTE/mqdefault.jpg",
    "title": "【星のカービィ ディスカバリー】生まれて初めてのカービィ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-14T06:59:09Z"
  },
  {
    "videoId": "oBAiIAyB07M",
    "thumbnail": "https://i.ytimg.com/vi/oBAiIAyB07M/mqdefault.jpg",
    "title": "【APEX】ネオポルテと遊ぶ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-15T09:50:51Z"
  },
  {
    "videoId": "Ml8NZoKbpoU",
    "thumbnail": "https://i.ytimg.com/vi/Ml8NZoKbpoU/mqdefault.jpg",
    "title": "【APEX】CRカップ顔合わせ！ / Rasさんと椎名唯華ちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-16T15:46:19Z"
  },
  {
    "videoId": "69_Tf_7OL9k",
    "thumbnail": "https://i.ytimg.com/vi/69_Tf_7OL9k/mqdefault.jpg",
    "title": "【星のカービィ ディスカバリー】カービィと行く！#2【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-17T15:52:54Z"
  },
  {
    "videoId": "ZwPThORW8JQ",
    "thumbnail": "https://i.ytimg.com/vi/ZwPThORW8JQ/mqdefault.jpg",
    "title": "【APEX】CRカップカスタム１日目 / #しらすフェス【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-18T15:21:03Z"
  },
  {
    "videoId": "FoK5XaROLy4",
    "thumbnail": "https://i.ytimg.com/vi/FoK5XaROLy4/mqdefault.jpg",
    "title": "【星のカービィ ディスカバリー】全員助けるカービィ物語#3【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-19T07:26:53Z"
  },
  {
    "videoId": "BtzS61Z7oP0",
    "thumbnail": "https://i.ytimg.com/vi/BtzS61Z7oP0/mqdefault.jpg",
    "title": "【APEX】CRカップカスタム2日目 / #しらすフェス【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-19T15:57:39Z"
  },
  {
    "videoId": "A2ZW5LlCNJA",
    "thumbnail": "https://i.ytimg.com/vi/A2ZW5LlCNJA/mqdefault.jpg",
    "title": "【APEX】CRカップカスタム3日目 / #しらすフェス【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-20T15:46:43Z"
  },
  {
    "videoId": "_NjclQSL7XM",
    "thumbnail": "https://i.ytimg.com/vi/_NjclQSL7XM/mqdefault.jpg",
    "title": "【APEX】CRカップカスタム4日目 / #しらすフェス【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-21T15:43:49Z"
  },
  {
    "videoId": "l4kRVLzZGJg",
    "thumbnail": "https://i.ytimg.com/vi/l4kRVLzZGJg/mqdefault.jpg",
    "title": "【朝活】おはようのあさまちゅ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-22T00:55:05Z"
  },
  {
    "videoId": "U4Coj55PyuE",
    "thumbnail": "https://i.ytimg.com/vi/U4Coj55PyuE/mqdefault.jpg",
    "title": "【歌枠】バラード縛り【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-23T14:42:05Z"
  },
  {
    "videoId": "ORC3KWB4CWE",
    "thumbnail": "https://i.ytimg.com/vi/ORC3KWB4CWE/mqdefault.jpg",
    "title": "【星のカービィ ディスカバリー】遊園地で遊ぶカービィさん#4【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-24T07:26:13Z"
  },
  {
    "videoId": "hqPWE5nYjxE",
    "thumbnail": "https://i.ytimg.com/vi/hqPWE5nYjxE/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖にゴルフ場を作る！/素材集め編【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-24T11:37:25Z"
  },
  {
    "videoId": "kIjIbyZ48nk",
    "thumbnail": "https://i.ytimg.com/vi/kIjIbyZ48nk/mqdefault.jpg",
    "title": "【星のカービィ ディスカバリー】ヨーロピアンな世界に行くやさん～#5【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-26T09:00:56Z"
  },
  {
    "videoId": "cLg_l33fhLg",
    "thumbnail": "https://i.ytimg.com/vi/cLg_l33fhLg/mqdefault.jpg",
    "title": "【APEX LEGENDS】渋ハルカスタム参戦！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-26T14:44:41Z"
  },
  {
    "videoId": "WUDdUkIhbAY",
    "thumbnail": "https://i.ytimg.com/vi/WUDdUkIhbAY/mqdefault.jpg",
    "title": "【星のカービィ ディスカバリー】ボス戦から次のステージへ！#6【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-28T08:22:15Z"
  },
  {
    "videoId": "e-ybuJCdzSs",
    "thumbnail": "https://i.ytimg.com/vi/e-ybuJCdzSs/mqdefault.jpg",
    "title": "【歌枠】おうたやさん開店！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-29T13:42:20Z"
  },
  {
    "videoId": "kJClTjX3qCU",
    "thumbnail": "https://i.ytimg.com/vi/kJClTjX3qCU/mqdefault.jpg",
    "title": "マッチングアプリで出会い厨してみたｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-30T15:50:07Z"
  },
  {
    "videoId": "d9lnuaPWV_M",
    "thumbnail": "https://i.ytimg.com/vi/d9lnuaPWV_M/mqdefault.jpg",
    "title": "【カウントダウン】活動4周年を君と迎えたい！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-05-31T15:42:28Z"
  },
  {
    "videoId": "dfisHwZQ8lw",
    "thumbnail": "https://i.ytimg.com/vi/dfisHwZQ8lw/mqdefault.jpg",
    "title": "【マリオカート8DX】視聴者よ。戦おうぜ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-02T07:07:01Z"
  },
  {
    "videoId": "4OXjIVL_a2A",
    "thumbnail": "https://i.ytimg.com/vi/4OXjIVL_a2A/mqdefault.jpg",
    "title": "【影廊 -Shadow Corridor-】超明るい曲歌いながらならホラー怖くない説！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-02T09:17:05Z"
  },
  {
    "videoId": "cctYWoCu-sE",
    "thumbnail": "https://i.ytimg.com/vi/cctYWoCu-sE/mqdefault.jpg",
    "title": "【APEX】お久しぶりだなぁ！？CRカップカスタムよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-02T15:25:38Z"
  },
  {
    "videoId": "g8HeE_ruTB4",
    "thumbnail": "https://i.ytimg.com/vi/g8HeE_ruTB4/mqdefault.jpg",
    "title": "【本人切り抜き】世界一うるさいマリカー実況ｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-03T04:11:34Z"
  },
  {
    "videoId": "iObUrEvBiDw",
    "thumbnail": "https://i.ytimg.com/vi/iObUrEvBiDw/mqdefault.jpg",
    "title": "【CRカップ】こんな大会初めてっ！勝つぞ～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-04T11:04:00Z"
  },
  {
    "videoId": "vebSLR2aK1A",
    "thumbnail": "https://i.ytimg.com/vi/vebSLR2aK1A/mqdefault.jpg",
    "title": "【凸待ち】4周年記念！お披露目＆凸待ち！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-04T15:15:32Z"
  },
  {
    "videoId": "anTqL0paWDQ",
    "thumbnail": "https://i.ytimg.com/vi/anTqL0paWDQ/mqdefault.jpg",
    "title": "【歌枠】Singing KARAOKE♪【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-06T15:37:57Z"
  },
  {
    "videoId": "tZp7sHVEWuE",
    "thumbnail": "https://i.ytimg.com/vi/tZp7sHVEWuE/mqdefault.jpg",
    "title": "【おじさんと遊ぼう】ｵﾊﾖ❗おぢさんと今カラ遊ぼ💛【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-07T12:47:19Z"
  },
  {
    "videoId": "B2LcUYWYeh4",
    "thumbnail": "https://i.ytimg.com/vi/B2LcUYWYeh4/mqdefault.jpg",
    "title": "【Minecraft】ゴルフ場の整地させろください【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-08T16:29:51Z"
  },
  {
    "videoId": "hfPekq8zpJU",
    "thumbnail": "https://i.ytimg.com/vi/hfPekq8zpJU/mqdefault.jpg",
    "title": "【わくわく】３回目を乗り越えたい【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-09T21:05:00Z"
  },
  {
    "videoId": "aFxjuXbzI7g",
    "thumbnail": "https://i.ytimg.com/vi/aFxjuXbzI7g/mqdefault.jpg",
    "title": "【APEX LEGENDS】朝カジュアル～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-11T00:39:39Z"
  },
  {
    "videoId": "UbEO-156dLM",
    "thumbnail": "https://i.ytimg.com/vi/UbEO-156dLM/mqdefault.jpg",
    "title": "【モンスターハンターライズ】片手剣の使い方覚えてますか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-11T09:27:51Z"
  },
  {
    "videoId": "gH4-AzO_lMY",
    "thumbnail": "https://i.ytimg.com/vi/gH4-AzO_lMY/mqdefault.jpg",
    "title": "【おはよう】日曜日も早起きしてこ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-11T23:40:42Z"
  },
  {
    "videoId": "KG4uZgC-0rM",
    "thumbnail": "https://i.ytimg.com/vi/KG4uZgC-0rM/mqdefault.jpg",
    "title": "【歌枠】バラード / Ballad only KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-12T11:23:49Z"
  },
  {
    "videoId": "GA1Gv-G4m-s",
    "thumbnail": "https://i.ytimg.com/vi/GA1Gv-G4m-s/mqdefault.jpg",
    "title": "完全ソロスナ縛りちゃんぴおん",
    "publishedAt": "2022-06-12T11:47:09Z"
  },
  {
    "videoId": "cNKO1d1kFbI",
    "thumbnail": "https://i.ytimg.com/vi/cNKO1d1kFbI/mqdefault.jpg",
    "title": "【モンスターハンターライズ】片手剣で今日も行くぜっ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-13T10:14:17Z"
  },
  {
    "videoId": "8GCxOinCzOs",
    "thumbnail": "https://i.ytimg.com/vi/8GCxOinCzOs/mqdefault.jpg",
    "title": "【公認ミラー配信】#カプコンショーケース公認ミラー配信 【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-13T22:41:44Z"
  },
  {
    "videoId": "k8UuJxhGQf8",
    "thumbnail": "https://i.ytimg.com/vi/k8UuJxhGQf8/mqdefault.jpg",
    "title": "【Golf It!】誰が一番のゴルファーか決めようか⛳【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-14T15:31:52Z"
  },
  {
    "videoId": "ILc1DQSqLxI",
    "thumbnail": "https://i.ytimg.com/vi/ILc1DQSqLxI/mqdefault.jpg",
    "title": "carとかいう武器強すぎる⚔️",
    "publishedAt": "2022-06-16T17:21:34Z"
  },
  {
    "videoId": "k1kZj6rfFVU",
    "thumbnail": "https://i.ytimg.com/vi/k1kZj6rfFVU/mqdefault.jpg",
    "title": "【視聴者参加型】推しの直筆あてれる・・・！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-18T10:54:04Z"
  },
  {
    "videoId": "UDdyN-B9-Hs",
    "thumbnail": "https://i.ytimg.com/vi/UDdyN-B9-Hs/mqdefault.jpg",
    "title": "【朝活】おはよ～！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-20T00:00:45Z"
  },
  {
    "videoId": "05mW8CHi8Zk",
    "thumbnail": "https://i.ytimg.com/vi/05mW8CHi8Zk/mqdefault.jpg",
    "title": "【歌枠】好きなアニソン歌う屋さん～/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-20T12:33:59Z"
  },
  {
    "videoId": "fGbXpW-eM64",
    "thumbnail": "https://i.ytimg.com/vi/fGbXpW-eM64/mqdefault.jpg",
    "title": "【VALORANT】あいあん３【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-21T00:12:07Z"
  },
  {
    "videoId": "VsibeR2iqcI",
    "thumbnail": "https://i.ytimg.com/vi/VsibeR2iqcI/mqdefault.jpg",
    "title": "【APEX LEGENDS】なんですかこのメンツは？？？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-21T13:58:16Z"
  },
  {
    "videoId": "EV79oBtV2o4",
    "thumbnail": "https://i.ytimg.com/vi/EV79oBtV2o4/mqdefault.jpg",
    "title": "【HoloCure】ファンメイドのホロライブゲーム！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-25T03:32:03Z"
  },
  {
    "videoId": "Q3-Hyo7sc1A",
    "thumbnail": "https://i.ytimg.com/vi/Q3-Hyo7sc1A/mqdefault.jpg",
    "title": "最近のクリップやさん📎",
    "publishedAt": "2022-06-25T16:27:27Z"
  },
  {
    "videoId": "nAvU0rFKEC4",
    "thumbnail": "https://i.ytimg.com/vi/nAvU0rFKEC4/mqdefault.jpg",
    "title": "【HoloCure】今日はクリアできるか！？ファンメイドの神ゲー！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-26T03:02:32Z"
  },
  {
    "videoId": "nf2p7xh4tbA",
    "thumbnail": "https://i.ytimg.com/vi/nf2p7xh4tbA/mqdefault.jpg",
    "title": "【モンスターハンターライズ】ハンターランク激盛りできますか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-26T15:37:33Z"
  },
  {
    "videoId": "bI2NzfPvwU4",
    "thumbnail": "https://i.ytimg.com/vi/bI2NzfPvwU4/mqdefault.jpg",
    "title": "【HoloCure】ハコス・ベールズちゃん縛り！！クリアするぞっ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-06-28T03:22:35Z"
  },
  {
    "videoId": "nuiO1LGaUUI",
    "thumbnail": "https://i.ytimg.com/vi/nuiO1LGaUUI/mqdefault.jpg",
    "title": "無言ランクの巻(・x・)",
    "publishedAt": "2022-07-01T07:56:53Z"
  },
  {
    "videoId": "YLgJVvi1xPs",
    "thumbnail": "https://i.ytimg.com/vi/YLgJVvi1xPs/mqdefault.jpg",
    "title": "silence🔇",
    "publishedAt": "2022-07-04T12:20:29Z"
  },
  {
    "videoId": "OSUrl4n8QPI",
    "thumbnail": "https://i.ytimg.com/vi/OSUrl4n8QPI/mqdefault.jpg",
    "title": "【復帰】ただいま！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-07T10:26:41Z"
  },
  {
    "videoId": "2oZoUkhZz5Y",
    "thumbnail": "https://i.ytimg.com/vi/2oZoUkhZz5Y/mqdefault.jpg",
    "title": "【歌枠】リハビリで歌うやさんするっ！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-07T12:12:02Z"
  },
  {
    "videoId": "Om20tTd8c_g",
    "thumbnail": "https://i.ytimg.com/vi/Om20tTd8c_g/mqdefault.jpg",
    "title": "【HoloCure】無双屋さんのはじまりッ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-08T07:29:08Z"
  },
  {
    "videoId": "KiFOcZA6QvQ",
    "thumbnail": "https://i.ytimg.com/vi/KiFOcZA6QvQ/mqdefault.jpg",
    "title": "【第3走者・夏色まつり】1期生Live2Dver3.0お披露目リレー【ホロライブ/hololive】",
    "publishedAt": "2022-07-09T11:39:19Z"
  },
  {
    "videoId": "x6h11r7J8-k",
    "thumbnail": "https://i.ytimg.com/vi/x6h11r7J8-k/mqdefault.jpg",
    "title": "【live2Dver3.0】もっと動くところ見せちゃうやさん～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-11T10:29:52Z"
  },
  {
    "videoId": "PsWa9M8tkHI",
    "thumbnail": "https://i.ytimg.com/vi/PsWa9M8tkHI/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】はじめてなんですがまだ間に合うやさんですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-12T10:35:25Z"
  },
  {
    "videoId": "lRK9WgF2WtU",
    "thumbnail": "https://i.ytimg.com/vi/lRK9WgF2WtU/mqdefault.jpg",
    "title": "【モンスターハンターライズ：サンブレイク】ソロハンターでもいけますか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-13T11:06:41Z"
  },
  {
    "videoId": "rO_3KK3jE-Q",
    "thumbnail": "https://i.ytimg.com/vi/rO_3KK3jE-Q/mqdefault.jpg",
    "title": "【HoloCure】ムメイちゃんなら30分耐久いけるやさん！！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-14T04:05:23Z"
  },
  {
    "videoId": "y7wiMu7C9eA",
    "thumbnail": "https://i.ytimg.com/vi/y7wiMu7C9eA/mqdefault.jpg",
    "title": "【RUST】ホロ鯖突撃！まずは拠点作らねば！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-15T12:01:19Z"
  },
  {
    "videoId": "tc4lVyJAHsU",
    "thumbnail": "https://i.ytimg.com/vi/tc4lVyJAHsU/mqdefault.jpg",
    "title": "【Minecraft】IDとの世界をつなぐポータルリレー！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-17T04:31:42Z"
  },
  {
    "videoId": "JSB18PI19bs",
    "thumbnail": "https://i.ytimg.com/vi/JSB18PI19bs/mqdefault.jpg",
    "title": "【RUST】まだ行ったことのない場所へ！探索編【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-19T14:35:51Z"
  },
  {
    "videoId": "UL9eJh0R0T4",
    "thumbnail": "https://i.ytimg.com/vi/UL9eJh0R0T4/mqdefault.jpg",
    "title": "【重大告知】7月22日わかりますよね？詳しく話します！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-20T09:33:20Z"
  },
  {
    "videoId": "jBYZuglgpJM",
    "thumbnail": "https://i.ytimg.com/vi/jBYZuglgpJM/mqdefault.jpg",
    "title": "7月22日20:00～ 告知動画",
    "publishedAt": "2022-07-20T09:33:25Z"
  },
  {
    "videoId": "MxxqteLgFu4",
    "thumbnail": "https://i.ytimg.com/vi/MxxqteLgFu4/mqdefault.jpg",
    "title": "人生は最高の暇つぶし/夏色まつり(cover)",
    "publishedAt": "2022-07-21T15:15:14Z"
  },
  {
    "videoId": "oRxRVZR-03c",
    "thumbnail": "https://i.ytimg.com/vi/oRxRVZR-03c/mqdefault.jpg",
    "title": "【カウントダウン】誕生日を一緒に迎えてくれますか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-21T15:41:40Z"
  },
  {
    "videoId": "oFn0ZypcaM8",
    "thumbnail": "https://i.ytimg.com/vi/oFn0ZypcaM8/mqdefault.jpg",
    "title": "【#夏色ReSTART】BIRTHDAY 3DLIVE🎂~今日はまつりが主役~【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-22T12:19:00Z"
  },
  {
    "videoId": "t0CrvllN5Kw",
    "thumbnail": "https://i.ytimg.com/vi/t0CrvllN5Kw/mqdefault.jpg",
    "title": "【#AmongHolo】インポスターになってからがまつりのスタートだ。【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-23T14:50:00Z"
  },
  {
    "videoId": "kD51ADczUlY",
    "thumbnail": "https://i.ytimg.com/vi/kD51ADczUlY/mqdefault.jpg",
    "title": "【RUST】レッドカードいつ使うの！今でしょ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-24T10:33:43Z"
  },
  {
    "videoId": "cHSwCzzid6Y",
    "thumbnail": "https://i.ytimg.com/vi/cHSwCzzid6Y/mqdefault.jpg",
    "title": "【歌枠】久々の歌枠！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-25T14:45:03Z"
  },
  {
    "videoId": "hpRJyJb5d4A",
    "thumbnail": "https://i.ytimg.com/vi/hpRJyJb5d4A/mqdefault.jpg",
    "title": "【stray】今日からまつりにゃんこです🐈【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-27T10:26:37Z"
  },
  {
    "videoId": "YJwchAwdM1M",
    "thumbnail": "https://i.ytimg.com/vi/YJwchAwdM1M/mqdefault.jpg",
    "title": "【RUST】潜水艦がほしい！地下もいきたい！欲張り屋さん～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-28T13:29:14Z"
  },
  {
    "videoId": "dfOjpZbMc6c",
    "thumbnail": "https://i.ytimg.com/vi/dfOjpZbMc6c/mqdefault.jpg",
    "title": "【RUST】急遽みんなでラージオイルリグいく！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-30T18:38:04Z"
  },
  {
    "videoId": "thjaghywRZw",
    "thumbnail": "https://i.ytimg.com/vi/thjaghywRZw/mqdefault.jpg",
    "title": "【RUST】オイルリグにソロでいく！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-31T07:54:46Z"
  },
  {
    "videoId": "7PTWWcUAh2s",
    "thumbnail": "https://i.ytimg.com/vi/7PTWWcUAh2s/mqdefault.jpg",
    "title": "【おばか人狼】常識問題が解けないバカが１人います！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-07-31T10:12:25Z"
  },
  {
    "videoId": "Cm-LTQhI7YM",
    "thumbnail": "https://i.ytimg.com/vi/Cm-LTQhI7YM/mqdefault.jpg",
    "title": "【歌枠】想いを歌にのせて.../Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-02T12:37:30Z"
  },
  {
    "videoId": "kyn90SGs-mE",
    "thumbnail": "https://i.ytimg.com/vi/kyn90SGs-mE/mqdefault.jpg",
    "title": "【朝活】おはようの挨拶していけ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-03T00:49:01Z"
  },
  {
    "videoId": "2A2fyFvXaEg",
    "thumbnail": "https://i.ytimg.com/vi/2A2fyFvXaEg/mqdefault.jpg",
    "title": "【RUST】ホロライブ花火大会！綺麗にデザインするやさん～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-03T13:21:45Z"
  },
  {
    "videoId": "bRM_f84-Af4",
    "thumbnail": "https://i.ytimg.com/vi/bRM_f84-Af4/mqdefault.jpg",
    "title": "【RUST】最終決戦！すべてを破壊せよッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-04T14:47:39Z"
  },
  {
    "videoId": "3Lbys2pktp0",
    "thumbnail": "https://i.ytimg.com/vi/3Lbys2pktp0/mqdefault.jpg",
    "title": "【APEX】１カ月ぶりに戦場におりてみるぞッ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-05T06:23:42Z"
  },
  {
    "videoId": "PWt1sVJmsUs",
    "thumbnail": "https://i.ytimg.com/vi/PWt1sVJmsUs/mqdefault.jpg",
    "title": "【朝活】おはよ～！！夏休みでも早起きすべし！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-06T00:01:14Z"
  },
  {
    "videoId": "56_irzTAwKg",
    "thumbnail": "https://i.ytimg.com/vi/56_irzTAwKg/mqdefault.jpg",
    "title": "【3Dコラボ】1-2-Switchで大暴れ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-06T12:02:16Z"
  },
  {
    "videoId": "CDPkJfnFF8o",
    "thumbnail": "https://i.ytimg.com/vi/CDPkJfnFF8o/mqdefault.jpg",
    "title": "【朝活】最近朝早く起きれる('ω')✌【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-08T00:37:56Z"
  },
  {
    "videoId": "Vd-x7IT_N08",
    "thumbnail": "https://i.ytimg.com/vi/Vd-x7IT_N08/mqdefault.jpg",
    "title": "【RUST】ホロ鯖シーズン2開幕！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-09T11:39:23Z"
  },
  {
    "videoId": "cL8-qUSZyeg",
    "thumbnail": "https://i.ytimg.com/vi/cL8-qUSZyeg/mqdefault.jpg",
    "title": "【RUST】オイルリグやら地下やら行って物資に差をつけろ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-11T11:01:52Z"
  },
  {
    "videoId": "zcQnZ2i3MEc",
    "thumbnail": "https://i.ytimg.com/vi/zcQnZ2i3MEc/mqdefault.jpg",
    "title": "【RUST】ゆるく素材集めとかする朝配信【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-13T00:37:12Z"
  },
  {
    "videoId": "RTbeJQQQcXU",
    "thumbnail": "https://i.ytimg.com/vi/RTbeJQQQcXU/mqdefault.jpg",
    "title": "ポルカの家いくだけ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-14T00:17:06Z"
  },
  {
    "videoId": "2zlEuqFceek",
    "thumbnail": "https://i.ytimg.com/vi/2zlEuqFceek/mqdefault.jpg",
    "title": "【APEXランク】久々ランク行きますか～！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-15T08:58:35Z"
  },
  {
    "videoId": "ZBYRI-m3VZQ",
    "thumbnail": "https://i.ytimg.com/vi/ZBYRI-m3VZQ/mqdefault.jpg",
    "title": "【お披露目】新しい水着を見せるため歌います！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-16T10:25:44Z"
  },
  {
    "videoId": "PXS3OmqEd6k",
    "thumbnail": "https://i.ytimg.com/vi/PXS3OmqEd6k/mqdefault.jpg",
    "title": "【APEXランク】ダイヤランクいっぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-16T17:10:21Z"
  },
  {
    "videoId": "n1a7DtOCFas",
    "thumbnail": "https://i.ytimg.com/vi/n1a7DtOCFas/mqdefault.jpg",
    "title": "【 Minecraft 】この3人で出店できるの！？！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-17T15:58:00Z"
  },
  {
    "videoId": "W1EbmkGqWAQ",
    "thumbnail": "https://i.ytimg.com/vi/W1EbmkGqWAQ/mqdefault.jpg",
    "title": "【RUST】お金持ちなるます💰/電気の時代も来た！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-18T13:18:59Z"
  },
  {
    "videoId": "dpN-v8RgCDY",
    "thumbnail": "https://i.ytimg.com/vi/dpN-v8RgCDY/mqdefault.jpg",
    "title": "【RUST】初めての貨物船攻略！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-19T08:00:47Z"
  },
  {
    "videoId": "_J8vpBOciBw",
    "thumbnail": "https://i.ytimg.com/vi/_J8vpBOciBw/mqdefault.jpg",
    "title": "【プロセカ】にっこり^^調査隊のテーマ/VTuberが歌って踊ってみた【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-19T09:00:14Z"
  },
  {
    "videoId": "rAdvfmMtyZ4",
    "thumbnail": "https://i.ytimg.com/vi/rAdvfmMtyZ4/mqdefault.jpg",
    "title": "【RUST】最恐二人でミリタリートンネル完全初見攻略！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-21T11:01:44Z"
  },
  {
    "videoId": "1rXLMv0-luk",
    "thumbnail": "https://i.ytimg.com/vi/1rXLMv0-luk/mqdefault.jpg",
    "title": "【#ガルパホロライブサマー】チーム練習やってみよ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-23T12:12:20Z"
  },
  {
    "videoId": "2z7dEtmh8Cg",
    "thumbnail": "https://i.ytimg.com/vi/2z7dEtmh8Cg/mqdefault.jpg",
    "title": "【歌枠】浴衣お披露目しながらかわいく歌うッ！！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-25T12:31:33Z"
  },
  {
    "videoId": "I9iaFc6aIWw",
    "thumbnail": "https://i.ytimg.com/vi/I9iaFc6aIWw/mqdefault.jpg",
    "title": "【APEXガチャ】クラフトメタルしかでない・・・【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-26T12:20:37Z"
  },
  {
    "videoId": "qI0qAEDQ_Fk",
    "thumbnail": "https://i.ytimg.com/vi/qI0qAEDQ_Fk/mqdefault.jpg",
    "title": "【 #ホロ鯖夏祭り 】夏祭りを全力で楽しむ夏色まつりちゃん！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-08-29T14:20:14Z"
  },
  {
    "videoId": "HYa2Js-nOOE",
    "thumbnail": "https://i.ytimg.com/vi/HYa2Js-nOOE/mqdefault.jpg",
    "title": "【RUST】オレ テキ  ゼンイン ヤル【#ホロRUSTチーム戦 】",
    "publishedAt": "2022-08-30T13:55:22Z"
  },
  {
    "videoId": "ZX1JJd4WOys",
    "thumbnail": "https://i.ytimg.com/vi/ZX1JJd4WOys/mqdefault.jpg",
    "title": "【RUST】シーズン２最終戦！どこに鉛を打ち込むべきですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-09-01T14:43:45Z"
  },
  {
    "videoId": "sHEz7JjgCCI",
    "thumbnail": "https://i.ytimg.com/vi/sHEz7JjgCCI/mqdefault.jpg",
    "title": "【歌枠】お昼にまったり歌いますッ✨/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-09-04T06:09:25Z"
  },
  {
    "videoId": "Re4fkPYHBKk",
    "thumbnail": "https://i.ytimg.com/vi/Re4fkPYHBKk/mqdefault.jpg",
    "title": "【RUST】オイルリグキャリーします！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-09-10T10:33:10Z"
  },
  {
    "videoId": "xYFI2IoASbM",
    "thumbnail": "https://i.ytimg.com/vi/xYFI2IoASbM/mqdefault.jpg",
    "title": "【HoloCure】データが消えた女と最新アップデート【ホロライブ/夏色まつり】",
    "publishedAt": "2022-09-12T07:52:39Z"
  },
  {
    "videoId": "k-ZcikYqhoc",
    "thumbnail": "https://i.ytimg.com/vi/k-ZcikYqhoc/mqdefault.jpg",
    "title": "【Splatoon3】コラボ中暴言禁止ですか？ぬれええええええええええ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-09-14T15:23:33Z"
  },
  {
    "videoId": "xxH2dqlyoM0",
    "thumbnail": "https://i.ytimg.com/vi/xxH2dqlyoM0/mqdefault.jpg",
    "title": "【歌枠】19日からおやすみもらうます～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-09-17T07:56:02Z"
  },
  {
    "videoId": "ZlxfoWtbEd0",
    "thumbnail": "https://i.ytimg.com/vi/ZlxfoWtbEd0/mqdefault.jpg",
    "title": "【CRカップ】ヴァルキリー専になりました？【#しらすフェスWIN】",
    "publishedAt": "2022-09-18T13:35:50Z"
  },
  {
    "videoId": "IVi3MKMiU7U",
    "thumbnail": "https://i.ytimg.com/vi/IVi3MKMiU7U/mqdefault.jpg",
    "title": "【ただいま】休止してたの気づいてた？？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-01T08:27:56Z"
  },
  {
    "videoId": "NyHk7YwUcwk",
    "thumbnail": "https://i.ytimg.com/vi/NyHk7YwUcwk/mqdefault.jpg",
    "title": "【Splatoon3】ガチマやるぞおおおおおお！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-03T22:45:44Z"
  },
  {
    "videoId": "Y9V58IRul24",
    "thumbnail": "https://i.ytimg.com/vi/Y9V58IRul24/mqdefault.jpg",
    "title": "ランクリップ✂️",
    "publishedAt": "2022-10-04T15:56:39Z"
  },
  {
    "videoId": "MWNnX_HROUQ",
    "thumbnail": "https://i.ytimg.com/vi/MWNnX_HROUQ/mqdefault.jpg",
    "title": "【Splatoon3】起きてる？遊ぶかあああ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-04T23:55:44Z"
  },
  {
    "videoId": "E3zMHBih8uM",
    "thumbnail": "https://i.ytimg.com/vi/E3zMHBih8uM/mqdefault.jpg",
    "title": "【RUST】何が始まるんです？ばきゅーん❤【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-06T15:11:58Z"
  },
  {
    "videoId": "Nat17dL3sFg",
    "thumbnail": "https://i.ytimg.com/vi/Nat17dL3sFg/mqdefault.jpg",
    "title": "【Splatoon3】パブロ一本でS目指す！！🖌【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-07T19:54:18Z"
  },
  {
    "videoId": "PQPKP0sDv7M",
    "thumbnail": "https://i.ytimg.com/vi/PQPKP0sDv7M/mqdefault.jpg",
    "title": "パブロ1本でA帯無双する夏色まつり【Splatoon3】",
    "publishedAt": "2022-10-08T00:14:01Z"
  },
  {
    "videoId": "I4ZN3AwnLzE",
    "thumbnail": "https://i.ytimg.com/vi/I4ZN3AwnLzE/mqdefault.jpg",
    "title": "【朝活】日曜日の朝起きてますか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-09T02:02:12Z"
  },
  {
    "videoId": "6ODUfcUnklE",
    "thumbnail": "https://i.ytimg.com/vi/6ODUfcUnklE/mqdefault.jpg",
    "title": "【歌枠】お歌の時間だコラァ！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-11T13:20:38Z"
  },
  {
    "videoId": "g_v6-Qvmx8s",
    "thumbnail": "https://i.ytimg.com/vi/g_v6-Qvmx8s/mqdefault.jpg",
    "title": "【Splatoon3】バイトの時間です！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-12T08:34:35Z"
  },
  {
    "videoId": "IQbMyADfIh0",
    "thumbnail": "https://i.ytimg.com/vi/IQbMyADfIh0/mqdefault.jpg",
    "title": "【ホロライブ検定試験】ホロライブ愛試されちゃう！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-15T11:18:49Z"
  },
  {
    "videoId": "m-24UjK-Noc",
    "thumbnail": "https://i.ytimg.com/vi/m-24UjK-Noc/mqdefault.jpg",
    "title": "【歌枠】夜中にバラード【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-17T16:34:50Z"
  },
  {
    "videoId": "ix4sPQ95BCI",
    "thumbnail": "https://i.ytimg.com/vi/ix4sPQ95BCI/mqdefault.jpg",
    "title": "【RUST】シーズン4遅刻しました(*'ω'*)【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-22T12:10:23Z"
  },
  {
    "videoId": "96I4iXGraVQ",
    "thumbnail": "https://i.ytimg.com/vi/96I4iXGraVQ/mqdefault.jpg",
    "title": "すこし～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-28T10:20:29Z"
  },
  {
    "videoId": "xIkZzICHQ2Y",
    "thumbnail": "https://i.ytimg.com/vi/xIkZzICHQ2Y/mqdefault.jpg",
    "title": "【歌枠】ハッピーハロウィン🎃/Singing  KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-10-31T10:37:20Z"
  },
  {
    "videoId": "fvuxtZ2qG6o",
    "thumbnail": "https://i.ytimg.com/vi/fvuxtZ2qG6o/mqdefault.jpg",
    "title": "【APEX】新シーズンえぺぺ～【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-01T19:49:45Z"
  },
  {
    "videoId": "ip8BMYXkk10",
    "thumbnail": "https://i.ytimg.com/vi/ip8BMYXkk10/mqdefault.jpg",
    "title": "【雑談】ひるほ～！おはなししよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-03T07:49:53Z"
  },
  {
    "videoId": "kZY4HuxGLCI",
    "thumbnail": "https://i.ytimg.com/vi/kZY4HuxGLCI/mqdefault.jpg",
    "title": "【PowerWash Simulator】深夜のあわあわやさん【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-04T18:34:17Z"
  },
  {
    "videoId": "jAV1xfAdyb4",
    "thumbnail": "https://i.ytimg.com/vi/jAV1xfAdyb4/mqdefault.jpg",
    "title": "【朝活】おはようの挨拶お待ちしてます☀【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-07T02:27:03Z"
  },
  {
    "videoId": "33h1PNbL0ho",
    "thumbnail": "https://i.ytimg.com/vi/33h1PNbL0ho/mqdefault.jpg",
    "title": "【歌枠】昭和曲縛りで歌う✨【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-08T12:38:20Z"
  },
  {
    "videoId": "BWSVlPoOTTU",
    "thumbnail": "https://i.ytimg.com/vi/BWSVlPoOTTU/mqdefault.jpg",
    "title": "【Splatoon3】えいえんのほのお耐久！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-12T09:42:01Z"
  },
  {
    "videoId": "TPTnwYCVJFE",
    "thumbnail": "https://i.ytimg.com/vi/TPTnwYCVJFE/mqdefault.jpg",
    "title": "【Splatoon3】🔥🔥🔥燃え上がれ🔥🔥🔥【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-13T14:51:15Z"
  },
  {
    "videoId": "KE0RERAqt-8",
    "thumbnail": "https://i.ytimg.com/vi/KE0RERAqt-8/mqdefault.jpg",
    "title": "【ひるほ～】まったりお話に付き合ってくだちい【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-16T05:08:13Z"
  },
  {
    "videoId": "8DiN87kF9LM",
    "thumbnail": "https://i.ytimg.com/vi/8DiN87kF9LM/mqdefault.jpg",
    "title": "【地獄銭湯】お風呂一緒についてきて・・・？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-16T15:08:16Z"
  },
  {
    "videoId": "G--BO7A7WKc",
    "thumbnail": "https://i.ytimg.com/vi/G--BO7A7WKc/mqdefault.jpg",
    "title": "【あくありうむ。】俺のメイドがかわいすぎる件 #1【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-18T15:07:43Z"
  },
  {
    "videoId": "VijrLPBnwRg",
    "thumbnail": "https://i.ytimg.com/vi/VijrLPBnwRg/mqdefault.jpg",
    "title": "【 ラブライブ！】伝説の水着会「先輩禁止！」を一緒に見るぞッ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-19T09:50:33Z"
  },
  {
    "videoId": "ycscRBMDhbw",
    "thumbnail": "https://i.ytimg.com/vi/ycscRBMDhbw/mqdefault.jpg",
    "title": "【歌枠】アイドル曲をスーパー最強アイドルが歌うッ❤【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-20T10:33:53Z"
  },
  {
    "videoId": "sXst3oh6bDY",
    "thumbnail": "https://i.ytimg.com/vi/sXst3oh6bDY/mqdefault.jpg",
    "title": "【ポケモンSV】視聴者参加型│サンドイッチスローライフ【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-22T11:11:50Z"
  },
  {
    "videoId": "YzBQBkMJlXc",
    "thumbnail": "https://i.ytimg.com/vi/YzBQBkMJlXc/mqdefault.jpg",
    "title": "【マリオパーティ スーパースターズ】遊ぼうぜ☆【#ふわふま渋谷まつり】",
    "publishedAt": "2022-11-26T16:08:34Z"
  },
  {
    "videoId": "UBLMh5xmDtg",
    "thumbnail": "https://i.ytimg.com/vi/UBLMh5xmDtg/mqdefault.jpg",
    "title": "【 The Backrooms 1998 】怖い部屋に連れていく妖怪狐に連れてこられた【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-27T15:48:14Z"
  },
  {
    "videoId": "C425ix20yMw",
    "thumbnail": "https://i.ytimg.com/vi/C425ix20yMw/mqdefault.jpg",
    "title": "【歌枠】うた【ホロライブ/夏色まつり】",
    "publishedAt": "2022-11-30T14:51:57Z"
  },
  {
    "videoId": "x_ub8lRE3jM",
    "thumbnail": "https://i.ytimg.com/vi/x_ub8lRE3jM/mqdefault.jpg",
    "title": "【あつ森】睡眠導入💤島整備【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-01T19:37:53Z"
  },
  {
    "videoId": "CgmyapbZibA",
    "thumbnail": "https://i.ytimg.com/vi/CgmyapbZibA/mqdefault.jpg",
    "title": "【APEX】家電を奪い取ります！/Rakuten esports cup 家電争奪戦【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-03T15:17:52Z"
  },
  {
    "videoId": "k-aogvupwAA",
    "thumbnail": "https://i.ytimg.com/vi/k-aogvupwAA/mqdefault.jpg",
    "title": "【Trombone Champ】元吹奏楽部行きます！ぱ～ぱ～ぽ～♪【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-04T10:14:31Z"
  },
  {
    "videoId": "vPww9-sY-l4",
    "thumbnail": "https://i.ytimg.com/vi/vPww9-sY-l4/mqdefault.jpg",
    "title": "【食費APEX】1ダメ1円で相手の食費を稼ぐ！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-07T10:10:27Z"
  },
  {
    "videoId": "35e3pMx8pnk",
    "thumbnail": "https://i.ytimg.com/vi/35e3pMx8pnk/mqdefault.jpg",
    "title": "【#超絶おいしい】5分で超絶おいしい！私もカレーメシ宣言！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-09T11:01:52Z"
  },
  {
    "videoId": "ZZqNPI975MY",
    "thumbnail": "https://i.ytimg.com/vi/ZZqNPI975MY/mqdefault.jpg",
    "title": "【朝活】あさ☀【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-10T00:18:31Z"
  },
  {
    "videoId": "nVpEmfWj4E0",
    "thumbnail": "https://i.ytimg.com/vi/nVpEmfWj4E0/mqdefault.jpg",
    "title": "【デート報告】シオンと大阪旅行に行ったんですか・・・❤【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-10T11:10:51Z"
  },
  {
    "videoId": "5Chu3Yq9Hzo",
    "thumbnail": "https://i.ytimg.com/vi/5Chu3Yq9Hzo/mqdefault.jpg",
    "title": "【マリオカート8DX】ショートカット覚える！強くなる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-16T08:51:28Z"
  },
  {
    "videoId": "k9d4o0UK880",
    "thumbnail": "https://i.ytimg.com/vi/k9d4o0UK880/mqdefault.jpg",
    "title": "【歌枠】元気になれる歌枠✨【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-18T14:48:18Z"
  },
  {
    "videoId": "cEbp9fWPvz0",
    "thumbnail": "https://i.ytimg.com/vi/cEbp9fWPvz0/mqdefault.jpg",
    "title": "【マリオカート8DX】ぶうううううううううううううううん🚙【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-22T15:16:38Z"
  },
  {
    "videoId": "X8iyO1DTKnw",
    "thumbnail": "https://i.ytimg.com/vi/X8iyO1DTKnw/mqdefault.jpg",
    "title": "【APEX】イブはまつトワで過ごします///　#まつトワクリスマスイヴ　【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-24T07:25:04Z"
  },
  {
    "videoId": "6GWlS05L2D0",
    "thumbnail": "https://i.ytimg.com/vi/6GWlS05L2D0/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】目指せ5曲✨歌います♡/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-25T06:21:48Z"
  },
  {
    "videoId": "VYgFVklI_GQ",
    "thumbnail": "https://i.ytimg.com/vi/VYgFVklI_GQ/mqdefault.jpg",
    "title": "【おはよう】クリスマスに緊急搬送されてました【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-26T23:27:15Z"
  },
  {
    "videoId": "0eE9rB11nQU",
    "thumbnail": "https://i.ytimg.com/vi/0eE9rB11nQU/mqdefault.jpg",
    "title": "【ASMR】メン限お試しいちゃいちゃASMR/KU100【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-28T11:21:13Z"
  },
  {
    "videoId": "LjTx42r1uww",
    "thumbnail": "https://i.ytimg.com/vi/LjTx42r1uww/mqdefault.jpg",
    "title": "【#年末アベマで花咲くホロライブ 】期間限定でBloom,が無料で見れる！？【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-30T07:53:07Z"
  },
  {
    "videoId": "O3EbD5fCCL4",
    "thumbnail": "https://i.ytimg.com/vi/O3EbD5fCCL4/mqdefault.jpg",
    "title": "【APEXガチャ】⚠今年最後のスパレジェ耐久！⚠【ホロライブ/夏色まつり】",
    "publishedAt": "2022-12-31T08:39:13Z"
  },
  {
    "videoId": "WY5nHPYzQcA",
    "thumbnail": "https://i.ytimg.com/vi/WY5nHPYzQcA/mqdefault.jpg",
    "title": "【筆おろし】君の名前も書かれちゃう！？デジタル書初め♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-01T13:48:42Z"
  },
  {
    "videoId": "XBtFWErA8Ps",
    "thumbnail": "https://i.ytimg.com/vi/XBtFWErA8Ps/mqdefault.jpg",
    "title": "【おはよう】朝活で今日からがんばる君を応援！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-03T22:55:34Z"
  },
  {
    "videoId": "3rskP62vS9c",
    "thumbnail": "https://i.ytimg.com/vi/3rskP62vS9c/mqdefault.jpg",
    "title": "【マリオカート8DX】視聴者参加型特訓！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-05T14:51:45Z"
  },
  {
    "videoId": "Gia9TFG2tRc",
    "thumbnail": "https://i.ytimg.com/vi/Gia9TFG2tRc/mqdefault.jpg",
    "title": "【マリオカート8DX】マリカ1位耐久いくぞおおおおおお！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-06T14:44:09Z"
  },
  {
    "videoId": "cXktf4FxAg0",
    "thumbnail": "https://i.ytimg.com/vi/cXktf4FxAg0/mqdefault.jpg",
    "title": "【マリオカート8DX】2023年初寝坊したくせに耐久19分で終わらせた女【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-06T18:14:01Z"
  },
  {
    "videoId": "HOroSjUSfjE",
    "thumbnail": "https://i.ytimg.com/vi/HOroSjUSfjE/mqdefault.jpg",
    "title": "【#ホロお正月CUP2023】私、頑張ります！！/予選【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-07T06:08:53Z"
  },
  {
    "videoId": "EMR_GNXZ8vE",
    "thumbnail": "https://i.ytimg.com/vi/EMR_GNXZ8vE/mqdefault.jpg",
    "title": "【#ホロお正月CUP2023】ドキドキしながら頑張ります！/つよ杯【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-07T08:50:40Z"
  },
  {
    "videoId": "TaTxIrzsSqc",
    "thumbnail": "https://i.ytimg.com/vi/TaTxIrzsSqc/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】🍰えいえん耐久スタート！！🍰【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-07T23:11:19Z"
  },
  {
    "videoId": "PZ2NzxEvCcU",
    "thumbnail": "https://i.ytimg.com/vi/PZ2NzxEvCcU/mqdefault.jpg",
    "title": "【APEXランク】🔥マスター耐久🔥【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-08T16:34:49Z"
  },
  {
    "videoId": "aImq68IOjlA",
    "thumbnail": "https://i.ytimg.com/vi/aImq68IOjlA/mqdefault.jpg",
    "title": "【つぐのひ】バイトしに来ただけなのに怖いんですが！？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-10T10:26:05Z"
  },
  {
    "videoId": "HDQFmjDQI0w",
    "thumbnail": "https://i.ytimg.com/vi/HDQFmjDQI0w/mqdefault.jpg",
    "title": "【歌枠】💞KAWAII Song💞【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-11T12:11:15Z"
  },
  {
    "videoId": "sZVWzvKZIAA",
    "thumbnail": "https://i.ytimg.com/vi/sZVWzvKZIAA/mqdefault.jpg",
    "title": "【ぶっちゃけ】マシュマロトークでおはなし！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-12T14:55:34Z"
  },
  {
    "videoId": "VGWkmNaACCQ",
    "thumbnail": "https://i.ytimg.com/vi/VGWkmNaACCQ/mqdefault.jpg",
    "title": "【GeoGuessr】ここはどーこだ！！あ！このカレー屋さんおいしいよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-14T15:10:00Z"
  },
  {
    "videoId": "n82XjwgrQ54",
    "thumbnail": "https://i.ytimg.com/vi/n82XjwgrQ54/mqdefault.jpg",
    "title": "【歌枠】新エフェクターでケロケロ歌う！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-15T03:11:49Z"
  },
  {
    "videoId": "VFqHO9Tl44M",
    "thumbnail": "https://i.ytimg.com/vi/VFqHO9Tl44M/mqdefault.jpg",
    "title": "【報告会】最近いろんなことがあった！！楽しい！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-16T15:32:14Z"
  },
  {
    "videoId": "i4iPdKtl-m0",
    "thumbnail": "https://i.ytimg.com/vi/i4iPdKtl-m0/mqdefault.jpg",
    "title": "【 もろだし相撲 】アーカイブに制限がつくゲームらしいｗｗｗ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-17T10:03:52Z"
  },
  {
    "videoId": "SOugryNTs28",
    "thumbnail": "https://i.ytimg.com/vi/SOugryNTs28/mqdefault.jpg",
    "title": "出た！負け惜しみ～！",
    "publishedAt": "2023-01-17T14:39:40Z"
  },
  {
    "videoId": "qst77t-8yDE",
    "thumbnail": "https://i.ytimg.com/vi/qst77t-8yDE/mqdefault.jpg",
    "title": "【ASMR】メン限お試しメスガキASMR/KU100【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-18T14:19:00Z"
  },
  {
    "videoId": "Ttl4hfufasU",
    "thumbnail": "https://i.ytimg.com/vi/Ttl4hfufasU/mqdefault.jpg",
    "title": "絶望",
    "publishedAt": "2023-01-20T04:36:53Z"
  },
  {
    "videoId": "_DHFAuQzGIU",
    "thumbnail": "https://i.ytimg.com/vi/_DHFAuQzGIU/mqdefault.jpg",
    "title": "【#ホロライブ共通テスト】このテストなら赤点回避できそうです！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-22T14:03:50Z"
  },
  {
    "videoId": "5i7u79T1bMw",
    "thumbnail": "https://i.ytimg.com/vi/5i7u79T1bMw/mqdefault.jpg",
    "title": "【 Minecraft 】新ホロ鯖きちゃ！！0から始めていくぜ✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-23T15:38:33Z"
  },
  {
    "videoId": "0aq3v7K6Zok",
    "thumbnail": "https://i.ytimg.com/vi/0aq3v7K6Zok/mqdefault.jpg",
    "title": "【 Minecraft 】おしゃれモダンハウス完成させる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-25T08:50:43Z"
  },
  {
    "videoId": "-u11qN4tq1o",
    "thumbnail": "https://i.ytimg.com/vi/-u11qN4tq1o/mqdefault.jpg",
    "title": "【お披露目】これは・・！？がお・・？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-26T11:44:32Z"
  },
  {
    "videoId": "MkUBPs6xCTQ",
    "thumbnail": "https://i.ytimg.com/vi/MkUBPs6xCTQ/mqdefault.jpg",
    "title": "【歌枠】バラード【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-26T15:35:48Z"
  },
  {
    "videoId": "O_g5HxZHjvo",
    "thumbnail": "https://i.ytimg.com/vi/O_g5HxZHjvo/mqdefault.jpg",
    "title": "【 Minecraft 】いい家ができたら冒険や！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-28T08:13:41Z"
  },
  {
    "videoId": "zP2Jr7mdAyw",
    "thumbnail": "https://i.ytimg.com/vi/zP2Jr7mdAyw/mqdefault.jpg",
    "title": "【 Minecraft 】おしゃれ倉庫にいいものしまいたい！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-29T18:19:26Z"
  },
  {
    "videoId": "psfv6zL8e3Y",
    "thumbnail": "https://i.ytimg.com/vi/psfv6zL8e3Y/mqdefault.jpg",
    "title": "【A Little to the Left】☁ まったりパズルゲーム ☁【ホロライブ/夏色まつり】",
    "publishedAt": "2023-01-31T17:31:47Z"
  },
  {
    "videoId": "CmWE7nOUwCs",
    "thumbnail": "https://i.ytimg.com/vi/CmWE7nOUwCs/mqdefault.jpg",
    "title": "【 Minecraft 】ダイヤフル装備つくるぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-03T18:15:33Z"
  },
  {
    "videoId": "gTddgowqiG8",
    "thumbnail": "https://i.ytimg.com/vi/gTddgowqiG8/mqdefault.jpg",
    "title": "【歌枠】歌わせていただきます！！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-05T02:00:43Z"
  },
  {
    "videoId": "uDjKw7Rskis",
    "thumbnail": "https://i.ytimg.com/vi/uDjKw7Rskis/mqdefault.jpg",
    "title": "【APEX】APEX4周年おめでとうございます！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-06T11:25:07Z"
  },
  {
    "videoId": "wc9npigkbLM",
    "thumbnail": "https://i.ytimg.com/vi/wc9npigkbLM/mqdefault.jpg",
    "title": "【 Minecraft 】初！ネザライト装備つくりたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-07T13:18:24Z"
  },
  {
    "videoId": "N2MVACnZnLg",
    "thumbnail": "https://i.ytimg.com/vi/N2MVACnZnLg/mqdefault.jpg",
    "title": "【 Minecraft 】まったり昼釣り雑談🎣【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-08T07:04:14Z"
  },
  {
    "videoId": "ae_t20SMUOc",
    "thumbnail": "https://i.ytimg.com/vi/ae_t20SMUOc/mqdefault.jpg",
    "title": "【スプラトゥーン3】ホラガイとミルクとバイトと朝【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-11T02:42:06Z"
  },
  {
    "videoId": "RWaBdljNnpI",
    "thumbnail": "https://i.ytimg.com/vi/RWaBdljNnpI/mqdefault.jpg",
    "title": "【スプラトゥーン3】甘いミルクの海に沈めます🍫【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-12T17:31:49Z"
  },
  {
    "videoId": "k9rqdD95N04",
    "thumbnail": "https://i.ytimg.com/vi/k9rqdD95N04/mqdefault.jpg",
    "title": "【 ホグワーツレガシー 】ハリーポッターを1mmも知らない女が行く魔法学校1日目【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-13T09:37:09Z"
  },
  {
    "videoId": "BMOjUCu7Hdg",
    "thumbnail": "https://i.ytimg.com/vi/BMOjUCu7Hdg/mqdefault.jpg",
    "title": "【APEXデート】クリスマスもバレンタインも一緒って恋人やん！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-13T15:30:21Z"
  },
  {
    "videoId": "ciyvpCL1Ars",
    "thumbnail": "https://i.ytimg.com/vi/ciyvpCL1Ars/mqdefault.jpg",
    "title": "【歌枠】恋してくれませんか？/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-15T08:08:50Z"
  },
  {
    "videoId": "4Dy7IAiTlC4",
    "thumbnail": "https://i.ytimg.com/vi/4Dy7IAiTlC4/mqdefault.jpg",
    "title": "【 Minecraft 】深夜に睡眠導入釣り配信🐡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-16T17:19:50Z"
  },
  {
    "videoId": "k6BSVh2YMHU",
    "thumbnail": "https://i.ytimg.com/vi/k6BSVh2YMHU/mqdefault.jpg",
    "title": "【 ホグワーツレガシー 】ミリしらレイブンクローの生徒として生きる2日目【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-17T08:04:23Z"
  },
  {
    "videoId": "GqfKgy9uq10",
    "thumbnail": "https://i.ytimg.com/vi/GqfKgy9uq10/mqdefault.jpg",
    "title": "【スプラトゥーン3】でんせつアルバイターとクマさん武器🐻【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-19T10:18:22Z"
  },
  {
    "videoId": "-SW43V-xlX8",
    "thumbnail": "https://i.ytimg.com/vi/-SW43V-xlX8/mqdefault.jpg",
    "title": "【 mocopi 】おうち全身3Dで歌ったり踊ったり！？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-20T15:20:49Z"
  },
  {
    "videoId": "m3tedRbJO9w",
    "thumbnail": "https://i.ytimg.com/vi/m3tedRbJO9w/mqdefault.jpg",
    "title": "【 APEX 】 #DREAMMATCH / 渋ハル軍清楚担当:前半【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-23T05:29:38Z"
  },
  {
    "videoId": "zrbZfjxvM_c",
    "thumbnail": "https://i.ytimg.com/vi/zrbZfjxvM_c/mqdefault.jpg",
    "title": "【 APEX 】 #DREAMMATCH / 渋ハル軍清楚担当:後半【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-23T11:41:07Z"
  },
  {
    "videoId": "IuaLIOhr7S8",
    "thumbnail": "https://i.ytimg.com/vi/IuaLIOhr7S8/mqdefault.jpg",
    "title": "少しの間おやすみします！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-23T14:26:45Z"
  },
  {
    "videoId": "jzlLldkI_nI",
    "thumbnail": "https://i.ytimg.com/vi/jzlLldkI_nI/mqdefault.jpg",
    "title": "hug meeeeeeee!!!!!!!!【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-25T13:00:33Z"
  },
  {
    "videoId": "t45UEPraoxo",
    "thumbnail": "https://i.ytimg.com/vi/t45UEPraoxo/mqdefault.jpg",
    "title": "【&honey】ガチ愛用してるシャンプーレビューする！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-28T09:00:08Z"
  },
  {
    "videoId": "bLVnWl8jZEM",
    "thumbnail": "https://i.ytimg.com/vi/bLVnWl8jZEM/mqdefault.jpg",
    "title": "Chill time:)　【ホロライブ/夏色まつり】",
    "publishedAt": "2023-02-28T13:00:34Z"
  },
  {
    "videoId": "r4Yba_lrK3U",
    "thumbnail": "https://i.ytimg.com/vi/r4Yba_lrK3U/mqdefault.jpg",
    "title": "No brake【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-03T13:00:41Z"
  },
  {
    "videoId": "74ZavcGXq4s",
    "thumbnail": "https://i.ytimg.com/vi/74ZavcGXq4s/mqdefault.jpg",
    "title": "【APEX】#SBINEXUM / ねこの爪は痛いチーム【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-04T14:13:39Z"
  },
  {
    "videoId": "Wo656lUnKz4",
    "thumbnail": "https://i.ytimg.com/vi/Wo656lUnKz4/mqdefault.jpg",
    "title": "お願い👉🏻👈🏻【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-07T13:00:32Z"
  },
  {
    "videoId": "DkPSVmZBDB0",
    "thumbnail": "https://i.ytimg.com/vi/DkPSVmZBDB0/mqdefault.jpg",
    "title": "【ただいま！】元気な復帰配信✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-09T09:53:40Z"
  },
  {
    "videoId": "Apc9HIq91_Y",
    "thumbnail": "https://i.ytimg.com/vi/Apc9HIq91_Y/mqdefault.jpg",
    "title": "【HoloCure】ホロメンを操っちゃうぞッ❤【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-09T16:10:08Z"
  },
  {
    "videoId": "6J9OKt7FZ14",
    "thumbnail": "https://i.ytimg.com/vi/6J9OKt7FZ14/mqdefault.jpg",
    "title": "【 APEX 】1年ぶりにNGなしのわちゃわちゃコラボ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-10T10:16:33Z"
  },
  {
    "videoId": "JFSC3rCzXWk",
    "thumbnail": "https://i.ytimg.com/vi/JFSC3rCzXWk/mqdefault.jpg",
    "title": "【 Minecraft 】海底神殿に行きたい！何が必要？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-11T08:28:36Z"
  },
  {
    "videoId": "OkXiTAkFS1M",
    "thumbnail": "https://i.ytimg.com/vi/OkXiTAkFS1M/mqdefault.jpg",
    "title": "【老人会】ホロメン勝手にメル画大会！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-12T14:20:34Z"
  },
  {
    "videoId": "khp-YGmFn_g",
    "thumbnail": "https://i.ytimg.com/vi/khp-YGmFn_g/mqdefault.jpg",
    "title": "【歌枠】おうた【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-14T12:22:12Z"
  },
  {
    "videoId": "qpAWvkAAEp8",
    "thumbnail": "https://i.ytimg.com/vi/qpAWvkAAEp8/mqdefault.jpg",
    "title": "【 雑談 / free talk 】まもなくライブですけども【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-16T11:30:06Z"
  },
  {
    "videoId": "f8jeoisZeFY",
    "thumbnail": "https://i.ytimg.com/vi/f8jeoisZeFY/mqdefault.jpg",
    "title": "絶対王政カーニバル / 夏色まつり(official)",
    "publishedAt": "2023-03-20T11:30:09Z"
  },
  {
    "videoId": "BKDsGsb7JbI",
    "thumbnail": "https://i.ytimg.com/vi/BKDsGsb7JbI/mqdefault.jpg",
    "title": "【裏話あり】感想＆同時視聴会✨【 ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-20T12:27:25Z"
  },
  {
    "videoId": "FAR53G8sptM",
    "thumbnail": "https://i.ytimg.com/vi/FAR53G8sptM/mqdefault.jpg",
    "title": "【歌枠】ホロライブ曲限定✨/hololive only【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-21T07:24:44Z"
  },
  {
    "videoId": "XeRxEkENvzQ",
    "thumbnail": "https://i.ytimg.com/vi/XeRxEkENvzQ/mqdefault.jpg",
    "title": "【 APEX 】V最協顔合わせ！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-22T11:25:12Z"
  },
  {
    "videoId": "FeZva-7YIA8",
    "thumbnail": "https://i.ytimg.com/vi/FeZva-7YIA8/mqdefault.jpg",
    "title": "【 APEX 】修行のお供に参戦！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-26T08:20:05Z"
  },
  {
    "videoId": "IygGH-mqvjc",
    "thumbnail": "https://i.ytimg.com/vi/IygGH-mqvjc/mqdefault.jpg",
    "title": "【 APEX 】ちーむ名はなんですか？/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-26T17:53:56Z"
  },
  {
    "videoId": "urGrKKnXmAM",
    "thumbnail": "https://i.ytimg.com/vi/urGrKKnXmAM/mqdefault.jpg",
    "title": "【 APEX 】三清傑いくぞ！！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-27T14:29:04Z"
  },
  {
    "videoId": "nj2jKWHcqbM",
    "thumbnail": "https://i.ytimg.com/vi/nj2jKWHcqbM/mqdefault.jpg",
    "title": "【 APEX 】たまにはランクをしましょうと【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-27T18:54:31Z"
  },
  {
    "videoId": "xszx6x8_EmQ",
    "thumbnail": "https://i.ytimg.com/vi/xszx6x8_EmQ/mqdefault.jpg",
    "title": "【 Q Remastered 】ごり押し物理演算パズル【ホロライブ/夏色まつり】",
    "publishedAt": "2023-03-28T08:06:00Z"
  },
  {
    "videoId": "U2dpPBBf9uk",
    "thumbnail": "https://i.ytimg.com/vi/U2dpPBBf9uk/mqdefault.jpg",
    "title": "【朝活】おはようの挨拶5億人からほしい☀【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-01T00:12:53Z"
  },
  {
    "videoId": "g8cBqHkpc_0",
    "thumbnail": "https://i.ytimg.com/vi/g8cBqHkpc_0/mqdefault.jpg",
    "title": "【 APEX 】ちゃんぴおんまでもう少し・・・！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-02T18:09:07Z"
  },
  {
    "videoId": "seAv-Qo5Szg",
    "thumbnail": "https://i.ytimg.com/vi/seAv-Qo5Szg/mqdefault.jpg",
    "title": "【朝歌枠】朝から元気がでる歌枠☀【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-04T01:12:54Z"
  },
  {
    "videoId": "OppRCgnWiS0",
    "thumbnail": "https://i.ytimg.com/vi/OppRCgnWiS0/mqdefault.jpg",
    "title": "【 APEX 】突如あつまりまｓた/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-04T15:42:11Z"
  },
  {
    "videoId": "hXgMcoSFFz0",
    "thumbnail": "https://i.ytimg.com/vi/hXgMcoSFFz0/mqdefault.jpg",
    "title": "【ぷよぷよテトリス2】0からはじめるテトリス生活#1【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-05T08:41:46Z"
  },
  {
    "videoId": "o1_brnwdJhk",
    "thumbnail": "https://i.ytimg.com/vi/o1_brnwdJhk/mqdefault.jpg",
    "title": "【 APEX 】トライあんどエラー/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-05T18:15:36Z"
  },
  {
    "videoId": "VB57F-uaq6o",
    "thumbnail": "https://i.ytimg.com/vi/VB57F-uaq6o/mqdefault.jpg",
    "title": "【 APEX 】渋ハルカスタムに参戦！！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-06T17:51:59Z"
  },
  {
    "videoId": "8HmjcJDRidQ",
    "thumbnail": "https://i.ytimg.com/vi/8HmjcJDRidQ/mqdefault.jpg",
    "title": "【アソビ大全】1時間で泣かすか泣かされるか【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-07T13:26:26Z"
  },
  {
    "videoId": "wJHAeGX16xA",
    "thumbnail": "https://i.ytimg.com/vi/wJHAeGX16xA/mqdefault.jpg",
    "title": "【 APEX 】頑張れ！頑張る！カスタム！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-07T19:21:40Z"
  },
  {
    "videoId": "PImcL1Inxb0",
    "thumbnail": "https://i.ytimg.com/vi/PImcL1Inxb0/mqdefault.jpg",
    "title": "【違う冬のぼくら/BOKURA】見てる世界が違うなか協力できますか？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-08T11:15:07Z"
  },
  {
    "videoId": "CAoKP91aMkQ",
    "thumbnail": "https://i.ytimg.com/vi/CAoKP91aMkQ/mqdefault.jpg",
    "title": "【 APEX 】声出し声出し！！！！！！！！！！！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-08T20:20:53Z"
  },
  {
    "videoId": "bZml-K3JA0c",
    "thumbnail": "https://i.ytimg.com/vi/bZml-K3JA0c/mqdefault.jpg",
    "title": "【違う冬のぼくら/BOKURA】2周目のぼくらになにができますか【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-09T08:00:07Z"
  },
  {
    "videoId": "wRXC84MPV3Q",
    "thumbnail": "https://i.ytimg.com/vi/wRXC84MPV3Q/mqdefault.jpg",
    "title": "【 APEX 】まったりオーダーの日/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-09T17:14:27Z"
  },
  {
    "videoId": "Pltm-VasXRs",
    "thumbnail": "https://i.ytimg.com/vi/Pltm-VasXRs/mqdefault.jpg",
    "title": "【APEXランク】ぷらちなランクやさん w/えでんさん、水無瀬くん【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-10T09:15:12Z"
  },
  {
    "videoId": "FW6QEUZO5SQ",
    "thumbnail": "https://i.ytimg.com/vi/FW6QEUZO5SQ/mqdefault.jpg",
    "title": "【 APEX 】ふれー！ふれー！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-10T17:28:31Z"
  },
  {
    "videoId": "TneGAEfJH-4",
    "thumbnail": "https://i.ytimg.com/vi/TneGAEfJH-4/mqdefault.jpg",
    "title": "【Splatoon3】久しぶりの出勤です！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-11T11:46:59Z"
  },
  {
    "videoId": "TscYmLwPTMc",
    "thumbnail": "https://i.ytimg.com/vi/TscYmLwPTMc/mqdefault.jpg",
    "title": "【 APEX 】声を大きく出すぞッ！/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-11T18:13:49Z"
  },
  {
    "videoId": "ph5xx5rN-o0",
    "thumbnail": "https://i.ytimg.com/vi/ph5xx5rN-o0/mqdefault.jpg",
    "title": "【 APEX 】ちゃれんじいちねんせい/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-12T17:03:49Z"
  },
  {
    "videoId": "VdJwRnEBqlA",
    "thumbnail": "https://i.ytimg.com/vi/VdJwRnEBqlA/mqdefault.jpg",
    "title": "【 APEX 】てくてくあるく/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-13T15:30:10Z"
  },
  {
    "videoId": "V6iDwb8NsFk",
    "thumbnail": "https://i.ytimg.com/vi/V6iDwb8NsFk/mqdefault.jpg",
    "title": "【 APEX 】せいこうたいけん/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-14T17:22:24Z"
  },
  {
    "videoId": "oVtrOAH52xs",
    "thumbnail": "https://i.ytimg.com/vi/oVtrOAH52xs/mqdefault.jpg",
    "title": "【 APEX 】本番当日の勝利/ wえる、藍沢エマ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-15T14:08:06Z"
  },
  {
    "videoId": "PDqfol1wZK4",
    "thumbnail": "https://i.ytimg.com/vi/PDqfol1wZK4/mqdefault.jpg",
    "title": "【 ぷよテト2 】優しくしてください【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-16T11:48:21Z"
  },
  {
    "videoId": "7thgmRICLjU",
    "thumbnail": "https://i.ytimg.com/vi/7thgmRICLjU/mqdefault.jpg",
    "title": "【歌枠】久しぶりのおうた🎵【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-19T06:20:00Z"
  },
  {
    "videoId": "1zYUMPW_pNU",
    "thumbnail": "https://i.ytimg.com/vi/1zYUMPW_pNU/mqdefault.jpg",
    "title": "【a pet shop after dark】動物のいない不思議なペットショップ店員【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-22T19:47:15Z"
  },
  {
    "videoId": "fGRm_4nP9SU",
    "thumbnail": "https://i.ytimg.com/vi/fGRm_4nP9SU/mqdefault.jpg",
    "title": "【 APEXランク 】ダイヤ帯平和ですか・・・？ w/ハユン、H1yaA【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-24T08:23:48Z"
  },
  {
    "videoId": "lSRzVx2jc-Q",
    "thumbnail": "https://i.ytimg.com/vi/lSRzVx2jc-Q/mqdefault.jpg",
    "title": "【 Rust / スト鯖】はじめてのスト鯖失礼します！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-24T17:55:39Z"
  },
  {
    "videoId": "LD7hmuZAUpc",
    "thumbnail": "https://i.ytimg.com/vi/LD7hmuZAUpc/mqdefault.jpg",
    "title": "【 Rust / スト鯖】ギャンブルとモーテル【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-25T20:09:32Z"
  },
  {
    "videoId": "oxbycHoKqCQ",
    "thumbnail": "https://i.ytimg.com/vi/oxbycHoKqCQ/mqdefault.jpg",
    "title": "【 Rust / スト鯖】健全なRust【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-27T01:49:30Z"
  },
  {
    "videoId": "Z0WefcR86RM",
    "thumbnail": "https://i.ytimg.com/vi/Z0WefcR86RM/mqdefault.jpg",
    "title": "【 Rust / スト鯖】では、ギャンブルを始めます【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-27T23:41:08Z"
  },
  {
    "videoId": "UfkDjdxVp04",
    "thumbnail": "https://i.ytimg.com/vi/UfkDjdxVp04/mqdefault.jpg",
    "title": "【 Rust / スト鯖】全財産でボイスリクエストする【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-28T16:01:00Z"
  },
  {
    "videoId": "h1pKWbqLwjk",
    "thumbnail": "https://i.ytimg.com/vi/h1pKWbqLwjk/mqdefault.jpg",
    "title": "【 #ホロドロケイ 】君の心を盗みます♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-04-29T13:13:44Z"
  },
  {
    "videoId": "kdS5ymWhAfk",
    "thumbnail": "https://i.ytimg.com/vi/kdS5ymWhAfk/mqdefault.jpg",
    "title": "【朝活】おはよ～！！！今日も元気にいこう！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-01T01:54:03Z"
  },
  {
    "videoId": "kNKkmhdLIr4",
    "thumbnail": "https://i.ytimg.com/vi/kNKkmhdLIr4/mqdefault.jpg",
    "title": "【APEX】1週間ぶりなのでエイムあわせPEX【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-02T00:32:03Z"
  },
  {
    "videoId": "yay60Ahkhhc",
    "thumbnail": "https://i.ytimg.com/vi/yay60Ahkhhc/mqdefault.jpg",
    "title": "【歌枠】今宵はお歌を歌います！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-04T11:32:49Z"
  },
  {
    "videoId": "YqRRf_jxfKQ",
    "thumbnail": "https://i.ytimg.com/vi/YqRRf_jxfKQ/mqdefault.jpg",
    "title": "【老人会】ホロメン勝手にメル画大会！/第二弾【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-05T10:14:50Z"
  },
  {
    "videoId": "uUnXss6JG1o",
    "thumbnail": "https://i.ytimg.com/vi/uUnXss6JG1o/mqdefault.jpg",
    "title": "【VALORANT】振り分け戦いってみます！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-06T12:45:47Z"
  },
  {
    "videoId": "NCiTCXQ9_O0",
    "thumbnail": "https://i.ytimg.com/vi/NCiTCXQ9_O0/mqdefault.jpg",
    "title": "【APEX】異色コラボ感謝します。【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-16T16:35:50Z"
  },
  {
    "videoId": "DXOeV4bfuyM",
    "thumbnail": "https://i.ytimg.com/vi/DXOeV4bfuyM/mqdefault.jpg",
    "title": "【ゼルダの伝説　ティアーズ オブ ザ キングダム】謎解きは得意です！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-17T15:48:08Z"
  },
  {
    "videoId": "UExXW6Lluqc",
    "thumbnail": "https://i.ytimg.com/vi/UExXW6Lluqc/mqdefault.jpg",
    "title": "【ゼルダの伝説　ティアーズ オブ ザ キングダム】さくさく謎解きまつリンク！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-21T09:27:08Z"
  },
  {
    "videoId": "VGwbuTWekzw",
    "thumbnail": "https://i.ytimg.com/vi/VGwbuTWekzw/mqdefault.jpg",
    "title": "【ゴッドフィールド】視聴者相手なら勝てるやろ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-22T10:10:19Z"
  },
  {
    "videoId": "gg6bQx3ghx8",
    "thumbnail": "https://i.ytimg.com/vi/gg6bQx3ghx8/mqdefault.jpg",
    "title": "【APEX】ぱいせんに教わりやす【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-22T14:07:24Z"
  },
  {
    "videoId": "EQjmSTqm4rs",
    "thumbnail": "https://i.ytimg.com/vi/EQjmSTqm4rs/mqdefault.jpg",
    "title": "【The Outlast Trials】#ホロ１期生コラボ ってホラー苦手3人いますが？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-26T15:22:39Z"
  },
  {
    "videoId": "KEc-7W9c3Ho",
    "thumbnail": "https://i.ytimg.com/vi/KEc-7W9c3Ho/mqdefault.jpg",
    "title": "【歌枠】アイドル様のおうた🎵【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-27T15:22:11Z"
  },
  {
    "videoId": "pks-OmJ3FeU",
    "thumbnail": "https://i.ytimg.com/vi/pks-OmJ3FeU/mqdefault.jpg",
    "title": "【witch it】たくさんの人とあそぶ！w/関優太・AlphaAzur・なちょ・らむ・れんじろう・まるーん・ファン太・ラトナ・プティ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-28T12:13:33Z"
  },
  {
    "videoId": "dizdXwVNSEY",
    "thumbnail": "https://i.ytimg.com/vi/dizdXwVNSEY/mqdefault.jpg",
    "title": "【APEXガチャ】何度目かの正直っていうじゃん？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-05-29T12:18:21Z"
  },
  {
    "videoId": "kllDy0nlzxw",
    "thumbnail": "https://i.ytimg.com/vi/kllDy0nlzxw/mqdefault.jpg",
    "title": "【タワーオブスカイ】ホロライブコラボ開催！普通にハマってますが？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-01T11:06:57Z"
  },
  {
    "videoId": "-_iTJtH7QAU",
    "thumbnail": "https://i.ytimg.com/vi/-_iTJtH7QAU/mqdefault.jpg",
    "title": "強風オールバック/夏色まつり(cover)",
    "publishedAt": "2023-06-03T13:00:10Z"
  },
  {
    "videoId": "fNTXjwAW4yk",
    "thumbnail": "https://i.ytimg.com/vi/fNTXjwAW4yk/mqdefault.jpg",
    "title": "【復活】爆熱してました(*'ω'*)【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-08T09:29:18Z"
  },
  {
    "videoId": "E7jl8SU4vSg",
    "thumbnail": "https://i.ytimg.com/vi/E7jl8SU4vSg/mqdefault.jpg",
    "title": "【雑談】まったりおはなししよ♡ Free talk【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-13T10:53:02Z"
  },
  {
    "videoId": "lL19VebEPEw",
    "thumbnail": "https://i.ytimg.com/vi/lL19VebEPEw/mqdefault.jpg",
    "title": "【歌枠】リハビリおうた屋さん/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-14T10:22:09Z"
  },
  {
    "videoId": "o-60xZawwvg",
    "thumbnail": "https://i.ytimg.com/vi/o-60xZawwvg/mqdefault.jpg",
    "title": "【#夏色まつり周年祭】5周年記念に凸待ちしちゃいます！/スペシャルサプライズあり！？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-15T13:12:33Z"
  },
  {
    "videoId": "j1_3TuFOxHc",
    "thumbnail": "https://i.ytimg.com/vi/j1_3TuFOxHc/mqdefault.jpg",
    "title": "【APEX】ソロで全キャラちゃんぴおん耐久【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-16T15:06:33Z"
  },
  {
    "videoId": "JkF_XHzT5CE",
    "thumbnail": "https://i.ytimg.com/vi/JkF_XHzT5CE/mqdefault.jpg",
    "title": "【APEX】ソロで全キャラちゃんぴおん耐久2枠目【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-16T15:19:04Z"
  },
  {
    "videoId": "5fSKfT_ZmwY",
    "thumbnail": "https://i.ytimg.com/vi/5fSKfT_ZmwY/mqdefault.jpg",
    "title": "【古銭プッシャーフレンズ弐】一攫千金ってやつ！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-19T11:22:39Z"
  },
  {
    "videoId": "pz3M30Z5Hpw",
    "thumbnail": "https://i.ytimg.com/vi/pz3M30Z5Hpw/mqdefault.jpg",
    "title": "【歌枠】バラード【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-25T16:38:46Z"
  },
  {
    "videoId": "RVqfzaUsoZo",
    "thumbnail": "https://i.ytimg.com/vi/RVqfzaUsoZo/mqdefault.jpg",
    "title": "【APEX】ちゃんぴおん以外即終了！ w/ばたーくっきー あおはる【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-27T09:44:07Z"
  },
  {
    "videoId": "X8G9387lCn8",
    "thumbnail": "https://i.ytimg.com/vi/X8G9387lCn8/mqdefault.jpg",
    "title": "【APEX】渋ハルカスタム失礼します～！ w/渋谷ハル dtto.【ホロライブ/夏色まつり】",
    "publishedAt": "2023-06-29T13:58:07Z"
  },
  {
    "videoId": "eok-UgHcC0g",
    "thumbnail": "https://i.ytimg.com/vi/eok-UgHcC0g/mqdefault.jpg",
    "title": "【雑談】6月おわってたけど7月から頑張るの気持ち Free Talk【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-01T16:01:31Z"
  },
  {
    "videoId": "J41zOVseGXI",
    "thumbnail": "https://i.ytimg.com/vi/J41zOVseGXI/mqdefault.jpg",
    "title": "【Only Up!】完全初見！高みを目指しとにかくのぼれ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-02T11:09:53Z"
  },
  {
    "videoId": "1zSnG0RqOQE",
    "thumbnail": "https://i.ytimg.com/vi/1zSnG0RqOQE/mqdefault.jpg",
    "title": "【APEX】フルパランク w/渋谷ハル ハセシン【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-03T15:34:30Z"
  },
  {
    "videoId": "QdKMQVD64CY",
    "thumbnail": "https://i.ytimg.com/vi/QdKMQVD64CY/mqdefault.jpg",
    "title": "【Only Up!】クリア耐久【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-04T12:12:14Z"
  },
  {
    "videoId": "fnTovrZsqGs",
    "thumbnail": "https://i.ytimg.com/vi/fnTovrZsqGs/mqdefault.jpg",
    "title": "【歌枠】お歌を歌います！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-06T15:25:34Z"
  },
  {
    "videoId": "ifWU5Jcp6KU",
    "thumbnail": "https://i.ytimg.com/vi/ifWU5Jcp6KU/mqdefault.jpg",
    "title": "【朝活】おはよ～！！休日も早起きえら～い！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-08T23:06:36Z"
  },
  {
    "videoId": "RbN8l7VdDrA",
    "thumbnail": "https://i.ytimg.com/vi/RbN8l7VdDrA/mqdefault.jpg",
    "title": "【#夏色まつり新衣装】1年ぶりの激カワ新衣装お披露目だあああああああああああああ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-11T12:34:35Z"
  },
  {
    "videoId": "R1p02nu-Q24",
    "thumbnail": "https://i.ytimg.com/vi/R1p02nu-Q24/mqdefault.jpg",
    "title": "【渋ハルカスタム】うい！えっさほいさ！わっしょいしょい！ちーむ！！！！　w/ハセシン ナリちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-13T13:56:10Z"
  },
  {
    "videoId": "ubTjdJhnW5o",
    "thumbnail": "https://i.ytimg.com/vi/ubTjdJhnW5o/mqdefault.jpg",
    "title": "【歌枠】清楚担当のおうた♡ / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-14T12:35:25Z"
  },
  {
    "videoId": "RDKUKrM9Nr4",
    "thumbnail": "https://i.ytimg.com/vi/RDKUKrM9Nr4/mqdefault.jpg",
    "title": "【Apex Legends】KILL Highlight #1【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-15T04:34:16Z"
  },
  {
    "videoId": "xLjQsd_KWOw",
    "thumbnail": "https://i.ytimg.com/vi/xLjQsd_KWOw/mqdefault.jpg",
    "title": "【VALORANT】スカイとキルジョイ触ってみる【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-15T21:43:55Z"
  },
  {
    "videoId": "heV6C_PaDZA",
    "thumbnail": "https://i.ytimg.com/vi/heV6C_PaDZA/mqdefault.jpg",
    "title": "【朝活】おはよおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおおお【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-15T23:23:36Z"
  },
  {
    "videoId": "G3X22TfqXYU",
    "thumbnail": "https://i.ytimg.com/vi/G3X22TfqXYU/mqdefault.jpg",
    "title": "【VALORANT】スカイを学ぶ w/ばたーくっきー【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-19T15:15:31Z"
  },
  {
    "videoId": "Ra3u6_rT0SQ",
    "thumbnail": "https://i.ytimg.com/vi/Ra3u6_rT0SQ/mqdefault.jpg",
    "title": "【Pikmin 4】労働労働労働労働【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-21T12:18:59Z"
  },
  {
    "videoId": "K9_rITGWo9s",
    "thumbnail": "https://i.ytimg.com/vi/K9_rITGWo9s/mqdefault.jpg",
    "title": "【誕生日】カウントダウンして一緒に迎えてくれますか？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-21T15:22:08Z"
  },
  {
    "videoId": "kNPMlQZPOLA",
    "thumbnail": "https://i.ytimg.com/vi/kNPMlQZPOLA/mqdefault.jpg",
    "title": "一緒に抜けだそ？　#ホロサマshorts #hololivesummer2023 #shorts",
    "publishedAt": "2023-07-22T03:00:20Z"
  },
  {
    "videoId": "tUmqaWwd-y0",
    "thumbnail": "https://i.ytimg.com/vi/tUmqaWwd-y0/mqdefault.jpg",
    "title": "【歌枠】誕生日ガールがご機嫌に歌う🎵【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-22T14:44:04Z"
  },
  {
    "videoId": "Sf1OZIiYDLI",
    "thumbnail": "https://i.ytimg.com/vi/Sf1OZIiYDLI/mqdefault.jpg",
    "title": "【雑談/Free talk】毎日ダンスレッスンの日々～【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-25T14:33:39Z"
  },
  {
    "videoId": "CIheD9dvO9Q",
    "thumbnail": "https://i.ytimg.com/vi/CIheD9dvO9Q/mqdefault.jpg",
    "title": "【アソビ大全】まおうさま降臨！！なのだよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-26T15:10:22Z"
  },
  {
    "videoId": "VRGTsJFIUiM",
    "thumbnail": "https://i.ytimg.com/vi/VRGTsJFIUiM/mqdefault.jpg",
    "title": "【#ホロサマ歌枠リレー】水着お披露目！歌枠✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-29T16:00:48Z"
  },
  {
    "videoId": "ni9-mqUWNq4",
    "thumbnail": "https://i.ytimg.com/vi/ni9-mqUWNq4/mqdefault.jpg",
    "title": "【VALORANT】しんやれんしゅう【ホロライブ/夏色まつり】",
    "publishedAt": "2023-07-31T17:25:16Z"
  },
  {
    "videoId": "ZajjR9A7P8c",
    "thumbnail": "https://i.ytimg.com/vi/ZajjR9A7P8c/mqdefault.jpg",
    "title": "【VALORANT】足を引っ張らない練習【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-01T07:37:27Z"
  },
  {
    "videoId": "CzxXer5PELo",
    "thumbnail": "https://i.ytimg.com/vi/CzxXer5PELo/mqdefault.jpg",
    "title": "【VALORANT】アイアンからの成長記録#1【ホロライブ/夏色まつり1】",
    "publishedAt": "2023-08-01T12:04:55Z"
  },
  {
    "videoId": "54cx26JEwEM",
    "thumbnail": "https://i.ytimg.com/vi/54cx26JEwEM/mqdefault.jpg",
    "title": "【#ラッシュパトラッシュ】大会本番！落ち着け自分！hololive × VALORANT MEETUP powered by Holizontal【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-03T14:25:45Z"
  },
  {
    "videoId": "eYDwZoXdWFQ",
    "thumbnail": "https://i.ytimg.com/vi/eYDwZoXdWFQ/mqdefault.jpg",
    "title": "【歌枠】お歌の時間【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-04T13:24:51Z"
  },
  {
    "videoId": "8ZCm92ycqBg",
    "thumbnail": "https://i.ytimg.com/vi/8ZCm92ycqBg/mqdefault.jpg",
    "title": "【Viewfinder】撮った写真で道を作る謎解きパズルゲーム！？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-06T12:36:19Z"
  },
  {
    "videoId": "ymA0UozeC8s",
    "thumbnail": "https://i.ytimg.com/vi/ymA0UozeC8s/mqdefault.jpg",
    "title": "【スーパードンキーコング2】初レトロゲーですがいけますか！？#ホロ１期ドンキ２並走【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-19T17:09:23Z"
  },
  {
    "videoId": "1fFob12l0z0",
    "thumbnail": "https://i.ytimg.com/vi/1fFob12l0z0/mqdefault.jpg",
    "title": "【告知あり】嬉しいお知らせをもって帰ってきた！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-24T09:43:30Z"
  },
  {
    "videoId": "zAiKT5Q7hyo",
    "thumbnail": "https://i.ytimg.com/vi/zAiKT5Q7hyo/mqdefault.jpg",
    "title": "【歌枠】ホロライブサマー！おつかれサマー☀【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-28T10:43:06Z"
  },
  {
    "videoId": "cB-8A760jtI",
    "thumbnail": "https://i.ytimg.com/vi/cB-8A760jtI/mqdefault.jpg",
    "title": "【3DLIVE】夏色まつり Birthday Live🎂🎉 #今夜はdancethenight【ホロライブ/夏色まつり】",
    "publishedAt": "2023-08-31T12:59:05Z"
  },
  {
    "videoId": "a9CWgFuoULU",
    "thumbnail": "https://i.ytimg.com/vi/a9CWgFuoULU/mqdefault.jpg",
    "title": "【オリジナル曲】ばーちゃらぶ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-01T10:30:11Z"
  },
  {
    "videoId": "ZEICraSnprA",
    "thumbnail": "https://i.ytimg.com/vi/ZEICraSnprA/mqdefault.jpg",
    "title": "【感想会】誕生日ライブ見ながら振り返り～！同時視聴あり【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-01T11:12:00Z"
  },
  {
    "videoId": "U7UprIAp6d4",
    "thumbnail": "https://i.ytimg.com/vi/U7UprIAp6d4/mqdefault.jpg",
    "title": "【 漢字でGO 】漢字つよつよなところみせてやる～！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-02T10:36:30Z"
  },
  {
    "videoId": "VK7pdQ5abqQ",
    "thumbnail": "https://i.ytimg.com/vi/VK7pdQ5abqQ/mqdefault.jpg",
    "title": "【歌枠】すーぱーあいどるうたわく♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-04T10:22:16Z"
  },
  {
    "videoId": "bIYnzZ4h5Dg",
    "thumbnail": "https://i.ytimg.com/vi/bIYnzZ4h5Dg/mqdefault.jpg",
    "title": "【お絵かき心理テスト】まつりのひみつ教えます♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-08T10:17:20Z"
  },
  {
    "videoId": "IulD-W2qoBc",
    "thumbnail": "https://i.ytimg.com/vi/IulD-W2qoBc/mqdefault.jpg",
    "title": "【食べ比べ】月見バーガー全種爆食してやる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-09T09:47:48Z"
  },
  {
    "videoId": "9XXVpU36ESc",
    "thumbnail": "https://i.ytimg.com/vi/9XXVpU36ESc/mqdefault.jpg",
    "title": "【VALORANT】お久しぶりの認定戦ですッ！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-11T02:49:22Z"
  },
  {
    "videoId": "NOZG7vgwhO8",
    "thumbnail": "https://i.ytimg.com/vi/NOZG7vgwhO8/mqdefault.jpg",
    "title": "【お披露目歌枠】突然ですがかわいいをくらってください♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-14T08:18:42Z"
  },
  {
    "videoId": "KQfwi11N1s0",
    "thumbnail": "https://i.ytimg.com/vi/KQfwi11N1s0/mqdefault.jpg",
    "title": "【アスタタ】すべてのクオリティがすごすぎる神ゲー紹介させてくれ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-14T11:26:42Z"
  },
  {
    "videoId": "bNUlv9Se6H8",
    "thumbnail": "https://i.ytimg.com/vi/bNUlv9Se6H8/mqdefault.jpg",
    "title": "【IQクイズ】柔軟なのは体だけじゃないですよってな！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-15T10:18:24Z"
  },
  {
    "videoId": "HOEHEGoL5iw",
    "thumbnail": "https://i.ytimg.com/vi/HOEHEGoL5iw/mqdefault.jpg",
    "title": "【VALORANT】かるびちゃんに教えてもらう！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-17T15:33:53Z"
  },
  {
    "videoId": "E1r4e_Xtb8I",
    "thumbnail": "https://i.ytimg.com/vi/E1r4e_Xtb8I/mqdefault.jpg",
    "title": "【Minecraft】借金返済期日が迫ってきました；；【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-22T11:59:02Z"
  },
  {
    "videoId": "0uHP8AZVG_o",
    "thumbnail": "https://i.ytimg.com/vi/0uHP8AZVG_o/mqdefault.jpg",
    "title": "【Minecraft】ポルカに金で返さなきゃ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-24T11:22:59Z"
  },
  {
    "videoId": "17P6HLbm4rc",
    "thumbnail": "https://i.ytimg.com/vi/17P6HLbm4rc/mqdefault.jpg",
    "title": "【Minecraft】ねこねこあいらんど？本当に楽しいところですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-29T15:43:42Z"
  },
  {
    "videoId": "U6QWyt6T-3A",
    "thumbnail": "https://i.ytimg.com/vi/U6QWyt6T-3A/mqdefault.jpg",
    "title": "【 スイカゲーム 】3000点？余裕やろ！！行くぞッ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-09-30T12:07:26Z"
  },
  {
    "videoId": "yCs6lw790LA",
    "thumbnail": "https://i.ytimg.com/vi/yCs6lw790LA/mqdefault.jpg",
    "title": "【歌枠】かわいいの供給過多!!!!!!!!!!!!!!!!!!!!!!!!!!!【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-02T11:17:06Z"
  },
  {
    "videoId": "GsXWTvikBHQ",
    "thumbnail": "https://i.ytimg.com/vi/GsXWTvikBHQ/mqdefault.jpg",
    "title": "【朝活】おはよおおおおおおおおおおお【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-03T23:20:16Z"
  },
  {
    "videoId": "Lxj6TzFY10Q",
    "thumbnail": "https://i.ytimg.com/vi/Lxj6TzFY10Q/mqdefault.jpg",
    "title": "【 スイカゲーム 】新記録目指して！！🍑つり】",
    "publishedAt": "2023-10-04T11:38:57Z"
  },
  {
    "videoId": "Q1M4Rk01Zpo",
    "thumbnail": "https://i.ytimg.com/vi/Q1M4Rk01Zpo/mqdefault.jpg",
    "title": "【歌枠】朝から歌お～！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-05T00:39:43Z"
  },
  {
    "videoId": "IcVCyyiIEj4",
    "thumbnail": "https://i.ytimg.com/vi/IcVCyyiIEj4/mqdefault.jpg",
    "title": "【 APEX 】 #DREAMMATCH / チーム:姫騎士勝ちます✌　前半【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-08T06:13:28Z"
  },
  {
    "videoId": "GjnHkqokCF0",
    "thumbnail": "https://i.ytimg.com/vi/GjnHkqokCF0/mqdefault.jpg",
    "title": "【 APEX 】 #DREAMMATCH / チーム:姫騎士勝ちます✌　後半【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-08T12:07:55Z"
  },
  {
    "videoId": "Z1b1B4SRbes",
    "thumbnail": "https://i.ytimg.com/vi/Z1b1B4SRbes/mqdefault.jpg",
    "title": "けーたいみしてよ/夏色まつり(cover)",
    "publishedAt": "2023-10-09T09:00:06Z"
  },
  {
    "videoId": "i_R9XY0b2HM",
    "thumbnail": "https://i.ytimg.com/vi/i_R9XY0b2HM/mqdefault.jpg",
    "title": "【 APEXランク 】マスター屋さん出陣！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-10T15:29:07Z"
  },
  {
    "videoId": "x21OuyPKeJI",
    "thumbnail": "https://i.ytimg.com/vi/x21OuyPKeJI/mqdefault.jpg",
    "title": "【おはよう】土曜日に午前起きはえらいぞ【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-14T01:08:30Z"
  },
  {
    "videoId": "IotlE7-nGA8",
    "thumbnail": "https://i.ytimg.com/vi/IotlE7-nGA8/mqdefault.jpg",
    "title": "【VALORANT】ラプラスとラブラブデュオコンペ♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-15T11:28:32Z"
  },
  {
    "videoId": "Ntt0x5-eARQ",
    "thumbnail": "https://i.ytimg.com/vi/Ntt0x5-eARQ/mqdefault.jpg",
    "title": "【 ホロのスイカ 】ファンメイド神ゲーきちゃ！？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-18T10:59:35Z"
  },
  {
    "videoId": "kuNl2pU_9UI",
    "thumbnail": "https://i.ytimg.com/vi/kuNl2pU_9UI/mqdefault.jpg",
    "title": "【#vtuber発掘 】チャンネル1万人以下の原石VTuber大紹介逆凸✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-22T10:47:54Z"
  },
  {
    "videoId": "t4xjf5i_mcs",
    "thumbnail": "https://i.ytimg.com/vi/t4xjf5i_mcs/mqdefault.jpg",
    "title": "ねれねえええええええｗｗｗｗｗｗ",
    "publishedAt": "2023-10-22T21:12:03Z"
  },
  {
    "videoId": "b7ckDReLbBA",
    "thumbnail": "https://i.ytimg.com/vi/b7ckDReLbBA/mqdefault.jpg",
    "title": "【歌枠】君は何の曲が好きですか？♡ / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-23T10:16:56Z"
  },
  {
    "videoId": "slFBU5xtJ6w",
    "thumbnail": "https://i.ytimg.com/vi/slFBU5xtJ6w/mqdefault.jpg",
    "title": "【告知あり】ちょっとだけおはなし！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-24T09:57:07Z"
  },
  {
    "videoId": "RidlG3_1GAA",
    "thumbnail": "https://i.ytimg.com/vi/RidlG3_1GAA/mqdefault.jpg",
    "title": "【VALORANT】CRカップ顔合わせ＆カスタムいくぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-24T18:00:48Z"
  },
  {
    "videoId": "CTRt7Zm_4aQ",
    "thumbnail": "https://i.ytimg.com/vi/CTRt7Zm_4aQ/mqdefault.jpg",
    "title": "【#ホロハロウィンAmongUs】殺戮の限り【ホロライブ/夏色まつり】",
    "publishedAt": "2023-10-31T15:16:40Z"
  },
  {
    "videoId": "CXLL4W4w4I8",
    "thumbnail": "https://i.ytimg.com/vi/CXLL4W4w4I8/mqdefault.jpg",
    "title": "【3DLIVE】#まちゅまちゅ動画 ～インターネット老人会～【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-01T12:04:52Z"
  },
  {
    "videoId": "8PTi-eyr4sQ",
    "thumbnail": "https://i.ytimg.com/vi/8PTi-eyr4sQ/mqdefault.jpg",
    "title": "【渋ハルカスタム】姫騎士で今日は何王になってやろうか✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-02T14:38:06Z"
  },
  {
    "videoId": "MKcNzz21P8g",
    "thumbnail": "https://i.ytimg.com/vi/MKcNzz21P8g/mqdefault.jpg",
    "title": "【 #ホロライブ大運動会2023 】黄組ぜってぇ優勝しようなあああああ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-04T12:22:04Z"
  },
  {
    "videoId": "v_1j1_USMj8",
    "thumbnail": "https://i.ytimg.com/vi/v_1j1_USMj8/mqdefault.jpg",
    "title": "【APEX】新シーズン初APEXいくぞ～！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-07T15:30:25Z"
  },
  {
    "videoId": "BIvVzBkckQU",
    "thumbnail": "https://i.ytimg.com/vi/BIvVzBkckQU/mqdefault.jpg",
    "title": "バラード",
    "publishedAt": "2023-11-09T15:36:24Z"
  },
  {
    "videoId": "1QqsGYrEdTk",
    "thumbnail": "https://i.ytimg.com/vi/1QqsGYrEdTk/mqdefault.jpg",
    "title": "【手描き】ルイねぇの豪邸で大量のダイヤを発見しちゃうまつりちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-12T09:00:11Z"
  },
  {
    "videoId": "qvHGiCmpOb8",
    "thumbnail": "https://i.ytimg.com/vi/qvHGiCmpOb8/mqdefault.jpg",
    "title": "【歌枠】140万人いつの間にか達成してる喜びを歌う【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-16T15:28:35Z"
  },
  {
    "videoId": "I9pKiXJgW5w",
    "thumbnail": "https://i.ytimg.com/vi/I9pKiXJgW5w/mqdefault.jpg",
    "title": "【＃ホロプロマリカ】寝起き５分で戦います【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-18T10:17:56Z"
  },
  {
    "videoId": "5-e2C_8Hcdc",
    "thumbnail": "https://i.ytimg.com/vi/5-e2C_8Hcdc/mqdefault.jpg",
    "title": "人マニア/夏色まつり(cover)【スマホ視聴推奨】",
    "publishedAt": "2023-11-19T09:00:07Z"
  },
  {
    "videoId": "2OrGPXBccAI",
    "thumbnail": "https://i.ytimg.com/vi/2OrGPXBccAI/mqdefault.jpg",
    "title": "【 APEX 】渋ハルカスタムいくぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-23T14:02:18Z"
  },
  {
    "videoId": "a_nsIU67KKw",
    "thumbnail": "https://i.ytimg.com/vi/a_nsIU67KKw/mqdefault.jpg",
    "title": "【歌枠】お久しぶりにおうたをうたいましょう！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-11-26T15:25:04Z"
  },
  {
    "videoId": "Lyec7_geI-4",
    "thumbnail": "https://i.ytimg.com/vi/Lyec7_geI-4/mqdefault.jpg",
    "title": "【Splatoon3】ソロ練習会～＾→みこちとぽよよん【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-04T23:15:23Z"
  },
  {
    "videoId": "y2RHidRr6Yw",
    "thumbnail": "https://i.ytimg.com/vi/y2RHidRr6Yw/mqdefault.jpg",
    "title": "【Splatoon3】ころねと二人→フルパ練習会✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-06T16:43:44Z"
  },
  {
    "videoId": "eVRob1xsaA0",
    "thumbnail": "https://i.ytimg.com/vi/eVRob1xsaA0/mqdefault.jpg",
    "title": "【Splatoon3/スプラトゥーン3】絶対勝ちます#宝神秋祭WIN 【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-09T12:04:13Z"
  },
  {
    "videoId": "TYkOvj5v6gs",
    "thumbnail": "https://i.ytimg.com/vi/TYkOvj5v6gs/mqdefault.jpg",
    "title": "【VCR GTA】まつり！就職します！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-10T21:34:49Z"
  },
  {
    "videoId": "29tg_NR8lj8",
    "thumbnail": "https://i.ytimg.com/vi/29tg_NR8lj8/mqdefault.jpg",
    "title": "【VCR GTA】ギャングのおしごと【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-11T15:52:21Z"
  },
  {
    "videoId": "Q6PTMtxjsVM",
    "thumbnail": "https://i.ytimg.com/vi/Q6PTMtxjsVM/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】まつりのぶーぶみて～！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-12T13:23:22Z"
  },
  {
    "videoId": "FzFxKDkh5hs",
    "thumbnail": "https://i.ytimg.com/vi/FzFxKDkh5hs/mqdefault.jpg",
    "title": "【VCR GTA】メンヘラギャングボスは仲良くなりたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-12T21:24:25Z"
  },
  {
    "videoId": "PRGMMTrJLpo",
    "thumbnail": "https://i.ytimg.com/vi/PRGMMTrJLpo/mqdefault.jpg",
    "title": "【VCR GTA】常にクールにたまにメンヘラ！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-13T10:14:27Z"
  },
  {
    "videoId": "PlJe8FLHoI4",
    "thumbnail": "https://i.ytimg.com/vi/PlJe8FLHoI4/mqdefault.jpg",
    "title": "【VCR GTA】大型はんざいいくぞ～！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-13T19:15:19Z"
  },
  {
    "videoId": "eZVk6TBXuKs",
    "thumbnail": "https://i.ytimg.com/vi/eZVk6TBXuKs/mqdefault.jpg",
    "title": "【歌枠】ホロライブ歌枠✨/hololive song KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-16T05:31:30Z"
  },
  {
    "videoId": "ENkplx_Oo-c",
    "thumbnail": "https://i.ytimg.com/vi/ENkplx_Oo-c/mqdefault.jpg",
    "title": "【VCR GTA】まじめにいきるぎゃんぐ　そのいち【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-17T06:39:06Z"
  },
  {
    "videoId": "Qr7Pe586uqY",
    "thumbnail": "https://i.ytimg.com/vi/Qr7Pe586uqY/mqdefault.jpg",
    "title": "【朝活】月曜日のおはよう☀【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-18T00:58:04Z"
  },
  {
    "videoId": "CvwR3tdjs8s",
    "thumbnail": "https://i.ytimg.com/vi/CvwR3tdjs8s/mqdefault.jpg",
    "title": "【歌枠】初めての縦型配信🥰【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-19T07:08:57Z"
  },
  {
    "videoId": "4Tq-7t8ILZQ",
    "thumbnail": "https://i.ytimg.com/vi/4Tq-7t8ILZQ/mqdefault.jpg",
    "title": "【なぁぜなぁぜ？】こんなにダンスができるのに… #HoshimaticProject【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-19T12:05:00Z"
  },
  {
    "videoId": "62fLqQ1EZ6U",
    "thumbnail": "https://i.ytimg.com/vi/62fLqQ1EZ6U/mqdefault.jpg",
    "title": "【縦型配信】おはよう～！！朝活！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-19T22:03:44Z"
  },
  {
    "videoId": "j-4JcN3SAm4",
    "thumbnail": "https://i.ytimg.com/vi/j-4JcN3SAm4/mqdefault.jpg",
    "title": "【VCR GTA】もしもし？お医者さんになったけど？【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-21T20:52:26Z"
  },
  {
    "videoId": "WjmmdPvNf5o",
    "thumbnail": "https://i.ytimg.com/vi/WjmmdPvNf5o/mqdefault.jpg",
    "title": "【VCR GTA】最終日ですから♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-22T15:20:17Z"
  },
  {
    "videoId": "79lt0HbEeDc",
    "thumbnail": "https://i.ytimg.com/vi/79lt0HbEeDc/mqdefault.jpg",
    "title": "【#うちトレ】お気に入りのスカートを履くため本気ダイエットはじめます！#トレーニングWEEK【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-23T12:43:17Z"
  },
  {
    "videoId": "hCXSUtqK4IQ",
    "thumbnail": "https://i.ytimg.com/vi/hCXSUtqK4IQ/mqdefault.jpg",
    "title": "【縦型配信】おはよう朝歌✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-24T00:52:14Z"
  },
  {
    "videoId": "v4FGKgE2KaM",
    "thumbnail": "https://i.ytimg.com/vi/v4FGKgE2KaM/mqdefault.jpg",
    "title": "【#ぴーかーぶぅ】クリスマスオフコラボで爆食女子トーク♡【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-24T10:02:18Z"
  },
  {
    "videoId": "LzPDyVNUpLw",
    "thumbnail": "https://i.ytimg.com/vi/LzPDyVNUpLw/mqdefault.jpg",
    "title": "【縦型配信】朝活歌枠！morning song🎶【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-25T01:21:17Z"
  },
  {
    "videoId": "T-Xc51vG18c",
    "thumbnail": "https://i.ytimg.com/vi/T-Xc51vG18c/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー 】めっちゃメリクリ～✨【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-25T05:01:44Z"
  },
  {
    "videoId": "VJts_BqyGrA",
    "thumbnail": "https://i.ytimg.com/vi/VJts_BqyGrA/mqdefault.jpg",
    "title": "【縦型配信】おはようざつだん！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-26T01:20:50Z"
  },
  {
    "videoId": "4IN-5GBGkH0",
    "thumbnail": "https://i.ytimg.com/vi/4IN-5GBGkH0/mqdefault.jpg",
    "title": "【縦型配信】おはよー！！！おはなし！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-27T01:25:47Z"
  },
  {
    "videoId": "BHROxLyIURc",
    "thumbnail": "https://i.ytimg.com/vi/BHROxLyIURc/mqdefault.jpg",
    "title": "【マリオカート8DX】鬼特訓はじめるぞ～！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-27T07:29:31Z"
  },
  {
    "videoId": "8MTuaimFWIk",
    "thumbnail": "https://i.ytimg.com/vi/8MTuaimFWIk/mqdefault.jpg",
    "title": "【手描き】かわいいと言われたい夏色まつり【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-28T09:00:09Z"
  },
  {
    "videoId": "drGE4OhHiJc",
    "thumbnail": "https://i.ytimg.com/vi/drGE4OhHiJc/mqdefault.jpg",
    "title": "【#うちトレ】楽しく本気ダイエット！！その２#トレーニングWEEK【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-28T11:34:16Z"
  },
  {
    "videoId": "JTgRCtm-LG4",
    "thumbnail": "https://i.ytimg.com/vi/JTgRCtm-LG4/mqdefault.jpg",
    "title": "【縦型配信】可愛すぎる歌枠【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-30T03:52:20Z"
  },
  {
    "videoId": "eq7-eZJ77Sg",
    "thumbnail": "https://i.ytimg.com/vi/eq7-eZJ77Sg/mqdefault.jpg",
    "title": "【タルコフ】ゴリラとゴミ拾い1日目-Escape from Tarkov【ホロライブ/夏色まつり】",
    "publishedAt": "2023-12-30T14:21:37Z"
  },
  {
    "videoId": "DmEmLRwDOSM",
    "thumbnail": "https://i.ytimg.com/vi/DmEmLRwDOSM/mqdefault.jpg",
    "title": "【お正月】あけおめ！！お年玉の日だ！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-01T07:24:30Z"
  },
  {
    "videoId": "x5R1hO_yXkI",
    "thumbnail": "https://i.ytimg.com/vi/x5R1hO_yXkI/mqdefault.jpg",
    "title": "【お正月】あけおめりたーんず🐉【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-02T14:04:35Z"
  },
  {
    "videoId": "ybJLt_ngN7U",
    "thumbnail": "https://i.ytimg.com/vi/ybJLt_ngN7U/mqdefault.jpg",
    "title": "【深夜歌枠】バラード【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-03T18:07:14Z"
  },
  {
    "videoId": "t6i_XzPE79U",
    "thumbnail": "https://i.ytimg.com/vi/t6i_XzPE79U/mqdefault.jpg",
    "title": "【マリオカート8DX】軽量級はじめました！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-05T12:17:19Z"
  },
  {
    "videoId": "rhAcm1B7-g4",
    "thumbnail": "https://i.ytimg.com/vi/rhAcm1B7-g4/mqdefault.jpg",
    "title": "【マリオカート8DX】予選を抜けたい！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-07T09:46:41Z"
  },
  {
    "videoId": "PKulFQafQDM",
    "thumbnail": "https://i.ytimg.com/vi/PKulFQafQDM/mqdefault.jpg",
    "title": "【マリオカート8DX】きのこまみれ大事件！？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-08T09:41:36Z"
  },
  {
    "videoId": "hYHGULAobII",
    "thumbnail": "https://i.ytimg.com/vi/hYHGULAobII/mqdefault.jpg",
    "title": "【#一期生オフ】同期とはちゃめちゃ新年会✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-09T15:04:21Z"
  },
  {
    "videoId": "ZRRvFsifalg",
    "thumbnail": "https://i.ytimg.com/vi/ZRRvFsifalg/mqdefault.jpg",
    "title": "【AmongUs】発掘企画で見つけたみんなとだまし合い！？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-10T14:17:24Z"
  },
  {
    "videoId": "wHaMV-sgWPo",
    "thumbnail": "https://i.ytimg.com/vi/wHaMV-sgWPo/mqdefault.jpg",
    "title": "【雑談】すこしだけお話しましょ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-18T10:44:45Z"
  },
  {
    "videoId": "URNdVmgBSCQ",
    "thumbnail": "https://i.ytimg.com/vi/URNdVmgBSCQ/mqdefault.jpg",
    "title": "【歌枠】お歌聴いてくれますか？💞【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-20T10:19:47Z"
  },
  {
    "videoId": "Gp07Fmbu8Og",
    "thumbnail": "https://i.ytimg.com/vi/Gp07Fmbu8Og/mqdefault.jpg",
    "title": "【Palworld】完全初見！パルワールドホロ鯖に降臨✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-24T16:17:03Z"
  },
  {
    "videoId": "97YJwJw6Acs",
    "thumbnail": "https://i.ytimg.com/vi/97YJwJw6Acs/mqdefault.jpg",
    "title": "【 APEX 】渋ハルカスタム最終回！　w/tttcheekyttt,杏戸ゆげ【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-25T14:34:39Z"
  },
  {
    "videoId": "D3p3Ourcawk",
    "thumbnail": "https://i.ytimg.com/vi/D3p3Ourcawk/mqdefault.jpg",
    "title": "【朝活】おはようなのだ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-25T23:41:53Z"
  },
  {
    "videoId": "ZhCfcaI-3UM",
    "thumbnail": "https://i.ytimg.com/vi/ZhCfcaI-3UM/mqdefault.jpg",
    "title": "【Palworld】かわいいパルを探すぞ～！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-01-29T09:13:37Z"
  },
  {
    "videoId": "Y807dr7kSyI",
    "thumbnail": "https://i.ytimg.com/vi/Y807dr7kSyI/mqdefault.jpg",
    "title": "【歌枠/Singing KARAOKE】やみかわ歌枠👿【ホロライブ/夏色まつり】",
    "publishedAt": "2024-02-04T13:17:05Z"
  },
  {
    "videoId": "YKKKPbeTHKg",
    "thumbnail": "https://i.ytimg.com/vi/YKKKPbeTHKg/mqdefault.jpg",
    "title": "【休暇中】インフルになってました；；【ホロライブ/夏色まつり】",
    "publishedAt": "2024-02-17T14:49:07Z"
  },
  {
    "videoId": "ZRn4g82M0ig",
    "thumbnail": "https://i.ytimg.com/vi/ZRn4g82M0ig/mqdefault.jpg",
    "title": "【手描き】ホラゲが怖すぎてフブキに泣きつくまつり【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-03T09:00:09Z"
  },
  {
    "videoId": "na_IConuDkk",
    "thumbnail": "https://i.ytimg.com/vi/na_IConuDkk/mqdefault.jpg",
    "title": "【復帰】今日からまつりちゃん帰ってきますよっと【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-03T11:06:58Z"
  },
  {
    "videoId": "Q7yVe9fZJ7o",
    "thumbnail": "https://i.ytimg.com/vi/Q7yVe9fZJ7o/mqdefault.jpg",
    "title": "【算数でGO!】さすがに\"算数\"はできますよ✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-04T11:10:35Z"
  },
  {
    "videoId": "i4Dpa_2NFs0",
    "thumbnail": "https://i.ytimg.com/vi/i4Dpa_2NFs0/mqdefault.jpg",
    "title": "【 トロッコ問題 】ENTP効率厨による究極の二択問題【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-06T10:07:09Z"
  },
  {
    "videoId": "3FyRLSAZRZo",
    "thumbnail": "https://i.ytimg.com/vi/3FyRLSAZRZo/mqdefault.jpg",
    "title": "【歌枠】すーぱーあいどるお歌配信なのだ～✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-08T11:31:29Z"
  },
  {
    "videoId": "fL6Gw0hw6U8",
    "thumbnail": "https://i.ytimg.com/vi/fL6Gw0hw6U8/mqdefault.jpg",
    "title": "プロポーズ - 内緒のピアス/夏色まつり(cover)【ホロライブ】",
    "publishedAt": "2024-03-12T09:00:07Z"
  },
  {
    "videoId": "4xQid0mH01Y",
    "thumbnail": "https://i.ytimg.com/vi/4xQid0mH01Y/mqdefault.jpg",
    "title": "【歌ってみた】プロポーズ-内緒のピアス【ホロライブ】#shorts #夏色まつり",
    "publishedAt": "2024-03-15T01:47:55Z"
  },
  {
    "videoId": "l3TVG-BRJME",
    "thumbnail": "https://i.ytimg.com/vi/l3TVG-BRJME/mqdefault.jpg",
    "title": "【 #hololivefesexpo24 】写真見ながら感想会✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-17T14:36:06Z"
  },
  {
    "videoId": "Wl8EhCOZhew",
    "thumbnail": "https://i.ytimg.com/vi/Wl8EhCOZhew/mqdefault.jpg",
    "title": "【ゲリラ歌枠】満足するまで好きな歌うたうよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-18T09:40:45Z"
  },
  {
    "videoId": "6ia8k3LXDwY",
    "thumbnail": "https://i.ytimg.com/vi/6ia8k3LXDwY/mqdefault.jpg",
    "title": "ダーリン - 須田景凪 /夏色まつり(cover)【ホロライブ】",
    "publishedAt": "2024-03-19T09:00:07Z"
  },
  {
    "videoId": "LGXcQ0ldP7c",
    "thumbnail": "https://i.ytimg.com/vi/LGXcQ0ldP7c/mqdefault.jpg",
    "title": "【雑談】ざざざざざ/free talk【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-24T13:20:50Z"
  },
  {
    "videoId": "FBM6m2KMwJU",
    "thumbnail": "https://i.ytimg.com/vi/FBM6m2KMwJU/mqdefault.jpg",
    "title": "【朝活】おはよ～☀【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-25T23:29:23Z"
  },
  {
    "videoId": "C7DBhDszs-c",
    "thumbnail": "https://i.ytimg.com/vi/C7DBhDszs-c/mqdefault.jpg",
    "title": "【APEX】猫鯖フェスでも暴れますか～！？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-03-29T14:32:12Z"
  },
  {
    "videoId": "51537S7efMk",
    "thumbnail": "https://i.ytimg.com/vi/51537S7efMk/mqdefault.jpg",
    "title": "【 新幹線０号 】名古屋にはとまらない！？名古屋飛ばしは異変です！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-04T10:39:32Z"
  },
  {
    "videoId": "_JsC9hKC8g0",
    "thumbnail": "https://i.ytimg.com/vi/_JsC9hKC8g0/mqdefault.jpg",
    "title": "【#GOLDRUSH】えぺまつりには夏色まつりでしょ💰【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-06T13:41:55Z"
  },
  {
    "videoId": "RSUeHicmh0M",
    "thumbnail": "https://i.ytimg.com/vi/RSUeHicmh0M/mqdefault.jpg",
    "title": "【歌枠】しんぎんぐ【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-07T09:16:39Z"
  },
  {
    "videoId": "vpGbjJOYMTw",
    "thumbnail": "https://i.ytimg.com/vi/vpGbjJOYMTw/mqdefault.jpg",
    "title": "【はっきり言います！】ぶったぎりマシュマロお悩み相談会【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-13T11:17:18Z"
  },
  {
    "videoId": "9PBLPtLDFqU",
    "thumbnail": "https://i.ytimg.com/vi/9PBLPtLDFqU/mqdefault.jpg",
    "title": "【Warlander】Rakuten esports cup景品ください💰【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-14T13:39:04Z"
  },
  {
    "videoId": "beExkAryQko",
    "thumbnail": "https://i.ytimg.com/vi/beExkAryQko/mqdefault.jpg",
    "title": "【Buckshot Roulette】おにーさんはなに賭けてくれるの？♡【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-19T16:40:12Z"
  },
  {
    "videoId": "DfgeWDeoBlI",
    "thumbnail": "https://i.ytimg.com/vi/DfgeWDeoBlI/mqdefault.jpg",
    "title": "【#ホロドロケイ2024】捕まるには心当たりがありすぎる！？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-04-28T13:38:32Z"
  },
  {
    "videoId": "Yyfc-XGxP2o",
    "thumbnail": "https://i.ytimg.com/vi/Yyfc-XGxP2o/mqdefault.jpg",
    "title": "【手描き】どんな声でもかわいいと言われ地声で話すまつりちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2024-05-01T09:00:07Z"
  },
  {
    "videoId": "nhzL5fcQkzQ",
    "thumbnail": "https://i.ytimg.com/vi/nhzL5fcQkzQ/mqdefault.jpg",
    "title": "【歌枠】GWはまったりお歌配信～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-05-02T09:10:11Z"
  },
  {
    "videoId": "HhQylSq0bug",
    "thumbnail": "https://i.ytimg.com/vi/HhQylSq0bug/mqdefault.jpg",
    "title": "【縦型配信】ゆるりお歌配信🎧【ホロライブ/夏色まつり】",
    "publishedAt": "2024-05-08T10:38:37Z"
  },
  {
    "videoId": "0Bwvk_7N9fY",
    "thumbnail": "https://i.ytimg.com/vi/0Bwvk_7N9fY/mqdefault.jpg",
    "title": "【朝活】おはよ～！今日もがんばろう✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-05-14T23:51:39Z"
  },
  {
    "videoId": "mvhLAQdIGHk",
    "thumbnail": "https://i.ytimg.com/vi/mvhLAQdIGHk/mqdefault.jpg",
    "title": "混沌ブギ/夏色まつり(cover)【ホロライブ】",
    "publishedAt": "2024-05-24T09:00:06Z"
  },
  {
    "videoId": "YKwjo_0vJhQ",
    "thumbnail": "https://i.ytimg.com/vi/YKwjo_0vJhQ/mqdefault.jpg",
    "title": "【歌枠】きゃわたんおうた配信なのだっ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-05-27T10:13:41Z"
  },
  {
    "videoId": "9S-iYarPBI4",
    "thumbnail": "https://i.ytimg.com/vi/9S-iYarPBI4/mqdefault.jpg",
    "title": "【6周年】カウントダウン一緒にしよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-05-31T15:13:49Z"
  },
  {
    "videoId": "CVU3GU4dZw0",
    "thumbnail": "https://i.ytimg.com/vi/CVU3GU4dZw0/mqdefault.jpg",
    "title": "【#夏色まつり6周年】激かわグッズ紹介するよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-06-10T12:43:42Z"
  },
  {
    "videoId": "CFJ5SFKRlSM",
    "thumbnail": "https://i.ytimg.com/vi/CFJ5SFKRlSM/mqdefault.jpg",
    "title": "【学園アイドルマスター】ことねガシャきちゃ！！最低2凸します※ネタバレあり【ホロライブ/夏色まつり】",
    "publishedAt": "2024-06-12T14:48:55Z"
  },
  {
    "videoId": "R5Z35aXCv9Q",
    "thumbnail": "https://i.ytimg.com/vi/R5Z35aXCv9Q/mqdefault.jpg",
    "title": "Bling-Bang-Bang-Born  /夏色まつり(cover)【ホロライブ】",
    "publishedAt": "2024-06-13T13:00:06Z"
  },
  {
    "videoId": "7dDwHxNPEU8",
    "thumbnail": "https://i.ytimg.com/vi/7dDwHxNPEU8/mqdefault.jpg",
    "title": "【歌枠】おうた聴いてくれますか？💞Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2024-06-16T10:09:12Z"
  },
  {
    "videoId": "ZC5eolmo0HQ",
    "thumbnail": "https://i.ytimg.com/vi/ZC5eolmo0HQ/mqdefault.jpg",
    "title": "【雑談】はなそ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-06-26T13:12:27Z"
  },
  {
    "videoId": "u-26OI1aJQE",
    "thumbnail": "https://i.ytimg.com/vi/u-26OI1aJQE/mqdefault.jpg",
    "title": "【DORONKO WANKO】ポメちゃんになって汚しまくるぞ～！🐶【ホロライブ/夏色まつり】",
    "publishedAt": "2024-06-28T08:51:00Z"
  },
  {
    "videoId": "jyrQX5eC9Eg",
    "thumbnail": "https://i.ytimg.com/vi/jyrQX5eC9Eg/mqdefault.jpg",
    "title": "【歌枠】KAWAII SONG🎵【ホロライブ/夏色まつり】",
    "publishedAt": "2024-06-28T13:07:52Z"
  },
  {
    "videoId": "lru7FGHu5lc",
    "thumbnail": "https://i.ytimg.com/vi/lru7FGHu5lc/mqdefault.jpg",
    "title": "【アレルギー】検査結果がでたので発表します【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-05T12:55:52Z"
  },
  {
    "videoId": "I8ICeTijuwA",
    "thumbnail": "https://i.ytimg.com/vi/I8ICeTijuwA/mqdefault.jpg",
    "title": "【七夕歌枠】夜空へ向けて届けまつりの歌🌠 / Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-07T12:06:30Z"
  },
  {
    "videoId": "bS_Yy9_e2hE",
    "thumbnail": "https://i.ytimg.com/vi/bS_Yy9_e2hE/mqdefault.jpg",
    "title": "【 僕、アルバイトォォ！！ 】迷惑客１名様ご来店！！！まつりの神対応みせてやんよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-09T10:19:28Z"
  },
  {
    "videoId": "h7SLcArY72A",
    "thumbnail": "https://i.ytimg.com/vi/h7SLcArY72A/mqdefault.jpg",
    "title": "【歌枠】バラード【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-11T10:17:37Z"
  },
  {
    "videoId": "2SPjdXZAssc",
    "thumbnail": "https://i.ytimg.com/vi/2SPjdXZAssc/mqdefault.jpg",
    "title": "【相関図】まつりからみたホロメン相関図つくるぞ！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-16T13:18:25Z"
  },
  {
    "videoId": "Yynr-4iWb3g",
    "thumbnail": "https://i.ytimg.com/vi/Yynr-4iWb3g/mqdefault.jpg",
    "title": "【 告知あり！ 】インターネット老人会！神曲歌うよ～💞【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-17T12:05:50Z"
  },
  {
    "videoId": "tdeICNbnFlM",
    "thumbnail": "https://i.ytimg.com/vi/tdeICNbnFlM/mqdefault.jpg",
    "title": "【カウントダウン】もう少しで誕生日！一緒にお祝いしてくれるよね？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-21T15:11:56Z"
  },
  {
    "videoId": "rANmEFiMHVU",
    "thumbnail": "https://i.ytimg.com/vi/rANmEFiMHVU/mqdefault.jpg",
    "title": "【#夏色まつり新衣装】誕生日に新衣装お披露目✨お知らせあり！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-22T12:10:03Z"
  },
  {
    "videoId": "nHNV7QiSJAI",
    "thumbnail": "https://i.ytimg.com/vi/nHNV7QiSJAI/mqdefault.jpg",
    "title": "【APEX】リハビリランク【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-30T08:15:08Z"
  },
  {
    "videoId": "JCee6Xf7Z9A",
    "thumbnail": "https://i.ytimg.com/vi/JCee6Xf7Z9A/mqdefault.jpg",
    "title": "【雑談】ゆるりんおはなし～【ホロライブ/夏色まつり】",
    "publishedAt": "2024-07-30T13:20:20Z"
  },
  {
    "videoId": "KM-thCptV6A",
    "thumbnail": "https://i.ytimg.com/vi/KM-thCptV6A/mqdefault.jpg",
    "title": "【APEX】V最顔合わせ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-09T14:27:52Z"
  },
  {
    "videoId": "-Ej80aq77tU",
    "thumbnail": "https://i.ytimg.com/vi/-Ej80aq77tU/mqdefault.jpg",
    "title": "【APEX】視聴者参加型カスタムするぞ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-13T14:21:51Z"
  },
  {
    "videoId": "gM8SVdzvT3M",
    "thumbnail": "https://i.ytimg.com/vi/gM8SVdzvT3M/mqdefault.jpg",
    "title": "【 Chained Together 】落ちるときは一緒だよ♡【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-14T18:12:08Z"
  },
  {
    "videoId": "6eVAZsHbYW8",
    "thumbnail": "https://i.ytimg.com/vi/6eVAZsHbYW8/mqdefault.jpg",
    "title": "【APEX】水色うさぎ🐰カスタム参加します！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-17T16:26:06Z"
  },
  {
    "videoId": "5QDbW4N05js",
    "thumbnail": "https://i.ytimg.com/vi/5QDbW4N05js/mqdefault.jpg",
    "title": "【APEX】クリフサイド行きます！！！/V最協カスタム1日目【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-18T17:59:05Z"
  },
  {
    "videoId": "0YvE73TySXg",
    "thumbnail": "https://i.ytimg.com/vi/0YvE73TySXg/mqdefault.jpg",
    "title": "【APEX】まつりの手綱握ってください！/V最協カスタム2日目【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-19T17:20:12Z"
  },
  {
    "videoId": "D8l_KzwbS-c",
    "thumbnail": "https://i.ytimg.com/vi/D8l_KzwbS-c/mqdefault.jpg",
    "title": "【APEX】なんとかなれー！！/V最協カスタム3日目【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-20T16:33:06Z"
  },
  {
    "videoId": "Y_LYgb0oUq8",
    "thumbnail": "https://i.ytimg.com/vi/Y_LYgb0oUq8/mqdefault.jpg",
    "title": "【APEX】自己中カスタム→合同カスタム/V最協カスタム4日目【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-21T15:38:50Z"
  },
  {
    "videoId": "IoDGVAkYsJA",
    "thumbnail": "https://i.ytimg.com/vi/IoDGVAkYsJA/mqdefault.jpg",
    "title": "【APEX】自己中カスタム→合同カスタム/V最協カスタム5日目【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-22T11:19:45Z"
  },
  {
    "videoId": "xsLos2MP3S4",
    "thumbnail": "https://i.ytimg.com/vi/xsLos2MP3S4/mqdefault.jpg",
    "title": "【APEX】くやしさをばねに/V最協カスタム最終日【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-23T11:51:32Z"
  },
  {
    "videoId": "7B-4NGBmMzE",
    "thumbnail": "https://i.ytimg.com/vi/7B-4NGBmMzE/mqdefault.jpg",
    "title": "【VTuber最協決定戦】クリフサイドでも勝気で行きます！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-24T14:41:44Z"
  },
  {
    "videoId": "MWZEwUl9Kfk",
    "thumbnail": "https://i.ytimg.com/vi/MWZEwUl9Kfk/mqdefault.jpg",
    "title": "【歌枠】久々にいろんな曲うたうよ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-30T10:12:28Z"
  },
  {
    "videoId": "FPb7srvTtXs",
    "thumbnail": "https://i.ytimg.com/vi/FPb7srvTtXs/mqdefault.jpg",
    "title": "【Minecraft】闘志を燃やせ～！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-08-31T12:53:49Z"
  },
  {
    "videoId": "Yz6GEYQjWhY",
    "thumbnail": "https://i.ytimg.com/vi/Yz6GEYQjWhY/mqdefault.jpg",
    "title": "【雑談】まちゅりとおはなし会【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-06T14:52:42Z"
  },
  {
    "videoId": "JVfh9laGnc8",
    "thumbnail": "https://i.ytimg.com/vi/JVfh9laGnc8/mqdefault.jpg",
    "title": "【 Minecraft 】ミニゲームであそぶ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-07T10:56:51Z"
  },
  {
    "videoId": "Rb1yZFG74_0",
    "thumbnail": "https://i.ytimg.com/vi/Rb1yZFG74_0/mqdefault.jpg",
    "title": "【APEX｜#演JOY軍団カスタム】勝つぞ～！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-07T15:39:30Z"
  },
  {
    "videoId": "6OakBLxqUkg",
    "thumbnail": "https://i.ytimg.com/vi/6OakBLxqUkg/mqdefault.jpg",
    "title": "【 holoindie 】お宝マウンテンで遊ぶぞ～！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-10T12:26:23Z"
  },
  {
    "videoId": "0iYcUlX9p18",
    "thumbnail": "https://i.ytimg.com/vi/0iYcUlX9p18/mqdefault.jpg",
    "title": "同担☆拒否/夏色まつり(cover)【ホロライブ】",
    "publishedAt": "2024-09-11T09:00:07Z"
  },
  {
    "videoId": "_V_-CqlZF1M",
    "thumbnail": "https://i.ytimg.com/vi/_V_-CqlZF1M/mqdefault.jpg",
    "title": "【 holoindie 】#夏色はあと でお宝マウンテン1時間勝負！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-13T10:43:49Z"
  },
  {
    "videoId": "7QbMzjXL0NU",
    "thumbnail": "https://i.ytimg.com/vi/7QbMzjXL0NU/mqdefault.jpg",
    "title": "【#holoGTA】こう見えて警察ですが＾＾【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-17T15:03:52Z"
  },
  {
    "videoId": "TJ_x_pxt898",
    "thumbnail": "https://i.ytimg.com/vi/TJ_x_pxt898/mqdefault.jpg",
    "title": "【#holoGTA】警察2日目！切符切りまくり！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-18T15:49:01Z"
  },
  {
    "videoId": "wkD0rdMyOTY",
    "thumbnail": "https://i.ytimg.com/vi/wkD0rdMyOTY/mqdefault.jpg",
    "title": "【#holoGTA】今日は遊ぶ日✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-19T15:05:52Z"
  },
  {
    "videoId": "i-X4ujm7pRQ",
    "thumbnail": "https://i.ytimg.com/vi/i-X4ujm7pRQ/mqdefault.jpg",
    "title": "【#holoGTA】今日はたくさん捕まえま～す！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-20T16:17:58Z"
  },
  {
    "videoId": "ECLrnsRdC2M",
    "thumbnail": "https://i.ytimg.com/vi/ECLrnsRdC2M/mqdefault.jpg",
    "title": "【#holoGTA】市民にもギャングにも寄り添うポリスですよ～【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-21T15:16:34Z"
  },
  {
    "videoId": "y8HEwczfTnk",
    "thumbnail": "https://i.ytimg.com/vi/y8HEwczfTnk/mqdefault.jpg",
    "title": "【#holoGTA】あと２日全力で楽しむホロポリス【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-22T15:35:35Z"
  },
  {
    "videoId": "trHwhaQi70s",
    "thumbnail": "https://i.ytimg.com/vi/trHwhaQi70s/mqdefault.jpg",
    "title": "【#holoGTA】最終日ロケットランチャーしたい日【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-23T16:21:23Z"
  },
  {
    "videoId": "3vpPUcplpGc",
    "thumbnail": "https://i.ytimg.com/vi/3vpPUcplpGc/mqdefault.jpg",
    "title": "【歌枠】君の好きな歌を歌う～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-24T09:51:40Z"
  },
  {
    "videoId": "qhzi-CLOZOA",
    "thumbnail": "https://i.ytimg.com/vi/qhzi-CLOZOA/mqdefault.jpg",
    "title": "【添削】ホロライブ非公式wikiって本当にあってるの？？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-29T14:13:53Z"
  },
  {
    "videoId": "hIQmxM3sJyM",
    "thumbnail": "https://i.ytimg.com/vi/hIQmxM3sJyM/mqdefault.jpg",
    "title": "【声マネキング】声真似といえばまつり！100点余裕でしょ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-09-30T13:09:21Z"
  },
  {
    "videoId": "jWjgOcal4oI",
    "thumbnail": "https://i.ytimg.com/vi/jWjgOcal4oI/mqdefault.jpg",
    "title": "【ガチ老人会】昭和歌謡曲歌枠♪/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-03T10:10:15Z"
  },
  {
    "videoId": "fHtiABJSedQ",
    "thumbnail": "https://i.ytimg.com/vi/fHtiABJSedQ/mqdefault.jpg",
    "title": "パイパイ仮面でどうかしらん？踊ってみた💃🏻 #shorts #dance",
    "publishedAt": "2024-10-08T03:35:12Z"
  },
  {
    "videoId": "Kv39aNhtOdA",
    "thumbnail": "https://i.ytimg.com/vi/Kv39aNhtOdA/mqdefault.jpg",
    "title": "【まいたけダンス】まいたけグルグル〜！ #shorts #dance",
    "publishedAt": "2024-10-09T08:57:40Z"
  },
  {
    "videoId": "SpICFBlnGvA",
    "thumbnail": "https://i.ytimg.com/vi/SpICFBlnGvA/mqdefault.jpg",
    "title": "【squirrel with a gun】リスが銃で大暴れ！？いけー！まつりす～！🐿【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-09T12:25:50Z"
  },
  {
    "videoId": "3BMsJZL6oak",
    "thumbnail": "https://i.ytimg.com/vi/3BMsJZL6oak/mqdefault.jpg",
    "title": "【作業用BGM】歌枠好きなだけ歌うから好きなときにききな～♡【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-11T14:57:41Z"
  },
  {
    "videoId": "-NmitTf7ITc",
    "thumbnail": "https://i.ytimg.com/vi/-NmitTf7ITc/mqdefault.jpg",
    "title": "#Boom 踊ってみた✨ モーションデータ配布中！一緒に踊ろう！ #PR #YouTubeショート #ギガプロ #dance",
    "publishedAt": "2024-10-17T13:00:00Z"
  },
  {
    "videoId": "netaG2GDc2A",
    "thumbnail": "https://i.ytimg.com/vi/netaG2GDc2A/mqdefault.jpg",
    "title": "【雑談】風邪ひいてました(*'ω'*)【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-18T10:11:37Z"
  },
  {
    "videoId": "kPY_yADOPD4",
    "thumbnail": "https://i.ytimg.com/vi/kPY_yADOPD4/mqdefault.jpg",
    "title": "【食費APEX】1ダメージ＝1円！１時間勝負✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-21T10:23:43Z"
  },
  {
    "videoId": "zZsgnPmP6lg",
    "thumbnail": "https://i.ytimg.com/vi/zZsgnPmP6lg/mqdefault.jpg",
    "title": "【視聴者参加型】どうぶつタワーバトル連勝チャレンジ！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-21T12:16:34Z"
  },
  {
    "videoId": "O3YxrSOvpRQ",
    "thumbnail": "https://i.ytimg.com/vi/O3YxrSOvpRQ/mqdefault.jpg",
    "title": "【昼雑談】ひるほ～！お昼に起きててえら～い！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-23T04:02:39Z"
  },
  {
    "videoId": "rsRHK869f_s",
    "thumbnail": "https://i.ytimg.com/vi/rsRHK869f_s/mqdefault.jpg",
    "title": "【スーパー マリオパーティ ジャンボリー】初見ソロモードいくぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-24T10:33:55Z"
  },
  {
    "videoId": "NDjFyV2ruH4",
    "thumbnail": "https://i.ytimg.com/vi/NDjFyV2ruH4/mqdefault.jpg",
    "title": "【告知あり】可愛く歌って可愛く告知するよ♡【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-26T13:14:12Z"
  },
  {
    "videoId": "PpEU_XyYP0A",
    "thumbnail": "https://i.ytimg.com/vi/PpEU_XyYP0A/mqdefault.jpg",
    "title": "【縦型歌枠】久々縦型配信だゅ🐰【ホロライブ/夏色まつり】",
    "publishedAt": "2024-10-27T14:20:49Z"
  },
  {
    "videoId": "pKc5qSSWJQs",
    "thumbnail": "https://i.ytimg.com/vi/pKc5qSSWJQs/mqdefault.jpg",
    "title": "【3D LIVE】#夏色FullBloom / 夏色まつり誕生ライブ【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-01T11:56:11Z"
  },
  {
    "videoId": "Wr10_8s_yAQ",
    "thumbnail": "https://i.ytimg.com/vi/Wr10_8s_yAQ/mqdefault.jpg",
    "title": "【オリジナル曲】ENDLESS FES【ホロライブ/夏色まつり/ FAKE TYPE.】",
    "publishedAt": "2024-11-01T12:15:06Z"
  },
  {
    "videoId": "M4a73FCLmlQ",
    "thumbnail": "https://i.ytimg.com/vi/M4a73FCLmlQ/mqdefault.jpg",
    "title": "【 Liar's Bar 】命を賭けるのが流行ってるらしいですね！？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-02T10:56:22Z"
  },
  {
    "videoId": "FuelqqQlHeQ",
    "thumbnail": "https://i.ytimg.com/vi/FuelqqQlHeQ/mqdefault.jpg",
    "title": "【 Liar's Bar 】3勝するまで終われないデスゲーム開幕💀【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-03T07:47:34Z"
  },
  {
    "videoId": "-zXFSjds3Hk",
    "thumbnail": "https://i.ytimg.com/vi/-zXFSjds3Hk/mqdefault.jpg",
    "title": "【うたわく】📛幼児向け歌枠📛【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-03T13:09:05Z"
  },
  {
    "videoId": "LIftYQoyjHI",
    "thumbnail": "https://i.ytimg.com/vi/LIftYQoyjHI/mqdefault.jpg",
    "title": "【VALORANT】ブロンズベイビーがコンペいく【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-04T09:49:31Z"
  },
  {
    "videoId": "DauTQg8VagE",
    "thumbnail": "https://i.ytimg.com/vi/DauTQg8VagE/mqdefault.jpg",
    "title": "【 Liar's Bar 】💀負けたら即終了デスゲーム開幕💀【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-05T11:14:06Z"
  },
  {
    "videoId": "G03kbbkZawM",
    "thumbnail": "https://i.ytimg.com/vi/G03kbbkZawM/mqdefault.jpg",
    "title": "【 Liar's Bar 】💀リベンジ💀【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-05T11:36:37Z"
  },
  {
    "videoId": "9VsPjLOY28o",
    "thumbnail": "https://i.ytimg.com/vi/9VsPjLOY28o/mqdefault.jpg",
    "title": "【 Liar's Bar 】💀3度目の正直っていうやん💀【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-05T12:02:57Z"
  },
  {
    "videoId": "KCPs-oAwsMY",
    "thumbnail": "https://i.ytimg.com/vi/KCPs-oAwsMY/mqdefault.jpg",
    "title": "【 #1期生お披露目リレー配信 】おそろいって憧れだよね！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-09T10:30:25Z"
  },
  {
    "videoId": "5UFFR94lv7I",
    "thumbnail": "https://i.ytimg.com/vi/5UFFR94lv7I/mqdefault.jpg",
    "title": "【睡眠導入】久々に自分の島見に行くよ🌃【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-09T19:19:39Z"
  },
  {
    "videoId": "YKEhO5jhP3g",
    "thumbnail": "https://i.ytimg.com/vi/YKEhO5jhP3g/mqdefault.jpg",
    "title": "Boom / Team ahamo（天宮こころ/橘ひなの/アルス・アルマル/夏色まつり/尾丸ポルカ）【GIGA MASH PROJECT】",
    "publishedAt": "2024-11-12T12:00:06Z"
  },
  {
    "videoId": "GVcxCl4AZRw",
    "thumbnail": "https://i.ytimg.com/vi/GVcxCl4AZRw/mqdefault.jpg",
    "title": "ENDLESS FES #shorts #歌ってみた #オリジナル曲 #夏色まつり #vtuber",
    "publishedAt": "2024-11-13T13:18:02Z"
  },
  {
    "videoId": "DNvE3H-NJkc",
    "thumbnail": "https://i.ytimg.com/vi/DNvE3H-NJkc/mqdefault.jpg",
    "title": "【APEX】えぺまつり外伝 feat.日本赤十字社【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-16T12:25:31Z"
  },
  {
    "videoId": "Cg4VazFCtQg",
    "thumbnail": "https://i.ytimg.com/vi/Cg4VazFCtQg/mqdefault.jpg",
    "title": "【Maquette】模型と現実がリンクする！？脳がバグるゲーム！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-17T12:10:47Z"
  },
  {
    "videoId": "eLNCBH4-J_Q",
    "thumbnail": "https://i.ytimg.com/vi/eLNCBH4-J_Q/mqdefault.jpg",
    "title": "【PICO PARK2】力をあわせていくぞ～！！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-18T13:33:29Z"
  },
  {
    "videoId": "gi3tuywwdMQ",
    "thumbnail": "https://i.ytimg.com/vi/gi3tuywwdMQ/mqdefault.jpg",
    "title": "【#vtuber発掘2 】チャンネル1万人以下の歌うま原石VTuber大紹介逆凸✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-19T10:45:46Z"
  },
  {
    "videoId": "HCxjpqZP4bI",
    "thumbnail": "https://i.ytimg.com/vi/HCxjpqZP4bI/mqdefault.jpg",
    "title": "【アソビ大全】ホロライブってのを新人ちゃんに教えたるわ🐅【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-19T12:19:02Z"
  },
  {
    "videoId": "5Iag9dZqTKE",
    "thumbnail": "https://i.ytimg.com/vi/5Iag9dZqTKE/mqdefault.jpg",
    "title": "【 マリパジャンボリー 】阿鼻叫喚のジャンボリーはじめます！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-21T12:25:43Z"
  },
  {
    "videoId": "kOx-eaHQcaQ",
    "thumbnail": "https://i.ytimg.com/vi/kOx-eaHQcaQ/mqdefault.jpg",
    "title": "【 Chained Together 】まちゅゼタ姉妹で高みを目指す！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-22T13:37:26Z"
  },
  {
    "videoId": "VUY9WXt7fIQ",
    "thumbnail": "https://i.ytimg.com/vi/VUY9WXt7fIQ/mqdefault.jpg",
    "title": "【Buckshot Roulette】実力で新人ちゃんをわからせる💬🔁💙【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-26T10:16:06Z"
  },
  {
    "videoId": "51vrnG_JULg",
    "thumbnail": "https://i.ytimg.com/vi/51vrnG_JULg/mqdefault.jpg",
    "title": "【 空気読み｡4 】空気は吸うものだろ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-27T09:55:31Z"
  },
  {
    "videoId": "I_d_Zim5_hg",
    "thumbnail": "https://i.ytimg.com/vi/I_d_Zim5_hg/mqdefault.jpg",
    "title": "【歌枠】✨まつりスーパーエキストラ歌枠✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-28T10:15:31Z"
  },
  {
    "videoId": "M3tsIzVqyKA",
    "thumbnail": "https://i.ytimg.com/vi/M3tsIzVqyKA/mqdefault.jpg",
    "title": "【Liar's Bar】ホロライブのトップを決めようじゃないか。【ホロライブ/夏色まつり】",
    "publishedAt": "2024-11-29T14:17:18Z"
  },
  {
    "videoId": "vBfp6wDU1Eo",
    "thumbnail": "https://i.ytimg.com/vi/vBfp6wDU1Eo/mqdefault.jpg",
    "title": "【 Liar's Bar 】カオスモードで3勝耐久！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-03T13:19:35Z"
  },
  {
    "videoId": "EZo9eAeHcIE",
    "thumbnail": "https://i.ytimg.com/vi/EZo9eAeHcIE/mqdefault.jpg",
    "title": "【歌枠】バラード【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-04T15:08:03Z"
  },
  {
    "videoId": "CR-ZpaMfXu8",
    "thumbnail": "https://i.ytimg.com/vi/CR-ZpaMfXu8/mqdefault.jpg",
    "title": "【歌枠】げりげりげりら！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-07T08:45:48Z"
  },
  {
    "videoId": "kZlEYuFQ7UQ",
    "thumbnail": "https://i.ytimg.com/vi/kZlEYuFQ7UQ/mqdefault.jpg",
    "title": "【雑談】げりらごりら🦍【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-09T08:44:23Z"
  },
  {
    "videoId": "Db40B4iA3aQ",
    "thumbnail": "https://i.ytimg.com/vi/Db40B4iA3aQ/mqdefault.jpg",
    "title": "【プロフィール帳】本当にまつりのことちゃんと知ってる？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-14T11:01:05Z"
  },
  {
    "videoId": "4uyvV_fvVec",
    "thumbnail": "https://i.ytimg.com/vi/4uyvV_fvVec/mqdefault.jpg",
    "title": "【漢字でGO! 集英社マンガ祭】俺たちの戦いはこれからだ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-16T10:56:48Z"
  },
  {
    "videoId": "TFeLmnTxskw",
    "thumbnail": "https://i.ytimg.com/vi/TFeLmnTxskw/mqdefault.jpg",
    "title": "みこちを産みたい👶🏻🍼︎ #shorts #dance #夏色まつり",
    "publishedAt": "2024-12-17T12:00:37Z"
  },
  {
    "videoId": "MWZywQvZGY8",
    "thumbnail": "https://i.ytimg.com/vi/MWZywQvZGY8/mqdefault.jpg",
    "title": "【Rakuten esports cup】初対面ですがまつりを超えるやばいやつがいるとききました。【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-19T13:32:04Z"
  },
  {
    "videoId": "U-ebUV2JPEA",
    "thumbnail": "https://i.ytimg.com/vi/U-ebUV2JPEA/mqdefault.jpg",
    "title": "【Minecraft】サンタより子供役がいいです！プレゼントくださ～い！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-20T12:47:44Z"
  },
  {
    "videoId": "oGHK7sqQufg",
    "thumbnail": "https://i.ytimg.com/vi/oGHK7sqQufg/mqdefault.jpg",
    "title": "【アソビ大全】リバーシ最弱王決定戦！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-21T10:55:37Z"
  },
  {
    "videoId": "UJ--NBlbTvQ",
    "thumbnail": "https://i.ytimg.com/vi/UJ--NBlbTvQ/mqdefault.jpg",
    "title": "POP IN 2 / B小町 covered by 夏色まつり×白上フブキ×轟はじめ",
    "publishedAt": "2024-12-21T11:00:06Z"
  },
  {
    "videoId": "eaUOFMrXtZ0",
    "thumbnail": "https://i.ytimg.com/vi/eaUOFMrXtZ0/mqdefault.jpg",
    "title": "【同時視聴】✨全日本高校eスポーツ選手権✨【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-22T06:39:42Z"
  },
  {
    "videoId": "MjD2ABGNC18",
    "thumbnail": "https://i.ytimg.com/vi/MjD2ABGNC18/mqdefault.jpg",
    "title": "歌ってみたもあげたから聞いてね！#shorts  #dance  #夏色まつり #popin2",
    "publishedAt": "2024-12-22T12:00:31Z"
  },
  {
    "videoId": "GVqkIhhH9Ig",
    "thumbnail": "https://i.ytimg.com/vi/GVqkIhhH9Ig/mqdefault.jpg",
    "title": "【リアル凸待ち】クリスマスはホロライブと過ごしませんか！？【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-24T08:11:15Z"
  },
  {
    "videoId": "BDI8EoUxkco",
    "thumbnail": "https://i.ytimg.com/vi/BDI8EoUxkco/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】今年も最多曲数目指します！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-25T08:43:12Z"
  },
  {
    "videoId": "WAq_q2m-s0g",
    "thumbnail": "https://i.ytimg.com/vi/WAq_q2m-s0g/mqdefault.jpg",
    "title": "【APEXガチャ】クリスマスプレゼント（スパレジェ）ください！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-25T13:43:04Z"
  },
  {
    "videoId": "v5Ht8Lj88QE",
    "thumbnail": "https://i.ytimg.com/vi/v5Ht8Lj88QE/mqdefault.jpg",
    "title": "【お宝マウンテン】バトルモードきちゃ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-26T10:09:44Z"
  },
  {
    "videoId": "SIp41_h5aus",
    "thumbnail": "https://i.ytimg.com/vi/SIp41_h5aus/mqdefault.jpg",
    "title": "【ASMR】メン限お試しいちゃいちゃASMR【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-27T10:15:46Z"
  },
  {
    "videoId": "gKd1zl2T4eM",
    "thumbnail": "https://i.ytimg.com/vi/gKd1zl2T4eM/mqdefault.jpg",
    "title": "DT砲だけ知ってます！！！  #shorts  #dance #夏色まつり #テトリス #柊マグネタイト",
    "publishedAt": "2024-12-27T12:00:53Z"
  },
  {
    "videoId": "QrM2c7nOWEo",
    "thumbnail": "https://i.ytimg.com/vi/QrM2c7nOWEo/mqdefault.jpg",
    "title": "【歌枠】KAWAII SONG♪【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-28T11:19:16Z"
  },
  {
    "videoId": "P8kSWvWQTWc",
    "thumbnail": "https://i.ytimg.com/vi/P8kSWvWQTWc/mqdefault.jpg",
    "title": "扉バーーーーン！！！　 #shorts #dance #夏色まつり #一旦ステイTONIGHT",
    "publishedAt": "2024-12-29T12:00:25Z"
  },
  {
    "videoId": "69zij_bHIik",
    "thumbnail": "https://i.ytimg.com/vi/69zij_bHIik/mqdefault.jpg",
    "title": "だめにきまってんだろー！？　#shorts #dance #夏色まつり #かわいいだけじゃだめですか",
    "publishedAt": "2024-12-30T12:00:09Z"
  },
  {
    "videoId": "Y17uuSruZVs",
    "thumbnail": "https://i.ytimg.com/vi/Y17uuSruZVs/mqdefault.jpg",
    "title": "【時間未定】起きてから始まる年越し耐久【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-31T08:51:50Z"
  },
  {
    "videoId": "SuESDUd3_nA",
    "thumbnail": "https://i.ytimg.com/vi/SuESDUd3_nA/mqdefault.jpg",
    "title": "－・－・・　♡　#shorts #dance #夏色まつり #はいよろこんで #こっちのけんと",
    "publishedAt": "2024-12-31T12:00:38Z"
  },
  {
    "videoId": "6SjDBj3Qn10",
    "thumbnail": "https://i.ytimg.com/vi/6SjDBj3Qn10/mqdefault.jpg",
    "title": "【時間未定】起きてから始まる年越し耐久【ホロライブ/夏色まつり】",
    "publishedAt": "2024-12-31T16:10:05Z"
  },
  {
    "videoId": "70smLJSc2W0",
    "thumbnail": "https://i.ytimg.com/vi/70smLJSc2W0/mqdefault.jpg",
    "title": "【お年玉】2025年新年のご挨拶【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-01T11:00:55Z"
  },
  {
    "videoId": "FAODjHbQRhg",
    "thumbnail": "https://i.ytimg.com/vi/FAODjHbQRhg/mqdefault.jpg",
    "title": "個人的には逆バニーが好きです。#shorts #dance #夏色まつり #bunnygirl",
    "publishedAt": "2025-01-01T12:00:16Z"
  },
  {
    "videoId": "V-wOP_IPYEg",
    "thumbnail": "https://i.ytimg.com/vi/V-wOP_IPYEg/mqdefault.jpg",
    "title": "【筆おろし】今年も君の筆おろします。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-02T09:09:02Z"
  },
  {
    "videoId": "T0lO_-a1Src",
    "thumbnail": "https://i.ytimg.com/vi/T0lO_-a1Src/mqdefault.jpg",
    "title": "こんこよカッコイイのも似合うよね #shorts #dance  #夏色まつり #デコレート",
    "publishedAt": "2025-01-02T12:00:35Z"
  },
  {
    "videoId": "lv6xwOAoAtQ",
    "thumbnail": "https://i.ytimg.com/vi/lv6xwOAoAtQ/mqdefault.jpg",
    "title": "俺が守るぞ。ルーナ。 #shorts #dance  #夏色まつり #守護ってルーナイト",
    "publishedAt": "2025-01-03T12:00:58Z"
  },
  {
    "videoId": "8bHKdbOrK-8",
    "thumbnail": "https://i.ytimg.com/vi/8bHKdbOrK-8/mqdefault.jpg",
    "title": "ノエル節だいすきwww　#shorts #dance #夏色まつり #ぎゅーどんかーにばる",
    "publishedAt": "2025-01-04T12:00:10Z"
  },
  {
    "videoId": "ubmgoVFekAc",
    "thumbnail": "https://i.ytimg.com/vi/ubmgoVFekAc/mqdefault.jpg",
    "title": "FAKE TYPE.×夏色まつりの神曲ｷﾀ━(ﾟ∀ﾟ)━!　#shorts #dance  #夏色まつり #endlessfes",
    "publishedAt": "2025-01-05T12:01:15Z"
  },
  {
    "videoId": "BYQVnnVOwj4",
    "thumbnail": "https://i.ytimg.com/vi/BYQVnnVOwj4/mqdefault.jpg",
    "title": "【#ホロクラダイヤ発掘隊】ダイヤほりほり隊にはいりました。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-06T15:04:56Z"
  },
  {
    "videoId": "M3YW7gKMNYg",
    "thumbnail": "https://i.ytimg.com/vi/M3YW7gKMNYg/mqdefault.jpg",
    "title": "【#ホロクラダイヤ発掘隊】さむねつくってくれ【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-07T15:34:31Z"
  },
  {
    "videoId": "VQidcgLL7BM",
    "thumbnail": "https://i.ytimg.com/vi/VQidcgLL7BM/mqdefault.jpg",
    "title": "【ポケカ福袋】✨300万✨の福袋開封するぞおおおおおおおお！！！！！！！！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-08T10:51:10Z"
  },
  {
    "videoId": "1dlgKhVV3Fc",
    "thumbnail": "https://i.ytimg.com/vi/1dlgKhVV3Fc/mqdefault.jpg",
    "title": "【#ホロクラダイヤ発掘隊】2025個のダイヤほりほり隊【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-09T15:02:57Z"
  },
  {
    "videoId": "mQG3IG31lEo",
    "thumbnail": "https://i.ytimg.com/vi/mQG3IG31lEo/mqdefault.jpg",
    "title": "【切り抜き】300万ポケカ福袋開封で大勝利するまつりちゃん【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-12T09:00:06Z"
  },
  {
    "videoId": "-SR_N-7lFa0",
    "thumbnail": "https://i.ytimg.com/vi/-SR_N-7lFa0/mqdefault.jpg",
    "title": "【マリオカート8DX】 #ホロ新春ゲーム祭り2025 チームに貢献するために！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-12T12:04:24Z"
  },
  {
    "videoId": "EAGrSQhgYdo",
    "thumbnail": "https://i.ytimg.com/vi/EAGrSQhgYdo/mqdefault.jpg",
    "title": "【Puzzle Together】トワチームパズル視点【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-13T12:23:21Z"
  },
  {
    "videoId": "38hYYvOBgQs",
    "thumbnail": "https://i.ytimg.com/vi/38hYYvOBgQs/mqdefault.jpg",
    "title": "【#ホロ新春ゲーム祭2025】本番！がんばるぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-13T14:43:58Z"
  },
  {
    "videoId": "nAITza35G5g",
    "thumbnail": "https://i.ytimg.com/vi/nAITza35G5g/mqdefault.jpg",
    "title": "【睡眠導入】君が寝れるまでまったりあつ森🌳【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-15T18:19:29Z"
  },
  {
    "videoId": "knxZaE8Tep4",
    "thumbnail": "https://i.ytimg.com/vi/knxZaE8Tep4/mqdefault.jpg",
    "title": "はいよろこんでNG集！りりかに教わらないとかな🙃🙃  #夏色まつり #はいよろこんで #shorts #dance",
    "publishedAt": "2025-01-18T12:01:04Z"
  },
  {
    "videoId": "PZm1FlhqDaE",
    "thumbnail": "https://i.ytimg.com/vi/PZm1FlhqDaE/mqdefault.jpg",
    "title": "【DYPING】タイピングなら任せてください！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-19T11:32:02Z"
  },
  {
    "videoId": "WEp4Ig5bwCA",
    "thumbnail": "https://i.ytimg.com/vi/WEp4Ig5bwCA/mqdefault.jpg",
    "title": "【歌枠】テンション上がる神曲歌枠！/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-20T13:17:28Z"
  },
  {
    "videoId": "OpIjlHsFtEM",
    "thumbnail": "https://i.ytimg.com/vi/OpIjlHsFtEM/mqdefault.jpg",
    "title": "【APEXランク】ソロランクでミラージュと和解する。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-27T12:49:23Z"
  },
  {
    "videoId": "PgYfCzN2m_M",
    "thumbnail": "https://i.ytimg.com/vi/PgYfCzN2m_M/mqdefault.jpg",
    "title": "【#夏色まつり150万人耐久】150万人まで歌うぞおおおおおおおおおおお！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-28T10:22:39Z"
  },
  {
    "videoId": "P3M3IjCtWPs",
    "thumbnail": "https://i.ytimg.com/vi/P3M3IjCtWPs/mqdefault.jpg",
    "title": "【公式依頼!?】ホロカに使う○○を制作します！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-28T12:20:08Z"
  },
  {
    "videoId": "ZunoqvjsyKQ",
    "thumbnail": "https://i.ytimg.com/vi/ZunoqvjsyKQ/mqdefault.jpg",
    "title": "【#夏色まつり150万人耐久】150万人まで歌うぞおおおおおおおおおおお！！！Day2【ホロライブ/夏色まつり】",
    "publishedAt": "2025-01-29T11:25:28Z"
  },
  {
    "videoId": "S5yPuqq2PLA",
    "thumbnail": "https://i.ytimg.com/vi/S5yPuqq2PLA/mqdefault.jpg",
    "title": "【PUBG MOBILE】PUBG MOBILEとコラボ！？まつりボイスでいざドン勝へ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-02T14:06:35Z"
  },
  {
    "videoId": "0qmGzK3aWys",
    "thumbnail": "https://i.ytimg.com/vi/0qmGzK3aWys/mqdefault.jpg",
    "title": "【 Minecraft 】新鯖きちゃ！マイハウス立てるぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-03T13:17:02Z"
  },
  {
    "videoId": "bBMRsDqsIZc",
    "thumbnail": "https://i.ytimg.com/vi/bBMRsDqsIZc/mqdefault.jpg",
    "title": "【 Minecraft 】新鯖でなんかする！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-04T08:20:19Z"
  },
  {
    "videoId": "ZB5MIhEI2u0",
    "thumbnail": "https://i.ytimg.com/vi/ZB5MIhEI2u0/mqdefault.jpg",
    "title": "【 Minecraft 】大冒険のはじまり～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-04T16:39:31Z"
  },
  {
    "videoId": "qQzNYGr8ZCU",
    "thumbnail": "https://i.ytimg.com/vi/qQzNYGr8ZCU/mqdefault.jpg",
    "title": "【 Minecraft 】みこちからの依頼！マグマハウス作るぞ＾＾【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-06T17:59:46Z"
  },
  {
    "videoId": "ezkPttGsqyI",
    "thumbnail": "https://i.ytimg.com/vi/ezkPttGsqyI/mqdefault.jpg",
    "title": "【 Minecraft 】経験値ほし～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-07T13:49:10Z"
  },
  {
    "videoId": "k1_iHNQaKQI",
    "thumbnail": "https://i.ytimg.com/vi/k1_iHNQaKQI/mqdefault.jpg",
    "title": "【相性診断】まつこよの相性〇％！？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-07T14:59:51Z"
  },
  {
    "videoId": "knE_3O0YtO4",
    "thumbnail": "https://i.ytimg.com/vi/knE_3O0YtO4/mqdefault.jpg",
    "title": "【台本制作】俺の考える最強のホロメンシチュエーションボイス#1【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-08T10:25:15Z"
  },
  {
    "videoId": "oA6J5VwxpcY",
    "thumbnail": "https://i.ytimg.com/vi/oA6J5VwxpcY/mqdefault.jpg",
    "title": "【 Minecraft 】ネザライト装備を目指して！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-09T12:03:53Z"
  },
  {
    "videoId": "HXV9ULvaMVc",
    "thumbnail": "https://i.ytimg.com/vi/HXV9ULvaMVc/mqdefault.jpg",
    "title": "【 Minecraft 】🏴‍☠️船長からの依頼🏴‍☠️水辺のおうちを作るよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-10T05:58:54Z"
  },
  {
    "videoId": "63BhIgM-YWA",
    "thumbnail": "https://i.ytimg.com/vi/63BhIgM-YWA/mqdefault.jpg",
    "title": "【 Minecraft 】🏴‍☠️船長からの依頼🏴‍☠️水辺のおうちを作るよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-11T06:04:48Z"
  },
  {
    "videoId": "ed7dCfg9sGg",
    "thumbnail": "https://i.ytimg.com/vi/ed7dCfg9sGg/mqdefault.jpg",
    "title": "【ASMR】メン限お試しいちゃいちゃASMR【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-12T10:15:52Z"
  },
  {
    "videoId": "RIvngFAHTF4",
    "thumbnail": "https://i.ytimg.com/vi/RIvngFAHTF4/mqdefault.jpg",
    "title": "【 Apex Legends 】dtto.CUPきちゃ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-15T12:26:01Z"
  },
  {
    "videoId": "uAgjhqzkIBo",
    "thumbnail": "https://i.ytimg.com/vi/uAgjhqzkIBo/mqdefault.jpg",
    "title": "【 Minecraft 】いろいろ作るよ～！匠まちゅ登場✨【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-16T13:45:02Z"
  },
  {
    "videoId": "IwaZglnBS4Q",
    "thumbnail": "https://i.ytimg.com/vi/IwaZglnBS4Q/mqdefault.jpg",
    "title": "【 Minecraft 】ポルカの水上コテージを作るよ✨【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-17T07:24:11Z"
  },
  {
    "videoId": "_NBmcMHztmI",
    "thumbnail": "https://i.ytimg.com/vi/_NBmcMHztmI/mqdefault.jpg",
    "title": "【 Minecraft 】ポルカの水上コテージのために～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-19T06:56:40Z"
  },
  {
    "videoId": "Dh5eHlVuhfg",
    "thumbnail": "https://i.ytimg.com/vi/Dh5eHlVuhfg/mqdefault.jpg",
    "title": "【 Minecraft 】ポルカの水上コテージ完成します～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-22T09:25:38Z"
  },
  {
    "videoId": "KM8d6hh4QCw",
    "thumbnail": "https://i.ytimg.com/vi/KM8d6hh4QCw/mqdefault.jpg",
    "title": "【歌枠】猫の日🐈KAWAII SONG!!【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-22T11:59:15Z"
  },
  {
    "videoId": "w9_T7FbEI84",
    "thumbnail": "https://i.ytimg.com/vi/w9_T7FbEI84/mqdefault.jpg",
    "title": "【 Minecraft 】新ホロ鯖です！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-24T15:45:24Z"
  },
  {
    "videoId": "lmMdox1tbUE",
    "thumbnail": "https://i.ytimg.com/vi/lmMdox1tbUE/mqdefault.jpg",
    "title": "【 Minecraft 】ネザライトとダイヤ！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-25T12:55:34Z"
  },
  {
    "videoId": "oXKSgGxyvFQ",
    "thumbnail": "https://i.ytimg.com/vi/oXKSgGxyvFQ/mqdefault.jpg",
    "title": "【 Minecraft 】ぬ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-27T16:59:26Z"
  },
  {
    "videoId": "hApMCEf-e18",
    "thumbnail": "https://i.ytimg.com/vi/hApMCEf-e18/mqdefault.jpg",
    "title": "【 Minecraft 】aaaaaaaaaaaaaaaaaa【ホロライブ/夏色まつり】",
    "publishedAt": "2025-02-28T14:58:42Z"
  },
  {
    "videoId": "-tlaPNvJVic",
    "thumbnail": "https://i.ytimg.com/vi/-tlaPNvJVic/mqdefault.jpg",
    "title": "まつりもこぼマリンの間にいれてよ。#III #夏色まつり #shorts #dance",
    "publishedAt": "2025-03-01T09:00:00Z"
  },
  {
    "videoId": "x596XJTQac8",
    "thumbnail": "https://i.ytimg.com/vi/x596XJTQac8/mqdefault.jpg",
    "title": "IIIの振りハマりすぎではあるよ #loveandjoy #夏色まつり #shorts #dance",
    "publishedAt": "2025-03-02T09:01:00Z"
  },
  {
    "videoId": "r5LyW7P22u0",
    "thumbnail": "https://i.ytimg.com/vi/r5LyW7P22u0/mqdefault.jpg",
    "title": "【モンハンワイルズ】ついにきた！片手剣いくぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-02T11:28:42Z"
  },
  {
    "videoId": "7azYqpkhj_E",
    "thumbnail": "https://i.ytimg.com/vi/7azYqpkhj_E/mqdefault.jpg",
    "title": "【モンハンワイルズ】片手剣でいざ行くぞ！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-03T10:21:02Z"
  },
  {
    "videoId": "w5KOoH8uOxs",
    "thumbnail": "https://i.ytimg.com/vi/w5KOoH8uOxs/mqdefault.jpg",
    "title": "【 Minecraft 】新ホロ鯖いろいろするぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-03T15:30:53Z"
  },
  {
    "videoId": "7gK9aztXjPY",
    "thumbnail": "https://i.ytimg.com/vi/7gK9aztXjPY/mqdefault.jpg",
    "title": "【モンハンワイルズ】片手剣でいざ行くぞ！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-04T09:47:34Z"
  },
  {
    "videoId": "rt0nEh8EhmU",
    "thumbnail": "https://i.ytimg.com/vi/rt0nEh8EhmU/mqdefault.jpg",
    "title": "【モンハンワイルズ】片手剣でいざ行くぞ！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-05T08:55:42Z"
  },
  {
    "videoId": "BwA-GzfYzMs",
    "thumbnail": "https://i.ytimg.com/vi/BwA-GzfYzMs/mqdefault.jpg",
    "title": "【オリジナル曲】ラヴレター【ホロライブ/夏色まつり/内緒のピアス】",
    "publishedAt": "2025-03-08T13:00:06Z"
  },
  {
    "videoId": "k0eS6FQXLMI",
    "thumbnail": "https://i.ytimg.com/vi/k0eS6FQXLMI/mqdefault.jpg",
    "title": "【#hololivefesEXPO25】DAY1打ち上げ会場✨【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-08T13:56:19Z"
  },
  {
    "videoId": "_XsB7PG2uw8",
    "thumbnail": "https://i.ytimg.com/vi/_XsB7PG2uw8/mqdefault.jpg",
    "title": "どんな形でもいいから私を認知して。 #ラヴレター #夏色まつり #shorts",
    "publishedAt": "2025-03-09T13:00:52Z"
  },
  {
    "videoId": "p8oMeldeHkY",
    "thumbnail": "https://i.ytimg.com/vi/p8oMeldeHkY/mqdefault.jpg",
    "title": "【#hololivefesEXPO25】振り返り配信✨ 【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-10T10:09:27Z"
  },
  {
    "videoId": "M68Ltj4QxbE",
    "thumbnail": "https://i.ytimg.com/vi/M68Ltj4QxbE/mqdefault.jpg",
    "title": "【歌枠】2次会カラオケいくぞ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-10T14:09:20Z"
  },
  {
    "videoId": "xMwXrmMX48Y",
    "thumbnail": "https://i.ytimg.com/vi/xMwXrmMX48Y/mqdefault.jpg",
    "title": "【 Minecraft 】ゲームセンターを作るぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-11T09:34:06Z"
  },
  {
    "videoId": "LHwnr_DqPHk",
    "thumbnail": "https://i.ytimg.com/vi/LHwnr_DqPHk/mqdefault.jpg",
    "title": "神羅万象チョコ #夏色まつり #shorts #dance #undead",
    "publishedAt": "2025-03-14T14:00:24Z"
  },
  {
    "videoId": "h7K1py-s30U",
    "thumbnail": "https://i.ytimg.com/vi/h7K1py-s30U/mqdefault.jpg",
    "title": "【モンハンワイルズ】片手剣でHR100まで！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-14T20:54:04Z"
  },
  {
    "videoId": "3940guXET3o",
    "thumbnail": "https://i.ytimg.com/vi/3940guXET3o/mqdefault.jpg",
    "title": "ピンチケオタクが通ります #夏色まつり #shorts #dance #アイドルライフエクストラパック #iLiFE #アイエク",
    "publishedAt": "2025-03-15T12:00:03Z"
  },
  {
    "videoId": "yCZptEmgam8",
    "thumbnail": "https://i.ytimg.com/vi/yCZptEmgam8/mqdefault.jpg",
    "title": "ぴかぴか～！好きなポケモンはケムッソです #夏色まつり #dance #shorts #ピッカーン",
    "publishedAt": "2025-03-16T13:30:37Z"
  },
  {
    "videoId": "JE6oXkzpSDI",
    "thumbnail": "https://i.ytimg.com/vi/JE6oXkzpSDI/mqdefault.jpg",
    "title": "💎",
    "publishedAt": "2025-03-17T17:09:49Z"
  },
  {
    "videoId": "cbhN0ATuphg",
    "thumbnail": "https://i.ytimg.com/vi/cbhN0ATuphg/mqdefault.jpg",
    "title": "【 Minecraft 】ゲームセンターを作るぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-18T08:49:07Z"
  },
  {
    "videoId": "fZrrbmBhBdo",
    "thumbnail": "https://i.ytimg.com/vi/fZrrbmBhBdo/mqdefault.jpg",
    "title": "一番好きなのはクッキーです！君は？ #夏色まつり #ホロライブ #踊ってみた #レモンメロンクッキー",
    "publishedAt": "2025-03-18T13:30:35Z"
  },
  {
    "videoId": "FBQlOqQL2ps",
    "thumbnail": "https://i.ytimg.com/vi/FBQlOqQL2ps/mqdefault.jpg",
    "title": "【モンハンワイルズ】１期生モンハンいくぞ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-19T18:43:02Z"
  },
  {
    "videoId": "tZa48d-iwIk",
    "thumbnail": "https://i.ytimg.com/vi/tZa48d-iwIk/mqdefault.jpg",
    "title": "常にかわいいを更新してるってこと #夏色まつり #ホロライブ #踊ってみた #newkawaii #fruitszipper",
    "publishedAt": "2025-03-20T12:01:24Z"
  },
  {
    "videoId": "ZtjCpW7oxcw",
    "thumbnail": "https://i.ytimg.com/vi/ZtjCpW7oxcw/mqdefault.jpg",
    "title": "かっこよダンス！憧れの二人の曲踊れて幸💞 #夏色まつり #ladycrazy #ヒメヒナ #踊ってみた #ホロライブ",
    "publishedAt": "2025-03-23T12:00:46Z"
  },
  {
    "videoId": "lBFl88S6IwY",
    "thumbnail": "https://i.ytimg.com/vi/lBFl88S6IwY/mqdefault.jpg",
    "title": "バズらせてください！！ #夏色まつり #ホロライブ #ひたむきシンデレラ #踊ってみた",
    "publishedAt": "2025-03-24T12:01:09Z"
  },
  {
    "videoId": "SrGhxifIlDU",
    "thumbnail": "https://i.ytimg.com/vi/SrGhxifIlDU/mqdefault.jpg",
    "title": "みむかｩわナイストライ/夏色まつり(cover)【ホロライブ】",
    "publishedAt": "2025-03-25T10:00:06Z"
  },
  {
    "videoId": "0yAQJf5WqNc",
    "thumbnail": "https://i.ytimg.com/vi/0yAQJf5WqNc/mqdefault.jpg",
    "title": "【雑談】風邪からやっと復活！おかえりください！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-27T11:14:36Z"
  },
  {
    "videoId": "52QhZIKuTBA",
    "thumbnail": "https://i.ytimg.com/vi/52QhZIKuTBA/mqdefault.jpg",
    "title": "【 Minecraft 】ゲームセンターを作るぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-03-29T09:25:14Z"
  },
  {
    "videoId": "fayZplZuu30",
    "thumbnail": "https://i.ytimg.com/vi/fayZplZuu30/mqdefault.jpg",
    "title": "#みむかゥわナイストライ 歌ってみた #夏色まつり #ホロライブ",
    "publishedAt": "2025-03-29T12:01:01Z"
  },
  {
    "videoId": "g9Fk-1Ou0SM",
    "thumbnail": "https://i.ytimg.com/vi/g9Fk-1Ou0SM/mqdefault.jpg",
    "title": "#みむかゥわナイストライ 歌ってみた #夏色まつり #ホロライブ",
    "publishedAt": "2025-03-30T12:00:56Z"
  },
  {
    "videoId": "AiUQtkyRlGc",
    "thumbnail": "https://i.ytimg.com/vi/AiUQtkyRlGc/mqdefault.jpg",
    "title": "#みむかゥわナイストライ 歌ってみた #夏色まつり #ホロライブ",
    "publishedAt": "2025-03-31T12:00:16Z"
  },
  {
    "videoId": "99j8B9dTcsg",
    "thumbnail": "https://i.ytimg.com/vi/99j8B9dTcsg/mqdefault.jpg",
    "title": "💎",
    "publishedAt": "2025-03-31T13:00:31Z"
  },
  {
    "videoId": "Ry75JmGpeow",
    "thumbnail": "https://i.ytimg.com/vi/Ry75JmGpeow/mqdefault.jpg",
    "title": "【お披露目】新3Dついに公開⁉【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-01T09:05:24Z"
  },
  {
    "videoId": "lDusnvmuwZQ",
    "thumbnail": "https://i.ytimg.com/vi/lDusnvmuwZQ/mqdefault.jpg",
    "title": "\"あなたの好きになればなるほど、私の嫌いな私になって あなたを嫌いになればなるほど、私は死んでいく\" #夏色まつり #ラヴレター #内緒のピアス #ホロライブ",
    "publishedAt": "2025-04-02T12:01:14Z"
  },
  {
    "videoId": "cnyqVRcLicU",
    "thumbnail": "https://i.ytimg.com/vi/cnyqVRcLicU/mqdefault.jpg",
    "title": "【モンハンワイルズ】片手剣でタマミツネ狩りまくり！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-04T14:54:38Z"
  },
  {
    "videoId": "v_JyeJoTX5Y",
    "thumbnail": "https://i.ytimg.com/vi/v_JyeJoTX5Y/mqdefault.jpg",
    "title": "【歌枠】沢山歌うよ🎶/Singing KARAOKE【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-05T10:07:51Z"
  },
  {
    "videoId": "BZiIFR5ptEU",
    "thumbnail": "https://i.ytimg.com/vi/BZiIFR5ptEU/mqdefault.jpg",
    "title": "新曲「ラヴレター」MV40万再生ありがとう！たくさん聴いてね #夏色まつり #ホロライブ #ラヴレター #内緒のピアス",
    "publishedAt": "2025-04-05T12:00:17Z"
  },
  {
    "videoId": "sfAswIhtbmA",
    "thumbnail": "https://i.ytimg.com/vi/sfAswIhtbmA/mqdefault.jpg",
    "title": "【モンハンワイルズ】あそぼあそぼあそぼあそぼあそぼ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-05T13:39:22Z"
  },
  {
    "videoId": "DnVM7CoLn58",
    "thumbnail": "https://i.ytimg.com/vi/DnVM7CoLn58/mqdefault.jpg",
    "title": "【モンハンワイルズ】アーティア武器ガチャしにいくぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-06T05:08:45Z"
  },
  {
    "videoId": "OTD26FMpIwM",
    "thumbnail": "https://i.ytimg.com/vi/OTD26FMpIwM/mqdefault.jpg",
    "title": "まつりは夕方過ぎにおきます。 #夏色まつり #ホロライブ #明日の私に幸あれ #踊ってみた",
    "publishedAt": "2025-04-06T12:00:35Z"
  },
  {
    "videoId": "eDO2EfTloDo",
    "thumbnail": "https://i.ytimg.com/vi/eDO2EfTloDo/mqdefault.jpg",
    "title": "「好きっていって？」『好きぃぃぃぃいいい』 #夏色まつり #ホロライブ #どきキュンダンス #踊ってみた",
    "publishedAt": "2025-04-07T12:01:04Z"
  },
  {
    "videoId": "dJfsKhMECdc",
    "thumbnail": "https://i.ytimg.com/vi/dJfsKhMECdc/mqdefault.jpg",
    "title": "【That's not my Neighbor】まつりす、ドアを開けなさい。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-07T12:42:35Z"
  },
  {
    "videoId": "3nq_sJqy9Ww",
    "thumbnail": "https://i.ytimg.com/vi/3nq_sJqy9Ww/mqdefault.jpg",
    "title": "【モンハンワイルズ】まちゅゼタ！モンスター討伐日記【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-08T14:43:19Z"
  },
  {
    "videoId": "Nvcc69R40L4",
    "thumbnail": "https://i.ytimg.com/vi/Nvcc69R40L4/mqdefault.jpg",
    "title": "本家再現ダンスしてみたよ！ #夏色まつり #ホロライブ #踊ってみた",
    "publishedAt": "2025-04-11T12:00:30Z"
  },
  {
    "videoId": "2C4Kn2Cc6A8",
    "thumbnail": "https://i.ytimg.com/vi/2C4Kn2Cc6A8/mqdefault.jpg",
    "title": "【モンハンワイルズ】今日こそアーティア武器完成させます！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-11T12:45:04Z"
  },
  {
    "videoId": "9DXqFIXHjD0",
    "thumbnail": "https://i.ytimg.com/vi/9DXqFIXHjD0/mqdefault.jpg",
    "title": "この曲聞くだけで青春した感でるよね  #夏色まつり #ホロライブ #踊ってみた #純恋愛のインゴット",
    "publishedAt": "2025-04-12T12:00:15Z"
  },
  {
    "videoId": "pSO1HVq8ucU",
    "thumbnail": "https://i.ytimg.com/vi/pSO1HVq8ucU/mqdefault.jpg",
    "title": "【歌枠】病み曲限定歌枠♡【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-13T14:20:12Z"
  },
  {
    "videoId": "N8JDeIb8Qd8",
    "thumbnail": "https://i.ytimg.com/vi/N8JDeIb8Qd8/mqdefault.jpg",
    "title": "【モンハンワイルズ】今日も今日とてアーティア武器制作！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-15T06:53:05Z"
  },
  {
    "videoId": "QNFQa0C6ZMg",
    "thumbnail": "https://i.ytimg.com/vi/QNFQa0C6ZMg/mqdefault.jpg",
    "title": "【押してダメなら押してみろ】閉じ込められました。ぽちっと【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-15T10:07:01Z"
  },
  {
    "videoId": "H58Dv0EX8b0",
    "thumbnail": "https://i.ytimg.com/vi/H58Dv0EX8b0/mqdefault.jpg",
    "title": "【歌枠】すーぱーアイドルSong！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-18T10:19:01Z"
  },
  {
    "videoId": "ruvVoj0908s",
    "thumbnail": "https://i.ytimg.com/vi/ruvVoj0908s/mqdefault.jpg",
    "title": "【 Minecraft 】ネザライト枯渇！大量にとるぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-19T06:53:28Z"
  },
  {
    "videoId": "MqMcRytZenQ",
    "thumbnail": "https://i.ytimg.com/vi/MqMcRytZenQ/mqdefault.jpg",
    "title": "船長は俺のプリンセスだよ #夏色まつり #ホロライブ #踊ってみた",
    "publishedAt": "2025-04-19T12:00:49Z"
  },
  {
    "videoId": "vY6NI_7vL64",
    "thumbnail": "https://i.ytimg.com/vi/vY6NI_7vL64/mqdefault.jpg",
    "title": "【 #holoRUST 】いい立地に家を建てる。人生のはじまり【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-19T18:15:17Z"
  },
  {
    "videoId": "tSaGaROUyLA",
    "thumbnail": "https://i.ytimg.com/vi/tSaGaROUyLA/mqdefault.jpg",
    "title": "いつでもビジュいいよ。Vtuberなのでな #夏色まつり #ホロライブ #踊ってみた #イイじゃん",
    "publishedAt": "2025-04-20T12:01:33Z"
  },
  {
    "videoId": "6M19Tz6gvKM",
    "thumbnail": "https://i.ytimg.com/vi/6M19Tz6gvKM/mqdefault.jpg",
    "title": "【 #holoRUST 】完全ソロ！貨物船で物資うまうま！？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-20T18:26:28Z"
  },
  {
    "videoId": "S-VgHpi9no0",
    "thumbnail": "https://i.ytimg.com/vi/S-VgHpi9no0/mqdefault.jpg",
    "title": "【 #holoRUST 】ギャンブルと僕。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-21T15:55:55Z"
  },
  {
    "videoId": "TQDPRx0SlAg",
    "thumbnail": "https://i.ytimg.com/vi/TQDPRx0SlAg/mqdefault.jpg",
    "title": "【 #holoRUST 】今日もやってやるぞおおおおおおお【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-22T06:30:52Z"
  },
  {
    "videoId": "IHOVJRznN-A",
    "thumbnail": "https://i.ytimg.com/vi/IHOVJRznN-A/mqdefault.jpg",
    "title": "【 #holoRUST 】ハラハラしてぇよ【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-23T15:18:46Z"
  },
  {
    "videoId": "Op73RLDKfxo",
    "thumbnail": "https://i.ytimg.com/vi/Op73RLDKfxo/mqdefault.jpg",
    "title": "【 #holoRUST 】ヘリと花火とあの子【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-24T16:30:15Z"
  },
  {
    "videoId": "TlWzOmRPFXI",
    "thumbnail": "https://i.ytimg.com/vi/TlWzOmRPFXI/mqdefault.jpg",
    "title": "【歌枠】少し歌わせて【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-26T11:55:25Z"
  },
  {
    "videoId": "th8cAmxZ2Nw",
    "thumbnail": "https://i.ytimg.com/vi/th8cAmxZ2Nw/mqdefault.jpg",
    "title": "音源押したときに出る女の子たち可愛すぎだろ #夏色まつり #ホロライブ #百花繚乱 #踊ってみた",
    "publishedAt": "2025-04-27T12:01:33Z"
  },
  {
    "videoId": "H-Bwg7EaMlY",
    "thumbnail": "https://i.ytimg.com/vi/H-Bwg7EaMlY/mqdefault.jpg",
    "title": "【 #holoRUST 】ヘリをゆるさない。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-27T13:34:21Z"
  },
  {
    "videoId": "Rv_9hG2XWW8",
    "thumbnail": "https://i.ytimg.com/vi/Rv_9hG2XWW8/mqdefault.jpg",
    "title": "このアイドルさんのオーディション「倍倍FIGHT」言えないから落ちるの確定や #夏色まつり #ホロライブ #踊ってみた",
    "publishedAt": "2025-04-28T12:15:08Z"
  },
  {
    "videoId": "_5cC7eQ0kro",
    "thumbnail": "https://i.ytimg.com/vi/_5cC7eQ0kro/mqdefault.jpg",
    "title": "【 #holoRUST 】ぎゃんぶる【ホロライブ/夏色まつり】",
    "publishedAt": "2025-04-28T15:17:31Z"
  },
  {
    "videoId": "sp5fl1R7gKQ",
    "thumbnail": "https://i.ytimg.com/vi/sp5fl1R7gKQ/mqdefault.jpg",
    "title": "MVハーフミリオン達成！JOYSOUNDでも配信スタート✨ #夏色まつり #ホロライブ #ラヴレター",
    "publishedAt": "2025-04-30T12:31:03Z"
  },
  {
    "videoId": "Y9UzZ5_pRP0",
    "thumbnail": "https://i.ytimg.com/vi/Y9UzZ5_pRP0/mqdefault.jpg",
    "title": "【歌枠】ご注文はおうたのじかんですか？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-01T14:17:56Z"
  },
  {
    "videoId": "hbRhFqz4VSs",
    "thumbnail": "https://i.ytimg.com/vi/hbRhFqz4VSs/mqdefault.jpg",
    "title": "【 #holoRUST 】PVPだってさっ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-02T16:28:36Z"
  },
  {
    "videoId": "YqwprLdwshc",
    "thumbnail": "https://i.ytimg.com/vi/YqwprLdwshc/mqdefault.jpg",
    "title": "๛ก(ｰ̀ωｰ́ก)‬びびっと！伝わった？ #夏色まつり #ホロライブ #踊ってみた #テレパシ",
    "publishedAt": "2025-05-03T09:01:00Z"
  },
  {
    "videoId": "Zd_IqbC6L58",
    "thumbnail": "https://i.ytimg.com/vi/Zd_IqbC6L58/mqdefault.jpg",
    "title": "【 #holoRUST 】PvPの結果はいかに！？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-03T15:06:18Z"
  },
  {
    "videoId": "izRF6TIYDsQ",
    "thumbnail": "https://i.ytimg.com/vi/izRF6TIYDsQ/mqdefault.jpg",
    "title": "ラヴレター（ファンレター）５億通おまちしてます。",
    "publishedAt": "2025-05-04T08:30:18Z"
  },
  {
    "videoId": "nvnOEj-xDqk",
    "thumbnail": "https://i.ytimg.com/vi/nvnOEj-xDqk/mqdefault.jpg",
    "title": "チョコミントよりはそりゃ好きだよ #夏色まつり #ホロライブ #愛スクリーム #踊ってみた",
    "publishedAt": "2025-05-05T08:30:23Z"
  },
  {
    "videoId": "8j8i1VqrEvc",
    "thumbnail": "https://i.ytimg.com/vi/8j8i1VqrEvc/mqdefault.jpg",
    "title": "コメントは「好き」で埋めてね♡ #夏色まつり #ホロライブ #ダイダイダイダイダイキライ #踊ってみた",
    "publishedAt": "2025-05-06T08:30:04Z"
  },
  {
    "videoId": "71p4its-EF4",
    "thumbnail": "https://i.ytimg.com/vi/71p4its-EF4/mqdefault.jpg",
    "title": "【ホロアース】ホロライブが作った世界ってどんな！？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-06T10:54:55Z"
  },
  {
    "videoId": "KNPqQKbBAsw",
    "thumbnail": "https://i.ytimg.com/vi/KNPqQKbBAsw/mqdefault.jpg",
    "title": "【ホロアース】ホロアースで使えるスタンプ＆洋服デザインする！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-07T11:36:50Z"
  },
  {
    "videoId": "LCFkqAihTKE",
    "thumbnail": "https://i.ytimg.com/vi/LCFkqAihTKE/mqdefault.jpg",
    "title": "夏色まつりへのガチ恋は修羅の道",
    "publishedAt": "2025-05-09T08:36:07Z"
  },
  {
    "videoId": "DnT0JkF6-ak",
    "thumbnail": "https://i.ytimg.com/vi/DnT0JkF6-ak/mqdefault.jpg",
    "title": "【ホロアース】鉄の時代と撮影会！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-09T13:55:57Z"
  },
  {
    "videoId": "27qrRGB02aw",
    "thumbnail": "https://i.ytimg.com/vi/27qrRGB02aw/mqdefault.jpg",
    "title": "ルイねぇのひみつのおしごと。まつり気になります！",
    "publishedAt": "2025-05-10T08:30:01Z"
  },
  {
    "videoId": "xfXtgC75wJY",
    "thumbnail": "https://i.ytimg.com/vi/xfXtgC75wJY/mqdefault.jpg",
    "title": "【歌枠】うたいます。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-12T05:57:04Z"
  },
  {
    "videoId": "Rtf1lIogveI",
    "thumbnail": "https://i.ytimg.com/vi/Rtf1lIogveI/mqdefault.jpg",
    "title": "練習良い感じだからみせます",
    "publishedAt": "2025-05-16T08:30:12Z"
  },
  {
    "videoId": "dEx4GANgU_s",
    "thumbnail": "https://i.ytimg.com/vi/dEx4GANgU_s/mqdefault.jpg",
    "title": "【#Huel】完全栄養食！トレーニングも一緒に！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-16T11:02:03Z"
  },
  {
    "videoId": "_b7L1Y1G9U0",
    "thumbnail": "https://i.ytimg.com/vi/_b7L1Y1G9U0/mqdefault.jpg",
    "title": "ラヴレターもらったことあるのかってきいてんの！",
    "publishedAt": "2025-05-17T08:30:26Z"
  },
  {
    "videoId": "-bZ_xB7Ydso",
    "thumbnail": "https://i.ytimg.com/vi/-bZ_xB7Ydso/mqdefault.jpg",
    "title": "NG多くてもビジュはいい",
    "publishedAt": "2025-05-18T08:30:00Z"
  },
  {
    "videoId": "1LbwIfYEjls",
    "thumbnail": "https://i.ytimg.com/vi/1LbwIfYEjls/mqdefault.jpg",
    "title": "【復帰】ただいまとおかえり【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-23T08:26:18Z"
  },
  {
    "videoId": "TSlUz_8H_14",
    "thumbnail": "https://i.ytimg.com/vi/TSlUz_8H_14/mqdefault.jpg",
    "title": "三角関係になったらみんなは手を引くタイプ？",
    "publishedAt": "2025-05-23T08:30:24Z"
  },
  {
    "videoId": "dhJzqXQP3lQ",
    "thumbnail": "https://i.ytimg.com/vi/dhJzqXQP3lQ/mqdefault.jpg",
    "title": "貴重なチア部要素",
    "publishedAt": "2025-05-24T08:30:30Z"
  },
  {
    "videoId": "7PIobIycP-8",
    "thumbnail": "https://i.ytimg.com/vi/7PIobIycP-8/mqdefault.jpg",
    "title": "【えぺまつり】うるさすぎるチームでランク→えぺまつり【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-24T12:39:44Z"
  },
  {
    "videoId": "YQaOjhQcB8s",
    "thumbnail": "https://i.ytimg.com/vi/YQaOjhQcB8s/mqdefault.jpg",
    "title": "ホロライブのきつねさんとしたいですね・・・",
    "publishedAt": "2025-05-25T08:30:25Z"
  },
  {
    "videoId": "Y6Prffx-Les",
    "thumbnail": "https://i.ytimg.com/vi/Y6Prffx-Les/mqdefault.jpg",
    "title": "【60 Seconds! Reatomized】核シェルターに引きこもりですか・・・【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-25T12:08:38Z"
  },
  {
    "videoId": "AH25hyaWhm8",
    "thumbnail": "https://i.ytimg.com/vi/AH25hyaWhm8/mqdefault.jpg",
    "title": "【ホロアース】鉄の時代を謳歌するぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-28T08:08:48Z"
  },
  {
    "videoId": "uWIOCXlbx88",
    "thumbnail": "https://i.ytimg.com/vi/uWIOCXlbx88/mqdefault.jpg",
    "title": "かなたんの神曲魔法で踊らせてみた！",
    "publishedAt": "2025-05-29T08:30:25Z"
  },
  {
    "videoId": "8eNC-_3UpL8",
    "thumbnail": "https://i.ytimg.com/vi/8eNC-_3UpL8/mqdefault.jpg",
    "title": "【60 Seconds! Reatomized】今日こそは１人でも生き残ろうね！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-29T11:37:36Z"
  },
  {
    "videoId": "S5_JThlFV4I",
    "thumbnail": "https://i.ytimg.com/vi/S5_JThlFV4I/mqdefault.jpg",
    "title": "【ホロアース】無限に時間がとけます。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-30T07:37:38Z"
  },
  {
    "videoId": "9Cwre--Wqu0",
    "thumbnail": "https://i.ytimg.com/vi/9Cwre--Wqu0/mqdefault.jpg",
    "title": "5000兆円ほしいいいいいいいい！船長ください！！",
    "publishedAt": "2025-05-31T08:30:04Z"
  },
  {
    "videoId": "adCVS66I6n4",
    "thumbnail": "https://i.ytimg.com/vi/adCVS66I6n4/mqdefault.jpg",
    "title": "【カウントダウン】７年活動を続けてるらしい【ホロライブ/夏色まつり】",
    "publishedAt": "2025-05-31T15:28:01Z"
  },
  {
    "videoId": "srMoDpwTSnA",
    "thumbnail": "https://i.ytimg.com/vi/srMoDpwTSnA/mqdefault.jpg",
    "title": "【応援会場】21時30分にグッズもでるよ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-01T13:10:39Z"
  },
  {
    "videoId": "pFZWI48oMPI",
    "thumbnail": "https://i.ytimg.com/vi/pFZWI48oMPI/mqdefault.jpg",
    "title": "ぴゅあぴゅあな気持ちで推して下さい🫶 #ぴゅあ推しダンス",
    "publishedAt": "2025-06-02T08:30:34Z"
  },
  {
    "videoId": "9dcrn_ZfYtA",
    "thumbnail": "https://i.ytimg.com/vi/9dcrn_ZfYtA/mqdefault.jpg",
    "title": "MMDモーション＆歌詞素材配布中！バズれー！！ #ぴゅあ推しダンス",
    "publishedAt": "2025-06-03T08:30:02Z"
  },
  {
    "videoId": "0Ex84GyJeME",
    "thumbnail": "https://i.ytimg.com/vi/0Ex84GyJeME/mqdefault.jpg",
    "title": "【歌枠】てんしのうたわく【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-03T15:08:50Z"
  },
  {
    "videoId": "y5xtS2HYOJ0",
    "thumbnail": "https://i.ytimg.com/vi/y5xtS2HYOJ0/mqdefault.jpg",
    "title": "【APEXガチャ】7周年でめでたいですし勝てます。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-04T11:38:31Z"
  },
  {
    "videoId": "2w1dNQ9Npvw",
    "thumbnail": "https://i.ytimg.com/vi/2w1dNQ9Npvw/mqdefault.jpg",
    "title": "【ホロの花札】ミリしら花札ですがいけますか？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-05T10:03:09Z"
  },
  {
    "videoId": "NnBNWHiH_jA",
    "thumbnail": "https://i.ytimg.com/vi/NnBNWHiH_jA/mqdefault.jpg",
    "title": "【爆盛食堂】まつりの今日食べるごはんの量を決めます。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-06T09:29:16Z"
  },
  {
    "videoId": "TlSojDVlLQo",
    "thumbnail": "https://i.ytimg.com/vi/TlSojDVlLQo/mqdefault.jpg",
    "title": "これオタクは絶対部屋で一人で踊るやつ",
    "publishedAt": "2025-06-07T08:30:26Z"
  },
  {
    "videoId": "L6SOr1YqCqg",
    "thumbnail": "https://i.ytimg.com/vi/L6SOr1YqCqg/mqdefault.jpg",
    "title": "【ホロアース】新おしゃれハウスをめざして！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-07T08:55:21Z"
  },
  {
    "videoId": "RdZK9f4t3Tw",
    "thumbnail": "https://i.ytimg.com/vi/RdZK9f4t3Tw/mqdefault.jpg",
    "title": "【 R.E.P.O. 】フルパでかっこいいところ見せたいからさ【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-08T08:24:43Z"
  },
  {
    "videoId": "hV_h3DYmAwE",
    "thumbnail": "https://i.ytimg.com/vi/hV_h3DYmAwE/mqdefault.jpg",
    "title": "きゅーすとすこすこ侍",
    "publishedAt": "2025-06-08T08:30:29Z"
  },
  {
    "videoId": "FiZvjPLH02Y",
    "thumbnail": "https://i.ytimg.com/vi/FiZvjPLH02Y/mqdefault.jpg",
    "title": "【 R.E.P.O. 】初見でもフルパならいけるよね！？【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-08T15:21:10Z"
  },
  {
    "videoId": "BdJ2_dd4Ezo",
    "thumbnail": "https://i.ytimg.com/vi/BdJ2_dd4Ezo/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル 】１日目💰一攫千金ってやつ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-09T14:38:40Z"
  },
  {
    "videoId": "WtYMhTpxQHY",
    "thumbnail": "https://i.ytimg.com/vi/WtYMhTpxQHY/mqdefault.jpg",
    "title": "このこの～！浮気厳禁やぞおおおおおお",
    "publishedAt": "2025-06-10T08:30:15Z"
  },
  {
    "videoId": "PuJMsUXD7s4",
    "thumbnail": "https://i.ytimg.com/vi/PuJMsUXD7s4/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル 】2日目💰釣りとピグリンとまつり【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-10T15:22:28Z"
  },
  {
    "videoId": "fEuKlV2J85k",
    "thumbnail": "https://i.ytimg.com/vi/fEuKlV2J85k/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル 】3日目💰職人という職業。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-11T16:19:12Z"
  },
  {
    "videoId": "53HhPpkGyMc",
    "thumbnail": "https://i.ytimg.com/vi/53HhPpkGyMc/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル 】4日目💰今日は秘密基地でがっぽり【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-12T15:50:09Z"
  },
  {
    "videoId": "B4yTwZ7gQkE",
    "thumbnail": "https://i.ytimg.com/vi/B4yTwZ7gQkE/mqdefault.jpg",
    "title": "7周年LIVEでのUNDEAD！",
    "publishedAt": "2025-06-13T08:30:05Z"
  },
  {
    "videoId": "0s1-c_F5qRQ",
    "thumbnail": "https://i.ytimg.com/vi/0s1-c_F5qRQ/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル 】最終日💰ギャンブルで大逆転しかないんだ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-13T15:24:43Z"
  },
  {
    "videoId": "VKtSGNx1yqQ",
    "thumbnail": "https://i.ytimg.com/vi/VKtSGNx1yqQ/mqdefault.jpg",
    "title": "まつりは天使？悪魔？どっちだとおもう？",
    "publishedAt": "2025-06-14T08:30:16Z"
  },
  {
    "videoId": "a7ebO-lQw3c",
    "thumbnail": "https://i.ytimg.com/vi/a7ebO-lQw3c/mqdefault.jpg",
    "title": "【モンギル：STAR DIVE】β試遊会大開催！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-14T12:21:25Z"
  },
  {
    "videoId": "AO6Si9vNPi8",
    "thumbnail": "https://i.ytimg.com/vi/AO6Si9vNPi8/mqdefault.jpg",
    "title": "【Delta Force】Delta Force×性格診断！？まつりは討論者です。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-15T06:22:10Z"
  },
  {
    "videoId": "aRG7k38s64A",
    "thumbnail": "https://i.ytimg.com/vi/aRG7k38s64A/mqdefault.jpg",
    "title": "座右の銘は「猪突猛進」",
    "publishedAt": "2025-06-15T08:30:01Z"
  },
  {
    "videoId": "kHN887STuOo",
    "thumbnail": "https://i.ytimg.com/vi/kHN887STuOo/mqdefault.jpg",
    "title": "UNDEADの意味を知らない物語",
    "publishedAt": "2025-06-16T08:30:32Z"
  },
  {
    "videoId": "HU6cLwd0WA8",
    "thumbnail": "https://i.ytimg.com/vi/HU6cLwd0WA8/mqdefault.jpg",
    "title": "イラストverのダイダイダイダイダイキライ！まつりのことはもちろん？",
    "publishedAt": "2025-06-17T08:30:11Z"
  },
  {
    "videoId": "sKxrRjruYIQ",
    "thumbnail": "https://i.ytimg.com/vi/sKxrRjruYIQ/mqdefault.jpg",
    "title": "【歌枠】⋈SINGING! ⋈るーるるるん♪【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-17T10:08:19Z"
  },
  {
    "videoId": "BEkijuc5CWc",
    "thumbnail": "https://i.ytimg.com/vi/BEkijuc5CWc/mqdefault.jpg",
    "title": "神MVをありがとう。関わらせていただけたこと神に感謝",
    "publishedAt": "2025-06-19T08:30:05Z"
  },
  {
    "videoId": "0_FKPOAbobA",
    "thumbnail": "https://i.ytimg.com/vi/0_FKPOAbobA/mqdefault.jpg",
    "title": "【ホロアース】おしゃれハウス内装つくるぞ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-19T13:00:29Z"
  },
  {
    "videoId": "fSDzqKGFzO4",
    "thumbnail": "https://i.ytimg.com/vi/fSDzqKGFzO4/mqdefault.jpg",
    "title": "ルイねぇ誘ってくれてありがとおおおお！楽しかった！",
    "publishedAt": "2025-06-21T08:30:21Z"
  },
  {
    "videoId": "yjEPReQNlDE",
    "thumbnail": "https://i.ytimg.com/vi/yjEPReQNlDE/mqdefault.jpg",
    "title": "【部屋紹介】ホロリスの部屋見たいみた～い！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-21T10:03:05Z"
  },
  {
    "videoId": "vtuOZ1qnVdk",
    "thumbnail": "https://i.ytimg.com/vi/vtuOZ1qnVdk/mqdefault.jpg",
    "title": "さわやかっこいい曲で好",
    "publishedAt": "2025-06-22T08:30:29Z"
  },
  {
    "videoId": "FxluGNTT2xg",
    "thumbnail": "https://i.ytimg.com/vi/FxluGNTT2xg/mqdefault.jpg",
    "title": "ざぁ～こっ！",
    "publishedAt": "2025-06-23T08:30:06Z"
  },
  {
    "videoId": "rAZQDPvX9NE",
    "thumbnail": "https://i.ytimg.com/vi/rAZQDPvX9NE/mqdefault.jpg",
    "title": "【 ゴブリン・ノーム・ホーン 】ここで働かせてください！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-23T11:05:53Z"
  },
  {
    "videoId": "ra840Lbjmz4",
    "thumbnail": "https://i.ytimg.com/vi/ra840Lbjmz4/mqdefault.jpg",
    "title": "もう踊るしかない～",
    "publishedAt": "2025-06-26T09:00:49Z"
  },
  {
    "videoId": "jrKSfXkI0DA",
    "thumbnail": "https://i.ytimg.com/vi/jrKSfXkI0DA/mqdefault.jpg",
    "title": "【たまごっちのプチプチおみせっち おまちど～さま！】ずっとまってた。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-27T06:45:57Z"
  },
  {
    "videoId": "lss8vKwbDoo",
    "thumbnail": "https://i.ytimg.com/vi/lss8vKwbDoo/mqdefault.jpg",
    "title": "体育のリレーもフライングしがち",
    "publishedAt": "2025-06-27T08:30:34Z"
  },
  {
    "videoId": "joE0KcXA5P0",
    "thumbnail": "https://i.ytimg.com/vi/joE0KcXA5P0/mqdefault.jpg",
    "title": "おしりふるの癖すぎて黒子になったとしても即バレしそうで草",
    "publishedAt": "2025-06-28T08:30:22Z"
  },
  {
    "videoId": "EQXAfl63YmQ",
    "thumbnail": "https://i.ytimg.com/vi/EQXAfl63YmQ/mqdefault.jpg",
    "title": "懐かしい曲が流行ると腕組んじゃうよね",
    "publishedAt": "2025-06-29T08:30:11Z"
  },
  {
    "videoId": "QJstI6bV0Ns",
    "thumbnail": "https://i.ytimg.com/vi/QJstI6bV0Ns/mqdefault.jpg",
    "title": "【歌枠 / Singing Stream】いろいろ歌うよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-06-29T11:23:50Z"
  },
  {
    "videoId": "6DfhtZci8Qk",
    "thumbnail": "https://i.ytimg.com/vi/6DfhtZci8Qk/mqdefault.jpg",
    "title": "【 R.E.P.O. 】【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-01T11:27:13Z"
  },
  {
    "videoId": "wf7TsT6wOVk",
    "thumbnail": "https://i.ytimg.com/vi/wf7TsT6wOVk/mqdefault.jpg",
    "title": "【 マリオカートワールド 】初めてのswitch2いくぞおおおおおおおおおお！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-02T06:51:45Z"
  },
  {
    "videoId": "BhgGzuaZp6s",
    "thumbnail": "https://i.ytimg.com/vi/BhgGzuaZp6s/mqdefault.jpg",
    "title": "【 Nintendo Switch 2 のひみつ展 】まつりに隠し事しないでね♡【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-04T11:13:56Z"
  },
  {
    "videoId": "Rg4els6dOOA",
    "thumbnail": "https://i.ytimg.com/vi/Rg4els6dOOA/mqdefault.jpg",
    "title": "【 マリオカートワールド 】ハッチンとサバイバル！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-05T07:12:07Z"
  },
  {
    "videoId": "cS8C50isFtg",
    "thumbnail": "https://i.ytimg.com/vi/cS8C50isFtg/mqdefault.jpg",
    "title": "まつりは幼虫が好きです🐛",
    "publishedAt": "2025-07-05T08:30:31Z"
  },
  {
    "videoId": "vgvpaabAuRM",
    "thumbnail": "https://i.ytimg.com/vi/vgvpaabAuRM/mqdefault.jpg",
    "title": "【 Minecraft 】ホロ鯖にハッピーガスト降臨！？ほしすぎるうううううううううう【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-05T11:39:17Z"
  },
  {
    "videoId": "h11W-k5vTso",
    "thumbnail": "https://i.ytimg.com/vi/h11W-k5vTso/mqdefault.jpg",
    "title": "ぬっぬっ",
    "publishedAt": "2025-07-06T08:30:24Z"
  },
  {
    "videoId": "9vCDGmDrpFo",
    "thumbnail": "https://i.ytimg.com/vi/9vCDGmDrpFo/mqdefault.jpg",
    "title": "一番の雑魚はまちゅり・・・",
    "publishedAt": "2025-07-07T08:30:09Z"
  },
  {
    "videoId": "oUqDXUI-vYc",
    "thumbnail": "https://i.ytimg.com/vi/oUqDXUI-vYc/mqdefault.jpg",
    "title": "【重大告知あり！】ホロフレとのおでかけ写真が見たい✨【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-07T11:50:04Z"
  },
  {
    "videoId": "7M0pPADOzQ8",
    "thumbnail": "https://i.ytimg.com/vi/7M0pPADOzQ8/mqdefault.jpg",
    "title": "ヘンな動きしがちですｗｗ",
    "publishedAt": "2025-07-08T08:30:04Z"
  },
  {
    "videoId": "d-e4gCQpD1o",
    "thumbnail": "https://i.ytimg.com/vi/d-e4gCQpD1o/mqdefault.jpg",
    "title": "【 #夏色まつり降臨祭 】新しい姿で帰ってきたぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-08T11:51:25Z"
  },
  {
    "videoId": "NI_NG3TRMLQ",
    "thumbnail": "https://i.ytimg.com/vi/NI_NG3TRMLQ/mqdefault.jpg",
    "title": "絶対流行らせたい！にのっかる",
    "publishedAt": "2025-07-09T08:30:13Z"
  },
  {
    "videoId": "mzh5SRJCuvU",
    "thumbnail": "https://i.ytimg.com/vi/mzh5SRJCuvU/mqdefault.jpg",
    "title": "地獄がどこにあるかわかんなくなりました",
    "publishedAt": "2025-07-10T08:30:24Z"
  },
  {
    "videoId": "w-QPEyTRZXM",
    "thumbnail": "https://i.ytimg.com/vi/w-QPEyTRZXM/mqdefault.jpg",
    "title": "【R.E.P.O.】そろそろソロでも行けます！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-10T10:07:34Z"
  },
  {
    "videoId": "d6x2-aWb1MQ",
    "thumbnail": "https://i.ytimg.com/vi/d6x2-aWb1MQ/mqdefault.jpg",
    "title": "【R.E.P.O.】そろそろソロでも行けます！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-10T12:05:58Z"
  },
  {
    "videoId": "MBaOK5EBHrA",
    "thumbnail": "https://i.ytimg.com/vi/MBaOK5EBHrA/mqdefault.jpg",
    "title": "逆になるのあるあるすぎるよね",
    "publishedAt": "2025-07-11T08:30:20Z"
  },
  {
    "videoId": "nXxGuaqxHFk",
    "thumbnail": "https://i.ytimg.com/vi/nXxGuaqxHFk/mqdefault.jpg",
    "title": "【R.E.P.O.】コラボのお誘い無限に待ってます。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-11T11:12:51Z"
  },
  {
    "videoId": "DCw0VDeN85o",
    "thumbnail": "https://i.ytimg.com/vi/DCw0VDeN85o/mqdefault.jpg",
    "title": "遠井さんかわいい",
    "publishedAt": "2025-07-12T08:30:13Z"
  },
  {
    "videoId": "YjjDNWZlOZI",
    "thumbnail": "https://i.ytimg.com/vi/YjjDNWZlOZI/mqdefault.jpg",
    "title": "【R.E.P.O.】ステージ6の壁を超える。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-12T12:59:51Z"
  },
  {
    "videoId": "SkdVqKOtCw4",
    "thumbnail": "https://i.ytimg.com/vi/SkdVqKOtCw4/mqdefault.jpg",
    "title": "声ありだときょういくばんぐみ感さらにでるね！",
    "publishedAt": "2025-07-13T08:30:12Z"
  },
  {
    "videoId": "bHBPo4Oh7nQ",
    "thumbnail": "https://i.ytimg.com/vi/bHBPo4Oh7nQ/mqdefault.jpg",
    "title": "【R.E.P.O.】続き！ステージ5からいくぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-14T10:23:28Z"
  },
  {
    "videoId": "IguNlgLmFL8",
    "thumbnail": "https://i.ytimg.com/vi/IguNlgLmFL8/mqdefault.jpg",
    "title": "君と一緒のまつり日和 #holonatsuParadise #ホロナツpiece #shorts",
    "publishedAt": "2025-07-16T09:00:27Z"
  },
  {
    "videoId": "uWOVbPcNTJ4",
    "thumbnail": "https://i.ytimg.com/vi/uWOVbPcNTJ4/mqdefault.jpg",
    "title": "【開封配信】みこちの加湿空気清浄器が届いたぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-16T10:05:22Z"
  },
  {
    "videoId": "vbph_MgeCuE",
    "thumbnail": "https://i.ytimg.com/vi/vbph_MgeCuE/mqdefault.jpg",
    "title": "【R.E.P.O.】トワまちゅデート【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-17T12:01:22Z"
  },
  {
    "videoId": "fN8GSguTyxI",
    "thumbnail": "https://i.ytimg.com/vi/fN8GSguTyxI/mqdefault.jpg",
    "title": "【オリジナル曲】ホロメン体操【ホロライブ/夏色まつり/まろん】",
    "publishedAt": "2025-07-18T08:30:07Z"
  },
  {
    "videoId": "oELSKvSp434",
    "thumbnail": "https://i.ytimg.com/vi/oELSKvSp434/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀1日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-18T22:12:09Z"
  },
  {
    "videoId": "qEqzynEMcjI",
    "thumbnail": "https://i.ytimg.com/vi/qEqzynEMcjI/mqdefault.jpg",
    "title": "【R.E.P.O.】朝から【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-18T23:49:13Z"
  },
  {
    "videoId": "jhLyJUjgog0",
    "thumbnail": "https://i.ytimg.com/vi/jhLyJUjgog0/mqdefault.jpg",
    "title": "先生にみつからないように！内緒だよ！※良い子はマネしないでください",
    "publishedAt": "2025-07-19T09:01:13Z"
  },
  {
    "videoId": "29DhsCWE0D4",
    "thumbnail": "https://i.ytimg.com/vi/29DhsCWE0D4/mqdefault.jpg",
    "title": "【同時視聴】ミリしらハリーポッターと賢者の石【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-19T11:44:03Z"
  },
  {
    "videoId": "cP9PfxAjBc8",
    "thumbnail": "https://i.ytimg.com/vi/cP9PfxAjBc8/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀2日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-19T22:15:22Z"
  },
  {
    "videoId": "T_5Tepa1Frc",
    "thumbnail": "https://i.ytimg.com/vi/T_5Tepa1Frc/mqdefault.jpg",
    "title": "オフまつり撮られてました！？",
    "publishedAt": "2025-07-20T09:55:30Z"
  },
  {
    "videoId": "HT5AOlnwelE",
    "thumbnail": "https://i.ytimg.com/vi/HT5AOlnwelE/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀3日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-20T22:12:52Z"
  },
  {
    "videoId": "oELyMENOAlM",
    "thumbnail": "https://i.ytimg.com/vi/oELyMENOAlM/mqdefault.jpg",
    "title": "【カウントダウン】🎂誕生日🎂本日の主役じゃ～い！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-21T15:14:52Z"
  },
  {
    "videoId": "43qgOnpQrQQ",
    "thumbnail": "https://i.ytimg.com/vi/43qgOnpQrQQ/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀4日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-21T22:14:29Z"
  },
  {
    "videoId": "IwfQQqXQ-zQ",
    "thumbnail": "https://i.ytimg.com/vi/IwfQQqXQ-zQ/mqdefault.jpg",
    "title": "【 誕生日 】新衣装とお知らせ💞【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-22T11:57:22Z"
  },
  {
    "videoId": "f-h3oNfxwn0",
    "thumbnail": "https://i.ytimg.com/vi/f-h3oNfxwn0/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀5日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-22T22:16:56Z"
  },
  {
    "videoId": "uzjYTwazvJ4",
    "thumbnail": "https://i.ytimg.com/vi/uzjYTwazvJ4/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀6日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-23T22:18:39Z"
  },
  {
    "videoId": "HaqMnPj79rk",
    "thumbnail": "https://i.ytimg.com/vi/HaqMnPj79rk/mqdefault.jpg",
    "title": "【R.E.P.O.】朝から【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-24T01:29:05Z"
  },
  {
    "videoId": "0ur37GNqZ3Q",
    "thumbnail": "https://i.ytimg.com/vi/0ur37GNqZ3Q/mqdefault.jpg",
    "title": "【R.E.P.O.】ワンオペの時間は終わりだ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-24T14:36:39Z"
  },
  {
    "videoId": "-3UNixXa5z4",
    "thumbnail": "https://i.ytimg.com/vi/-3UNixXa5z4/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀7日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-24T22:16:34Z"
  },
  {
    "videoId": "nvTBC9c9eN8",
    "thumbnail": "https://i.ytimg.com/vi/nvTBC9c9eN8/mqdefault.jpg",
    "title": "【R.E.P.O.】朝から【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-25T01:19:27Z"
  },
  {
    "videoId": "WxB6uA5zaHg",
    "thumbnail": "https://i.ytimg.com/vi/WxB6uA5zaHg/mqdefault.jpg",
    "title": "おじさんのおごりならお寿司（まわらないやつ）いかせてくれ",
    "publishedAt": "2025-07-25T08:30:28Z"
  },
  {
    "videoId": "4eJnQehbv_o",
    "thumbnail": "https://i.ytimg.com/vi/4eJnQehbv_o/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀8日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-25T22:16:23Z"
  },
  {
    "videoId": "jXPd6z5AXbo",
    "thumbnail": "https://i.ytimg.com/vi/jXPd6z5AXbo/mqdefault.jpg",
    "title": "【R.E.P.O.】朝から【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-26T02:19:24Z"
  },
  {
    "videoId": "plQt-seA_8w",
    "thumbnail": "https://i.ytimg.com/vi/plQt-seA_8w/mqdefault.jpg",
    "title": "【 #ホロナツ歌枠リレー 】夏担当といえばまつりちゃんでしょ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-26T05:33:43Z"
  },
  {
    "videoId": "mRvMF5BjZaQ",
    "thumbnail": "https://i.ytimg.com/vi/mRvMF5BjZaQ/mqdefault.jpg",
    "title": "常に未読999＋です。",
    "publishedAt": "2025-07-26T08:30:32Z"
  },
  {
    "videoId": "VRKuVLclf5k",
    "thumbnail": "https://i.ytimg.com/vi/VRKuVLclf5k/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀9日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-26T22:16:33Z"
  },
  {
    "videoId": "GPh4T5oVrg8",
    "thumbnail": "https://i.ytimg.com/vi/GPh4T5oVrg8/mqdefault.jpg",
    "title": "適当に生きすぎてるかも",
    "publishedAt": "2025-07-27T08:30:07Z"
  },
  {
    "videoId": "Nqth-_cw3L8",
    "thumbnail": "https://i.ytimg.com/vi/Nqth-_cw3L8/mqdefault.jpg",
    "title": "【PEAK】1期生で協力して登れ。頂点まで！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-27T15:10:59Z"
  },
  {
    "videoId": "H2jze9aEkVA",
    "thumbnail": "https://i.ytimg.com/vi/H2jze9aEkVA/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀10日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-27T22:15:32Z"
  },
  {
    "videoId": "lXiNzA-d5TI",
    "thumbnail": "https://i.ytimg.com/vi/lXiNzA-d5TI/mqdefault.jpg",
    "title": "【PEAK】1人で登るぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-28T06:55:48Z"
  },
  {
    "videoId": "BN6_qcQSCoE",
    "thumbnail": "https://i.ytimg.com/vi/BN6_qcQSCoE/mqdefault.jpg",
    "title": "おしゃえばんちょー！ぶぶぶん！！！",
    "publishedAt": "2025-07-28T08:30:12Z"
  },
  {
    "videoId": "ZrIakVCy5d0",
    "thumbnail": "https://i.ytimg.com/vi/ZrIakVCy5d0/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀11日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-28T22:15:40Z"
  },
  {
    "videoId": "VVQS07J4t4A",
    "thumbnail": "https://i.ytimg.com/vi/VVQS07J4t4A/mqdefault.jpg",
    "title": "【PEAK】ひとりで朝から登山🏔【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-29T00:14:51Z"
  },
  {
    "videoId": "djOvLHIJjOc",
    "thumbnail": "https://i.ytimg.com/vi/djOvLHIJjOc/mqdefault.jpg",
    "title": "結果よければ過去の失敗はすべて忘れる派です",
    "publishedAt": "2025-07-29T08:30:16Z"
  },
  {
    "videoId": "NqbpIjr5VlA",
    "thumbnail": "https://i.ytimg.com/vi/NqbpIjr5VlA/mqdefault.jpg",
    "title": "【R.E.P.O.】プロ2人とバイト2人。先輩についてきな！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-29T14:45:41Z"
  },
  {
    "videoId": "kRDYet6WEws",
    "thumbnail": "https://i.ytimg.com/vi/kRDYet6WEws/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀12日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-29T22:15:53Z"
  },
  {
    "videoId": "GxSgWqQCep8",
    "thumbnail": "https://i.ytimg.com/vi/GxSgWqQCep8/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀13日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-30T22:17:47Z"
  },
  {
    "videoId": "oq8J13CK0V4",
    "thumbnail": "https://i.ytimg.com/vi/oq8J13CK0V4/mqdefault.jpg",
    "title": "【R.E.P.O.】朝から【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-31T00:35:20Z"
  },
  {
    "videoId": "YNEX0-qVUvQ",
    "thumbnail": "https://i.ytimg.com/vi/YNEX0-qVUvQ/mqdefault.jpg",
    "title": "まつりをコメントで怒らせてみてｗ",
    "publishedAt": "2025-07-31T08:30:30Z"
  },
  {
    "videoId": "G9D4Fc-Y-RM",
    "thumbnail": "https://i.ytimg.com/vi/G9D4Fc-Y-RM/mqdefault.jpg",
    "title": "【 #ホロメン体操 】☀毎日7時の健康生活☀14日目【ホロライブ/夏色まつり】",
    "publishedAt": "2025-07-31T22:15:53Z"
  },
  {
    "videoId": "pi9ywF4zpXU",
    "thumbnail": "https://i.ytimg.com/vi/pi9ywF4zpXU/mqdefault.jpg",
    "title": "【配信切り抜き】まつりすにあたり強すぎるかもしれないｗｗ",
    "publishedAt": "2025-08-02T08:30:25Z"
  },
  {
    "videoId": "iRBhyzijonk",
    "thumbnail": "https://i.ytimg.com/vi/iRBhyzijonk/mqdefault.jpg",
    "title": "まちゅまちゅびいいいいいいいいいいいいいいいいいいいいむ",
    "publishedAt": "2025-08-03T08:30:30Z"
  },
  {
    "videoId": "gJ6A6N0xjVc",
    "thumbnail": "https://i.ytimg.com/vi/gJ6A6N0xjVc/mqdefault.jpg",
    "title": "まつりもBONBONGIRLですよね！？！？",
    "publishedAt": "2025-08-04T08:55:00Z"
  },
  {
    "videoId": "AH9vsaFsrEQ",
    "thumbnail": "https://i.ytimg.com/vi/AH9vsaFsrEQ/mqdefault.jpg",
    "title": "スマホのカメラロールと検索履歴と視聴履歴みせて。",
    "publishedAt": "2025-08-05T08:55:00Z"
  },
  {
    "videoId": "Epd0iDtoeSI",
    "thumbnail": "https://i.ytimg.com/vi/Epd0iDtoeSI/mqdefault.jpg",
    "title": "うい・・・好きだ・・・",
    "publishedAt": "2025-08-06T10:45:05Z"
  },
  {
    "videoId": "iOnZgmWtz4M",
    "thumbnail": "https://i.ytimg.com/vi/iOnZgmWtz4M/mqdefault.jpg",
    "title": "人生初パラパラ！💅🔥",
    "publishedAt": "2025-08-07T10:20:06Z"
  },
  {
    "videoId": "gRzFgJLZ6Rc",
    "thumbnail": "https://i.ytimg.com/vi/gRzFgJLZ6Rc/mqdefault.jpg",
    "title": "ただいま",
    "publishedAt": "2025-08-08T06:44:00Z"
  },
  {
    "videoId": "rsSbwKAoFOk",
    "thumbnail": "https://i.ytimg.com/vi/rsSbwKAoFOk/mqdefault.jpg",
    "title": "メロい女になりたいですわ♡",
    "publishedAt": "2025-08-09T08:30:35Z"
  },
  {
    "videoId": "eaVQ9YmoSW0",
    "thumbnail": "https://i.ytimg.com/vi/eaVQ9YmoSW0/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】完全初見から大会に出るまで全部見せます！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-09T09:06:31Z"
  },
  {
    "videoId": "8jPZ7QXG3a0",
    "thumbnail": "https://i.ytimg.com/vi/8jPZ7QXG3a0/mqdefault.jpg",
    "title": "コメントをシャンパンで埋めてね🍾",
    "publishedAt": "2025-08-10T08:30:04Z"
  },
  {
    "videoId": "ItC1JHDeJlA",
    "thumbnail": "https://i.ytimg.com/vi/ItC1JHDeJlA/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】ランクCになるまで終わらない！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-10T11:17:50Z"
  },
  {
    "videoId": "3-SEsgsL3XA",
    "thumbnail": "https://i.ytimg.com/vi/3-SEsgsL3XA/mqdefault.jpg",
    "title": "アンチだぁ・・・ファンだぁ・・・",
    "publishedAt": "2025-08-11T08:30:01Z"
  },
  {
    "videoId": "5xMoOuTVuqA",
    "thumbnail": "https://i.ytimg.com/vi/5xMoOuTVuqA/mqdefault.jpg",
    "title": "【 Minecraft 】#ホロ鯖サマーパーク 自分水族館いいですか。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-12T11:28:02Z"
  },
  {
    "videoId": "hn6c_sgf_DQ",
    "thumbnail": "https://i.ytimg.com/vi/hn6c_sgf_DQ/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】明日本番！？ランクBになるぞ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-14T13:03:05Z"
  },
  {
    "videoId": "zPlt4zPyHVI",
    "thumbnail": "https://i.ytimg.com/vi/zPlt4zPyHVI/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】6日目！大会にでますよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-15T15:47:20Z"
  },
  {
    "videoId": "BeJ_4OEpB_I",
    "thumbnail": "https://i.ytimg.com/vi/BeJ_4OEpB_I/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】別クラス触って理解を深めてみる！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-15T17:11:12Z"
  },
  {
    "videoId": "jmp5Y6eLkFQ",
    "thumbnail": "https://i.ytimg.com/vi/jmp5Y6eLkFQ/mqdefault.jpg",
    "title": "魔法ではなく踊ってみたよ～",
    "publishedAt": "2025-08-16T08:30:32Z"
  },
  {
    "videoId": "zu6DuIrd07U",
    "thumbnail": "https://i.ytimg.com/vi/zu6DuIrd07U/mqdefault.jpg",
    "title": "【 Minecraft 】#ホロ鯖サマーパーク 全力で遊ぶぞ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-16T13:59:35Z"
  },
  {
    "videoId": "lHdUqNPf4LM",
    "thumbnail": "https://i.ytimg.com/vi/lHdUqNPf4LM/mqdefault.jpg",
    "title": "君の推しはオタクちゃんです♡",
    "publishedAt": "2025-08-17T08:30:23Z"
  },
  {
    "videoId": "w6jpioEUNVA",
    "thumbnail": "https://i.ytimg.com/vi/w6jpioEUNVA/mqdefault.jpg",
    "title": "【歌枠】おひるにうたうよ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-19T08:01:04Z"
  },
  {
    "videoId": "7XX6KRaL718",
    "thumbnail": "https://i.ytimg.com/vi/7XX6KRaL718/mqdefault.jpg",
    "title": "【#ソロREPO並走 】森の館はスキップで！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-21T13:38:56Z"
  },
  {
    "videoId": "m_ph9wVO-aY",
    "thumbnail": "https://i.ytimg.com/vi/m_ph9wVO-aY/mqdefault.jpg",
    "title": "まつりと一夏の淡い恋してみない？",
    "publishedAt": "2025-08-23T08:30:20Z"
  },
  {
    "videoId": "I2zPBi9hLG0",
    "thumbnail": "https://i.ytimg.com/vi/I2zPBi9hLG0/mqdefault.jpg",
    "title": "【 APEX 】ハセまつりでえっさほいさ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-23T13:11:05Z"
  },
  {
    "videoId": "_4U6fibHPbw",
    "thumbnail": "https://i.ytimg.com/vi/_4U6fibHPbw/mqdefault.jpg",
    "title": "まつりも君たちと踊りたいです～！",
    "publishedAt": "2025-08-24T08:30:17Z"
  },
  {
    "videoId": "1IUgT__sr5E",
    "thumbnail": "https://i.ytimg.com/vi/1IUgT__sr5E/mqdefault.jpg",
    "title": "【歌枠】バラード【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-24T17:11:03Z"
  },
  {
    "videoId": "Vpv7UQSwV5s",
    "thumbnail": "https://i.ytimg.com/vi/Vpv7UQSwV5s/mqdefault.jpg",
    "title": "まつりも誰かのかっこいいすっげーヒーローになりたい",
    "publishedAt": "2025-08-26T09:30:17Z"
  },
  {
    "videoId": "DMHMb3PRISo",
    "thumbnail": "https://i.ytimg.com/vi/DMHMb3PRISo/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】ランクするよ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-26T15:05:33Z"
  },
  {
    "videoId": "Vf6zwB0PnA4",
    "thumbnail": "https://i.ytimg.com/vi/Vf6zwB0PnA4/mqdefault.jpg",
    "title": "【30 Days on Ship】30日一人で生き残るぞ！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-28T11:32:42Z"
  },
  {
    "videoId": "Xb_sBffp87I",
    "thumbnail": "https://i.ytimg.com/vi/Xb_sBffp87I/mqdefault.jpg",
    "title": "いっぱい元気になれる歌！",
    "publishedAt": "2025-08-30T09:00:46Z"
  },
  {
    "videoId": "eID1t5EFf7Y",
    "thumbnail": "https://i.ytimg.com/vi/eID1t5EFf7Y/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】新パックきちゃ～！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-30T09:09:29Z"
  },
  {
    "videoId": "QOibPljuCpI",
    "thumbnail": "https://i.ytimg.com/vi/QOibPljuCpI/mqdefault.jpg",
    "title": "【 nosh 】自炊したくない！楽したい！/運営さん「ぴったりのものが・・・」【ホロライブ/夏色まつり】",
    "publishedAt": "2025-08-31T12:12:55Z"
  },
  {
    "videoId": "Gjembme8Q_U",
    "thumbnail": "https://i.ytimg.com/vi/Gjembme8Q_U/mqdefault.jpg",
    "title": "最後何回やってもこの走り方になってしまうｗｗ",
    "publishedAt": "2025-09-01T09:30:12Z"
  },
  {
    "videoId": "3OKukpbzscM",
    "thumbnail": "https://i.ytimg.com/vi/3OKukpbzscM/mqdefault.jpg",
    "title": "【 日本事故物件監視協会 】激レアホラーゲーム会【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-01T12:18:31Z"
  },
  {
    "videoId": "83q_ueYFi_E",
    "thumbnail": "https://i.ytimg.com/vi/83q_ueYFi_E/mqdefault.jpg",
    "title": "【歌枠】アイドルだから可愛い曲を歌うの♪【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-03T09:11:26Z"
  },
  {
    "videoId": "8drKm5OWIPg",
    "thumbnail": "https://i.ytimg.com/vi/8drKm5OWIPg/mqdefault.jpg",
    "title": "【#ホロフレ夏休み】ホロフレと僕の夏休み思い出写真館！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-06T10:09:31Z"
  },
  {
    "videoId": "S4CPBE8l2H8",
    "thumbnail": "https://i.ytimg.com/vi/S4CPBE8l2H8/mqdefault.jpg",
    "title": "【 PEAK 】リオーナ！山に登ろうよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-06T14:27:49Z"
  },
  {
    "videoId": "5aauzE5Ej-M",
    "thumbnail": "https://i.ytimg.com/vi/5aauzE5Ej-M/mqdefault.jpg",
    "title": "ホロメンの歌みた無限にください",
    "publishedAt": "2025-09-07T08:30:04Z"
  },
  {
    "videoId": "AEMrNHYNSi4",
    "thumbnail": "https://i.ytimg.com/vi/AEMrNHYNSi4/mqdefault.jpg",
    "title": "【８番出口】8番出口前集合でデートしよ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-08T10:27:09Z"
  },
  {
    "videoId": "rnlcSzH3cB8",
    "thumbnail": "https://i.ytimg.com/vi/rnlcSzH3cB8/mqdefault.jpg",
    "title": "今年も花火みたよ。マイクラで",
    "publishedAt": "2025-09-09T11:15:14Z"
  },
  {
    "videoId": "csUQV8Z7ANI",
    "thumbnail": "https://i.ytimg.com/vi/csUQV8Z7ANI/mqdefault.jpg",
    "title": "魔法の力で踊らせてみた！ミオしゃライブお疲れ様✨",
    "publishedAt": "2025-09-10T13:40:02Z"
  },
  {
    "videoId": "73SBPGi4HG8",
    "thumbnail": "https://i.ytimg.com/vi/73SBPGi4HG8/mqdefault.jpg",
    "title": "君の推しも何かのオタクです",
    "publishedAt": "2025-09-11T10:30:12Z"
  },
  {
    "videoId": "L9rBmc_2h6U",
    "thumbnail": "https://i.ytimg.com/vi/L9rBmc_2h6U/mqdefault.jpg",
    "title": "【Onigiri Shop Simulator】心を込めて\"握ります\"【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-12T08:58:50Z"
  },
  {
    "videoId": "Spd5oR6NAkA",
    "thumbnail": "https://i.ytimg.com/vi/Spd5oR6NAkA/mqdefault.jpg",
    "title": "ママコメ、パパコメでコメント欄埋めてねｗ",
    "publishedAt": "2025-09-12T09:30:17Z"
  },
  {
    "videoId": "sOXklB9Uyvc",
    "thumbnail": "https://i.ytimg.com/vi/sOXklB9Uyvc/mqdefault.jpg",
    "title": "OPめちゃかわなんで見てください",
    "publishedAt": "2025-09-13T09:30:34Z"
  },
  {
    "videoId": "PAj6FvTIhqA",
    "thumbnail": "https://i.ytimg.com/vi/PAj6FvTIhqA/mqdefault.jpg",
    "title": "ニコニコ懐古厨のワイ。懐か死",
    "publishedAt": "2025-09-14T09:30:12Z"
  },
  {
    "videoId": "VROleOqGNkE",
    "thumbnail": "https://i.ytimg.com/vi/VROleOqGNkE/mqdefault.jpg",
    "title": "【Onigiri Shop Simulator】鬼のワンオペおにぎり屋さん🍙【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-14T11:15:01Z"
  },
  {
    "videoId": "2sfVp-ZCEQk",
    "thumbnail": "https://i.ytimg.com/vi/2sfVp-ZCEQk/mqdefault.jpg",
    "title": "【Onigiri Shop Simulator】今日の営業が最後になります🍙【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-15T12:04:03Z"
  },
  {
    "videoId": "B0kSzoaH38w",
    "thumbnail": "https://i.ytimg.com/vi/B0kSzoaH38w/mqdefault.jpg",
    "title": "愛伝えてください",
    "publishedAt": "2025-09-17T08:30:04Z"
  },
  {
    "videoId": "xlAjopyTv7U",
    "thumbnail": "https://i.ytimg.com/vi/xlAjopyTv7U/mqdefault.jpg",
    "title": "【 #突発ホロAmongUs 】食いしん坊なんで全員食べます！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-17T14:03:10Z"
  },
  {
    "videoId": "C6YVs1mKp24",
    "thumbnail": "https://i.ytimg.com/vi/C6YVs1mKp24/mqdefault.jpg",
    "title": "もうすぐ夏も終わるね。思い出ある？",
    "publishedAt": "2025-09-18T14:00:16Z"
  },
  {
    "videoId": "aPNWE3fnZjE",
    "thumbnail": "https://i.ytimg.com/vi/aPNWE3fnZjE/mqdefault.jpg",
    "title": "完全に理解した！（わかってない）",
    "publishedAt": "2025-09-19T13:00:01Z"
  },
  {
    "videoId": "IGwWxOYfaB4",
    "thumbnail": "https://i.ytimg.com/vi/IGwWxOYfaB4/mqdefault.jpg",
    "title": "わためぇのかっこいい感じの曲好き",
    "publishedAt": "2025-09-24T10:35:00Z"
  },
  {
    "videoId": "j_KusCv7csk",
    "thumbnail": "https://i.ytimg.com/vi/j_KusCv7csk/mqdefault.jpg",
    "title": "どのまつりを攻略してみる？",
    "publishedAt": "2025-09-27T11:45:12Z"
  },
  {
    "videoId": "g0vK84LTx0E",
    "thumbnail": "https://i.ytimg.com/vi/g0vK84LTx0E/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！新たな冒険の旅へ【ホロライブ/夏色まつり】",
    "publishedAt": "2025-09-29T14:16:16Z"
  },
  {
    "videoId": "nh5u-5FHdOg",
    "thumbnail": "https://i.ytimg.com/vi/nh5u-5FHdOg/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！推しキャラ見つけたい！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-02T11:18:26Z"
  },
  {
    "videoId": "FjrSl8hoUXk",
    "thumbnail": "https://i.ytimg.com/vi/FjrSl8hoUXk/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！パーティー見直したり～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-04T13:32:46Z"
  },
  {
    "videoId": "dpIVQ_9uAds",
    "thumbnail": "https://i.ytimg.com/vi/dpIVQ_9uAds/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！氷パーティーでいざ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-05T12:04:40Z"
  },
  {
    "videoId": "f5YRB_2Du5I",
    "thumbnail": "https://i.ytimg.com/vi/f5YRB_2Du5I/mqdefault.jpg",
    "title": "【 CloverPit 】負けたらさっきの倍かけて勝てばいい。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-06T10:24:22Z"
  },
  {
    "videoId": "wsDyBShxDuw",
    "thumbnail": "https://i.ytimg.com/vi/wsDyBShxDuw/mqdefault.jpg",
    "title": "【 Keep Digging 】掘って掘って掘りまくれ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-07T14:30:29Z"
  },
  {
    "videoId": "TcRI88ijcJ4",
    "thumbnail": "https://i.ytimg.com/vi/TcRI88ijcJ4/mqdefault.jpg",
    "title": "【睡眠導入朗読】蜘蛛の糸/芥川龍之介【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-07T15:15:41Z"
  },
  {
    "videoId": "Yf06ZceO3Js",
    "thumbnail": "https://i.ytimg.com/vi/Yf06ZceO3Js/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！真実を知る時が来た。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-09T04:49:33Z"
  },
  {
    "videoId": "WFQhnccjP6o",
    "thumbnail": "https://i.ytimg.com/vi/WFQhnccjP6o/mqdefault.jpg",
    "title": "振り入れ中のレアまつり！",
    "publishedAt": "2025-10-10T10:20:00Z"
  },
  {
    "videoId": "Dq_b95W5t2E",
    "thumbnail": "https://i.ytimg.com/vi/Dq_b95W5t2E/mqdefault.jpg",
    "title": "アホ毛ぽよぽよ～ん",
    "publishedAt": "2025-10-11T11:02:32Z"
  },
  {
    "videoId": "Ob_nBcLd1Es",
    "thumbnail": "https://i.ytimg.com/vi/Ob_nBcLd1Es/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！道草くいすぎて進まない～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-21T15:07:33Z"
  },
  {
    "videoId": "3KT0ShW51b4",
    "thumbnail": "https://i.ytimg.com/vi/3KT0ShW51b4/mqdefault.jpg",
    "title": "【絵チャ】おえかきしたい気分！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-23T16:30:44Z"
  },
  {
    "videoId": "PN2CYNlpcRs",
    "thumbnail": "https://i.ytimg.com/vi/PN2CYNlpcRs/mqdefault.jpg",
    "title": "【 CloverPit 】長く長く生き残るのだ！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-24T06:12:35Z"
  },
  {
    "videoId": "4u6oRPBv35E",
    "thumbnail": "https://i.ytimg.com/vi/4u6oRPBv35E/mqdefault.jpg",
    "title": "【PowerWash Simulator 2】寝れないなら洗おう。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-25T20:04:02Z"
  },
  {
    "videoId": "0SmsT7mp0GI",
    "thumbnail": "https://i.ytimg.com/vi/0SmsT7mp0GI/mqdefault.jpg",
    "title": "【PowerWash Simulator 2】うぉしゅうぉしゅ【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-26T11:09:25Z"
  },
  {
    "videoId": "TRB3A0UZneg",
    "thumbnail": "https://i.ytimg.com/vi/TRB3A0UZneg/mqdefault.jpg",
    "title": "【恋愛相談】あなたの恋のお悩み夏色はあとが解決します♡【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-28T14:12:34Z"
  },
  {
    "videoId": "1_db4VL9mzM",
    "thumbnail": "https://i.ytimg.com/vi/1_db4VL9mzM/mqdefault.jpg",
    "title": "【エスケープ フロム ダッコフ】アヒルの神ゲーらしい！ぐわぐわ～！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-29T12:22:49Z"
  },
  {
    "videoId": "J_vdZFalnhU",
    "thumbnail": "https://i.ytimg.com/vi/J_vdZFalnhU/mqdefault.jpg",
    "title": "夏色まつり誕生祭ライブまであと3日！",
    "publishedAt": "2025-10-29T12:35:00Z"
  },
  {
    "videoId": "VX-JE1b-lmk",
    "thumbnail": "https://i.ytimg.com/vi/VX-JE1b-lmk/mqdefault.jpg",
    "title": "【エスケープ フロム ダッコフ】スタジオから少しだけ（沼）【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-30T07:56:59Z"
  },
  {
    "videoId": "DLqBgZnWTY0",
    "thumbnail": "https://i.ytimg.com/vi/DLqBgZnWTY0/mqdefault.jpg",
    "title": "夏色まつり誕生祭ライブまであと2日！",
    "publishedAt": "2025-10-30T12:15:06Z"
  },
  {
    "videoId": "gPr9ziUeJ4M",
    "thumbnail": "https://i.ytimg.com/vi/gPr9ziUeJ4M/mqdefault.jpg",
    "title": "夏色まつり誕生祭ライブまであと1日！",
    "publishedAt": "2025-10-31T11:01:24Z"
  },
  {
    "videoId": "p6AyEyHPwfE",
    "thumbnail": "https://i.ytimg.com/vi/p6AyEyHPwfE/mqdefault.jpg",
    "title": "【AmongUs】今日は推理じゃなく直感でいきます！！！！！！！！！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-31T13:53:07Z"
  },
  {
    "videoId": "tKI-TdesWus",
    "thumbnail": "https://i.ytimg.com/vi/tKI-TdesWus/mqdefault.jpg",
    "title": "【エスケープ フロム ダッコフ】ぐわっ【ホロライブ/夏色まつり】",
    "publishedAt": "2025-10-31T21:13:11Z"
  },
  {
    "videoId": "8xvqpvjW_TA",
    "thumbnail": "https://i.ytimg.com/vi/8xvqpvjW_TA/mqdefault.jpg",
    "title": "本日21時から！いよいよ誕生祭当日！",
    "publishedAt": "2025-11-01T11:13:39Z"
  },
  {
    "videoId": "mZPcE3JJGds",
    "thumbnail": "https://i.ytimg.com/vi/mZPcE3JJGds/mqdefault.jpg",
    "title": "【オリジナル曲】ウーニャカ【ホロライブ/夏色まつり/かいりきベア】",
    "publishedAt": "2025-11-01T13:05:06Z"
  },
  {
    "videoId": "L-XVS13TRTI",
    "thumbnail": "https://i.ytimg.com/vi/L-XVS13TRTI/mqdefault.jpg",
    "title": "【 #夏色まつり誕生祭2025 】重大告知あり！アイドル革命進行中！～今日の主役は夢の途中～　【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-01T13:07:14Z"
  },
  {
    "videoId": "_I4RwciQMsw",
    "thumbnail": "https://i.ytimg.com/vi/_I4RwciQMsw/mqdefault.jpg",
    "title": "#ウーニャカ のタグをつけてみんなもshorts動画投稿してね！",
    "publishedAt": "2025-11-01T13:30:44Z"
  },
  {
    "videoId": "Qnd8UeG8py8",
    "thumbnail": "https://i.ytimg.com/vi/Qnd8UeG8py8/mqdefault.jpg",
    "title": "#ウーニャカ 投稿キャンペーンを実施！#ウーニャカ をつけて投稿されたものの中から、選ばれた動画に夏色まつりがリアクション動画を投稿します🎁コメントで遊びに行く可能性も…！？音源の紐づけをお忘れなく！",
    "publishedAt": "2025-11-02T14:01:29Z"
  },
  {
    "videoId": "VA0wA6TAVtw",
    "thumbnail": "https://i.ytimg.com/vi/VA0wA6TAVtw/mqdefault.jpg",
    "title": "【R.E.P.O.】アプデきちゃ！！久々に稼ぐぞ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-04T15:46:21Z"
  },
  {
    "videoId": "9oaTh2Hi0Bk",
    "thumbnail": "https://i.ytimg.com/vi/9oaTh2Hi0Bk/mqdefault.jpg",
    "title": "【エスケープ フロム ダッコフ】おはぐわ！農園？行きたい！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-05T01:41:27Z"
  },
  {
    "videoId": "TpXNMsPaKd8",
    "thumbnail": "https://i.ytimg.com/vi/TpXNMsPaKd8/mqdefault.jpg",
    "title": "まつりが踊った動きでMMD出来るって神じゃないか！？みんなもにゃんにゃん踊ってねෆ˚* #ウーニャカ #夏色まつり",
    "publishedAt": "2025-11-05T11:00:56Z"
  },
  {
    "videoId": "lOQ_9eULWNY",
    "thumbnail": "https://i.ytimg.com/vi/lOQ_9eULWNY/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！新たな星へ...！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-06T13:22:57Z"
  },
  {
    "videoId": "tmRHVkNRmw0",
    "thumbnail": "https://i.ytimg.com/vi/tmRHVkNRmw0/mqdefault.jpg",
    "title": "【APEX】久々のカスタム✨勝つぞ～！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-08T11:59:55Z"
  },
  {
    "videoId": "x4TGyMbG3u8",
    "thumbnail": "https://i.ytimg.com/vi/x4TGyMbG3u8/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】それでも秘術ウィッチを使いたい。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-09T10:08:55Z"
  },
  {
    "videoId": "CniPbbN5M7M",
    "thumbnail": "https://i.ytimg.com/vi/CniPbbN5M7M/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】リオナと秘密？の研究会♡【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-10T14:02:52Z"
  },
  {
    "videoId": "Blboa2yl6Nk",
    "thumbnail": "https://i.ytimg.com/vi/Blboa2yl6Nk/mqdefault.jpg",
    "title": "【 シャドバWB/Shadowverse 】下剋上【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-14T10:56:44Z"
  },
  {
    "videoId": "U5LWOuREbeM",
    "thumbnail": "https://i.ytimg.com/vi/U5LWOuREbeM/mqdefault.jpg",
    "title": "【崩壊：スターレイル】完全初見！最強パーティーでいくぞ！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-15T14:20:28Z"
  },
  {
    "videoId": "q4Zouc3f1KM",
    "thumbnail": "https://i.ytimg.com/vi/q4Zouc3f1KM/mqdefault.jpg",
    "title": "【歌枠】おうた！！うたうた！！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-17T13:18:02Z"
  },
  {
    "videoId": "tJRfew3BgcU",
    "thumbnail": "https://i.ytimg.com/vi/tJRfew3BgcU/mqdefault.jpg",
    "title": "【ARC Raiders】Don't  Shoot!!!!!!!!!!!!!!!!!!!!!!!!!!!【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-18T13:40:41Z"
  },
  {
    "videoId": "Drobnj6mAtw",
    "thumbnail": "https://i.ytimg.com/vi/Drobnj6mAtw/mqdefault.jpg",
    "title": "アルバム収録のHoneyWorksさん書き下ろし楽曲を一部公開✨ #夏色まつり #honeyworks",
    "publishedAt": "2025-11-21T13:30:14Z"
  },
  {
    "videoId": "yHjB87oj9Jw",
    "thumbnail": "https://i.ytimg.com/vi/yHjB87oj9Jw/mqdefault.jpg",
    "title": "【ARC Raiders】All My Love【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-23T14:58:29Z"
  },
  {
    "videoId": "eIfqScwtHpM",
    "thumbnail": "https://i.ytimg.com/vi/eIfqScwtHpM/mqdefault.jpg",
    "title": "【ARC Raiders】ロボ子さんを護るためなら撃つよ。【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-24T15:32:47Z"
  },
  {
    "videoId": "bx-27NAEo7E",
    "thumbnail": "https://i.ytimg.com/vi/bx-27NAEo7E/mqdefault.jpg",
    "title": "【歌枠】君のためのうた【ホロライブ/夏色まつり】",
    "publishedAt": "2025-11-26T10:17:32Z"
  },
  {
    "videoId": "YP26oX-Nyqk",
    "thumbnail": "https://i.ytimg.com/vi/YP26oX-Nyqk/mqdefault.jpg",
    "title": "ホロメン衣装チェンジ✨どの子の衣装が似合うかな！？",
    "publishedAt": "2025-11-27T10:00:59Z"
  },
  {
    "videoId": "bLCJAx9SzzY",
    "thumbnail": "https://i.ytimg.com/vi/bLCJAx9SzzY/mqdefault.jpg",
    "title": "ウーニャカ制服で踊ってみた！甘いキャンディたくさんください- ̗̀🍭 ̖́-",
    "publishedAt": "2025-11-29T09:50:01Z"
  },
  {
    "videoId": "qybxFVW0RHo",
    "thumbnail": "https://i.ytimg.com/vi/qybxFVW0RHo/mqdefault.jpg",
    "title": "ウーニャカ踊ってみた！MVも超可愛からみてね！",
    "publishedAt": "2025-11-30T09:01:19Z"
  },
  {
    "videoId": "F7i1oSpB6xQ",
    "thumbnail": "https://i.ytimg.com/vi/F7i1oSpB6xQ/mqdefault.jpg",
    "title": "アルバム収録のじんさん書き下ろし楽曲を一部公開✨ #夏色まつり #じん",
    "publishedAt": "2025-12-01T09:00:19Z"
  },
  {
    "videoId": "nHcq0BzmIZ0",
    "thumbnail": "https://i.ytimg.com/vi/nHcq0BzmIZ0/mqdefault.jpg",
    "title": "ホロメン衣装チェンジpart2✨どの子の衣装が似合うかな！？",
    "publishedAt": "2025-12-03T09:01:22Z"
  },
  {
    "videoId": "jgibLBdQqT0",
    "thumbnail": "https://i.ytimg.com/vi/jgibLBdQqT0/mqdefault.jpg",
    "title": "ウーニャカアイドル衣装で踊ったよ！みんなも体感チャレンジやってみてね！",
    "publishedAt": "2025-12-04T09:01:16Z"
  },
  {
    "videoId": "TF-tRbcoehw",
    "thumbnail": "https://i.ytimg.com/vi/TF-tRbcoehw/mqdefault.jpg",
    "title": "【Stormlander】おいしいものたべたあああああい！！【ホロライブ/夏色まつり】",
    "publishedAt": "2025-12-06T14:07:20Z"
  },
  {
    "videoId": "9WgUNLExjBQ",
    "thumbnail": "https://i.ytimg.com/vi/9WgUNLExjBQ/mqdefault.jpg",
    "title": "夏色まつりオリ曲メドレーPart1✨君はどの曲が好き！？",
    "publishedAt": "2025-12-07T09:00:12Z"
  },
  {
    "videoId": "C4Je84GCokY",
    "thumbnail": "https://i.ytimg.com/vi/C4Je84GCokY/mqdefault.jpg",
    "title": "夏色まつり 1st Album『Chasing the Dream〜スポットライトは放課後に〜』クロスフェード",
    "publishedAt": "2025-12-10T12:00:25Z"
  },
  {
    "videoId": "WjmQcRFMzVM",
    "thumbnail": "https://i.ytimg.com/vi/WjmQcRFMzVM/mqdefault_live.jpg",
    "title": "【歌枠】スポットライトは放課後に【ホロライブ/夏色まつり】",
    "publishedAt": "2025-12-10T13:24:04Z"
  }
],



}